// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/primereact/resources/themes/lara-light-indigo/theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/primeicons/primeicons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/primereact/resources/primereact.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-time-picker/dist/TimePicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-clock/dist/Clock.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/react-scripts/node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-datepicker/dist/react-datepicker.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/img/theme/bg-1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/img/theme/bg-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/img/theme/bg-3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/img/theme/bg-4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/assets/img/authentication/login-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../public/assets/img/authentication/register-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../public/assets/img/authentication/forgot-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../public/assets/img/authentication/reset-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/****** Utils ******/
/****** Layout ******/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  border-radius: 50px !important;
}

::-webkit-scrollbar-track {
  background: #898989;
}

::-webkit-scrollbar-thumb {
  background: #E41F07;
}

::-webkit-scrollbar-thumb:hover {
  background: #898989;
}

.swal2-header .swal2-title {
  font-size: 18px;
}

.none {
  display: none !important;
}

.text-red {
  color: #FC0027 !important;
}

.text-green {
  color: #5CB85C !important;
}

.input-blocks input[type=text]:focus {
  border-color: #E8E8E8;
}

.input-group .scanner-set {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #E41F07;
  border-radius: 5px !important;
  width: 40px;
  color: #FFF;
  font-weight: 600;
  padding: 0;
}
.input-group .scanner-set:hover {
  background: #262A2A;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  border-radius: 50px !important;
}

::-webkit-scrollbar-track {
  background: #898989;
}

::-webkit-scrollbar-thumb {
  background: #E41F07;
}

::-webkit-scrollbar-thumb:hover {
  background: #898989;
}

.swal2-header .swal2-title {
  font-size: 18px;
}

.none {
  display: none !important;
}

.text-red {
  color: #FC0027 !important;
}

.text-green {
  color: #5CB85C !important;
}

.input-blocks input[type=text]:focus {
  border-color: #E8E8E8;
}

.form-sorts {
  position: relative;
}
.form-sorts > a {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  background: #FFF;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  padding: 9px 21px;
}
@media (max-width: 991.98px) {
  .form-sorts > a {
    padding: 9px 12px;
  }
}
.form-sorts > a i {
  margin-right: 8px;
}
.form-sorts > a:hover {
  color: #262A2A;
}
.form-sorts > a.show {
  border: 1px solid #0092E4;
}
@media (max-width: 575.98px) {
  .form-sorts > a {
    width: 100%;
  }
}
.form-sorts .filter-dropdown-menu {
  padding: 24px;
  border-radius: 5px;
  background: #FFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 24px 0px rgba(188, 188, 188, 0.2509803922);
  position: absolute;
  z-index: 1;
  min-width: 400px;
  right: 0;
  top: 40px;
}
@media (max-width: 767.98px) {
  .form-sorts .filter-dropdown-menu {
    min-width: 270px;
  }
}
@media (max-width: 575.98px) {
  .form-sorts .filter-dropdown-menu {
    right: unset;
    left: 0;
  }
}
.form-sorts.table-filter-show .filter-dropdown-menu {
  display: block;
  opacity: 1;
}
.form-sorts .filter-set-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 14px;
}
.form-sorts .filter-set-head h4 {
  margin-bottom: 10px;
}
.form-sorts .filter-set-head h4 i {
  margin-right: 8px;
}
@media (max-width: 991.98px) {
  .form-sorts .filter-set-head h4 {
    font-size: 16px;
  }
}
.form-sorts .filter-set-head a {
  color: #4A00E5;
  margin-bottom: 10px;
}
.form-sorts .filter-set-head a:hover {
  color: #E41F07;
}
.form-sorts .filter-set-content {
  margin-bottom: 24px;
}
.form-sorts .filter-set-content .filter-set-content-head a {
  display: flex;
  align-items: center;
  color: #262A2A;
  font-weight: 600;
  position: relative;
  padding-left: 16px;
}
.form-sorts .filter-set-content .filter-set-content-head a::before {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size: 14px;
}
.form-sorts .filter-set-content .filter-set-content-head a:not(.collapsed) {
  padding-left: 20px;
}
.form-sorts .filter-set-content .filter-set-content-head a:not(.collapsed)::before {
  content: "\\f078";
}
.form-sorts .filter-reset-btns a {
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  width: 100%;
}
@media (max-width: 575.98px) {
  .form-sorts .filter-reset-btns a {
    padding: 10px 30px;
  }
}
.form-sorts .filter-reset-btns .btn-light {
  background: #F5F5F5;
  border: 1px solid #E8E8E8;
}

.radio-btn-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 14px;
}
.radio-btn-items .radio-btn {
  margin: 0 30px 10px 0;
}
.radio-btn-items .radio-btn:last-child {
  margin-right: 0;
}

.filter-set-contents .filter-content-list {
  background: #F9F9FC;
  border-radius: 5px;
  padding: 15px;
  margin-top: 15px;
}
.filter-set-contents .filter-content-list .form-wrap {
  margin-bottom: 15px;
}
.filter-set-contents .filter-content-list .form-wrap .form-control {
  max-width: 100%;
}
.filter-set-contents .filter-content-list ul {
  max-height: 150px;
  overflow-y: auto;
  padding: 1px 0;
}
.filter-set-contents .filter-content-list ul::-webkit-scrollbar {
  width: 3px;
  background: #E41F07;
  height: 1px;
}
.filter-set-contents .filter-content-list ul::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(231, 231, 231);
  border-radius: 4px;
}
.filter-set-contents .filter-content-list ul::-webkit-scrollbar-thumb {
  background: #E41F07;
  border-radius: 4px;
}
.filter-set-contents .filter-content-list ul li {
  position: relative;
  display: flex;
  margin-bottom: 15px;
}
.filter-set-contents .filter-content-list ul li:last-child {
  margin-bottom: 0;
}
.filter-set-contents .filter-content-list ul li .checkboxs {
  padding-left: 0;
  display: flex;
  align-items: center;
}
.filter-set-contents .filter-content-list ul li .checkboxs .checkmarks {
  position: relative;
  top: 0;
  margin-right: 5px;
  display: flex;
}
.filter-set-contents .filter-content-list ul li .rating {
  margin-left: 0;
}
.filter-set-contents .filter-content-list ul li .rating i {
  color: #E8E8E8;
}
.filter-set-contents .filter-content-list ul li .rating i.filled {
  color: #FDA700;
}
.filter-set-contents .filter-content-list ul li .rating span {
  margin-left: 5px;
}
.filter-set-contents .filter-content-list ul li .collapse-inside-text {
  margin-left: 0;
}
.filter-set-contents .filter-content-list ul li .collapse-inside-text h5 {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
}

.page-wrapper {
  transition: all 0.5s ease;
  margin: 0 0 0 276px;
  padding: 56px 0 0;
  position: relative;
  left: 0;
  transition: all 0.2s ease;
}
@media (max-width: 991.98px) {
  .page-wrapper {
    margin: 0;
    padding: 60px 0 0;
  }
}
.page-wrapper .content {
  padding: 24px;
  padding-bottom: 0;
}
@media (max-width: 991.98px) {
  .page-wrapper .content {
    padding: 15px 15px 0;
  }
}

.header {
  height: 56px;
  z-index: 999;
  background: #FFF;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  transition: all 0.5s ease;
}
.header .flag-nav > a img {
  border-radius: 50%;
  width: 22px;
  height: 22px;
}
.header .searchinputs {
  padding: 0;
  position: relative;
}
.header .searchinputs input {
  width: 335px;
  height: 42px;
  border: 1px solid #F6F6F6;
  background: #F6F6F6;
  padding: 5px 10px;
  padding-right: 35px;
  border-radius: 5px;
  color: #262A2A;
}
@media (max-width: 1199.98px) {
  .header .searchinputs input {
    width: 170px;
  }
}
.header .searchinputs input::placeholder {
  color: #6F6F6F;
}
.header .searchinputs .search-addon button {
  z-index: 9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 5px;
  cursor: pointer;
  background: transparent;
  border: 0;
  padding: 0;
  color: #262A2A;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
@media (min-width: 992px) {
  .header .dropdown-menu {
    top: 85px;
    right: 0;
    left: auto;
    min-width: 200px;
    visibility: hidden;
    opacity: 0;
    border: 0;
    display: block;
    border-radius: 5px;
    box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
    margin: 0;
    padding: 0;
    transition: all 0.4s ease;
    transform: translateY(20px);
    -webkit-transform: translateY(20px);
    -ms-transform: translateY(20px);
  }
}
@media (max-width: 991.98px) {
  .header .dropdown-menu {
    transition: none;
  }
}
.header .dropdown-menu.show {
  visibility: visible;
  opacity: 1;
  margin-top: 8px !important;
  transform: translateY(0);
  -webkit-transform: translateY(0);
  -ms-transform: translateY(0);
  transition: all 0.4s ease;
}
.header .header-left {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  float: left;
  height: 56px;
  position: relative;
  text-align: center;
  width: 276px;
  z-index: 1;
  background: #FFF;
  padding: 0 15px;
  transition: all 0.5s ease;
}
.header .header-left .logo {
  display: inline-block;
  line-height: 0;
}
.header .header-left .logo img {
  width: 130px;
  display: block;
}
.header .header-left .logo img.white-logo {
  display: none;
}
@media (max-width: 991.98px) {
  .header .header-left .logo {
    text-align: center;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header .header-left .logo img {
    width: 140px;
  }
}
.header .header-left .logo-small {
  display: none;
}
@media (max-width: 991.98px) {
  .header .header-left {
    position: absolute;
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .header .header-left #toggle_btn {
    display: none;
  }
}
@media (min-width: 991.98px) {
  .header #toggle_btn {
    font-size: 18px;
    padding: 4px;
    border-radius: 6px;
  }
  .header #toggle_btn .bar-icon {
    display: inline-block;
    width: 21px;
  }
  .header #toggle_btn .bar-icon span {
    background-color: #FFF;
    display: block;
    float: left;
    height: 2px;
    width: 21px;
    margin: 0 0 5px;
    border-radius: 50px;
  }
  .header #toggle_btn .bar-icon span:nth-child(2) {
    width: 15px;
  }
}
.header .bar-icon {
  display: inline-block;
  width: 31px;
  margin-top: 20px;
}
.header .bar-icon span {
  background-color: #E41F07;
  display: block;
  float: left;
  height: 3px;
  margin-bottom: 7px;
  width: 31px;
  border-radius: 2px;
  transition: all 0.5s;
}
.header .bar-icon span:nth-child(2) {
  width: 16px;
}
.header .menu-opened .slide-nav .bar-icon {
  display: inline-block;
  width: 31px;
  margin-top: 20px;
}
.header .menu-opened .slide-nav .bar-icon span:first-child {
  position: relative;
  top: 10px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}
.header .menu-opened .slide-nav .bar-icon span:nth-child(2) {
  display: none;
}
.header .menu-opened .slide-nav .bar-icon span:last-child {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
}
.header .menus-info {
  min-width: 500px;
  border-radius: 5px;
  padding: 8px;
}
@media (max-width: 1199.98px) {
  .header .menus-info {
    min-width: 430px;
  }
}
.header .menus-info .menu-list li {
  margin-bottom: 0;
  margin-right: 0;
}
.header .menus-info .menu-list li a {
  display: block;
  padding: 8px;
  background: #FFF;
  border-radius: 5px;
}
.header .menus-info .menu-list li a:hover {
  background: #F6F6F6;
}
.header .menus-info .menu-list li a .menu-details {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .menus-info .menu-list li a .menu-details .menu-list-icon {
  font-size: 18px;
  color: #FFF;
  width: 36px;
  min-width: 36px;
  height: 36px;
  padding: 5px;
  margin-right: 8px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.header .menus-info .menu-list li a .menu-details .menu-details-content p {
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 0;
}
.header .menus-info .menu-list li a .menu-details .menu-details-content span {
  font-weight: 400;
  color: #6F6F6F;
}
@media (max-width: 1199.98px) {
  .header .menus-info .menu-list li a .menu-details .menu-details-content span {
    font-size: 13px;
  }
}
.header .profilename {
  padding: 0px;
}
.header .profilename .profileset {
  display: flex;
  padding: 10px 10px 3px;
}
.header .profilename .profileset h6 {
  font-size: 14px;
  color: #FFA201;
  font-weight: 500;
}
.header .profilename .profileset h5 {
  font-size: 14px;
  color: #565E5E;
}
.header .profilename .profileset .profilesets {
  margin-left: 10px;
}
.header .profilename .profileset .user-img img {
  margin-top: 0;
}
.header .show .user-info::after {
  transform: rotate(-140deg);
  top: 10px;
}
.header .user-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
  padding: 0;
}
@media (max-width: 1199.98px) {
  .header .user-info span.user-detail {
    display: none;
  }
}
.header .user-info::after {
  content: "";
  width: 8px;
  height: 8px;
  border-top: 0;
  border-left: 0;
  border-right: 2px solid #1B2950;
  border-bottom: 2px solid #1B2950;
  border-radius: 1px;
  transform: rotate(45deg);
  transition: all 0.5s;
  top: 8px;
  position: absolute;
  right: 12px;
  display: none;
}
@media (max-width: 1199.98px) {
  .header .user-info::after {
    top: 12px;
  }
}
.header .user-info .user-role {
  display: block;
  color: #67748E;
  font-size: 12px;
}
.header .user-info .user-letter {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FFF;
  width: 36px;
  height: 36px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 15px;
  margin-right: 0;
}
@media (max-width: 1199.98px) {
  .header .user-info .user-letter {
    margin-right: 0;
  }
}
.header .user-info .user-letter img {
  border-radius: 5px;
}
.header .user-info .user-name {
  font-size: 15px;
  font-weight: 600;
  color: #1B2950;
  display: flex;
  align-items: center;
}
.header .user-info .user-name img {
  margin-left: 10px;
}
.header .header-user {
  padding: 15px 24px;
  display: contents;
}
.header .header-user .user-menu {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin: 0;
  position: relative;
  height: 100%;
  border-bottom: 0;
  padding: 0 24px;
  transition: all 0.5s ease;
}
@media (max-width: 991.98px) {
  .header .header-user .user-menu {
    display: none;
  }
}
.header .header-user .user-menu .status {
  position: absolute;
  content: "";
  background: #E41F07;
  width: 10px;
  height: 10px;
  border-radius: 50px;
  top: 3px;
  right: 3px;
}
.header .header-user .user-menu .header-title h3 {
  font-size: 24px;
  font-weight: 700;
}
.header .header-user .user-menu .header-title h6 {
  font-size: 12px;
  font-weight: 600;
}
.header .header-user .user-menu > li {
  margin-left: 10px;
  margin-inline-end: 0;
}
.header .header-user .user-menu > li:first-child {
  margin-left: 0;
}
@media (max-width: 1199.98px) {
  .header .header-user .user-menu > li {
    margin-left: 8px;
  }
}
.header .header-user .user-menu > li svg {
  width: 18px;
  color: #67748E;
}
.header .header-user .user-menu > li a:hover svg {
  color: #E41F07;
}
.header .header-user .user-menu .dropdown-toggle::after {
  border: 0;
  display: none;
}
.header .header-user .user-menu .nav-searchinputs {
  margin-right: auto;
  margin-left: 25px;
}
.header .header-user .user-menu .nav-item-box > a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #F6F6F6;
  color: #262A2A;
  border-radius: 5px;
  width: 36px;
  height: 36px;
  position: relative;
  border: 0;
}
.header .header-user .user-menu .nav-item-box > a:hover {
  background: #EAEAEA;
}
.header .header-user .user-menu .nav-item-email.nav-item-box {
  margin-left: 15px;
}
.header .header-user .user-menu.nav > li > a {
  padding: 0;
  display: flex;
  line-height: normal;
  color: #3E4265;
}
.header .header-user .user-menu.nav > li > a.btn-header-list {
  color: #FFF;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.header .header-user .user-menu.nav > li > a .badge {
  color: #FFF;
  font-weight: 700;
  position: absolute;
  top: 4px;
  right: 4px;
  background: #E41F07;
  width: 15px;
  height: 15px;
  font-size: 10px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.header .header-user .user-menu.nav > li > a i {
  font-size: 18px;
}
.header .header-user .user-menu.nav > li > a .badge-success {
  background: #5CB85C;
  border: 3px solid #FFF;
  padding: 0;
  top: inherit;
  bottom: -3px;
  right: -3px;
}
.header .header-user .user-menu.nav > li.flag-nav a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .header-user .user-menu.nav > li.flag-nav a .dropdown-menu {
  max-height: 150px;
  min-width: 120px;
  overflow-y: auto;
}
.header .header-user .user-menu.nav > li.flag-nav a .dropdown-menu .dropdown-item {
  padding: 5px 15px;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu {
  padding: 15px;
  min-width: 210px;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item {
  padding: 10px 10px;
  color: #67748E;
  border-radius: 10px;
  transition: none;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item.active {
  color: #FFF;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item.active, .header .header-user .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item:hover {
  background: #F7F7F7 no-repeat calc(100% - 12px) center;
}
.header .header-user .user-menu.nav > li.flag-nav .dropdown-menu a img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
}
.header .page-title-box {
  float: left;
  height: 60px;
  margin-bottom: 0;
  padding: 17px 20px;
  border-radius: 0;
}
@media (max-width: 991.98px) {
  .header .page-title-box {
    display: none;
  }
}
.header .page-title-box a {
  color: #E41F07;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid #E41F07;
  margin: 0;
  padding: 5px;
  border-radius: 5px;
}
.header .page-title-box a:hover {
  background: #E41F07;
  color: #FFF;
}
.header .mobile_btn {
  display: none;
  float: left;
}
@media (max-width: 991.98px) {
  .header .mobile_btn {
    color: #E41F07;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    width: 60px;
    z-index: 10;
    padding: 0 20px;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }
}
.header .responsive-search {
  display: none;
  color: #FFF;
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  padding: 0 15px;
}
@media (max-width: 991.98px) {
  .header .responsive-search {
    display: block;
  }
}
.header .top-nav-search form {
  position: relative;
}
@media (max-width: 991.98px) {
  .header .top-nav-search form {
    display: none;
  }
}
.header .top-nav-search form .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  height: 40px;
  padding: 10px 50px 10px 15px;
  border-radius: 50px;
}
.header .top-nav-search form .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.header .top-nav-search form .btn {
  background-color: transparent;
  border-color: transparent;
  color: rgba(255, 255, 255, 0.7);
  min-height: 40px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 991.98px) {
  .header .top-nav-search.active form {
    display: block;
    position: absolute;
    left: 0;
  }
  .header .top-nav-search.active form .form-control {
    background-color: #FFF;
  }
  .header .top-nav-search.active form .btn {
    background-color: transparent;
    border-color: transparent;
    min-height: 40px;
    position: absolute;
    top: 0;
    right: 0;
    padding: 7px 15px;
  }
}
.header .userset {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .userset .usernames {
  line-height: initial;
  text-align: right;
  padding-right: 10px;
}
.header .userset .usernames span {
  display: block;
  line-height: initial;
}
.header .menu-drop-user .dropdown-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
  color: #262A2A;
  padding: 10px;
  border-bottom: 1px solid #F5F5F5;
  border-radius: 0;
}
.header .menu-drop-user .dropdown-item:first-child {
  border-radius: 5px 5px 0 0;
}
.header .menu-drop-user .dropdown-item:last-child {
  border-radius: 0 0 5px 5px;
  border-bottom: 0;
}
.header .menu-drop-user .dropdown-item:hover {
  padding-left: 20px;
  letter-spacing: 0.5px;
}
.header .menu-drop-user .dropdown-item i {
  font-size: 16px;
  margin-right: 8px;
}
@media (max-width: 991.98px) {
  .header .has-arrow .dropdown-toggle > span:nth-child(2) {
    display: none;
  }
  .header .has-arrow .dropdown-toggle:after {
    display: none !important;
  }
}
.header .profilename .user-img .status {
  bottom: 10px;
}
.header .user-img {
  display: inline-block;
  position: relative;
}
.header .user-img img {
  width: 38px;
  border-radius: 50%;
}
.header .user-img .status {
  border: 2px solid #FFF;
  height: 10px;
  width: 10px;
  margin: 0;
  position: absolute;
  right: 0;
  bottom: 30px;
  border-radius: 50%;
  display: inline-block;
  background: #5CB85C;
}
.header .mobile-user-menu {
  color: #FFF;
  display: none;
  float: right;
  font-size: 24px;
  height: 60px;
  line-height: 60px;
  text-align: right;
  width: 60px;
  z-index: 10;
  padding: 0 20px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 991.98px) {
  .header .mobile-user-menu {
    display: block;
  }
}
.header .mobile-user-menu a {
  color: #E41F07;
  padding: 0;
}
.header .mobile-user-menu a::after {
  display: none;
}
.header .mobile-user-menu .dropdown-menu {
  padding: 0;
}
.header .mobile-user-menu .dropdown-menu a {
  color: #323737;
  line-height: 40px;
  padding: 0 10px;
}

.logo-small img {
  width: 30px;
}

@media (min-width: 992px) {
  .mini-sidebar.expand-menu .header-left {
    flex-direction: row;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
  }
  .mini-sidebar .header-left {
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    width: 80px;
    padding: 0;
    flex-direction: column;
  }
  .mini-sidebar .header-left .logo-small {
    display: block;
    padding: 10px 0 0;
  }
  .mini-sidebar .header-left .logo {
    display: none;
  }
  .mini-sidebar .menu-arrow {
    display: none !important;
  }
  .mini-sidebar .chat-user {
    display: none !important;
  }
  .mini-sidebar .user-menu .badge {
    display: flex !important;
  }
  .mini-sidebar.expand-menu .menu-arrow {
    display: block !important;
  }
  .mini-sidebar.expand-menu .chat-user {
    display: block !important;
  }
  .mini-sidebar.expand-menu .logo-small {
    display: none;
  }
  .mini-sidebar.expand-menu .logo {
    display: block;
  }
  .mini-sidebar.expand-menu #toggle_btn {
    opacity: 1;
  }
  .mini-sidebar.expand-menu .header-left {
    padding: 0 15px;
    display: flex;
  }
  .mini-sidebar .noti-dot:before {
    display: none;
  }
}
.nav-list {
  position: relative;
  padding-right: 15px;
}
.nav-list::before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  width: 1px;
  height: 20px;
  background: #E8E8E8;
  z-index: 1;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle {
  width: 66px;
  height: 36px;
  background: #F9F9FC;
  border: 1px solid #E8E8E8;
  font-size: 16px;
  border-radius: 5px;
  padding: 3px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle i {
  font-size: 16px;
  color: #262A2A;
  border-radius: 5px;
  line-height: 26px;
  width: 26px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle i.light-mode.active {
  color: #FFF;
  background: #5CB85C;
}
.nav-list .nav .dark-mode-list .dark-mode-toggle i.dark-mode.active {
  color: #FFF;
  background: #262A2A;
}
.nav-list .nav li {
  margin-right: 10px;
}
.nav-list .nav li:last-child {
  margin-right: 0;
}
.nav-list .nav li .btn {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 36px;
  height: 36px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid transparent;
}
.nav-list .nav li .btn-header-list {
  color: #00918E;
  background: #E0F5D7;
  border: 1px solid #00918E;
}
.nav-list .nav li .btn-header-list:hover {
  color: #FFF;
  background: #00918E;
}
.nav-list .nav li .btn-help {
  color: #3C2371;
  background: #F3EDFF;
}
.nav-list .nav li .btn-help:hover {
  color: #FFF;
  background: #3C2371;
}
.nav-list .nav li .btn-chart-pie {
  color: #FFA201;
  background: #FFF7D8;
}
.nav-list .nav li .btn-chart-pie:hover {
  color: #FFF;
  background: #FFA201;
}

.mobile-show {
  display: none;
}
@media (max-width: 991.98px) {
  .mobile-show {
    display: block;
  }
}

.sidebar {
  display: flex;
  background-color: #FFF;
  margin-top: 0;
  z-index: 1001;
  position: fixed;
  top: 56px;
  bottom: 0;
  left: 0;
  transition: all 0.5s ease;
  width: 276px;
}
@media (max-width: 991.98px) {
  .sidebar {
    margin-left: -575px;
    transition: all 0.4s ease;
    z-index: 1041;
    background: #FFF;
  }
}
@media (max-width: 575.98px) {
  .sidebar {
    width: 100%;
  }
}
.sidebar .slimScrollDiv {
  border-right: 1px solid transparent;
}
@media (max-width: 575.98px) {
  .sidebar .slimScrollDiv {
    width: 100% !important;
  }
}
.sidebar .sidebar-menu {
  padding: 15px;
}
.sidebar .sidebar-menu .clinicdropdown {
  margin-bottom: 24px;
}
.sidebar .sidebar-menu .clinicdropdown > a {
  background: #F6F6F6;
  border-radius: 5px;
  padding: 10px;
}
.sidebar .sidebar-menu .clinicdropdown > a img {
  width: 42px;
  height: 42px;
  border-radius: 5px;
}
.sidebar .sidebar-menu .clinicdropdown > a .user-names {
  margin-left: 10px;
  flex: 1 1;
}
.sidebar .sidebar-menu .clinicdropdown > a .user-names h5 {
  font-size: 16px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 2px;
}
.sidebar .sidebar-menu .clinicdropdown > a .user-names h6 {
  font-size: 14px;
  font-weight: 400;
  color: #6F6F6F;
  margin-bottom: 0;
}
.sidebar .sidebar-menu .submenu-two .subdrop.active {
  background: transparent !important;
}
.sidebar .sidebar-menu > ul > li {
  margin-bottom: 24px;
}
.sidebar .sidebar-menu > ul > li.active a {
  color: #FFF;
}
.sidebar .sidebar-menu > ul > li.active svg {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li svg {
  min-width: 16px;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.sidebar .sidebar-menu > ul > li > a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 10px 15px;
  position: relative;
  color: #FFA201;
}
.sidebar .sidebar-menu > ul > li > a svg {
  color: #637381;
}
.sidebar .sidebar-menu > ul > li > a img {
  color: #637381;
}
.sidebar .sidebar-menu > ul > li > a.active {
  background: rgba(254, 159, 67, 0.08);
  color: #FE9F43;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li > a.active svg {
  color: #FFF;
}
.sidebar .sidebar-menu > ul > li > a.active img {
  filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);
}
.sidebar .sidebar-menu > ul > li > a.active span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a.active .menu-arrow {
  background: #FFEDDC;
}
.sidebar .sidebar-menu > ul > li > a.active .menu-arrow::before {
  border-color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a span {
  font-size: 15px;
  font-weight: 500;
  color: #565E5E;
}
.sidebar .sidebar-menu > ul > li.active a {
  background: rgba(254, 159, 67, 0.08);
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li.active a img {
  filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);
}
.sidebar .sidebar-menu > ul > li.active a span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li.submenu ul {
  display: none;
}
.sidebar .sidebar-menu > ul > li.submenu ul li a {
  font-weight: 500;
  font-size: 14px;
  position: relative;
  display: block;
  padding: 8px 8px 8px 40px;
  padding-left: 30px;
}
.sidebar .sidebar-menu > ul > li ul {
  display: block;
  margin-bottom: 24px;
}
.sidebar .sidebar-menu > ul > li ul li {
  margin-bottom: 5px;
  border-radius: 5px;
  overflow: hidden;
}
.sidebar .sidebar-menu > ul > li ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #6F6F6F;
  position: relative;
  width: 100%;
  padding: 8px;
}
.sidebar .sidebar-menu > ul > li ul li a i {
  color: #262A2A;
  font-size: 16px;
  background: #F6F6F6;
  border-radius: 5px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar .sidebar-menu > ul > li ul li a span {
  font-size: 15px;
  font-weight: 500;
  white-space: nowrap;
  color: #262A2A;
  margin-left: 10px;
}
.sidebar .sidebar-menu > ul > li ul li a.active {
  color: #E41F07;
  background: #FCE9E6;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li ul li a.active span {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul li a.active i {
  background: #E41F07;
  color: #FFF;
}
.sidebar .sidebar-menu > ul > li ul li a:hover {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul li a:hover span {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul > li.active a.subdrop {
  background: #FFEEEC;
  border-radius: 5px;
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul > li.active a.subdrop i {
  color: #FFF;
  background: #E41F07;
}
.sidebar .sidebar-menu > ul > li ul > li.active a.subdrop span {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul > li .submenu-hdr {
  font-weight: 600;
  font-size: 12px;
  color: #6F6F6F;
  margin: 0 0 14px 0;
  text-transform: uppercase;
}
.sidebar .sidebar-menu > ul > li:first-child h6 {
  margin-top: 0;
}
.sidebar .sidebar-menu > ul > li .submenu ul {
  display: none;
  border: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.sidebar .sidebar-menu > ul li {
  margin-bottom: 5px;
}
.sidebar .sidebar-menu > ul li .submenu > ul {
  margin: 0;
}
.sidebar .sidebar-menu > ul li .submenu > ul li a {
  padding-left: 44px;
  font-size: 14px;
  background: transparent;
  position: relative;
}
.sidebar .sidebar-menu > ul li .submenu > ul li a:after {
  position: absolute;
  content: "";
  background-color: #898989;
  width: 7px;
  height: 7px;
  border-radius: 50px;
  left: 16px;
  top: 14px;
}
.sidebar .sidebar-menu > ul li .submenu > ul li a:before {
  position: absolute;
  content: "";
  background-color: #898989;
  width: 0.5px;
  height: 8px;
  left: 19px;
  top: 0px;
}
.sidebar .sidebar-menu > ul li .submenu > a.subdrop {
  background: #F9F9FC;
}
.sidebar .sidebar-menu > ul li .submenu > a.subdrop i {
  background: #171724;
  color: #FFF;
}
.sidebar .sidebar-menu > ul li .submenu > a.subdrop.submenu-two {
  background: transparent;
}
.sidebar .sidebar-menu > ul li .submenu > a.active {
  background: #FCE9E6;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul li .submenu > a.active i {
  background: #E41F07;
  color: #FFF;
}
.sidebar .sidebar-menu > ul li .submenu > a.active span {
  color: #E41F07;
}
.sidebar .sidebar-menu > ul li .submenu > a.active .menu-arrow::before {
  border-right: 2px solid #E41F07;
  border-bottom: 2px solid #E41F07;
}
.sidebar .sidebar-menu .submenu-open:last-child {
  margin-bottom: 0;
}
.sidebar .sidebar-menu .submenu-open:last-child ul {
  border-bottom: none;
  padding-bottom: 0;
}
.sidebar .sidebar-menu .submenu-open .submenu.submenu-two ul li a {
  margin-left: 45px;
}
.sidebar .sidebar-menu .submenu-open .submenu.submenu-two.submenu-three ul li a {
  margin-left: 65px;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a {
  margin-left: 25px;
  padding-bottom: 4px;
  font-size: 14px;
  color: #B8BCC9;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a::after {
  content: "";
  background: rgba(50, 71, 92, 0.38);
  width: 8px;
  height: 8px;
  border: 2px solid #FFF;
  border-radius: 50px;
  position: absolute;
  top: 16px;
  left: 0;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a:hover {
  color: #E41F07;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a:hover:after {
  background: #FE9F43;
  border: 2px solid #FDB;
}
.sidebar .sidebar-menu .menu-arrow {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  text-rendering: auto;
  line-height: 40px;
  font-size: 18px;
  line-height: 16px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  top: 12px;
  right: 10px;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transition: all 0.2s ease;
}
.sidebar .sidebar-menu .menu-arrow::before {
  height: 8px;
  width: 8px;
  border-top: 0;
  content: "";
  border-left: 0;
  border-right: 2px solid #262A2A;
  border-bottom: 2px solid #262A2A;
  transform: rotate(-45deg);
  position: absolute;
  left: 5px;
  top: 5px;
}
.sidebar .sidebar-menu .menu-arrow.inside-submenu {
  right: 10px;
}
.sidebar .sidebar-menu .menu-arrow.inside-submenu.inside-submenu-two {
  right: 60px;
}
.sidebar .sidebar-menu.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  background: #FFEDDC;
}
.sidebar .nav-link {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 10px;
  color: #FFA201;
  position: relative;
}
.sidebar .nav-link.active {
  color: #E41F07;
  background: transparent;
  position: relative;
}
.sidebar .nav-link.active:after {
  content: "";
  border-width: 10px;
  border-color: transparent #E41F07 transparent transparent;
  border-style: solid;
  position: absolute;
  top: 36px;
  right: 0;
}
.sidebar .sidebar-left {
  width: 100px;
  box-shadow: 5px 0px 15px rgba(0, 0, 0, 0.05);
}
.sidebar .sidebar-right {
  width: 250px;
  height: 100%;
  transition: all 0.2s ease;
  display: none;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right {
    width: calc(100% - 70px);
  }
}
.sidebar .sidebar-right .slimScrollDiv {
  width: 250px !important;
  overflow: visible !important;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right .slimScrollDiv {
    width: 100% !important;
  }
}
.sidebar .sidebar-right .tab-content {
  padding: 20px 20px 40px;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right .tab-content {
    padding: 10px;
  }
}
.sidebar .sidebar-right p {
  font-size: 10px;
  color: #6F7A7A;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 10px;
}
.sidebar .sidebar-right ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sidebar .sidebar-right ul li.active a {
  background: linear-gradient(46.62deg, #E41F07 0%, #676DFF 93.64%);
  color: #FFF;
}
.sidebar .sidebar-right ul li a {
  font-weight: 400;
  font-size: 14px;
  color: #FFA201;
}
.sidebar .sidebar-right ul li a.active {
  color: #E41F07;
}
.sidebar .sidebar-right .menu-arrow {
  transition: transform 0.15s;
  display: inline-block;
  font-family: "Font Awesome 5 Free";
  text-rendering: auto;
  line-height: 40px;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 18px;
  top: 0px;
  position: relative;
  font-weight: 700;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
}
.sidebar .sidebar-right .menu-arrow:before {
  content: "\\f105";
}
.sidebar .sub-menu a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.sidebar li a.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.sidebar .nav-items .nav-link {
  display: flex;
  flex-direction: column;
  border-radius: 0;
  border-bottom: 1px solid #6F6F6F;
  padding: 20px 0;
  transition: all 0.4s ease;
}
.sidebar .nav-items .nav-link:hover {
  box-shadow: 0 0 0 150px #676DFF inset;
  color: #FFF;
}
.sidebar .nav-items .nav-link span {
  margin-top: 15px;
  font-weight: 500;
}
.sidebar .sidemenu a {
  width: 100%;
  font-weight: 500;
  display: block;
  border-radius: 5px;
  margin: 0 0 10px;
  padding: 10px;
}
.sidebar .sidemenu a:hover {
  background: linear-gradient(46.62deg, #E41F07 0%, #676DFF 93.64%);
  color: #FFF;
}
.sidebar .sidemenu a:hover svg {
  color: #FFF;
}
.sidebar .sidemenu a svg {
  stroke-width: 1px;
}

@media (min-width: 991.98px) {
  .mini-sidebar .page-wrapper {
    margin-left: 80px;
  }
  .mini-sidebar .user-names {
    display: none;
  }
  .mini-sidebar .header-left #toggle_btn {
    opacity: 1;
    transform: rotate(180deg);
  }
  .mini-sidebar .header-left #toggle_btn:after {
    border: 0;
  }
  .mini-sidebar .sidebar .sidebar-menu .clinicdropdown > a {
    padding: 5px;
  }
  .mini-sidebar.expand-menu .header-left #toggle_btn {
    opacity: 1;
    transform: rotate(180deg);
  }
  .mini-sidebar.expand-menu .sidebar .sidebar-menu .clinicdropdown > a {
    padding: 10px;
  }
  .mini-sidebar .sidebar-right {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li a span {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li .submenu-hdr {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li svg {
    margin-right: 0;
  }
  .mini-sidebar .sidebar {
    width: 80px;
    overflow: hidden;
  }
  .mini-sidebar.expand-menu .sidebar {
    display: block;
  }
  .expand-menu.mini-sidebar .sidebar .sidebar-menu .submenu-hdr {
    display: block;
  }
  .expand-menu.mini-sidebar .sidebar .user-names {
    display: block;
  }
  .expand-menu .sidebar-right {
    display: block;
    transition: all 0.2s ease;
  }
  .expand-menu .sidebar {
    width: 276px;
  }
  .expand-menu .sidebar .sidebar-menu ul > li > a span {
    display: inline-block;
    line-height: 0;
  }
  .expand-menu .sidebar .sidebar-menu ul > li svg {
    margin-right: 10px;
  }
  .expand-menu .sidebar .sidebar-menu .submenu-hdr {
    display: block;
  }
  .expand-menu .header-left {
    width: 276px;
  }
  #toggle_btn {
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    float: left;
  }
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li ul li a {
  justify-content: start;
}

body.mini-sidebar .sidebar .sidebar-menu > ul > li ul li a {
  justify-content: center;
}
body.mini-sidebar .sidebar .sidebar-menu > ul > li.submenu-open ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-weight: 500;
  font-size: 15px;
  color: #67748E;
  position: relative;
  width: 100%;
  padding: 10px;
}
body.mini-sidebar .sidebar .sidebar-menu > ul > li ul > li.active a {
  padding: 10px;
  justify-content: center;
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li.submenu-open ul li a {
  justify-content: left;
  -webkit-justify-content: left;
  -ms-flex-pack: left;
  padding-left: 18px;
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li ul > li.active a {
  padding: 10px 15px;
  justify-content: start;
}

.sidebarrightmenu .sidebar-right {
  display: block;
}

.slide-nav .sidebar {
  margin-left: 0;
}

.sidebar-overlay {
  display: none;
  height: 100%;
  width: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 60px;
  left: 0;
}
.sidebar-overlay.opened {
  display: block;
}

.mini-sidebar .active.subdrop ~ ul {
  display: none !important;
}

.mini-sidebar.expand-menu .active.subdrop ~ ul {
  display: block !important;
}

.active.subdrop ~ ul {
  display: block !important;
}

.sidebar .sidebar-menu > ul li .submenu.submenu-two > ul li a {
  margin-left: 30px;
}
.sidebar .sidebar-menu > ul li .submenu.submenu-two.submenu-three > ul li a {
  margin-left: 60px;
}

.mini-sidebar .header #toggle_btn {
  opacity: 0;
  height: 0;
  width: 0;
}

[data-sidebar=dark] .sidebar {
  background-color: #171724;
}
[data-sidebar=dark] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #000000;
}
[data-sidebar=dark] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-sidebar=dark] .sidebar .sidebar-menu ul > li ul li a span {
  color: #a3a6a6;
}
[data-sidebar=dark] .sidebar .sidebar-menu .menu-arrow:before {
  border-right: 2px solid #a3a6a6;
  border-bottom: 2px solid #a3a6a6;
}

[data-sidebar=blue] .sidebar {
  background-color: #3C2371;
}
[data-sidebar=blue] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #2f0093;
}
[data-sidebar=blue] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu .clinicdropdown a .user-names h6 {
  color: #e4e4e4;
}
[data-sidebar=blue] .sidebar .sidebar-menu > ul > li .submenu-hdr {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li .submenu-hdr {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a.active i {
  background-color: #3C2371;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a.active span {
  color: #3C2371;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a.active .menu-arrow::before {
  border-right: 2px solid #3C2371;
  border-bottom: 2px solid #3C2371;
}
[data-sidebar=blue] .sidebar .sidebar-menu ul > li ul li a span {
  color: #FFF;
}
[data-sidebar=blue] .sidebar .sidebar-menu .menu-arrow:before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}

[data-sidebar=green] .sidebar {
  background-color: #00918E;
}
[data-sidebar=green] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #005351;
}
[data-sidebar=green] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu .clinicdropdown a .user-names h6 {
  color: #e4e4e4;
}
[data-sidebar=green] .sidebar .sidebar-menu > ul > li .submenu-hdr {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li .submenu-hdr {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a.active i {
  background-color: #00918E;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a.active span {
  color: #00918E;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a.active .menu-arrow::before {
  border-right: 2px solid #00918E;
  border-bottom: 2px solid #00918E;
}
[data-sidebar=green] .sidebar .sidebar-menu ul > li ul li a span {
  color: #FFF;
}
[data-sidebar=green] .sidebar .sidebar-menu .menu-arrow:before {
  border-right: 2px solid #FFF;
  border-bottom: 2px solid #FFF;
}

[data-color=red] .btn-primary {
  background: #E41F07;
  border: 1px solid #E41F07;
}
[data-color=red] .btn-primary:hover {
  background: #c11a06;
  border-color: #c11a06;
}

[data-color=yellow] .btn-primary:hover {
  background: #FF9901 !important;
  border-color: #FF9901 !important;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #FFA201;
  background: #FFF6E6;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a.active span {
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a.active i {
  background: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a:hover {
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li ul li a:hover span {
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu .subdrop.active {
  background: #FFF6E6;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu ul li a.active {
  background: transparent;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: transparent;
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  background: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu > a.active span {
  color: #FFA201;
}
[data-color=yellow] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-right: 2px solid #FFA201;
  border-bottom: 2px solid #FFA201;
}
[data-color=yellow] .user-accordion-item .accordion-wrap:not(.collapsed) span {
  background: #FFA201;
}
[data-color=yellow] .page-header .btn-added {
  background: #FFA201;
}
[data-color=yellow] .settings-menu .nav li a.active {
  color: #FFA201;
  border-bottom: 4px solid #FFA201;
}
[data-color=yellow] .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=yellow] .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=yellow] .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover {
  background: #FFA201;
  border-color: #FFA201;
}
[data-color=yellow] .todo-inbox-check .checkboxs input:checked ~ .checkmarks {
  border-color: #FFA201;
  background-color: #FFA201;
}
[data-color=yellow] .custom-pagination .paginations .page-wrap li a.active {
  background: #FFA201;
}
[data-color=yellow] .contact-nav li a:hover, [data-color=yellow] .contact-nav li a.active {
  color: #FFA201;
  border-color: #FFA201;
}
[data-color=yellow] .dataTables_paginate .pagination li.active a.page-link, [data-color=yellow] #dataTables_paginate .pagination li.active a.page-link {
  background: #FFA201;
  border-color: #FFA201;
}
[data-color=yellow] .btn-primary {
  background: #FFA201;
  border: 1px solid #FFA201;
}
[data-color=yellow] .select2-container--default .select2-results__option--selected {
  background: #FFA201;
  color: #FFF;
}
[data-color=yellow] .view-icons a.active,
[data-color=yellow] .view-icons a:hover {
  background: #FFA201;
}
[data-color=yellow] .btn.btn-primary {
  background-color: #FFA201;
  border: 1px solid #FFA201;
}
[data-color=yellow] .form-check-input:checked {
  background-color: #FFA201;
  border-color: #FFA201;
}
[data-color=yellow] .breadcrumb .breadcrumb-item.active {
  color: #FFA201;
}
[data-color=yellow] .btn-outline-primary {
  border: 1px solid #FFA201 !important;
  color: #FFA201 !important;
}

[data-color=blue] .btn-primary:hover {
  background: #3B4971 !important;
  border-color: #3B4971 !important;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #3C2371;
  background: #ECE9F1;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a.active span {
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a.active i {
  background: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a:hover {
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li ul li a:hover span {
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu .subdrop.active {
  background: #ECE9F1;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu ul li a.active {
  background: transparent;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: transparent;
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  background: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu > a.active span {
  color: #3C2371;
}
[data-color=blue] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-right: 2px solid #3C2371;
  border-bottom: 2px solid #3C2371;
}
[data-color=blue] .user-accordion-item .accordion-wrap:not(.collapsed) span {
  background: #3C2371;
}
[data-color=blue] .page-header .btn-added {
  background: #3C2371;
}
[data-color=blue] .settings-menu .nav li a.active {
  color: #3C2371;
  border-bottom: 4px solid #3C2371;
}
[data-color=blue] .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=blue] .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=blue] .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover {
  background: #3C2371;
  border-color: #3C2371;
}
[data-color=blue] .todo-inbox-check .checkboxs input:checked ~ .checkmarks {
  border-color: #3C2371;
  background-color: #3C2371;
}
[data-color=blue] .custom-pagination .paginations .page-wrap li a.active {
  background: #3C2371;
}
[data-color=blue] .contact-nav li a:hover, [data-color=blue] .contact-nav li a.active {
  color: #3C2371;
  border-color: #3C2371;
}
[data-color=blue] .dataTables_paginate .pagination li.active a.page-link, [data-color=blue] #dataTables_paginate .pagination li.active a.page-link {
  background: #3C2371;
  border-color: #3C2371;
}
[data-color=blue] .btn-primary {
  background: #3C2371;
  border: 1px solid #3C2371;
}
[data-color=blue] .select2-container--default .select2-results__option--selected {
  background: #3C2371;
  color: #FFF;
}
[data-color=blue] .view-icons a.active,
[data-color=blue] .view-icons a:hover {
  background: #3C2371;
}
[data-color=blue] .btn.btn-primary {
  background-color: #3C2371;
  border: 1px solid #3C2371;
}
[data-color=blue] .form-check-input:checked {
  background-color: #3C2371;
  border-color: #3C2371;
}
[data-color=blue] .breadcrumb .breadcrumb-item.active {
  color: #3C2371;
}
[data-color=blue] .btn-outline-primary {
  border: 1px solid #3C2371 !important;
  color: #3C2371 !important;
}

[data-color=green] .btn-primary:hover {
  background: #005e5c !important;
  border-color: #005e5c !important;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a.active {
  color: #00918E;
  background: #E6F4F4;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a.active span {
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a.active i {
  background: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a:hover {
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li ul li a:hover span {
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu .subdrop.active {
  background: #E6F4F4;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu ul li a.active {
  background: transparent;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu > a.active {
  background: transparent;
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu > a.active i {
  background: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu > a.active span {
  color: #00918E;
}
[data-color=green] .sidebar .sidebar-menu > ul > li .submenu > a.active .menu-arrow::before {
  border-right: 2px solid #00918E;
  border-bottom: 2px solid #00918E;
}
[data-color=green] .user-accordion-item .accordion-wrap:not(.collapsed) span {
  background: #00918E;
}
[data-color=green] .page-header .btn-added {
  background: #00918E;
}
[data-color=green] .settings-menu .nav li a.active {
  color: #00918E;
  border-bottom: 4px solid #00918E;
}
[data-color=green] .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=green] .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover,
[data-color=green] .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover {
  background: #00918E;
  border-color: #00918E;
}
[data-color=green] .todo-inbox-check .checkboxs input:checked ~ .checkmarks {
  border-color: #00918E;
  background-color: #00918E;
}
[data-color=green] .custom-pagination .paginations .page-wrap li a.active {
  background: #00918E;
}
[data-color=green] .contact-nav li a:hover, [data-color=green] .contact-nav li a.active {
  color: #00918E;
  border-color: #00918E;
}
[data-color=green] .dataTables_paginate .pagination li.active a.page-link, [data-color=green] #dataTables_paginate .pagination li.active a.page-link {
  background: #00918E;
  border-color: #00918E;
}
[data-color=green] .btn-primary {
  background: #00918E;
  border: 1px solid #00918E;
}
[data-color=green] .select2-container--default .select2-results__option--selected {
  background: #00918E;
  color: #FFF;
}
[data-color=green] .view-icons a.active,
[data-color=green] .view-icons a:hover {
  background: #00918E;
}
[data-color=green] .btn.btn-primary {
  background-color: #00918E;
  border: 1px solid #00918E;
}
[data-color=green] .form-check-input:checked {
  background-color: #00918E;
  border-color: #00918E;
}
[data-color=green] .breadcrumb .breadcrumb-item.active {
  color: #00918E;
}
[data-color=green] .btn-outline-primary {
  border: 1px solid #00918E !important;
  color: #00918E !important;
}

[data-theme=dark] body {
  background-color: #171724;
  color: #a3a6a6;
}
[data-theme=dark] h1, [data-theme=dark] h2, [data-theme=dark] h3, [data-theme=dark] h4, [data-theme=dark] h5, [data-theme=dark] h6, [data-theme=dark] .h1, [data-theme=dark] .h2, [data-theme=dark] .h3, [data-theme=dark] .h4, [data-theme=dark] .h5, [data-theme=dark] .h6 {
  color: #FFF;
}
[data-theme=dark] .header {
  background-color: #171724;
}
[data-theme=dark] .header .header-left {
  background-color: #171724;
}
[data-theme=dark] .header .header-left .logo img {
  display: none;
}
[data-theme=dark] .header .header-left .logo img.white-logo {
  display: block;
}
[data-theme=dark] .header .header-left #toggle_btn {
  color: #FFF;
}
[data-theme=dark] .header .dropdown-menu {
  background-color: #171724;
  box-shadow: none;
}
[data-theme=dark] .header .dropdown-menu a {
  color: #FFF;
}
[data-theme=dark] .header .dropdown-menu .topnav-dropdown-header {
  border-color: #393947;
}
[data-theme=dark] .header .dropdown-menu .topnav-dropdown-header .notification-title {
  color: #FFF;
}
[data-theme=dark] .header .menu-drop-user .dropdown-item {
  border-color: #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li {
  border-bottom: 1px solid #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-title {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-details {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li p.noti-time {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon span {
  border: 1px solid #393947;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-text p {
  color: #FFF;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .noti-pdf .noti-pdf-text span {
  color: #B5B5B5;
}
[data-theme=dark] .header .notification-dropdown .notification-list li .notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #565E5E;
}
[data-theme=dark] .header .notification-dropdown .topnav-dropdown-footer {
  background: #171724;
}
[data-theme=dark] .header .searchinputs input {
  border-color: #393947;
  background: transparent;
}
[data-theme=dark] .header .searchinputs .search-addon button {
  color: #B5B5B5;
}
[data-theme=dark] .header .menus-info .menu-list li a {
  background: transparent;
  border-radius: 5px;
}
[data-theme=dark] .header .menus-info .menu-list li a:hover {
  background: transparent;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-list-icon {
  color: #FFF;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-details-content p {
  color: #FFF;
  margin-bottom: 0;
}
[data-theme=dark] .header .menus-info .menu-list li a .menu-details .menu-details-content span {
  font-weight: 400;
  color: #B5B5B5;
}
[data-theme=dark] .sidebar {
  background-color: #171724;
}
[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown a {
  background-color: #28283E;
}
[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown a .user-names h5 {
  color: #FFF;
}
[data-theme=dark] .sidebar .sidebar-menu ul > li ul li a span {
  color: #a3a6a6;
}
[data-theme=dark] .sidebar .sidebar-menu .menu-arrow:before {
  border-right: 2px solid #a3a6a6;
  border-bottom: 2px solid #a3a6a6;
}
[data-theme=dark] .contact-grid.proposals-grid .grid-head .table-action .action-icon {
  background: #393947;
  color: #FFF;
}
[data-theme=dark] .contact-grid.proposals-grid .grid-footer {
  background: #171724;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .title-head {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings {
  background: #171724;
}
[data-theme=dark] .sidebar-themesettings .themesettings-header {
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-header h4 {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner .themesettings-content {
  border-color: #393947;
}
[data-theme=dark] .sidebar-themesettings .themesettings-inner .themesettings-content h6 {
  color: #FFF;
}
[data-theme=dark] .sidebar-themesettings .input-themeselect {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .sidebar-themesettings .input-themeselect .checkboxs-theme:after {
  border-color: #393947;
}
[data-theme=dark] .form-check-label,
[data-theme=dark] .form-label,
[data-theme=dark] .sub-header {
  color: #a3a6a6;
}
[data-theme=dark] .form-select option {
  background: transparent;
}
[data-theme=dark] .icon-form .form-icon {
  color: #a3a6a6;
}
[data-theme=dark] .drop-down > a,
[data-theme=dark] .export-dropdwon > a,
[data-theme=dark] .form-sorts > a {
  border-color: #393947;
  box-shadow: none;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .drop-down > a:hover,
[data-theme=dark] .export-dropdwon > a:hover,
[data-theme=dark] .form-sorts > a:hover {
  color: #a3a6a6;
}
[data-theme=dark] .manage-dropdwon .dropdown-menu {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .form-sorts .filter-set-content .filter-set-content-head a {
  color: #a3a6a6;
}
[data-theme=dark] .header-set .select2-container--default .select2-selection--single {
  border-color: #393947;
}
[data-theme=dark] .form-sorts .filter-dropdown-menu {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .status-radio:checked + label,
[data-theme=dark] .status-radio:not(:checked) + label {
  color: #a3a6a6;
}
[data-theme=dark] .filter-set-contents .filter-content-list {
  border-color: #393947;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .dataTables_length label .form-select,
[data-theme=dark] #dataTables_length label .form-select {
  border-color: #393947;
  box-shadow: none;
  background-color: #1A1A25;
  color: #a3a6a6;
}
[data-theme=dark] .view-icons {
  border-color: #393947;
}
[data-theme=dark] .toast {
  background-color: #1A1A25;
}
[data-theme=dark] .select2-selection--multiple {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
  color: #a3a6a6;
}
[data-theme=dark] .twitter-bs-wizard .twitter-bs-wizard-nav .step-icon {
  border-color: #FFF;
  color: #FFF;
}
[data-theme=dark] .text-dark {
  color: #a3a6a6 !important;
}
[data-theme=dark] .select2-container--default .select2-selection--single {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__rendered {
  box-shadow: none;
  border: 1px solid #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .select2-container--default .select2-selection--single .select2-selection__arrow {
  box-shadow: none;
}
[data-theme=dark] .toggle-popup .sidebar-layout,
[data-theme=dark] .toggle-popup1 .sidebar-layout,
[data-theme=dark] .toggle-popup2 .sidebar-layout {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .user-accordion-item .accordion-wrap {
  color: #a3a6a6;
}
[data-theme=dark] .user-accordion-item .accordion-wrap:hover {
  color: #a3a6a6;
}
[data-theme=dark] .user-accordion-item .content-collapse {
  border-color: #393947;
}
[data-theme=dark] .bootstrap-tagsinput {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .user-accordion-item,
[data-theme=dark] .files-wrap,
[data-theme=dark] .contact-wrap,
[data-theme=dark] .notes-activity .note-download,
[data-theme=dark] .contact-tab-wrap,
[data-theme=dark] .contact-tab-view,
[data-theme=dark] .calls-box,
[data-theme=dark] .notes-activity .reply-box,
[data-theme=dark] .note-download {
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .contact-sidebar, [data-theme=dark] .contact-tab-view {
  background-color: #1E1E2D;
  box-shadow: none;
}
[data-theme=dark] .action-drop .dropdown-toggle {
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .upcoming-info {
  border-color: #393947;
}
[data-theme=dark] .calls-box .caller-info .calls-user p span {
  color: #a3a6a6;
  font-weight: 500;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-toggle {
  color: #a3a6a6;
  border-color: #393947;
}
[data-theme=dark] .bootstrap-tagsinput {
  box-shadow: none;
}
[data-theme=dark] .contact-grid {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
  box-shadow: none;
}
[data-theme=dark] .contact-grid .grid-head .users-profile .name-user h6 a {
  color: #FFF;
}
[data-theme=dark] .contact-grid .grid-body .address-info p i {
  color: #a3a6a6;
}
[data-theme=dark] .contact-grid .grid-footer {
  border-color: #393947;
}
[data-theme=dark] .company-info li span {
  border-color: #393947;
}
[data-theme=dark] .contacts-action .btn-icon, [data-theme=dark] .contacts-action .btn-icon.rating {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .contacts-action .act-dropdown > a {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .social-info li a {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .view-header .form-sort .select2-container .select2-selection .select2-selection__rendered {
  color: #a3a6a6;
}
[data-theme=dark] .basic-info li span {
  color: #a3a6a6;
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .badge-day {
  color: #a3a6a6;
  background: #3d3d64;
}
[data-theme=dark] .contact-nav li a {
  border-color: transparent;
}
[data-theme=dark] .upcoming-info .dropdown .dropdown-toggle {
  color: #a3a6a6;
}
[data-theme=dark] .contact-sidebar ul, [data-theme=dark] .view-header, [data-theme=dark] .activity-wrap {
  border-color: #393947;
}
[data-theme=dark] .search-section {
  border-color: #393947;
}
[data-theme=dark] .select2-container--default .select2-results__option--selected {
  background: #E41F07;
  color: #FFF;
}
[data-theme=dark] .form-floating > .form-control:not(:placeholder-shown) ~ label::after {
  background: transparent;
}
[data-theme=dark] .select2-dropdown {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .select2-dropdown ul li {
  color: #FFF;
}
[data-theme=dark] .btn-outline-light {
  color: #a3a6a6 !important;
}
[data-theme=dark] .page-wrapper {
  background: #151525;
}
[data-theme=dark] .page-wrapper .page-header h3 {
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-header h4 {
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-header .head-icons a {
  border-color: #393947;
  background: transparent;
  color: #FFF;
}
[data-theme=dark] .page-wrapper .page-title {
  color: #FFF;
}
[data-theme=dark] .note-editable.card-block {
  color: #FFF;
}
[data-theme=dark] .accordion-item {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .accordion-item .accordion-body {
  border-color: #393947;
  background: #28283E;
}
[data-theme=dark] .accordion-button {
  border-color: #393947;
  background: #28283E;
}
[data-theme=dark] .seprator-lg {
  border-color: #393947;
}
[data-theme=dark] .card {
  background: #1E1E2D;
  box-shadow: none;
}
[data-theme=dark] .card.bg-white {
  background: #1E1E2D !important;
}
[data-theme=dark] .card.main-card {
  background: #28283E;
  box-shadow: none;
}
[data-theme=dark] .card.custom-card {
  background: #28283E;
}
[data-theme=dark] .card.custom-card .card-header {
  border-color: #393947;
}
[data-theme=dark] .card.custom-card .card-footer {
  border-color: #393947;
}
[data-theme=dark] .card .card-header {
  border-color: #393947;
}
[data-theme=dark] .card .card-header .card-title {
  color: #FFF;
}
[data-theme=dark] .card .card-header .card-text {
  color: #a3a6a6;
}
[data-theme=dark] .card .card-body {
  color: #a3a6a6;
}
[data-theme=dark] .col-form-label {
  color: #a3a6a6;
}
[data-theme=dark] .custom-table .table-responsive {
  border-color: #393947;
}
[data-theme=dark] .btn-purple-light {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .btn-purple-light:hover {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .note-toolbar {
  background: #171724;
}
[data-theme=dark] .note-btn-group .note-btn {
  background: #171724;
  border-color: #393947;
  color: #a3a6a6;
}
[data-theme=dark] .note-toolbar {
  border-color: #393947;
}
[data-theme=dark] .table-action .action-icon {
  background: #171724;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .table-action .action-icon:hover {
  background: #1A1A25;
  color: #FFF;
}
[data-theme=dark] .table-action .action-icon:hover i {
  color: #FFF;
}
[data-theme=dark] .toggle-popup .sidebar-layout .sidebar-header {
  border-color: #171724;
}
[data-theme=dark] table.table.table-primary {
  background: #171724;
}
[data-theme=dark] table.table thead {
  border-color: #393947;
}
[data-theme=dark] table.table thead tr {
  border-color: #393947;
}
[data-theme=dark] table.table thead tr th {
  background: #171724;
  color: #FFF;
  border-color: #393947;
}
[data-theme=dark] table.table tbody tr td {
  background: #171724;
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead > tr {
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable > thead > tr th {
  background: #171724;
  color: #FFF;
  border-color: #393947;
}
[data-theme=dark] table.table.dataTable tbody tr td {
  background: #171724;
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] .statistic-header h4 i {
  color: #B5B5B5;
}
[data-theme=dark] .statistic-header h4 {
  color: #FFF;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-toggle {
  color: #FFF;
  border: 1px solid #1A1A25;
  box-shadow: none;
  background: #1A1A25;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-toggle:after {
  border-bottom: 2px solid #B5B5B5;
  border-right: 2px solid #B5B5B5;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-menu {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .statistic-header .statistic-dropdown .dropdown-menu a {
  background: transparent;
  color: #FFF;
}
[data-theme=dark] .toggle-popup .sidebar-layout .sidebar-header,
[data-theme=dark] .toggle-popup1 .sidebar-layout .sidebar-header,
[data-theme=dark] .toggle-popup2 .sidebar-layout .sidebar-header {
  border-color: #393947;
}
[data-theme=dark] .form-control, [data-theme=dark] .form-select {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
  box-shadow: none;
}
[data-theme=dark] .form-control:disabled, [data-theme=dark] .form-select:disabled {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .form-control:focus, [data-theme=dark] .form-select:focus {
  border-color: #393947;
  background: #171724;
  color: #a3a6a6;
}
[data-theme=dark] .input-group-text {
  background: #393947;
  color: #a3a6a6;
  border-color: #393947;
}
[data-theme=dark] .radio label, [data-theme=dark] .checkbox label {
  color: #a3a6a6;
}
[data-theme=dark] .apexcharts-text tspan {
  fill: #FFF;
}
[data-theme=dark] a {
  color: #FFF;
}
[data-theme=dark] a.label-add {
  color: #E41F07;
}
[data-theme=dark] .settings-sub-header {
  border-color: #393947;
}
[data-theme=dark] .profile-details {
  border-color: #393947;
}
[data-theme=dark] .profile-upload .profile-upload-img {
  border-color: #393947;
}
[data-theme=dark] .settings-sidebar ul li a {
  color: #B5B5B5;
}
[data-theme=dark] .settings-sidebar ul li a:hover {
  color: #FFF;
}
[data-theme=dark] .settings-sidebar ul li a.active {
  background: #28283D;
  color: #FFF;
}
[data-theme=dark] .btn.btn-light {
  background-color: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .btn.btn-light:hover {
  background-color: rgb(3.1186440678, 3.1186440678, 4.8813559322);
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .security-grid {
  border-color: #393947;
  background: #1E1E2D;
}
[data-theme=dark] .security-grid .security-heading h5 {
  color: #FFF;
}
[data-theme=dark] .notification-wrap ul li .security-checkbox .checkboxs {
  color: #FFF;
}
[data-theme=dark] .notificaion-table .table tbody tr td {
  color: #FFF;
}
[data-theme=dark] .integration-grid {
  background: #28283E;
  border-color: #28283E;
}
[data-theme=dark] .integration-grid .integration-content p {
  color: #FFF;
}
[data-theme=dark] .storage-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .storage-wrap .storage-icon h6 {
  color: #FFF;
}
[data-theme=dark] .black-text {
  color: #FFF !important;
}
[data-theme=dark] .theme-type-images .theme-image {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .theme-type-images .theme-image span {
  color: #FFF;
}
[data-theme=dark] .table tbody tr td a {
  color: #FFF;
}
[data-theme=dark] .text-black {
  color: #FFF !important;
}
[data-theme=dark] .lang-flag a {
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .modal .modal-content {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .modal .modal-content .modal-header {
  border-color: #393947;
}
[data-theme=dark] .modal .modal-content .col-form-label {
  color: #FFF;
}
[data-theme=dark] .drag-attach {
  border-color: #393947;
}
[data-theme=dark] .upload-file {
  border-color: #393947;
  background: #171724;
}
[data-theme=dark] .lang-type li a {
  background: #171724;
}
[data-theme=dark] .dropdown-menu {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .table-action .dropdown-menu a {
  color: #B5B5B5;
}
[data-theme=dark] .table-action .dropdown-menu a:hover {
  background: #28283D;
  color: #FFF;
}
[data-theme=dark] .btn-add {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon {
  background: #1A1A25;
  border-color: #393947;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon:hover {
  background: #1A1A25;
  color: #FFF;
}
[data-theme=dark] .settings-sub-header.setting-item .table-action .action-icon:hover i {
  color: #FFF;
}
[data-theme=dark] .mail-wrapper {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .mail-wrapper .mail-wrap .email-action .info-icon:hover {
  color: #FFF;
}
[data-theme=dark] .mail-wrapper .mail-wrap .email-action .info-icon::after {
  background: #393947;
}
[data-theme=dark] .mail-wrapper .mail-collapse {
  border-color: #393947;
}
[data-theme=dark] .bank-box {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .bank-box.active::after {
  background-color: #28283E;
}
[data-theme=dark] .bank-box .table-action .action-icon:hover {
  background: #1A1A25;
}
[data-theme=dark] .custom-modal .modal-header .btn-close {
  border-color: #393947;
  background: #1A1A25;
  box-shadow: none;
}
[data-theme=dark] .storage-wrap .storage-icon .system-app-icon {
  background: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .storage-wrap .setting-gateway a {
  color: #B5B5B5;
}
[data-theme=dark] .ip-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .ip-wrap .table-action .action-icon {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .ip-wrap .table-action .action-icon:hover {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .action-drop .dropdown-item {
  color: #B5B5B5;
}
[data-theme=dark] .action-drop .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .notes-activity .note-download:hover {
  background-color: transparent;
}
[data-theme=dark] .notes-activity .note-download:hover a {
  background: #28283D;
  color: #B5B5B5;
}
[data-theme=dark] .notes-activity .note-download a {
  background: #28283D;
  color: #B5B5B5;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-menu {
  border-color: #393947;
}
[data-theme=dark] .calls-box .caller-info .calls-action .dropdown-menu .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .bootstrap-tagsinput .tag {
  background: #28283D;
}
[data-theme=dark] .contacts-action .act-dropdown .dropdown-item {
  color: #B5B5B5;
}
[data-theme=dark] .contacts-action .act-dropdown .dropdown-item:hover {
  background: #28283E;
  color: #FFF;
}
[data-theme=dark] .profile-pic-upload .profile-pic {
  border-color: #393947;
}
[data-theme=dark] .contact-wrap .contact-profile .avatar.company-avatar {
  border-color: #393947;
}
[data-theme=dark] .select2-container--default.select2-container--focus .select2-selection--multiple,
[data-theme=dark] .select2-container--default .select2-selection--multiple {
  border-color: #393947;
}
[data-theme=dark] .select2-container--classic .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice,
[data-theme=dark] .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  background: #28283D;
  border-color: #393947;
}
[data-theme=dark] .title-name {
  color: #FFF !important;
}
[data-theme=dark] .kanban-list-items {
  border-color: #393947;
}
[data-theme=dark] .kanban-list-items .kanban-list-head {
  background: #28283E;
}
[data-theme=dark] .kanban-list-items .kanban-list-head .kanban-action-btns .table-action .action-icon {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .email-header .btn-white {
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .pipeline-list {
  border-color: #393947;
}
[data-theme=dark] .priority-info .dropdown .dropdown-toggle {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .priority-info .dropdown a {
  color: #B5B5B5;
}
[data-theme=dark] .pipeline-item {
  border-color: #393947;
}
[data-theme=dark] .pipeline-item p {
  color: #FFF;
}
[data-theme=dark] .kanban-card {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .kanban-card .kanban-card-body ul li {
  color: #B5B5B5;
}
[data-theme=dark] .kanban-card .kanban-card-footer {
  border-color: #393947;
}
[data-theme=dark] .kanban-card .kanban-card-footer span {
  border-color: #393947;
}
[data-theme=dark] .campaign-tab {
  background: #28283E;
}
[data-theme=dark] .campaign-tab ul li a {
  border-color: transparent;
}
[data-theme=dark] .campaign-tab ul li a.active {
  color: #E41F07;
}
[data-theme=dark] .campaign-tab ul li a span {
  border-color: #393947;
}
[data-theme=dark] ul.project-mem li.more-set a {
  background: #28283E;
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .pipeline-progress span, [data-theme=dark] .task-info p,
[data-theme=dark] .con-sidebar-title p, [data-theme=dark] .task-actions ul li {
  color: #FFF;
}
[data-theme=dark] .contact-grid.project .grid-head {
  background-color: #28283E;
}
[data-theme=dark] .contact-grid.project .grid-head .users-profile .con-avatar {
  background-color: #1E1E2D;
  border-color: #393947;
}
[data-theme=dark] .access-wrap li:hover {
  background: #28283E;
}
[data-theme=dark] .task-wrap {
  background: #28283E;
  border-color: #393947;
}
[data-theme=dark] .rate-icon, [data-theme=dark] .con-sidebar-title.border-line {
  border-color: #393947;
}
[data-theme=dark] .pipeline-list ul li a.bg-gray {
  color: #262A2A;
}
[data-theme=dark] .task-wrapper .task-accordion span {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .task-drops .dropdown-toggle {
  background-color: transparent;
}
[data-theme=dark] .task-wrapper {
  border-color: #393947;
}
[data-theme=dark] .card.analytics-card {
  background-color: #1E1E2D;
}
[data-theme=dark] .card.analytics-card .card-header {
  background: transparent;
}
[data-theme=dark] .card.analytics-card .card-header .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #FFF;
}
[data-theme=dark] .activities-list ul li {
  background: #28283E;
}
[data-theme=dark] .activities-list ul li .activity-name h5 {
  color: #FFF;
}
[data-theme=dark] .campaign-card ul .campaign-wrap {
  background: #28283E;
}
[data-theme=dark] .campaign-card ul .campaign-wrap .campaign-info {
  border-color: #393947;
}
[data-theme=dark] .campaign-card ul .campaign-wrap .campaign-info h5 {
  color: #FFF;
}
[data-theme=dark] .card.analytics-card .card-body .table th {
  background: #171724;
  color: #FFF;
}
[data-theme=dark] .card.analytics-card .card-body .table th:first-child, [data-theme=dark] .card.analytics-card .card-body .table th:last-child {
  border-color: #393947;
}
[data-theme=dark] .card.analytics-card .card-body .table td:first-child, [data-theme=dark] .card.analytics-card .card-body .table td:last-child {
  border-color: #393947;
}
[data-theme=dark] .active-list ul li a {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .activity-title h4::after {
  background: #393947;
}
[data-theme=dark] .header-set {
  border-color: #393947;
}
[data-theme=dark] .header-set .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #FFF;
}
[data-theme=dark] .radio-activity li .active-type input[type=radio] ~ label {
  background: #1A1A25;
  border-color: #393947;
  color: #FFF;
}
[data-theme=dark] .tab-activity {
  box-shadow: none;
}
[data-theme=dark] .tab-activity ul li a span {
  color: #B5B5B5;
  border-color: #393947;
}
[data-theme=dark] .report-header {
  border-color: #393947;
}
[data-theme=dark] .location-flag-img {
  border-color: #393947;
}
[data-theme=dark] .table-imgname.flag-image span {
  color: #FFF;
}
[data-theme=dark] .membership-plans .plan-selected h4 {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid .plan-price-head {
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid .plan-price-head .plan-type {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid .plans-features ul li {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid.active {
  background-color: #1E1E2D;
}
[data-theme=dark] .membership-plan-grid.active .plan-price-head {
  border-color: #393947;
}
[data-theme=dark] .membership-plan-grid.active .plan-price-head .plan-type {
  color: #FFF;
}
[data-theme=dark] .membership-plan-grid.active .plans-features ul li {
  color: #FFF;
}
[data-theme=dark] .file-manager aside {
  border-color: #393947;
}
[data-theme=dark] .notes-dash {
  background-color: #28283E;
}
[data-theme=dark] .notes-dash .notes-top-head {
  border-color: #393947;
}
[data-theme=dark] .notes-dash .notes-top-head-submenu {
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-card-body .notes-card-details {
  background-color: #28283E;
  border-color: #393947;
  box-shadow: none;
}
[data-theme=dark] .search-set .search-input input[type=search] {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .search-set .search-input input[type=search]::placeholder {
  color: #B5B5B5;
}
[data-theme=dark] .todo-wrapper-list {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-bulk-wrap {
  background-color: #28283E;
  box-shadow: none;
}
[data-theme=dark] .notes-page-wrapper .content .page-add-notes {
  border-color: #393947;
}
[data-theme=dark] .notes-page-wrapper .content .section-notes-slider {
  border-color: #393947;
}
[data-theme=dark] .fc-day {
  background-color: #28283E;
}
[data-theme=dark] .file-manager .folders {
  border-color: #393947;
  background-color: #28283E;
}
[data-theme=dark] .file-manager .accordion .accordion-item .accordion-body {
  background: transparent;
}
[data-theme=dark] table tbody td.action-table-data a {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat .chat-header {
  background-color: #28283E;
  border-color: #393947;
  box-shadow: none;
}
[data-theme=dark] .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
  background-color: #28283E;
}
[data-theme=dark] .main-chat-blk .chat-page-wrapper .left-chat-title {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .main-chat-blk .chat .chat-header .user-details h5 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body h5 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body p {
  color: #B5B5B5;
}
[data-theme=dark] .main-chat-blk .chat-page-wrapper .setting-title-head h4 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {
  color: #B5B5B5 !important;
}
[data-theme=dark] .main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {
  color: #FFF;
}
[data-theme=dark] .main-chat-blk .sidebar .user-list li a {
  border-color: #393947;
}
[data-theme=dark] .main-chat-blk .last-seen {
  color: #B5B5B5;
}
[data-theme=dark] .daterangepicker {
  background-color: #28283E;
  border-color: #393947;
}
[data-theme=dark] .daterangepicker.show-ranges.ltr .drp-calendar.left {
  border-color: #393947;
}
[data-theme=dark] .daterangepicker .drp-buttons {
  border-color: #393947;
}
[data-theme=dark] .daterangepicker .drp-buttons .btn-default {
  color: #B5B5B5;
}

[data-sidebar=sidebarbg1] .sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebar=sidebarbg1] .sidebar .sidebar-menu {
  background: rgba(255, 255, 255, 0.85);
}

[data-sidebar=sidebarbg2] .sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebar=sidebarbg2] .sidebar .sidebar-menu {
  background: rgba(255, 255, 255, 0.85);
}

[data-sidebar=sidebarbg3] .sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebar=sidebarbg3] .sidebar .sidebar-menu {
  background: rgba(255, 255, 255, 0.85);
}

[data-sidebar=sidebarbg4] .sidebar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  background-color: transparent;
}
[data-sidebar=sidebarbg4] .sidebar .sidebar-menu {
  background: rgba(255, 255, 255, 0.85);
}

[data-theme=dark] .border, [data-theme=dark] .border-top, [data-theme=dark] .border-bottom, [data-theme=dark] .border-start, [data-theme=dark] .border-end {
  border-color: #393947 !important;
}
[data-theme=dark] .dropdown .dropdown-toggle {
  border-color: #393947;
  color: #B5B5B5;
}
[data-theme=dark] .dropdown .dropdown-menu {
  background: #171724;
  border-color: #393947;
}
[data-theme=dark] .bg-white {
  background: #171724 !important;
}
[data-theme=dark] .bg-light-200, [data-theme=dark] .bg-light-300, [data-theme=dark] .bg-light-400 {
  background: #1A1A25;
}
[data-theme=dark] .dropdown .dropdown-menu .dropdown-item {
  background: #1A1A25;
}
[data-theme=dark] .offcanvas {
  background: #171724;
}
[data-theme=dark] .accordion-button:after {
  background: transparent;
}
[data-theme=dark] .bg-success.border {
  border-color: #5CB85C !important;
}
[data-theme=dark] .bg-purple.border {
  border-color: #4A00E5 !important;
}
[data-theme=dark] .bg-warning.border {
  border-color: #FDA700 !important;
}
[data-theme=dark] .bg-danger.border {
  border-color: #FC0027 !important;
}
[data-theme=dark] .btn-close {
  --bs-btn-close-color: \$dark-text;
  color: #FFF;
}
[data-theme=dark] .input-themeselect span {
  color: #FFF;
}

.sidebar-contact {
  position: fixed;
  top: 0%;
  right: -350px;
  transform: translateY(-50%);
  width: 350px;
  height: auto;
  background: #fff;
  box-sizing: border-box;
  transition: 0.5s;
  z-index: 9999;
}
.sidebar-contact .toggle-theme {
  position: absolute;
  width: 35px;
  text-align: center;
  cursor: pointer;
  background: #fed713;
  top: 225px;
  right: 350px;
  padding: 6px;
  height: 35px;
  color: #000;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.sidebar-contact .toggle-theme .fa-spin {
  animation: fa-spin 2s infinite linear;
}

#theme-settings {
  width: 26px;
  height: 26px;
  border: 1px solid #E8E8E8;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
}

.input-themeselect label {
  width: 100%;
}

.sidebar-themesettings {
  position: fixed;
  right: -380px;
  top: 0;
  background: #fff;
  transition: all 0.5s;
  width: 380px;
  height: 100vh;
  z-index: 99999;
  padding: 15px;
  overflow: auto;
  max-width: 100%;
}
.sidebar-themesettings.open {
  right: 0;
}
.sidebar-themesettings .themesettings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid #E8E8E8;
}
.sidebar-themesettings .themesettings-header h4 {
  color: #262A2A;
  font-size: 18px;
}
.sidebar-themesettings .themesettings-inner {
  padding: 24px;
  background: #fff;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin-top: 15px;
  padding-bottom: 9px;
}
.sidebar-themesettings .themesettings-inner .themesettings-content {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.sidebar-themesettings .themesettings-inner .themesettings-content h6 {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-bottom: 15px;
}
.sidebar-themesettings .input-themeselect {
  background: #F6F6F6;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.sidebar-themesettings .input-themeselect input[type=radio] {
  display: none;
}
.sidebar-themesettings .input-themeselect input[type=radio]:checked ~ label .checkboxs-theme:after {
  background-color: #4A00E5;
  border-color: #4A00E5;
  content: "";
}
.sidebar-themesettings .input-themeselect input[type=radio]:checked ~ label .checkboxs-theme::before {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  right: 4px;
  position: absolute;
  top: -14px;
  z-index: 9;
}
.sidebar-themesettings .input-themeselect img {
  height: 80px;
}
.sidebar-themesettings .input-themeselect .checkboxs-theme {
  position: relative;
  width: 100%;
  display: block;
}
.sidebar-themesettings .input-themeselect .checkboxs-theme:after {
  position: absolute;
  content: "";
  border: 1px solid #E8E8E8;
  width: 16px;
  height: 16px;
  border-radius: 5px;
  right: 0;
  top: -17px;
}

.sidebar-themeoverlay {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: -100%;
  z-index: 10000;
}
.sidebar-themeoverlay.open {
  left: 0;
}

.theme-colorsset {
  margin: 15px 0;
}
.theme-colorsset ul {
  display: flex;
  align-items: center;
}
.theme-colorsset ul li .input-themeselects label {
  width: 30px;
  height: 30px;
  border-radius: 2px;
  position: relative;
}
.theme-colorsset ul li .input-themeselects label.red-clr {
  background: #E41F07;
}
.theme-colorsset ul li .input-themeselects label.yellow-clr {
  background: #FFA201;
}
.theme-colorsset ul li .input-themeselects label.blue-clr {
  background: #3C2371;
}
.theme-colorsset ul li .input-themeselects label.green-clr {
  background: #00918E;
}
.theme-colorsset ul li .input-themeselects input[type=radio] {
  display: none;
}
.theme-colorsset ul li .input-themeselects input[type=radio]:checked ~ label:after {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}
.theme-colorsset ul li + li {
  margin-left: 10px;
}

.themesettings-footer {
  margin-top: 15px;
}
.themesettings-footer ul {
  display: flex;
  align-items: center;
}
.themesettings-footer ul li {
  width: 50%;
}
.themesettings-footer ul li + li {
  margin-left: 10px;
}
.themesettings-footer ul li .btn {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  padding: 8px;
}
.themesettings-footer ul li .btn-cancel {
  background: #F6F6F6;
  border: 1px solid #E8E8E8;
  color: #262A2A;
}
.themesettings-footer ul li .btn-cancel:hover {
  background: #E8E8E8;
}
.themesettings-footer ul li .btn-reset {
  background: #00918E;
  color: #fff;
}
.themesettings-footer ul li .btn-reset:hover {
  background: #005e5c;
}

.topnav-dropdown-header {
  padding: 15px;
  border-bottom: 1px solid #E8E8E8;
}
.topnav-dropdown-header .notification-title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  margin-bottom: 0;
}

.notification-dropdown .noti-content {
  width: 440px;
  height: 390px;
  overflow-y: auto;
  position: relative;
}
.notification-dropdown .notification-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.notification-dropdown .notification-list li {
  margin-top: 0;
  border-bottom: 1px solid #F4F4F4;
  font-size: 14px;
}
.notification-dropdown .notification-list li:last-child {
  border-bottom: 0;
}
.notification-dropdown .notification-list li a {
  display: block;
  padding: 15px;
}
.notification-dropdown .notification-list li .avatar {
  width: 36px;
  height: 36px;
  margin: 0 16px 0 0;
  border-radius: 5px;
  position: relative;
}
.notification-dropdown .notification-list li .avatar img {
  border-radius: 5px;
}
.notification-dropdown .notification-list li .avatar .badge {
  display: inline-block;
  position: absolute;
  top: -7px;
  left: -7px;
  padding: 4px;
}
.notification-dropdown .notification-list li .noti-title {
  color: #323737;
  font-weight: 500;
}
.notification-dropdown .notification-list li .noti-details {
  font-weight: 500;
  color: #6F6F6F;
  margin: 0 0 8px;
}
.notification-dropdown .notification-list li .noti-sub-details {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: #6F6F6F;
  position: relative;
  margin: 0 0 8px;
  padding: 0 0 0 15px;
}
.notification-dropdown .notification-list li .noti-sub-details::before {
  content: "";
  position: absolute;
  left: 0;
  width: 4px;
  height: -webkit-fill-available;
  background: #6F6F6F;
  border-radius: 5px;
}
.notification-dropdown .notification-list li p.noti-time {
  font-size: 12px;
  color: #262A2A;
  margin: 0;
}
.notification-dropdown .notification-list li .noti-pdf {
  display: inline-flex;
  align-items: center;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 8px;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon {
  margin-right: 10px;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-icon span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #E41F07;
  width: 24px;
  min-width: 24px;
  height: 24px;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-text {
  line-height: normal;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-text p {
  font-size: 12px;
  color: #262A2A;
  margin-bottom: 0;
}
.notification-dropdown .notification-list li .noti-pdf .noti-pdf-text span {
  font-size: 12px;
  color: #6F6F6F;
}
.notification-dropdown .notification-list li .notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #565E5E;
}
.notification-dropdown .notification-list li .list-item {
  border: 0;
  padding: 0;
  position: relative;
}
.notification-dropdown .notification-list li .list-item .list-left {
  height: 48px;
  position: absolute;
  width: 48px;
}
.notification-dropdown .notification-list li .list-item .list-body {
  padding: 0 0 0 50px;
}
.notification-dropdown .notification-list li .list-item .list-body .message-author {
  color: #323737;
  float: left;
  font-weight: 500;
  width: 175px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.notification-dropdown .notification-list li .list-item .list-body .message-time {
  color: #565E5E;
  float: right;
  font-size: 11px;
}
.notification-dropdown .notification-list li .list-item .list-body .message-content {
  color: #323737;
  font-size: 13px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topnav-dropdown-footer {
  background: #F9F9FC;
  text-align: right;
  padding: 15px;
}
.topnav-dropdown-footer a {
  font-weight: 600;
  margin-right: 15px;
}
.topnav-dropdown-footer a:last-child {
  margin-right: 0;
}
.topnav-dropdown-footer .view-link {
  color: #262A2A;
}
.topnav-dropdown-footer .view-link:hover {
  color: #6F6F6F;
}
.topnav-dropdown-footer .clear-link {
  color: #E41F07;
}
.topnav-dropdown-footer .clear-link:hover {
  color: rgb(178.5191489362, 24.2723404255, 5.4808510638);
}

.list-left {
  height: 48px;
  position: absolute;
  width: 48px;
}

.list-body {
  padding: 0 0 0 50px;
}
.list-body .message-author {
  color: #323737;
  float: left;
  font-weight: 500;
  width: 175px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-body .message-time {
  color: #565E5E;
  float: right;
  font-size: 11px;
}
.list-body .message-content {
  color: #323737;
  font-size: 13px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activity {
  width: 100%;
}
.activity .activity-box {
  position: relative;
}
.activity .activity-list {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
}
.activity .activity-list li {
  background-color: #FFF;
  position: relative;
  border: 1px solid #6F6F6F;
  margin: 0 0 10px;
  padding: 20px 10px 10px;
  font-size: 15px;
}
.activity .activity-list li .activity-user {
  height: 50px;
  margin: 0;
  padding: 0;
  width: 50px;
  position: absolute;
  top: 12px;
  left: 8px;
}
.activity .activity-list li .activity-content {
  background-color: #FFF;
  position: relative;
  margin: 0 0 0 60px;
  padding: 0;
}
.activity .activity-list li .time {
  color: #6F7A7A;
  display: block;
  font-size: 12px;
  line-height: 1.35;
}
.activity .activity-list li a.name {
  color: #000;
}
.activity .activity-list li a {
  color: #FFA201;
  font-weight: 600;
  font-size: 15px;
}
.activity .activity-list li a img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
}

/******* Components ******/
.avatar {
  position: relative;
  height: 2.625rem;
  width: 2.625rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #FFF;
  font-weight: 500;
}
.avatar a.badge:hover {
  color: #FFF;
}
.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.avatar.avatar-rounded {
  border-radius: 50%;
}
.avatar.avatar-rounded img {
  border-radius: 50%;
}
.avatar.avatar-radius-0 {
  border-radius: 0;
}
.avatar.avatar-radius-0 img {
  border-radius: 0;
}
.avatar .avatar-badge {
  position: absolute;
  inset-block-start: -4%;
  inset-inline-end: -0.375rem;
  width: 1.4rem;
  height: 1.4rem;
  font-size: 0.625rem;
  border: 2px solid #FFF;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar.online:before, .avatar.offline:before {
  position: absolute;
  content: "";
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  inset-inline-end: 0;
  inset-block-end: 0;
  border: 2px solid #FFF !important;
  z-index: 1;
}
.avatar.online:before {
  background-color: #5CB85C;
}
.avatar.offline:before {
  background-color: #6F7A7A;
}
.avatar.avatar-xs {
  width: 1.25rem;
  height: 1.25rem;
  line-height: 1.25rem;
  font-size: 0.65rem;
}
.avatar.avatar-xs .avatar-badge {
  padding: 0.25rem;
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.5rem;
  inset-block-start: -25%;
  inset-inline-end: -0.5rem;
}
.avatar.avatar-sm {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 0.65rem;
}
.avatar.avatar-sm .avatar-badge {
  padding: 0.3rem;
  width: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.5rem;
  inset-block-start: -28%;
  inset-inline-end: -0.45rem;
}
.avatar.avatar-sm.online:before, .avatar.avatar-sm.offline:before {
  width: 0.5rem;
  height: 0.5rem;
}
.avatar.avatar-md {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  font-size: 0.8rem;
}
.avatar.avatar-md .avatar-badge {
  padding: 0.4rem;
  width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.65rem;
  inset-block-start: -6%;
  inset-inline-end: -13%;
}
.avatar.avatar-md.online:before, .avatar.avatar-md.offline:before {
  width: 0.75rem;
  height: 0.75rem;
}
.avatar.avatar-md svg {
  width: 1.5rem;
  height: 1.5rem;
}
.avatar.avatar-lg {
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  font-size: 1rem;
}
.avatar.avatar-lg .avatar-badge {
  inset-block-start: -15%;
  inset-inline-end: -0.25%;
}
.avatar.avatar-lg.online:before, .avatar.avatar-lg.offline:before {
  width: 0.8rem;
  height: 0.8rem;
}
.avatar.avatar-lg svg {
  width: 1.8rem;
  height: 1.8rem;
}
.avatar.avatar-xl {
  width: 4rem;
  height: 4rem;
  line-height: 4rem;
  font-size: 1.25rem;
}
.avatar.avatar-xl .avatar-badge {
  inset-block-start: -8%;
  inset-inline-end: -0.2%;
}
.avatar.avatar-xl.online:before, .avatar.avatar-xl.offline:before {
  width: 0.95rem;
  height: 0.95rem;
}
.avatar.avatar-xxl {
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.5rem;
}
.avatar.avatar-xxl .avatar-badge {
  inset-block-start: -4%;
  inset-inline-end: 0rem;
}
.avatar.avatar-xxl.online:before, .avatar.avatar-xxl.offline:before {
  width: 1.05rem;
  height: 1.05rem;
  inset-block-end: 0.25rem;
}
.avatar.avatar-xxl.online.online-sm:before, .avatar.avatar-xxl.offline.online-sm:before {
  width: 10px;
  height: 10px;
  inset-block-end: 0rem;
}
.avatar.avatar-xxxl {
  width: 6rem;
  height: 6rem;
  line-height: 6rem;
  font-size: 1.75rem;
}
.avatar.avatar-xxxl .avatar-badge {
  inset-block-start: -4%;
  inset-inline-end: 0rem;
}
.avatar.avatar-xxxl.online:before, .avatar.avatar-xxxl.offline:before {
  width: 1.05rem;
  height: 1.05rem;
  inset-block-end: 0.25rem;
}

.avatar-list-stacked {
  padding: 0;
}
.avatar-list-stacked.avatar-group-overlapped .avatar {
  margin-right: -0.875rem;
}
.avatar-list-stacked.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-list-stacked.avatar-group-lg .avatar {
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-list-stacked.avatar-group-lg .avatar > .initial-wrap {
  font-size: 0.95rem;
}
.avatar-list-stacked.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -1rem;
}
.avatar-list-stacked.avatar-group-sm .avatar {
  width: 2rem;
  height: 2rem;
}
.avatar-list-stacked.avatar-group-sm .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-list-stacked.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -0.625rem;
}
.avatar-list-stacked.avatar-group-xs .avatar {
  width: 1.5rem;
  height: 1.5rem;
}
.avatar-list-stacked.avatar-group-xs .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-list-stacked .avatar {
  margin-inline-end: -0.875rem !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  vertical-align: middle;
  transition: transform ease 200ms;
}
.avatar-list-stacked .avatar:last-child {
  margin-inline-end: 0 !important;
}
.avatar-list-stacked .avatar:hover {
  z-index: 1;
  transform: translateY(-0.188rem);
}

.avatar-group {
  display: inline-flex;
}
.avatar-group .avatar {
  width: 2.625rem;
  height: 2.625rem;
}
.avatar-group .avatar .avatar-img,
.avatar-group .avatar > .initial-wrap {
  border: 2px solid #FFF;
  font-size: 0.9rem;
}
.avatar-group.avatar-group-overlapped .avatar {
  margin-right: -0.875rem;
}
.avatar-group.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-group.avatar-group-lg .avatar {
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-group.avatar-group-lg .avatar > .initial-wrap {
  font-size: 0.95rem;
}
.avatar-group.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -1rem;
}
.avatar-group.avatar-group-sm .avatar {
  width: 2rem;
  height: 2rem;
}
.avatar-group.avatar-group-sm .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-group.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -0.625rem;
}

.avatar-xxs {
  width: 16px;
  height: 16px;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #FDA700;
  text-shadow: unset;
}

.bootstrap-datetimepicker-widget table td.today:before {
  border-bottom-color: #FDA700;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {
  background: transparent;
}

.bor-b1 {
  border-bottom: 1px solid #898989;
}

.link-purple {
  color: #4A00E5;
}
.link-purple:hover {
  color: rgb(70.703930131, 0, 218.8);
}

hr {
  border-color: #E8E8E8;
}

.btn-primary {
  color: #FFF;
  background-color: #E41F07;
  border-color: #E41F07;
  font-size: 14px;
  font-size: 14px;
}

.btn-save {
  background: #E41F07;
  color: #FFF;
  font-size: 14px;
  font-size: 14px;
  border-radius: 5px;
  padding: 8px 20px;
  transition: all 0.2s ease;
}
.btn-save:hover {
  background: rgb(178.5191489362, 24.2723404255, 5.4808510638);
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-save {
    min-width: auto;
    padding: 5px 7px;
  }
}

.btn-reset {
  background: #6F6F6F;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  padding: 8px 20px;
  transition: all 0.2s ease;
}
.btn-reset:hover {
  background: #FFA201;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-reset {
    min-width: auto;
    padding: 5px 7px;
  }
}

.btn-send {
  background: #E41F07;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-send:hover {
  background: rgb(178.5191489362, 24.2723404255, 5.4808510638);
  color: #FFF;
}
.btn-send .send-mail {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-download {
  background: #FFA201;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-download:hover {
  background: #262A2A;
  color: #FFF;
}
.btn-download .download {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-barcode {
  background: #FC0027;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-barcode:hover {
  background: #FC0027;
  color: #FFF;
}
.btn-barcode .print {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-primary.add-em-payroll {
  padding: 9px 11px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
}
.btn-primary.add-em-payroll .me-2 {
  width: 16px;
  height: 16px;
}

.swal2-actions .swal2-confirm.btn:active {
  background-color: #E41F07;
  border-color: #E41F07;
}

.btn-check:checked + .btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active {
  background-color: #E41F07;
  border-color: #E41F07;
  color: #FFF;
}

.modal .card {
  border: 0;
}

.search-input .btn-searchset:active {
  background-color: transparent;
  border-color: transparent;
}
.search-input .btn-searchset:active svg {
  color: #FFA201;
}

.input-blocks input[type=text].datetimepicker {
  padding-left: 35px;
}

.iti__country-list {
  z-index: 101;
}

button {
  cursor: pointer;
}
button:focus {
  outline: 0;
  box-shadow: none;
}

.btn {
  border-radius: 5px;
  padding: 0.625rem 1.25rem;
  padding: 0.5rem 0.85rem;
  font-size: 0.85rem;
  transition: all 0.5s;
  font-weight: 600;
}
.btn:focus {
  box-shadow: none !important;
}
.btn:hover {
  transition: all 0.5s;
}
.btn.btn-lg {
  padding: 0.65rem 1rem;
  font-size: 0.95rem;
}
.btn.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}
.btn.btn-primary {
  background-color: #E41F07;
  border: 1px solid #E41F07;
  color: #FFF;
}
.btn.btn-primary:hover, .btn.btn-primary:focus, .btn.btn-primary.focus, .btn.btn-primary:active, .btn.btn-primary.active {
  background-color: rgb(193.3634042553, 26.2906382979, 5.9365957447);
  border: 1px solid rgb(193.3634042553, 26.2906382979, 5.9365957447);
  color: #FFF;
}
.btn.btn-secondary {
  background-color: #FFA201;
  border: 1px solid #FFA201;
  color: #FFF;
}
.btn.btn-secondary:hover, .btn.btn-secondary:focus, .btn.btn-secondary.focus, .btn.btn-secondary:active, .btn.btn-secondary.active {
  background-color: rgb(220.3, 139.638976378, 0);
  border: 1px solid rgb(220.3, 139.638976378, 0);
  color: #FFF;
}
.btn.btn-success {
  background-color: #5CB85C;
  border: 1px solid #5CB85C;
  color: #FFF;
}
.btn.btn-success:hover, .btn.btn-success:focus, .btn.btn-success.focus, .btn.btn-success:active, .btn.btn-success.active {
  background-color: rgb(72.9115384615, 167.3884615385, 72.9115384615);
  border: 1px solid rgb(72.9115384615, 167.3884615385, 72.9115384615);
  color: #FFF;
}
.btn.btn-info {
  background-color: #1ECBE2;
  border: 1px solid #1ECBE2;
  color: #FFF;
}
.btn.btn-info:hover, .btn.btn-info:focus, .btn.btn-info.focus, .btn.btn-info:active, .btn.btn-info.active {
  background-color: rgb(25.1523622047, 175.1992125984, 195.1476377953);
  border: 1px solid rgb(25.1523622047, 175.1992125984, 195.1476377953);
  color: #FFF;
}
.btn.btn-warning {
  background-color: #FDA700;
  border: 1px solid #FDA700;
  color: #FFF;
}
.btn.btn-warning:hover, .btn.btn-warning:focus, .btn.btn-warning.focus, .btn.btn-warning:active, .btn.btn-warning.active {
  background-color: rgb(217.3, 143.4351778656, 0);
  border: 1px solid rgb(217.3, 143.4351778656, 0);
  color: #FFF;
}
.btn.btn-danger {
  background-color: #FC0027;
  border: 1px solid #FC0027;
  color: #FFF;
}
.btn.btn-danger:hover, .btn.btn-danger:focus, .btn.btn-danger.focus, .btn.btn-danger:active, .btn.btn-danger.active {
  background-color: rgb(216.3, 0, 33.475);
  border: 1px solid rgb(216.3, 0, 33.475);
  color: #FFF;
}
.btn.btn-dark {
  background-color: #171724;
  border: 1px solid #171724;
  color: #FFF;
}
.btn.btn-dark:hover, .btn.btn-dark:focus, .btn.btn-dark.focus, .btn.btn-dark:active, .btn.btn-dark.active {
  background-color: rgb(9.0830508475, 9.0830508475, 14.2169491525);
  border: 1px solid rgb(9.0830508475, 9.0830508475, 14.2169491525);
  color: #FFF;
}
.btn.btn-light {
  background-color: #FDFDFE;
  border: 1px solid #FDFDFE;
  color: #FFF;
}
.btn.btn-light:hover, .btn.btn-light:focus, .btn.btn-light.focus, .btn.btn-light:active, .btn.btn-light.active {
  background-color: rgb(229.2, 229.2, 242.1);
  border: 1px solid rgb(229.2, 229.2, 242.1);
  color: #FFF;
}
.btn.btn-black {
  background-color: #000;
  border: 1px solid #000;
  color: #FFF;
}
.btn.btn-black:hover, .btn.btn-black:focus, .btn.btn-black.focus, .btn.btn-black:active, .btn.btn-black.active {
  background-color: black;
  border: 1px solid black;
  color: #FFF;
}
.btn.btn-purple {
  background-color: #4A00E5;
  border: 1px solid #4A00E5;
  color: #FFF;
}
.btn.btn-purple:hover, .btn.btn-purple:focus, .btn.btn-purple.focus, .btn.btn-purple:active, .btn.btn-purple.active {
  background-color: rgb(62.4637554585, 0, 193.3);
  border: 1px solid rgb(62.4637554585, 0, 193.3);
  color: #FFF;
}
.btn.btn-yellow {
  background-color: #ffff00;
  border: 1px solid #ffff00;
  color: #FFF;
}
.btn.btn-yellow:hover, .btn.btn-yellow:focus, .btn.btn-yellow.focus, .btn.btn-yellow:active, .btn.btn-yellow.active {
  background-color: rgb(219.3, 219.3, 0);
  border: 1px solid rgb(219.3, 219.3, 0);
  color: #FFF;
}
.btn.btn-teal {
  background-color: #02a8b5;
  border: 1px solid #02a8b5;
  color: #FFF;
}
.btn.btn-teal:hover, .btn.btn-teal:focus, .btn.btn-teal.focus, .btn.btn-teal:active, .btn.btn-teal.active {
  background-color: rgb(1.6098360656, 135.2262295082, 145.6901639344);
  border: 1px solid rgb(1.6098360656, 135.2262295082, 145.6901639344);
  color: #FFF;
}
.btn.btn-light {
  background-color: #F5F5F5;
  border: 1px solid #E8E8E8;
  color: #262A2A;
}
.btn.btn-light:hover, .btn.btn-light:focus, .btn.btn-light.focus, .btn.btn-light:active, .btn.btn-light.active {
  background-color: rgb(237.35, 237.35, 237.35);
  border: 1px solid #E8E8E8;
  color: #262A2A;
}

.btn-group .btn {
  padding: 0.45rem 0.75rem;
}

.btn-group-lg .btn {
  padding: 0.65rem 1rem;
}

.btn-group-sm .btn {
  padding: 0.25rem 0.5rem;
}

.btn.btn-w-xs {
  min-width: 5.625rem;
}
.btn.btn-w-sm {
  min-width: 6.975rem;
}
.btn.btn-w-md {
  min-width: 8.125rem;
}
.btn.btn-w-lg {
  min-width: 9.375rem;
}

.btn-icon i {
  padding: 0rem;
  margin: -0.5rem;
}
.btn-icon.btn-sm {
  width: 1.75rem;
  height: 1.75rem;
  font-size: 0.8rem;
}
.btn-icon.btn-lg {
  width: 2.75rem;
  height: 2.75rem;
  font-size: 1.2rem;
}

.btn-list > button, .btn-list > a {
  margin: 0 0.375rem 0.375rem 0;
}

[dir=rtl] .btn-list button,
[dir=rtl] .btn-list div,
[dir=rtl] .btn-list a,
[dir=rtl] .btn-list input {
  margin: 0 0 0.375rem 0.375rem;
}

.btn-list {
  margin-block-end: -0.5rem;
}

.btn-square {
  border-radius: 0;
}

.btn-group-pill .btn:first-child {
  border-radius: 60px 0 0 60px;
}

.btn-group-pill .btn:last-child {
  border-radius: 0 60px 60px 0;
}

.btn-group-square .btn:first-child {
  border-radius: 0px 0 0 0px;
}

.btn-group-square .btn:last-child {
  border-radius: 0 0px 0px 0;
}

.btn.btn-primary-light {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.btn.btn-primary-light:hover, .btn.btn-primary-light:focus, .btn.btn-primary-light:active {
  background-color: #E41F07;
  color: #FFF;
  border-color: #E41F07;
}
.btn.btn-secondary-light {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
}
.btn.btn-secondary-light:hover, .btn.btn-secondary-light:focus, .btn.btn-secondary-light:active {
  background-color: #FFA201;
  color: #FFF;
  border-color: #FFA201;
}
.btn.btn-warning-light {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
}
.btn.btn-warning-light:hover, .btn.btn-warning-light:focus, .btn.btn-warning-light:active {
  background-color: #FDA700;
  color: #FFF;
  border-color: #FDA700;
}
.btn.btn-info-light {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
}
.btn.btn-info-light:hover, .btn.btn-info-light:focus, .btn.btn-info-light:active {
  background-color: #1ECBE2;
  color: #FFF;
  border-color: #1ECBE2;
}
.btn.btn-success-light {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
}
.btn.btn-success-light:hover, .btn.btn-success-light:focus, .btn.btn-success-light:active {
  background-color: #5CB85C;
  color: #FFF;
  border-color: #5CB85C;
}
.btn.btn-danger-light {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
}
.btn.btn-danger-light:hover, .btn.btn-danger-light:focus, .btn.btn-danger-light:active {
  background-color: #FC0027;
  color: #FFF;
  border-color: #FC0027;
}

.btn.btn-primary-ghost {
  background-color: transparent;
  color: #E41F07;
  border: 1px solid #E41F07;
}
.btn.btn-primary-ghost:active {
  color: #E41F07;
  border: 1px solid #E41F07;
  background-color: transparent;
}
.btn.btn-dark {
  background: #131022 !important;
  border-color: #131022 !important;
  box-shadow: none;
  color: #fff;
}
.btn.btn-dark:hover {
  background: #E41F07;
}
.btn.btn-secondary-ghost {
  background-color: transparent;
  color: #FFA201;
  border: 1px solid #FFA201;
}
.btn.btn-secondary-ghost:active {
  color: #FFA201;
  border: 1px solid #FFA201;
  background-color: transparent;
}
.btn.btn-warning-ghost {
  background-color: transparent;
  color: #FDA700;
  border: 1px solid #FDA700;
}
.btn.btn-warning-ghost:active {
  color: #FDA700;
  border: 1px solid #FDA700;
  background-color: transparent;
}
.btn.btn-info-ghost {
  background-color: transparent;
  color: #1ECBE2;
  border: 1px solid #1ECBE2;
}
.btn.btn-info-ghost:active {
  color: #1ECBE2;
  border: 1px solid #1ECBE2;
  background-color: transparent;
}
.btn.btn-success-ghost {
  background-color: transparent;
  color: #5CB85C;
  border: 1px solid #5CB85C;
}
.btn.btn-success-ghost:active {
  color: #5CB85C;
  border: 1px solid #5CB85C;
  background-color: transparent;
}
.btn.btn-danger-ghost {
  background-color: transparent;
  color: #FC0027;
  border: 1px solid #FC0027;
}
.btn.btn-danger-ghost:active {
  color: #FC0027;
  border: 1px solid #FC0027;
  background-color: transparent;
}

.btn-list button {
  margin: 0 0.375rem 0.375rem 0;
}

.btn-outline-primary {
  border: 1px solid #E41F07 !important;
  color: #E41F07 !important;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary.focus, .btn-outline-primary:active, .btn-outline-primary.active {
  background-color: #E41F07 !important;
  border: 1px solid #E41F07 !important;
  box-shadow: 0 3px 10px rgba(228, 31, 7, 0.5);
  color: #FFF !important;
}

.btn-outline-secondary {
  border: 1px solid #FFA201 !important;
  color: #FFA201 !important;
}
.btn-outline-secondary:hover, .btn-outline-secondary:focus, .btn-outline-secondary.focus, .btn-outline-secondary:active, .btn-outline-secondary.active {
  background-color: #FFA201 !important;
  border: 1px solid #FFA201 !important;
  box-shadow: 0 3px 10px rgba(255, 162, 1, 0.5);
  color: #FFF !important;
}

.btn-outline-success {
  border: 1px solid #5CB85C !important;
  color: #5CB85C !important;
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success.focus, .btn-outline-success:active, .btn-outline-success.active {
  background-color: #5CB85C !important;
  border: 1px solid #5CB85C !important;
  box-shadow: 0 3px 10px rgba(92, 184, 92, 0.5);
  color: #FFF !important;
}

.btn-outline-danger {
  border: 1px solid #FC0027 !important;
  color: #FC0027 !important;
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger.focus, .btn-outline-danger:active, .btn-outline-danger.active {
  background-color: #FC0027 !important;
  border: 1px solid #FC0027 !important;
  box-shadow: 0 3px 10px rgba(252, 0, 39, 0.5);
  color: #FFF !important;
}

.btn-outline-warning {
  border: 1px solid #FDA700 !important;
  color: #FDA700 !important;
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning.focus, .btn-outline-warning:active, .btn-outline-warning.active {
  background-color: #FDA700 !important;
  border: 1px solid #FDA700 !important;
  box-shadow: 0 3px 10px rgba(253, 167, 0, 0.5);
  color: #FFF !important;
}

.btn-outline-info {
  border: 1px solid #1ECBE2 !important;
  color: #1ECBE2 !important;
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info.focus, .btn-outline-info:active, .btn-outline-info.active {
  background-color: #1ECBE2 !important;
  border: 1px solid #1ECBE2 !important;
  box-shadow: 0 3px 10px rgba(30, 203, 226, 0.5);
  color: #FFF !important;
}

.btn-outline-light {
  border: 1px solid #FDFDFE;
  color: #323737 !important;
}
.btn-outline-light:hover, .btn-outline-light:focus, .btn-outline-light.focus, .btn-outline-light:active, .btn-outline-light.active {
  background-color: #FDFDFE;
  border: 1px solid #FDFDFE;
  color: #171724 !important;
}

.btn-outline-dark {
  border: 1px solid #171724 !important;
  color: #171724 !important;
}
.btn-outline-dark:hover, .btn-outline-dark:focus, .btn-outline-dark.focus, .btn-outline-dark:active, .btn-outline-dark.active {
  background-color: #171724 !important;
  border: 1px solid #171724 !important;
  box-shadow: 0 3px 10px rgba(23, 23, 36, 0.5);
  color: #FFF !important;
}

.btn-soft-primary {
  background-color: #F7BCB5 !important;
  color: #E41F07 !important;
}
.btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary.focus, .btn-soft-primary:active, .btn-soft-primary.active {
  box-shadow: 0 3px 12px rgba(228, 31, 7, 0.2);
  border-color: #E41F07;
}

.btn-soft-secondary {
  background-color: #FFE3B3 !important;
  color: #FFA201 !important;
}
.btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary.focus, .btn-soft-secondary:active, .btn-soft-secondary.active {
  box-shadow: 0 3px 12px rgba(255, 162, 1, 0.2);
  border-color: #FFA201;
}

.btn-soft-success {
  background-color: #CEEACE !important;
  color: #5CB85C !important;
}
.btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success.focus, .btn-soft-success:active, .btn-soft-success.active {
  box-shadow: 0 3px 12px rgba(92, 184, 92, 0.2);
  border-color: #5CB85C;
}

.btn-soft-danger {
  background-color: #FEB3BE !important;
  color: #FC0027 !important;
}
.btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger.focus, .btn-soft-danger:active, .btn-soft-danger.active {
  box-shadow: 0 3px 12px rgba(252, 0, 39, 0.2);
  border-color: #FC0027;
}

.btn-soft-warning {
  background-color: #FEE5B3 !important;
  color: #FDA700 !important;
}
.btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning.focus, .btn-soft-warning:active, .btn-soft-warning.active {
  box-shadow: 0 3px 12px rgba(253, 167, 0, 0.2);
  border-color: #FDA700;
}

.btn-soft-info {
  background-color: rgba(30, 203, 226, 0.3) !important;
  color: #1ECBE2 !important;
}
.btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info.focus, .btn-soft-info:active, .btn-soft-info.active {
  box-shadow: 0 3px 12px rgba(30, 203, 226, 0.2);
  border-color: #1ECBE2;
}

.btn-soft-light {
  background-color: rgba(253, 253, 254, 0.9) !important;
  color: #6F6F6F !important;
}
.btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light.focus, .btn-soft-light:active, .btn-soft-light.active {
  box-shadow: 0 3px 12px rgba(253, 253, 254, 0.2);
  border-color: #FDFDFE;
  border-color: #6F6F6F;
}

.btn-soft-dark {
  background-color: rgba(23, 23, 36, 0.3) !important;
  color: #FFF !important;
}
.btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark.focus, .btn-soft-dark:active, .btn-soft-dark.active {
  box-shadow: 0 3px 12px rgba(23, 23, 36, 0.2);
  border-color: #171724;
}

.custom-btn-close.btn-close {
  background-image: none;
  transition: 0.5s all;
}
.custom-btn-close.btn-close:hover {
  background: #FC0027;
  color: #FFF;
  border-color: #FC0027 !important;
  transition: 0.5s all;
  transform: rotateZ(360deg);
}

.modal .custom-btn-close.btn-close {
  background-image: none;
  transition: 0.5s all;
  width: auto !important;
  height: auto !important;
}
.modal .custom-btn-close.btn-close:hover {
  background: #FC0027 !important;
  color: #FFF !important;
  border-color: #FC0027 !important;
  transition: 0.5s all;
  transform: rotateZ(360deg);
}

.btn-purple-light {
  background-color: #F3EDFF;
  border-color: #F3EDFF;
  color: #4A00E5;
  font-size: 14px;
  font-weight: 500;
  border-radius: 5px;
  padding: 9px 20px;
  transition: all 0.2s ease;
  align-items: center;
  display: inline-flex;
}
@media (max-width: 991.98px) {
  .btn-purple-light {
    padding: 9px 14px;
  }
}

.btn-primary {
  background: #00918E;
  border: 1px solid #00918E;
  transition: all 0.2s ease;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.btn-primary:hover, .btn-primary:active {
  background: #c11a06;
  border-color: #c11a06;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-primary {
    min-width: auto;
  }
}

.badge.badge-primary {
  background: rgba(228, 31, 7, 0.1);
  box-shadow: 0 1px 1px rgba(228, 31, 7, 0.5);
  color: #E41F07;
}

.badge.badge-primary {
  background: #E41F07;
  box-shadow: 0 1px 1px rgba(228, 31, 7, 0.5);
  color: #FFF;
}
.badge.badge-soft-primary {
  background: rgba(228, 31, 7, 0.1);
  box-shadow: 0 1px 1px rgba(228, 31, 7, 0.5);
  color: #E41F07;
}

.badge.badge-secondary {
  background: #FFA201;
  box-shadow: 0 1px 1px rgba(255, 162, 1, 0.5);
  color: #FFF;
}
.badge.badge-soft-secondary {
  background: rgba(255, 162, 1, 0.1);
  box-shadow: 0 1px 1px rgba(255, 162, 1, 0.5);
  color: #FFA201;
}

.badge.badge-success {
  background: #5CB85C;
  box-shadow: 0 1px 1px rgba(92, 184, 92, 0.5);
  color: #FFF;
}
.badge.badge-soft-success {
  background: rgba(92, 184, 92, 0.1);
  box-shadow: 0 1px 1px rgba(92, 184, 92, 0.5);
  color: #5CB85C;
}

.badge.badge-info {
  background: #1ECBE2;
  box-shadow: 0 1px 1px rgba(30, 203, 226, 0.5);
  color: #FFF;
}
.badge.badge-soft-info {
  background: rgba(30, 203, 226, 0.1);
  box-shadow: 0 1px 1px rgba(30, 203, 226, 0.5);
  color: #1ECBE2;
}

.badge.badge-warning {
  background: #FDA700;
  box-shadow: 0 1px 1px rgba(253, 167, 0, 0.5);
  color: #FFF;
}
.badge.badge-soft-warning {
  background: rgba(253, 167, 0, 0.1);
  box-shadow: 0 1px 1px rgba(253, 167, 0, 0.5);
  color: #FDA700;
}

.badge.badge-danger {
  background: #FC0027;
  box-shadow: 0 1px 1px rgba(252, 0, 39, 0.5);
  color: #FFF;
}
.badge.badge-soft-danger {
  background: rgba(252, 0, 39, 0.1);
  box-shadow: 0 1px 1px rgba(252, 0, 39, 0.5);
  color: #FC0027;
}

.badge.badge-dark {
  background: #171724;
  box-shadow: 0 1px 1px rgba(23, 23, 36, 0.5);
  color: #FFF;
}
.badge.badge-soft-dark {
  background: rgba(23, 23, 36, 0.1);
  box-shadow: 0 1px 1px rgba(23, 23, 36, 0.5);
  color: #171724;
}

.badge.badge-light {
  background: #FDFDFE;
  box-shadow: 0 1px 1px rgba(253, 253, 254, 0.5);
  color: #FFF;
}
.badge.badge-soft-light {
  background: rgba(253, 253, 254, 0.1);
  box-shadow: 0 1px 1px rgba(253, 253, 254, 0.5);
  color: #FDFDFE;
}

.badge.badge-black {
  background: #000;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  color: #FFF;
}
.badge.badge-soft-black {
  background: rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  color: #000;
}

.badge.badge-purple {
  background: #4A00E5;
  box-shadow: 0 1px 1px rgba(74, 0, 229, 0.5);
  color: #FFF;
}
.badge.badge-soft-purple {
  background: rgba(74, 0, 229, 0.1);
  box-shadow: 0 1px 1px rgba(74, 0, 229, 0.5);
  color: #4A00E5;
}

.badge.badge-yellow {
  background: #ffff00;
  box-shadow: 0 1px 1px rgba(255, 255, 0, 0.5);
  color: #FFF;
}
.badge.badge-soft-yellow {
  background: rgba(255, 255, 0, 0.1);
  box-shadow: 0 1px 1px rgba(255, 255, 0, 0.5);
  color: #ffff00;
}

.badge.badge-teal {
  background: #02a8b5;
  box-shadow: 0 1px 1px rgba(2, 168, 181, 0.5);
  color: #FFF;
}
.badge.badge-soft-teal {
  background: rgba(2, 168, 181, 0.1);
  box-shadow: 0 1px 1px rgba(2, 168, 181, 0.5);
  color: #02a8b5;
}

.badge {
  padding: 0.25rem 0.45rem;
  text-transform: capitalize;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 4px;
  color: #262A2A;
}
.badge.badge-xs {
  font-size: 10px;
  padding: 0px 5px;
  line-height: 18px;
}
.badge.badge-sm {
  font-size: 11px;
  padding: 5px 8px;
  line-height: 11px;
}
.badge.badge-md {
  font-size: 12px;
  padding: 5px 12px;
  line-height: 1.5;
}
.badge.badge-lg {
  font-size: 14px;
  padding: 0px 10px;
  line-height: 30px;
}
.badge.badge-xl {
  font-size: 16px;
  padding: 0px 15px;
  line-height: 35px;
}

.badge-soft-purple {
  background: #F3EDFF;
  color: #4A00E5;
}

.bg-light-danger {
  background-color: #FFEEEC !important;
}
.bg-light-danger .badge-dots {
  background-color: #FC1A3D;
}

.bg-light-success {
  background-color: #EFF8EF !important;
}
.bg-light-success .badge-dots {
  background-color: #6CBF6C;
}

.bg-light-info {
  background-color: #E9FAFC !important;
}
.bg-light-info .badge-dots {
  background-color: #35D0E5;
}

.bg-light-warning {
  background-color: #FFF7D8 !important;
}
.bg-light-warning .badge-dots {
  background-color: #FDB01A;
}

.badge-danger-light {
  background-color: #FFEEEC !important;
  color: #FC1A3D;
}

.badge-pending {
  background: #676DFF !important;
  color: #FFF !important;
}

.badge-tertiary {
  background: #3C2371;
  color: #FFF;
}

.badge-status {
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 8px;
  min-width: 64px;
  color: #FFF;
}

.badge-tag {
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 4px;
  font-weight: 400;
}
.badge-tag.badge-success-light {
  background: #E0F5D7;
  color: #5CB85C;
}
.badge-tag.badge-warning-light {
  background: #FFF7D8;
  color: #FDA700;
}
.badge-tag.badge-purple-light {
  background: #F3EDFF;
  color: #4A00E5;
}
.badge-tag.badge-danger-light {
  background: #FFEEEC;
  color: #FC0027;
}

.border-container {
  display: inline-block;
  width: 5rem;
  height: 5rem;
  margin: 0.25rem;
  background-color: #FDFDFE;
}

.border {
  border: 1px solid #E8E8E8 !important;
}
.border.border-dashed {
  border-style: dashed !important;
}
.border.border-dotted {
  border-style: dotted !important;
}
.border.border-primary {
  border: 1px solid #E41F07 !important;
  opacity: 1;
}
.border.border-primary.border-opacity-10 {
  border-color: rgba(228, 31, 7, 0.1) !important;
}
.border.border-primary.border-opacity-25 {
  border-color: rgba(228, 31, 7, 0.25) !important;
}
.border.border-primary.border-opacity-50 {
  border-color: rgba(228, 31, 7, 0.5) !important;
}
.border.border-primary.border-opacity-75 {
  border-color: rgba(228, 31, 7, 0.75) !important;
}
.border.border-primary.border-opacity-100 {
  border-color: #e41f07 !important;
}
.border.border-secondary {
  border: 1px solid #FFA201 !important;
  opacity: 1;
}
.border.border-secondary.border-opacity-10 {
  border-color: rgba(255, 162, 1, 0.1) !important;
}
.border.border-secondary.border-opacity-25 {
  border-color: rgba(255, 162, 1, 0.25) !important;
}
.border.border-secondary.border-opacity-50 {
  border-color: rgba(255, 162, 1, 0.5) !important;
}
.border.border-secondary.border-opacity-75 {
  border-color: rgba(255, 162, 1, 0.75) !important;
}
.border.border-secondary.border-opacity-100 {
  border-color: #ffa201 !important;
}
.border.border-info {
  border: 1px solid #1ECBE2 !important;
  opacity: 1;
}
.border.border-info.border-opacity-10 {
  border-color: rgba(30, 203, 226, 0.1) !important;
}
.border.border-info.border-opacity-25 {
  border-color: rgba(30, 203, 226, 0.25) !important;
}
.border.border-info.border-opacity-50 {
  border-color: rgba(30, 203, 226, 0.5) !important;
}
.border.border-info.border-opacity-75 {
  border-color: rgba(30, 203, 226, 0.75) !important;
}
.border.border-info.border-opacity-100 {
  border-color: #1ecbe2 !important;
}
.border.border-success {
  border: 1px solid #5CB85C !important;
  opacity: 1;
}
.border.border-success.border-opacity-10 {
  border-color: rgba(92, 184, 92, 0.1) !important;
}
.border.border-success.border-opacity-25 {
  border-color: rgba(92, 184, 92, 0.25) !important;
}
.border.border-success.border-opacity-50 {
  border-color: rgba(92, 184, 92, 0.5) !important;
}
.border.border-success.border-opacity-75 {
  border-color: rgba(92, 184, 92, 0.75) !important;
}
.border.border-success.border-opacity-100 {
  border-color: #5cb85c !important;
}
.border.border-warning {
  border: 1px solid #FDA700 !important;
  opacity: 1;
}
.border.border-warning.border-opacity-10 {
  border-color: rgba(253, 167, 0, 0.1) !important;
}
.border.border-warning.border-opacity-25 {
  border-color: rgba(253, 167, 0, 0.25) !important;
}
.border.border-warning.border-opacity-50 {
  border-color: rgba(253, 167, 0, 0.5) !important;
}
.border.border-warning.border-opacity-75 {
  border-color: rgba(253, 167, 0, 0.75) !important;
}
.border.border-warning.border-opacity-100 {
  border-color: #fda700 !important;
}
.border.border-danger {
  border: 1px solid #FC0027 !important;
  opacity: 1;
}
.border.border-danger.border-opacity-10 {
  border-color: rgba(252, 0, 39, 0.1) !important;
}
.border.border-danger.border-opacity-25 {
  border-color: rgba(252, 0, 39, 0.25) !important;
}
.border.border-danger.border-opacity-50 {
  border-color: rgba(252, 0, 39, 0.5) !important;
}
.border.border-danger.border-opacity-75 {
  border-color: rgba(252, 0, 39, 0.75) !important;
}
.border.border-danger.border-opacity-100 {
  border-color: #fc0027 !important;
}
.border.border-white {
  border: 1px solid #FFF !important;
  opacity: 1;
}
.border.border-white.border-opacity-10 {
  border-color: rgba(255, 255, 255, 0.1) !important;
}
.border.border-white.border-opacity-25 {
  border-color: rgba(255, 255, 255, 0.25) !important;
}
.border.border-white.border-opacity-50 {
  border-color: rgba(255, 255, 255, 0.5) !important;
}
.border.border-white.border-opacity-75 {
  border-color: rgba(255, 255, 255, 0.75) !important;
}
.border.border-white.border-opacity-100 {
  border-color: white !important;
}
.border.border-light {
  border: 1px solid #FDFDFE !important;
  opacity: 1;
}
.border.border-light.border-opacity-10 {
  border-color: rgba(253, 253, 254, 0.1) !important;
}
.border.border-light.border-opacity-25 {
  border-color: rgba(253, 253, 254, 0.25) !important;
}
.border.border-light.border-opacity-50 {
  border-color: rgba(253, 253, 254, 0.5) !important;
}
.border.border-light.border-opacity-75 {
  border-color: rgba(253, 253, 254, 0.75) !important;
}
.border.border-light.border-opacity-100 {
  border-color: #fdfdfe !important;
}
.border.border-dark {
  border: 1px solid #171724 !important;
  opacity: 1;
}
.border.border-dark.border-opacity-10 {
  border-color: rgba(23, 23, 36, 0.1) !important;
}
.border.border-dark.border-opacity-25 {
  border-color: rgba(23, 23, 36, 0.25) !important;
}
.border.border-dark.border-opacity-50 {
  border-color: rgba(23, 23, 36, 0.5) !important;
}
.border.border-dark.border-opacity-75 {
  border-color: rgba(23, 23, 36, 0.75) !important;
}
.border.border-dark.border-opacity-100 {
  border-color: #171724 !important;
}
.border.border-orange {
  border: 1px solid #FF9D0A !important;
  opacity: 1;
}
.border.border-orange.border-opacity-10 {
  border-color: rgba(255, 157, 10, 0.1) !important;
}
.border.border-orange.border-opacity-25 {
  border-color: rgba(255, 157, 10, 0.25) !important;
}
.border.border-orange.border-opacity-50 {
  border-color: rgba(255, 157, 10, 0.5) !important;
}
.border.border-orange.border-opacity-75 {
  border-color: rgba(255, 157, 10, 0.75) !important;
}
.border.border-orange.border-opacity-100 {
  border-color: #ff9d0a !important;
}
.border.border-opacity-10 {
  --bs-border-opacity: 0.1 !important;
}
.border.border-opacity-25 {
  --bs-border-opacity: 0.25 !important;
}
.border.border-opacity-50 {
  --bs-border-opacity: 0.5 !important;
}
.border.border-opacity-75 {
  --bs-border-opacity: 0.75 !important;
}
.border.border-opacity-100 {
  --bs-border-opacity: 1 !important;
}
.border.border-1 {
  border-width: 1px !important;
}
.border.border-2 {
  border-width: 2px !important;
}
.border.border-3 {
  border-width: 3px !important;
}
.border.border-4 {
  border-width: 4px !important;
}
.border.border-5 {
  border-width: 5px !important;
}
.border.border-block-start-dashed {
  border-top-style: dashed;
}
.border.border-block-start-dotted {
  border-top-style: dotted;
}
.border.border-inline-end-dashed {
  border-inline-end-style: dashed;
}
.border.border-inline-end-dotted {
  border-inline-end-style: dotted;
}
.border.border-block-end-dashed {
  border-bottom-style: dashed;
}
.border.border-block-end-dotted {
  border-bottom-style: dotted;
}
.border.border-inline-start-dashed {
  border-inline-start-style: dashed;
}
.border.border-inline-start-dotted {
  border-inline-start-style: dotted;
}
.border.border-0 {
  border: 0 !important;
}
.border.border-top-0 {
  border-block-start: 0 !important;
}
.border.border-end-0 {
  border-inline-end: 0 !important;
}
.border.border-bottom-0 {
  border-block-end: 0 !important;
}
.border.border-start-0 {
  border-inline-start: 0 !important;
}

.border-top {
  border-top: 1px solid #E8E8E8 !important;
}
.border-top.border-block-start-dashed {
  border-top-style: dashed !important;
}
.border-top.border-block-start-dotted {
  border-top-style: dotted !important;
}
.border-top.border-primary {
  border-color: #E41F07 !important;
}
.border-top.border-secondary {
  border-color: #FFA201 !important;
}
.border-top.border-warning {
  border-color: #FDA700 !important;
}
.border-top.border-info {
  border-color: #1ECBE2 !important;
}
.border-top.border-success {
  border-color: #5CB85C !important;
}
.border-top.border-danger {
  border-color: #FC0027 !important;
}
.border-top.border-light {
  border-color: #FDFDFE !important;
}
.border-top.border-dark {
  border-color: #171724 !important;
}

.border-end {
  border-inline-end: 1px solid #E8E8E8 !important;
}
.border-end.border-inline-end-dashed {
  border-inline-end-style: dashed !important;
}
.border-end.border-inline-end-dotted {
  border-inline-end-style: dotted !important;
}
.border-end.border-primary {
  border-color: #E41F07 !important;
}
.border-end.border-secondary {
  border-color: #FFA201 !important;
}
.border-end.border-warning {
  border-color: #FDA700 !important;
}
.border-end.border-info {
  border-color: #1ECBE2 !important;
}
.border-end.border-success {
  border-color: #5CB85C !important;
}
.border-end.border-danger {
  border-color: #FC0027 !important;
}
.border-end.border-light {
  border-color: #FDFDFE !important;
}
.border-end.border-dark {
  border-color: #171724 !important;
}

.border-bottom {
  border-bottom: 1px solid #E8E8E8 !important;
}
.border-bottom.border-block-end-dashed {
  border-bottom-style: dashed !important;
}
.border-bottom.border-block-end-dotted {
  border-bottom-style: dotted !important;
}
.border-bottom.border-primary {
  border-color: #E41F07 !important;
}
.border-bottom.border-secondary {
  border-color: #FFA201 !important;
}
.border-bottom.border-warning {
  border-color: #FDA700 !important;
}
.border-bottom.border-info {
  border-color: #1ECBE2 !important;
}
.border-bottom.border-success {
  border-color: #5CB85C !important;
}
.border-bottom.border-danger {
  border-color: #FC0027 !important;
}
.border-bottom.border-light {
  border-color: #FDFDFE !important;
}
.border-bottom.border-dark {
  border-color: #171724 !important;
}

.border-start {
  border-inline-start: 1px solid #E8E8E8 !important;
}
.border-start.border-inline-start-dashed {
  border-inline-start-style: dashed !important;
}
.border-start.border-inline-start-dotted {
  border-inline-start-style: dotted !important;
}
.border-start.border-primary {
  border-color: #E41F07 !important;
}
.border-start.border-secondary {
  border-color: #FFA201 !important;
}
.border-start.border-warning {
  border-color: #FDA700 !important;
}
.border-start.border-info {
  border-color: #1ECBE2 !important;
}
.border-start.border-success {
  border-color: #5CB85C !important;
}
.border-start.border-danger {
  border-color: #FC0027 !important;
}
.border-start.border-light {
  border-color: #FDFDFE !important;
}
.border-start.border-dark {
  border-color: #171724 !important;
}

.br-1 {
  border-radius: 0.0625rem;
}

.br-2 {
  border-radius: 0.125rem;
}

.br-3 {
  border-radius: 0.1875rem;
}

.br-4 {
  border-radius: 0.25rem;
}

.br-5 {
  border-radius: 0.3125rem;
}

.br-6 {
  border-radius: 0.375rem;
}

.br-7 {
  border-radius: 0.4375rem;
}

.br-8 {
  border-radius: 0.5rem;
}

.br-9 {
  border-radius: 0.5625rem;
}

.br-10 {
  border-radius: 0.625rem;
}

.br-15 {
  border-radius: 0.9375rem;
}

.br-20 {
  border-radius: 1.25rem;
}

.rounded {
  border-radius: 4px !important;
}

.calendar-events {
  border: 1px solid transparent;
  cursor: move;
  padding: 10px 15px;
}

.calendar-events:hover {
  border-color: #898989;
  background-color: #FFF;
}

.calendar-events i {
  margin-right: 8px;
}

.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5rem;
}

.none-border .modal-footer {
  border-top: none;
}

.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 600;
  font-family: "Roboto", sans-serif;
  line-height: 30px;
  text-transform: uppercase;
}

.fc-day-grid-event .fc-time {
  font-family: "Roboto", sans-serif;
}

.fc-day {
  background: #FFF;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
  z-index: 0;
}

.fc th.fc-widget-header {
  background: #F6F6F6;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #f3f3f3;
}

.fc-basic-view .fc-day-number,
.fc-basic-view .fc-week-number {
  padding: 2px 5px;
}

.fc-button {
  background: #f1f1f1;
  border: none;
  color: #797979;
  text-transform: capitalize;
  box-shadow: none !important;
  border-radius: 3px !important;
  margin: 0 3px !important;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 16px;
}

.fc-state-hover {
  background: #f3f3f3;
}

.fc-state-highlight {
  background: #f0f0f0;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #E41F07 !important;
  color: #FFF !important;
  text-shadow: none !important;
}

.fc-cell-overlay {
  background: #f0f0f0;
}

.fc-unthemed .fc-today {
  background: #FFF;
}

.fc-event {
  border-radius: 2px;
  border: none;
  color: #FFF !important;
  cursor: move;
  font-size: 13px;
  margin: 1px 7px;
  padding: 5px 5px;
  text-align: center;
}

.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.fc-basic-view td.fc-day-number {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.event-form .input-group .form-control {
  height: 40px;
}

.submit-section {
  text-align: center;
  margin-top: 40px;
}

.submit-btn {
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  min-width: 200px;
  padding: 10px 20px;
}

.apexcharts-legend.apexcharts-align-center.position-right {
  display: none;
}

.apexcharts-toolbar {
  display: none !important;
}

#sales_charts,
.chart-set {
  overflow: hidden;
}

.apexcharts-canvas {
  width: 100% !important;
}

.h-250 {
  height: 250px;
}

.chat-user-actives .call-meet-blk {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #FFF;
  border-radius: 5px;
  margin-bottom: 15px;
  padding: 10px;
  transition: all 0.5s ease;
}
.chat-user-actives .call-meet-blk:hover {
  background-color: #000;
  transition: all 0.5s ease;
}
.chat-user-actives .call-meet-blk .meet-border {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  width: 39px;
  height: 39px;
  background: #FFF;
  border: 0.5px solid #898989;
  border-radius: 10px;
  margin-right: 10px;
}
.chat-user-actives .call-meet-blk .meet-border svg {
  width: 16px;
  color: #339DFF;
}
.chat-user-actives .call-meet-blk .recent-user-titles h5 {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-bottom: 5px;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chat-user-actives .call-meet-blk .recent-user-titles p {
  font-size: 10px;
  color: #6F6F6F;
}

.new-join-link .chat-user-actives .meet-border {
  background: gray;
  border: 0;
  border-radius: 6px;
}
.new-join-link .chat-user-actives .meet-border:hover {
  background: #E41F07;
}
.new-join-link .chat-user-actives .meet-border:hover svg {
  color: #FFF;
}
.new-join-link .chat-user-actives .meet-border svg {
  color: #E41F07;
}
.new-join-link .chat-user-actives .recent-user-titles h5 {
  color: #E41F07;
  width: 100%;
  margin-bottom: 0;
  font-size: 15px;
}

.meet-chat-blk .join-call .join-video {
  position: relative;
  margin-bottom: 25px;
}
.meet-chat-blk .join-call .join-video img {
  border-radius: 10px;
}
.meet-chat-blk .join-call .join-video .video-avatar {
  color: #FFF;
  background: #5D5D5D;
  font-size: 50px;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.meet-chat-blk .join-call .join-video .video-avatar.active {
  display: flex;
  position: relative;
  height: 426px;
}
.meet-chat-blk .join-call .join-video .call-icons {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items {
  border-radius: 5px;
  padding: 0;
  margin: 0;
  list-style: none;
  display: inline-flex;
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translate(-50%, 0);
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item {
  display: inline-block;
  text-align: center;
  margin-right: 15px;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item:last-child {
  margin-right: 0px;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a {
  color: #FFF;
  background: #FFF;
  border-radius: 10px;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 20px;
  white-space: nowrap;
}
@media (max-width: 767.98px) {
  .meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a {
    width: 45px;
    height: 45px;
  }
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a i {
  color: #6F6F6F;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a.stop {
  color: #FFF;
  background: #FC0027;
}
.meet-chat-blk .join-call .join-video .call-icons .call-items .call-item a.stop i {
  color: #FFF;
}
.meet-chat-blk .join-call .join-video .meet-drop ul li i {
  font-size: 18px;
}
.meet-chat-blk .join-call .join-content {
  text-align: center;
  max-width: 500px;
  margin: auto;
}
.meet-chat-blk .join-call .join-content h4 {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
}
@media (max-width: 767.98px) {
  .meet-chat-blk .join-call .join-content h4 {
    font-size: 18px;
  }
}
.meet-chat-blk .join-call .join-content .event-user-group {
  margin-bottom: 10px;
}
.meet-chat-blk .join-call .join-content .event-user-group .avatar-group .avatar {
  width: 38px;
  height: 38px;
  border: 3px solid #FFF;
}
.meet-chat-blk .join-call .join-content .event-user-group .avatar-group .avatar + .avatar {
  margin-left: -20px;
}
.meet-chat-blk .join-call .join-content .event-user-group .avatar-group .avatar .avatar-title {
  color: #000;
  font-size: 14px;
  font-weight: 600;
  background: gray;
}
.meet-chat-blk .join-call .join-content p {
  font-size: 13px;
  color: #6F6F6F;
}
.meet-chat-blk .join-call .join-content .btn-join-call .btn-primary {
  background: #E41F07;
  border-radius: 6px 6px 6px 6px;
  color: #FFF;
  font-size: 14px;
  border: 1px solid #E41F07;
  font-weight: 600;
  min-width: 105px;
  padding: 8px 15px;
}
.meet-chat-blk .join-call .join-content .btn-join-call .btn-primary:hover {
  background: #FC0027;
  border: 1px solid gray;
  color: #E41F07;
}

.conference-meet-group {
  display: flex;
}
.conference-meet-group .meeting-list {
  width: 100%;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .meeting-list.add-meeting {
  width: 65%;
  margin-right: 24px;
}
@media (max-width: 767.98px) {
  .conference-meet-group .meeting-list.add-meeting {
    display: none;
    margin-right: 0px;
  }
}
.conference-meet-group .right-user-side {
  width: 0;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .right-user-side.right-side-party {
  width: 0;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .right-user-side.right-side-party .party-msg-blk .last-call-time .call-recent {
  background: none;
}
.conference-meet-group .right-user-side.right-side-party .party-msg-blk .last-call-time .call-recent svg {
  color: #E41F07;
  width: 14px;
}
.conference-meet-group .right-user-side.chat-rooms {
  width: 0;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.conference-meet-group .right-user-side.chat-rooms .slime-grp {
  padding: 0;
}
.conference-meet-group .right-user-side.chat-rooms .slime-grp .left-chat-title {
  padding: 20px;
  border-bottom: 1px solid #E1E8ED;
  border-radius: 10px 10px 0 0;
}
.conference-meet-group .right-user-side.chat-rooms.open-chats {
  width: 35%;
  opacity: 1;
}
@media (max-width: 767.98px) {
  .conference-meet-group .right-user-side.chat-rooms.open-chats {
    width: 100%;
  }
}
.conference-meet-group .right-user-side.open-message {
  width: 35%;
  opacity: 1;
}
@media (max-width: 767.98px) {
  .conference-meet-group .right-user-side.open-message {
    width: 100%;
  }
}

.meet-drop {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  position: absolute;
  top: 20px;
  right: 20px;
}
.meet-drop ul li .chats-dot a {
  width: 50px;
  height: 50px;
  color: #6B7280;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-drop ul li .chats-dot a {
    width: 38px;
    height: 38px;
  }
}
.meet-drop.meet-mutes {
  background: #E41F07;
  right: inherit;
  left: 20px;
}
.meet-drop.meet-mutes ul li a {
  color: #FFF;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-drop.meet-mutes ul li a {
    width: 38px;
    height: 38px;
  }
}
.meet-drop.meet-mutes-bottom {
  background: #E41F07;
  bottom: 20px;
  border-radius: 50px;
  top: inherit;
}
.meet-drop.meet-mutes-bottom ul li a {
  color: #FFF;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-drop.meet-mutes-bottom ul li a {
    width: 38px;
    height: 38px;
  }
}
.meet-drop.meet-mutes-bottom ul li a i {
  font-size: 20px;
}

.meet-call-menu-blk .video-call-action {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 767.98px) {
  .meet-call-menu-blk .video-call-action {
    display: block;
  }
}
.meet-call-menu-blk .video-call-action ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.meet-call-menu-blk .video-call-action ul li {
  margin-right: 5px;
}
.meet-call-menu-blk .video-call-action ul li:last-child {
  margin-right: 0;
}
.meet-call-menu-blk .video-call-action ul li a {
  width: 40px;
  height: 40px;
  border-radius: 50px;
  background: #D9D9D9;
  border: 1px solid #D9D9D9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #000;
  font-size: 18px;
}
.meet-call-menu-blk .video-call-action ul li a.call-end {
  background-color: #FC0027;
  border-color: #FC0027;
  color: #FFF;
  width: 60px;
  height: 60px;
  rotate: 135deg;
  font-size: 20px;
}
.meet-call-menu-blk .video-call-action ul li a.stop {
  color: #FFF;
  background: #FC0027;
  border-color: #FC0027;
}
.meet-call-menu-blk .video-call-action ul li a.stop i {
  color: #FFF;
}
.meet-call-menu-blk .video-call-action ul li.active a {
  background: #E41F07;
  border-color: #E41F07;
  color: #FFF;
}
.meet-call-menu-blk .video-call-action ul li.active a img {
  filter: invert(1) brightness(100);
}
@media (max-width: 767.98px) {
  .meet-call-menu-blk .video-call-action ul {
    margin-bottom: 5px;
    justify-content: center;
  }
}
@media (max-width: 767.98px) {
  .meet-call-menu-blk .video-call-action ul:last-child {
    margin-bottom: 0px;
  }
}

.recession-meet-blk {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 30px;
}
@media (max-width: 767.98px) {
  .recession-meet-blk {
    display: block;
  }
}
@media (max-width: 767.98px) {
  .recession-meet-blk .reccession-head {
    margin-bottom: 5px;
  }
}
.recession-meet-blk .reccession-head h5 {
  font-size: 20px;
  font-weight: 700;
  color: #262A2A;
  margin-bottom: 0px;
}
@media (max-width: 767.98px) {
  .recession-meet-blk .reccession-head h5 {
    font-size: 18px;
  }
}
.recession-meet-blk .reccession-head ul li {
  font-size: 15px;
  font-weight: 400;
  color: #6F6F6F;
  margin-right: 25px;
}
.recession-meet-blk .reccession-head ul li:last-child {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .recession-meet-blk .reccession-head ul li {
    margin-bottom: 10px;
  }
}
.recession-meet-blk .partispant-blk {
  display: flex;
}
.recession-meet-blk .partispant-blk .btn-primary {
  background: #1b2950;
  border-radius: 6px;
  color: #FFF;
  border: 1px solid #1b2950;
  margin-right: 10px;
  font-weight: 700;
  font-size: 14px;
}
.recession-meet-blk .partispant-blk .btn-primary:hover {
  background: #E41F07;
  border: 1px solid #E41F07;
}
@media (max-width: 767.98px) {
  .recession-meet-blk .partispant-blk .btn-primary {
    font-size: 13px;
  }
}
.recession-meet-blk .partispant-blk .btn-primary {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.recession-meet-blk .partispant-blk .btn-primary:last-child {
  margin-right: 0;
}
.recession-meet-blk .partispant-blk span a {
  width: 42px;
  height: 42px;
  background: #E8E8E8;
  border-radius: 5px;
  color: #6F6F6F;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.recession-meet-blk .partispant-blk span a:hover {
  background: #E41F07;
  color: #FFF;
}

.recording-time {
  position: relative;
  padding-left: 20px;
}
.recording-time::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 4px;
  background-color: #FC0027;
  width: 13px;
  height: 13px;
  border-radius: 50px;
}
.recording-time::after {
  content: "";
  position: absolute;
  left: 3px;
  top: 7px;
  background-color: #FFF;
  width: 7px;
  height: 7px;
  border-radius: 50px;
  animation: blink-animation 1.5s steps(5, start) infinite;
  -webkit-animation: blink-animation 1.5s steps(5, start) infinite;
}

.page-content {
  width: 100%;
}

.join-call {
  width: 100%;
  margin: 0 auto;
}

.join-video {
  position: relative;
  margin-bottom: 25px;
}
.join-video img {
  border-radius: 10px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.join-video.join-video-front img {
  height: 423px;
}

.video-avatar {
  color: #FFF;
  background: #5D5D5D;
  font-size: 50px;
  border-radius: 10px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  align-items: center;
  justify-content: center;
}
.video-avatar h4 {
  font-weight: 700;
  font-size: 24px;
  color: #FFF;
}

.video-avatar.active {
  display: flex;
}

.join-video.video-hide > img,
.video-wrap.video-hide > video {
  display: none;
}

.join-content p {
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 25px;
  color: #000;
}
.join-content label {
  font-size: 18px;
  margin-bottom: 0;
  color: #000;
  font-weight: 700;
}

.part-name {
  position: absolute;
  top: 20px;
  left: 12px;
  text-align: left;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50px;
  padding: 5px 15px;
}
.part-name h4 {
  font-weight: 500;
  font-size: 15px;
  color: #6F6F6F;
  margin-bottom: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media (max-width: 767.98px) {
  .part-name h4 {
    font-size: 13px;
  }
}
.part-name.sub-part-name {
  background: #FFF;
  bottom: 10px;
  top: inherit;
}
.part-name.sub-part-name h4 {
  color: #262A2A;
  font-size: 12px;
}

.grid-join .part-name {
  background: rgba(0, 0, 0, 0.3);
  top: inherit;
  bottom: 20px;
}
.grid-join .part-name h4 {
  color: #FFF;
}

.join-hover-img {
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.join-hover-img .event-user-group .avatar-group {
  background: rgba(0, 0, 0, 0.3);
  padding: 2px 10px;
  border-radius: 50px;
}
.join-hover-img .event-user-group .avatar-group .avatar {
  width: 26px;
  height: 26px;
  border: 1px solid #FFF;
}
.join-hover-img .event-user-group .avatar-group .avatar + .avatar {
  margin-left: -16px;
}
.join-hover-img .event-user-group .avatar-group .avatar:last-child {
  margin-right: 0px;
}
.join-hover-img .event-user-group .avatar-group .avatar .avatar-title {
  color: #1F2937;
  font-size: 12px;
  font-weight: 600;
  background: #F3F4F6;
}

.more-icon {
  position: absolute;
  bottom: 10px;
  right: 12px;
}
@media (max-width: 767.98px) {
  .more-icon {
    bottom: 8px;
    right: 13px;
  }
}
.more-icon a {
  color: #6F6F6F;
  width: 30px;
  height: 30px;
  background: #FFF;
  border-radius: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.more-icon a:hover {
  opacity: 0.8;
}
.more-icon a.other-mic-off.stop i {
  color: #FC0027;
}
.more-icon.audio-more-icon a.other-mic-off.stop {
  background-color: #FC0027 !important;
}
.more-icon.audio-more-icon a.other-mic-off.stop i {
  color: #FFF;
}

.call-recent.recent-part a.other-mic-off.stop, .call-recent.recent-part a.other-video-off.stop {
  background: #FC0027 !important;
}
.call-recent.recent-part a.other-mic-off.stop i, .call-recent.recent-part a.other-video-off.stop i {
  color: #FFF;
}

.meeting .part-name {
  top: 15px;
  left: 15px;
}
.meeting .more-icon {
  top: 15px;
  right: 15px;
  display: flex;
}

.vertical-view .vertical-sec .part-name h4 {
  font-size: 14px;
  font-weight: 400;
}

.horizontal-view .join-video.single-user .part-name h4 {
  font-size: 14px;
  font-weight: 400;
}

.meeting-wrapper, .meeting {
  width: inherit;
  max-width: inherit;
}

.meet-footer {
  position: fixed;
  bottom: 25px;
  width: 100%;
  max-width: 950px;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 3;
}

.show-chat-list, .show-invite-list,
.show-chat-list .user-sidebar-right,
.show-invite-list .invite-sidebar-right {
  transition: all 0.8s ease;
}

.user-sidebar-right, .invite-sidebar-right {
  background: #dedede;
  border-radius: 10px;
  width: 410px;
  position: absolute;
  top: 105px;
  bottom: 117px;
  right: 0;
  margin-right: -410px;
  transition: all 0.8s ease;
  overflow: hidden;
  font-size: 13px;
  z-index: 3;
}

.join-contents {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}
.join-contents.grid-view {
  align-content: center;
}

.ripple {
  width: 114px;
  height: 114px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.multigrid-view .text-box {
  height: 61px;
  width: 61px;
}

.multigrid-view .ripple {
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.meeting .join-video {
  margin: 0 5px 10px;
  width: 100%;
}

.join-video.user-active {
  background: #415B6A;
  border-radius: 10px;
  width: 100%;
  height: 370px;
}
.join-video.user-active.audio-calls {
  height: 520px;
}
.join-video.vertical-active {
  margin-right: 24px;
}
.join-video.single-user {
  width: 100%;
  min-height: 230px;
  box-sizing: border-box;
  margin-right: 24px;
  justify-content: space-between;
  text-align: center;
  height: auto;
  background: #415B6A;
  border-radius: 10px;
  padding: 0;
  flex-grow: 1;
}
@media (max-width: 1280px) {
  .join-video.single-user {
    width: 100%;
  }
}
@media (max-width: 1199.98px) {
  .join-video.single-user {
    min-height: 203px;
  }
}
@media (max-width: 991.98px) {
  .join-video.single-user {
    min-height: 230px;
  }
}
.join-video.single-user:nth-child(even) {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .join-video.single-user:nth-child(even) {
    margin-right: 10px;
  }
}
@media (max-width: 767.98px) {
  .join-video.single-user {
    width: 100%;
    min-height: 257px;
  }
}

@media (max-width: 767.98px) {
  .multi-grid .join-video.single-user {
    width: 45%;
  }
}
.multi-grid .join-video.single-user:nth-child(even) {
  margin-right: 24px;
}
@media (max-width: 767.98px) {
  .multi-grid .join-video.single-user:nth-child(even) {
    margin-right: 0px;
  }
}
.multi-grid .join-video.single-user:nth-child(4n) {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .multi-grid .join-video.single-user:nth-child(4n):nth-child(4n) {
    margin-right: 0px;
  }
}

.multigrid-view .join-video.single-user {
  flex-grow: 0;
}

.horizontal-view .join-video.single-user:nth-child(even) {
  margin-right: 24px;
}
.horizontal-view .join-video.single-user:nth-child(5) {
  margin-right: 0px;
}
@media (max-width: 767.98px) {
  .horizontal-view .join-video.single-user:nth-child(3n) {
    margin-right: 0;
  }
}

.text-avatar {
  color: #FFF;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.text-avatar h4 {
  color: #FFF;
}

.text-box {
  height: 86px;
  width: 86px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
  font-size: 36px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.more-icon.mic-view .mic-on, .more-icon .mic-off {
  display: none;
}

.more-icon.mic-view .mic-off {
  display: inline-flex;
}

.grid-view .join-video.single-user {
  width: 47%;
}
@media (max-width: 767.98px) {
  .grid-view .join-video.single-user {
    width: 40%;
  }
}
@media (max-width: 767.98px) {
  .grid-view .join-video.single-user:nth-child(2n) {
    margin-right: 0px;
  }
}
@media (max-width: 767.98px) {
  .grid-view .join-video.single-user:nth-child(3n) {
    margin-right: 24px;
  }
}

.join-contents.multigrid-view {
  max-width: 100%;
  justify-content: center;
}

.meeting {
  position: absolute;
  top: 80px;
  bottom: 107px;
  left: 0;
  right: 0;
}

.meeting-list {
  flex-direction: column;
  height: 100%;
  width: 100%;
  position: relative;
}

.user-active .more-icon .handraise-on {
  display: none;
}
.user-active .more-icon .handraise-on.active {
  display: block;
  animation: mymove 5s;
}

.user-active .more-icon .handraise-on.active .meeting .join-video.user-active::before {
  animation: mymove 5s infinite;
  opacity: 1;
}

@keyframes mymove {
  from {
    color: #0074E0;
  }
  to {
    color: transparent;
  }
}
.join-contents.vertical-view {
  display: flex;
  align-items: center;
  align-content: center;
  max-width: 1300px;
}
@media (max-width: 767.98px) {
  .join-contents.vertical-view {
    display: block;
  }
}
.join-contents.vertical-view .join-video.user-active {
  flex: 1 1;
  margin-bottom: 24px;
}
.join-contents.vertical-view .join-video.single-user {
  width: 97%;
  flex-grow: 1;
  display: flex;
}
@media (max-width: 767.98px) {
  .join-contents.vertical-view .join-video.single-user {
    width: 100%;
  }
}
.join-contents.vertical-view .vertical-sec {
  width: 20%;
}
@media (max-width: 991.98px) {
  .join-contents.vertical-view .vertical-sec {
    width: 30%;
  }
}
@media (max-width: 767.98px) {
  .join-contents.vertical-view .vertical-sec {
    width: 100%;
  }
}
.join-contents.vertical {
  flex-direction: column;
  height: 200px;
}

.meeting .join-contents.vertical .join-video.user-active {
  flex: 1 0 100%;
}

.meeting .join-contents.vertical .join-video.single-user {
  flex: 0 1;
}

.meeting .join-contents.vertical .join-video {
  width: auto;
}

.chat-footer .btn:hover {
  background: #0066c5;
  color: #FFF;
}

.join-contents.show-whiteboard {
  display: none;
}
.join-contents.single-view {
  padding-top: 0;
  margin-top: 25px;
  position: relative;
}
.join-contents.single-view .single-user {
  position: absolute;
  right: 8px;
  top: 40px;
  width: 130px;
  height: 130px;
  min-height: 130px;
}
.join-contents.single-view .single-user img {
  height: 130px;
}

.record-time {
  position: absolute;
  top: 20px;
  z-index: 1;
  position: absolute;
  left: 20px;
}
.record-time span {
  background-color: rgba(255, 255, 255, 0.2);
  display: inline-block;
  border-radius: 130px;
  color: #FFF;
  font-size: 14px;
  font-weight: 600;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 34px;
  position: relative;
  padding-left: 15px;
}
.record-time span:before {
  content: "";
  position: absolute;
  left: 7px;
  top: 7px;
  background-color: #FFF;
  width: 18px;
  height: 18px;
  border-radius: 50px;
}
.record-time span:after {
  content: "";
  position: absolute;
  left: 12px;
  top: 12px;
  background-color: #FC0027;
  width: 8px;
  height: 8px;
  border-radius: 50px;
  animation: blink-animation 1.5s steps(5, start) infinite;
  -webkit-animation: blink-animation 1.5s steps(5, start) infinite;
}

@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
.volume-col {
  position: absolute;
  left: 20px;
  bottom: 20px;
}

.volume-col .inner-volume-col {
  background-color: #898989;
  border-radius: 130px;
  width: 30px;
  height: 120px;
  position: relative;
  z-index: 9;
}

.volume-col #volume {
  position: absolute;
  left: 50%;
  top: 15px;
  margin: 0 auto;
  height: 80px;
  width: 5px;
  background: #FFF;
  border-radius: 15px;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.volume-col #volume .ui-slider-range-min {
  height: 5px;
  width: 100%;
  position: absolute;
  bottom: 0;
  background: #E41F07;
  border: none;
  border-radius: 10px;
  outline: none;
}

.volume-col #volume .ui-slider-handle {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background: #E41F07;
  position: absolute;
  left: 50%;
  margin-top: -8px;
  cursor: pointer;
  outline: none;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
}

.volume-col #player {
  width: auto;
  height: 104px;
  position: relative;
  margin: 0 auto;
  top: 0px;
}

.volume-col #player i {
  position: absolute;
  margin-top: -6px;
  color: #666;
}

.volume-col .volume-icons {
  color: #FFF;
  margin-left: 0px;
  font-size: 18px;
  margin-top: 22px;
}

.chat-msg-blk {
  padding: 15px;
}
.chat-msg-blk .chats {
  max-width: 100%;
  margin-bottom: 1.5rem;
  display: flex;
  display: -webkit-flex;
}
@media (max-width: 767.98px) {
  .chat-msg-blk .chats {
    max-width: 100%;
  }
}
.chat-msg-blk .chats .chat-action-btns .chat-user-time .chats-dot a {
  color: #00918E;
}
.chat-msg-blk .chats.chats-right {
  margin-left: auto;
  flex-direction: row-reverse;
}
.chat-msg-blk .chats.chats-right .chat-content {
  order: 1;
  -webkit-order: 1;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content {
  background-color: #E8E8E8;
  border-radius: 8px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .chat-time {
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col {
  position: relative;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li {
  margin-right: 8px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li:last-child {
  margin-right: 0px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col {
  position: relative;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col.image-not-download a img {
  filter: blur(1px);
  border-color: #000;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col.image-not-download span {
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col.image-not-download span i {
  color: #FFF;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col .download-action a {
  color: #FFF;
  font-size: 10px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content .download-col ul li .image-download-col img {
  border-radius: 5px;
}
.chat-msg-blk .chats.chats-right .chat-content .message-content::before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #E8E8E8;
  border-right: 0;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  right: -4px;
  left: auto;
}
.chat-msg-blk .chats.chats-right .chat-avatar {
  padding: 8px 0px 0 15px;
}
.chat-msg-blk .chats.chats-right .chat-action-btns {
  order: 2;
  -webkit-order: 2;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
}
.chat-msg-blk .chats.chats-right .chat-action-btns .chat-user-time .chats-dot a {
  color: #00918E;
}
.chat-msg-blk .chats .chat-avatar {
  padding: 8px 15px 0 8px;
  display: flex;
  display: -webkit-flex;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  flex-shrink: 0;
}
.chat-msg-blk .chats .chat-avatar .dreams_chat {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.chat-msg-blk .chats .message-content {
  background-color: #E8E8E8;
  border-radius: 8px;
  padding: 10px 20px;
  font-weight: 500;
  margin-bottom: 5px;
  position: relative;
}
.chat-msg-blk .chats .message-content h4 {
  font-size: 13px;
  color: #262A2A;
  margin-bottom: 0px;
  line-height: 1.4;
  font-weight: 500;
}
.chat-msg-blk .chats .message-content .chat-time {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 10px;
  font-weight: 500;
  color: #00918E;
  margin-bottom: 0;
}
.chat-msg-blk .chats .message-content .chat-time svg {
  width: 10px;
}
.chat-msg-blk .chats .message-content::before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #E8E8E8;
  border-top: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 8px;
  left: -4px;
  right: auto;
}
.chat-msg-blk .chats .chat-profile-name h6 {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: left;
  -webkit-justify-content: left;
  -ms-flex-pack: left;
  font-size: 8px;
  font-weight: 500;
  color: #6F6F6F;
}
.chat-msg-blk .chats .chat-profile-name h6 i {
  font-size: 12px;
  color: #008024;
}
.chat-msg-blk .chat-line {
  margin: 0px 0 20px;
  position: relative;
  text-align: center;
  width: 100%;
}
.chat-msg-blk .chat-line:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  background-color: #00918E;
  width: 100%;
  height: 1px;
}
.chat-msg-blk .chat-line .chat-date {
  background-color: #00918E;
  color: #00918E;
  font-size: 13px;
  padding: 7px 14px;
  border-radius: 3px;
  display: inline-block;
  font-weight: 600;
  position: relative;
}

.right-user-side.call-user-side .slime-grp .right-sidebar-profile {
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border-bottom: 0;
  padding-bottom: 10px;
}
.right-user-side.call-user-side .slime-grp .right-sidebar-profile .profile-call-blk {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.right-user-side.call-user-side .slime-grp .right-sidebar-profile .edit-group svg {
  width: 16px;
  color: #00918E;
}
.right-user-side.call-user-side .slime-grp .chat-options {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-bottom: 1px solid #00918E;
  padding-bottom: 20px;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a {
  color: #00918E;
  width: 30px;
  height: 30px;
  background-color: gray;
  padding: 0;
  border-radius: 50px;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a:hover {
  background: #E41F07;
  border-color: #E41F07;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a:hover svg {
  color: #FFF;
}
.right-user-side.call-user-side .slime-grp .chat-options ul li a svg {
  width: 15px;
}
.right-user-side.right-side-party .slime-grp {
  padding: 0px;
}
.right-user-side.right-side-party .slime-grp .left-chat-title {
  padding: 20px;
  margin-bottom: 0;
  background-color: #F9F9FC;
  border-radius: 10px 10px 0 0;
}
.right-user-side.right-side-party .slime-grp .left-chat-title h4 {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .left-chat-title h4 span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 25px;
  height: 25px;
  background-color: #FDA700;
  border-radius: 50px;
  font-size: 14px;
  color: #FFF;
  margin-left: 10px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk {
  padding: 20px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list {
  border-radius: 0.25rem;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 5px;
  display: flex;
  display: -webkit-flex;
  border-radius: 6px;
  background-color: #F6F7F8;
  margin-bottom: 10px;
  border: 0;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item:hover {
  background-color: #F6F7F8;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .avatar {
  margin-right: 0.8rem;
  display: inline-block;
  margin-bottom: 0;
  height: 40px;
  width: 40px;
  position: relative;
  flex-shrink: 0;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .avatar::before {
  top: 0;
  bottom: inherit;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .avatar img {
  border-radius: 0px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-grow: 1;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user {
  display: grid;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user h5 {
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 2px;
  color: #6F6F6F;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user p {
  font-size: 12px;
  color: #FC0027;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .name-list-user p svg {
  width: 14px;
  height: 14px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .chat-user-time .chats-dot a {
  color: #FC0027;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-chat-time .text-muted {
  font-size: 10px;
  color: #262A2A;
  font-weight: 500;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-chat-time .new-message-count {
  width: 20px;
  height: 20px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  line-height: 0;
  font-size: 11px;
  background-color: #E41F07;
  color: #FFF;
  border-radius: 50%;
  margin-left: auto;
  margin-top: 5px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-call-time {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-call-time .call-recent a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 30px;
  height: 30px;
  background: #B8BCC9;
  color: #262A2A;
  border-radius: 50px;
}
.right-user-side.right-side-party .slime-grp .card-body-blk .user-list .user-list-item .users-list-body .last-call-time .call-recent a svg {
  color: #262A2A;
}
.right-user-side .slimScrollDiv {
  height: calc(100vh - 110px) !important;
}
.right-user-side .slimScrollDiv .slimscroll {
  height: calc(100vh - 110px) !important;
}
.right-user-side .slime-grp {
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.4705882353);
  border: 1px solid #E1E8ED;
  border-radius: 10px;
  padding: 15px;
}
.right-user-side .slime-grp .left-chat-title {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
  background-color: #F9F9FC;
}
.right-user-side .slime-grp .left-chat-title .chat-title h4 {
  font-size: 18px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 0;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 26px;
  height: 26px;
  background: transparent;
  border-radius: 50px;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile:hover {
  background: #E41F07;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile:hover svg {
  color: #FFF;
}
.right-user-side .slime-grp .left-chat-title .contact-close_call .close_profile svg {
  width: 16px;
  color: #FC0027;
}
.right-user-side .slime-grp .chat-footer {
  position: sticky;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 15px;
  background: #FFF;
}
.right-user-side .slime-grp .chat-footer form {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  position: relative;
}
.right-user-side .slime-grp .chat-footer form .comman-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.right-user-side .slime-grp .chat-footer form .comman-icon a {
  color: #6F6F6F;
}
.right-user-side .slime-grp .chat-footer form .smile-col {
  right: inherit;
  left: 15px;
}
.right-user-side .slime-grp .chat-footer form .attach-col {
  right: inherit;
  left: 45px;
}
.right-user-side .slime-grp .chat-footer form .micro-col {
  right: 50px;
  left: inherit;
}
.right-user-side .slime-grp .chat-footer form .micro-col a {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.right-user-side .slime-grp .chat-footer form .send-chat {
  right: 5px;
}
.right-user-side .slime-grp .chat-footer form .send-chat a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 34px;
  height: 34px;
  background: #E41F07;
  border-radius: 50px;
}
.right-user-side .slime-grp .chat-footer form .send-chat a:hover {
  background: #1b2950;
}
.right-user-side .slime-grp .chat-footer form .send-chat a:hover svg {
  color: #FFF;
}
.right-user-side .slime-grp .chat-footer form .send-chat a svg {
  width: 14px;
  color: #FFF;
}
.right-user-side .slime-grp .chat-footer form .chat_form {
  border-radius: 20px;
  margin-right: 0px;
  background: #FFF;
  border: 1px solid rgba(145, 158, 171, 0.3);
  border-radius: 6px;
  height: 48px;
  padding: 10px 70px;
}
.right-user-side .slime-grp .chat-footer form .chat_form::placeholder {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.2);
}

.owl-carousel.video-slide .owl-nav.disabled {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
}
.owl-carousel.video-slide .owl-nav {
  top: 50%;
  transform: translate(0, -50%);
}
@media (max-width: 1280px) {
  .owl-carousel.video-slide .owl-nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
  }
}
.owl-carousel.video-slide .owl-nav button.owl-next, .owl-carousel.video-slide .owl-nav button.owl-prev {
  background-color: #D9D9D9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.owl-carousel.video-slide .owl-nav button.owl-next:hover, .owl-carousel.video-slide .owl-nav button.owl-prev:hover {
  background-color: #E41F07;
}
.owl-carousel.video-slide .owl-nav button.owl-next:hover i, .owl-carousel.video-slide .owl-nav button.owl-prev:hover i {
  color: #FFF;
}
.owl-carousel.video-slide .owl-nav button.owl-next i, .owl-carousel.video-slide .owl-nav button.owl-prev i {
  color: #6F6F6F;
}

.audio-call-group {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 100%;
}
.audio-call-group ul {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  -webkit-justify-content: space-evenly;
  -ms-flex-pack: space-evenly;
  width: 100%;
}
.audio-call-group ul li {
  position: relative;
}
.audio-call-group ul li.active .avatar::before {
  content: "";
  width: 250px;
  height: 250px;
  position: absolute;
  border: 1px solid #E41F07;
  border-radius: 50%;
  left: -25px;
  top: -25px;
}
@media (max-width: 991.98px) {
  .audio-call-group ul li.active .avatar::before {
    width: 150px;
    height: 150px;
    left: -10px;
    top: -10px;
  }
}
@media (max-width: 767.98px) {
  .audio-call-group ul li.active .avatar::before {
    width: 100px;
    height: 100px;
    left: -5px;
    top: -5px;
  }
}
.audio-call-group ul li .avatar {
  width: 200px;
  height: 200px;
  margin: 0;
  position: relative;
}
@media (max-width: 991.98px) {
  .audio-call-group ul li .avatar {
    width: 130px;
    height: 130px;
  }
}
@media (max-width: 767.98px) {
  .audio-call-group ul li .avatar {
    width: 90px;
    height: 90px;
  }
}
.audio-call-group ul li .avatar img {
  width: 100%;
  position: relative;
}
.audio-call-group ul li .user-audio-call h5 {
  font-size: 14px;
  color: #FFF;
  font-weight: 400;
  text-transform: capitalize;
  text-align: center;
  margin-top: 35px;
}
@media (max-width: 767.98px) {
  .audio-call-group ul li .user-audio-call h5 {
    margin-top: 15px;
  }
}
.audio-call-group ul li .more-icon {
  position: absolute;
  bottom: 10px;
  right: inherit;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
}
@media (max-width: 767.98px) {
  .audio-call-group ul li .more-icon {
    bottom: 0px;
  }
}
.audio-call-group ul li .more-icon a {
  background-color: #E41F07;
  color: #FFF;
}

.audio-volume {
  position: absolute;
  width: fit-content;
  height: 134px;
  bottom: 20px;
  left: 20px;
  background: #898989;
  border-radius: 50px;
  padding: 10px 14px;
  width: 30px;
  padding-bottom: 30px;
}
.audio-volume .volume-icons a {
  position: absolute;
  bottom: 0;
  width: 30px;
  height: 30px;
  left: 0;
  border-radius: 50px;
  background: #FFF;
  border: 1px solid #FDA700;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.custom-input {
  width: 100%;
  height: 4px;
  width: 3px;
  height: 100%;
  background: #FFF;
  border-radius: 5px;
  writing-mode: vertical-lr;
}

.custom-input::-webkit-slider-thumb {
  appearance: none;
  width: 12px;
  height: 12px;
  background: #E41F07 !important;
  border-radius: 50%;
  cursor: pointer;
}

.custom-input::-moz-range-thumb {
  width: 12px;
  height: 12px;
  background: #E41F07 !important;
  border-radius: 50%;
  cursor: pointer;
}

.table-top-head {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 575.98px) {
  .table-top-head.low-stock-top-head {
    flex-wrap: wrap;
    justify-content: start;
  }
}
.table-top-head.low-stock-top-head li {
  margin-bottom: 10px;
}
.table-top-head.low-stock-top-head li:last-child {
  margin-right: 0;
}
.table-top-head li {
  margin-right: 10px;
  flex-shrink: 0;
}
.table-top-head li:last-child {
  margin-right: 0;
}
.table-top-head li #collapse-header {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .table-top-head li #collapse-header {
    display: none;
  }
}
.table-top-head li a {
  height: 38px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #898989;
  background: #FFF;
  border-radius: 8px;
  padding: 6px;
}
.table-top-head li a svg {
  color: #262A2A;
}
.table-top-head li a:hover {
  background: #e3e3e3;
}
.table-top-head li a label {
  margin-right: 10px;
}
.table-top-head li a.btn-secondary {
  background-color: #262A2A;
  color: #FFF;
  padding: 10px;
  font-weight: 700;
  font-size: 14px;
}
.table-top-head li a.btn-secondary:hover {
  background-color: #E41F07;
}
.table-top-head li a.btn-secondary svg {
  width: 16px;
  margin-right: 5px;
  color: #FFF;
}
@media (max-width: 767.98px) {
  .table-top-head li a.btn-secondary {
    padding: 5px;
    font-size: 14px;
  }
}
.table-top-head li a .action-edit.sales-action {
  color: #339DFF;
}
.table-top-head li .status-toggle {
  height: 38px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #C0C0C0;
  background: #FFF;
  border-radius: 8px;
  padding: 6px 10px;
}
.table-top-head li .status-toggle label {
  margin-right: 10px;
}

.main-chat-blk .slimscroll {
  height: calc(100vh - 60px) !important;
}
.main-chat-blk .slimscroll-active-sidebar a {
  color: #6F6F6F;
}
.main-chat-blk .emoj-group ul {
  display: flex;
  align-items: center;
}
.main-chat-blk .emoj-group ul li + li {
  margin-left: 10px;
}
.main-chat-blk .emoj-group ul li a {
  width: 34px;
  height: 34px;
  background: #f6f7f8;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .emoj-group ul li a i {
  color: #424242;
}
.main-chat-blk .message-content {
  position: relative;
}
.main-chat-blk .message-content:hover .emoj-group {
  opacity: 1;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group {
  position: absolute;
  top: 50%;
  right: -100px;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  transform: translate(0, -50%);
}
.main-chat-blk .rig-emoji-group {
  position: absolute;
  right: 210px;
}
.main-chat-blk .wrap-emoji-group {
  position: absolute;
  right: 290px;
}
.main-chat-blk .emoj-group-list-foot {
  display: none;
  position: absolute;
  top: -50px;
  left: -90px;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group-list-foot ul {
  display: flex;
  align-items: center;
  background: #f6f7f8;
  border-radius: 50px;
  padding: 5px;
}
.main-chat-blk .emoj-group-list-foot ul li a {
  padding: 0;
  display: flex;
  align-items: center;
}
.main-chat-blk .emoj-group-list-foot ul li.add-emoj a {
  background: #EDEDED;
}
.main-chat-blk .emoj-group-list-foot ul li.add-emoj a i {
  font-size: 20px;
  color: #424242;
}
.main-chat-blk .down-emoji-circle {
  position: absolute;
  left: 10px !important;
  top: -38px !important;
}
.main-chat-blk .emoj-action-foot .down-emoji-circle ul {
  padding: 10px;
}
.main-chat-blk .down-emoji-circle ul li + li {
  margin-left: 14px;
}
.main-chat-blk .emoj-action-foot .down-emoji-circle ul li:last-child a {
  width: 34px;
  height: 34px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-page-wrapper .content {
  padding: 24px 0 0 24px;
}
.main-chat-blk .chat-page-wrapper .sidebar {
  position: initial;
}
@media (max-width: 991.98px) {
  .main-chat-blk .chat-page-wrapper .sidebar {
    margin-left: 0;
  }
}
.main-chat-blk .chat-page-wrapper .left-chat-title {
  padding: 12px;
  border-bottom: 1px solid #E0E0E0;
  min-height: 72px;
}
.main-chat-blk .chat-page-wrapper .setting-title-head h4 {
  font-size: 18px;
  color: #262A2A;
  font-weight: 700;
}
.main-chat-blk .chat-page-wrapper .chat .slimscroll {
  height: calc(100vh - 135px) !important;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item {
  font-size: 14px;
  cursor: pointer;
  padding: 7px 14px;
  font-weight: 500;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item i {
  font-size: 16px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item span {
  float: right;
  font-size: 18px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item.active {
  background: none;
  color: inherit;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:focus,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:active {
  background-color: #e6e6e6;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu {
  background: #FFF;
  border: 1px solid #E5E7EB;
  box-sizing: border-box;
  box-shadow: 0px 4px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-width: 173px;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item {
  margin: 0;
  position: relative;
  display: flex;
  align-items: center;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu.chat-drop-menu .dropdown-item i {
  font-size: 16px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:focus,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:active {
  background-color: #F8ECFF;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item span {
  margin-right: 10px;
  display: flex;
  align-items: center;
}
.main-chat-blk .chat-page-wrapper .contact-close_call {
  display: flex;
  align-items: center;
}
@keyframes wave {
  0%, 100%, 60% {
    transform: initial;
  }
  30% {
    transform: translateY(-5px);
  }
}
.main-chat-blk .chat {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  background: #FFF;
}
.main-chat-blk .chat .chat-header {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  padding: 15px 24px;
  align-items: center;
  border-bottom: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: var(--White, #FFF);
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  position: relative;
}
.main-chat-blk .chat .chat-header .user-details {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .chat .chat-header .user-details figure {
  margin-right: 1rem;
}
.main-chat-blk .chat .chat-header .user-details h5 {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  line-height: 1;
  color: #262A2A;
}
.main-chat-blk .chat .chat-header .chat-options ul {
  margin-bottom: 0;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a {
  font-size: 14px;
  color: #262A2A;
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a i {
  font-size: 20px;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a:not(.no-bg):hover {
  background-color: #C0C0C0;
  border-color: #C0C0C0;
}
.main-chat-blk .chat .chat-body {
  flex: 1 1;
  padding: 24px;
  padding-bottom: 40px;
}
.main-chat-blk .chat .chat-body:not(.no-message) {
  overflow: hidden;
}
.main-chat-blk .chat .chat-body .messages {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: flex-start;
  -webkit-align-items: flex-start;
}
.main-chat-blk .chat .chat-body .messages .chats {
  max-width: 75%;
  margin-bottom: 1.5rem;
  display: flex;
  display: -webkit-flex;
}
.main-chat-blk .chat .chat-body .messages .chats:last-child {
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .avatar {
  margin-right: 1rem;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time h5 {
  font-size: 15px;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time {
  color: #FFF;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time i {
  color: rgba(247, 247, 247, 0.5);
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time i img {
  width: 14px;
  height: auto;
  margin-left: 2px;
  vertical-align: 0px;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content {
  border-radius: 0px 15px 15px 15px;
  background: var(--light-color, #F6F7F8);
  padding: 14px 20px;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.031372549);
}
.main-chat-blk .chat .chat-body .messages .chats .message-content a {
  color: #299cdb;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.award-link a {
  color: #262A2A;
  margin-bottom: 2px;
  display: block;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.award-link img {
  border-radius: 10px;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.chat-award-link a {
  display: flex;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.fancy-msg-box .image-not-download span {
  position: absolute;
  color: #FFF;
  font-size: 13px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {
  margin-bottom: 0;
  color: #262A2A;
  font-weight: 600;
  font-size: 15px;
}
.main-chat-blk .chat .chat-body .messages .chat-profile-name h6 span {
  font-size: 12px;
  color: #6F7A7A;
  font-weight: 400;
  padding-left: 10px;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right {
  margin-left: auto;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-time {
  justify-content: flex-end;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content {
  border-radius: 15px 0px 15px 15px;
  background: rgba(255, 159, 67, 0.12);
  color: #262A2A;
  padding: 15px;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time {
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time .time {
  color: #6F7A7A;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time .time i {
  color: #299cdb;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns {
  order: 2;
  -webkit-order: 2;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns .chat-action-col {
  width: 20px;
  text-align: center;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns .chat-read-col {
  display: flex;
  display: -webkit-flex;
  align-items: flex-end;
  -webkit-align-items: flex-end;
  padding-bottom: 22px;
  color: #565E5E;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-content {
  order: 1;
  -webkit-order: 1;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-avatar {
  padding: 8px 0px 0 15px;
}
.main-chat-blk .chat .chat-body .messages .download-col {
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .download-col ul {
  list-style: none;
  padding: 0;
  margin: 0 0 5px 0;
  display: flex;
  display: -webkit-flex;
}
.main-chat-blk .chat .chat-body .messages .download-col ul li + li {
  margin-left: 5px;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col {
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col a > img {
  border: 1px solid transparent;
  width: 80px;
  border-radius: 8px;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col.image-not-download a > img {
  filter: blur(1px);
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action a {
  color: #FFF;
  font-size: 10px;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action div img {
  width: 13px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
  bottom: 14px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action a {
  color: #FFF;
  font-size: 10px;
  color: #323737;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action div img {
  width: 13px;
}
.main-chat-blk .chat .chat-body .messages .file-download {
  position: relative;
  background: #E8E8E8;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 7px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-type {
  width: 54px;
  height: 54px;
  background-color: #FFF;
  border-radius: 4px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-type i {
  color: #6F7A7A;
  font-size: 24px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details span.file-name {
  color: #262A2A;
  display: inline-block;
  width: 100%;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details span.file-size {
  color: #6F7A7A;
  display: inline-block;
  width: 100%;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul {
  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li {
  list-style: none;
  color: #262A2A;
  font-size: 14px;
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 13px;
  background: #C2C2C2;
  right: -8px;
  top: 5px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li:last-child::before {
  display: none;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li a {
  color: #E41F07;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li + li {
  padding-left: 15px;
}
.main-chat-blk .chat .chat-body.no-message {
  -webkit-user-select: none;
          user-select: none;
}
.main-chat-blk .chat .chat-footer {
  position: relative;
}
.main-chat-blk .chat .chat-footer form {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
}
@media (max-width: 991.98px) {
  .main-chat-blk .chat .chat-footer form {
    padding-bottom: 15px;
  }
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn {
  margin-left: 0px;
  color: #6F6F6F;
  font-size: 20px;
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn:last-child {
  margin-right: 0;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background: #E41F07;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #FFF !important;
  margin-left: 10px;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:hover {
  background-color: #FFF;
  border-color: #323737;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:hover i {
  color: #323737;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:focus {
  box-shadow: none;
}
.main-chat-blk .chat .chat-footer form .specker-col span {
  color: #323737;
  font-size: 25px;
}
.main-chat-blk .chat .chat-footer form .attach-col i {
  color: #323737;
  font-size: 20px;
}
.main-chat-blk .chat .chat-footer form .attach-col {
  right: inherit;
  left: 60px;
}
.main-chat-blk .chat .chat-footer form .smile-col i {
  color: #323737;
  font-size: 20px;
  font-size: 22px;
}
.main-chat-blk .chat .chat-footer form .smile-col {
  right: inherit;
  left: 15px;
}
.main-chat-blk .chat .chat-footer form .smile-foot {
  margin-right: 10px;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle {
  width: 38px;
  height: 38px;
  background: #FFF;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle:hover {
  background-color: #C0C0C0;
  border-color: #C0C0C0;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle i {
  color: #262A2A;
  font-size: 18px;
}
.main-chat-blk .chat .chat-footer form .form-control::-webkit-input-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control::-moz-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control:-ms-input-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control:-moz-placeholder {
  color: #262A2A;
  opacity: 1;
}
.main-chat-blk .chat-options ul.list-inline .list-inline-item {
  margin-bottom: 0;
}
.main-chat-blk .last-seen {
  color: #262A2A;
  font-size: 14px;
}
.main-chat-blk .user_callog {
  display: flex;
  margin-top: 0px;
}
.main-chat-blk .calllog_p {
  margin-left: 5px;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline-item a {
  background: #E41F07;
  width: 38px;
  height: 38px;
  border-radius: 50px;
  color: #262A2A;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FFF !important;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #FFF;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline {
  border-bottom: 1px solid #EDEDED;
  margin-bottom: 0;
  padding-bottom: 15px;
}
.main-chat-blk .last-seen-profile span {
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 12px;
  display: block;
}
.main-chat-blk .header_button {
  position: absolute;
  right: 5px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
  color: #FFF;
  text-align: center;
  background: #ffa977;
  bottom: 40px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .btn-warning:hover {
  color: #FFF;
  background-color: #E94C39;
  border-color: #E73520;
}
.main-chat-blk .right_sidebar_profile {
  margin-top: 0px;
}
.main-chat-blk .account_details {
  background-color: #898989;
  border-color: #6F6F6F;
  border-radius: 5px !important;
  border-bottom: 0 !important;
}
.main-chat-blk .security_details {
  background-color: #898989;
  border-color: #6F6F6F;
  border-radius: 5px !important;
  border-bottom: 0 !important;
}
.main-chat-blk .close_icon {
  font-size: 18px;
}
.main-chat-blk .button_plus {
  margin-left: 0px;
}
.main-chat-blk .chat-search {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  opacity: 0;
  visibility: hidden;
}
.main-chat-blk .chat-search input[type=text] {
  padding: 8px 8px 8px 35px;
  width: 100%;
  min-height: 47px;
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background-color: #FFF;
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .chat-search input[type=text]:hover {
  border-color: #9B9B9B;
}
.main-chat-blk .chat-search input[type=text]:focus {
  border-color: #9B9B9B;
}
.main-chat-blk .chat-search input[type=text]:focus-visible {
  border-color: #9B9B9B;
}
.main-chat-blk .chat-search.visible-chat {
  opacity: 1;
  visibility: visible;
  top: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  z-index: 9;
}
.main-chat-blk .form-control-feedback {
  z-index: 2;
  display: block;
  text-align: center;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.main-chat-blk .form-control-feedback i {
  font-size: 16px;
  color: #262A2A;
}
.main-chat-blk .user-chat-search {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  opacity: 0;
  visibility: hidden;
}
.main-chat-blk .user-chat-search input[type=text] {
  padding: 8px 8px 8px 35px;
  width: 100%;
  min-height: 47px;
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background-color: #FFF;
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .user-chat-search input[type=text]:hover {
  border-color: #9B9B9B;
}
.main-chat-blk .user-chat-search input[type=text]:focus {
  border-color: #9B9B9B;
}
.main-chat-blk .user-chat-search input[type=text]:focus-visible {
  border-color: #9B9B9B;
}
.main-chat-blk .user-chat-search.visible-chat {
  opacity: 1;
  visibility: visible;
  top: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  z-index: 9;
}
.main-chat-blk .all-chats {
  position: relative;
}
.main-chat-blk .close-btn-chat {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  right: 12px;
  top: 9px;
  cursor: pointer;
}
.main-chat-blk .user-close-btn-chat {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  right: 12px;
  top: 9px;
  cursor: pointer;
}
.main-chat-blk .main_content {
  width: 100% !important;
}
.main-chat-blk .avatar-main {
  height: 50px;
  width: 50px;
}
.main-chat-blk .archive-btn {
  border: 1px solid #008024;
  color: #565E5E;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  margin-right: 1.5rem;
}
.main-chat-blk .archive-btn-grey {
  border: 1px solid #909090;
  color: #6F7A7A;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 500;
  padding: 2px 6px;
  margin-top: 0.25rem;
}
.main-chat-blk .right_sidebar_icon {
  list-style: none;
}
.main-chat-blk .btn.btn-outline-light:hover {
  background: #e6e6e6;
}
.main-chat-blk .chat-avatar {
  padding: 8px 15px 0 8px;
  display: flex;
  display: -webkit-flex;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  flex-shrink: 0;
}
.main-chat-blk .chat-profile-name {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.main-chat-blk .chat-profile-name .chat-action-col a {
  display: flex;
}
.main-chat-blk .delete-pop-btn .btn-primary {
  margin: 0 0 0 10px;
}
.main-chat-blk .delete-model-head {
  padding: 40px;
}
.main-chat-blk .delete-model-head .modal-header {
  padding: 0;
  margin-bottom: 32px;
}
.main-chat-blk .delete-model-head .modal-body {
  padding: 0;
}
.main-chat-blk .delete-chat-notify {
  margin-bottom: 32px;
}
.main-chat-blk .delete-chat-notify .form-check {
  margin-bottom: 14px;
}
.main-chat-blk .chats.chats-right {
  flex-direction: row-reverse;
}
.main-chat-blk .message-star {
  display: flex;
  align-items: center;
}
.main-chat-blk .message-star .avatar {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}
.main-chat-blk .message-star .avatar img {
  width: 100%;
}
.main-chat-blk .message-star h6 {
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 0;
}
.main-chat-blk .message-star h6 span i {
  color: #FEC14D;
}
.main-chat-blk .chat-voice-group ul {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 0;
  margin-bottom: 0;
}
.main-chat-blk .chat-voice-group ul li span {
  width: 28px;
  height: 28px;
  background: #E41F07;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .chat-voice-group li {
  margin-bottom: 0;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  list-style: none;
}
.main-chat-blk .chat-voice-group li + li {
  padding-left: 10px;
}
.main-chat-blk .file-download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.main-chat-blk .file-download-col .download-action a {
  color: #FFF;
  font-size: 10px;
}
.main-chat-blk .file-download-col .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .file-download-col .download-action div img {
  width: 13px;
}
.main-chat-blk .file-download-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .file-download-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .file-download-col ul li {
  float: left;
  width: 50%;
  padding: 5px;
}
.main-chat-blk .file-download-col ul li .image-download-col {
  position: relative;
}
.main-chat-blk .file-download-col ul li .image-download-col a > img {
  width: 100%;
}
.main-chat-blk .file-download-col ul li.full-width {
  width: 100%;
}
.main-chat-blk .chat-select .select2-container .select2-selection--single {
  border: 0;
  height: 24px;
}
.main-chat-blk .chat-select .select2-container .select2-selection--single .select2-selection__rendered {
  padding-right: 40px;
  padding-left: 0px;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #6F7A7A;
  font-size: 18px;
  font-weight: normal;
  line-height: 24px;
  font-weight: 600;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 24px;
  right: 7px;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #424848;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  height: 0;
  left: 50%;
  margin-left: -5px;
  margin-top: -5px;
  position: absolute;
  top: 50%;
  width: 0;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.main-chat-blk .chat-select .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #262A2A;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--multiple {
  border: 1px solid #ddd;
  min-height: 40px;
}
.main-chat-blk .chat-select .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #424848;
  border-width: 2px 0 0 2px;
  padding: 3px;
  margin-top: -5px;
  border-color: #424848;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
}
.main-chat-blk .chat-select .select2-container--default.form-control-sm .select2-selection--single .select2-selection__arrow {
  top: 7px;
}
.main-chat-blk .chat-select .select2-container--open .select2-dropdown--below {
  margin-top: 10px;
}
.main-chat-blk .success-pass {
  margin-bottom: 40px;
  text-align: center;
}
.main-chat-blk .review-files p {
  margin-bottom: 5px;
  color: #262A2A;
  font-size: 14px;
}
.main-chat-blk .like-chat-grp ul {
  padding: 0;
  margin-bottom: 0;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-top: 10px;
}
.main-chat-blk .like-chat-grp ul li {
  list-style: none;
}
.main-chat-blk .like-chat-grp ul li a {
  border: 1px solid #E0E0E0;
  border-radius: 50px;
  padding: 3px 12px;
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #262A2A;
  font-weight: 400;
  font-size: 14px;
}
.main-chat-blk .like-chat-grp ul li a img {
  margin-left: 5px;
}
.main-chat-blk .like-chat-grp ul li + li {
  margin-left: 10px;
}
.main-chat-blk .like-chat-grp ul li.like-chat a {
  background: #FEF6DC;
}
.main-chat-blk .like-chat-grp ul li.comment-chat a {
  background: #FFE8E9;
}
.main-chat-blk .chat-line {
  margin: 0px 0 20px;
  position: relative;
  text-align: center;
  width: 100%;
}
.main-chat-blk .chat-line:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  background-color: #E8E8E8;
  width: 100%;
  height: 1px;
}
.main-chat-blk .chat-date {
  border-radius: 100px;
  background: #E8E8E8;
  color: #262A2A;
  font-size: 14px;
  padding: 4px 20px;
  display: inline-block;
  font-weight: 400;
  position: relative;
  border: 1px solid #E0E0E0;
}
.main-chat-blk .chat + .sidebar-group {
  margin-right: 0px;
}
.main-chat-blk .chat + .sidebar-group .sidebar {
  margin-right: 0px;
}
.main-chat-blk .group-comman-theme {
  padding: 0 24px;
}
.main-chat-blk .group-comman-theme h6 {
  margin-bottom: 15px;
}
.main-chat-blk .group-comman-theme ul {
  padding: 0;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #EDEDED;
}
.main-chat-blk .group-comman-theme ul li {
  display: flex;
  align-items: center;
  list-style: none;
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 10px;
}
.main-chat-blk .group-comman-theme ul li:last-child {
  margin-bottom: 0;
}
.main-chat-blk .group-comman-theme ul li .avatar {
  flex-shrink: 0;
  margin-right: 10px;
}
.main-chat-blk .theme-content h6 {
  margin-bottom: 6px;
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .theme-content p {
  margin-bottom: 0;
  text-align: start;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: #262A2A;
  font-size: 14px;
}
.main-chat-blk .chat-message-grp {
  padding: 24px;
  padding-top: 0;
}
.main-chat-blk .chat-message-grp ul {
  padding: 0;
}
.main-chat-blk .chat-message-grp ul li {
  list-style: none;
  margin-bottom: 15px;
}
.main-chat-blk .chat-message-grp ul li:last-child {
  margin-bottom: 0px;
}
.main-chat-blk .chat-message-grp ul li a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .chat-message-grp ul li a:hover .stared-group h6 {
  color: #323737;
}
.main-chat-blk .stared-group {
  display: flex;
  align-items: center;
}
.main-chat-blk .stared-group span {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  margin-right: 10px;
  background: #F6F7F8;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .stared-group span i {
  font-size: 16px;
}
.main-chat-blk .stared-group h6 {
  font-size: 15px;
  font-weight: 500;
  color: #6F6F6F;
  margin-bottom: 0;
}
.main-chat-blk .star-message {
  background: #FEF6DC;
}
.main-chat-blk .star-message i {
  color: #FEC14D;
}
.main-chat-blk .mute-message {
  background: rgba(235, 253, 255, 0.9803921569);
}
.main-chat-blk .mute-message i {
  color: #299cdb;
}
.main-chat-blk .block-message {
  background: #FFE8E9;
}
.main-chat-blk .block-message i {
  color: #4A00E5;
}
.main-chat-blk .report-message {
  background: #F8ECFF;
}
.main-chat-blk .report-message i {
  color: #262A2A;
}
.main-chat-blk .delete-message {
  background: #FFE8E9;
}
.main-chat-blk .delete-message i {
  color: #FD3352;
}
.main-chat-blk .count-group {
  display: flex;
  align-items: center;
}
.main-chat-blk .count-group span {
  width: 16px;
  height: 16px;
  border-radius: 50px;
  color: #FFF;
  font-size: 10px;
  background: #E41F07;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 5px;
}
.main-chat-blk .count-group i {
  color: #424242;
  font-size: 16px;
}
.main-chat-blk .nav.nav-tabs.chat-tabs .nav-item .nav-link {
  font-size: 16px;
  font-weight: bold;
  color: #FFF;
  background-color: transparent;
  border: 0;
}
.main-chat-blk .nav.nav-tabs.chat-tabs .nav-item .nav-link.active {
  font-size: 16px;
  font-weight: bold;
  color: #E94C39;
}
.main-chat-blk .header-top ul li a {
  color: #000;
  font-size: 18px;
}
.main-chat-blk .set-search {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 50px;
  width: 28px;
  height: 28px;
}
.main-chat-blk .set-search:hover {
  background: #F5F5F5;
  border-color: #C0C0C0;
}
.main-chat-blk .header-action {
  list-style: none;
  margin: 0;
  padding: 0;
}
.main-chat-blk .header-action li {
  display: inline-block;
  margin-left: 10px;
}
.main-chat-blk .header-action li a {
  color: #262A2A;
  font-size: 18px;
}
.main-chat-blk .user-list {
  border-radius: 0.25rem;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.main-chat-blk .user-list li a {
  padding: 17px 20px;
  display: flex;
  display: -webkit-flex;
  cursor: pointer;
  border-radius: 6px;
  margin-bottom: 10px;
  border: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.main-chat-blk .user-list li .avatar {
  margin-right: 0.8rem;
  display: inline-block;
  margin-bottom: 0;
  height: 46px;
  width: 46px;
  border-radius: 50%;
  position: relative;
  z-index: 0;
}
.main-chat-blk .user-list li .avatar .letter-avatar {
  width: 45px;
  height: 45px;
  border-radius: 45px;
  margin-right: 0.8rem;
  margin-bottom: 0;
  position: relative;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  background-color: #6F6F6F;
  font-size: 16px;
  font-weight: 600;
  color: #676DFF;
}
.main-chat-blk .user-list li a.admin-shade {
  box-shadow: none;
}
.main-chat-blk .user-list .avatar > a > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .user-list .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar-away::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #FFF;
  z-index: 9;
  background-color: #ffff00;
}
.main-chat-blk .avatar-offline::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #FFF;
  z-index: 9;
}
.main-chat-blk .avatar-online::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #FFF;
  z-index: 9;
  background-color: #00918E;
}
.main-chat-blk .animate-typing-col {
  color: #5CB85C;
}
.main-chat-blk .animate-typing-col .dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  margin-right: -1px;
  background: #0D9B35;
  animation: wave 1.3s linear infinite;
  opacity: 0.6;
}
.main-chat-blk .animate-typing-col .dot:nth-child(2) {
  animation-delay: -1.1s;
}
.main-chat-blk .animate-typing-col .dot:nth-child(3) {
  animation-delay: -0.9s;
}
.main-chat-blk .chat_form {
  border-radius: 20px;
  margin-right: 0px;
  background: #FFF;
  border: 1px solid #C2C2C2;
  box-shadow: 0px 4px 4px #F5F8FF;
  border-radius: 6px;
  height: 40px;
  padding: 10px 10px;
}
.main-chat-blk .contact-close a {
  color: #262A2A;
  opacity: 0.5;
  border-color: #898989;
}
.main-chat-blk .main-wrapper .content .sidebar-group.right-sidebar .sidebar {
  width: 310px;
}
.main-chat-blk .primary-title {
  color: #E94C39;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}
.main-chat-blk .primary-title i {
  font-size: 14px;
}
.main-chat-blk .contact-action {
  padding: 0;
  margin: 0;
  list-style: none;
}
.main-chat-blk .contact-action li {
  padding: 11px 0;
  border-bottom: 1px solid #f1f1f1;
}
.main-chat-blk .contact-action li a {
  color: #262A2A;
  color: #262A2A;
  font-size: 14px;
  font-weight: bold;
}
.main-chat-blk .contact-action li.report-contact a {
  color: #FC0027;
}
.main-chat-blk .contact-action li.delete-chat a {
  color: #FC0027;
}
.main-chat-blk .contact-action li.sign-out a {
  color: #FC0027;
}
.main-chat-blk .left-sidebar {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
}
.main-chat-blk .left-sidebar-wrap {
  background: #FBFBFB;
  overflow: hidden;
  width: 448px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  flex: 1 1;
}
.main-chat-blk .right-sidebar {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  background-color: #FDFDFE;
  opacity: 100%;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  position: relative;
  width: 320px;
}
.main-chat-blk .right-sidebar .right-sidebar-wrap {
  background-color: #FFF;
  border-left: 1px solid #E0E0E0;
  border-radius: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  height: calc(100vh - 0px);
}
.main-chat-blk .right-sidebar .right-sidebar-wrap .sidebar-body {
  padding: 0;
}
.main-chat-blk .right-sidebar .right-sidebar-wrap .right-sidebar-profile {
  padding: 24px;
  padding-bottom: 0;
  margin-bottom: 15px;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile.close-star {
  color: #FDA700;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile.close-trash {
  color: #FC0027;
}
.main-chat-blk .right-sidebar.video-right-sidebar {
  width: 371px;
}
.main-chat-blk .right-sidebar.video-right-sidebar .chat .chat-body {
  padding-bottom: 110px;
}
.main-chat-blk .right-sidebar.video-right-sidebar .chat {
  margin-left: 0 !important;
  display: block;
}
.main-chat-blk .video-call-chat .left-chat-title.with-bg {
  background: transparent;
}
.main-chat-blk .video-call-chat .left-chat-title {
  border: 0;
}
.main-chat-blk .video-call-chat .chat-title h4 {
  font-size: 18px;
  font-weight: 600;
  color: #262A2A;
}
.main-chat-blk .video-call-chat .chat-title span {
  font-size: 12px;
  font-weight: 400;
  color: #262A2A;
}
.main-chat-blk .chat.video-call-chat .chat-body {
  background-image: none;
}
.main-chat-blk .chat.video-call-chat .chat-body .messages .chats .message-content {
  background: #F5F5F5;
}
.main-chat-blk .chat.video-call-chat .chat-body .messages .chats.chats-right .message-content {
  background: #F8ECFF;
}
.main-chat-blk .member-details {
  margin-bottom: 10px;
}
.main-chat-blk .chat-member-details {
  padding: 0 24px;
}
.main-chat-blk .chat-member-details .member-details ul {
  padding: 0;
  border-bottom: 1px solid #EDEDED;
}
.main-chat-blk .chat-member-details .member-details ul li {
  list-style: none;
  margin-bottom: 15px;
}
.main-chat-blk .chat-member-details .member-details ul li h6 {
  font-size: 15px;
  font-weight: 400;
  color: #262A2A;
  margin-bottom: 5px;
}
.main-chat-blk .chat-member-details .member-details ul li h5 {
  font-size: 15px;
  font-weight: 500;
  color: #262A2A;
  margin-bottom: 0px;
}
.main-chat-blk .chat-member-details .member-details ul li span {
  font-size: 16px;
  font-weight: 400;
  color: #262A2A;
}
.main-chat-blk .chat-member-details .member-details ul li a {
  font-size: 15px;
  font-weight: 500;
  color: #323737;
  border-radius: 100px;
  padding: 5px;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-member-details .member-details ul li a:hover {
  color: #262A2A;
}
.main-chat-blk .chat-member-details .member-details ul li a + a {
  margin-left: 10px;
}
.main-chat-blk .right-sidebar.show-right-sidebar {
  margin-right: 0;
}
.main-chat-blk .right-sidebar.video-right-sidebar.show-right-sidebar {
  margin-right: 0;
}
.main-chat-blk .right-sidebar.hide-right-sidebar {
  margin-right: -320px;
}
.main-chat-blk .right-sidebar.video-right-sidebar.hide-right-sidebar {
  margin-right: -371px;
}
.main-chat-blk .status-modal .custom-status-close {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  background-color: #C0C0C0;
  border-color: #C0C0C0;
}
.main-chat-blk .group-description .description-sub h5 span a {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #262A2A;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  border-color: #C0C0C0;
}
.main-chat-blk .list_group_notread {
  color: #E94C39 !important;
}
.main-chat-blk .chat-cont-type {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-cont-type .chat-type-wrapper {
  margin-bottom: 0;
}
.main-chat-blk .chat-cont-type .chat-type-wrapper p {
  color: #6F7A7A;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0;
}
.main-chat-blk .group-type-radio {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-size: 16px;
  font-weight: 400;
  color: #262A2A;
  margin-right: 24px;
}
.main-chat-blk .group-type-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.main-chat-blk .group-type-radio input:checked ~ .checkmark {
  background-color: #323737;
}
.main-chat-blk .group-type-radio input:checked ~ .checkmark:after {
  display: block;
}
.main-chat-blk .group-type-radio .checkmark:after {
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
}
.main-chat-blk .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #FFF;
  border: 1px solid #E4E4E4;
  border-radius: 50%;
}
.main-chat-blk .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.main-chat-blk .pass-login label {
  color: #262A2A;
  font-size: 14px;
  font-weight: 500;
}
.main-chat-blk .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #323737 !important;
}
.main-chat-blk .right-sidebar-profile > .avatar {
  background: rgba(66, 11, 161, 0.1);
}
.main-chat-blk .group_img {
  position: relative;
  display: inline-block;
}
.main-chat-blk .group-name-search {
  margin-bottom: 14px;
}
.main-chat-blk .parti-wrapper {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}
.main-chat-blk .group_header {
  width: 38px !important;
  height: 38px !important;
  border: 2px solid #FFF;
}
.main-chat-blk .last-chat-time i.missed-col {
  width: 17px;
  display: inline-block;
  margin-top: 10px;
}
.main-chat-blk .last-chat-time i.missed-col img {
  max-width: 100%;
  height: auto;
}
.main-chat-blk .right-sidebar-head {
  padding: 0px 24px;
}
.main-chat-blk .right-sidebar-head h5 {
  font-size: 15px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 0px;
}
.main-chat-blk .right-sidebar-head.share-media .share-media-blk {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav-tabs {
  margin-bottom: 15px;
  padding: 5px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 10px;
  margin-bottom: 15px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item.active {
  background: #E41F07;
  border-radius: 6px;
  color: #262A2A;
  color: #FFF;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item {
  padding: 2px 10px;
  font-size: 14px;
  color: #262A2A;
  font-weight: 500;
  border: 0;
  margin-right: 10px;
  background: #F9F9FC;
  color: #262A2A;
  border-radius: 6px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item:last-child {
  margin-right: 0px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li {
  margin: 0px 6px 6px 0px;
  position: relative;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li img {
  border-radius: 8px;
  width: 84px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li span i {
  font-size: 20px;
  color: #FFF;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li span {
  position: absolute;
  color: #FFF;
  font-size: 13px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li:hover span i {
  color: #898989;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li.blur-media img {
  filter: blur(2px);
}
.main-chat-blk .media-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 15px;
}
.main-chat-blk .media-file:last-child {
  margin-bottom: 0;
}
.main-chat-blk .media-doc-blk {
  display: flex;
  align-items: center;
}
.main-chat-blk .media-doc-blk span {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 10px;
}
.main-chat-blk .media-doc-blk span i {
  font-size: 24px;
}
.main-chat-blk .document-detail ul {
  padding: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.main-chat-blk .document-detail ul li {
  list-style: none;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  position: relative;
}
.main-chat-blk .document-detail ul li::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 13px;
  background: #C2C2C2;
  right: -8px;
  top: 5px;
}
.main-chat-blk .document-detail ul li:last-child::before {
  display: none;
}
.main-chat-blk .document-detail ul li + li {
  padding-left: 15px;
}
.main-chat-blk .document-detail h6 {
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .media-download a {
  color: #262A2A;
}
.main-chat-blk .social-media-col {
  margin-top: 35px;
}
.main-chat-blk .social-media-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .social-media-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .social-media-col ul li {
  float: left;
}
.main-chat-blk .social-media-col ul li a {
  color: #676DFF;
  font-size: 18px;
}
.main-chat-blk .social-media-col ul li + li {
  margin-left: 10px;
}
.main-chat-blk .social-media-col h6 {
  font-weight: 600;
  color: #000;
  font-size: 15px;
  margin-bottom: 20px;
}
.main-chat-blk .media-link-grp {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.main-chat-blk .media-link-detail h6 a {
  color: #262A2A;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 5px;
}
.main-chat-blk .media-link-detail span a {
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}
.main-chat-blk .media-link-detail a:hover {
  color: #323737;
}
.main-chat-blk .share-media-blk a {
  color: #323737;
  font-weight: 500;
}
.main-chat-blk .link-img {
  flex-shrink: 0;
}
.main-chat-blk .link-img img {
  border-radius: 4px;
  margin-right: 10px;
}
.main-chat-blk .settings-col h6 {
  font-weight: 600;
  color: #000;
  font-size: 15px;
  margin-bottom: 20px;
}
.main-chat-blk .settings-col {
  margin-top: 35px;
}
.main-chat-blk .settings-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .settings-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .settings-col ul li {
  color: #565E5E;
  font-weight: 500;
}
.main-chat-blk .settings-col ul li + li {
  margin-top: 15px;
}
.main-chat-blk .settings-col .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 23px;
  margin-bottom: 0;
  margin-right: 10px;
}
.main-chat-blk .settings-col .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.main-chat-blk .settings-col .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #6F7A7A;
  transition: 0.4s;
}
.main-chat-blk .settings-col .slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 4px;
  background-color: #FFF;
  transition: 0.4s;
}
.main-chat-blk .settings-col input:checked + .slider {
  background-color: #339DFF;
}
.main-chat-blk .settings-col input:checked + .slider:before {
  transform: translateX(16px);
}
.main-chat-blk .settings-col input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
.main-chat-blk .settings-col .slider.round {
  border-radius: 34px;
}
.main-chat-blk .settings-col .slider.round:before {
  border-radius: 50%;
}
.main-chat-blk .report-col {
  margin-top: 35px;
  padding: 12px;
  padding-bottom: 50px;
}
.main-chat-blk .report-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .report-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .report-col ul:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .report-col ul li {
  display: block;
  width: 100%;
  font-weight: 500;
  position: relative;
}
.main-chat-blk .report-col ul li a {
  color: #FC0027;
  padding-left: 25px;
}
.main-chat-blk .report-col ul li a span {
  position: absolute;
  left: 0;
  top: 0px;
  font-size: 16px;
}
.main-chat-blk .report-col ul li + li {
  margin-top: 19px;
}
.main-chat-blk .load-more-btn {
  font-weight: 600;
  margin-top: 10px;
}
.main-chat-blk .load-more-btn i {
  background: #0057FF;
  border-radius: 50%;
  height: 12px;
  width: 12px;
  color: #FFF;
  line-height: 8px;
  font-size: 12px;
  vertical-align: top;
}
.main-chat-blk .chat-message-grp.chat-encrypt {
  padding-bottom: 0;
}
.main-chat-blk .chat-message-grp.chat-encrypt ul {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .participants-list {
  padding: 0px 24px;
}
.main-chat-blk .participants-list .participants-list-group h6.parti-search {
  font-size: 20px !important;
  display: flex;
  align-items: center;
}
.main-chat-blk .participants-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .participants-list ul li {
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  background-color: #FFF;
  padding: 10px;
}
.main-chat-blk .participants-list ul li + li {
  margin-top: 10px;
}
.main-chat-blk .participants-list .users-list-body h5 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #262A2A;
}
.main-chat-blk .participants-list .users-list-body p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0;
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
}
.main-chat-blk .participants-list .users-list-body {
  flex: 1 1;
  position: relative;
  min-width: 0px;
  display: flex;
  display: -webkit-flex;
  width: 100%;
}
.main-chat-blk .participants-list .admin-profiles {
  display: inline-block;
  color: #323737;
  border-radius: 6px;
  font-size: 12px;
  padding: 2px 10px;
  font-weight: 500;
  background: #F8ECFF;
}
.main-chat-blk .participants-list .admin-profiles:hover {
  background: #680A83;
  color: #FFF;
}
.main-chat-blk .participants-list-group {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .participants-list-group h6 {
  margin-bottom: 15px;
  font-size: 15px;
  font-weight: 500;
  color: #262A2A;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .chat-message-grp.group-exits {
  padding: 0px 24px;
  padding-bottom: 30px;
}
.main-chat-blk .grp-delete .chat-action-col {
  display: flex;
  align-items: center;
  height: 100%;
}
.main-chat-blk .grp-delete .chat-action-col > a {
  color: #6F7A7A;
}
.main-chat-blk .chat-action-col > a {
  color: #262A2A;
}
.main-chat-blk .darkmode-btn {
  width: 35px;
  height: 32px;
  background-color: #339DFF;
  border: 1px solid #FBFBFB;
  border-radius: 5px;
  color: #FFF;
  font-size: 16px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin: 0 auto;
}
.main-chat-blk .darkmode-btn:hover {
  color: #FFF;
}
.main-chat-blk .darkmode-btn:focus {
  color: #FFF;
}
.main-chat-blk .add-contacts-btn:hover {
  color: #FFF;
}
.main-chat-blk .add-contacts-btn:focus {
  color: #FFF;
}
.main-chat-blk .add-contacts-btn {
  width: 25px;
  height: 25px;
  border-radius: 30px;
  background-color: #323737;
  color: #FFF;
  font-size: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin: 0 auto;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link {
  color: #323737;
  border: 0;
  border-radius: 10px;
  font-weight: 500;
  padding: 6px 25px;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link:hover {
  color: #323737;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link + .nav-link {
  margin-left: 10px;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link.active {
  background-color: rgba(90, 7, 139, 0.1);
  color: #323737;
}
.main-chat-blk .group-call-tab nav {
  padding: 0 15px 20px;
  position: relative;
}
.main-chat-blk .group-call-tab nav:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #6F6F6F;
  height: 1px;
}
.main-chat-blk .header_image {
  width: 195px;
}
.main-chat-blk .chat_avator_img {
  position: relative;
}
.main-chat-blk .group_img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.main-chat-blk .dreams_chat {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.main-chat-blk .voice_pop {
  padding-right: 17px;
}
.main-chat-blk .status_carousel {
  margin-top: 50px;
}
.main-chat-blk .carousel_img {
  width: 650px;
  height: 434px;
}
.main-chat-blk .video_content {
  min-height: 200px;
  margin-top: 70px;
}
.main-chat-blk .voice-call-content {
  min-height: 200px;
}
.main-chat-blk .chatimage img {
  width: 120px;
  height: 120px;
}
.main-chat-blk .send-btn_status {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #FFF !important;
  background-color: #FFA977 !important;
  margin-left: 15px;
  font-size: 22px;
}
.main-chat-blk .status_telegram {
  color: #FFF;
}
.main-chat-blk .media-lists {
  display: flex;
  justify-content: flex-start;
  margin: 0 -5px 0px;
  flex-wrap: wrap;
}
.main-chat-blk .media-lists .media-image {
  margin: 5px;
  flex-basis: 74px;
  min-width: 74px;
}
.main-chat-blk .media-lists .media-image img {
  max-width: 100%;
}
.main-chat-blk .avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.main-chat-blk .list-group-item {
  background-color: inherit;
  border-color: #ebebeb;
}
.main-chat-blk ul.list-inline .list-inline-item {
  margin-bottom: 0.5rem;
}
.main-chat-blk .form-control {
  border-radius: 5px;
}
.main-chat-blk .form-control:focus {
  box-shadow: none;
  border-color: #e6e6e6;
}
.main-chat-blk .custom-control-label {
  line-height: 25px;
}
.main-chat-blk .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #0a80ff;
}
.main-chat-blk .open_drop {
  color: #FFF !important;
}
.main-chat-blk .send-btn_status:focus {
  box-shadow: none !important;
  border-color: #ffa977 !important;
}
.main-chat-blk .avatar {
  display: inline-block;
  margin-bottom: 0;
  height: 48px;
  width: 48px;
  border-radius: 50%;
}
.main-chat-blk .avatar .avatar-title {
  color: #FFF;
  background: #680A83;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 19px;
  font-weight: 600;
}
.main-chat-blk .avatar > a {
  width: 100%;
  height: 100%;
  display: block;
  transition: color 0.3s;
  color: #0a80ff;
}
.main-chat-blk .avatar > a > img,
.main-chat-blk .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar.avatar-sm {
  height: 1.3rem;
  width: 1.3rem;
}
.main-chat-blk .avatar.avatar-sm .avatar-title {
  font-size: 14px;
}
.main-chat-blk .avatar.avatar-lg {
  height: 3.8rem;
  width: 3.8rem;
}
.main-chat-blk .avatar.avatar-lg .avatar-title {
  font-size: 29px;
}
.main-chat-blk .avatar.avatar-xl {
  height: 100px;
  width: 100px;
}
.main-chat-blk .header_drop_icon {
  border-radius: 6px;
}
.main-chat-blk .accordion-col .accordion-title {
  cursor: pointer;
  padding: 15px 0 8px;
}
.main-chat-blk .accordion-col .accordion-title .primary-title i {
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.main-chat-blk .accordion-col .accordion-title.active .primary-title i {
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
}
.main-chat-blk .accordion-col .accordion-content {
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 15px;
}
.main-chat-blk .accordion-col .accordion-content:last-child {
  border-bottom: 0;
}
.main-chat-blk .accordion-col .accordion-content h6 {
  font-size: 14px;
}
.main-chat-blk .status-right {
  font-weight: 500;
  color: #444444;
  font-size: 16px;
  text-align: center;
}
.main-chat-blk .status-right p {
  margin-top: 20px;
  margin-bottom: 0;
}
.main-chat-blk .star-drop .btn-outline-light {
  color: #424242;
  border: 0;
  padding: 0;
}
.main-chat-blk .star-drop .btn-outline-light i {
  font-size: 20px;
}
.main-chat-blk .star-drop .btn.btn-outline-light:hover {
  background: transparent;
  border: 0;
}
.main-chat-blk .chat.star-chat-group {
  background-image: none;
}
.main-chat-blk .chat.star-chat-group .chat-body {
  background-image: none;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats {
  max-width: 100%;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content {
  background: #F5F5F5;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content.award-link a {
  word-break: break-all;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content.award-link img {
  max-width: 100%;
}
.main-chat-blk .chat .chat-body .messages .chats.forward-chat-msg {
  display: none;
}
.main-chat-blk .chats.forward-chat-msg {
  background: #EDEDED;
  border-radius: 15px;
  padding: 20px;
  border-left: 2px solid #680A83;
}
.main-chat-blk .chats.forward-chat-msg .chat-avatar {
  padding: 0;
  padding-right: 15px;
}
.main-chat-blk .chat-title h4 a {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  color: #4B0973;
  margin-bottom: 0;
}
.main-chat-blk .left-chat-title .add-section > a {
  width: 30px;
  height: 30px;
  background-color: #680A83;
  border-radius: 30px;
  color: #FFF;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  font-size: 13px;
}
.main-chat-blk .add-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .add-section ul li {
  float: left;
  border-radius: 50px;
  width: 28px;
  height: 28px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .add-section ul li + li {
  margin-left: 10px;
}
.main-chat-blk .add-section ul li a {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  font-size: 20px;
}
.main-chat-blk .all-chats .add-section ul li:hover {
  background-color: #F5F5F5;
  border-color: #F5F5F5;
}
.main-chat-blk .online {
  color: #008024;
  font-weight: 500;
}
.main-chat-blk .top-online-contacts {
  padding: 24px 24px 0px;
}
.main-chat-blk .fav-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 15px;
}
.main-chat-blk .fav-title h6 {
  margin-bottom: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.main-chat-blk .fav-title h6 i {
  font-size: 22px;
}
.main-chat-blk .fav-title a {
  margin-bottom: 0;
  color: #E41F07;
  font-weight: 500;
}
.main-chat-blk .fav-title a:hover {
  color: #0A0A0A;
}
.main-chat-blk .top-contacts-box .profile-img {
  position: relative;
  width: 46px;
  height: 46px;
}
.main-chat-blk .top-contacts-box .profile-img img {
  max-width: 100%;
  height: auto;
  border-radius: 50px;
}
.main-chat-blk .profile-name span {
  color: #585858;
  font-size: 12px;
  display: inline-block;
  margin-top: 9px;
}
.main-chat-blk .top-contacts-box .profile-img.online:before {
  content: "";
  position: absolute;
  right: 0;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  top: 0px;
  background-color: #49E073;
  width: 10px;
  height: 10px;
  border: 2px solid #FFF;
  border-radius: 50px;
}
.main-chat-blk .dropdown-menu .dropdown-item span.edit-profile-icon,
.main-chat-blk .dropdown-menu .dropdown-item span.profile-icon-col {
  font-size: 15px;
}
.main-chat-blk .avatar {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
}
.main-chat-blk .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar-title {
  width: 100%;
  height: 100%;
  background-color: #650681;
  color: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .avatar-away::before,
.main-chat-blk .avatar-offline::before,
.main-chat-blk .avatar-online::before {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #FFF;
}
.main-chat-blk .avatar-online::before {
  background-color: #00e65b;
}
.main-chat-blk .avatar-offline::before {
  background-color: #ff0100;
}
.main-chat-blk .avatar-away::before {
  background-color: #ffbc34;
}
.main-chat-blk .avatar .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar .rounded {
  border-radius: 6px !important;
}
.main-chat-blk .avatar .avatar-title {
  font-size: 18px;
}
.main-chat-blk .avatar-xs {
  width: 1.65rem;
  height: 1.65rem;
}
.main-chat-blk .avatar-xs .border {
  border-width: 2px !important;
}
.main-chat-blk .avatar-xs .rounded {
  border-radius: 4px !important;
}
.main-chat-blk .avatar-xs .avatar-title {
  font-size: 10px;
}
.main-chat-blk .avatar-xs.avatar-away::before,
.main-chat-blk .avatar-xs.avatar-offline::before,
.main-chat-blk .avatar-xs.avatar-online::before {
  border-width: 1px;
}
.main-chat-blk .avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}
.main-chat-blk .avatar-sm .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar-sm .rounded {
  border-radius: 4px !important;
}
.main-chat-blk .avatar-sm .avatar-title {
  font-size: 15px;
}
.main-chat-blk .avatar-sm.avatar-away::before,
.main-chat-blk .avatar-sm.avatar-offline::before,
.main-chat-blk .avatar-sm.avatar-online::before {
  border-width: 2px;
}
.main-chat-blk .avatar-lg {
  width: 3.75rem;
  height: 3.75rem;
}
.main-chat-blk .avatar-lg .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar-lg .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-lg .avatar-title {
  font-size: 24px;
}
.main-chat-blk .avatar-lg.avatar-away::before,
.main-chat-blk .avatar-lg.avatar-offline::before,
.main-chat-blk .avatar-lg.avatar-online::before {
  border-width: 3px;
}
.main-chat-blk .avatar-xl {
  width: 5rem;
  height: 5rem;
}
.main-chat-blk .avatar-xl .border {
  border-width: 4px !important;
}
.main-chat-blk .avatar-xl .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-xl .avatar-title {
  font-size: 28px;
}
.main-chat-blk .avatar-xl.avatar-away::before,
.main-chat-blk .avatar-xl.avatar-offline::before,
.main-chat-blk .avatar-xl.avatar-online::before {
  border-width: 4px;
}
.main-chat-blk .avatar-xxl {
  width: 5.125rem;
  height: 5.125rem;
}
.main-chat-blk .avatar-xxl .border {
  border-width: 6px !important;
}
.main-chat-blk .avatar-xxl .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-xxl .avatar-title {
  font-size: 30px;
}
.main-chat-blk .avatar-xxl.avatar-away::before,
.main-chat-blk .avatar-xxl.avatar-offline::before,
.main-chat-blk .avatar-xxl.avatar-online::before {
  border-width: 4px;
}
.main-chat-blk .avatar-group {
  display: flex;
  display: -webkit-flex;
  padding-left: 15px;
  margin-left: auto;
  margin-right: 15px;
  cursor: pointer;
}
.main-chat-blk .avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.main-chat-blk .avatar-group .avatar-xs + .avatar-xs {
  margin-left: -15px;
}
.main-chat-blk .avatar-group .avatar-sm + .avatar-sm {
  margin-left: -0.625rem;
}
.main-chat-blk .avatar-group .avatar-lg + .avatar-lg {
  margin-left: -1rem;
}
.main-chat-blk .avatar-group .avatar-xl + .avatar-xl {
  margin-left: -1.28125rem;
}
.main-chat-blk .avatar-group .avatar:hover {
  z-index: 1;
}
.main-chat-blk .avatar-group.group-col {
  display: block;
}
.main-chat-blk .avatar-group.group-col > div {
  display: flex;
  display: -webkit-flex;
  padding-bottom: 5px;
}
.main-chat-blk .avatar-group.group-col .avatar {
  margin-right: 0;
}
.main-chat-blk .contact-close {
  float: right;
  left: 95%;
  right: 0px;
  position: relative;
  top: 5%;
}
.main-chat-blk .status_contactclose {
  float: right;
  left: 95%;
  right: 0px;
  position: relative;
  top: 1%;
}
.main-chat-blk .status-active {
  border: 4px solid #650681;
}
.main-chat-blk .avatar.avatar-xl .avatar-title {
  font-size: 39px;
}
.main-chat-blk .nav.nav-tabs {
  border: none;
  line-height: 2;
}
.main-chat-blk .badge {
  padding: 5px 10px;
  font-size: 11px;
}
.main-chat-blk .badge.badge-success {
  background: #0abb87;
}
.main-chat-blk .badge.badge-danger {
  background: #fd397a;
}
.main-chat-blk .badge.badge-secondary {
  background: dimgray;
}
.main-chat-blk .badge.badge-info {
  background: #00bcd4;
}
.main-chat-blk .badge.badge-warning {
  background: #ffb822;
}
.main-chat-blk .badge.badge-dark {
  background: #3a3f51;
}
.main-chat-blk .badge.badge-primary {
  background: #0a80ff;
}
.main-chat-blk .badge.badge-light {
  background: #e6e6e6;
}
.main-chat-blk .btn {
  position: relative;
}
.main-chat-blk .btn .badge {
  padding: 2px 6px;
  right: 7px;
  top: -7px;
  position: absolute;
}
.main-chat-blk .input-group .input-group-text {
  font-size: 14px;
}
.main-chat-blk .tooltip > .tooltip-inner {
  text-align: left;
  max-width: 500px;
  --bs-tooltip-bg: \$primary;
}
.main-chat-blk .tooltip {
  --bs-tooltip-bg: \$primary;
}
.main-chat-blk .tooltip .arrow {
  display: none;
  background-color: #E41F07;
}
.main-chat-blk .tooltip .tooltip-inner {
  background-color: #E41F07;
}
.main-chat-blk .sticky-top {
  z-index: auto;
}
.main-chat-blk .tab-content {
  padding-top: 30px;
}
.main-chat-blk .tab-content .form-item {
  margin-bottom: 0.8rem;
}
.main-chat-blk .main-wrapper {
  height: 100vh;
  overflow: hidden;
}
.main-chat-blk .main-wrapper .content {
  display: flex;
  display: -webkit-flex;
}
@media (max-width: 991.98px) {
  .main-chat-blk .main-wrapper .content {
    display: block;
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  z-index: 99;
  width: 340px;
}
@media (max-width: 991.98px) {
  .main-chat-blk .main-wrapper .content .sidebar-group {
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .main-chat-blk .chats .chat-content {
    width: calc(100% - 55px);
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
  background: #FFF;
  overflow: hidden;
  width: 340px !important;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  border-right: 1px solid rgb(224, 224, 224);
}
@media (max-width: 991.98px) {
  .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
    width: 100% !important;
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group .sidebar:not(.active) {
  display: none;
}
.main-chat-blk .header-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  font-weight: 600;
  background-color: #680A83;
}
.main-chat-blk .header-top .logo {
  margin-top: 0 !important;
}
.main-chat-blk .header-top > span {
  font-size: 22px;
}
.main-chat-blk .header-top ul {
  margin-bottom: 0;
  display: flex;
}
.main-chat-blk .header-top ul.header-action {
  margin-top: 14px !important;
}
.main-chat-blk .chat-header ul {
  margin-bottom: 0;
}
.main-chat-blk .chat-header ul li:not(.list-inline-item) {
  margin-bottom: 0;
  width: 48px;
  margin-right: 15px !important;
}
.main-chat-blk .chat-header ul li:last-child {
  margin-right: 0 !important;
}
.main-chat-blk .sidebar-body {
  flex: 1 1;
  overflow: auto;
  padding: 24px 24px 10px;
  width: 100%;
}
.main-chat-blk .pin-chat img {
  margin-right: 6px;
}
.main-chat-blk .sidebar-body .profile-name {
  font-weight: 600;
  color: #0A0A0A;
  font-size: 18px;
  margin-bottom: 0;
}
.main-chat-blk .online-profile {
  position: relative;
}
.main-chat-blk .online-profile span {
  position: relative;
  color: #565656;
  font-size: 13px;
  padding-left: 10px;
}
.main-chat-blk .online-profile span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 7px;
  background-color: #49E073;
  width: 8px;
  height: 8px;
  border-radius: 50px;
}
.main-chat-blk .close_profile4 {
  color: #000;
  border-color: #e6e6e6;
}
.main-chat-blk .sidebar .user-list li a {
  padding: 10px;
  display: flex;
  display: -webkit-flex;
  cursor: pointer;
  margin-bottom: 15px;
  border: 1px solid #E0E0E0;
  box-shadow: none;
  border-radius: 5px;
  position: relative;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.main-chat-blk .sidebar .user-list li a:hover {
  background-color: rgba(254, 159, 67, 0.08);
  border: 1px solid rgba(254, 159, 67, 0.08);
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.main-chat-blk .sidebar .user-list li.item-typing {
  background-color: #F1F6FF;
}
.main-chat-blk .sidebar .user-list li figure {
  margin-right: 1rem;
}
.main-chat-blk .sidebar .user-list li .users-list-body {
  flex: 1 1;
  position: relative;
  min-width: 0px;
  display: flex;
}
.main-chat-blk .lock-icon {
  color: #000000;
}
.main-chat-blk .sidebar .user-list li .users-list-body > div:first-child {
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.main-chat-blk .parti-notify-check {
  margin-bottom: 0 !important;
  display: flex;
  align-items: center;
}
.main-chat-blk .sidebar .user-list li .users-list-body h5 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 3px;
  color: #0A0A0A;
}
.main-chat-blk .sidebar .user-list li .users-list-body p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0;
  color: #232323;
  font-size: 14px;
}
.main-chat-blk .sidebar .user-list li .users-list-body p.missed-call-col {
  color: #DE3E44;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time {
  padding-left: 15px;
  position: relative;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {
  color: #424242 !important;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 5px;
  display: block;
  text-align: right;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .contact-toggle {
  color: #680A83;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .new-message-count {
  width: 20px;
  height: 20px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  line-height: 0;
  font-size: 11px;
  background-color: #E41F07;
  color: #FFF;
  border-radius: 50%;
  margin-left: auto;
  margin-top: 10px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .chat-toggle {
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0;
  text-align: right;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  width: 18px;
  height: 24px;
}
.main-chat-blk .sidebar .user-list li.unread h5 {
  color: #FFF;
}
.main-chat-blk .sidebar .user-list li.unread p {
  color: #FFF;
}
.main-chat-blk .sidebar .user-list li.unread .text-muted {
  color: rgba(255, 255, 255, 0.4) !important;
}
.main-chat-blk .sidebar .user-list li.user-list-item.item-typing .users-list-body p {
  color: #0D9B35;
}
.main-chat-blk .rightside_tab {
  padding-top: 5px !important;
}
.main-chat-blk .chat-pin {
  display: flex;
  align-items: center;
  justify-content: end;
  -webkit-justify-content: end;
  -ms-flex-pack: end;
}
.main-chat-blk .chat-pin .green-check {
  color: #0D9B35;
}
.main-chat-blk .chat-pin img {
  width: 10px;
}
.main-chat-blk .chat-pin .check {
  color: #53BDEB;
}
.main-chat-blk .select-message-box {
  margin-top: 50px;
}
.main-chat-blk .select-message-box h4 {
  margin-bottom: 5px;
}
.main-chat-blk .select-message-box p {
  margin-top: 0;
  margin-bottom: 24px;
  color: #424242;
  font-size: 16px;
  font-weight: 400;
}
.main-chat-blk .select-message-box .btn i {
  font-size: 15px;
}
.main-chat-blk .group-description {
  padding: 0px 24px;
}
.main-chat-blk .group-description .description-sub {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .group-description h5 {
  font-size: 15px;
  font-weight: 500;
  color: #0A0A0A;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .group-description h5 a:hover {
  color: #650681 !important;
}
.main-chat-blk .group-description p {
  color: #424242;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
}
.main-chat-blk .group-description p.description-date {
  color: #424242;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0px;
}
.main-chat-blk .encrypted-message p {
  font-size: 12px;
  color: #424242;
  font-weight: 400;
  margin-bottom: 0;
}
.main-chat-blk .group-view-all {
  margin-top: 10px;
}
.main-chat-blk .group-view-all a {
  color: #680A83;
  font-size: 14px;
  font-weight: 500;
}
.main-chat-blk .group-view-all a:hover {
  color: #0A0A0A;
}
.main-chat-blk .exit-bg-message {
  background: #FFE8E9;
}
.main-chat-blk .exit-bg-message i {
  color: #DE3E44;
}
.main-chat-blk .disapper-message {
  background: #E7FAF2;
}
.main-chat-blk .disapper-message i {
  color: #1BA345;
}
.main-chat-blk .group-setting-msg {
  background: #F8ECFF;
}
.main-chat-blk .group-setting-msg i {
  color: #680A83;
}
.main-chat-blk .group-setting .stared-group span {
  width: 50px;
  height: 50px;
}
.main-chat-blk .edit-set-details p {
  font-size: 14px;
  font-weight: 400;
  color: #424242;
  margin-bottom: 0;
}
.main-chat-blk .group-send-msg {
  background: #FEF6DC;
}
.main-chat-blk .parcipant-check p a {
  color: #680A83;
}
.main-chat-blk .select-group-chat .dropdown-toggle::after {
  display: none;
}
.main-chat-blk .select-group-chat .dropdown-toggle i {
  margin-left: 15px;
}
.main-chat-blk .select-group-chat .dropdown-toggle:hover {
  color: #0A0A0A;
}
.main-chat-blk .select-group-chat .dropdown-toggle {
  font-weight: 600;
  color: #0A0A0A;
  font-size: 18px;
}
.main-chat-blk .select-group-chat .dropdown-menu .dropdown-item {
  font-size: 14px;
  font-weight: 400;
  color: #0A0A0A;
}
.main-chat-blk .select-group-chat .dropdown-menu li:first-child .dropdown-item:hover {
  border-radius: 5px 5px 0 0;
}
.main-chat-blk .select-group-chat .dropdown-menu li:last-child .dropdown-item:hover {
  border-radius: 0 0 5px 5px;
}
.main-chat-blk .dropzone {
  background: #FFF;
  border: 1px dashed #C2C2C2;
  border-radius: 5px;
  padding: 10px;
  min-height: 70px;
  text-align: center;
}
.main-chat-blk .dropzone.dz-clickable .dz-message {
  display: none;
}
.main-chat-blk .dropzone p {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #0A0A0A;
}
.main-chat-blk .dropzone span {
  color: #424242;
  font-size: 14px;
  font-weight: 400;
}
.main-chat-blk .uplaod-image img {
  border-radius: 20px;
}
.main-chat-blk .upload-img-file .modal-body {
  padding: 0;
}
.main-chat-blk .upload-img-file .modal-content {
  position: relative;
}
.main-chat-blk .upload-img-file .modal-header {
  position: absolute;
  top: 0;
  z-index: 9;
  left: 0;
  right: 0;
}
.main-chat-blk .upload-image-list {
  display: flex;
  align-items: center;
}
.main-chat-blk .upload-image-list li + li {
  margin-left: 10px;
}
.main-chat-blk .upload-img-file .modal-header .close {
  background-color: transparent;
  color: #FFF;
}
.main-chat-blk .check-star i {
  color: #FEC001;
}
.main-chat-blk .emoj-group-list {
  display: none;
  position: absolute;
  top: -50px;
  left: -90px;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group-list ul {
  display: flex;
  align-items: center;
  background: #f6f7f8;
  border-radius: 50px;
  padding: 5px;
}
.main-chat-blk .emoj-group-list ul li a {
  padding: 0;
}
.main-chat-blk .emoj-group-list ul li.add-emoj a {
  background: #EDEDED;
}
.main-chat-blk .emoj-group-list ul li.add-emoj a i {
  font-size: 20px;
  color: #424242;
}
.main-chat-blk .chat .slimscroll {
  height: calc(100vh - 60px) !important;
}
.main-chat-blk .settings-option {
  display: none;
  text-align: right;
}
.main-chat-blk .settings-option a {
  font-size: 15px;
  font-weight: 500;
  color: #680A83;
}
.main-chat-blk .empty-dark-img {
  display: none;
}
.main-chat-blk .bootstrap-datetimepicker-widget span {
  position: relative;
}

.chat-window .card .card-header {
  background-color: #FFF;
  border-bottom: 1px solid #898989;
}
.chat-window .badge-success {
  background-color: #5CB85C !important;
}

.chat-page .footer {
  display: none;
}

.chat-search .input-group .form-control {
  margin: 0;
  padding: 0 0 0 36px;
  height: 46px;
}
.chat-search .input-group .input-group-prepend {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #424848;
  pointer-events: none;
  z-index: 4;
  position: absolute;
  top: 0;
  right: 15px;
  bottom: 0;
}

.chat-cont-left .chat-scroll {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  padding: 0;
}
.chat-cont-left .chat-scroll .media {
  border-bottom: 1px solid #898989;
  margin: 0;
  padding: 10px;
  transition: all 0.2s;
}
.chat-cont-left .chat-scroll .media.active {
  background-color: #C0C0C0;
}
.chat-cont-left .chat-scroll .media:hover {
  background-color: #C0C0C0;
}
.chat-cont-left .chat-scroll .media .media-img-wrap {
  margin: 0 15px 0 0;
  position: relative;
}
.chat-cont-left .chat-scroll .media .media-img-wrap .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.chat-cont-left .chat-scroll .media .media-body {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.chat-cont-left .chat-scroll .media .media-body .user-name {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #262A2A;
  font-size: 16px;
  font-weight: 700;
}
.chat-cont-left .chat-scroll .media .media-body .user-last-chat {
  color: #323737;
  font-size: 14px;
  line-height: 24px;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-cont-left .chat-scroll .media .media-body .last-chat-time {
  color: #565E5E;
  font-size: 13px;
}
.chat-cont-left .chat-scroll .media .media-body div:last-child {
  text-align: right;
}

.chat-cont-right {
  transition: all 0.4s;
}
.chat-cont-right .chat-scroll {
  max-height: calc(100vh - 293px);
  overflow-y: auto;
}
.chat-cont-right .msg_head .back-user-list {
  display: none;
  margin: 0 0 0 -10px;
  padding: 0 10px;
}
.chat-cont-right .img_cont {
  position: relative;
  height: 45px;
  width: 45px;
}
.chat-cont-right .img_cont .user_img {
  height: 45px;
  min-width: 45px;
  width: 45px;
  border: 1.5px solid #E41F07;
}
.chat-cont-right .user_info {
  margin: 0 auto 0 15px;
  padding: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-cont-right ul.list-unstyled {
  margin: 0 auto;
  padding: 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent {
  margin-bottom: 20px;
}
.chat-cont-right ul.list-unstyled .media.sent .avatar {
  order: 3;
  height: 30px;
  width: 30px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin: 0 20px 0 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box {
  margin: 0;
  padding: 0 0 0 50px;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box + .msg-box {
  margin: 5px 0 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box p {
  margin: 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box:first-child::before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #e3e3e3;
  border-top: 6px solid #e3e3e3;
  border-right: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 0;
  right: -12px;
  left: auto;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box > div {
  margin: 0;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: #e3e3e3;
  display: inline-block;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box:first-child > div {
  border-radius: 10px 0 10px 10px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments {
  display: flex;
  margin: 0 -1px;
  padding: 4px 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  content: "";
  opacity: 0.4;
  transition: all 0.4s;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment:hover .chat-attach-download {
  opacity: 1;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments > div {
  margin: 0 1px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments img {
  max-width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attach-download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.4s;
  color: #FFF;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin: 5px 0 0;
  padding: 0;
  flex-wrap: wrap;
  clear: both;
  flex-direction: row-reverse;
  list-style: none;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info li {
  margin: 0;
  padding: 0 0 0 16px;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info li:not(:last-child)::after {
  position: absolute;
  top: 50%;
  right: auto;
  left: 8px;
  transform: translate(-50%, -50%);
  background: #E41F07;
  content: "";
  height: 4px;
  width: 4px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info .chat-time {
  color: rgba(50, 65, 72, 0.4);
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info a {
  color: #323737;
}
.chat-cont-right ul.list-unstyled .media.received {
  position: relative;
  margin-bottom: 20px;
}
.chat-cont-right ul.list-unstyled .media.received .media-body {
  position: relative;
  margin: 0 0 0 20px;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.received .media-body::before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #E41F07;
  border-top: 6px solid #E41F07;
  border-left: 6px solid transparent;
  content: "";
  height: 0;
  position: absolute;
  top: 0px;
  right: auto;
  left: -6px;
  width: 0;
}
.chat-cont-right ul.list-unstyled .media.received .media-body > div {
  margin: 0;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: #E41F07;
  display: table;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.received .media-body > div p {
  color: #FFF;
  margin: 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.received .msg-box {
  display: block;
}
.chat-cont-right ul.list-unstyled .media.received .msg-box + .msg-box {
  margin-top: 5px;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
  margin: 5px 0 0;
  padding: 0;
  clear: both;
  list-style: none;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-info .chat-time {
  color: rgba(255, 255, 255, 0.8);
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments {
  display: flex;
  margin: 0 -1px;
  padding: 4px 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000;
  content: "";
  opacity: 0.4;
  transition: all 0.4s;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment:hover .chat-attach-download {
  opacity: 1;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments > div {
  margin: 0 1px;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments img {
  max-width: 100%;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attach-download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transition: all 0.4s;
  opacity: 0;
  color: #FFF;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
}
.chat-cont-right ul.list-unstyled .chat-date {
  font-size: 14px;
  margin: 1.875rem 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  text-transform: capitalize;
}
.chat-cont-right ul.list-unstyled .chat-date:before {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  margin-right: 28px;
  position: absolute;
  top: 50%;
  right: 50%;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .chat-date:after {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  margin: 0 0 0 28px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
}

.card-footer {
  background-color: #FFF;
  border-top: 1px solid #898989;
  margin: 0;
  padding: 1rem 1.5rem;
}
.card-footer .type_msg {
  background-color: rgba(0, 0, 0, 0.1) !important;
  border: 0 !important;
  overflow-y: auto;
}

@media (max-width: 992px) {
  .chat-window.chat-slide .chat-cont-right {
    right: 0;
    opacity: 1;
    visibility: visible;
  }
  .chat-cont-right {
    position: absolute;
    right: -100px;
    opacity: 0;
    visibility: hidden;
    z-index: 99;
  }
  .chat-cont-right .msg_head .back-user-list {
    display: flex;
    align-items: center;
  }
}
.page-header .breadcrumb {
  margin-bottom: 0;
}
.page-header h3 {
  font-weight: 700;
  color: #262A2A;
  font-size: 18px;
}
@media (max-width: 991.98px) {
  .page-header h3 {
    font-size: 14px;
  }
}
.page-header h4 {
  font-weight: 700;
  color: #262A2A;
  font-size: 18px;
  margin-bottom: 5px;
}
@media (max-width: 991.98px) {
  .page-header h4 {
    font-size: 18px;
  }
}
.page-header h6 {
  font-size: 14px;
  color: #424848;
  font-weight: 400;
}
@media (max-width: 991.98px) {
  .page-header h6 {
    font-size: 12px;
  }
}
@media (max-width: 575.98px) {
  .page-header h6 {
    font-size: 12px;
    margin-bottom: 20px;
  }
}
.page-header .btn-filter {
  background: #E41F07;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 0;
}
.page-header .btn-filter:hover {
  background: linear-gradient(46.62deg, #E41F07 0%, #676DFF 93.64%);
}
.page-header .page-btn {
  margin-left: 10px;
}
@media (max-width: 575.98px) {
  .page-header .page-btn {
    margin-left: 0;
    margin-top: 20px;
  }
}
.page-header .btn-added {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #E41F07;
  padding: 8px 11px;
  color: #FFF;
  font-weight: 700;
  font-size: 14px;
  height: 40px;
  border-radius: 5px;
}
.page-header .btn-added:active {
  color: #FFF;
}
.page-header .btn-added img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added {
    padding: 10px 10px;
  }
}
.page-header .btn-added:hover {
  background: #262A2A;
}
.page-header .btn-added .me-2 {
  width: 16px;
  height: 16px;
}
.page-header .btn-added.downloader {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #262A2A;
  padding: 9px 11px;
  color: #FFF;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
  margin: 0 15px 0 15px;
}
.page-header .btn-added.downloader img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added.downloader {
    padding: 10px 10px;
  }
}
.page-header .btn-added.downloader:hover {
  background: #E41F07;
}
.page-header .btn-added.downloader .me-2 {
  width: 16px;
  height: 16px;
}
.page-header .btn-added.printer {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #FC0027;
  padding: 9px 11px;
  color: #FFF;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
}
.page-header .btn-added.printer img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added.printer {
    padding: 10px 10px;
  }
}
.page-header .btn-added.printer:hover {
  background: #262A2A;
}
.page-header .btn-added.printer .me-2 {
  width: 16px;
  height: 16px;
}
@media (max-width: 767.98px) {
  .page-header .add-item {
    display: block !important;
  }
  .page-header .add-item .page-btn {
    margin-left: 0;
  }
}
@media (max-width: 575.98px) {
  .page-header .add-item .page-btn {
    margin-left: 0;
    margin-bottom: 24px;
  }
}
.page-header .add-item .page-title.modal-datail {
  line-height: 2;
}
.page-header .add-item.d-flex {
  margin-right: auto;
}
.page-header .add-item.payslip-list {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
}

.page-wrapper.details-blk {
  padding: 0;
  margin: 0;
}

.history-modal-profile .content {
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile {
  background: #F9F9FC;
  border-radius: 8px;
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a {
  background: #E41F07;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #FFF !important;
}
.history-modal-profile .right-sidebar-profile .avatar {
  margin-bottom: 24px;
  width: 150px;
  height: 150px;
}
.history-modal-profile .right-sidebar-profile .avatar img {
  border-radius: 8px;
}

.msg-typing {
  width: auto;
  height: 24px;
  padding-top: 8px;
}
.msg-typing span {
  height: 8px;
  width: 8px;
  float: left;
  background-color: #FFF;
  display: block;
  opacity: 0.4;
  margin: 0 1px;
  border-radius: 50%;
}
.msg-typing span:nth-of-type(1) {
  animation: 1s blink infinite 0.33333s;
}
.msg-typing span:nth-of-type(2) {
  animation: 1s blink infinite 0.66666s;
}
.msg-typing span :nth-of-type(3) {
  animation: 1s blink infinite 0.99999s;
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}
.phone-call-icon svg {
  width: 18px;
}
.phone-call-icon .income-success {
  color: #5CB85C;
}
.phone-call-icon .income-success-missed {
  color: #FC0027;
}

.history-modal-profile .content {
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile {
  background: #F9F9FC;
  border-radius: 8px;
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a {
  background: #E41F07;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  color: #FFF !important;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #FFF !important;
}
.history-modal-profile .right-sidebar-profile .avatar {
  margin-bottom: 24px;
  width: 150px;
  height: 150px;
}
.history-modal-profile .right-sidebar-profile .avatar img {
  border-radius: 8px;
}

.modal-profile-detail .modal-userlist li {
  font-size: 14px;
  color: #000;
  margin-bottom: 10px;
}
.modal-profile-detail .modal-userlist li span {
  display: block;
  color: #6F6F6F;
}
.modal-profile-detail .modal-userlist li:last-child {
  margin-bottom: 0;
}

@media (max-width: 991.98px) {
  .chat_sidebar.hide-left-sidebar {
    display: none !important;
  }
}

@media (max-width: 991.98px) {
  .left-sidebar.hide-left-sidebar {
    margin-left: -991px;
  }
}

.img-cropper .dropup .dropdown-toggle::after {
  content: "";
  display: none;
}

.dropdown-auto {
  overflow: auto;
}

.dropdown-divider {
  margin: 0;
}

.dropdown .dropdown-toggle:after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}
.dropdown .dropdown-toggle.btn-primary {
  color: #FFF;
}
.dropdown .dropdown-menu {
  font-family: "Noto Sans", sans-serif;
}

.dropdown > a {
  color: #262A2A;
  border: 1px solid #E8E8E8;
  padding: 9px 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

.dropdown-menu {
  border-color: #E8E8E8;
  box-shadow: 0 1rem 1.125rem rgba(169, 169, 169, 0.15);
  font-size: 0.875rem;
  color: #6F6F6F;
  background-color: #FFF;
  padding: 0;
  z-index: 10;
}

.dropdown-divider {
  border-color: #E8E8E8;
}

.dropdown-item-text {
  color: #6F6F6F;
}

.dropdown-header {
  color: #6F6F6F;
}

.dropdown-item {
  color: #6F6F6F;
  white-space: unset;
  padding: 0.5rem 0.9375rem;
  font-size: 0.8125rem;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #6F6F6F;
  opacity: 0.5;
}
.dropdown-item:not(.active):hover, .dropdown-item:not(.active):focus, .dropdown-item:not(.active):active {
  color: #E41F07;
  background-color: rgba(228, 31, 7, 0.05);
}
.dropdown-item.active {
  background-color: #E41F07 !important;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f077";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f053";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.btn.dropdown-toggle-split {
  opacity: 0.85;
}

.dropdown-menu-dark {
  background-color: #171724;
  border-color: rgba(255, 255, 255, 0.1);
}
.dropdown-menu-dark li a {
  color: #FFF;
}

.btn-list a.dropdown-item {
  margin-block-end: 0;
}
.btn-list .btn-soft-success:hover {
  transform: translateY(0);
}
.btn-list .btn-soft-danger:hover {
  transform: translateY(0);
}
.dropdown-menu.dropdown-menu-primary {
  background-color: #E41F07;
}
.dropdown-menu.dropdown-menu-primary li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-primary .dropdown-item:hover, .dropdown-menu.dropdown-menu-primary .dropdown-item:focus, .dropdown-menu.dropdown-menu-primary .dropdown-item:active, .dropdown-menu.dropdown-menu-primary .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-secondary {
  background-color: #FFA201;
}
.dropdown-menu.dropdown-menu-secondary li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-secondary .dropdown-item:hover, .dropdown-menu.dropdown-menu-secondary .dropdown-item:focus, .dropdown-menu.dropdown-menu-secondary .dropdown-item:active, .dropdown-menu.dropdown-menu-secondary .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-warning {
  background-color: #FDA700;
}
.dropdown-menu.dropdown-menu-warning li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-warning .dropdown-item:hover, .dropdown-menu.dropdown-menu-warning .dropdown-item:focus, .dropdown-menu.dropdown-menu-warning .dropdown-item:active, .dropdown-menu.dropdown-menu-warning .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-info {
  background-color: #1ECBE2;
}
.dropdown-menu.dropdown-menu-info li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-info .dropdown-item:hover, .dropdown-menu.dropdown-menu-info .dropdown-item:focus, .dropdown-menu.dropdown-menu-info .dropdown-item:active, .dropdown-menu.dropdown-menu-info .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-success {
  background-color: #5CB85C;
}
.dropdown-menu.dropdown-menu-success li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-success .dropdown-item:hover, .dropdown-menu.dropdown-menu-success .dropdown-item:focus, .dropdown-menu.dropdown-menu-success .dropdown-item:active, .dropdown-menu.dropdown-menu-success .dropdown-item.active {
  color: #FFF;
}
.dropdown-menu.dropdown-menu-danger {
  background-color: #FC0027;
}
.dropdown-menu.dropdown-menu-danger li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-danger .dropdown-item:hover, .dropdown-menu.dropdown-menu-danger .dropdown-item:focus, .dropdown-menu.dropdown-menu-danger .dropdown-item:active, .dropdown-menu.dropdown-menu-danger .dropdown-item.active {
  color: #FFF;
}

.dropdown-menu.dropmenu-item-primary .dropdown-item:hover, .dropdown-menu.dropmenu-item-primary .dropdown-item:focus, .dropdown-menu.dropmenu-item-primary .dropdown-item:active, .dropdown-menu.dropmenu-item-primary .dropdown-item.active {
  background-color: rgba(228, 31, 7, 0.1) !important;
  color: #E41F07;
}
.dropdown-menu.dropmenu-item-secondary .dropdown-item:hover, .dropdown-menu.dropmenu-item-secondary .dropdown-item:focus, .dropdown-menu.dropmenu-item-secondary .dropdown-item:active, .dropdown-menu.dropmenu-item-secondary .dropdown-item.active {
  background-color: rgba(255, 162, 1, 0.1) !important;
  color: #FFA201;
}
.dropdown-menu.dropmenu-item-warning .dropdown-item:hover, .dropdown-menu.dropmenu-item-warning .dropdown-item:focus, .dropdown-menu.dropmenu-item-warning .dropdown-item:active, .dropdown-menu.dropmenu-item-warning .dropdown-item.active {
  background-color: rgba(253, 167, 0, 0.1) !important;
  color: #FDA700;
}
.dropdown-menu.dropmenu-item-info .dropdown-item:hover, .dropdown-menu.dropmenu-item-info .dropdown-item:focus, .dropdown-menu.dropmenu-item-info .dropdown-item:active, .dropdown-menu.dropmenu-item-info .dropdown-item.active {
  background-color: rgba(30, 203, 226, 0.1) !important;
  color: #1ECBE2;
}
.dropdown-menu.dropmenu-item-success .dropdown-item:hover, .dropdown-menu.dropmenu-item-success .dropdown-item:focus, .dropdown-menu.dropmenu-item-success .dropdown-item:active, .dropdown-menu.dropmenu-item-success .dropdown-item.active {
  background-color: rgba(var(--success-rgb), 0.1) !important;
  color: #5CB85C;
}
.dropdown-menu.dropmenu-item-danger .dropdown-item:hover, .dropdown-menu.dropmenu-item-danger .dropdown-item:focus, .dropdown-menu.dropmenu-item-danger .dropdown-item:active, .dropdown-menu.dropmenu-item-danger .dropdown-item.active {
  background-color: rgba(var(--danger-rgb), 0.1) !important;
  color: #FC0027;
}

.dropdown-menu.dropmenu-light-primary {
  background-color: rgba(var(#FFA201), 0.1);
  backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-primary .dropdown-item:hover, .dropdown-menu.dropmenu-light-primary .dropdown-item:focus, .dropdown-menu.dropmenu-light-primary .dropdown-item:active, .dropdown-menu.dropmenu-light-primary .dropdown-item.active {
  color: #FFF;
  background-color: #E41F07 !important;
}
.dropdown-menu.dropmenu-light-secondary {
  background-color: rgba(var(#FFA201), 0.1);
  backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-secondary .dropdown-item:hover, .dropdown-menu.dropmenu-light-secondary .dropdown-item:focus, .dropdown-menu.dropmenu-light-secondary .dropdown-item:active, .dropdown-menu.dropmenu-light-secondary .dropdown-item.active {
  color: #FFF;
  background-color: #FFA201 !important;
}
.dropdown-menu.dropmenu-light-info {
  background-color: rgba(30, 203, 226, 0.1);
  backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-info .dropdown-item:hover, .dropdown-menu.dropmenu-light-info .dropdown-item:focus, .dropdown-menu.dropmenu-light-info .dropdown-item:active, .dropdown-menu.dropmenu-light-info .dropdown-item.active {
  color: #FFF;
  background-color: #1ECBE2 !important;
}
.dropdown-menu.dropmenu-light-warning {
  background-color: rgba(253, 167, 0, 0.1);
  backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-warning .dropdown-item:hover, .dropdown-menu.dropmenu-light-warning .dropdown-item:focus, .dropdown-menu.dropmenu-light-warning .dropdown-item:active, .dropdown-menu.dropmenu-light-warning .dropdown-item.active {
  color: #FFF;
  background-color: #FDA700 !important;
}
.dropdown-menu.dropmenu-light-success {
  background-color: rgba(92, 184, 92, 0.1);
  backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-success .dropdown-item:hover, .dropdown-menu.dropmenu-light-success .dropdown-item:focus, .dropdown-menu.dropmenu-light-success .dropdown-item:active, .dropdown-menu.dropmenu-light-success .dropdown-item.active {
  color: #FFF;
  background-color: #5CB85C !important;
}
.dropdown-menu.dropmenu-light-danger {
  background-color: rgba(var(--danger-rgb), 0.1);
  backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-danger .dropdown-item:hover, .dropdown-menu.dropmenu-light-danger .dropdown-item:focus, .dropdown-menu.dropmenu-light-danger .dropdown-item:active, .dropdown-menu.dropmenu-light-danger .dropdown-item.active {
  color: #FFF;
  background-color: #FC0027 !important;
}

.dropdown-divider {
  margin: 0;
}

.bd-example > .dropdown-menu {
  position: static;
  display: block;
}

.dropdown-md {
  min-width: 315px;
}

.table-action .action-icon {
  width: 33px;
  height: 33px;
  background: #F6F6F6;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #262A2A;
}
.table-action .action-icon:hover {
  color: #262A2A;
}
.table-action .action-icon:hover i {
  color: #262A2A;
}
.table-action .dropdown-toggle::after {
  display: none;
}
.table-action .dropdown-menu a {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  color: #262A2A;
  white-space: nowrap;
}
.table-action .dropdown-menu a i {
  margin-right: 8px;
}
.table-action .dropdown-menu a:hover {
  background: #F6F6F6;
  color: #262A2A;
}

.daterangepicker {
  font-family: "Noto Sans", sans-serif;
}
.daterangepicker .calendar-table th {
  color: #262A2A;
}
.daterangepicker .calendar-table td {
  color: #262A2A;
}

.daterangepicker td.active, .daterangepicker td.active:hover {
  background-color: #FC0027;
  color: #FFEEEC;
}

.daterangepicker .ranges li.active {
  background-color: #00918E;
}

.sort-dropdown.drop-down .dropdown-menu li a {
  white-space: nowrap;
}

.drop-down {
  position: relative;
}
.drop-down > a {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  background: #FFF;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 9px 15px;
}
.drop-down > a i {
  margin-right: 8px;
}
.drop-down > a:hover {
  color: #262A2A;
}
.drop-down > a.show {
  border: 1px solid #0092E4;
}
.drop-down > a::after {
  font-size: 14px;
  margin-left: 8px;
}
.drop-down > a[aria-expanded=true]::after {
  transition: all 0.2s ease;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}
.drop-down .dropdown-menu li a {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
}
.drop-down .dropdown-menu li a i {
  margin-right: 8px;
}
.drop-down .dropdown-menu li a:hover {
  background: #F6F6F6;
  color: #262A2A;
}

.dropdown-menu {
  border: 1px solid #E8E8E8;
  padding: 15px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}

.inbox-menu {
  display: inline-block;
  width: 100%;
  margin: 0 0 20px;
  padding: 0;
}
.inbox-menu li {
  display: inline-block;
  width: 100%;
}
.inbox-menu li a {
  color: #333;
  display: inline-block;
  padding: 10px 15px;
  width: 100%;
  font-weight: 600;
  text-transform: capitalize;
  transition: 0.3s ease;
}
.inbox-menu li a:hover {
  background: rgba(33, 33, 33, 0.05);
}
.inbox-menu li a i {
  font-size: 16px;
  padding-right: 10px;
  color: #878787;
}

.compose-btn {
  margin-bottom: 25px;
}

.top-action-left .btn-group {
  margin-bottom: 5px;
}
.top-action-left .dropdown-toggle {
  height: 40px;
}
.top-action-left .dropdown-toggle::after {
  display: none;
}

.table-inbox .starred.fas.fa-star {
  color: #FDA700;
}
.table-inbox .checked {
  background-color: #898989;
}
.table-inbox th {
  border-color: #F2ECFF;
}
.table-inbox tbody tr td {
  font-size: 14px;
  color: #FFA201;
  border-color: #E8E8E8;
}

.unread .name,
.unread .subject,
.unread .mail-date {
  color: #000;
  font-weight: 700;
}

.email-header .btn-white {
  min-width: auto;
  height: 38px;
  border: 1px solid #E8E8E8;
}
.email-header .btn-white i {
  margin-left: 5px;
}

.file-manager {
  color: #6F6F6F;
}
.file-manager .search-dropdown {
  height: auto;
}
.file-manager .form-sort {
  width: auto;
}
.file-manager .form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-right: 27px;
}
.file-manager .form-sort.owned-by {
  margin-right: 10px;
}
.file-manager.notes-page-wrapper .content .page-add-notes {
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap {
  margin-top: 0;
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap .form-sort svg.fa-filter {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk {
  margin-right: 15px;
}
.file-manager .page-header .btn-added {
  margin-left: 10px;
}
@media (max-width: 575.98px) {
  .file-manager .page-header .form-sort {
    margin-top: 0;
    margin-bottom: 15px;
  }
}
@media (max-width: 575.98px) {
  .file-manager .page-header .table-top-head {
    margin-bottom: 15px;
  }
}
@media (max-width: 991.98px) {
  .file-manager .page-header .table-top-head li:last-child {
    margin-right: 0;
  }
}
@media (max-width: 767.98px) {
  .file-manager .bulk-action-type {
    align-items: start !important;
  }
}
@media (max-width: 575.98px) {
  .file-manager .bulk-action-type {
    display: block !important;
  }
}
@media (max-width: 767.98px) {
  .file-manager .bulk-action-type .form-sort {
    margin-top: 0;
    margin-bottom: 15px;
    width: 100%;
  }
}
.file-manager aside {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border-radius: 8px;
}
.file-manager aside h5 {
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #C0C0C0;
  margin: 0 0 15px 0;
  padding: 0 0 15px 0;
}
.file-manager aside .btn {
  font-weight: 700;
}
.file-manager aside .dropdown > a {
  width: auto;
  height: 40px;
  color: #FFF;
  border-radius: 5px;
}
.file-manager aside .dropdown > a:hover, .file-manager aside .dropdown > a:focus {
  border-color: #6F6F6F;
  background: #6F6F6F;
}
.file-manager aside .dropdown ul {
  width: 100%;
}
.file-manager aside .dropdown ul li a {
  font-size: 15px;
}
.file-manager aside ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 5px 0;
  padding: 7px 10px;
  border-radius: 5px;
  height: 40px;
}
.file-manager aside ul li a span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  width: auto;
}
.file-manager aside ul li a:hover, .file-manager aside ul li a.active {
  background: #6F6F6F;
  color: #FFF;
}
.file-manager aside span {
  font-size: 13px;
  font-weight: 500;
  width: auto;
  height: auto;
}
.file-manager aside h6 {
  font-size: 16px;
  font-weight: 600;
  position: relative;
  z-index: 2;
}
.file-manager aside .space-manager {
  color: #FFF;
  background: #6F6F6F;
  border-radius: 8px;
  position: relative;
}
.file-manager aside .space-manager img {
  position: absolute;
  top: 0;
  right: 0;
}
.file-manager aside .space-manager h6 a {
  color: #FFF;
}
.file-manager aside .space-manager p {
  color: #B8BCC9;
}
.file-manager .progress {
  height: 6px;
  border-radius: 5px;
}
.file-manager .search-set .search-input input[type=search] {
  width: 170px;
  height: 40px;
}
.file-manager .budgeted-role-notes .search-set .search-input input[type=search] {
  width: 298px;
}
.file-manager h4 {
  font-size: 18px;
  font-weight: 600;
}
.file-manager h6 {
  font-size: 16px;
  font-weight: 600;
}
.file-manager h6 a {
  color: #6F6F6F;
}
.file-manager h6 a:hover {
  color: #E41F07;
}
.file-manager .overview .detail a.bg {
  border-radius: 8px 8px 0 0;
}
.file-manager .overview .detail a.bg span {
  width: 66px;
  height: 66px;
  border-radius: 100%;
}
.file-manager .overview .detail a.bg span img {
  transition: all 0.5s ease;
}
.file-manager .overview .detail a:hover img {
  transform: scale(1.2);
}
.file-manager .info {
  border-radius: 0 0 8px 8px;
  padding: 15px;
  background: #FFF;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
}
.file-manager .info span {
  color: #6F6F6F;
  font-size: 13px;
}
.file-manager .folders {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border-radius: 8px;
  background: #FFF;
}
.file-manager .folders h6 {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 8px;
}
.file-manager .dropdown > a {
  color: #6F6F6F;
  width: 25px;
  height: 25px;
  transition: all 0.5s ease;
  border-radius: 100%;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.file-manager .dropdown > a:hover {
  background: #E41F07;
}
.file-manager .dropdown > a:hover i {
  color: #FFF;
}
.file-manager .project-plan {
  font-size: 13px;
  font-weight: 600;
  margin-top: 10px;
}
.file-manager .project-plan label {
  color: #6F6F6F;
  margin-right: 9px;
  font-size: 13px;
}
.file-manager .project-plan ul li {
  font-size: 13px;
  position: relative;
  padding: 0 9px 0 14px;
  color: #6F6F6F;
}
.file-manager .project-plan ul li:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  width: 5px;
  height: 5px;
  background: #6F6F6F;
  border-radius: 5px;
}
.file-manager .avatar-wrap a svg {
  color: #6F6F6F;
  width: 18px;
}
.file-manager .avatar-wrap a:hover svg {
  color: #E41F07;
}
.file-manager .accordion {
  border: none;
  --bs-accordion-border-width: none;
}
.file-manager .accordion .accordion-item {
  border: none;
  border-bottom: 1px solid #E8E8E8;
  background: none;
}
.file-manager .accordion .accordion-item:last-of-type {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: none;
}
.file-manager .accordion .accordion-item .accordion-button {
  background: none;
  border: none;
  font-size: 18px;
  font-weight: 600;
  color: #6F6F6F;
  padding: 0;
  display: inline-block;
  width: auto;
}
.file-manager .accordion .accordion-item .accordion-button:after {
  transition: all 0.8s ease;
  background-image: none;
  content: "View All";
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #6F6F6F;
  transform: none;
  width: 60px;
  text-align: right;
}
.file-manager .accordion .accordion-item .accordion-button:not(.collapsed)::after {
  content: "Hide";
}
.file-manager .accordion .accordion-item .accordion-button.collapsed {
  padding: 0;
}
.file-manager .accordion .accordion-item .accordion-button:hover:after {
  color: #E41F07;
}
.file-manager .accordion .accordion-item .accordion-body {
  border: none;
  padding: 0;
}
.file-manager .accordion .accordion-item .accordion-body .head img {
  min-width: 32px;
  width: 32px;
  height: 32px;
}
.file-manager .accordion .accordion-item .accordion-body .owl-carousel {
  padding-top: 15px;
}
.file-manager .owl-carousel .owl-item {
  margin-left: -0.1px !important;
}
.file-manager .owl-carousel .dropdown-menu {
  left: auto !important;
  right: 0 !important;
  top: 27px !important;
  transform: none !important;
  background: #FFF !important;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  z-index: 99999 !important;
}
.file-manager .owl-carousel .owl-nav {
  top: -20px;
  left: 43px;
  display: inline-table;
}
.file-manager .owl-carousel .owl-nav button {
  margin-top: 0;
  margin-bottom: 0;
  background: none;
  cursor: pointer;
}
.file-manager .owl-carousel .owl-nav button.owl-next, .file-manager .owl-carousel .owl-nav button.owl-prev {
  position: relative;
  width: 15px;
}
.file-manager .owl-carousel .owl-nav button.owl-next i, .file-manager .owl-carousel .owl-nav button.owl-prev i {
  color: #6F6F6F;
}
.file-manager .owl-carousel .owl-nav button.owl-next:hover, .file-manager .owl-carousel .owl-nav button.owl-prev:hover {
  background: none;
}
.file-manager .owl-carousel .owl-nav button.owl-next:hover i, .file-manager .owl-carousel .owl-nav button.owl-prev:hover i {
  color: #E41F07;
}
.file-manager .owl-carousel.folders-carousel .owl-nav {
  left: 75px;
}
.file-manager .owl-carousel.video-section .owl-nav {
  left: 60px;
}
.file-manager .owl-carousel.video-section .info a svg {
  color: #6F6F6F;
  width: 18px;
}
.file-manager .all-files {
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border: none;
}
.file-manager .all-files .btn-grp a {
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 575.98px) {
  .file-manager .all-files .btn-grp a {
    margin-bottom: 15px;
    display: inline-block;
  }
}
.file-manager .all-files .btn-grp a.btn-outline-secondary {
  color: #6F6F6F;
  background: #F9F9FC;
  border-color: #F9F9FC;
}
.file-manager .all-files .btn-grp a:hover {
  background: #6F6F6F;
  border-color: #6F6F6F;
  color: #FFF;
}
.file-manager .all-files .table thead tr th {
  border-color: #E8E8E8;
}
.file-manager .all-files .table tbody tr td {
  display: table-cell;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  border-color: #E8E8E8;
}
.file-manager .all-files .table tbody tr td a {
  font-size: 14px;
  font-weight: 500;
}
.file-manager .all-files .table tbody tr td a.product-img img {
  width: 32px;
  height: 32px;
  border: 0;
}
.file-manager #file-delete {
  font-size: 14px;
}

aside {
  padding: 24px;
}

.color-primary {
  color: #6F6F6F;
}

.icon-select {
  position: relative;
  width: 149px;
  height: 38px;
}
.icon-select .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: 100;
}
.icon-select .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
}

.bg-light-orange {
  background: #FAD2CD;
}
.bg-light-orange span {
  background: #FAD2CD;
}

.bg-light-red {
  background: #FECCD4;
}
.bg-light-red span {
  background: #FECCD4;
}

.bg-light-green {
  background: #CEEACE;
}
.bg-light-green span {
  background: #CEEACE;
}

.seprator-sm {
  margin: 0 0 24px 0;
  padding: 0 0 9px 0;
  border-bottom: 1px solid #C0C0C0;
}

.seprator-lg {
  margin: 0 0 24px 0;
  padding: 0 0 24px 0;
  border-bottom: 1px solid #E8E8E8;
}

.group-avatar .avatar {
  position: relative;
  width: 43px;
  height: 43px;
  line-height: 43px;
  margin: 0;
}
.group-avatar .avatar + .avatar {
  margin-left: -1.2rem;
}
.group-avatar .avatar:hover {
  z-index: 1;
}
.group-avatar .count a {
  color: #5CB85C;
  line-height: 27px;
  font-size: 13px;
  font-weight: 500;
}
.group-avatar .count a:hover {
  color: #E41F07;
}
.group-avatar .avatar img {
  display: block;
  border-radius: 100%;
  width: 100%;
  border: 2px solid #FFF;
}

.video-section .item {
  opacity: 0.4;
  transition: 0.4s ease all;
  transform: scale(0.8);
}

@media (max-width: 1000px) {
  .video-section .item {
    margin: 0;
    transform: scale(0.9);
  }
}
.video-section .active .item {
  opacity: 1;
  transform: scale(1);
}

.video-section .owl-item {
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0) scale(1, 1);
}

.video-section video {
  max-width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
}

.delete-alert {
  padding: 10px 20px;
  background: #FECCD4;
  border: none;
  border-radius: 8px;
}
.delete-alert p {
  font-size: 15px;
}
.delete-alert .btn {
  font-weight: 700;
}

.deleted-info {
  display: none;
}
.deleted-info .bin-bg {
  width: 184px;
  height: 184px;
  border-radius: 100%;
  background: #FDFDFE;
  margin: 0 auto;
}

.popup-toggle {
  cursor: pointer;
}

.toggle-sidebar {
  width: 456px;
  padding: 25px;
  position: fixed;
  right: -456px;
  top: 0;
  height: 100%;
  background: #FFF;
  z-index: 100001;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  overflow-y: auto;
  transition: all 0.5s ease;
}
@media (max-width: 575.98px) {
  .toggle-sidebar {
    width: 320px;
    right: -320px;
  }
}
.toggle-sidebar.open-sidebar {
  right: 0;
  transition: all 0.5s ease;
}
.toggle-sidebar .head .color-primary:hover {
  color: #FC0027;
}
.toggle-sidebar h4, .toggle-sidebar h5 {
  font-weight: 700;
}
.toggle-sidebar h4 {
  font-size: 20px;
}
.toggle-sidebar h5 {
  font-size: 18px;
}
.toggle-sidebar h6 {
  font-size: 15px;
  font-weight: 600;
}
.toggle-sidebar .nav-tabs {
  border-bottom: 1px solid #C0C0C0;
}
.toggle-sidebar .nav-tabs .nav-link {
  padding: 8px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  background: #F9F9FC;
  color: #6F6F6F;
}
.toggle-sidebar .nav-tabs .nav-link:hover, .toggle-sidebar .nav-tabs .nav-link.active {
  background: #E41F07;
  color: #FFF;
}
.toggle-sidebar .tab-content .tab-pane ul li h6 {
  margin-bottom: 5px;
}
.toggle-sidebar .tab-content .tab-pane ul li p.location {
  background: #F9F9FC;
  border: 1px solid #C0C0C0;
  border-radius: 5px;
  padding: 5px;
  display: inline-block;
}
.toggle-sidebar .tab-content .tab-pane ul li p.location img {
  width: 20px;
  height: 20px;
}
.toggle-sidebar .tab-content .tab-pane ul li .note-editor.note-airframe .note-statusbar, .toggle-sidebar .tab-content .tab-pane ul li .note-editor.note-frame .note-statusbar {
  border-top: none;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span a {
  display: inline-flex;
  margin-right: 3px;
  padding-right: 3px;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span:first-child a {
  margin-right: 10px;
  padding-right: 10px;
  border-right: 1px solid #C0C0C0;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span:last-child a {
  margin-right: 0;
  padding-right: 0;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span .add {
  background: #E41F07;
  color: #FFF;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span .add:hover {
  background: #6F6F6F;
}
.toggle-sidebar p {
  color: #6F6F6F;
  font-size: 15px;
}
.toggle-sidebar .show-all {
  font-weight: 700;
}
.toggle-sidebar .show-all:hover {
  color: #6F6F6F;
}

.text-danger {
  color: #FC0027 !important;
}

.avatar-md {
  width: 45px;
  height: 45px;
  border-radius: 45px;
}

.text-secondary {
  color: #6F6F6F !important;
}

.text-primary {
  color: #E41F07 !important;
}

.text-default {
  color: #6F6F6F;
}

.btn-icon svg {
  width: 18px;
}

.file-manager-modal .modal-header h5 {
  font-size: 18px;
  font-weight: 700;
}
.file-manager-modal#hold-order h2 {
  font-size: 36px;
  font-weight: 700;
  color: #262A2A;
  margin-bottom: 10px;
  background-color: #F9F9FC;
  border-radius: 10px;
}
.file-manager-modal#hold-order .input-block label {
  margin-bottom: 5px;
}
.file-manager-modal#hold-order p {
  margin-top: 20px;
}
.file-manager-modal#recents .table tbody tr td {
  padding: 10px 15px;
}
.file-manager-modal .badge {
  padding: 5px 10px;
  font-size: 15px;
  font-weight: normal;
}
.file-manager-modal#orders .modal-dialog {
  max-width: 575px;
}
.file-manager-modal#orders .order-body {
  height: 50vh;
  overflow: auto;
}
.file-manager-modal#orders .order-body .default-cover {
  border: 1px solid #C0C0C0;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  border-radius: 8px;
}
.file-manager-modal#orders .order-body .record {
  font-size: 15px;
}
.file-manager-modal#orders .order-body .record td {
  padding-bottom: 15px;
}
.file-manager-modal#orders .order-body .record tr:last-child td {
  padding-bottom: 0;
}
.file-manager-modal#orders .order-body .record .colon {
  padding: 0 10px;
  color: #FFA201;
}
.file-manager-modal#orders .order-body .record .text {
  color: #6F6F6F;
  white-space: nowrap;
}
.file-manager-modal#orders .order-body p {
  font-size: 15px;
  background-color: #F9F9FC;
  border-radius: 8px;
}
.file-manager-modal#orders .order-body .search-set .search-input {
  width: 100%;
}
.file-manager-modal#orders .order-body .search-set .search-input label {
  width: 100%;
}
.file-manager-modal#orders .order-body .search-set .search-input label input {
  width: 100%;
}
.file-manager-modal.upload-modal .modal-body .drag-drop {
  position: relative;
  padding: 20px;
  border: 1px dashed #B8BCC9;
}
.file-manager-modal.upload-modal .modal-body .drag-drop input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.file-manager-modal.upload-modal .modal-body span {
  font-size: 13px;
  font-weight: 500;
  color: #6F6F6F;
}
.file-manager-modal.upload-modal .modal-body p {
  font-size: 16px;
  font-weight: 600;
  color: #FFA201;
  margin-bottom: 0;
}
.file-manager-modal.upload-modal .modal-body .progress {
  height: 6px;
  border-radius: 5px;
}
.file-manager-modal.upload-modal .modal-body ul li {
  margin: 0 0 15px 0;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #C0C0C0;
}
.file-manager-modal.upload-modal .modal-body ul li svg {
  width: 18px;
}
.file-manager-modal.upload-modal .modal-body ul li h6 a {
  font-size: 16px;
  font-weight: 600;
  color: #FFA201;
}
.file-manager-modal.upload-modal .modal-body ul li h6 a svg {
  color: #5CB85C;
}
.file-manager-modal.upload-modal .modal-body ul li h6:hover a {
  color: #E41F07;
}
.file-manager-modal.upload-modal .modal-body ul li:last-child {
  margin-bottom: 0;
}
.file-manager-modal#upload-message .modal-dialog {
  position: fixed;
  bottom: 0px;
  right: 24px;
  margin: 0px;
  left: auto;
  top: calc(100% - 300px);
  width: 600px;
}
.file-manager-modal#upload-message .progress {
  height: 6px;
  border-radius: 5px;
}

.datanew tr td svg {
  width: 18px;
}

.icons-list {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.icons-list li {
  display: block;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 18px;
  border-radius: 50px;
  border: 1px solid #e6ebf1;
  color: #E41F07;
  margin: 5px;
  box-shadow: 0 2px 3px rgb(215, 197, 255);
}

.progress {
  background-color: #E8E8E8;
  height: 0.75rem;
  border-radius: 0.25rem;
}

.progress-stacked {
  background-color: #E8E8E8;
}

.progress-bar {
  color: #FFF;
  background-color: #E41F07;
}

@keyframes progress-animate {
  0% {
    width: 0;
  }
}
.progress-animate {
  position: relative;
  border-radius: 0.625rem;
}
.progress-animate .progress-bar {
  position: relative;
  border-radius: 0.625rem;
  animation: 2s progress-animate;
}

.progress.progress-xs, .progress-stacked.progress-xs {
  height: 0.3125rem;
}
.progress.progress-sm, .progress-stacked.progress-sm {
  height: 0.5rem;
}
.progress.progress-lg, .progress-stacked.progress-lg {
  height: 1rem;
}
.progress.progress-xl, .progress-stacked.progress-xl {
  height: 1.25rem;
}

.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 10px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical .progress-bar {
  width: 100%;
}
.progress-vertical.progress-xl {
  width: 15px;
}
.progress-vertical.progress-lg {
  width: 12px;
}
.progress-vertical.progress-sm {
  width: 8px;
}
.progress-vertical.progress-xs {
  width: 5px;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 10px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical-bottom .progress-bar {
  width: 100%;
  bottom: 0;
  position: absolute;
}
.progress-vertical-bottom.progress-xl {
  width: 15px;
}
.progress-vertical-bottom.progress-lg {
  width: 12px;
}
.progress-vertical-bottom.progress-sm {
  width: 8px;
}
.progress-vertical-bottom.progress-xs {
  width: 5px;
}

.progress-custom {
  overflow: visible;
  position: relative;
}
.progress-custom .progress-bar {
  position: relative;
  overflow: visible;
}
.progress-custom .progress-bar:after {
  content: "";
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 50%;
  box-shadow: 0 0.313rem 0.313rem rgba(228, 31, 7, 0.5);
  background: #FFF;
  position: absolute;
  inset-inline-end: -0.375rem;
  inset-block-start: -0.375rem;
  border: 0.25rem solid #E41F07;
}
.progress-custom .progress-bar.bg-secondary:after {
  border: 0.25rem solid #FFA201;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--secondary-rgb), 0.2);
}
.progress-custom .progress-bar.bg-warning:after {
  border: 0.25rem solid #FDA700;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--warning-rgb), 0.2);
}
.progress-custom .progress-bar.bg-info:after {
  border: 0.25rem solid #1ECBE2;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--info-rgb), 0.2);
}
.progress-custom .progress-bar.bg-success:after {
  border: 0.25rem solid #5CB85C;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--success-rgb), 0.2);
}
.progress-custom .progress-bar.bg-danger:after {
  border: 0.25rem solid #FC0027;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--danger-rgb), 0.2);
}
.progress-custom .progress-bar-value {
  width: 1.875rem;
  height: 1.25rem;
  line-height: 1.25rem;
  border-radius: 0.188rem;
  background: #E41F07;
  box-shadow: 0 0.313rem 0.313rem rgba(0, 0, 0, 0.4);
  font-size: 0.625rem;
  font-weight: 600;
  color: #FFF;
  text-align: center;
  position: absolute;
  inset-block-end: 1.5rem;
  inset-inline-end: -0.688rem;
}
.progress-custom .progress-bar-value:after {
  content: "";
  border-block-start: 0.438rem solid #E41F07;
  border-inline-start: 0.438rem solid transparent;
  border-inline-end: 0.438rem solid transparent;
  position: absolute;
  inset-block-end: -0.375rem;
  inset-inline-start: 28%;
}
.progress-custom .progress-bar-value.bg-secondary {
  background-color: #FFA201;
}
.progress-custom .progress-bar-value.bg-secondary:after {
  border-block-start: 0.438rem solid #FFA201;
}
.progress-custom .progress-bar-value.bg-success {
  background-color: #5CB85C;
}
.progress-custom .progress-bar-value.bg-success:after {
  border-block-start: 0.438rem solid #5CB85C;
}
.progress-custom .progress-bar-value.bg-warning {
  background-color: #FDA700;
}
.progress-custom .progress-bar-value.bg-warning:after {
  border-block-start: 0.438rem solid #FDA700;
}
.progress-custom .progress-bar-value.bg-danger {
  background-color: #FC0027;
}
.progress-custom .progress-bar-value.bg-danger:after {
  border-block-start: 0.438rem solid #FC0027;
}
.progress-custom .progress-bar-value.bg-info {
  background-color: #1ECBE2;
}
.progress-custom .progress-bar-value.bg-info:after {
  border-block-start: 0.438rem solid #1ECBE2;
}

[dir=rtl] .progress-bar-title {
  border-radius: 0 0.313rem 0.313rem 0;
}

.progress-item-1, .progress-item-2, .progress-item-3 {
  position: absolute;
  margin-block-start: -0.25rem;
  z-index: 1;
  height: 0.938rem;
  width: 0.938rem;
  border-radius: 1.563rem;
  background-color: #FDFDFE;
}

.progress-item-1 {
  inset-inline-start: 25%;
}

.progress-item-2 {
  inset-inline-start: 50%;
}

.progress-item-3 {
  inset-inline-start: 75%;
}

.custom-progress-3 {
  overflow: visible;
  border-radius: 0.625rem;
}
.custom-progress-3 .progress-bar {
  position: relative;
  overflow: visible;
  margin: 0.313rem;
  border-radius: 0.25rem;
}
.custom-progress-3 .progress-bar:before {
  content: "";
  position: absolute;
  width: 0.25rem;
  height: 0.25rem;
  inset-inline-start: 0.125rem;
  background-color: #FFF;
  border-radius: 50%;
}
.custom-progress-3 .progress-bar .progress-bar-value {
  border: 0.125rem solid #E41F07;
  width: 2.5rem;
  height: 1.563rem;
  line-height: 1.313rem;
  border-radius: 3.125rem;
  background: #FFF;
  font-size: 0.625rem;
  font-weight: 600;
  color: #E41F07;
  text-align: center;
  position: absolute;
  inset-inline-end: -0.625rem;
}
.custom-progress-3 .progress-bar .progress-bar-value.secondary {
  border: 0.125rem solid #FFA201;
  color: #FFA201;
}
.custom-progress-3 .progress-bar .progress-bar-value.warning {
  border: 0.125rem solid #FDA700;
  color: #FDA700;
}
.custom-progress-3 .progress-bar .progress-bar-value.info {
  border: 0.125rem solid #1ECBE2;
  color: #1ECBE2;
}
.custom-progress-3 .progress-bar .progress-bar-value.success {
  border: 0.125rem solid #5CB85C;
  color: #5CB85C;
}
.custom-progress-3 .progress-bar .progress-bar-value.danger {
  border: 0.125rem solid #FC0027;
  color: #FC0027;
}

.custom-progress-4.progress {
  background-color: rgba(228, 31, 7, 0.1);
  border-radius: 0.25rem;
}
.custom-progress-4.progress.secondary {
  background-color: rgba(255, 162, 1, 0.1);
}
.custom-progress-4.progress.secondary .progress-bar-label {
  color: #FFA201;
}
.custom-progress-4.progress.warning {
  background-color: rgba(253, 167, 0, 0.1);
}
.custom-progress-4.progress.warning .progress-bar-label {
  color: #FDA700;
}
.custom-progress-4.progress.info {
  background-color: rgba(30, 203, 226, 0.1);
}
.custom-progress-4.progress.info .progress-bar-label {
  color: #1ECBE2;
}
.custom-progress-4.progress.success {
  background-color: rgba(92, 184, 92, 0.1);
}
.custom-progress-4.progress.success .progress-bar-label {
  color: #5CB85C;
}
.custom-progress-4.progress.danger {
  background-color: rgba(252, 0, 39, 0.1);
}
.custom-progress-4.progress.danger .progress-bar-label {
  color: #FC0027;
}
.custom-progress-4.progress .progress-bar {
  border-radius: 0.25rem;
}
.custom-progress-4.progress .progress-bar-label {
  position: absolute;
  inset-inline-end: 0.313rem;
  font-weight: 600;
  font-size: 0.813rem;
  color: #E41F07;
}

.page-link {
  color: #6F6F6F;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
}
.page-link:focus {
  box-shadow: none;
  background-color: #FDFDFE;
}
.page-link:hover {
  color: #E41F07;
  background-color: #FDFDFE;
  border-color: #E8E8E8;
}

.page-item.active .page-link {
  color: #FFF;
  background-color: #E41F07;
  border-color: #E41F07;
}

.disabled > .page-link, .page-link.disabled {
  color: #6F6F6F;
  background-color: #FFF;
  border-color: #E8E8E8;
  opacity: 0.7;
}

[dir=rtl] .pagination .page-link .bx-chevron-left::before {
  content: "\\ea50";
}
[dir=rtl] .pagination .page-link .bx-chevron-right::before {
  content: "\\ea4d";
}
[dir=rtl] .pagination .page-link .ri-arrow-right-s-line:before {
  content: "\\ea64";
}
[dir=rtl] .pagination .page-link .ri-arrow-left-s-line:before {
  content: "\\ea6e";
}

.pagination-style-1 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-1 .pagination .page-item .page-link {
  border: 0;
  border-radius: 4px;
  font-size: 0.8125rem;
}
.pagination-style-1 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-1 .pagination .page-item.active .page-link {
  border-radius: 4px;
  background-color: #E41F07;
  color: #FFF;
}
.pagination-style-1 .pagination .page-item.active:hover .page-link {
  border-radius: 4px;
  background-color: #E41F07;
  color: #FFF;
}
.pagination-style-1 .pagination .page-item:hover .page-link {
  background-color: #FDFDFE;
  color: #E41F07;
}

.pagination-style-2 .pagination {
  border-radius: 4px;
}
.pagination-style-2 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-2 .pagination .page-item .page-link {
  border: 0 !important;
  font-size: 0.8125rem;
}
.pagination-style-2 .pagination .page-item.active .page-link {
  background-color: #FFF;
  color: #E41F07;
  position: relative;
  font-weight: bold;
}
.pagination-style-2 .pagination .page-item.active .page-link:before {
  position: absolute;
  content: "";
  inset-block-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 0.1rem;
  background-color: #E41F07;
}
.pagination-style-2 .pagination .page-item:hover .page-link {
  background-color: transparent;
}

.pagination-style-3 .pagination {
  border-radius: 50px;
  padding: 0.25rem;
  align-items: center;
}
.pagination-style-3 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-3 .pagination .page-item .page-link {
  border: 0;
  border-radius: 50px;
  font-size: 0.8125rem;
}
.pagination-style-3 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-3 .pagination .page-item.active .page-link {
  background-color: #E41F07;
  color: #FFF;
}
.pagination-style-3 .pagination .page-item.active:hover .page-link {
  background-color: #E41F07;
}
.pagination-style-3 .pagination .page-item:hover .page-link {
  background-color: #FDFDFE;
}

.pagination-style-4 .pagination .page-item .page-link {
  border: 0 !important;
  font-size: 0.8125rem;
  border-radius: 4px;
}
.pagination-style-4 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-4 .pagination .page-item.active .page-link {
  border: 0;
  border-radius: 4px;
  background-color: #E41F07;
  color: #FFF;
}
.pagination-style-4 .pagination .page-item.active:hover .page-link {
  background-color: #E41F07;
}
.pagination-style-4 .pagination .page-item:hover .page-link {
  background-color: transparent;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  color: #262A2A;
  font-family: "Noto Sans", sans-serif;
  font-weight: 700;
  margin-bottom: 0;
}

h1,
.h1 {
  font-size: 2rem;
}

h2,
.h2 {
  font-size: 1.75rem;
}

h3,
.h3 {
  font-size: 1.5rem;
}

h4,
.h4 {
  font-size: 1.125rem;
}

h5,
.h5 {
  font-size: 1rem;
}

h6,
.h6 {
  font-size: 0.875rem;
}

.fs-sm {
  font-size: 0.6875rem;
}

.fs-base {
  font-size: 0.875rem;
}

.fs-lg {
  font-size: 1.125rem;
}

.fs-1 {
  font-size: 0.0625rem;
}

.fs-2 {
  font-size: 0.125rem;
}

.fs-3 {
  font-size: 0.1875rem;
}

.fs-4 {
  font-size: 0.25rem;
}

.fs-5 {
  font-size: 0.3125rem;
}

.fs-6 {
  font-size: 0.375rem;
}

.fs-7 {
  font-size: 0.4375rem;
}

.fs-8 {
  font-size: 0.5rem;
}

.fs-9 {
  font-size: 0.5625rem;
}

.fs-10 {
  font-size: 0.625rem;
}

.fs-11 {
  font-size: 0.6875rem;
}

.fs-12 {
  font-size: 0.75rem;
}

.fs-13 {
  font-size: 0.8125rem;
}

.fs-14 {
  font-size: 0.875rem;
}

.fs-15 {
  font-size: 0.9375rem;
}

.fs-16 {
  font-size: 1rem;
}

.fs-17 {
  font-size: 1.0625rem;
}

.fs-18 {
  font-size: 1.125rem;
}

.fs-19 {
  font-size: 1.1875rem;
}

.fs-20 {
  font-size: 1.25rem;
}

.fs-21 {
  font-size: 1.3125rem;
}

.fs-22 {
  font-size: 1.375rem;
}

.fs-23 {
  font-size: 1.4375rem;
}

.fs-24 {
  font-size: 1.5rem;
}

.fs-25 {
  font-size: 1.5625rem;
}

.fs-26 {
  font-size: 1.625rem;
}

.fs-27 {
  font-size: 1.6875rem;
}

.fs-28 {
  font-size: 1.75rem;
}
@media (max-width: 575.98px) {
  .fs-28 {
    font-size: 1.25rem;
  }
}

.fs-29 {
  font-size: 1.8125rem;
}

.fs-30 {
  font-size: 1.875rem;
}

.fs-32 {
  font-size: 2rem;
}

.fs-34 {
  font-size: 2.125rem;
}

.fs-36 {
  font-size: 2.25rem;
}

.fs-38 {
  font-size: 2.375rem;
}

.fs-40 {
  font-size: 2.5rem;
}

.fs-60 {
  font-size: 3.75rem;
}
@media (max-width: 991.98px) {
  .fs-60 {
    font-size: 2.125rem;
  }
}
@media (max-width: 575.98px) {
  .fs-60 {
    font-size: 1.125rem;
  }
}

.text-default {
  color: #6F6F6F !important;
}

.text-muted {
  color: #9595b5 !important;
}

.text-primary {
  color: #E41F07 !important;
  opacity: 1;
}
.text-primary.text-opacity-75 {
  color: rgba(228, 31, 7, 0.75) !important;
}
.text-primary.text-opacity-25 {
  color: rgba(228, 31, 7, 0.25) !important;
}
.text-primary.text-opacity-50 {
  color: rgba(228, 31, 7, 0.5) !important;
}

.text-secondary {
  color: #FFA201 !important;
  opacity: 1;
}

.text-info {
  color: #1ECBE2 !important;
  opacity: 1;
}

.text-success {
  color: #5CB85C !important;
  opacity: 1;
}

.text-warning {
  color: #FDA700 !important;
  opacity: 1;
}

.text-danger {
  color: #FC0027 !important;
  opacity: 1;
}

.text-blue {
  color: #339DFF !important;
}

.text-green {
  color: #00918E !important;
}

.text-pink {
  color: #EA00B7 !important;
}

.text-teal {
  color: #02a8b5 !important;
}

.text-orange {
  color: #FF9D0A !important;
}

.text-indigo {
  color: #0092E4 !important;
}

.text-purple {
  color: #4A00E5 !important;
}

.text-dark {
  color: #171724 !important;
}

.text-light {
  color: #FDFDFE !important;
}

.text-gray {
  color: #6F7A7A !important;
}

.text-black {
  color: #000 !important;
}

.text-white {
  color: #FFF !important;
}

.text-fixed-white {
  color: #FFF !important;
}

.text-fixed-black {
  color: #000 !important;
}

.text-gray-1 {
  color: #C0C0C0;
}

.text-gray-2 {
  color: #9B9B9B;
}

.text-gray-3 {
  color: #898989;
}

.text-gray-4 {
  color: #6F6F6F;
}

.text-gray-5 {
  color: #6F7A7A;
}

.text-gray-6 {
  color: #565E5E;
}

.text-gray-7 {
  color: #424848;
}

.text-gray-8 {
  color: #323737;
}

.text-gray-9 {
  color: #262A2A;
}

a {
  color: #262A2A;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.5s ease;
}
a:hover {
  color: #E41F07;
  transition: all 0.5s ease;
}
a:focus {
  outline: 0;
}

.link-primary {
  color: #E41F07 !important;
}
.link-primary:hover, .link-primary:focus, .link-primary:active {
  color: #E41F07 !important;
}

.link-secondary {
  color: #FFA201 !important;
}
.link-secondary:hover, .link-secondary:focus, .link-secondary:active {
  color: #FFA201 !important;
}

.link-success {
  color: #5CB85C !important;
}
.link-success:hover, .link-success:focus, .link-success:active {
  color: #5CB85C !important;
}

.link-danger {
  color: #FC0027 !important;
}
.link-danger:hover, .link-danger:focus, .link-danger:active {
  color: #FC0027 !important;
}

.link-warning {
  color: #FDA700 !important;
}
.link-warning:hover, .link-warning:focus, .link-warning:active {
  color: #FDA700 !important;
}

.link-info {
  color: #1ECBE2 !important;
}
.link-info:hover, .link-info:focus, .link-info:active {
  color: #1ECBE2 !important;
}

.link-light {
  color: #FDFDFE !important;
}
.link-light:hover, .link-light:focus, .link-light:active {
  color: #FDFDFE !important;
}

.link-dark {
  color: #171724 !important;
}
.link-dark:hover, .link-dark:focus, .link-dark:active {
  color: #171724 !important;
}

hr.text-danger {
  border-color: #FC0027 !important;
}

.text-purple {
  color: #4A00E5 !important;
}

.blockquote-container {
  padding: 1.25rem;
  border-left: 4px solid #E8E8E8;
  position: relative;
}
.blockquote-container.text-end {
  border-right: 4px solid #E8E8E8;
  border-left: 0;
}

.blockquote.custom-blockquote {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 1rem;
  border-radius: 4px;
  position: relative;
}
.blockquote.custom-blockquote:before {
  content: "\\f10d";
  font-family: "Fontawesome";
  z-index: 0;
  font-size: 2rem;
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0.5rem;
}
.blockquote.custom-blockquote.primary {
  background-color: rgba(228, 31, 7, 0.1);
  border-inline-start: 2px solid #E41F07;
}
.blockquote.custom-blockquote.primary:before {
  color: rgba(228, 31, 7, 0.1);
}
.blockquote.custom-blockquote.secondary {
  background-color: rgba(255, 162, 1, 0.1);
  border-inline-start: 2px solid #FFA201;
}
.blockquote.custom-blockquote.secondary:before {
  color: rgba(255, 162, 1, 0.1);
}
.blockquote.custom-blockquote.info {
  background-color: rgba(30, 203, 226, 0.1);
  border-inline-start: 2px solid #1ECBE2;
}
.blockquote.custom-blockquote.info:before {
  color: rgba(30, 203, 226, 0.1);
}
.blockquote.custom-blockquote.warning {
  background-color: rgba(253, 167, 0, 0.1);
  border-inline-start: 2px solid #FDA700;
}
.blockquote.custom-blockquote.warning:before {
  color: rgba(253, 167, 0, 0.1);
}
.blockquote.custom-blockquote.success {
  background-color: rgba(92, 184, 92, 0.1);
  border-inline-start: 2px solid #5CB85C;
}
.blockquote.custom-blockquote.success:before {
  color: rgba(92, 184, 92, 0.1);
}
.blockquote.custom-blockquote.danger {
  background-color: rgba(252, 0, 39, 0.1);
  border-inline-start: 2px solid #FC0027;
}
.blockquote.custom-blockquote.danger:before {
  color: rgba(252, 0, 39, 0.1);
}

[data-theme-mode=dark] .shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(33, 37, 41, 0.3) !important;
}
[data-theme-mode=dark] .shadow {
  box-shadow: 0 0.5rem 1rem rgba(33, 37, 41, 0.3) !important;
}
[data-theme-mode=dark] .shadow-lg {
  box-shadow: 0 1rem 3rem rgba(33, 37, 41, 0.3) !important;
}

@media screen and (min-width: 576px) {
  .w-sm-auto {
    width: auto;
  }
}
[dir=rtl] .text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

.transform-none {
  transform: none !important;
}

.w-9 {
  width: 9px;
}

.h-9 {
  height: 9px;
}

.list-circle {
  list-style: circle;
  padding-left: 2rem;
}

.alert {
  padding: 0.625rem 0.85rem;
  border-radius: 4px;
  font-size: 0.8125rem;
}
.alert.alert-dismissible {
  padding: 0.625rem 2.25rem 0.625rem 0.85rem;
}
.alert i {
  font-size: 20px;
}
.alert .btn-close {
  background-image: none;
  padding: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert .btn-close i {
  font-size: 18px;
  line-height: 18px;
}
.alert:last-child {
  margin-bottom: 0;
}
.alert .alert-link {
  font-weight: 600;
}

[dir=rtl] .alert.alert-dismissible {
  padding: 0.625rem 0.85rem 0.625rem 2.25rem;
}

.alert-warning {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
  border-color: rgba(253, 167, 0, 0.1);
}
.alert-warning .alert-link {
  color: #FDA700;
}
.alert-warning .btn-close {
  color: #FDA700;
}
.alert-warning .btn-close.custom-close {
  background-color: #FDA700;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-primary {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
  border-color: rgba(228, 31, 7, 0.1);
}
.alert-primary .alert-link {
  color: #E41F07;
}
.alert-primary .custom-alert-icon {
  color: #E41F07;
}
.alert-primary .btn-close {
  color: #E41F07;
}
.alert-primary .btn-close.custom-close {
  background-color: #E41F07;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-secondary {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
  border-color: rgba(255, 162, 1, 0.1);
}
.alert-secondary .alert-link {
  color: #FFA201;
}
.alert-secondary .btn-close {
  color: #FFA201;
}
.alert-secondary .btn-close.custom-close {
  background-color: #FFA201;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-success {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
  border-color: rgba(92, 184, 92, 0.1);
}
.alert-success .alert-link {
  color: #5CB85C;
}
.alert-success .btn-close {
  color: #5CB85C;
}
.alert-success .btn-close.custom-close {
  background-color: #5CB85C;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-info {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
  border-color: rgba(30, 203, 226, 0.1);
}
.alert-info .alert-link {
  color: #1ECBE2;
}
.alert-info .btn-close {
  color: #1ECBE2;
}
.alert-info .btn-close.custom-close {
  background-color: #1ECBE2;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-danger {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
  border-color: rgba(252, 0, 39, 0.1);
}
.alert-danger .alert-link {
  color: #FC0027;
}
.alert-danger .btn-close {
  color: #FC0027;
}
.alert-danger .btn-close.custom-close {
  background-color: #FC0027;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-light {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border-color: #FDFDFE;
}
.alert-light .alert-link {
  color: #6F6F6F;
}
.alert-light .btn-close {
  color: #6F6F6F;
}
.alert-light .btn-close.custom-close {
  background-color: #FDFDFE;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-dark {
  background-color: rgba(23, 23, 36, 0.1);
  color: #6F6F6F;
  border-color: rgba(23, 23, 36, 0.1);
}
.alert-dark .alert-link {
  color: #6F6F6F;
}
.alert-dark .btn-close {
  color: #FFF;
}
.alert-dark .btn-close.custom-close {
  background-color: #171724;
  color: #FFF;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  padding: 0.85rem;
}

.alert-solid-primary {
  background-color: #E41F07;
  color: #FFF;
  border-color: #E41F07;
}
.alert-solid-primary .btn-close {
  color: #FFF;
}

.alert-solid-secondary {
  background-color: #FFA201;
  color: #FFF;
  border-color: #FFA201;
}
.alert-solid-secondary .btn-close {
  color: #FFF;
}

.alert-solid-warning {
  background-color: #FDA700;
  color: #FFF;
  border-color: #FDA700;
}
.alert-solid-warning .btn-close {
  color: #FFF;
}

.alert-solid-info {
  background-color: #1ECBE2;
  color: #FFF;
  border-color: #1ECBE2;
}
.alert-solid-info .btn-close {
  color: #FFF;
}

.alert-solid-success {
  background-color: #5CB85C;
  color: #FFF;
  border-color: #5CB85C;
}
.alert-solid-success .btn-close {
  color: #FFF;
}

.alert-solid-danger {
  background-color: #FC0027;
  color: #FFF;
  border-color: #FC0027;
}
.alert-solid-danger .btn-close {
  color: #FFF;
}

.alert-solid-light {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border-color: #E8E8E8;
}

.alert-solid-dark {
  background-color: #171724;
  color: #FFF;
  border-color: #171724;
}
.alert-solid-dark .btn-close {
  color: #FFF;
}

.alert-outline-primary {
  background-color: #FFF;
  color: #E41F07;
  border-color: #E41F07;
}
.alert-outline-primary .btn-close {
  color: #E41F07;
}

.alert-outline-secondary {
  background-color: #FFF;
  color: #FFA201;
  border-color: #FFA201;
}
.alert-outline-secondary .btn-close {
  color: #FFA201;
}

.alert-outline-info {
  background-color: #FFF;
  color: #1ECBE2;
  border-color: #1ECBE2;
}
.alert-outline-info .btn-close {
  color: #1ECBE2;
}

.alert-outline-warning {
  background-color: #FFF;
  color: #FDA700;
  border-color: #FDA700;
}
.alert-outline-warning .btn-close {
  color: #FDA700;
}

.alert-outline-success {
  background-color: #FFF;
  color: #5CB85C;
  border-color: #5CB85C;
}
.alert-outline-success .btn-close {
  color: #5CB85C;
}

.alert-outline-danger {
  background-color: #FFF;
  color: #FC0027;
  border-color: #FC0027;
}
.alert-outline-danger .btn-close {
  color: #FC0027;
}

.alert-outline-light {
  background-color: #FFF;
  color: #6F6F6F;
  border-color: #FDFDFE;
}

.alert-outline-dark {
  background-color: #FFF;
  color: #171724;
  border-color: #171724;
}
.alert-outline-dark .btn-close {
  color: #171724;
}

.alert-primary.custom-alert-icon {
  border-inline-start: 0.313rem solid #E41F07 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-primary.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-primary.custom-alert-icon > i {
  color: #E41F07;
}

.alert-secondary.custom-alert-icon {
  border-inline-start: 0.313rem solid #FFA201 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-secondary.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-secondary.custom-alert-icon > i {
  color: #FFA201;
}

.alert-warning.custom-alert-icon {
  border-inline-start: 0.313rem solid #FDA700 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-warning.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-warning.custom-alert-icon > i {
  color: #FDA700;
}

.alert-danger.custom-alert-icon {
  border-inline-start: 0.313rem solid #FC0027 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-danger.custom-alert-icon .btn-close {
  color: #6F6F6F;
}
.alert-danger.custom-alert-icon > i {
  color: #FC0027;
}

.alert-success.custom-alert-icon {
  border-inline-start: 0.313rem solid #5CB85C !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-success.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.alert-info.custom-alert-icon {
  border-inline-start: 0.313rem solid #1ECBE2 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-info.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.alert-light.custom-alert-icon {
  border-inline-start: 0.313rem solid #FDFDFE !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-light.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.alert-dark.custom-alert-icon {
  border-inline-start: 0.313rem solid #171724 !important;
  color: #9595b5;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  font-size: 0.813rem;
}
.alert-dark.custom-alert-icon .btn-close {
  color: #6F6F6F;
}

.custom-alert1 {
  margin-block-end: 0;
  background-color: #FFF;
  border: 0;
  padding: 1.25rem;
  color: #6F6F6F;
}
.custom-alert1 p {
  margin-block-end: 2.5rem;
  color: #9595b5;
  font-size: 0.8rem;
}
.custom-alert1 .custom-alert-icon {
  font-size: 40px;
  margin-bottom: 0.85rem;
}
.custom-alert1 .custom-alert-icon i {
  font-size: 40px;
}
.custom-alert1 .btn-close {
  padding: 0;
  margin-block-end: 1rem;
}
.custom-alert1.alert-primary {
  border-block-start: 0.313rem solid #E41F07;
}
.custom-alert1.alert-primary .custom-alert-icon {
  color: #E41F07;
}
.custom-alert1.alert-secondary {
  border-block-start: 0.313rem solid #FFA201;
}
.custom-alert1.alert-secondary .custom-alert-icon {
  color: #FFA201;
}
.custom-alert1.alert-warning {
  border-block-start: 0.313rem solid #FDA700;
}
.custom-alert1.alert-warning .custom-alert-icon {
  color: #FDA700;
}
.custom-alert1.alert-danger {
  border-block-start: 0.313rem solid #FC0027;
}
.custom-alert1.alert-danger .custom-alert-icon {
  color: #FC0027;
}

.alert-img {
  display: flex;
  align-items: center;
}
.alert-img .avatar {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 400px) {
  .btn-close.custom-close {
    margin: 9px 9px 9px 0;
  }
}
.op-1-1 {
  opacity: 1;
}

.op-0 {
  opacity: 0;
}

.op-1 {
  opacity: 0.1;
}

.op-2 {
  opacity: 0.2;
}

.op-3 {
  opacity: 0.3;
}

.op-4 {
  opacity: 0.4;
}

.op-5 {
  opacity: 0.5;
}

.op-6 {
  opacity: 0.6;
}

.op-7 {
  opacity: 0.7;
}

.op-8 {
  opacity: 0.8;
}

.op-9 {
  opacity: 0.9;
}

.custom-popover {
  --bs-popover-max-width: 12.5rem;
  --bs-popover-border-color: #E41F07;
  --bs-popover-header-bg: #E41F07;
  --bs-popover-header-color: #FFF;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 0.5rem;
}

.popover {
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  font-size: 0.8rem;
  border-radius: 4px;
  z-index: 999;
}
.popover .popover-header {
  background-color: #FFF;
  border-block-end: 1px solid #E8E8E8;
}
.popover .popover-body {
  color: #6F6F6F;
}
.popover.only-body {
  border-radius: 0.3rem;
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,
.bs-popover-top > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,
.bs-popover-top > .popover-arrow::before {
  border-top-color: #FDFDFE;
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,
.bs-popover-end > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,
.bs-popover-end > .popover-arrow::before {
  border-right-color: #FDFDFE;
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,
.bs-popover-start > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,
.bs-popover-start > .popover-arrow::before {
  border-left-color: #FDFDFE;
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,
.bs-popover-bottom > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,
.bs-popover-bottom > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,
.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FDFDFE;
}

.header-primary .popover-header {
  background-color: #E41F07;
  color: #FFF;
}
.header-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-primary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #E41F07;
}

.header-secondary .popover-header {
  background-color: #FFA201;
  color: #FFF;
}
.header-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-secondary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FFA201;
}

.header-warning .popover-header {
  background-color: #FDA700;
  color: #FFF;
}
.header-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-warning.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FDA700;
}

.header-info .popover-header {
  background-color: #1ECBE2;
  color: #FFF;
}
.header-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-info.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #1ECBE2;
}

.header-success .popover-header {
  background-color: #5CB85C;
  color: #FFF;
}
.header-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-success.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #5CB85C;
}

.header-danger .popover-header {
  background-color: #FC0027;
  color: #FFF;
}
.header-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-danger.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FC0027;
}

.popover-primary.popover {
  border: 1px solid #E41F07;
}
.popover-primary.popover .popover-header {
  background-color: #E41F07;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-primary.popover .popover-body {
  background-color: #E41F07;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-primary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-primary.bs-popover-top > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-primary.bs-popover-top > .popover-arrow::before {
  border-top-color: #E41F07;
}
.popover-primary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-primary.bs-popover-end > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-primary.bs-popover-end > .popover-arrow::before {
  border-right-color: #E41F07;
}
.popover-primary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-primary.bs-popover-start > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-primary.bs-popover-start > .popover-arrow::before {
  border-left-color: #E41F07;
}
.popover-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-primary.bs-popover-bottom > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-primary.bs-popover-bottom > .popover-arrow::before, .popover-primary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-primary.bs-popover-bottom .popover-header::before {
  border-bottom-color: #E41F07;
}

.popover-secondary.popover {
  border: 1px solid #FFA201;
}
.popover-secondary.popover .popover-header {
  background-color: #FFA201;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-secondary.popover .popover-body {
  background-color: #FFA201;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-secondary.bs-popover-top > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-secondary.bs-popover-top > .popover-arrow::before {
  border-top-color: #FFA201;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-secondary.bs-popover-end > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-secondary.bs-popover-end > .popover-arrow::before {
  border-right-color: #FFA201;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-secondary.bs-popover-start > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-secondary.bs-popover-start > .popover-arrow::before {
  border-left-color: #FFA201;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-secondary.bs-popover-bottom > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-secondary.bs-popover-bottom > .popover-arrow::before, .popover-secondary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-secondary.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FFA201;
}

.popover-warning.popover {
  border: 1px solid #FDA700;
}
.popover-warning.popover .popover-header {
  background-color: #FDA700;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-warning.popover .popover-body {
  background-color: #FDA700;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-warning.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-warning.bs-popover-top > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-warning.bs-popover-top > .popover-arrow::before {
  border-top-color: #FDA700;
}
.popover-warning.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-warning.bs-popover-end > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-warning.bs-popover-end > .popover-arrow::before {
  border-right-color: #FDA700;
}
.popover-warning.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-warning.bs-popover-start > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-warning.bs-popover-start > .popover-arrow::before {
  border-left-color: #FDA700;
}
.popover-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-warning.bs-popover-bottom > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-warning.bs-popover-bottom > .popover-arrow::before, .popover-warning.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-warning.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FDA700;
}

.popover-info.popover {
  border: 1px solid #1ECBE2;
}
.popover-info.popover .popover-header {
  background-color: #1ECBE2;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-info.popover .popover-body {
  background-color: #1ECBE2;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-info.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-info.bs-popover-top > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-info.bs-popover-top > .popover-arrow::before {
  border-top-color: #1ECBE2;
}
.popover-info.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-info.bs-popover-end > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-info.bs-popover-end > .popover-arrow::before {
  border-right-color: #1ECBE2;
}
.popover-info.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-info.bs-popover-start > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-info.bs-popover-start > .popover-arrow::before {
  border-left-color: #1ECBE2;
}
.popover-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-info.bs-popover-bottom > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-info.bs-popover-bottom > .popover-arrow::before, .popover-info.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-info.bs-popover-bottom .popover-header::before {
  border-bottom-color: #1ECBE2;
}

.popover-success.popover {
  border: 1px solid #5CB85C;
}
.popover-success.popover .popover-header {
  background-color: #5CB85C;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-success.popover .popover-body {
  background-color: #5CB85C;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-success.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-success.bs-popover-top > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-success.bs-popover-top > .popover-arrow::before {
  border-top-color: #5CB85C;
}
.popover-success.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-success.bs-popover-end > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-success.bs-popover-end > .popover-arrow::before {
  border-right-color: #5CB85C;
}
.popover-success.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-success.bs-popover-start > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-success.bs-popover-start > .popover-arrow::before {
  border-left-color: #5CB85C;
}
.popover-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-success.bs-popover-bottom > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-success.bs-popover-bottom > .popover-arrow::before, .popover-success.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-success.bs-popover-bottom .popover-header::before {
  border-bottom-color: #5CB85C;
}

.popover-danger.popover {
  border: 1px solid #FC0027;
}
.popover-danger.popover .popover-header {
  background-color: #FC0027;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-danger.popover .popover-body {
  background-color: #FC0027;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-danger.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-danger.bs-popover-top > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-danger.bs-popover-top > .popover-arrow::before {
  border-top-color: #FC0027;
}
.popover-danger.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-danger.bs-popover-end > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-danger.bs-popover-end > .popover-arrow::before {
  border-right-color: #FC0027;
}
.popover-danger.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-danger.bs-popover-start > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-danger.bs-popover-start > .popover-arrow::before {
  border-left-color: #FC0027;
}
.popover-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-danger.bs-popover-bottom > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-danger.bs-popover-bottom > .popover-arrow::before, .popover-danger.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-danger.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FC0027;
}

.popover-purple.popover {
  border: 1px solid #4A00E5;
}
.popover-purple.popover .popover-header {
  background-color: #4A00E5;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-purple.popover .popover-body {
  background-color: #4A00E5;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-purple.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-purple.bs-popover-top > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-purple.bs-popover-top > .popover-arrow::before {
  border-top-color: #4A00E5;
}
.popover-purple.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-purple.bs-popover-end > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-purple.bs-popover-end > .popover-arrow::before {
  border-right-color: #4A00E5;
}
.popover-purple.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-purple.bs-popover-start > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-purple.bs-popover-start > .popover-arrow::before {
  border-left-color: #4A00E5;
}
.popover-purple.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-purple.bs-popover-bottom > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-purple.bs-popover-bottom > .popover-arrow::before, .popover-purple.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-purple.bs-popover-bottom .popover-header::before {
  border-bottom-color: #4A00E5;
}

.popover-teal.popover {
  border: 1px solid #02a8b5;
}
.popover-teal.popover .popover-header {
  background-color: #02a8b5;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #FFF;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-teal.popover .popover-body {
  background-color: #02a8b5;
  color: #FFF;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-teal.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-teal.bs-popover-top > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-teal.bs-popover-top > .popover-arrow::before {
  border-top-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-teal.bs-popover-end > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-teal.bs-popover-end > .popover-arrow::before {
  border-right-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-teal.bs-popover-start > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-teal.bs-popover-start > .popover-arrow::before {
  border-left-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-teal.bs-popover-bottom > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-teal.bs-popover-bottom > .popover-arrow::before, .popover-teal.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-teal.bs-popover-bottom .popover-header::before {
  border-bottom-color: #02a8b5;
}

.popover-primary-light.popover {
  border: 1px solid rgba(228, 31, 7, 0.1);
}
.popover-primary-light.popover .popover-header {
  background-color: rgba(228, 31, 7, 0.1);
  border-block-end: 1px solid rgba(228, 31, 7, 0.1);
  color: #E41F07;
  border-radius: 0;
}
.popover-primary-light.popover .popover-body {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-primary-light.bs-popover-top > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-primary-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(228, 31, 7, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-primary-light.bs-popover-end > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-primary-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(228, 31, 7, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-primary-light.bs-popover-start > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-primary-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(228, 31, 7, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-primary-light.bs-popover-bottom > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-primary-light.bs-popover-bottom > .popover-arrow::before, .popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-primary-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(228, 31, 7, 0.1);
}

.popover-secondary-light.popover {
  border: 1px solid rgba(255, 162, 1, 0.1);
}
.popover-secondary-light.popover .popover-header {
  background-color: rgba(255, 162, 1, 0.1);
  border-block-end: 1px solid rgba(255, 162, 1, 0.1);
  color: #FFA201;
  border-radius: 0;
}
.popover-secondary-light.popover .popover-body {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-secondary-light.bs-popover-top > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-secondary-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--secondary-rgb), 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-secondary-light.bs-popover-end > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-secondary-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(255, 162, 1, 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-secondary-light.bs-popover-start > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-secondary-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--secondary-rgb), 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-secondary-light.bs-popover-bottom > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-secondary-light.bs-popover-bottom > .popover-arrow::before, .popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-secondary-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--secondary-rgb), 0.1);
}

.popover-warning-light.popover {
  border: 1px solid rgba(253, 167, 0, 0.1);
}
.popover-warning-light.popover .popover-header {
  background-color: rgba(253, 167, 0, 0.1);
  border-block-end: 1px solid rgba(253, 167, 0, 0.1);
  color: #FDA700;
  border-radius: 0;
}
.popover-warning-light.popover .popover-body {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-warning-light.bs-popover-top > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-warning-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(253, 167, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-warning-light.bs-popover-end > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-warning-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(253, 167, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-warning-light.bs-popover-start > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-warning-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(253, 167, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-warning-light.bs-popover-bottom > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-warning-light.bs-popover-bottom > .popover-arrow::before, .popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-warning-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(253, 167, 0, 0.1);
}

.popover-info-light.popover {
  border: 1px solid rgba(30, 203, 226, 0.1);
}
.popover-info-light.popover .popover-header {
  background-color: rgba(30, 203, 226, 0.1);
  border-block-end: 1px solid rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
  border-radius: 0;
}
.popover-info-light.popover .popover-body {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
}
.popover-info-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-info-light.bs-popover-top > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-info-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(30, 203, 226, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-info-light.bs-popover-end > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-info-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(30, 203, 226, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-info-light.bs-popover-start > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-info-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(30, 203, 226, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-info-light.bs-popover-bottom > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-info-light.bs-popover-bottom > .popover-arrow::before, .popover-info-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-info-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(30, 203, 226, 0.1);
}

.popover-success-light.popover {
  border: 1px solid rgba(92, 184, 92, 0.1);
}
.popover-success-light.popover .popover-header {
  background-color: rgba(92, 184, 92, 0.1);
  border-block-end: 1px solid rgba(92, 184, 92, 0.1);
  color: #5CB85C;
  border-radius: 0;
}
.popover-success-light.popover .popover-body {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
}
.popover-success-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-success-light.bs-popover-top > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-success-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(92, 184, 92, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-success-light.bs-popover-end > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-success-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(92, 184, 92, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-success-light.bs-popover-start > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-success-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(92, 184, 92, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-success-light.bs-popover-bottom > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-success-light.bs-popover-bottom > .popover-arrow::before, .popover-success-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-success-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(92, 184, 92, 0.1);
}

.popover-danger-light.popover {
  border: 1px solid rgba(252, 0, 39, 0.1);
}
.popover-danger-light.popover .popover-header {
  background-color: rgba(252, 0, 39, 0.1);
  border-block-end: 1px solid rgba(252, 0, 39, 0.1);
  color: #FC0027;
  border-radius: 0;
}
.popover-danger-light.popover .popover-body {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-danger-light.bs-popover-top > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-danger-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(252, 0, 39, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-danger-light.bs-popover-end > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-danger-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(252, 0, 39, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-danger-light.bs-popover-start > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-danger-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(252, 0, 39, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-danger-light.bs-popover-bottom > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-danger-light.bs-popover-bottom > .popover-arrow::before, .popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-danger-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(252, 0, 39, 0.1);
}

.popover-purple-light.popover {
  border: 1px solid rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.popover .popover-header {
  background-color: rgba(var(--purple-rgb), 0.1);
  border-block-end: 1px solid rgba(var(--purple-rgb), 0.1);
  color: #4A00E5;
  border-radius: 0;
}
.popover-purple-light.popover .popover-body {
  background-color: rgba(var(--purple-rgb), 0.1);
  color: #4A00E5;
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-purple-light.bs-popover-top > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-purple-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-purple-light.bs-popover-end > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-purple-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-purple-light.bs-popover-start > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-purple-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-purple-light.bs-popover-bottom > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-purple-light.bs-popover-bottom > .popover-arrow::before, .popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-purple-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--purple-rgb), 0.1);
}

.popover-teal-light.popover {
  border: 1px solid rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.popover .popover-header {
  background-color: rgba(var(--teal-rgb), 0.1);
  border-block-end: 1px solid rgba(var(--teal-rgb), 0.1);
  color: #02a8b5;
  border-radius: 0;
}
.popover-teal-light.popover .popover-body {
  background-color: rgba(var(--teal-rgb), 0.1);
  color: #02a8b5;
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-teal-light.bs-popover-top > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-teal-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-teal-light.bs-popover-end > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-teal-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-teal-light.bs-popover-start > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-teal-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-teal-light.bs-popover-bottom > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-teal-light.bs-popover-bottom > .popover-arrow::before, .popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-teal-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--teal-rgb), 0.1);
}

.timeline {
  position: relative;
  list-style: none;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0 20px;
}
.timeline:before {
  content: " ";
  position: absolute;
  width: 3px;
  margin-left: -1.5px;
  background-color: #898989;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
}
.timeline > li {
  position: relative;
  margin-bottom: 20px;
}
.timeline > li::before, .timeline > li::after {
  content: " ";
  display: table;
}
.timeline > li > .timeline-panel {
  float: left;
  position: relative;
  width: 46%;
  padding: 20px;
  border: 1px solid #6F7A7A;
  border-radius: 0.25rem;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}
.timeline > li > .timeline-panel::before {
  content: " ";
  display: inline-block;
  position: absolute;
  border-top: 8px solid transparent;
  border-right: 0 solid #6F7A7A;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #6F7A7A;
  position: absolute;
  top: 26px;
  right: -8px;
}
.timeline > li > .timeline-panel::after {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 27px;
  right: -7px;
  border-top: 7px solid transparent;
  border-right: 0 solid #FFF;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #FFF;
}

.timeline > li:after {
  clear: both;
}

.timeline > li > .timeline-badge {
  z-index: 1;
  width: 50px;
  height: 50px;
  margin-left: -25px;
  text-align: center;
  font-size: 1.4em;
  line-height: 50px;
  color: #FFF;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: 50%;
}

.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}
.timeline > li.timeline-inverted > .timeline-panel::before {
  right: auto;
  left: -8px;
  border-right-width: 8px;
  border-left-width: 0;
}
.timeline > li.timeline-inverted > .timeline-panel::after {
  right: auto;
  left: -7px;
  border-right-width: 7px;
  border-left-width: 0;
}

.timeline-badge.primary {
  background-color: #E41F07;
}

.timeline-badge.success {
  background-color: #5CB85C;
}

.timeline-badge.warning {
  background-color: #FDA700;
}

.timeline-badge.danger {
  background-color: #FC0027;
}

.timeline-badge.info {
  background-color: #1ECBE2;
}

.timeline-title {
  margin-top: 0;
  color: inherit;
  font-weight: regular;
}

.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
}

.timeline-body > p + p {
  margin-top: 5px;
}

.form-wrap {
  margin-bottom: 24px;
}

.col-form-label {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
}

.form-control {
  border-color: #E8E8E8;
  color: #6F6F6F;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  border-radius: 5px;
  padding: 0.5rem 0.85rem;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  min-height: 42px;
}
.form-control:focus {
  box-shadow: none;
  border-color: #E8E8E8;
  background-color: #FFF;
  box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.05);
  color: #6F6F6F;
}

.form-control[type=file] {
  padding: 0.3rem 0.5rem;
  line-height: 2.2;
}
.form-control[type=file].form-control-sm {
  padding: 0.25rem 0.5rem !important;
}
.form-control[type=file].form-control-lg {
  padding: 0.5rem 1rem !important;
}

.col-form-label {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
  padding: 0 0 5px;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
}

.form-text {
  color: #9595b5;
}

.form-control-light {
  background-color: #FDFDFE;
  border: 0;
}
.form-control-light:focus {
  background-color: #FDFDFE;
}

.form-control-primary {
  background-color: rgba(228, 31, 7, 0.1);
  border: 0;
  color: #E41F07;
}
.form-control-primary:focus {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}

.form-input-color {
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 4px;
  overflow: hidden;
  padding: 0;
}

.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  color: #9595b5;
}

.form-floating > .form-control:not(:placeholder-shown) ~ label::after {
  background-color: transparent;
}

.input-group-text {
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

.form-select {
  background-color: #ffffff;
  border: 1px solid #E8E8E8;
  color: #6F6F6F;
  font-size: 14px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: 1.25rem;
  line-height: 2;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}
.form-select option {
  background-color: #FFF;
  padding: 0.35rem 0.75rem;
  border-radius: 0.25rem;
  margin-block-end: 0.25rem;
}
.form-select option:last-child {
  margin-block-end: 0;
}
.form-select option:checked {
  background-color: rgba(var(#E41F07), 0.2);
  color: #E41F07;
}
.form-select option:select {
  background-color: rgba(var(#E41F07), 0.2);
  color: #E41F07;
}
.form-select option:hover {
  background-color: rgba(var(#E41F07), 0.2);
  color: #E41F07;
}
.form-select option:focus {
  background-color: rgba(var(#E41F07), 0.2);
  color: #E41F07;
}

.form-check-input {
  width: 0.9rem;
  height: 0.9rem;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
}
.form-check-input:checked {
  background-color: #E41F07;
  border-color: #E41F07;
}
.form-check-input.form-checked-outline:checked {
  background-color: transparent;
  border-color: #E41F07;
}
.form-check-input.form-checked-secondary:checked {
  background-color: #FFA201;
  border-color: #FFA201;
}
.form-check-input.form-checked-warning:checked {
  background-color: #FDA700;
  border-color: #FDA700;
}
.form-check-input.form-checked-info:checked {
  background-color: #1ECBE2;
  border-color: #1ECBE2;
}
.form-check-input.form-checked-success:checked {
  background-color: #5CB85C;
  border-color: #5CB85C;
}
.form-check-input.form-checked-danger:checked {
  background-color: #FC0027;
  border-color: #FC0027;
}
.form-check-input.form-checked-light:checked {
  background-color: #FDFDFE;
  border-color: #FDFDFE;
}
.form-check-input.form-checked-dark:checked {
  background-color: #171724;
  border-color: #171724;
}
.form-check-input:focus {
  box-shadow: none;
}

.form-checked-outline:checked[type=checkbox] {
  background-image: none;
  position: relative;
  background-color: transparent;
}
.form-checked-outline:checked[type=checkbox]:before {
  content: "\\f633";
  font-family: bootstrap-icons !important;
  position: absolute;
  color: #E41F07;
  width: 0.625rem;
  height: 0.625rem;
  inset-block-start: -1px;
  inset-inline-start: 0px;
  font-size: 0.688rem;
}
.form-checked-outline:checked[type=checkbox].form-checked-secondary:before {
  color: #FFA201;
}
.form-checked-outline:checked[type=checkbox].form-checked-warning:before {
  color: #FDA700;
}
.form-checked-outline:checked[type=checkbox].form-checked-info:before {
  color: #1ECBE2;
}
.form-checked-outline:checked[type=checkbox].form-checked-success:before {
  color: #5CB85C;
}
.form-checked-outline:checked[type=checkbox].form-checked-danger:before {
  color: #FC0027;
}
.form-checked-outline:checked[type=checkbox].form-checked-light:before {
  color: #FDFDFE;
}
.form-checked-outline:checked[type=checkbox].form-checked-dark:before {
  color: #171724;
}

.form-checked-outline:checked[type=radio] {
  background-image: none;
  position: relative;
  background-color: transparent;
}
.form-checked-outline:checked[type=radio]:before {
  content: "\\f309";
  font-family: bootstrap-icons !important;
  position: absolute;
  color: #E41F07;
  width: 0.625rem;
  height: 0.625rem;
  inset-block-start: -1.13rem;
  inset-inline-start: -0.6rem;
  font-size: 2rem;
}
.form-checked-outline:checked[type=radio].form-checked-secondary:before {
  color: #FFA201;
}
.form-checked-outline:checked[type=radio].form-checked-warning:before {
  color: #FDA700;
}
.form-checked-outline:checked[type=radio].form-checked-info:before {
  color: #1ECBE2;
}
.form-checked-outline:checked[type=radio].form-checked-success:before {
  color: #5CB85C;
}
.form-checked-outline:checked[type=radio].form-checked-danger:before {
  color: #FC0027;
}
.form-checked-outline:checked[type=radio].form-checked-light:before {
  color: #FDFDFE;
}
.form-checked-outline:checked[type=radio].form-checked-dark:before {
  color: #171724;
}

fieldset:disabled .btn {
  color: #FFF;
  background-color: #E41F07;
  border-color: #E41F07;
}

.form-select:focus {
  border-color: rgba(var(#E41F07), 0.5);
  outline: 0;
  box-shadow: none;
}

.btn-check:focus + .btn,
.btn:focus {
  background-color: none;
  border-color: none;
  outline: 0;
}

.btn-check:active + .btn:focus,
.btn-check:checked + .btn:focus,
.btn.active:focus,
.btn.show:focus,
.btn:active:focus {
  box-shadow: none;
}

.form-control:disabled,
.form-select:disabled {
  background-color: #FDFDFE;
  color: #6F6F6F;
}

.form-control-plaintext {
  color: #6F6F6F;
}

.form-control::-webkit-file-upload-button {
  color: #6F6F6F;
  background-color: #f7f8f9;
}

.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #f7f8f9;
}

.form-control:focus::-webkit-input-placeholder, .form-control:focus::placeholder {
  padding-inline-start: 0.3rem;
  -webkit-transition: padding-inline-start 0.1s ease-in;
  transition: padding-inline-start 0.1s ease-in;
}
.form-control::-webkit-input-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.7;
  color: #6F6F6F;
  padding-inline-start: 0px;
  -webkit-transition: padding-inline-start 0.1s ease-in;
  transition: padding-inline-start 0.1s ease-in;
}
.form-control:-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #6F6F6F;
}
.form-control::-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #6F6F6F;
}
.form-control:-ms-input-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #6F6F6F;
}

.form-control-sm {
  font-size: 0.8rem;
  padding: 0.25rem 0.8rem;
}

.form-control-lg {
  font-size: 1rem;
  padding: 0.5rem 1rem;
}

.form-check-md .form-check-input {
  width: 1.15rem;
  height: 1.15rem;
}
.form-check-md.form-switch .form-check-input {
  width: 2.25rem;
}
.form-check-md label {
  margin-inline-start: 0.5rem;
  font-size: 0.95rem;
  margin-block-start: 3px;
}

.form-check-lg .form-check-input {
  width: 1.35rem;
  height: 1.35rem;
}
.form-check-lg.form-switch .form-check-input {
  width: 2.5rem;
}
.form-check-lg label {
  margin-inline-start: 0.5rem;
  font-size: 1rem;
  margin-block-start: 3px;
}

.toggle {
  width: 3.75rem;
  height: 1.563rem;
  background-color: #FDFDFE;
  margin-inline-start: 0.625rem;
  margin-block-end: 0.313rem;
  padding: 0.125rem;
  border-radius: 0.188rem;
  position: relative;
  overflow: hidden;
  transition: all 0.2s ease;
}
.toggle span {
  position: absolute;
  inset-block-start: 0.188rem;
  inset-block-end: 0.25rem;
  inset-inline-start: 0.188rem;
  display: block;
  width: 1.25rem;
  border-radius: 0.125rem;
  background-color: #FFF;
  box-shadow: 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: all 0.2s ease;
}
.toggle span::before {
  content: "on";
  inset-inline-start: -1.563rem;
}
.toggle span::after {
  content: "off";
  inset-inline-end: -1.813rem;
  color: #9595b5;
}
.toggle span::before, .toggle span::after {
  position: absolute;
  font-size: 0.625rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  inset-block-start: 0.188rem;
  line-height: 1.38;
  transition: all 0.2s ease;
}
.toggle.on {
  background-color: rgba(var(#E41F07), 0.3);
}
.toggle.on span {
  background-color: #E41F07;
}
.toggle.on span::before {
  color: #E41F07;
}
.toggle.on.toggle-secondary {
  background-color: rgba(255, 162, 1, 0.4);
}
.toggle.on.toggle-secondary span {
  background-color: #FFA201;
}
.toggle.on.toggle-secondary span::before {
  color: #FFA201;
}
.toggle.on.toggle-warning {
  background-color: rgba(253, 167, 0, 0.4);
}
.toggle.on.toggle-warning span {
  background-color: #FDA700;
}
.toggle.on.toggle-warning span::before {
  color: #FDA700;
}
.toggle.on.toggle-info {
  background-color: rgba(30, 203, 226, 0.4);
}
.toggle.on.toggle-info span {
  background-color: #1ECBE2;
}
.toggle.on.toggle-info span::before {
  color: #1ECBE2;
}
.toggle.on.toggle-success {
  background-color: rgba(92, 184, 92, 0.4);
}
.toggle.on.toggle-success span {
  background-color: #5CB85C;
}
.toggle.on.toggle-success span::before {
  color: #5CB85C;
}
.toggle.on.toggle-danger {
  background-color: rgba(252, 0, 39, 0.4);
}
.toggle.on.toggle-danger span {
  background-color: #FC0027;
}
.toggle.on.toggle-danger span::before {
  color: #FC0027;
}
.toggle.on.toggle-light {
  background-color: rgba(253, 253, 254, 0.4);
}
.toggle.on.toggle-light span {
  background-color: #FDFDFE;
}
.toggle.on.toggle-light span::before, .toggle.on.toggle-light span::after {
  color: #9595b5;
}
.toggle.on.toggle-dark {
  background-color: rgba(23, 23, 36, 0.4);
}
.toggle.on.toggle-dark span {
  background-color: #171724;
}
.toggle.on.toggle-dark span::before {
  color: #FFF;
}
.toggle.on span {
  inset-inline-start: 2.313rem;
}
.toggle.on.toggle-sm span {
  inset-inline-start: 2.313rem;
}
.toggle.on.toggle-sm span::before {
  inset-block-start: -1px;
  inset-inline-start: -1.563rem;
}
.toggle.on.toggle-lg span {
  inset-inline-start: 2.563rem;
}
.toggle.on.toggle-lg span::before {
  inset-block-start: 0.5rem;
  inset-inline-start: -1.75rem;
}
.toggle.toggle-sm {
  height: 1.063rem;
  width: 3.125rem;
}
.toggle.toggle-sm span {
  width: 0.625rem;
  height: 0.625rem;
}
.toggle.toggle-sm span::after {
  inset-inline-end: -1.875rem;
  inset-block-start: -1px;
}
.toggle.toggle-lg {
  height: 2.125rem;
  width: 4.5rem;
}
.toggle.toggle-lg span {
  width: 1.75rem;
}
.toggle.toggle-lg span::after {
  inset-block-start: 0.5rem;
  inset-inline-end: -1.938rem;
}

.custom-toggle-switch > input[type=checkbox] {
  display: none;
}

.custom-toggle-switch > label {
  cursor: pointer;
  height: 0;
  position: relative;
  width: 2.5rem;
}

.label-primary {
  background: #E41F07;
  color: #FFF;
}

.label-secondary {
  background: #FFA201;
  color: #FFF;
}

.label-warning {
  background: #FDA700;
  color: #FFF;
}

.label-info {
  background: #1ECBE2;
  color: #FFF;
}

.label-success {
  background: #5CB85C;
  color: #FFF;
}

.label-danger {
  background: #FC0027;
  color: #FFF;
}

.label-light {
  background: #FDFDFE;
  color: #FFF;
}

.label-dark {
  background: #171724;
  color: #FFF;
}

.custom-toggle-switch > input[type=checkbox]:checked + label::before {
  background: inherit;
  opacity: 0.5;
}

.custom-toggle-switch > label::before {
  background: #9595b5;
  box-shadow: inset 0px 0px 0.625rem rgba(255, 255, 255, 0.5);
  border-radius: 0.5rem;
  content: "";
  height: 1rem;
  margin-block-start: -0.5rem;
  position: absolute;
  opacity: 0.3;
  transition: all 0.4s ease-in-out;
  width: 2.5rem;
}
.custom-toggle-switch > label::after {
  background: #FFF;
  border-radius: 1rem;
  box-shadow: 0 0 0.313rem rgba(228, 229, 237, 0.8);
  content: "";
  height: 1.5rem;
  inset-inline-start: -0.25rem;
  margin-block-start: -0.5rem;
  position: absolute;
  inset-block-start: -0.25rem;
  transition: all 0.3s ease-in-out;
  width: 1.5rem;
}

.custom-toggle-switch > input[type=checkbox]:checked + label::after {
  background: inherit;
  inset-inline-start: 50%;
}

.custom-toggle-switch.toggle-sm > label::before {
  height: 10px;
  width: 27px;
  border-radius: 10px;
}

.custom-toggle-switch.toggle-sm input[type=checkbox]:checked + label::after {
  inset-inline-start: 13px;
}

.custom-toggle-switch.toggle-sm > label::after {
  height: 17px;
  width: 17px;
  border-radius: 50%;
}

.custom-toggle-switch.toggle-lg > label::before {
  height: 27px;
  width: 55px;
  border-radius: 20px;
}

.custom-toggle-switch.toggle-lg input[type=checkbox]:checked + label::after {
  inset-inline-start: 77%;
}

.custom-toggle-switch.toggle-lg > label::after {
  height: 35px;
  width: 35px;
  margin-block-start: -8px;
  border-radius: 50%;
}

.form-floating > .form-control-plaintext::placeholder,
.form-floating > .form-control::placeholder {
  color: transparent !important;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem - 4px);
}

.form-floating.floating-primary label {
  color: #E41F07;
  opacity: 1;
}
.form-floating.floating-primary input {
  border: 1px solid #E41F07;
}
.form-floating.floating-primary > .form-control:focus ~ label {
  color: #E41F07 !important;
}
.form-floating.floating-secondary label {
  color: #FFA201;
  opacity: 1;
}
.form-floating.floating-secondary input {
  border: 1px solid #FFA201;
}
.form-floating.floating-secondary > .form-control:focus ~ label {
  color: #FFA201 !important;
}
.form-floating.floating-warning label {
  color: #FDA700;
  opacity: 1;
}
.form-floating.floating-warning input {
  border: 1px solid #FDA700;
}
.form-floating.floating-warning > .form-control:focus ~ label {
  color: #FDA700 !important;
}
.form-floating.floating-info label {
  color: #1ECBE2;
  opacity: 1;
}
.form-floating.floating-info input {
  border: 1px solid #1ECBE2;
}
.form-floating.floating-info > .form-control:focus ~ label {
  color: #1ECBE2 !important;
}
.form-floating.floating-success label {
  color: #5CB85C;
  opacity: 1;
}
.form-floating.floating-success input {
  border: 1px solid #5CB85C;
}
.form-floating.floating-success > .form-control:focus ~ label {
  color: #5CB85C !important;
}
.form-floating.floating-danger label {
  color: #FC0027;
  opacity: 1;
}
.form-floating.floating-danger input {
  border: 1px solid #FC0027;
}
.form-floating.floating-danger > .form-control:focus ~ label {
  color: #FC0027 !important;
}

.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-select ~ label::after {
  background-color: #FFF;
  border-radius: 4px;
}

.form-wizard-1 {
  border-bottom: 0;
  border-radius: 50px;
}
.form-wizard-1 .nav-link {
  border: 0;
}
.form-wizard-1.nav-tabs .nav-item {
  margin-inline-end: 1rem;
  position: relative;
}
.form-wizard-1.nav-tabs .nav-link {
  padding: 0.25rem 0.4rem;
  color: #9595b5;
  display: flex;
  align-items: center;
  border-radius: 50px;
  border: 2px solid transparent;
}
.form-wizard-1.nav-tabs .nav-link i {
  font-size: 12px;
  padding: 4px;
  line-height: 1;
  border-radius: 50px;
  border: 2px solid #E8E8E8;
}
.form-wizard-1.nav-tabs .nav-link:focus, .form-wizard-1.nav-tabs .nav-link:hover {
  border: 2px solid transparent;
}
.form-wizard-1.nav-tabs .nav-link.active {
  border: 2px solid #E41F07;
  border-radius: 50px;
  color: #E41F07;
  background-color: transparent;
}
.form-wizard-1.nav-tabs .nav-link.active i {
  border: 2px solid #E41F07;
}
.form-wizard-1 .nav-item:focus-visible {
  outline: none;
}

.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
  border-color: #5CB85C;
  box-shadow: none;
}

.form-control.is-valid,
.was-validated .form-control:valid {
  border-color: #5CB85C;
}

.form-control-color {
  width: 1.75rem;
  height: 1.75rem;
  overflow: hidden;
  padding: 0;
}

.example-picker .pcr-button {
  border-radius: 0.35rem !important;
  overflow: hidden;
}

[dir=rtl] [type=email],
[dir=rtl] [type=number],
[dir=rtl] [type=tel],
[dir=rtl] [type=url] {
  direction: rtl;
}

.form-select.is-invalid:not([multiple]):not([size]) {
  padding-right: 1.125rem;
  background-size: 16px 28px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.invoice-quantity-container .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: 0;
}

input[type=range]::-webkit-slider-runnable-track {
  background-color: #FDFDFE;
}

[dir=rtl] .form-checked-outline:checked[type=checkbox]:before {
  inset-inline-start: 1px;
}

.is-invalid ~ .invalid-feedback, .is-invalid ~ .invalid-tooltip, .was-validated :invalid ~ .invalid-feedback, .was-validated :invalid ~ .invalid-tooltip {
  display: inline-block;
}

.is-valid ~ .valid-feedback, .is-valid ~ .valid-tooltip, .was-validated :valid ~ .valid-feedback, .was-validated :valid ~ .valid-tooltip {
  display: inline-block;
}

.invalid-tooltip, .valid-tooltip {
  position: relative;
  top: 0;
}

.form-check {
  min-height: inherit !important;
}

.col-form-label-lg,
.col-form-label-sm,
.col-form-label {
  font-weight: 500;
}

#exampleColorInput::-webkit-color-swatch-wrapper {
  direction: rtl;
}

[data-theme-mode=dark] input[type=week]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=month]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=date]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=datetime-local]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=time]::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

[dir=rtl] input[type=week], [dir=rtl] input[type=month], [dir=rtl] input[type=date], [dir=rtl] input[type=datetime-local], [dir=rtl] input[type=time] {
  text-align: end;
}

.form-control.form-control-lg {
  height: 46px;
}
.form-control.form-control-sm {
  height: 30px;
  min-height: 30px;
}

.input-group-sm .input-group-text {
  height: 35px;
}
.input-group-sm .form-control {
  height: 35px;
  min-height: 35px;
}

.input-icon-addon {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  color: #515B73;
  pointer-events: none;
  font-size: 1.2em;
}

.checkboxs {
  display: block;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  padding-left: 25px;
}
.checkboxs input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkboxs input ~ .checkmarks {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}

.checkboxs input:checked ~ .checkmarks {
  background-color: #4A00E5;
  border-color: #4A00E5;
}

.checkboxs input:checked ~ .checkmarks:after {
  display: block;
}

.checkboxs .checkmarks {
  height: 16px;
  width: 16px;
  position: absolute;
  top: 0;
  left: 0;
}

.checkboxs .checkmarks:after {
  content: "";
  position: absolute;
  display: none;
}

.checkboxs .checkmarks:after {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #FFF;
  font-weight: 600;
  font-size: 10px;
}

.status-radio:checked,
.status-radio:not(:checked) {
  position: absolute;
  left: -9999px;
}

.status-radio:checked + label,
.status-radio:not(:checked) + label {
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  line-height: 16px;
  display: inline-block;
  color: #262A2A;
}

.status-radio:checked + label:before,
.status-radio:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 16px;
  height: 16px;
  border: 1px solid #E8E8E8;
  border-radius: 100%;
  background: #FFF;
}

.status-radio:checked + label:before {
  background: #0092E4;
  border-color: #0092E4;
}

.status-radio[type=radio]:checked + label:after,
.status-radio[type=radio]:not(:checked) + label:after {
  content: "";
  width: 8px;
  height: 8px;
  background: #FFF;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  transition: all 0.2s ease;
}

[type=radio]:not(:checked) + label:after {
  opacity: 0;
  transform: scale(0);
}

[type=radio]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}

.bootstrap-tagsinput {
  border-color: #F6F6F6;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
  font-size: 14px;
  color: #6F6F6F;
  min-height: 42px;
  line-height: 2;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-height: 42px;
  overflow-y: auto;
}
.bootstrap-tagsinput .tag {
  background: #F6F6F6;
  color: #6F6F6F;
  padding: 2px 5px;
  line-height: normal;
  border-radius: 5px;
  font-size: 14px;
}

.notes-page-wrapper .content {
  padding: 24px;
}
.notes-page-wrapper .content .page-add-notes {
  border-bottom: 1px solid #E8E8E8;
  padding-bottom: 25px;
  position: relative;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .notes-page-wrapper .content .page-add-notes {
    flex-direction: column;
    align-items: start;
  }
}
.notes-page-wrapper .content .page-add-notes .notes-tog {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  bottom: -12px;
  border-radius: 30px;
  background: #1B2850;
  color: #FFF;
  width: 24px;
  height: 24px;
  padding: 5px;
}
@media (max-width: 991.98px) {
  .notes-page-wrapper .content .page-add-notes .notes-tog {
    display: none;
  }
}
.notes-page-wrapper .content .section-bulk-wrap {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin: 30px 0 24px 0;
  padding: 20px;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
}
@media (max-width: 767.98px) {
  .notes-page-wrapper .content .section-bulk-wrap {
    flex-direction: column;
    align-items: start;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
@media (max-width: 767.98px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
    margin-bottom: 20px;
  }
}
@media (max-width: 575.98px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
    margin-bottom: 0;
    flex-direction: column;
    align-items: self-start;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk {
  margin-right: 8px;
  height: 40px;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk .select2-container .selection .select2-selection .select2-selection__rendered {
  padding-left: 10px !important;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added {
  background: #6F7A7A;
  padding: 8px 20px;
  color: #FFF;
  font-size: 15px;
  font-weight: 400;
  margin-right: 15px;
  height: 40px;
  line-height: normal;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added:hover {
  background: #E41F07;
}
@media (max-width: 575.98px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added {
    margin: 20px 0;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .form-sort .fa-filter {
  z-index: 100 !important;
  position: absolute;
  top: 15px;
  left: 15px;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-notes-slider {
  position: relative;
  padding-bottom: 40px;
  border-bottom: 1px solid #E8E8E8;
}
.notes-page-wrapper .content .section-notes-slider .notes-content {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
.notes-page-wrapper .content .section-notes-slider .notes-content .notes-close a {
  color: #FC0027;
  font-size: 15px;
  font-weight: 400;
}
.notes-page-wrapper .content .section-notes-slider .notes-content .notes-close a i {
  margin-right: 6px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card {
  padding: 24px;
  border-radius: 8px;
  background: rgba(255, 159, 67, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card.medium {
  background: rgba(116, 41, 248, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card.high {
  background: rgba(234, 84, 85, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged {
  border-radius: 8px;
  border: 1px solid #FDA700;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FDA700;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged i {
  font-size: 7px;
  margin-right: 4px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged.medium {
  color: #7429F8;
  border: 1px solid #7429F8;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged.high {
  color: #FC0027;
  border: 1px solid #FC0027;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #6F7A7A;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a.dropdown-item:hover {
  color: #262A2A;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a.dropdown-item:hover svg {
  color: #262A2A;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content {
  margin: 24px 0;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content h4 a {
  margin-bottom: 10px;
  color: #6F7A7A;
  font-size: 16px;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content h4 a:hover {
  color: #FDA700;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a {
  margin-right: 15px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a span {
  width: 32px;
  height: 32px;
  display: flex;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a span img {
  border-radius: 100px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.medium-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.medium-square i {
  color: #5CB85C;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.high-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.high-square i {
  color: #FDA700;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.low-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.low-square i {
  color: #288EC7;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #288EC7;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p i.fa-draw-polygon {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p.medium {
  color: #5CB85C;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p.high {
  color: #FDA700;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete span .fa-star {
  color: #FDA700;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete span .feather-trash-2 {
  color: #FC0027;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-card-body {
  padding-top: 40px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details {
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);
  padding: 24px;
  margin-bottom: 24px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border-radius: 8px;
  border: 1px solid #FDA700;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FDA700;
  font-size: 14px;
  font-weight: 600;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged i {
  font-size: 7px;
  margin-right: 4px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged.medium {
  color: #7429F8;
  border: 1px solid #7429F8;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged.high {
  color: #FC0027;
  border: 1px solid #FC0027;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #6F7A7A;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item span svg {
  width: 14px;
  height: 14px;
  color: #6F6F6F;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item:hover span svg {
  color: #FFF;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content {
  padding: 20px 0;
  border-bottom: 1px solid #E8E8E8;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content h4 a {
  color: #6F7A7A;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content h4 a:hover {
  color: #FDA700;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content .wrap-cal {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content .wrap-cal svg {
  margin-right: 5px;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget.notes-widget-profile {
  padding-top: 20px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo a {
  margin-right: 15px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo a span img {
  border-radius: 100px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.medium-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.medium-square i {
  color: #5CB85C;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.high-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.high-square i {
  color: #FDA700;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.low-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.low-square i {
  color: #288EC7;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p {
  color: #288EC7;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p i.fa-draw-polygon {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p.medium {
  color: #5CB85C;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p.high {
  color: #FDA700;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete span .feather-star {
  color: #6F6F6F;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete span .feather-trash-2 {
  color: #FC0027;
  width: 16px;
  height: 16px;
}

.notes-card-details .notes-card-body a {
  color: #6F7A7A;
}

.star-todo-inbox svg {
  width: 13px;
  height: 13px;
  color: #6F6F6F;
}

.inbox-call-profile {
  border-radius: 5px;
  background: #E92990;
  border: 1px solid #E92990;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 700;
  color: #FFF;
  margin: 0 20px;
}
.inbox-call-profile:hover {
  color: #E92990;
  background: #FFF;
}

.notes-tog i {
  transform: rotate(180deg);
}
.notes-tog.active i {
  transform: rotate(0deg);
}

.section-bulk-wrap .form-sort {
  position: relative;
}
.section-bulk-wrap .form-sort svg.feather-filter {
  position: absolute;
  z-index: 101;
  width: 16px;
  height: 16px;
  top: 12px;
  left: 10px;
}

.page-add-notes.active svg {
  transform: rotate(0) !important;
}

.dropdown-menu.notes-menu {
  z-index: 99999;
}
.dropdown-menu.notes-menu a.dropdown-item {
  color: #6F7A7A;
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
}
.dropdown-menu.notes-menu a.dropdown-item:hover {
  background: #F6F6F6;
  color: #262A2A;
}
.dropdown-menu.notes-menu a.dropdown-item:hover svg {
  color: #262A2A;
}
.dropdown-menu.notes-menu span {
  margin-right: 8px;
}
.dropdown-menu.notes-menu svg {
  width: 14px;
  height: 14px;
  color: #6F6F6F;
}

.edit-note-head a {
  border-radius: 30px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  color: #6F7A7A;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.edit-note-head a:hover {
  border-radius: 20px;
  background: #E41F07;
  color: #FFF;
}

.custom-modal-body .select2-container .selection .select2-selection .select2-selection__rendered {
  padding-left: 10px !important;
}

.bulk-con-wrap {
  width: 100%;
}

.section-bulk-widget {
  transition: 0.6s all;
}

.section-notes-dashboard {
  display: none;
  transition: 0.6s all;
}

.notes-tog i {
  transition: 0.5s all;
}

.notes-tag-left .notes-tog i {
  transform: rotate(360deg);
  transition: 0.5s all;
}

.budgeted-role-notes {
  width: 100%;
}

.notes-summernote .card {
  margin-bottom: 0 !important;
}

.dropdown-item:active {
  background: transparent;
}

.notes-summernote p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
}

.budget-role-notes .owl-carousel .owl-nav {
  margin: 0;
  position: absolute;
}

.notes-dash {
  margin-top: 30px;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  transition: 0.6s all;
}
.notes-dash .notes-top-head {
  border-bottom: 1px solid #E8E8E8;
}
.notes-dash .notes-top-head h5 {
  font-size: 18px;
  font-weight: 700;
  color: #6F7A7A;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.notes-dash .notes-top-head h5 svg {
  width: 19px;
  height: 19px;
  margin-right: 6px;
  color: #6F6F6F;
}
.notes-dash .notes-top-head-submenu {
  padding: 15px 0;
  border-bottom: 1px solid #E8E8E8;
}
.notes-dash .notes-top-head-submenu ul {
  padding: 15px 0;
}
.notes-dash .notes-top-head-submenu ul li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 10px;
}
.notes-dash .notes-top-head-submenu ul li.active {
  border-radius: 10px;
  background: #6F7A7A;
}
.notes-dash .notes-top-head-submenu ul li.active svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-dash .notes-top-head-submenu ul li.active p {
  color: #FFF;
}
.notes-dash .notes-top-head-submenu ul li p {
  font-size: 15px;
  font-weight: 600;
  color: #6F6F6F;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.notes-dash .notes-top-head-submenu ul li p svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-dash .notes-top-head-submenu ul li span {
  display: flex;
  width: 18px;
  height: 18px;
  padding: 0px 3px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #E41F07;
  color: #FFF;
}
.notes-dash .content-submenu-tag {
  margin-top: 15px;
  padding: 10px;
}
.notes-dash .content-submenu-tag h6 {
  font-size: 16px;
  font-weight: 600;
  color: #6F7A7A;
}
.notes-dash .content-submenu-tag ul {
  padding: 10px 0;
}
.notes-dash .content-submenu-tag ul.tags-list {
  margin-bottom: 24px;
}
.notes-dash .content-submenu-tag ul li.personal span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.personal span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.personal a {
  color: #288EC7;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.social span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.social span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.social a {
  color: #FDA700;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.work span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.work span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.work a {
  color: #5CB85C;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.public span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.public span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.public a {
  color: #A02F7A;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.medium span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.medium span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.medium a {
  color: #4A00E5;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.high span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.high span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.high a {
  color: #FC0027;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.low span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.low span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.low a {
  color: #FDA700;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li {
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li + li {
  margin-top: 10px;
}

.notes-logo a {
  display: flex;
  align-items: center;
}
.notes-logo a span {
  width: 32px;
  height: 32px;
}
.notes-logo a span img {
  border-radius: 32px;
}

.notes-top-head-submenu {
  padding: 15px 0;
  border-bottom: 1px solid #6F6F6F;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox {
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #6F6F6F;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 5px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox.active {
  border-radius: 5px;
  background: #212B36;
  padding: 10px;
  color: #FFF;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox.active svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox:hover {
  background: #212B36;
  color: #FFF;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox span {
  display: flex;
  width: 20px;
  height: 20px;
  padding: 0px 3px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #E41F07;
  color: #FFF;
}

.notes-trash-btn {
  background: #FC0027;
  color: #FFF;
  border-radius: 8px;
  margin: 4px 0 20px 0;
  padding: 10px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notes-trash-btn span {
  display: flex;
  align-items: center;
}
.notes-trash-btn span svg {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.delete-popup {
  padding: 24px;
  border-radius: 8px;
  background: #FFF;
}
.delete-popup .delete-image {
  margin-bottom: 20px;
}
.delete-popup .delete-heads {
  text-align: center;
}
.delete-popup .delete-heads h4 {
  color: #6F7A7A;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
}
.delete-popup .delete-heads p {
  color: #6F6F6F;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
}
.delete-popup .delete-footer {
  text-align: center;
}

.edit-page-title {
  display: flex;
  align-items: center;
}
.edit-page-title h4 {
  font-size: 18px;
  font-weight: 700;
  color: #6F7A7A;
  margin-bottom: 0;
  margin-right: 10px;
}
.edit-page-title p {
  font-size: 15px;
  font-weight: 400;
  color: #288EC7;
}

.edit-head-view {
  margin-bottom: 20px;
  border-bottom: rgba(145, 158, 171, 0.3);
}
.edit-head-view h6 {
  font-size: 16px;
  font-weight: 600;
  color: #6F7A7A;
  margin-bottom: 15px;
}
.edit-head-view p {
  font-size: 15px;
  font-weight: 400;
  color: #6F6F6F;
  margin-bottom: 15px;
}
.edit-head-view p.badged i {
  font-size: 7px;
  margin-right: 7px;
}
.edit-head-view p.badged {
  border-radius: 8px;
  border: 1px solid #FDA700;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FDA700;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}

.edit-footer-menu a {
  background-color: #FC0027;
}

.edit-noted-head a span i.fa-trash-alt {
  color: #FC0027;
  margin-right: 10px;
}
.edit-noted-head a span i.fa-star {
  color: #FDA700;
}

.edit-head-view p.badged.high i {
  font-size: 7px;
  margin-right: 7px;
}
.edit-head-view p.badged.high {
  border-radius: 8px;
  border: 1px solid #FC0027;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FC0027;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}

.people-profile-pic {
  border: none !important;
  margin-left: 14px;
  position: relative;
}
.people-profile-pic img {
  border-radius: 10px;
}
.people-profile-pic a {
  position: absolute;
  top: 15px;
  right: 7px;
}
.people-profile-pic a .x-square-add {
  border-radius: 3px;
  background: #FC0027;
  color: #FFF;
}

.people-customer-walk {
  max-width: 35px;
}

.custom-pagination .paginations {
  align-items: center;
}
.custom-pagination .paginations span {
  display: flex;
  align-items: center;
  color: #6F6F6F;
  width: 16px;
  height: 16px;
}
.custom-pagination .paginations span .fa-chevron-left {
  margin-right: 8px;
}
.custom-pagination .paginations .page-wrap li a {
  margin-right: 8px;
  border-radius: 85px;
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  width: 30px;
  height: 30px;
  padding: 5px;
  justify-content: center;
  align-items: center;
}
.custom-pagination .paginations .page-wrap li a.active {
  background: #E41F07;
  color: #FFF;
}
.custom-pagination .paginations .page-wrap li :hover {
  background: #E41F07;
  color: #FFF;
  transition: 0.3s all;
}

.section-notes-slider .notes-slider.owl-carousel .owl-nav {
  top: -42px;
  right: unset;
  left: 170px;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button {
  background-color: transparent;
  width: 15px;
  height: auto;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button i {
  color: #6F7A7A;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button:hover {
  background-color: transparent;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button:hover i {
  color: #E41F07;
}

.form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
.form-sort span.select2-container.select2-container--default.select2-container--open {
  z-index: 99;
}

.accordion-button:after, .accordion-button:not(.collapsed)::after {
  display: none;
}

.todo-accordion .accordion-item {
  background: transparent;
  margin-bottom: 10px;
  border: 0;
  padding: 0;
}

.search-set {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.search-set .search-input {
  position: relative;
  margin-right: 15px;
}
.search-set .search-input input[type=search] {
  height: 38px;
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: var(--White, #FFF);
  width: 298px;
  border-radius: 5px;
  padding: 10px;
}
.search-set .search-input input[type=search]::placeholder {
  color: #000;
}
@media (max-width: 1199.98px) {
  .search-set .search-input input[type=search] {
    width: 220px;
  }
}
@media (max-width: 991.98px) {
  .search-set .search-input input[type=search] {
    width: 200px;
  }
}
@media (max-width: 575.98px) {
  .search-set .search-input input[type=search] {
    width: auto;
  }
}
.search-set .search-input .btn-searchset {
  border-radius: 50px;
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
}
.search-set .search-input .btn-searchset .feather-search {
  width: 14px;
  height: 14px;
}

.page-add-notes {
  display: flex;
  flex-wrap: wrap;
}

.todo-inbox-check {
  margin-right: 15px;
}
.todo-inbox-check .checkboxs {
  margin-bottom: 0;
  padding-left: 25px;
  display: flex;
  align-items: center;
}
.todo-inbox-check .checkboxs input ~ .checkmarks {
  border-color: rgba(145, 158, 171, 0.3);
  border-radius: 5px;
  margin-top: 2px;
  width: 20px;
  height: 20px;
}
.todo-inbox-check .checkboxs input:checked ~ .checkmarks {
  border-color: #E41F07;
  background-color: #E41F07;
}

.btn-cancel {
  background: #565E5E;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  transition: all 0.5s ease;
}
.btn-cancel:hover {
  background: #424b52;
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-cancel {
    min-width: auto;
  }
}

.swal2-confirm {
  margin-right: 5px;
}

.btn-submit {
  background: #E41F07;
  color: #FFF;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  transition: all 0.2s ease;
}
.btn-submit:hover {
  background: rgb(178.5191489362, 24.2723404255, 5.4808510638);
  color: #FFF;
}
@media (max-width: 991.98px) {
  .btn-submit {
    min-width: auto;
  }
}

.sections-notes-slider .accordion-button:after {
  display: none;
}

.todo-wrapper-list-content {
  margin-left: 5px;
}

.notes-header h3 {
  color: #6F7A7A;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 0;
}

.todo-inbox-check .checkboxs .checkmarks:after {
  left: 9px;
  top: 10px;
}

.checkboxs input:checked ~ .checkmarks:after {
  display: block;
}

.todo-widget {
  margin-bottom: 25px;
}

.todo-today-content {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.todo-today-content .todo-drop-down span i {
  color: #6F7A7A;
}
.todo-today-content .todo-today-header {
  display: flex;
  align-items: center;
}
.todo-today-content .todo-today-header span {
  margin-right: 5px;
  display: flex;
  align-items: center;
}
.todo-today-content .todo-today-header span svg {
  width: 16px;
  height: 16px;
  color: #6F6F6F;
}
.todo-today-content .todo-today-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #6F7A7A;
  margin-bottom: 0;
  margin-right: 5px;
}
.todo-today-content .todo-today-header h6 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background-color: #E41F07;
  border-radius: 50px;
  color: #FFF;
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 0;
}

.todo-wrapper-list {
  padding: 15px;
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #FFF;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
@media (max-width: 575.98px) {
  .todo-wrapper-list {
    flex-direction: column;
  }
}
.todo-wrapper-list .todo-inbox-check {
  display: flex;
  align-items: center;
}
.todo-wrapper-list .todo-inbox-check .todo-wrapper-list-content h4 {
  font-size: 16px;
  font-weight: 700;
  color: #6F7A7A;
  margin-bottom: 5px;
}
.todo-wrapper-list .todo-inbox-check .todo-wrapper-list-content p {
  font-size: 13px;
  font-weight: 500;
  color: #6F6F6F;
  margin-bottom: 0;
}
.todo-wrapper-list .todo-inbox-check.todo-inbox-check-list {
  width: 45%;
}
@media (max-width: 575.98px) {
  .todo-wrapper-list .todo-inbox-check.todo-inbox-check-list {
    width: auto;
  }
}
.todo-wrapper-list .todo-inbox-check.todo-inbox-check-list .checkboxs {
  margin-bottom: 12px;
}
.todo-wrapper-list .todo-inbox-check.todo-inbox-check-list .checkboxs input ~ .checkmarks {
  border-radius: 5px;
  margin-top: 0;
}
.todo-wrapper-list .notes-card-body {
  width: 35%;
}
@media (max-width: 575.98px) {
  .todo-wrapper-list .notes-card-body {
    width: auto;
    margin: 20px 0;
  }
}
.todo-wrapper-list .notes-card-body p {
  display: flex;
  align-items: center;
}
.todo-wrapper-list .notes-card-body p.high {
  border-radius: 8px;
  border: 1px solid #FC0027;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 600;
  color: #FC0027;
  margin-right: 10px;
}
.todo-wrapper-list .notes-card-body p.medium {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #423B93;
  font-size: 14px;
  font-family: 600;
  color: #423B93;
}
.todo-wrapper-list .notes-card-body p.pending {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #288EC7;
  font-size: 14px;
  font-family: 600;
  color: #288EC7;
}
.todo-wrapper-list .notes-card-body p.low {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #FDA700;
  font-size: 14px;
  font-family: 600;
  color: #FDA700;
}
.todo-wrapper-list .notes-card-body p.success {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #5CB85C;
  font-size: 14px;
  font-family: 600;
  color: #5CB85C;
}
.todo-wrapper-list .notes-card-body p i.fa-circle {
  font-size: 7px;
  margin-right: 4px;
}
.todo-wrapper-list .todo-strike-content h4 {
  text-decoration-line: line-through;
}
.todo-wrapper-list .todo-strike-content p {
  text-decoration-line: line-through;
}
.todo-wrapper-list .todo-profile {
  width: 20%;
  justify-content: end;
}
.todo-wrapper-list .todo-profile img {
  border-radius: 30px;
  margin-right: 16px;
  width: 30px;
  height: 30px;
}
.todo-wrapper-list .todo-profile a .fa-ellipsis-v {
  color: #6F7A7A;
}

.datanew tbody {
  border-top: 1px solid #E8E8E8;
}

.form-sort {
  position: relative;
  width: 149px;
  height: 40px;
}
.form-sort .info-img {
  position: absolute;
  top: 52%;
  z-index: 100;
  width: 16px;
  height: 16px;
  left: 0;
  margin-left: 10px;
  color: #6F6F6F;
  transform: translateY(-50%);
  line-height: normal;
}
@media (max-width: 575.98px) {
  .form-sort {
    margin-top: 24px;
  }
}

.todo-calendar .input-groupicon.calender-input input {
  padding-left: 10px;
}

.todo-calendar {
  position: relative;
}
.todo-calendar .calender-input {
  position: relative;
}
.todo-calendar .calender-input .info-img {
  position: absolute;
  top: 11px;
  z-index: 100;
  width: 16px;
  height: 16px;
  right: 5px !important;
  color: #6F6F6F;
}

.todo-accordion .accordion-item {
  background: transparent;
  margin-bottom: 20px;
}
.todo-accordion .accordion-item .accordion-header {
  cursor: pointer;
}
.todo-accordion .accordion-item .accordion-header .accordion-button {
  background: transparent;
  padding: 0;
}
.todo-accordion .accordion-item .accordion-header .accordion-button.collapsed .todo-today-content {
  margin-bottom: 0;
}
.todo-accordion .accordion-item .accordion-header .todo-today-content {
  width: 100%;
}
.todo-accordion .accordion-item .accordion-header .todo-drop-down a span i {
  color: #6F6F6F;
}
.todo-accordion .accordion-item .accordion-body {
  padding: 0;
}
.todo-accordion .accordion-item .todo-widget {
  margin-bottom: 0;
}
.todo-accordion .accordion-item .todo-widget .todo-wrapper-list:last-child {
  margin-bottom: 0;
}

caption {
  color: #9595b5;
}

.table-active {
  --bs-table-color-state: var(--default-text-color);
}

.table {
  color: #6F6F6F;
  border-color: #E8E8E8;
  margin-block-end: 0;
}
.table .checkboxs {
  margin-bottom: 15px;
}
.table tbody tr th {
  font-weight: 500;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  line-height: 1.462;
  font-size: 0.813rem;
  white-space: nowrap;
}
.table thead tr th {
  font-weight: 600;
  font-size: 15px;
}
.table.table-sm > :not(caption) > * > * {
  padding: 0.3rem;
}
.table.table-dark {
  color: #F2ECFF;
  border-color: rgba(255, 255, 255, 0.1);
}
.table .thead-primary th {
  background-color: #E41F07;
  color: #FFF;
}
.table .thead-secondary th {
  background-color: #FFA201;
  color: #FFF;
}
.table .thead-info th {
  background-color: #1ECBE2;
  color: #FFF;
}
.table .thead-warning th {
  background-color: #FDA700;
  color: #FFF;
}
.table .thead-danger th {
  background-color: #FC0027;
  color: #FFF;
}
.table .thead-success th {
  background-color: #5CB85C;
  color: #FFF;
}
.table .thead-dark th {
  background-color: #171724;
  color: #FFF;
}
.table .thead-light th {
  background-color: #FAFAFA;
  color: #171724;
}
.table.table-primary {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.2);
}
.table.table-primary.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--primary-rgb), 0.2);
  color: #000;
}
.table.table-primary.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--primary-rgb), 0.4);
  color: #FFF;
}
.table.table-primary .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--primary-rgb));
  color: #FFF;
}
.table.table-secondary {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.2);
}
.table.table-secondary.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--secondary-rgb), 0.2);
  color: #000;
}
.table.table-secondary.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--secondary-rgb), 0.4);
  color: #FFF;
}
.table.table-secondary .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--secondary-rgb));
  color: #FFF;
}
.table.table-warning {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.2);
}
.table.table-warning.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--warning-rgb), 0.2);
  color: #000;
}
.table.table-warning.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--warning-rgb), 0.4);
  color: #FFF;
}
.table.table-warning .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--warning-rgb));
  color: #FFF;
}
.table.table-success {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--success-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.2);
}
.table.table-success.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--success-rgb), 0.2);
  color: #000;
}
.table.table-success.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--success-rgb), 0.4);
  color: #FFF;
}
.table.table-success .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--success-rgb));
  color: #FFF;
}
.table.table-danger {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.2);
}
.table.table-danger.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--danger-rgb), 0.2);
  color: #000;
}
.table.table-danger.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--danger-rgb), 0.4);
  color: #FFF;
}
.table.table-danger .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--danger-rgb));
  color: #FFF;
}
.table.table-info {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--info-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.2);
}
.table.table-info.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--info-rgb), 0.2);
  color: #000;
}
.table.table-info.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--info-rgb), 0.4);
  color: #FFF;
}
.table.table-info .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--info-rgb));
  color: #FFF;
}
.table.table-light {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--light-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.2);
}
.table.table-light.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--light-rgb), 0.2);
  color: #000;
}
.table.table-light.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--light-rgb), 0.4);
  color: #FFF;
}
.table.table-light .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--light-rgb));
  color: #FFF;
}
.table.table-dark {
  background-color: #FFF;
  color: #000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.2);
}
.table.table-dark.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--dark-rgb), 0.2);
  color: #000;
}
.table.table-dark.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--dark-rgb), 0.4);
  color: #FFF;
}
.table.table-dark .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--dark-rgb));
  color: #FFF;
}
.table.table-bordered.border-primary tbody,
.table.table-bordered.border-primary td,
.table.table-bordered.border-primary tfoot,
.table.table-bordered.border-primary th,
.table.table-bordered.border-primary thead,
.table.table-bordered.border-primary tr {
  border-color: rgba(228, 31, 7, 0.1);
}
.table.table-bordered.border-info tbody,
.table.table-bordered.border-info td,
.table.table-bordered.border-info tfoot,
.table.table-bordered.border-info th,
.table.table-bordered.border-info thead,
.table.table-bordered.border-info tr {
  border-color: rgba(30, 203, 226, 0.1);
}
.table.table-bordered.border-secondary tbody,
.table.table-bordered.border-secondary td,
.table.table-bordered.border-secondary tfoot,
.table.table-bordered.border-secondary th,
.table.table-bordered.border-secondary thead,
.table.table-bordered.border-secondary tr {
  border-color: rgba(255, 162, 1, 0.1);
}
.table.table-bordered.border-warning tbody,
.table.table-bordered.border-warning td,
.table.table-bordered.border-warning tfoot,
.table.table-bordered.border-warning th,
.table.table-bordered.border-warning thead,
.table.table-bordered.border-warning tr {
  border-color: rgba(253, 167, 0, 0.1);
}
.table.table-bordered.border-success tbody,
.table.table-bordered.border-success td,
.table.table-bordered.border-success tfoot,
.table.table-bordered.border-success th,
.table.table-bordered.border-success thead,
.table.table-bordered.border-success tr {
  border-color: rgba(92, 184, 92, 0.1);
}
.table.table-bordered.border-danger tbody,
.table.table-bordered.border-danger td,
.table.table-bordered.border-danger tfoot,
.table.table-bordered.border-danger th,
.table.table-bordered.border-danger thead,
.table.table-bordered.border-danger tr {
  border-color: rgba(252, 0, 39, 0.1);
}
.table.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: rgba(var(--dark-rgb),0.0125);
  color: #6F6F6F;
}
.table.table-striped-columns > :not(caption) > tr > :nth-child(2n) {
  --bs-table-accent-bg: rgba(var(--dark-rgb),0.025);
  color: #6F6F6F;
}
.table tbody.table-group-divider {
  border-top: 1px solid #E8E8E8;
}
.table.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: #f7f8f9;
  color: #6F6F6F;
}
.table .table-active {
  --bs-table-accent-bg: #FDFDFE;
  color: #6F6F6F;
}
.table thead.table-primary {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-secondary {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-warning {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-success {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--success-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-danger {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-info {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--info-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-light {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--light-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-dark {
  background-color: #FFF;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000;
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--primary-rgb), 0.1);
  background-color: #FFF;
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--secondary-rgb), 0.1);
  background-color: #FFF;
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--warning-rgb), 0.1);
  background-color: #FFF;
}

.table-success {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--success-rgb), 0.1);
  background-color: #FFF;
}

.table-info {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--info-rgb), 0.1);
  background-color: #FFF;
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--danger-rgb), 0.1);
  background-color: #FFF;
}

.table-dark {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--dark-rgb), 0.1);
  background-color: #FFF;
}

.table-light {
  --bs-table-color: #000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-hover-color: #000;
  color: #000;
  border-color: rgba(var(--light-rgb), 0.1);
  background-color: #FFF;
}

[data-theme-mode=dark] .table-dark {
  border-color: rgba(0, 0, 0, 0.025);
}

[dir=rtl] .table {
  margin-inline-end: 1px;
}

.table {
  margin: 0;
}
.table tbody tr td {
  color: #424848;
  font-size: 14px;
}
.table tbody tr td .product-img img {
  border: 0;
}
.table tbody tr td .userslist-img {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}
.table tbody tr td .userslist-img img {
  border-radius: 0;
}
.table tbody tr td .userslist-img.bg-img img {
  border: 1px solid var(--stroke-table, #E8EBED);
}
.table tbody tr td a {
  color: #FFA201;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.table tbody tr td a.product-img {
  margin-right: 5px;
  flex-shrink: 0;
}
.table tbody tr td a .info-img {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}
.table tbody tr td a:hover {
  color: #E41F07;
}
.table tbody tr td .emp-name {
  line-height: 1;
}
.table tbody tr td .emp-name a {
  color: #FFA201;
}
.table tbody tr td .emp-name p {
  line-height: 2;
  font-size: 15px;
  font-weight: 500;
  color: #6F6F6F;
}
.table tbody tr td .emp-name .role {
  line-height: unset;
}
.table tbody tr td .product-imgs {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 40px;
  height: 40px;
  background: #FFEBD8;
  font-size: 14px;
  color: #FF9F43 !important;
  font-weight: 500;
  margin-right: 10px;
}
.table tbody tr .data-header {
  font-weight: 600;
  color: #FFA201;
  font-size: 15px;
  border-bottom: none;
}
.table tbody tr .ref-number {
  color: #4A00E5;
}
.table tbody tr.active {
  border-bottom: 0;
}
.table tbody tr.active td {
  font-size: 18px;
  color: #424848;
  font-weight: 600;
  border-bottom: 0;
}
.table tbody .loss-highlight td {
  font-weight: 700;
  color: #FFA201;
  font-size: 14px;
  border-top: 1px solid #898989;
}
.table tbody .userimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.table tbody .userimgname img {
  margin-right: 8px;
  border-radius: 6px;
}
.table tbody .purchase-count td {
  padding-bottom: 20px;
}
.table .Expense-list tr td {
  padding: 15px 17px;
}
.table .Expense-list tr td a {
  margin-bottom: 0;
}
.table .sales-list tr td {
  padding: 20px 17px;
}
.table .Expense-list-blk tr td {
  padding: 20px 17px;
}

.new tbody tr td {
  border-bottom: none;
}

.table-height {
  min-height: 300px;
}
@media (max-width: 991.98px) {
  .table-height {
    min-height: auto;
    margin-bottom: 15px;
  }
}

.max-widthauto {
  max-width: 100% !important;
}

.dataTables_filter + .dataTables_filter {
  display: none;
}

.dataview .dataTables_length,
.dataview .dataTables_info,
.dataview .dataTables_paginate {
  display: none !important;
}

.dataTables_length {
  font-size: 12px;
}

.productimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.productimgname a {
  color: #FFA201;
  font-weight: 500;
}
.productimgname .view-product {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 50px;
  height: 50px;
  border-radius: 6px;
  background: #F8F8F8;
}

.input-blocks .calc-no {
  width: 50px !important;
  text-align: center;
}

.table .input-blocks input[type=text] {
  height: 40px;
}
.table .scanner-set {
  width: 40px;
  height: 40px;
}

.card.table-list-card .card-body {
  padding: 0;
}
.card.table-list-card .table-top {
  padding: 24px 24px 0;
}
.card.table-list-card .table-responsive {
  padding: 24px;
}
.card.table-list-card .table-responsive .dataTables_wrapper {
  border: 0;
  padding: 0;
}
.card.table-list-card .tabs-set .nav-tabs {
  padding: 24px 24px 0;
  margin-bottom: 0;
}

.table.profit-table thead {
  background-color: #FAFBFE;
  border-radius: 8px 8px 0px 0px;
}
.table.profit-table thead tr:hover {
  background-color: #FAFBFE;
}
.table.profit-table tbody td {
  border-bottom: 0;
}
.table.profit-table tbody .profit-table-bg td {
  color: #FFA201;
  font-weight: 700;
  border-top: 1px solid #C0C0C0;
  background-color: #FAFBFE;
}
.table.profit-table tbody .table-heading:hover {
  background-color: #FFF;
}
.table.profit-table tbody .table-heading td {
  color: #FFA201;
  font-weight: 700;
}

.profit-table-top .daterange-wraper {
  margin: 0 10px;
}
.profit-table-top .daterange-wraper input {
  padding-left: 35px;
}

table td .shield {
  width: 14px;
  height: 14px;
}

.paysilp-table-border {
  border: 1px solid #C0C0C0;
}
.paysilp-table-border th {
  border-right: 1px solid #C0C0C0;
  border-left: 1px solid #C0C0C0;
  padding: 15px;
  font-weight: 700;
  font-size: 16px;
}

.paysilp-table-borders td {
  border-right: 1px solid #C0C0C0;
  border-left: 1px solid #C0C0C0;
  padding: 5px 15px;
  color: #6F6F6F;
}

.payslip-border-bottom {
  border: 1px solid #C0C0C0;
}
.payslip-border-bottom th {
  padding: 5px 15px;
  font-weight: 700;
  font-size: 16px;
}
.payslip-border-bottom td {
  color: #6F6F6F;
}

.emp-details {
  margin: 20px 0;
}
.emp-details .pay-slip-salery h6 {
  font-weight: 700 !important;
  margin-bottom: 10px;
  font-size: 18px !important;
}
.emp-details .emp-name-id.pay-slip-salery {
  margin-right: 30px;
}

@media (max-width: 575.98px) {
  .slip-logo {
    flex-shrink: 0;
    margin-right: 15px;
  }
}

.product-name-slip h4 {
  color: #E41F07;
  font-weight: 700;
  font-size: 18px;
}

.pay-slip-box .modal-header {
  border-radius: 8px 8px 0 0;
}
.pay-slip-box .custom-modal-body {
  padding: 0;
}
.pay-slip-box .card {
  border: 0;
  border-radius: 0 0 10px 10px;
}
.pay-slip-box .card .card-body {
  padding: 20px;
}
.pay-slip-box .card .card-body .emp-details.justify-content-start {
  max-width: 760px;
  margin: 20px auto 20px;
}

.table {
  margin: 0;
}
.table tbody tr td {
  color: #424848;
  font-size: 14px;
}
.table tbody tr td .product-img img {
  border: 0;
}
.table tbody tr td .userslist-img {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}
.table tbody tr td .userslist-img img {
  border-radius: 0;
}
.table tbody tr td .userslist-img.bg-img img {
  border: 1px solid var(--stroke-table, #E8EBED);
}
.table tbody tr td a {
  color: #262A2A;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.table tbody tr td a.product-img {
  margin-right: 5px;
  flex-shrink: 0;
}
.table tbody tr td a .info-img {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}
.table tbody tr td a:hover {
  color: #E41F07;
}
.table tbody tr td a:hover i {
  color: #E41F07;
}
.table tbody tr td .emp-name {
  line-height: 1;
}
.table tbody tr td .emp-name a {
  color: #FFA201;
}
.table tbody tr td .emp-name p {
  line-height: 2;
  font-size: 15px;
  font-weight: 500;
  color: #6F6F6F;
}
.table tbody tr td .emp-name .role {
  line-height: unset;
}
.table tbody tr td .product-imgs {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 40px;
  height: 40px;
  background: #FFEBD8;
  font-size: 14px;
  color: #FF9F43 !important;
  font-weight: 500;
  margin-right: 10px;
}
.table tbody tr .data-header {
  font-weight: 600;
  color: #FFA201;
  font-size: 15px;
  border-bottom: none;
}
.table tbody tr .ref-number {
  color: #4A00E5;
}
.table tbody tr.active {
  border-bottom: 0;
}
.table tbody tr.active td {
  font-size: 18px;
  color: #424848;
  font-weight: 600;
  border-bottom: 0;
}
.table tbody .loss-highlight td {
  font-weight: 700;
  color: #FFA201;
  font-size: 14px;
  border-top: 1px solid #898989;
}
.table tbody .userimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.table tbody .userimgname img {
  margin-right: 8px;
  border-radius: 6px;
}
.table tbody .purchase-count td {
  padding-bottom: 20px;
}
.table .Expense-list tr td {
  padding: 15px 17px;
}
.table .Expense-list tr td a {
  margin-bottom: 0;
}
.table .sales-list tr td {
  padding: 20px 17px;
}
.table .Expense-list-blk tr td {
  padding: 20px 17px;
}
.table .userimgname .product-img {
  display: inherit;
  width: 35px;
  height: 35px;
  margin-right: 8px;
}

table tbody td.action-table-data {
  display: flex;
}
table tbody td.action-table-data a {
  border: 1px solid rgba(145, 158, 171, 0.3);
  background-color: #FFF;
  border-radius: 8px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 8px;
}
table tbody td.action-table-data a .feather-edit {
  color: #339DFF;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-edit {
  color: #6F6F6F;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .feather-trash-2 {
  color: #FC0027;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .feather-eye {
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-download {
  color: #339DFF;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-eye {
  color: #FFA201;
  width: 14px;
  height: 14px;
}
table tbody .productimgname {
  min-width: 200px;
}
table tbody .productimgname a.stock-img.product-img {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
}
table tbody .productimgname a.stock-img.product-img img {
  width: 50px;
  height: 50px;
  max-width: 100%;
  margin-right: 0;
}
table .edit-delete-action {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 50px;
}
table .edit-delete-action a {
  padding: 0;
}
table .edit-delete-action.data-view {
  min-height: 52px;
}
table .edit-delete-action.data-row {
  height: auto;
}
table .edit-delete-action.data {
  height: 44px;
}

.custom-table table td ul.social-links li a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  color: #6F6F6F;
}
.custom-table table td ul.social-links li a:hover {
  background: #E8E8E8;
  color: #6F6F6F;
}

.accordion-button {
  background-color: #FFF;
  color: #6F6F6F;
  padding: 0.75rem 1rem;
  font-size: 0.85rem;
  font-weight: 500;
}
.accordion-button.accordion-custom-button:after {
  content: "\\f054";
}
.accordion-button.accordion-custom-button:not(.collapsed) {
  color: #6F6F6F;
  background-color: #f7f8f9;
  box-shadow: none;
}
.accordion-button.accordion-custom-button:not(.collapsed):after {
  content: "\\f078";
  display: block;
  transform: none;
}
.accordion-button:not(.collapsed) {
  color: #6F6F6F;
  background-color: #f7f8f9;
  box-shadow: none;
}
.accordion-button:focus {
  border-color: rgba(228, 31, 7, 0.3);
  box-shadow: none;
}
.accordion-button:after, .accordion-button:not(.collapsed)::after {
  background-image: none;
}
.accordion-button:after {
  content: "\\f078";
  font-family: "Fontawesome";
  font-size: 12px;
  line-height: 1;
  background-color: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3.125rem;
  color: #6F6F6F;
}

.accordion-body {
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  color: #9595b5;
}

.accordion-item {
  color: #6F6F6F;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
}

.accordions-items-seperate .accordion-item:not(:first-of-type) {
  margin-block-start: 0.5rem;
}
.accordions-items-seperate .accordion-item {
  border-block-start: 1px solid #E8E8E8;
  border-radius: 4px;
  overflow: hidden;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: 0.35rem;
  border-bottom-left-radius: 0.35rem;
}

.accordion-item:first-of-type {
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
}

.accordion.accordion-primary .accordion-button {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.accordion.accordion-primary .accordion-button:after {
  background-color: #E41F07;
  color: #FFF;
}
.accordion.accordion-primary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-primary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-secondary .accordion-button {
  background-color: rgba(255, 162, 1, 0.1);
  color: #FFA201;
}
.accordion.accordion-secondary .accordion-button:after {
  background-color: #FFA201;
  color: #FFF;
}
.accordion.accordion-secondary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-secondary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-success .accordion-button {
  background-color: rgba(92, 184, 92, 0.1);
  color: #5CB85C;
}
.accordion.accordion-success .accordion-button:after {
  background-color: #5CB85C;
  color: #FFF;
}
.accordion.accordion-success .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-success .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-danger .accordion-button {
  background-color: rgba(252, 0, 39, 0.1);
  color: #FC0027;
}
.accordion.accordion-danger .accordion-button:after {
  background-color: #FC0027;
  color: #FFF;
}
.accordion.accordion-danger .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-danger .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-warning .accordion-button {
  background-color: rgba(253, 167, 0, 0.1);
  color: #FDA700;
}
.accordion.accordion-warning .accordion-button:after {
  background-color: #FDA700;
  color: #FFF;
}
.accordion.accordion-warning .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-warning .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-info .accordion-button {
  background-color: rgba(30, 203, 226, 0.1);
  color: #1ECBE2;
}
.accordion.accordion-info .accordion-button:after {
  background-color: #1ECBE2;
  color: #FFF;
}
.accordion.accordion-info .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-info .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}

.accordion.accordion-solid-primary .accordion-button {
  background-color: #E41F07;
  color: #FFF;
}
.accordion.accordion-solid-primary .accordion-button:after {
  background-color: #FFF;
  color: #E41F07;
}
.accordion.accordion-solid-primary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-primary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-secondary .accordion-button {
  background-color: #FFA201;
  color: #FFF;
}
.accordion.accordion-solid-secondary .accordion-button:after {
  background-color: #FFF;
  color: #FFA201;
}
.accordion.accordion-solid-secondary .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-secondary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-success .accordion-button {
  background-color: #5CB85C;
  color: #FFF;
}
.accordion.accordion-solid-success .accordion-button:after {
  background-color: #FFF;
  color: #5CB85C;
}
.accordion.accordion-solid-success .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-success .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-danger .accordion-button {
  background-color: #FC0027;
  color: #FFF;
}
.accordion.accordion-solid-danger .accordion-button:after {
  background-color: #FFF;
  color: #FC0027;
}
.accordion.accordion-solid-danger .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-danger .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-warning .accordion-button {
  background-color: #FDA700;
  color: #FFF;
}
.accordion.accordion-solid-warning .accordion-button:after {
  background-color: #FFF;
  color: #FDA700;
}
.accordion.accordion-solid-warning .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-warning .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}
.accordion.accordion-solid-info .accordion-button {
  background-color: #1ECBE2;
  color: #FFF;
}
.accordion.accordion-solid-info .accordion-button:after {
  background-color: #FFF;
  color: #1ECBE2;
}
.accordion.accordion-solid-info .accordion-button.collapsed {
  background-color: #FFF;
  color: #6F6F6F;
}
.accordion.accordion-solid-info .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #6F6F6F;
}

.accordion.accordion-border-primary .accordion-item {
  border: 1px solid #E41F07;
}
.accordion.accordion-border-primary .accordion-button {
  background-color: #FFF;
  color: #E41F07;
  border-block-end: 0px;
}
.accordion.accordion-border-primary .accordion-button:after {
  background-color: #FFF;
  color: #E41F07;
  border: 1px solid #E41F07;
}
.accordion.accordion-border-primary .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #E41F07;
}
.accordion.accordion-border-secondary .accordion-item {
  border: 1px solid #FFA201;
}
.accordion.accordion-border-secondary .accordion-button {
  background-color: #FFF;
  color: #FFA201;
  border-block-end: 0px;
}
.accordion.accordion-border-secondary .accordion-button:after {
  background-color: #FFF;
  color: #FFA201;
  border: 1px solid #FFA201;
}
.accordion.accordion-border-secondary .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FFA201;
}
.accordion.accordion-border-success .accordion-item {
  border: 1px solid #5CB85C;
}
.accordion.accordion-border-success .accordion-button {
  background-color: #FFF;
  color: #5CB85C;
  border-block-end: 0px;
}
.accordion.accordion-border-success .accordion-button:after {
  background-color: #FFF;
  color: #5CB85C;
  border: 1px solid #5CB85C;
}
.accordion.accordion-border-success .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #5CB85C;
}
.accordion.accordion-border-danger .accordion-item {
  border: 1px solid #FC0027;
}
.accordion.accordion-border-danger .accordion-button {
  background-color: #FFF;
  color: #FC0027;
  border-block-end: 0px;
}
.accordion.accordion-border-danger .accordion-button:after {
  background-color: #FFF;
  color: #FC0027;
  border: 1px solid #FC0027;
}
.accordion.accordion-border-danger .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FC0027;
}
.accordion.accordion-border-warning .accordion-item {
  border: 1px solid #FDA700;
}
.accordion.accordion-border-warning .accordion-button {
  background-color: #FFF;
  color: #FDA700;
  border-block-end: 0px;
}
.accordion.accordion-border-warning .accordion-button:after {
  background-color: #FFF;
  color: #FDA700;
  border: 1px solid #FDA700;
}
.accordion.accordion-border-warning .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FDA700;
}
.accordion.accordion-border-info .accordion-item {
  border: 1px solid #1ECBE2;
}
.accordion.accordion-border-info .accordion-button {
  background-color: #FFF;
  color: #1ECBE2;
  border-block-end: 0px;
}
.accordion.accordion-border-info .accordion-button:after {
  background-color: #FFF;
  color: #1ECBE2;
  border: 1px solid #1ECBE2;
}
.accordion.accordion-border-info .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #1ECBE2;
}

.accordion.accordionicon-none .accordion-button:after {
  display: none;
}

.accordion.accordionicon-left .accordion-button {
  padding-inline-start: 2.5rem;
}
.accordion.accordionicon-left .accordion-button:after {
  position: absolute;
  inset-inline-start: 0.625rem;
}

.accordion.accordion-customicon1 .accordion-button:after {
  content: "+";
  font-family: "Fontawesome";
  background-color: #f7f8f9;
}
.accordion.accordion-customicon1 .accordion-button:not(.collapsed)::after {
  content: "\\f068";
  font-family: "Fontawesome";
  background-color: #FFF;
}

.customized-accordion .accordion-item.custom-accordion-primary .accordion-button {
  background-color: rgba(228, 31, 7, 0.1);
  border-inline-start: 0.25rem solid rgba(228, 31, 7, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-primary .accordion-button:after {
  background-color: rgba(228, 31, 7, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-primary .accordion-body {
  background-color: rgba(228, 31, 7, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(228, 31, 7, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-button {
  background-color: rgba(255, 162, 1, 0.1);
  border-inline-start: 0.25rem solid rgba(255, 162, 1, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-button:after {
  background-color: rgba(255, 162, 1, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-body {
  background-color: rgba(255, 162, 1, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(255, 162, 1, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-button {
  background-color: rgba(253, 167, 0, 0.1);
  border-inline-start: 0.25rem solid rgba(253, 167, 0, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-button:after {
  background-color: rgba(253, 167, 0, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-body {
  background-color: rgba(253, 167, 0, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(253, 167, 0, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-button {
  background-color: rgba(30, 203, 226, 0.1);
  border-inline-start: 0.25rem solid rgba(30, 203, 226, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-button:after {
  background-color: rgba(30, 203, 226, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-body {
  background-color: rgba(30, 203, 226, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(30, 203, 226, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-button {
  background-color: rgba(92, 184, 92, 0.1);
  border-inline-start: 0.25rem solid rgba(92, 184, 92, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-button:after {
  background-color: rgba(92, 184, 92, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-body {
  background-color: rgba(92, 184, 92, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(92, 184, 92, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-button {
  background-color: rgba(252, 0, 39, 0.1);
  border-inline-start: 0.25rem solid rgba(252, 0, 39, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-button:after {
  background-color: rgba(252, 0, 39, 0.6);
  color: #FFF;
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-body {
  background-color: rgba(252, 0, 39, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(252, 0, 39, 0.6);
}

.page-header-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: var(--bs-breadcrumb-divider, "\\ea65");
  font-family: "tabler-icons" !important;
}

[dir=rtl] .page-header-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: var(--bs-breadcrumb-divider, "\\ea64");
  font-family: "tabler-icons" !important;
}

.breadcrumb .breadcrumb-item a {
  color: #9595b5;
}
.breadcrumb .breadcrumb-item.active {
  color: #E41F07;
}

.breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  opacity: 0.4;
}

.breadcrumb-arrow .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f101";
  font-family: "Fontawesome" !important;
}

.breadcrumb-pipe .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f061";
  font-family: "Fontawesome" !important;
}

.breadcrumb-line .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "-";
}

.breadcrumb-dot .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "•";
}

.breadcrumb-divide .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f054";
  font-family: "Fontawesome" !important;
}

.breadcrumb-separatorless .breadcrumb-item + .breadcrumb-item::before {
  content: "";
  display: none;
}

.breadcrumb-colored {
  padding: 12px 15px;
  border-radius: 4px;
}
.breadcrumb-colored li a {
  color: #FFF;
}
.breadcrumb-colored .breadcrumb-item a {
  color: #FFF;
}
.breadcrumb-colored .breadcrumb-item.active {
  color: #FFF;
  opacity: 0.8;
}
.breadcrumb-colored .breadcrumb-item + .breadcrumb-item a {
  color: #FFF;
}
.breadcrumb-colored .breadcrumb-item + .breadcrumb-item::before {
  color: #FFF;
}

.embedded-breadcrumb:before {
  opacity: 0.7;
}

[data-theme-mode=dark] .embedded-breadcrumb:before {
  filter: invert(1);
}

.card {
  margin-bottom: 24px;
  background-color: #FFF;
  transition: all 0.5s ease-in-out;
  position: relative;
  border-radius: 5px;
  border: 0;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  color: inherit;
}
.card .card-body {
  padding: 1rem;
}
.card .card-title {
  font-size: 18px;
  font-weight: 700;
  text-transform: capitalize;
}
.card .card-header {
  border-color: #E8E8E8;
  position: relative;
  background: transparent;
  padding: 1rem;
}
.card .card-header .card-title {
  margin-bottom: 0rem;
}
.card .card-header .subtitle {
  padding-top: 0.3125rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.card .card-footer {
  border-color: #E8E8E8;
  background: transparent;
  padding: 1rem 1.25rem 1rem;
}

.card-group .card {
  margin-bottom: 1.5rem;
}

.card.custom-card {
  border-radius: 4px;
  border: 0;
  background-color: #FFF;
  position: relative;
  margin-block-end: 1.5rem;
  width: 100%;
}
.card.custom-card .card-header {
  padding: 1rem 1.25rem;
  background-color: transparent !important;
  border-block-end: 1px solid #E8E8E8;
  display: flex;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
  gap: 0.25rem;
}
.card.custom-card .card-header:first-child {
  border-radius: 0.625rem 0.625rem 0 0;
}
.card.custom-card .card-header .card-title {
  position: relative;
  margin-block-end: 0;
  font-size: 0.9375rem;
  font-weight: 700;
  text-transform: capitalize;
}
.card.custom-card .card-header .card-title .subtitle {
  margin-block-end: 0;
  text-transform: initial;
}
.card.custom-card .card-footer {
  background-color: transparent !important;
  border-block-start: 1px solid #E8E8E8;
  padding: 1rem 1.5rem;
  font-size: 14px;
}
.card.custom-card .card-body {
  padding: 1.5rem;
  color: #6F6F6F;
}
.card.custom-card .card-link {
  font-size: 0.75rem;
}
.card .card-text {
  font-size: 0.813rem;
}
.card .footer-card-icon {
  width: 60px;
  height: 60px;
}
.card.overlay-card {
  position: relative;
  overflow: hidden;
  color: rgba(255, 255, 255, 0.9);
}
.card.overlay-card .card-header {
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
}
.card.overlay-card .card-footer {
  border-block-start: 1px solid rgba(255, 255, 255, 0.1);
}
.card.overlay-card .over-content-bottom {
  top: auto;
}
.card.overlay-card:before {
  content: "";
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
}
.card.card-bg-primary {
  background-color: #E41F07;
  color: #FFF;
}
.card.card-bg-primary .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-primary .card-header:before {
  background-color: #FFF;
}
.card.card-bg-primary .card-body {
  color: #FFF;
}
.card.card-bg-primary .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-secondary {
  background-color: #FFA201;
  color: #FFF;
}
.card.card-bg-secondary .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-secondary .card-header:before {
  background-color: #FFF;
}
.card.card-bg-secondary .card-body {
  color: #FFF;
}
.card.card-bg-secondary .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-warning {
  background-color: #FDA700;
  color: #FFF;
}
.card.card-bg-warning .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-warning .card-header:before {
  background-color: #FFF;
}
.card.card-bg-warning .card-body {
  color: #FFF;
}
.card.card-bg-warning .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-info {
  background-color: #1ECBE2;
  color: #FFF;
}
.card.card-bg-info .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-info .card-header:before {
  background-color: #FFF;
}
.card.card-bg-info .card-body {
  color: #FFF;
}
.card.card-bg-info .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-success {
  background-color: #5CB85C;
  color: #FFF;
}
.card.card-bg-success .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-success .card-header:before {
  background-color: #FFF;
}
.card.card-bg-success .card-body {
  color: #FFF;
}
.card.card-bg-success .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-danger {
  background-color: #FC0027;
  color: #FFF;
}
.card.card-bg-danger .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-danger .card-header:before {
  background-color: #FFF;
}
.card.card-bg-danger .card-body {
  color: #FFF;
}
.card.card-bg-danger .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-light {
  background-color: #FDFDFE;
  color: #6F6F6F;
}
.card.card-bg-light .card-header {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #6F6F6F;
  border-block-end: #E8E8E8;
}
.card.card-bg-light .card-body {
  color: #6F6F6F;
}
.card.card-bg-light .card-footer {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #6F6F6F;
  border-block-start: #E8E8E8;
}
.card.card-bg-dark {
  background-color: #171724;
  color: #FFF;
}
.card.card-bg-dark .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-dark .card-header:before {
  background-color: #FFF;
}
.card.card-bg-dark .card-body {
  color: #FFF;
}
.card.card-bg-dark .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #FFF;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card .card-anchor {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
}
.card .collapse-close {
  display: none;
}
.card.card .collapsed .collapse-close {
  display: block;
}
.card.card .collapsed .collapse-open {
  display: none;
}
.card.card-fullscreen {
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  inset-inline-start: 0;
  bottom: 0;
  z-index: 9999;
  margin: 0;
}

.cals-icon {
  font-size: 50px;
  color: #6F7A7A;
}

.callout {
  padding: 1.25rem;
  margin-block-start: 1.25rem;
  margin-block-end: 1.25rem;
  background-color: #FDFDFE;
  border-inline-start: 0.25rem solid #E8E8E8;
}

.callout-info {
  background-color: rgba(30, 203, 226, 0.075);
  border-color: rgba(30, 203, 226, 0.5);
}

.callout-warning {
  background-color: rgba(253, 167, 0, 0.075);
  border-color: rgba(253, 167, 0, 0.5);
}

.callout-danger {
  background-color: rgba(252, 0, 39, 0.075);
  border-color: rgba(252, 0, 39, 0.5);
}

.btn-facebook {
  background-color: #3B5998;
  color: #FFF;
  border: 1px solid #3B5998;
}
.btn-facebook:hover, .btn-facebook:focus, .btn-facebook:active {
  background-color: #3B5998 !important;
  color: #FFF !important;
  border: 1px solid #3B5998 !important;
}

.btn-instagram {
  background: #f09433;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );
  color: #FFF;
  border: 1px solid transparent;
}
.btn-instagram:hover, .btn-instagram:focus, .btn-instagram:active {
  color: #FFF;
  border: 1px solid transparent;
}

.btn-twitter {
  background-color: #00ACEE;
  color: #FFF;
  border: 1px solid #00ACEE;
}
.btn-twitter:hover, .btn-twitter:focus, .btn-twitter:active {
  background-color: #00ACEE !important;
  color: #FFF !important;
  border: 1px solid #00ACEE !important;
}

.btn-icon {
  width: 2.313rem;
  height: 2.313rem;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.btn-wave {
  display: inline-block !important;
}

@media (max-width: 575px) {
  .overlay-card .card-text {
    font-size: 0.613rem !important;
  }
}
@media (max-width: 400px) {
  .overlay-card .card-text {
    font-size: 0.413rem !important;
  }
}
.tooltip.tooltip-primary .tooltip-inner {
  background-color: #E41F07;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #E41F07;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #E41F07;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #E41F07;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #E41F07;
}
.tooltip.tooltip-secondary .tooltip-inner {
  background-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FFA201;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FFA201;
}
.tooltip.tooltip-warning .tooltip-inner {
  background-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FDA700;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FDA700;
}
.tooltip.tooltip-info .tooltip-inner {
  background-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #1ECBE2;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #1ECBE2;
}
.tooltip.tooltip-success .tooltip-inner {
  background-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #5CB85C;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #5CB85C;
}
.tooltip.tooltip-danger .tooltip-inner {
  background-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FC0027;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FC0027;
}
.tooltip.tooltip-dark .tooltip-inner {
  background-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #171724;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #171724;
}
.tooltip.tooltip-dark .tooltip-inner {
  color: #FFF;
}
.tooltip.tooltip-light .tooltip-inner {
  background-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FDFDFE;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FDFDFE;
}
.tooltip.tooltip-light .tooltip-inner {
  color: #6F6F6F;
}

.nav-item {
  margin-inline-end: 0.5rem;
}
.nav-item:last-child {
  margin-inline-end: 0;
}

.nav-link {
  color: #6F6F6F;
  border-radius: 4px;
  font-weight: 600;
}
.nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}

.navbar-brand {
  color: #6F6F6F;
}
.navbar-brand:focus, .navbar-brand:hover {
  color: #6F6F6F;
  opacity: 0.9;
}

.navbar-nav .nav-link.active,
.navbar-nav .show > .nav-link {
  color: #E41F07;
}

.nav-link.disabled {
  color: #6F6F6F;
  opacity: 0.3;
}

.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: rgba(23, 23, 36, 0.5);
}

.navbar-text {
  color: #6F6F6F;
}

.navbar-dark.bg-dark .nav-link,
.navbar-dark.bg-dark .navbar-brand {
  color: #FFF;
}
.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .show > .nav-link {
  color: #FFF;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #FFF;
  background-color: #E41F07;
}

.nav.nav-style-1 {
  border: 0;
}
.nav.nav-style-1 .nav-item {
  margin-inline-end: 0.25rem;
}
.nav.nav-style-1 .nav-item:last-child {
  margin-inline-end: 0;
}
.nav.nav-style-1 .nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.nav.nav-style-1 .nav-link.active:hover {
  background: rgba(228, 31, 7, 0.1);
}
.nav.nav-style-1 .nav-link:hover {
  background: transparent;
  color: #E41F07;
}

.nav.nav-style-2 .nav-item .nav-link {
  border-block-start: 3px solid transparent;
}
.nav.nav-style-2 .nav-item .nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  border-block-start: 3px solid #E41F07;
  color: #E41F07;
}

.nav.nav-style-3 .nav-link {
  border-radius: 0;
}
.nav.nav-style-3 .nav-link {
  border-block-end: 3px solid transparent;
}
.nav.nav-style-3 .nav-link.active {
  background-color: transparent;
  border-block-end: 3px solid #E41F07;
  color: #E41F07;
}

.nav.nav-style-4 {
  border: 0;
}
.nav.nav-style-4 .nav-link {
  color: #9595b5;
  border: 0;
}
.nav.nav-style-4 .nav-link {
  margin-bottom: 3px;
}
.nav.nav-style-4 .nav-link.active {
  background-color: #FDFDFE;
  color: #6F6F6F;
  border: 0;
}
.nav.nav-style-4 .nav-link:hover, .nav.nav-style-4 .nav-link:focus {
  border: 0;
}
.nav.nav-style-4 .nav-link:hover {
  background-color: #FDFDFE;
  color: #6F6F6F;
}

.nav-tabs.nav-style-5 {
  border: 0;
}
.nav-tabs.nav-style-5 .nav-link {
  color: #9595b5;
  border: 0;
  margin-bottom: 3px;
}
.nav-tabs.nav-style-5 .nav-link.active {
  background-color: #E41F07;
  color: #FFF;
  border: 0;
}
.nav-tabs.nav-style-5 .nav-link:hover, .nav-tabs.nav-style-5 .nav-link:focus {
  border: 0;
  background-color: #E41F07;
  color: #FFF;
}

.nav-style-6 {
  border: 0;
}
.nav-style-6.nav-pills .nav-link.active {
  border: 1px solid #E41F07;
  border-block-end: 2px solid #E41F07;
  background-color: transparent;
  color: #E41F07;
}

.nav-tabs-header {
  border: 0 !important;
}
.nav-tabs-header .nav-item {
  margin-inline-end: 0.5rem;
}
.nav-tabs-header .nav-item:last-child {
  margin-inline-end: 0;
}
.nav-tabs-header .nav-item .nav-link {
  border: 1px solid transparent;
  font-size: 0.8rem;
  padding: 0.4rem 0.5rem;
  font-weight: 500;
}
.nav-tabs-header .nav-item .nav-link.active {
  background: rgba(228, 31, 7, 0.1);
  color: #E41F07;
  border: 1px solid transparent;
}
.nav-tabs-header .nav-item .nav-link:hover, .nav-tabs-header .nav-item .nav-link:focus {
  border: 1px solid transparent;
  background-color: transparent;
  color: #E41F07;
}

.nav-tabs-footer {
  border: 0;
}
.nav-tabs-footer .nav-item {
  margin-inline-end: 0.5rem;
}
.nav-tabs-footer .nav-item:last-child {
  margin-inline-end: 0;
}
.nav-tabs-footer .nav-item .nav-link {
  background-color: transparent;
  color: #E41F07;
  border: 1px solid #E41F07;
  font-size: 0.8rem;
}
.nav-tabs-footer .nav-item .nav-link.active {
  background: #E41F07;
  color: #FFF;
  border: 1px solid #E41F07;
}
.nav-tabs-footer .nav-item .nav-link:hover, .nav-tabs-footer .nav-item .nav-link:focus {
  border: 1px solid #E41F07;
  background-color: transparent;
  color: #E41F07;
}

.vertical-tabs-2 {
  border: 0;
}
.vertical-tabs-2 .nav-item {
  margin-inline-end: 0.5rem;
}
.vertical-tabs-2 .nav-item:last-child {
  margin-inline-end: 0;
}
.vertical-tabs-2 .nav-item .nav-link {
  min-width: 7.5rem;
  max-width: 7.5rem;
  text-align: center;
  border: 1px solid #E8E8E8;
  margin-bottom: 0.5rem;
  color: #9595b5;
  background-color: #FDFDFE;
}
.vertical-tabs-2 .nav-item .nav-link i {
  font-size: 1rem;
}
.vertical-tabs-2 .nav-item .nav-link.active {
  background-color: #E41F07;
  color: #FFF;
  position: relative;
}
.vertical-tabs-2 .nav-item .nav-link.active:before {
  content: "";
  position: absolute;
  inset-inline-end: -0.5rem;
  inset-block-start: 38%;
  transform: rotate(45deg);
  width: 1rem;
  height: 1rem;
  background-color: #E41F07;
}
.vertical-tabs-2 .nav-item .nav-link.active:hover {
  color: #FFF;
}
.vertical-tabs-2 .nav-item .nav-link:hover {
  color: #E41F07;
}

.vertical-tabs-3 {
  border: 0;
}
.vertical-tabs-3 .nav-item {
  border: 0;
  margin-inline-end: 0.5rem;
}
.vertical-tabs-3 .nav-item:last-child {
  margin-inline-end: 0;
}
.vertical-tabs-3 .nav-item .nav-link {
  min-width: 160px;
  max-width: 160px;
  border: 1px solid #E41F07;
  padding: 1.3rem;
  margin-block-end: 0.5rem;
}
.vertical-tabs-3 .nav-item .nav-link i {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 1rem;
  background: #E41F07;
  color: #FFF;
  border-radius: 3.125rem;
  font-weight: 500;
}
.vertical-tabs-3 .nav-item .nav-link.active {
  background: #E41F07;
  border: 1px solid #E41F07;
  color: #FFF;
}
.vertical-tabs-3 .nav-item .nav-link.active:hover {
  background: #E41F07;
  border: 1px solid #E41F07;
  color: #FFF;
}
.vertical-tabs-3 .nav-item .nav-link.active i {
  background: #FFF;
  color: #E41F07;
}
.vertical-tabs-3 .nav-item .nav-link:hover, .vertical-tabs-3 .nav-item .nav-link:focus {
  border: 1px solid #E41F07;
  color: #E41F07;
  background: transparent;
}

.nav.tab-style-1 {
  border-block-end: 0;
  padding: 0.65rem;
  background-color: #FDFDFE;
  border-radius: 7px;
  margin-block-end: 1rem;
}
.nav.tab-style-1 .nav-item {
  margin-inline-end: 0.5rem;
}
.nav.tab-style-1 .nav-item:last-child {
  margin-inline-end: 0;
}
.nav.tab-style-1 .nav-link {
  border-radius: 7px;
  padding: 0.35rem 1rem;
}
.nav.tab-style-1 .nav-link.active {
  background-color: #E41F07 !important;
  color: #FFF !important;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
  transition: color 0.15s ease-in;
}

.nav-tabs.tab-style-1 .nav-link:hover {
  background: transparent;
  color: #E41F07;
}

.tab-style-2 {
  border-block-end: 0;
}
.tab-style-2 .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-2 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-2 .nav-item .nav-link {
  border: 0;
}
.tab-style-2 .nav-item .nav-link i {
  width: 1.875rem;
  height: 1.875rem;
  padding: 0.4rem;
  border-radius: 50px;
  background-color: #FDFDFE;
  color: #6F6F6F;
  display: inline-block;
}
.tab-style-2 .nav-item .nav-link:hover {
  border: 0;
  background: transparent;
  color: #E41F07;
}
.tab-style-2 .nav-item .nav-link:hover i {
  color: #E41F07;
}
.tab-style-2 .nav-item .nav-link.active {
  background-color: transparent;
  position: relative;
  border: 0;
  color: #E41F07;
}
.tab-style-2 .nav-item .nav-link.active i {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}
.tab-style-2 .nav-item .nav-link.active:before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-end: 0;
  width: 100%;
  height: 0.175rem;
  background-color: #E41F07;
  border-radius: 50px;
}

.tab-style-3 {
  border-block-end: 0;
}
.tab-style-3 .nav-item {
  position: relative;
  margin-inline-end: 0.5rem;
}
.tab-style-3 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-3 .nav-item .nav-link {
  position: relative;
  border: 0;
  font-size: 0.75rem;
}
.tab-style-3 .nav-item .nav-link:before {
  position: absolute;
  content: "";
  inset-block-end: -1.063rem;
  inset-inline-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 0.1rem;
  background-color: #FDFDFE;
  border-radius: 50%;
}
.tab-style-3 .nav-item .nav-link:after {
  position: absolute;
  content: "";
  inset-block-end: -2rem;
  inset-inline-start: 1.75rem;
  inset-inline-end: 0;
  inset-inline-start: 30%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FFF;
  border-radius: 50%;
  border: 2px solid #E8E8E8;
}
.tab-style-3 .nav-item .nav-link.home:after {
  content: "1";
}
.tab-style-3 .nav-item .nav-link.about:after {
  content: "2";
}
.tab-style-3 .nav-item .nav-link.services:after {
  content: "3";
}
.tab-style-3 .nav-item .nav-link:hover {
  border: 0;
  background: transparent;
  color: #E41F07;
}
.tab-style-3 .nav-item .nav-link.active {
  background-color: transparent;
  border: 0;
  color: #E41F07;
}
.tab-style-3 .nav-item .nav-link.active:before {
  background-color: #E41F07;
}
.tab-style-3 .nav-item .nav-link.active:after {
  border-color: #E41F07;
  color: #E41F07;
}

.tab-style-4.nav-tabs {
  border: 0;
}
.tab-style-4.nav-tabs .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-4.nav-tabs .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-4.nav-tabs .nav-link {
  border: 0;
}
.tab-style-4.nav-tabs .nav-link:hover {
  border: 0;
  background: transparent;
  color: #E41F07;
}
.tab-style-4.nav-tabs .nav-link.active {
  background-color: transparent;
  border: 0;
  color: #E41F07;
  position: relative;
  overflow: hidden;
}
.tab-style-4.nav-tabs .nav-link.active::before {
  position: absolute;
  content: "";
  width: 0.75rem;
  inset-block-start: 31px;
  transform: rotate(45deg);
  inset-inline-start: 47%;
  overflow: hidden;
  z-index: 1;
  height: 0.75rem;
  background-color: #E41F07;
  border: 1px solid #E41F07;
}
.tab-style-4.nav-tabs .nav-link.active:after {
  position: absolute;
  content: "";
  width: 40%;
  height: 1px;
  inset-inline-start: 30%;
  inset-block-end: 0;
  background-color: #E41F07;
}

#tab-style-4 .tab-pane.active {
  border: 1px solid #E41F07;
  background-color: #E41F07;
  color: #FFF;
  padding: 16px;
  border-radius: 7px;
}

.tab-style-5 .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-5 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-5 .nav-item .nav-link.active {
  background: #E41F07;
}

.tab-style-6 {
  border: 0;
  background-color: #FFF;
  border-radius: 7px;
  color: #E41F07;
  padding: 0.5rem;
}
.tab-style-6 .nav-item {
  border: 0;
  margin-inline-end: 0.5rem;
}
.tab-style-6 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-6 .nav-item .nav-link {
  color: #E41F07;
  padding: 0.5rem 1rem;
  font-size: 0.813rem;
  border: 0;
  font-weight: 500;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.tab-style-6 .nav-item .nav-link.active {
  border: 0;
  background-color: #E41F07;
  color: #FFF;
  border: 0;
  box-shadow: 0px 3px 10px 0px rgba(var(--dark-rgb), 0.05);
}
.tab-style-6 .nav-item .nav-link:hover, .tab-style-6 .nav-item .nav-link:focus {
  border: 0;
}

.tab-style-7 .nav-link {
  margin-block-end: 0.5rem;
  font-size: 0.813rem;
  color: #9595b5;
  text-align: left;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.tab-style-7 .nav-link:active, .tab-style-7 .nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}

.nav-style-1 .nav-item .nav-link.active {
  background-color: rgba(228, 31, 7, 0.1);
  color: #E41F07;
}

@media screen and (max-width: 400px) {
  .tab-style-4 .nav-link {
    padding-inline: 0.5rem;
  }
}
.nav-tabs {
  border-bottom: 0;
}
.nav-tabs.nav-tabs-bottom li {
  margin-bottom: -1px;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: 0 0;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link.active {
  border-color: #898989;
}
.nav-tabs li a {
  color: #565E5E;
  border-bottom-width: 2px;
}
.nav-tabs li a.active {
  border-color: transparent;
  border-bottom-color: #E41F07;
  background-color: transparent;
  transition: all 0.2s ease;
}

.nav-tabs .nav-tabs-solid {
  background-color: #FFF;
  border: 0;
}
.nav-tabs .nav-tabs-solid .active {
  background-color: #E41F07;
  border-color: #E41F07;
  color: #FFF;
}

.nav-tabs .nav-link:hover {
  border-color: transparent;
  color: #E41F07;
}
.nav-tabs.nav-tabs-top li a {
  border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top li a.active {
  border-top-color: #E41F07;
  border-radius: 0;
}
.nav-tabs.nav-tabs-top li a:hover {
  border-top-color: #E41F07;
  background-color: transparent;
  border-radius: 0;
}
.nav-tabs.nav-tabs-bottom li a {
  border-width: 0 0 2px 0;
}
.nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #E41F07;
  background: transparent;
  border-radius: 0;
}
.nav-tabs.nav-tabs-solid {
  background-color: #FFF;
  border: 0;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded li a.active {
  background-color: #E41F07;
  border-color: #E41F07;
  color: #FFF;
  border-radius: 50px;
}
.nav-tabs.nav-tabs-solid li a.active {
  background-color: #E41F07;
  border-color: #E41F07;
  color: #FFF;
  border-radius: 0;
}

.nav-link:hover {
  color: #E41F07;
}

.page-menu .nav-tabs li a {
  font-size: 16px;
}

.tabs-set .nav-tabs {
  border-bottom: 0;
  margin-bottom: 20px;
}
.tabs-set .nav-tabs .nav-link {
  color: #FFA201;
  padding: 8px 15px;
  font-size: 16px;
  font-weight: 700;
  border: 0;
  min-width: 120px;
  margin-right: 10px;
  border-radius: 8px;
  background: var(--Stroke, rgba(145, 158, 171, 0.3));
}
.tabs-set .nav-tabs .nav-link:focus {
  border-color: transparent;
}
.tabs-set .nav-tabs .nav-link:hover {
  border-color: transparent;
}
.tabs-set .nav-tabs .nav-link.active {
  border: 0;
  border-bottom: 2px solid #E41F07;
  background: #E41F07;
  color: #FFF;
}

.tabs-sets .nav-tabs {
  border-bottom: 0;
  margin: 0 0 40px;
}
.tabs-sets .nav-tabs .nav-link {
  color: #000;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  background: #898989;
  margin-right: 10px;
  padding: 8px 15px;
  border-radius: 8px;
  transition: all 0.5s ease;
}
.tabs-sets .nav-tabs .nav-link:focus, .tabs-sets .nav-tabs .nav-link:hover, .tabs-sets .nav-tabs .nav-link.active {
  background: #E41F07;
  color: #FFF;
}

@media (max-width: 768px) {
  .nav-tabs {
    border-bottom: 0;
    position: relative;
    background-color: #FFF;
    padding: 5px 0;
    border-radius: 3px;
  }
}
.ribbon1 {
  position: absolute;
  inset-block-start: -6.1px;
  inset-inline-end: 10px;
  color: #FFF;
  z-index: 1;
}
.ribbon1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 20px solid transparent;
  border-inline-end: 24px solid transparent;
  border-block-start: 13px solid #FC0027;
}
.ribbon1 span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-start-end-radius: 8px;
}
.ribbon1 span:before, .ribbon1 span:after {
  position: absolute;
  content: "";
}
.ribbon1 span:before {
  height: 6px;
  width: 6px;
  inset-inline-start: -6px;
  inset-block-start: 0;
  background: #FC0027;
}
.ribbon1 span:after {
  height: 6px;
  width: 8px;
  inset-inline-start: -8px;
  inset-block-start: 0;
  border-radius: 8px 8px 0 0;
  background: #FC0027;
}

.ribbone {
  width: 100%;
  position: relative;
  background-size: cover;
  text-transform: uppercase;
  color: #FFF;
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  z-index: 6;
}
.ribbone::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid;
}
.ribbone::before {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid;
}
.ribbone span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 3px 0;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #FFF;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
  text-align: center;
  font-size: 11px;
}

.ribbone1 {
  position: absolute;
  inset-block-start: -6.1px;
  inset-inline-start: 10px;
  z-index: 1;
}
.ribbone1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 20px solid transparent;
  border-inline-end: 24px solid transparent;
  border-block-start: 13px solid #FC0027;
}
.ribbone1 span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-start-end-radius: 8px;
}
.ribbone1 span:after {
  position: absolute;
  content: "";
  height: 6px;
  width: 8px;
  inset-inline-start: -8px;
  inset-block-start: 0;
  border-radius: 8px 8px 0 0;
  background: #FC0027;
}
.ribbone1 span:before {
  position: absolute;
  content: "";
  height: 6px;
  width: 6px;
  inset-inline-start: -6px;
  inset-block-start: 0;
  background: #FC0027;
}

.arrow-ribbone-left {
  color: #FFF;
  padding: 2px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-start: 0;
  z-index: 6;
  font-size: 13px;
}

.arrow-ribbone-left.bg-purple:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #4A00E5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-danger:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 112px solid transparent;
  border-inline-start: 12px solid #FC0027;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-primary:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-secondary:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #FFA201;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-success:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #E41F07;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-info:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #1ECBE2;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-warning:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #FDA700;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-pink:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #EA00B7;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-teal:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #02a8b5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right {
  color: #FFF;
  padding: 2px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-end: 0;
  z-index: 6;
  font-size: 13px;
}

.arrow-ribbone-right.bg-purple:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #4A00E5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-danger:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FC0027;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-primary:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-secondary:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FFA201;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-success:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #E41F07;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-info:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #1ECBE2;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-warning:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FDA700;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-pink:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #EA00B7;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-teal:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #02a8b5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone2 {
  color: #FFF;
  padding: 3px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-start: -1px;
  z-index: 6;
  font-size: 30px;
}
.arrow-ribbone2:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -24px;
  border-block-start: 24px solid transparent;
  border-block-end: 24px solid transparent;
  width: 0;
}

.power-ribbone {
  width: 56px;
  height: 56px;
  overflow: hidden;
  position: absolute;
  z-index: 6;
}
.power-ribbone span {
  position: absolute;
  display: block;
  width: 82px;
  padding: 8px 0;
  color: #FFF;
  font: 500 16px/1 Lato, sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
  text-align: center;
}

.power-ribbone-top-left {
  inset-block-start: -6px;
  inset-inline-start: -9px;
}
.power-ribbone-top-left span {
  inset-inline-end: -5px;
  inset-block-start: 1px;
  transform: rotate(-45deg);
}
.power-ribbone-top-left span i {
  transform: rotate(45deg);
  padding-block-start: 2px;
  padding-inline-start: 7px;
}

.power-ribbone-bottom-left {
  inset-block-end: -6px;
  inset-inline-start: -9px;
}
.power-ribbone-bottom-left span {
  inset-inline-end: -5px;
  inset-block-end: 1px;
  transform: rotate(45deg);
}
.power-ribbone-bottom-left span i {
  transform: rotate(-45deg);
  padding-block-end: 2px;
  padding-inline-start: 7px;
}

.power-ribbone-top-right {
  inset-block-start: -6px;
  inset-inline-end: -9px;
}
.power-ribbone-top-right span {
  inset-inline-start: -5px;
  inset-block-start: 1px;
  transform: rotate(45deg);
}
.power-ribbone-top-right span i {
  transform: rotate(-45deg);
  padding-block-start: 2px;
  padding-inline-end: 7px;
}

.power-ribbone-bottom-right {
  inset-block-end: -6px;
  inset-inline-end: -9px;
}
.power-ribbone-bottom-right span {
  inset-inline-start: -5px;
  inset-block-end: 1px;
  transform: rotate(-45deg);
}
.power-ribbone-bottom-right span i {
  transform: rotate(45deg);
  padding-block-end: 2px;
  padding-inline-end: 7px;
}

.ribbone-top-left {
  inset-block-start: -10px;
  inset-inline-start: -10px;
}
.ribbone-top-left::after {
  border-block-start-color: transparent;
  border-inline-start-color: transparent;
  inset-block-end: 50px;
  inset-inline-start: 0;
}
.ribbone-top-left::before {
  border-block-start-color: transparent;
  border-inline-start-color: transparent;
  inset-block-start: 0;
  inset-inline-end: 50px;
}
.ribbone-top-left span {
  inset-inline-end: 0px;
  inset-block-start: 24px;
  transform: rotate(-45deg);
}

.ribbone-top-right {
  inset-block-start: -10px;
  inset-inline-end: -10px;
}
.ribbone-top-right::after {
  border-block-start-color: transparent;
  border-inline-end-color: transparent;
  inset-block-end: 50px;
  inset-inline-end: 0;
}
.ribbone-top-right::before {
  border-block-start-color: transparent;
  border-inline-end-color: transparent;
  inset-block-start: 0;
  inset-inline-start: 50px;
}
.ribbone-top-right span {
  inset-inline-start: 0px;
  inset-block-start: 24px;
  transform: rotate(45deg);
}

.ribbone-warning-right {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-end: 10px;
  color: #FFF;
}
.ribbone-warning-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #FDA700;
  z-index: 6;
}
.ribbone-warning-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FDA700;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-end-radius: 10px;
  z-index: 6;
}
.ribbone-warning-right span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #FDA700;
  height: 6px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 0;
  border-start-start-radius: 50px;
  border-start-end-radius: 0;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-warning-right span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 3px;
  background: #FDA700;
}
.ribbone-warning-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-danger-right {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-end: 10px;
  color: #FFF;
}
.ribbone-danger-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #FC0027;
  z-index: 6;
}
.ribbone-danger-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-end-radius: 10px;
  z-index: 6;
}
.ribbone-danger-right span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #FC0027;
  height: 6px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 0;
  border-start-start-radius: 50px;
  border-start-end-radius: 0;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-danger-right span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 3px;
  background: #FC0027;
}
.ribbone-danger-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-success-left {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-start: 10px;
  color: #FFF;
}
.ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #5CB85C;
  z-index: 6;
}
.ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #5CB85C;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-start-radius: 10px;
  z-index: 6;
}
.ribbone-success-left span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #5CB85C;
  height: 6px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 0;
  border-start-start-radius: 0;
  border-start-end-radius: 50px;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-success-left span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 3px;
  background: #5CB85C;
}
.ribbone-success-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-info-left {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-start: 10px;
  color: #FFF;
}
.ribbone-info-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #1ECBE2;
  z-index: 6;
}
.ribbone-info-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #1ECBE2;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-start-radius: 10px;
  z-index: 6;
}
.ribbone-info-left span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #1ECBE2;
  height: 6px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 0;
  border-start-start-radius: 0;
  border-start-end-radius: 50px;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-info-left span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 3px;
  background: #1ECBE2;
}
.ribbone-info-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-success-left {
  position: absolute;
  inset-inline-start: 10px;
  color: #FFF;
}
.bookmark-ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-start: 0;
  border-inline-start: 18px solid #5CB85C;
  border-inline-end: 18px solid #5CB85C;
  border-block-end: 10px solid transparent;
}
.bookmark-ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #5CB85C;
  font-size: 13px;
  line-height: 1;
  padding: 12px 3px 20px;
  z-index: 6;
}
.bookmark-ribbone-success-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-danger-left {
  position: absolute;
  inset-inline-start: 10px;
  color: #FFF;
  width: 30px;
}
.bookmark-ribbone-danger-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-start: 0;
  border-inline-start: 15px solid #FC0027;
  border-inline-end: 15px solid #FC0027;
  border-block-end: 8px solid transparent;
}
.bookmark-ribbone-danger-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #FC0027;
  font-size: 12px;
  line-height: 1;
  padding: 12px 0px;
  z-index: 6;
}
.bookmark-ribbone-danger-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-secondary-right {
  position: absolute;
  inset-inline-end: 10px;
  color: #FFF;
  width: 30px;
}
.bookmark-ribbone-secondary-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-end: 0;
  border-inline-start: 15px solid #FFA201;
  border-inline-end: 15px solid #FFA201;
  border-block-end: 8px solid transparent;
}
.bookmark-ribbone-secondary-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FFA201;
  font-size: 11px;
  line-height: 1;
  padding: 12px 0px;
  z-index: 6;
}
.bookmark-ribbone-secondary-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-sideleft-ribbone-success-left {
  position: absolute;
  inset-block-start: 10px;
  color: #FFF;
}
.bookmark-sideleft-ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-block-start: 0;
  inset-inline-end: -8px;
  border-block-start: 13px solid #5CB85C;
  border-block-end: 13px solid #5CB85C;
  border-inline-end: 8px solid transparent;
}
.bookmark-sideleft-ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #5CB85C;
  font-size: 11px;
  padding: 5px 13px;
  z-index: 6;
  height: 26px;
}
.bookmark-sideleft-ribbone-success-left i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-sideright-ribbone-primary-right {
  position: absolute;
  inset-block-start: 10px;
  inset-inline-end: 0;
  color: #FFF;
}
.bookmark-sideright-ribbone-primary-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-block-start: 0;
  inset-inline-start: -8px;
  border-block-start: 13px solid #E41F07;
  border-block-end: 13px solid #E41F07;
  border-inline-start: 8px solid transparent;
}
.bookmark-sideright-ribbone-primary-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #E41F07;
  font-size: 11px;
  padding: 5px 13px;
  z-index: 6;
  height: 26px;
}
.bookmark-sideright-ribbone-primary-right i {
  color: #FFF;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-1 span:after {
  position: absolute;
  content: "";
}

.arrow-ribbone-2 {
  color: #FFF;
  padding: 3px 8px;
  position: absolute;
  z-index: 6;
  font-size: 20px;
}
.arrow-ribbone-2:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -24px;
  border-block-start: 16px solid transparent;
  border-inline-start: 24px solid #4A00E5;
  border-block-end: 16px solid transparent;
  width: 0;
}

.ribbone-card {
  overflow: hidden;
}

.fullwidth-primary-ribbons .bar {
  color: #FFF;
  background-color: #E41F07;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-primary-ribbons .bar span {
  position: absolute;
}
.fullwidth-primary-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-primary-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-primary-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-color: #E41F07 #E41F07 #E41F07 transparent;
  border-block-start-color: #E41F07;
  border-inline-end-color: #E41F07;
  border-block-end-color: #E41F07;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-primary-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #E41F07;
  border-inline-end-color: transparent;
  border-block-end-color: #E41F07;
  border-inline-start-color: #E41F07;
  inset-inline-end: -30px;
}

.fullwidth-secondary-ribbons .bar {
  color: #FFF;
  background-color: #FFA201;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-secondary-ribbons .bar span {
  position: absolute;
}
.fullwidth-secondary-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FFA201;
  border-inline-end-color: #FFA201;
  border-block-end-color: #FFA201;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FFA201;
  border-inline-end-color: transparent;
  border-block-end-color: #FFA201;
  border-inline-start-color: #FFA201;
  inset-inline-end: -30px;
}

.fullwidth-arrow-warning-ribbons .bar {
  color: #FFF;
  background-color: #FDA700;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-arrow-warning-ribbons .bar span {
  position: absolute;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FDA700;
  border-inline-end-color: #FDA700;
  border-block-end-color: #FDA700;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start: 18px solid transparent;
  border-inline-start: 18px solid #FDA700;
  border-block-end: 18px solid transparent;
  border-inline-end: transparent;
  inset-inline-end: -20px;
  inset-block-start: -2px;
}

.fullwidth-arrow-danger-ribbons-right .bar {
  color: #FFF;
  background-color: #FC0027;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #FDFDFE;
}
.fullwidth-arrow-danger-ribbons-right .bar span {
  position: absolute;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FC0027;
  border-inline-end-color: transparent;
  border-block-end-color: #FC0027;
  border-inline-start-color: #FC0027;
  inset-inline-end: -30px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start: 18px solid transparent;
  border-inline-end: 18px solid #FC0027;
  border-block-end: 18px solid transparent;
  border-inline-start: transparent;
  inset-inline-start: -20px;
  inset-block-start: -2px;
}

.power-ribbone span svg {
  width: 15px;
  height: 15px;
}

.ribbone-card .card-body {
  padding: 25px;
}

.ribbone-row .feather-zap {
  width: 15px;
  height: 15px;
}

[data-bs-toggle=card-fullscreen] svg {
  width: 15px;
  height: 15px;
}

[data-bs-toggle=card-remove] svg {
  width: 15px;
  height: 15px;
}

svg.collapse-open, svg.collapse-close {
  width: 15px;
  height: 15px;
}

.btn-icon.btn-danger-light {
  color: #FC1A3D;
  background: #FFEEEC;
}

.live-rating.badge {
  background: #E0F5D7;
  color: #6CBF6C;
}

@media (min-width: 576px) {
  .mx-sm-7 {
    margin-inline: 3rem !important;
  }
}
[dir=rtl] .power-ribbone-top-left span {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-top-left span i {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-bottom-left span {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-bottom-left span i {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-top-right span {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-top-right span i {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-bottom-right span {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-bottom-right span i {
  transform: rotate(-45deg);
}
[dir=rtl] .ribbone-top-left span {
  transform: rotate(45deg);
}
[dir=rtl] .ribbone-top-right span {
  transform: rotate(-45deg);
}
[dir=rtl] .ribbon-price .badge {
  transform: rotate(-45deg);
}

.modal-barcode ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.modal-barcode ul li {
  border-radius: 7px;
  width: 25%;
  margin-bottom: 10px;
  padding: 0 5px;
}
@media (max-width: 991.98px) {
  .modal-barcode ul li {
    width: 50%;
  }
}
.modal-barcode ul li a {
  border: 1px solid #6F6F6F;
  border-radius: 10px;
  display: block;
  padding: 10px;
  text-align: center;
}

.modal .modal-content {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  border-radius: 5px;
}
.modal .modal-title {
  font-weight: 700;
}
@media (max-width: 991.98px) {
  .modal .modal-title {
    font-size: 16px;
  }
}
.modal .logo-lg img {
  width: 150px;
}
.modal .modal-header {
  border-color: #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  justify-content: space-between;
}
.modal .modal-header .close,
.modal .modal-header .btn-close {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FD4D68;
  opacity: 1;
  font-size: 12px;
  width: 22px;
  height: 22px;
  border: 0;
  font-weight: 700;
  background-color: transparent;
  border-radius: 50px;
}
.modal .modal-header .close:hover,
.modal .modal-header .btn-close:hover {
  background-color: transparent;
  color: #FFF;
}
.modal .modal-footer .btn-print {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E41F07;
  color: #E41F07;
}
.modal .modal-footer .btn-print img {
  margin-left: 10px;
}
.modal .modal-footer .btn-print:hover {
  background: #E41F07;
  color: #FFF;
}
.modal .modal-footer .btn-print:hover img {
  filter: brightness(0) invert(1);
}
.modal .modal-footer .btn-secondary {
  background: #FFA201;
}
.modal .modal-footer .btn-secondary:hover {
  box-shadow: inset 0 0px 0px 100px #FFF;
  color: #FFA201 !important;
}
.modal .modal-dialog.right-slider-modal {
  margin: 0;
  margin-left: auto;
  max-width: 1102px;
}
.modal .modal-dialog.add-centered {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  max-width: 1192px;
}
.modal .modal-dialog.sales-details-modal {
  max-width: 1192px;
}
.modal .modal-dialog.edit-sales-modal {
  max-width: 1192px;
}
.modal .edit-add.card.edit-expense {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.modal .note-editor.note-frame.card {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.offcanvas.offcanvas-end {
  width: auto !important;
}

.offcanvas.offcanvas-end.em-payrol-add {
  max-width: 1192px !important;
}

.modal.animated .modal-dialog {
  transform: translate(0, 0);
}
.modal.effect-scale .modal-dialog {
  transform: scale(0.7);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-scale.show .modal-dialog {
  transform: scale(1);
  opacity: 1;
}
.modal.effect-slide-in-right .modal-dialog {
  transform: translateX(20%);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.modal.effect-slide-in-right.show .modal-dialog {
  transform: translateX(0);
  opacity: 1;
}
.modal.effect-slide-in-bottom .modal-dialog {
  transform: translateY(20%);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-slide-in-bottom.show .modal-dialog {
  transform: translateY(0);
  opacity: 1;
}
.modal.effect-newspaper .modal-dialog {
  transform: scale(0) rotate(720deg);
  opacity: 0;
}
.modal.effect-newspaper.show ~ .modal-backdrop, .modal.effect-newspaper .modal-dialog {
  transition: all 0.5s;
}
.modal.effect-newspaper.show .modal-dialog {
  transform: scale(1) rotate(0deg);
  opacity: 1;
}
.modal.effect-fall {
  perspective: 1300px;
}
.modal.effect-fall .modal-dialog {
  transform-style: preserve-3d;
  transform: translateZ(600px) rotateX(20deg);
  opacity: 0;
}
.modal.effect-fall.show .modal-dialog {
  transition: all 0.3s ease-in;
  transform: translateZ(0px) rotateX(0deg);
  opacity: 1;
}
.modal.effect-flip-horizontal {
  perspective: 1300px;
}
.modal.effect-flip-horizontal .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateY(-70deg);
  transition: all 0.3s;
  opacity: 0;
}
.modal.effect-flip-horizontal.show .modal-dialog {
  transform: rotateY(0deg);
  opacity: 1;
}
.modal.effect-flip-vertical {
  perspective: 1300px;
}
.modal.effect-flip-vertical .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateX(-70deg);
  transition: all 0.3s;
  opacity: 0;
}
.modal.effect-flip-vertical.show .modal-dialog {
  transform: rotateX(0deg);
  opacity: 1;
}
.modal.effect-super-scaled .modal-dialog {
  transform: scale(2);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-super-scaled.show .modal-dialog {
  transform: scale(1);
  opacity: 1;
}
.modal.effect-sign {
  perspective: 1300px;
}
.modal.effect-sign .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateX(-60deg);
  transform-origin: 50% 0;
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-sign.show .modal-dialog {
  transform: rotateX(0deg);
  opacity: 1;
}
.modal.effect-rotate-bottom {
  perspective: 1300px;
}
.modal.effect-rotate-bottom .modal-dialog {
  transform-style: preserve-3d;
  transform: translateY(100%) rotateX(90deg);
  transform-origin: 0 100%;
  opacity: 0;
  transition: all 0.3s ease-out;
}
.modal.effect-rotate-bottom.show .modal-dialog {
  transform: translateY(0%) rotateX(0deg);
  opacity: 1;
}
.modal.effect-rotate-left {
  perspective: 1300px;
}
.modal.effect-rotate-left .modal-dialog {
  transform-style: preserve-3d;
  transform: translateZ(100px) translateX(-30%) rotateY(90deg);
  transform-origin: 0 100%;
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-rotate-left.show .modal-dialog {
  transform: translateZ(0px) translateX(0%) rotateY(0deg);
  opacity: 1;
}

.offcanvas-end.offcanvas-large {
  width: 700px !important;
}

.modal {
  z-index: 1050 !important;
}

.modal-backdrop {
  z-index: 1001 !important;
}

.status-toggle.small-toggle-btn {
  float: unset;
}
.status-toggle.small-toggle-btn .label-text {
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 400;
}
.status-toggle.small-toggle-btn .checktoggle {
  width: 24px;
  height: 12px;
}
.status-toggle.small-toggle-btn .checktoggle:after {
  width: 8px;
  height: 8px;
}
.status-toggle.small-toggle-btn .check:checked + .checktoggle:after {
  right: 0;
  width: 8px;
  height: 8px;
}
.status-toggle .check {
  display: block;
  height: 0;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  margin: 0;
  padding: 0;
}
.status-toggle .check:checked + .checktoggle:after {
  left: 100%;
  transform: translate(calc(-100% - 3px), -50%);
  right: 0;
  width: 10px;
  height: 10px;
}
.status-toggle .check:checked + .checktoggle {
  background: #1ABE17;
}
.status-toggle .checktoggle {
  background: #CDCDCD;
  cursor: pointer;
  display: block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
  border-radius: 12px;
  width: 30px;
  height: 14px;
}
.status-toggle .checktoggle:after {
  content: " ";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #FFF;
  transition: all 0.2s ease;
  transform: translate(3px, -50%);
  -webkit-transform: translate(3px, -50%);
  -ms-transform: translate(3px, -50%);
  position: absolute;
  top: 50%;
  left: 0;
  border-radius: 50%;
}

.modal-btn .btn {
  margin: 0 10px 0 0;
  padding: 7px 15px;
}
.modal-btn .btn:last-child {
  margin-right: 0;
}

.custom-modal .modal-header .btn-close {
  margin: 0;
  padding: 0;
  background: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 50%;
  color: #6F6F6F;
  font-weight: 400;
  font-size: 14px;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  height: 26px;
  width: 26px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  transition: all 0.7s;
}
.custom-modal .modal-header .btn-close:hover {
  border: 1px solid #E41F07;
  background: #E41F07;
  color: #FFF;
  transition: all 0.7s;
  transform: rotateZ(360deg);
}

.grid-showcase {
  margin-bottom: -10px;
}
.grid-showcase span, .grid-showcase .grid-wrapper {
  display: block;
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  background-color: rgba(242, 243, 247, 0.7);
}

.grid-align {
  margin-bottom: -16px;
}

.grid-align .row {
  padding: 15px 0;
  min-height: 7rem;
  margin-bottom: 16px;
}

.grid-vertical {
  min-height: 150px;
  padding: 10px;
  color: #000;
}

table.table-bordered thead tr th p {
  margin-bottom: 0;
}

/******* Base *******/
body {
  font-family: "Noto Sans", sans-serif;
  font-size: 14px;
  color: #6F6F6F;
  line-height: 1.5;
  background-color: #F9F9FC;
  overflow-y: auto;
  overflow-x: hidden;
}

html {
  font-family: "Noto Sans", sans-serif;
}

::selection {
  background: #E41F07;
  color: #FFF;
  text-shadow: none;
}

img {
  max-width: 100%;
  height: auto;
  vertical-align: inherit;
}

* {
  outline: none;
}

button {
  transition: all 0.5s ease;
}
button:focus {
  box-shadow: none !important;
}

p {
  margin-bottom: 20px;
}
p:last-child {
  margin-bottom: 0;
}

strong {
  font-weight: 700;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  color: #262A2A;
  font-family: "Noto Sans", sans-serif;
  font-weight: 700;
  margin-bottom: 0;
}

ol, ul {
  list-style: none;
  margin-block-end: 0;
  padding: 0;
}

ul {
  list-style: none;
}
ul.list-disc {
  list-style: disc;
  padding-left: 15px;
}
ul.list-disc ul {
  list-style-type: circle;
}
ul.list-decimal {
  list-style: decimal;
  padding-left: 15px;
}
ul.list-decimal ul {
  list-style-type: decimal;
}
ul.list-icon {
  list-style: none;
  padding-left: 0;
}
ul.list-icon > li {
  padding-left: 1.875rem;
  counter-increment: li;
}
ul.list-icon > li i,
ul.list-icon > li .feather-icon,
ul.list-icon > li .svg-icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  text-align: center;
  margin-left: -1.25rem;
  position: relative;
  left: -10px;
  padding: 1px;
  top: -1px;
}
ul.list-icon > li i {
  font-size: 20px;
  top: 5px;
}
ul .btn-primary:not(:disabled):not(.disabled):active:focus, ul .btn-primary:not(:disabled):not(.disabled).active:focus {
  box-shadow: none;
}

.bg-primary {
  background-color: #E41F07 !important;
}

.bg-secondary {
  background-color: #FFA201 !important;
}

.bg-info {
  background-color: #1ECBE2 !important;
}

.bg-success {
  background-color: #5CB85C !important;
  color: #FFF !important;
}

.bg-warning {
  background-color: #FDA700 !important;
  color: #FFF !important;
}

.bg-danger {
  background-color: #FC0027 !important;
  color: #FFF !important;
}

.bg-dark {
  background-color: #171724 !important;
}

.bg-light {
  background-color: #FDFDFE !important;
}

.bg-light-300 {
  background-color: #F6F6F6 !important;
}

.bg-light-400 {
  background: #F5F5F5;
}

.bg-light-600 {
  background-color: #F4F4F4 !important;
}

.bg-white {
  background-color: #FFF !important;
}

.bg-pink {
  background-color: #EA00B7 !important;
}

.bg-purple {
  background-color: #4A00E5 !important;
}

.bg-teal {
  background-color: #02a8b5 !important;
}

.bg-blue {
  background-color: #339DFF !important;
}

.bg-tertiary {
  background-color: #3C2371 !important;
}

.bg-violet {
  background-color: #676DFF !important;
}

.bg-green {
  background-color: #00918E !important;
}

.bg-gray {
  background: #E0E2E7;
}

.bg-primary {
  background-color: #E41F07 !important;
}
.bg-primary.bg-opacity-10 {
  background-color: rgba(228, 31, 7, 0.1) !important;
}
.bg-primary.bg-opacity-25 {
  background-color: rgba(228, 31, 7, 0.25) !important;
}
.bg-primary.bg-opacity-50 {
  background-color: rgba(228, 31, 7, 0.5) !important;
}
.bg-primary.bg-opacity-75 {
  background-color: rgba(228, 31, 7, 0.75) !important;
}
.bg-primary.bg-opacity-100 {
  background-color: #e41f07 !important;
}

.bg-secondary {
  background-color: #FFA201 !important;
}
.bg-secondary.bg-opacity-10 {
  background-color: rgba(255, 162, 1, 0.1) !important;
}
.bg-secondary.bg-opacity-25 {
  background-color: rgba(255, 162, 1, 0.25) !important;
}
.bg-secondary.bg-opacity-50 {
  background-color: rgba(255, 162, 1, 0.5) !important;
}
.bg-secondary.bg-opacity-75 {
  background-color: rgba(255, 162, 1, 0.75) !important;
}
.bg-secondary.bg-opacity-100 {
  background-color: #ffa201 !important;
}

.bg-info {
  background-color: #1ECBE2 !important;
}
.bg-info.bg-opacity-10 {
  background-color: rgba(30, 203, 226, 0.1) !important;
}
.bg-info.bg-opacity-25 {
  background-color: rgba(30, 203, 226, 0.25) !important;
}
.bg-info.bg-opacity-50 {
  background-color: rgba(30, 203, 226, 0.5) !important;
}
.bg-info.bg-opacity-75 {
  background-color: rgba(30, 203, 226, 0.75) !important;
}
.bg-info.bg-opacity-100 {
  background-color: #1ecbe2 !important;
}

.bg-success {
  background-color: #5CB85C !important;
}
.bg-success.bg-opacity-10 {
  background-color: rgba(92, 184, 92, 0.1) !important;
}
.bg-success.bg-opacity-25 {
  background-color: rgba(92, 184, 92, 0.25) !important;
}
.bg-success.bg-opacity-50 {
  background-color: rgba(92, 184, 92, 0.5) !important;
}
.bg-success.bg-opacity-75 {
  background-color: rgba(92, 184, 92, 0.75) !important;
}
.bg-success.bg-opacity-100 {
  background-color: #5cb85c !important;
}

.bg-warning {
  background-color: #FDA700 !important;
}
.bg-warning.bg-opacity-10 {
  background-color: rgba(253, 167, 0, 0.1) !important;
}
.bg-warning.bg-opacity-25 {
  background-color: rgba(253, 167, 0, 0.25) !important;
}
.bg-warning.bg-opacity-50 {
  background-color: rgba(253, 167, 0, 0.5) !important;
}
.bg-warning.bg-opacity-75 {
  background-color: rgba(253, 167, 0, 0.75) !important;
}
.bg-warning.bg-opacity-100 {
  background-color: #fda700 !important;
}

.bg-danger {
  background-color: #FC0027 !important;
}
.bg-danger.bg-opacity-10 {
  background-color: rgba(252, 0, 39, 0.1) !important;
}
.bg-danger.bg-opacity-25 {
  background-color: rgba(252, 0, 39, 0.25) !important;
}
.bg-danger.bg-opacity-50 {
  background-color: rgba(252, 0, 39, 0.5) !important;
}
.bg-danger.bg-opacity-75 {
  background-color: rgba(252, 0, 39, 0.75) !important;
}
.bg-danger.bg-opacity-100 {
  background-color: #fc0027 !important;
}

.bg-dark {
  background-color: #171724 !important;
}
.bg-dark.bg-opacity-10 {
  background-color: rgba(23, 23, 36, 0.1) !important;
}
.bg-dark.bg-opacity-25 {
  background-color: rgba(23, 23, 36, 0.25) !important;
}
.bg-dark.bg-opacity-50 {
  background-color: rgba(23, 23, 36, 0.5) !important;
}
.bg-dark.bg-opacity-75 {
  background-color: rgba(23, 23, 36, 0.75) !important;
}
.bg-dark.bg-opacity-100 {
  background-color: #171724 !important;
}

.bg-light {
  background-color: #FDFDFE !important;
}
.bg-light.bg-opacity-10 {
  background-color: rgba(253, 253, 254, 0.1) !important;
}
.bg-light.bg-opacity-25 {
  background-color: rgba(253, 253, 254, 0.25) !important;
}
.bg-light.bg-opacity-50 {
  background-color: rgba(253, 253, 254, 0.5) !important;
}
.bg-light.bg-opacity-75 {
  background-color: rgba(253, 253, 254, 0.75) !important;
}
.bg-light.bg-opacity-100 {
  background-color: #fdfdfe !important;
}

.bg-primary {
  background-color: #E41F07 !important;
  border: 1px solid #E41F07 !important;
  color: #FFF;
}

.bg-secondary {
  background-color: #FFA201 !important;
  border: 1px solid #FFA201 !important;
  color: #FFF;
}

.bg-success {
  background-color: #5CB85C !important;
  border: 1px solid #5CB85C !important;
  color: #FFF;
}

.bg-info {
  background-color: #1ECBE2 !important;
  border: 1px solid #1ECBE2 !important;
  color: #FFF;
}

.bg-warning {
  background-color: #FDA700 !important;
  border: 1px solid #FDA700 !important;
  color: #FFF;
}

.bg-danger {
  background-color: #FC0027 !important;
  border: 1px solid #FC0027 !important;
  color: #FFF;
}

.bg-dark {
  background-color: #171724 !important;
  border: 1px solid #171724 !important;
  color: #FFF;
}

.bg-light {
  background-color: #FDFDFE !important;
  border: 1px solid #FDFDFE !important;
  color: #FFF;
}

.bg-black {
  background-color: #000 !important;
  border: 1px solid #000 !important;
  color: #FFF;
}

.bg-purple {
  background-color: #4A00E5 !important;
  border: 1px solid #4A00E5 !important;
  color: #FFF;
}

.bg-yellow {
  background-color: #ffff00 !important;
  border: 1px solid #ffff00 !important;
  color: #FFF;
}

.bg-teal {
  background-color: #02a8b5 !important;
  border: 1px solid #02a8b5 !important;
  color: #FFF;
}

.bg-soft-primary {
  background-color: #F7BCB5;
  color: #E41F07;
}

.bg-soft-secondary {
  background-color: #FFE3B3;
  color: #FFA201;
}

.bg-soft-success {
  background-color: #CEEACE;
  color: #5CB85C;
}

.bg-soft-danger {
  background-color: #FEB3BE;
  color: #FC0027;
}

.bg-soft-warning {
  background-color: #FEE5B3;
  color: #FDA700;
}

.bg-soft-info {
  background-color: rgba(30, 203, 226, 0.3);
  color: #1ECBE2;
}

.bg-soft-light {
  background-color: rgba(253, 253, 254, 0.9);
  color: #6F6F6F;
}

.bg-soft-dark {
  background-color: rgba(23, 23, 36, 0.3);
  color: #FFF;
}

.bg-light {
  color: #6F6F6F;
}

.bg-primary-gradient {
  background: linear-gradient(to right, #E41F07 0%, #8e77fa 100%) !important;
  color: #FFF;
}

.bg-secondary-gradient {
  background: linear-gradient(to right, #FFA201 0%, #28b7f9 100%) !important;
  color: #FFF;
}

.bg-warning-gradient {
  background: linear-gradient(to right, #FDA700 0%, #fbc434 100%) !important;
  color: #FFF;
}

.bg-info-gradient {
  background: linear-gradient(to right, #1ECBE2 0%, #00f2fe 100%) !important;
  color: #FFF;
}

.bg-success-gradient {
  background: linear-gradient(to right, #5CB85C 0%, #5cf9e2 100%) !important;
  color: #FFF;
}

.bg-danger-gradient {
  background: linear-gradient(to right, #FC0027 0%, #fd4a68 100%) !important;
  color: #FFF;
}

.bg-orange-gradient {
  background: linear-gradient(to right, #FF9D0A 0%, #FBB034 100%) !important;
  color: #FFF;
}

.bg-purple-gradient {
  background: linear-gradient(to right, #4A00E5 0%, #9b25b7 100%) !important;
  color: #FFF;
}

.bg-teal-gradient {
  background: linear-gradient(to right, #02a8b5 0%, #0695DD 100%) !important;
  color: #FFF;
}

.bg-light-gradient {
  background: linear-gradient(to right, #FDFDFE 0%, #D1D6DE 100%) !important;
  color: #000;
}

.bg-dark-gradient {
  background: linear-gradient(to right, #171724 0%, #54505D 100%) !important;
  color: #FFF;
}

.bg-outline-primary {
  background-color: #FFF;
  border: 1px solid #E41F07;
  color: #E41F07;
}

.bg-outline-secondary {
  background-color: #FFF;
  border: 1px solid #FFA201;
  color: #FFA201;
}

.bg-outline-warning {
  background-color: #FFF;
  border: 1px solid #FDA700;
  color: #FDA700;
}

.bg-outline-info {
  background-color: #FFF;
  border: 1px solid #1ECBE2;
  color: #1ECBE2;
}

.bg-outline-success {
  background-color: #FFF;
  border: 1px solid #5CB85C;
  color: #5CB85C;
}

.bg-outline-danger {
  background-color: #FFF;
  border: 1px solid #FC0027;
  color: #FC0027;
}

.bg-outline-dark {
  background-color: #FFF;
  border: 1px solid #171724;
  color: #171724;
}

.bg-outline-light {
  background-color: #FFF;
  border: 1px solid #FDFDFE !important;
  color: #000 !important;
}

.bg-primary-transparent {
  background-color: rgba(228, 31, 7, 0.1) !important;
  color: #E41F07 !important;
}
.bg-primary-transparent:hover {
  background-color: rgba(228, 31, 7, 0.1) !important;
  color: #E41F07 !important;
}

.bg-secondary-transparent {
  background-color: rgba(255, 162, 1, 0.1) !important;
  color: #FFA201 !important;
}
.bg-secondary-transparent:hover {
  background-color: rgba(255, 162, 1, 0.1) !important;
  color: #FFA201 !important;
}

.bg-info-transparent {
  background-color: rgba(30, 203, 226, 0.1) !important;
  color: #1ECBE2 !important;
}
.bg-info-transparent:hover {
  background-color: rgba(30, 203, 226, 0.1) !important;
  color: #1ECBE2 !important;
}

.bg-success-transparent {
  background-color: rgba(92, 184, 92, 0.1) !important;
  color: #5CB85C !important;
}
.bg-success-transparent:hover {
  background-color: rgba(92, 184, 92, 0.1) !important;
  color: #5CB85C !important;
}

.bg-warning-transparent {
  background-color: rgba(253, 167, 0, 0.1) !important;
  color: #FDA700 !important;
}
.bg-warning-transparent:hover {
  background-color: rgba(253, 167, 0, 0.1) !important;
  color: #FDA700 !important;
}

.bg-danger-transparent {
  background-color: rgba(252, 0, 39, 0.1) !important;
  color: #FC0027 !important;
}
.bg-danger-transparent:hover {
  background-color: rgba(252, 0, 39, 0.1) !important;
  color: #FC0027 !important;
}

.bg-light-transparent {
  background-color: rgba(253, 253, 254, 0.5) !important;
  color: #FDFDFE !important;
}
.bg-light-transparent:hover {
  background-color: rgba(253, 253, 254, 0.5) !important;
  color: #6F6F6F !important;
}

.bg-gray-100 {
  background-color: #C0C0C0;
}

.bg-gray-200 {
  background-color: #9B9B9B;
}

.bg-gray-300 {
  background-color: #898989;
}

.bg-gray-400 {
  background-color: #6F6F6F;
}

.bg-gray-500 {
  background-color: #6F7A7A;
}

.bg-gray-600 {
  background-color: #565E5E;
}

.bg-gray-700 {
  background-color: #424848;
}

.bg-gray-800 {
  background-color: #323737;
}

.bg-gray-900 {
  background-color: #262A2A;
}

.svg-primary {
  fill: #E41F07;
}

.svg-secondary {
  fill: #FFA201;
}

.svg-success {
  fill: #5CB85C;
}

.svg-danger {
  fill: #FC0027;
}

.svg-warning {
  fill: #FDA700;
}

.svg-white {
  fill: #FFF;
}

.svg-black {
  fill: #000;
}

.svg-pink {
  fill: #EA00B7;
}

.svg-orange {
  fill: #FF9D0A;
}

.svg-purple {
  fill: #4A00E5;
}

.svg-indigo {
  fill: #0092E4;
}

.svg-info {
  fill: #1ECBE2;
}

.svg-yellow {
  fill: #ffff00;
}

.svg-light {
  fill: #FDFDFE;
}

.svg-dark {
  fill: #171724;
}

.svg-teal {
  fill: #02a8b5;
}

.svg-default {
  fill: #6F6F6F;
}

.color-container {
  width: 5rem;
  height: 5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 3rem;
}

.text-container {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  box-shadow: 0px 4px 54px 0px rgba(224, 224, 224, 0.2509803922);
}

.color-box {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  margin-right: 0.75rem;
  margin-bottom: 0.75rem;
}

.bg-soft-purple {
  background: #F3EDFF !important;
  border-color: #F3EDFF !important;
}

.text-purple {
  color: #4A00E5;
}

.bg-light-200 {
  background: #F9F9FC;
}

.bg-light-100 {
  background: #FAFAFA;
}

.bg-danger-light {
  background: #FFEEEC;
}

.bg-pending {
  background: #676DFF !important;
  color: #FFF !important;
}

.bg-secondary-success {
  background: #00918E !important;
}

.bg-orange {
  background: #FF9D0A;
}

.text-blue {
  color: #4A00E5 !important;
}

.text-blue-light {
  color: #0092E4 !important;
}

/******* Pages ******/
.page-header {
  margin-bottom: 14px;
}
.page-header .page-title {
  font-weight: 600;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .page-header .page-title {
    font-size: 18px;
  }
}
@media (max-width: 767.98px) {
  .page-header .page-title {
    margin-bottom: 14px;
  }
}
.page-header .page-title .count-title {
  background: #F3EDFF;
  border-radius: 5px;
  margin: 0 0 0 8px;
  padding: 5px;
  color: #4A00E5;
  font-size: 12px;
  font-weight: 600;
}
@media (max-width: 991.98px) {
  .page-header .title-head {
    margin-top: 0;
  }
}
.page-header .head-icons {
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .page-header .head-icons {
    display: none;
  }
}
.page-header .head-icons a {
  width: 32px;
  height: 32px;
  background: #FFF;
  color: #262A2A;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin-right: 8px;
}
.page-header .head-icons a.active, .page-header .head-icons a:hover {
  background: #00918E;
  color: #FFF;
}
.page-header .head-icons a:last-child {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .page-header .head-icons a {
    margin-right: 4px !important;
  }
  .page-header .head-icons a:last-child {
    margin-right: 0 !important;
  }
}
.page-header .form-sort {
  margin-top: 0;
}

.set-star i {
  color: #E8E8E8;
}
.set-star i.filled {
  color: #FF9D0A;
}

.rating-select.filled i {
  color: #FF9D0A;
}

.icon-form {
  position: relative;
}
.icon-form .form-icon {
  position: absolute;
  top: 50%;
  left: 15px;
  transform: translateY(-50%);
  color: #262A2A;
}
.icon-form .form-control {
  padding: 8px 15px 8px 35px;
}
.icon-form .form-control:focus {
  padding: 8px 15px 8px 35px;
}

.icon-form-end {
  position: relative;
}
.icon-form-end .form-icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  color: #262A2A;
}
.icon-form-end .form-control {
  padding: 8px 34px 8px 15px;
}

.view-icons {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  padding: 2px;
  display: inline-flex;
  align-items: center;
}
.view-icons a {
  width: 34px;
  height: 36px;
  background: #FFF;
  color: #262A2A;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.view-icons a:first-child {
  border-radius: 5px 0 0 5px;
}
.view-icons a:last-child {
  border-radius: 0 5px 5px 0;
}
.view-icons a.active, .view-icons a:hover {
  background: #00918E;
  color: #FFF;
}

.sidebar-popoverlay {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: -100%;
  z-index: 1003;
}
.sidebar-popoverlay.open {
  left: 0;
}

.sidebar-popoverlay-sign {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.75);
  top: 0;
  left: -100%;
  z-index: 1003;
}
.sidebar-popoverlay-sign.open {
  left: 0;
}

.profile-pic-upload {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.profile-pic-upload .profile-pic {
  border: 2px dashed #E8E8E8;
  margin: 0 15px 10px 0;
  width: 100px;
  height: 100px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
}
.profile-pic-upload .profile-pic span {
  display: flex;
}
.profile-pic-upload .profile-pic img {
  width: 70px;
  height: 70px;
  border-radius: 5px;
}
.profile-pic-upload .profile-pic .close-img {
  background: #FC0027;
  color: #FFF;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  top: 10px;
  right: 10px;
}
.profile-pic-upload .upload-content p {
  margin-bottom: 10px;
}
.profile-pic-upload .upload-btn {
  background: #F3EDFF;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  display: inline-block;
}
.profile-pic-upload .upload-btn span {
  padding: 9px 12px;
  cursor: pointer;
  color: #4A00E5;
  display: inline-block;
}
.profile-pic-upload .upload-btn span i {
  margin-right: 10px;
}
.profile-pic-upload .upload-btn input {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}

.user-accordion-item {
  background: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  margin-bottom: 15px;
}
.user-accordion-item .accordion-wrap {
  padding: 10px 25px 10px 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  position: relative;
}
.user-accordion-item .accordion-wrap span {
  width: 36px;
  height: 36px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
}
.user-accordion-item .accordion-wrap:hover {
  color: #262A2A;
}
.user-accordion-item .accordion-wrap::before {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size: 14px;
  font-weight: 600;
}
.user-accordion-item .accordion-wrap:not(.collapsed)::before {
  content: "\\f078";
}
.user-accordion-item .accordion-wrap:not(.collapsed) span {
  background: #E41F07;
  color: #FFF;
}
.user-accordion-item .content-collapse {
  border-top: 1px solid #E8E8E8;
  margin: 5px 10px 10px;
  padding: 15px 0 0;
}
.user-accordion-item .accordion-collapse .form-wrap {
  margin-bottom: 24px;
}
.user-accordion-item .accordion-collapse .form-wrap.mb-wrap {
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .user-accordion-item .accordion-collapse .form-wrap.mb-wrap {
    margin-bottom: 24px;
  }
}

.submit-button .btn {
  font-size: 14px;
  font-weight: 600;
  border-radius: 5px;
  margin: 0 10px 0 0;
  padding: 7px 15px;
}
.submit-button .btn:last-child {
  margin-right: 0;
}

.radio-wrap .col-form-label {
  padding-bottom: 12px;
}
.radio-wrap .radio-btn {
  margin-right: 15px;
}
.radio-wrap .radio-btn:last-child {
  margin-right: 0;
}

.success-message h3 {
  margin-bottom: 10px;
  font-size: 20px;
}
.success-message .del-info {
  max-width: 300px;
  margin: 0 auto;
}
.success-message p {
  font-size: 16px;
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .success-message p {
    font-size: 14px;
  }
}
.success-message .modal-btn {
  margin-top: 40px;
}

.success-popup-icon {
  background: #FFEEEC;
  color: #FC0027;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  font-size: 42px;
}
.success-popup-icon.bg-light-blue {
  background: #F3EDFF;
  color: #4A00E5;
}

.access-wrap {
  border-radius: 5px;
  margin: 0 0 20px;
  padding: 10px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.access-wrap li {
  margin: 0 0 5px;
  padding: 0;
}
.access-wrap li.checkbox-checked label {
  background: #F6F6F6;
}
.access-wrap li label {
  width: 100%;
  position: relative;
  padding: 5px;
  background: transparent;
}
.access-wrap li label.checkboxs .checkmarks {
  right: 10px;
  left: unset;
  top: 50%;
  transform: translatey(-50%);
}
.access-wrap li label.checkboxs input:checked ~ .checkmark {
  background: #E41F07;
  border-color: #E41F07;
}
.access-wrap li label .people-profile {
  display: flex;
  align-items: center;
}
.access-wrap li label .people-profile img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
}
.access-wrap li label .people-profile a {
  color: #6F6F6F;
  font-size: 14px;
}
.access-wrap li:hover {
  background-color: #F6F6F6;
}
.access-wrap li:last-child {
  margin-bottom: 0;
}

.load-btn .btn i {
  margin-left: 4px;
  animation: spin 3000ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
  }
}
.img-select {
  position: relative;
}
.img-select .select-box-img {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 50%;
  left: 10px;
  z-index: 9999;
}
.img-select .select2-selection__rendered {
  padding-left: 40px !important;
}

.users-group ul {
  display: flex;
  align-items: center;
}
.users-group ul li a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: normal;
  margin-left: -11px;
}
.users-group ul li a img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.users-group ul li a.total-group-member {
  background: #E41F07;
  color: #FFF;
  font-size: 10px;
}
.users-group ul li a:hover {
  position: relative;
}
.users-group ul li:first-child a {
  margin-left: 0;
}

.add-new {
  color: #FC0027;
}

.contact-head {
  margin-bottom: 5px;
}
.contact-head .contact-breadcrumb {
  margin-bottom: 5px;
}
.contact-head .contact-breadcrumb li {
  color: #6F6F6F;
  position: relative;
  display: inline-block;
  margin: 0 2px 5px 0;
  padding: 0 0 0 10px;
}
.contact-head .contact-breadcrumb li a {
  color: #6F6F6F;
}
.contact-head .contact-breadcrumb li a i {
  color: #E41F07;
  margin-right: 8px;
}
.contact-head .contact-breadcrumb li a:hover {
  color: #E41F07;
}
.contact-head .contact-breadcrumb li:last-child {
  margin-right: 0;
}
.contact-head .contact-breadcrumb li:first-child {
  padding-left: 0;
}
.contact-head .contact-breadcrumb li:first-child::before {
  content: none;
}
.contact-head .contact-breadcrumb li::before {
  content: "/";
  position: absolute;
  top: 0;
  left: 0;
}
.contact-head .contact-breadcrumb li.before-none {
  padding-left: 5px;
}
.contact-head .contact-breadcrumb li.before-none::before {
  content: none;
}
.contact-head .contact-breadcrumb li .btn i {
  color: #FFF;
}
.contact-head .contact-breadcrumb li .btn {
  color: #FFF;
}
.contact-head .contact-breadcrumb li .btn:hover {
  color: #FFF;
}
.contact-head .contact-pagination {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-bottom: 10px;
}
.contact-head .contact-pagination p {
  margin: 0 15px 0 0;
}
.contact-head .contact-pagination ul li {
  display: inline-block;
  margin-right: 5px;
}
.contact-head .contact-pagination ul li a {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #FFF;
  color: #262A2A;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.contact-head .contact-pagination ul li a:hover {
  background: #E41F07;
  color: #FFF;
}
.contact-head .contact-pagination ul li:last-child {
  margin-right: 0;
}

.contacts-action {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.contacts-action > a {
  margin: 0 8px 8px 0;
}
.contacts-action > a:last-child {
  margin-right: 0;
}
.contacts-action .badge {
  margin: 0 8px 10px 0;
  padding: 7px 6px;
  font-size: 14px;
  font-weight: 400;
}
.contacts-action .badge.badge-light {
  background: #F4F4F4;
  color: #6F6F6F;
}
.contacts-action .badge i {
  margin-right: 8px;
}
.contacts-action .action-drops {
  margin-bottom: 10px;
}
.contacts-action .action-drops .dropdown-toggle {
  font-weight: 600;
  color: #FFF;
  display: inline-block;
}
.contacts-action .action-drops .dropdown-toggle span {
  display: inline-block;
  border-radius: 5px;
  padding: 4px 10px;
  color: #FFF;
}
.contacts-action .dropdown-toggle {
  margin-right: 0;
  color: #FFAB1A;
}
.contacts-action .dropdown-toggle::after {
  content: none;
}
.contacts-action .btn {
  border-radius: 5px;
  padding: 6px 13px;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 15px;
  font-weight: 500;
}
.contacts-action .btn i {
  margin-right: 5px;
}
.contacts-action .btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #F6F6F6;
  border: 1px solid #F6F6F6;
  color: #262A2A;
}
.contacts-action .btn-icon:hover {
  background: #E41F07;
  color: #FFF;
}
.contacts-action .btn-icon.rating {
  border-radius: 50%;
  background: #FFF;
  border: 1px solid #E8E8E8;
  color: #FF9D0A;
}
.contacts-action .act-dropdown {
  margin-bottom: 10px;
}
.contacts-action .act-dropdown > a {
  width: 34px;
  height: 34px;
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FFF;
  border: 1px solid #E8E8E8;
}
.contacts-action .act-dropdown > a:hover {
  background: #E8E8E8;
  color: #262A2A;
}
.contacts-action .act-dropdown .dropdown-item {
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 5px;
  color: #262A2A;
}
.contacts-action .act-dropdown .dropdown-item i {
  margin-right: 8px;
}
.contacts-action .act-dropdown .dropdown-item:hover {
  background: #F6F6F6;
  color: #262A2A;
}

.basic-info li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
}
.basic-info li span {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #F6F6F6;
  color: #262A2A;
  margin-right: 10px;
  flex-shrink: 0;
}

.set-info li a {
  color: #6F6F6F;
}
.set-info li a:hover {
  color: #E41F07;
}
.set-info li i {
  margin-right: 5px;
}

.other-info li {
  display: flex;
}
.other-info li .other-title {
  min-width: 110px;
  display: inline-block;
}
.other-info li .avatar-xs {
  width: 16px;
  height: 16px;
  border-radius: 5px;
}

.con-sidebar-title {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
}
.con-sidebar-title a {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #4A00E5;
}
.con-sidebar-title a:hover {
  color: #E41F07;
}

.company-info li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.company-info li span {
  width: 52px;
  height: 52px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  margin-right: 10px;
}
.company-info li h6 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}
.company-info li p {
  font-size: 14px;
  margin-bottom: 0;
}
.company-info.com-info li span {
  width: 32px;
  height: 32px;
  margin-right: 8px;
  border-radius: 50%;
}
.company-info.com-info li p i {
  margin-right: 5px;
  color: #FDA700;
}

.deals-info li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.deals-info li img {
  width: 32px;
  height: 32px;
  border-radius: 5px;
  margin-right: 10px;
}
.deals-info li p {
  margin-bottom: 0;
}

.social-info li {
  display: inline-block;
}
.social-info li a {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FFF;
  color: #262A2A;
}
.social-info li a:hover {
  background: #262A2A;
  color: #FFF;
}

.tag-info li {
  margin-right: 5px;
  display: inline-block;
}
.tag-info li a {
  font-size: 12px;
  font-weight: 500;
  border-radius: 5px;
  padding: 5px 10px;
  display: inline-block;
}
.tag-info li:last-child {
  margin-right: 0;
}

.star-icon {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  color: #FF9D0A;
}
.star-icon i {
  font-size: 14px;
}

@media (max-width: 575.98px) {
  .contact-nav {
    display: block;
  }
}
.contact-nav li {
  display: inline-block;
  margin: 0 20px 0 0;
}
.contact-nav li a {
  color: #6F6F6F;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 14px;
  font-weight: 500;
  border-bottom: 3px solid #FFF;
  text-align: center;
  padding: 5px 5px 10px 5px;
}
.contact-nav li a:hover, .contact-nav li a.active {
  color: #E41F07;
  border-color: #E41F07;
}
.contact-nav li a i {
  margin-right: 5px;
}
@media (max-width: 575.98px) {
  .contact-nav li {
    display: block;
  }
}

.form-sort {
  position: relative;
}
.form-sort i {
  position: absolute;
  z-index: 101;
  width: 16px;
  height: 16px;
  top: 14px;
  left: 7px;
}
.form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
.form-sort span.select2-container.select2-container--default.select2-container--open {
  z-index: 99;
}

.badge-day {
  background: #F3EDFF;
  color: #4A00E5;
  border-radius: 5px;
  display: inline-block;
  font-size: 14px;
  margin: 0 0 20px;
  padding: 4px 8px;
}
.badge-day i {
  margin-right: 5px;
}

.contact-activity ul:last-child .activity-wrap:last-child {
  margin-bottom: 0;
}

.upcoming-info {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin: 10px 0 0;
  padding: 15px 15px 5px;
}
.upcoming-info p {
  font-weight: 500;
  margin-bottom: 8px;
}
.upcoming-info .dropdown {
  margin-bottom: 10px;
}
.upcoming-info .dropdown .dropdown-toggle {
  color: #262A2A;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
}
.upcoming-info .dropdown .dropdown-toggle::after {
  content: none;
}
.upcoming-info .dropdown .avatar-xs {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 10px;
}
.upcoming-info .dropdown .circle {
  font-size: 10px;
}
.upcoming-info .dropdown .dropdown-menu a {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-size: 14px;
  color: #262A2A;
}

.notes-editor .dropdown-toggle::after {
  content: none;
}

.note-edit-wrap {
  display: none;
  margin-bottom: 15px;
}

.notes-activity .note-download {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  margin: 0 0 15px;
  padding: 15px;
  border-radius: 5px;
}
.notes-activity .note-download .note-info {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-right: 24px;
}
.notes-activity .note-download .note-info h6 {
  font-weight: 500;
  margin-bottom: 5px;
}
.notes-activity .note-download .note-info p {
  margin-bottom: 0;
}
@media (max-width: 767.98px) {
  .notes-activity .note-download .note-info {
    margin-right: 15px;
  }
}
.notes-activity .note-download .note-icon {
  width: 44px;
  height: 44px;
  border-radius: 5px;
  color: #FFF;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
  flex-shrink: 0;
}
.notes-activity .note-download .note-icon img {
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.notes-activity .note-download:hover {
  background: #F6F6F6;
}
.notes-activity .note-download:hover a {
  background: #FFF;
}
.notes-activity .note-download a {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  color: #262A2A;
  background: #F6F6F6;
}
@media (max-width: 767.98px) {
  .notes-activity .note-download {
    margin: 0 0 15px;
    padding: 10px;
  }
}
.notes-activity .reply-box {
  background: #F9F9FC;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 15px;
}
.notes-activity .reply-box p {
  margin-bottom: 10px;
}
.notes-activity .reply-box .btn {
  background: #FFF;
  border-color: #FFF;
  border-radius: 5px;
  color: #262A2A;
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  padding: 5px 10px;
}
.notes-activity .reply-box .btn i {
  margin-right: 3px;
}
.notes-activity .reply-box .btn:hover {
  background: #FAFAFA;
}

.note-btns {
  margin-top: 5px;
}
.note-btns .btn {
  margin: 10px 10px 0 0;
  padding: 7px 15px;
}
.note-btns .btn:last-child {
  margin-right: 0;
}
.note-btns .btn.btn-primary {
  min-width: 110px;
}

.drag-attach {
  border: 1px dashed #E8E8E8;
  border-radius: 5px;
  position: relative;
  text-align: center;
  width: 100%;
  overflow: hidden;
}
.drag-attach input {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}
.drag-attach .img-upload {
  background: #F3EDFF;
  color: #4A00E5;
  font-size: 14px;
  display: inline-block;
  text-align: center;
  margin: 24px 0;
  padding: 9px 17px;
  border-radius: 5px;
}
.drag-attach .img-upload i {
  margin-right: 10px;
}

.drag-upload {
  background: #FAFAFA;
  border: 1px dashed #FFECCC;
  border-radius: 5px;
  position: relative;
}
.drag-upload input {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  cursor: pointer;
}
.drag-upload i {
  font-size: 24px;
  margin-bottom: 10px;
}
.drag-upload p {
  font-size: 14px;
  margin-bottom: 0;
}
.drag-upload .img-upload {
  text-align: center;
  padding: 36px 20px;
}

.upload-file {
  background: #F9F9FC;
  border: 1px solid #E8E8E8;
  margin: 0 0 5px;
  padding: 15px;
  border-radius: 5px;
}
.upload-file h6 {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 2px;
}
.upload-file p {
  font-size: 14px;
  margin-bottom: 0;
}
.upload-file p.black-text {
  color: #262A2A;
}
.upload-file .progress {
  height: 3px;
  margin: 15px 0 4px;
}
.upload-file.upload-list {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}

.form-title {
  font-weight: 600;
  margin-bottom: 15px;
}

.sync-radio .radio-item {
  margin-bottom: 15px;
}
.sync-radio .radio-item label {
  font-size: 14px;
}
.sync-radio .radio-item:last-child {
  margin-bottom: 0;
}

.signature-wrap {
  background: #F2ECFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 15px 15px 0;
}
.signature-wrap h4, .signature-wrap p {
  margin-bottom: 15px;
}
.signature-wrap h4 {
  font-weight: 600;
}
@media (max-width: 767.98px) {
  .signature-wrap h4 {
    font-size: 16px;
  }
}

.add-sign {
  font-size: 16px;
  color: #FDA700;
}

.sign-item li {
  margin-bottom: 15px;
}
.sign-item li .sign-title {
  display: block;
  font-weight: 500;
  margin-bottom: 3px;
}

.trash-sign {
  color: #FC0027;
}

.send-success {
  border: 1px solid #5CB85C;
  background: #CEEACE;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 15px;
}
.send-success p {
  color: #262A2A;
  margin-bottom: 0;
}
.send-success p i {
  margin-right: 5px;
}

fieldset {
  display: none;
}
fieldset#first-field-file {
  display: block;
}

.add-details-wizard ul {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
@media (max-width: 575.98px) {
  .add-details-wizard ul {
    flex-direction: column;
  }
}
.add-details-wizard ul li {
  line-height: normal;
  background: #F6F6F6;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}
@media (max-width: 575.98px) {
  .add-details-wizard ul li {
    width: 100%;
    margin-bottom: 10px;
  }
}
.add-details-wizard ul li span {
  margin-right: 5px;
}
.add-details-wizard ul li .multi-step-info h6 {
  margin-bottom: 0;
  font-weight: 500;
  font-size: 14px;
  color: #6F6F6F;
}
.add-details-wizard ul li.active {
  background: #E41F07;
  color: #FFF;
}
.add-details-wizard ul li.active h6 {
  color: #FFF;
}

.pipeline-item {
  border: 1px solid #E8E8E8;
  margin: 0 0 5px;
  padding: 15px 15px 5px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  position: relative;
}
.pipeline-item::before {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  width: 2px;
  height: 100%;
  background: #FFA201;
}
.pipeline-item p {
  color: #262A2A;
  font-weight: 500;
  margin-bottom: 10px;
}
.pipeline-item .action-pipeline {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.pipeline-item .action-pipeline a {
  margin: 0 15px 10px 0;
}
.pipeline-item .action-pipeline a i {
  margin-right: 5px;
}
.pipeline-item .action-pipeline a:last-child {
  margin-right: 0;
}
.pipeline-item:last-child {
  margin-bottom: 0;
}

.access-item .radio-btn {
  margin-right: 15px;
}
.access-item .radio-btn:last-child {
  margin-right: 0;
}

.access-wrapper {
  margin-top: 20px;
}

.access-view {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border: 1px solid #E8E8E8;
  margin: 0 0 5px;
  padding: 15px 15px 15px;
  border-radius: 5px;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.access-view .access-img {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.access-view .access-img img {
  width: 32px;
  height: 32px;
  border-radius: 5px;
  margin-right: 10px;
}
.access-view a {
  font-weight: 600;
  color: #FC0027;
}

.header-collapse .header-user {
  display: none;
  height: 0;
}
.header-collapse .page-wrapper {
  padding-top: 0;
}
.header-collapse .header {
  border-bottom: none;
  background: transparent;
  width: 260px;
}
.header-collapse .header .header-left {
  background: white;
}
.header-collapse #collapse-header i {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}

.bootstrap-datetimepicker-widget {
  z-index: 99999;
}
.bootstrap-datetimepicker-widget table td.active, .bootstrap-datetimepicker-widget table td:hover {
  background-color: #00918E;
}

.note-modal-backdrop {
  z-index: 9;
}

.note-modal-footer {
  height: 57px;
}

.table tbody tr td a.title-name {
  color: #262A2A;
  font-weight: 500;
}
.table tbody tr td a.title-name:hover {
  color: #E41F07;
  text-decoration: underline;
}

.title-name {
  color: #262A2A;
  font-weight: 500;
}

.export-list > ul {
  display: flex;
  align-items: center;
  justify-content: end;
  flex-wrap: wrap;
}
@media (max-width: 575.98px) {
  .export-list > ul {
    justify-content: start;
  }
}

.grid-social-links a:hover {
  background: #FCE9E6 !important;
}

.daterange-picker .form-sort {
  margin-left: 10px;
}
.daterange-picker .form-sort input {
  padding-left: 25px;
  height: 38px;
}
.daterange-picker .form-sort .select2-container .select2-selection.select2-selection--single {
  height: 38px;
}
.daterange-picker .form-sort .select2-container .select2-selection.select2-selection--single .select2-selection__rendered {
  line-height: 38px;
}
.daterange-picker .form-sort .select2-container .select2-selection.select2-selection--single .select2-selection__arrow {
  height: 38px;
}

.card-select ul {
  display: flex;
  align-items: center;
}
.card-select ul li + li {
  margin-left: 12px;
}

.view-icons {
  float: right;
}
@media (max-width: 767.98px) {
  .view-icons {
    margin-right: 0;
  }
}
.view-icons .btn {
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  color: #FFB534;
  font-size: 18px;
  min-width: 40px;
  margin: 0 5px 0 0;
  padding: 7px 0 3px 0;
}
.view-icons .btn.active {
  color: #FFAB1A;
}
@media (max-width: 767.98px) {
  .view-icons .btn {
    min-width: 37px;
    margin: 0 5px 0 0;
    padding: 5px 0 3px 0;
  }
}

@media (max-width: 767.98px) {
  .page-header .view-icons {
    margin-right: 10px;
  }
}
@media (max-width: 575.98px) {
  .page-header .view-icons {
    margin-right: 0;
  }
}

.title-head {
  justify-content: end;
  align-items: center;
}
@media (max-width: 767.98px) {
  .title-head {
    justify-content: start;
    margin-top: 20px;
  }
}
@media (max-width: 575.98px) {
  .title-head {
    flex-direction: column;
    row-gap: 20px;
    align-items: start;
  }
}
.title-head .add-btn {
  margin-left: 10px;
  border-radius: 5px;
}
@media (max-width: 575.98px) {
  .title-head .add-btn {
    margin-left: 0;
  }
}
.title-head .form-sort .list-view {
  padding: 10px 10px 10px 30px;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  color: #FFC767;
  font-size: 14px;
  text-decoration: none;
  line-height: normal;
}

.daterange-picker .form-sort {
  min-width: 200px;
}

.statistic-dropdown .btn-primary {
  padding: 6px 15px;
  height: 35px;
}

td .badge-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.badge-dots {
  width: 12px;
  height: 12px;
  border-radius: 5px;
  margin-right: 5px;
  display: inline-flex;
}

.title-head .daterange-picker .form-sort {
  height: auto;
  min-width: 212px;
}
.title-head .daterange-picker .form-sort i {
  left: 15px;
  top: 9px;
}
.title-head .daterange-picker .form-sort input {
  height: 32px;
  min-height: 32px;
}
.title-head .daterange-picker .bookingrange {
  padding-left: 35px;
}

.error-page {
  background: #FFF;
}

.comming-shapes {
  position: relative;
}
@media (max-width: 991.98px) {
  .comming-shapes {
    display: none;
  }
}
.comming-shapes .comming-right-shape {
  position: fixed;
  top: 0;
  left: 0;
}
.comming-shapes .comming-left-shape {
  position: fixed;
  bottom: -5px;
  right: 0;
}
.comming-shapes img {
  width: 500px;
}

.error-img {
  max-width: 500px;
}

.account-page {
  background: #FFF;
}

.form-wrap .form-wrap-icon {
  position: relative;
}
.form-wrap .form-wrap-icon i {
  font-size: 18px;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}

.form-wrap-checkbox {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
.form-wrap-checkbox .check {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #262A2A;
  margin-bottom: 0;
}
.form-wrap-checkbox .check input {
  display: none;
}
.form-wrap-checkbox .check input:checked + .box {
  background: #FFA201;
}
.form-wrap-checkbox .check input:checked + .box:after {
  top: 0;
}
.form-wrap-checkbox .check .box {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 8px;
  transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);
  background: #F9F9FC;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}
.form-wrap-checkbox .check .box:after {
  width: 12px;
  height: 6px;
  content: "";
  position: absolute;
  border-left: 2px solid;
  border-bottom: 2px solid;
  border-color: #FFF;
  transform: rotate(-45deg) translate3d(0, 0, 0);
  transform-origin: center center;
  transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);
  left: 0;
  right: 0;
  top: 200%;
  bottom: 3px;
  margin: auto;
}

.hover-a {
  position: relative;
  color: #4A00E5;
}
.hover-a:after {
  content: "";
  height: 2px;
  width: 100%;
  background: #4A00E5;
  transform: scale(0);
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transition: all 0.3s ease;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.hover-a:hover:after {
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
}
.hover-a:hover {
  color: #4A00E5;
}

.account-bg-01 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.account-bg-02 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.account-bg-03 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.account-bg-04 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.link-hover {
  position: relative;
  color: #E41F07;
  font-weight: 500;
}
.link-hover:after {
  content: "";
  height: 2px;
  width: 100%;
  background: #E41F07;
  transform: scale(0);
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transition: all 0.3s ease;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.link-hover:hover:after {
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
}
.link-hover:hover {
  color: #E41F07 !important;
}

.bg-backdrop {
  background: rgba(255, 255, 255, 0.9490196078);
  backdrop-filter: blur(10px);
}
@media (max-width: 767.98px) {
  .bg-backdrop {
    width: 100% !important;
  }
}

.form-set-login.or-text {
  max-width: 365px;
  margin: auto;
}

.toggle-password {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #262A2A;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.toggle-password:hover {
  color: #E41F07;
}

.toggle-passwords {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #262A2A;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.toggle-passwords:hover {
  color: #E41F07;
}

.toggle-password-new {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #262A2A;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.toggle-password-new:hover {
  color: #E41F07;
}

.pass-group {
  position: relative;
  font-size: 14px;
}

.form-set-login {
  text-align: center;
  position: relative;
  color: #B8BCC9;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 23px;
}
.form-set-login h4 {
  position: relative;
  font-size: 14px;
  color: #6F6F6F;
  font-weight: 700;
}
.form-set-login h4:after {
  content: "";
  background: #B8BCC9;
  width: 21px;
  height: 1px;
  position: absolute;
  top: 10px;
  left: 200px;
}
@media (max-width: 991.98px) {
  .form-set-login h4:after {
    height: 0px;
  }
}
.form-set-login h4:before {
  content: "";
  background: #B8BCC9;
  width: 21px;
  height: 1px;
  position: absolute;
  top: 10px;
  right: 200px;
}
@media (max-width: 991.98px) {
  .form-set-login h4:before {
    height: 0px;
  }
}

.mw-450 {
  max-width: 450px;
}

.wh-85 {
  width: 85px;
  height: 85px;
}
@media (max-width: 575.98px) {
  .wh-85 {
    width: 50px;
    height: 50px;
  }
}

.login-shapes {
  position: relative;
}
@media (max-width: 991.98px) {
  .login-shapes {
    display: none;
  }
}
.login-shapes .login-right-shape {
  position: fixed;
  top: 0;
  left: 0;
}
.login-shapes .login-left-shape {
  position: fixed;
  bottom: 0;
  right: 0;
  line-height: 0;
}

.settings-sidebar h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 24px;
}
@media (max-width: 767.98px) {
  .settings-sidebar h4 {
    font-size: 16px;
    margin-bottom: 15px;
  }
}
.settings-sidebar a {
  color: #6F6F6F;
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  padding: 10px;
  width: 100%;
  position: relative;
}
.settings-sidebar a.active {
  background: #F6F6F6;
  color: #262A2A;
}
.settings-sidebar a.active:before {
  position: absolute;
  content: "\\f054";
  font-family: "FontAwesome";
  font-size: 12px;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
}
.settings-sidebar a:hover {
  color: #262A2A;
}

.profile-upload {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.profile-upload .profile-upload-img {
  width: 100px;
  min-width: 100px;
  height: 100px;
  position: relative;
  margin-right: 15px;
  border-radius: 5px;
  border: 2px dashed #E8E8E8;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.profile-upload .profile-upload-img span {
  color: #6F6F6F;
  position: absolute;
}
.profile-upload .profile-upload-content .profile-upload-btn {
  display: inline-flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  color: #4A00E5;
  background: #F3EDFF;
  border: 1px solid #F3EDFF;
  border-radius: 5px;
  padding: 8px 10px;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.5s;
}
.profile-upload .profile-upload-content .profile-upload-btn:hover {
  color: #FFF;
  background: #4A00E5;
  border: 1px solid #4A00E5;
  transition: all 0.5s;
}
.profile-upload .profile-upload-content .profile-upload-btn i {
  font-size: 16px;
  margin-right: 8px;
}
.profile-upload .profile-upload-content .profile-upload-btn input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
.profile-upload .profile-upload-content p {
  font-weight: 500;
  color: #6F6F6F;
}
.profile-upload .preview1 {
  display: none;
}
.profile-upload .it {
  width: 70px;
  height: 70px;
  border-radius: 5px;
  display: block;
  position: relative;
  background: #FFF;
  object-fit: cover;
}
.profile-upload .profile-remove {
  display: none;
}
.profile-upload .profile-remove-btn {
  width: 14px;
  height: 14px;
  font-size: 10px;
  color: #FFF;
  background: #FC0027;
  border: 1px solid #FC0027;
  border-radius: 5px;
  padding: 0;
  display: inline-block;
  position: absolute;
  top: 8px;
  right: 8px;
}
.profile-upload .profile-remove-btn:hover {
  background: rgb(201, 0, 31.1071428571);
  border: 1px solid rgb(201, 0, 31.1071428571);
}

.notificaion-table .table thead tr:first-child th {
  padding-top: 0;
}
.notificaion-table .table thead tr th {
  font-size: 16px;
  padding: 10px;
}
.notificaion-table .table tbody tr td {
  font-weight: 500;
  color: #262A2A;
  padding: 10px;
}
.notificaion-table .table tbody tr:last-child td {
  padding-bottom: 0;
}

.mod-toggle .status-toggle {
  margin-right: 20px;
}

.btn-add {
  width: 32px;
  height: 32px;
  background: #FFF;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #262A2A;
}
.btn-add:hover {
  background: #00918E;
  color: #FFF;
}

.settings-form .setting-title {
  margin-bottom: 15px;
}
.settings-form .setting-title h6 {
  font-size: 14px;
  font-weight: 500;
}
.settings-form .setting-title p {
  font-size: 12px;
}
.settings-form .form-wrap {
  margin-bottom: 15px;
}
.settings-form .submit-button {
  margin-top: 14px;
}

.bank-box {
  background: #F9F9FC;
  border-radius: 5px;
  border: 1px solid #F9F9FC;
  position: relative;
  margin: 0 0 24px;
  padding: 40px;
}
@media (max-width: 991.98px) {
  .bank-box {
    margin: 0 0 24px;
    padding: 20px;
  }
}
.bank-box.active {
  border-color: #5CB85C;
}
.bank-box.active::after {
  position: absolute;
  top: -8px;
  right: -8px;
  content: "\\f058";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  color: #6CBF6C;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #FFF;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.bank-box .table-action .action-icon {
  background-color: transparent;
}
.bank-box .table-action .action-icon:hover {
  background-color: #F6F6F6;
}

.inv-days .select2-container {
  min-width: 62px !important;
}
.inv-days p {
  color: #000;
  margin-left: 10px;
}

.lang-type {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.lang-type li {
  margin-right: 5px;
}
.lang-type li a {
  background-color: #F6F6F6;
  border-radius: 5px;
  color: #6F6F6F;
  font-weight: 500;
  padding: 8px 15px;
  display: inline-block;
}
.lang-type li a:hover {
  background-color: #00918E;
  color: #FFF !important;
}

.theme-type-images {
  flex-wrap: wrap;
}
.theme-type-images .theme-image {
  background: #FFF;
  border-radius: 5px;
  border: 1px solid #E8E8E8;
  padding: 10px;
  margin: 0 24px 15px 0;
  text-align: center;
}
.theme-type-images .theme-image img {
  width: 150px;
}
@media (max-width: 1399.98px) {
  .theme-type-images .theme-image img {
    width: 130px;
  }
}
.theme-type-images .theme-image:last-child {
  margin-right: 0;
}
.theme-type-images .theme-image span {
  font-weight: 500;
  font-size: 14px;
  color: #262A2A;
  margin-top: 10px;
  display: block;
}
.theme-type-images .theme-image.active {
  border-color: #E41F07;
}
.theme-type-images .theme-image.active span {
  color: #E41F07;
}

.theme-colors ul {
  display: flex;
  align-items: center;
}
.theme-colors ul li {
  margin-right: 10px;
}
.theme-colors ul li span {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #E41F07;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.theme-colors ul li span.active {
  background-color: #FCE9E6;
}
.theme-colors ul li span.active:after {
  content: "";
  width: 25px;
  height: 25px;
  background-color: #E41F07;
  border-radius: 50%;
  opacity: 1;
}
.theme-colors ul li span.theme-secondary {
  background-color: #FFA201;
}
.theme-colors ul li span.theme-secondary.active {
  background-color: #FFF6E6;
}
.theme-colors ul li span.theme-secondary.active:after {
  background-color: #FFA201;
}
.theme-colors ul li span.theme-violet {
  background-color: #3C2371;
}
.theme-colors ul li span.theme-violet.active {
  background-color: rgba(60, 35, 113, 0.1);
}
.theme-colors ul li span.theme-violet.active:after {
  background-color: #3C2371;
}
.theme-colors ul li span.theme-blue {
  background-color: #0092E4;
}
.theme-colors ul li span.theme-blue.active {
  background-color: #E6F4FC;
}
.theme-colors ul li span.theme-blue.active:after {
  background-color: #0092E4;
}
.theme-colors ul li span.theme-brown {
  background-color: #4A00E5;
}
.theme-colors ul li span.theme-brown.active {
  background-color: #F3EDFF;
}
.theme-colors ul li span.theme-brown.active:after {
  background-color: #4A00E5;
}
.theme-colors ul li:last-child {
  margin-right: 0;
}

.lang-wrap {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.lang-flag {
  margin-right: 15px;
}
.lang-flag a {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border: 1px solid #E8E8E8;
  border-radius: 8px;
  color: #262A2A;
  font-weight: 500;
  padding: 8px 8px;
}
.lang-flag a img {
  margin-right: 8px;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}

.lang-direct li {
  margin: 0 8px 0 0;
}
.lang-direct li a {
  background-color: #9B9B9B;
  color: #262A2A;
  border-radius: 5px;
  padding: 8px 15px;
  display: inline-block;
}
.lang-direct li a:hover, .lang-direct li a.active {
  background-color: #3C2371;
  color: #FFF;
}
.lang-direct li:last-child {
  margin-right: 0;
}

.translate-wrap h6 {
  font-weight: 500;
  margin-bottom: 15px;
}
.translate-wrap .form-wrap {
  margin-bottom: 15px;
}
.translate-wrap.translate-title h6 {
  font-size: 16px;
  font-weight: 600;
}

.translate-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
  margin-bottom: 24px;
}
.translate-item .btn, .translate-item .lang-flag {
  margin-bottom: 24px;
}

.lang-flag {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}

.lang-progress {
  margin-bottom: 24px;
}
.lang-progress p {
  font-weight: 500;
}
.lang-progress .progress {
  min-width: 100px;
  max-width: 150px;
  height: 7px;
}

.black-text {
  color: #262A2A !important;
}

.settings-tab .card-body {
  padding-top: 0;
}
@media (max-width: 767.98px) {
  .settings-tab .card-body {
    padding-top: 16px;
  }
}
.settings-tab .card-body li a {
  padding-top: 24px;
}
@media (max-width: 767.98px) {
  .settings-tab .card-body li a {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}

.payment-img {
  width: 80px;
  height: 40px;
}

.source-report {
  color: #00918E;
  font-weight: 500;
}

.dropdown.table-action .dropdown-toggle::after {
  display: none;
}
.dropdown .dropdown-toggle {
  color: #262A2A;
  border: 1px solid #E8E8E8;
  padding: 9px 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}
.dropdown .dropdown-toggle:after {
  border-top: 0;
  border-left: 0;
  border-bottom: 2px solid #262A2A;
  border-right: 2px solid #262A2A;
  content: "";
  display: inline-block;
  pointer-events: none;
  width: 8px;
  height: 8px;
  vertical-align: 2px;
  transform-origin: 66% 66%;
  -webkit-transform-origin: 66% 66%;
  -ms-transform-origin: 66% 66%;
  transition: all 0.2s ease;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}
.dropdown .dropdown-toggle[aria-expanded=true]:after {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
}
.dropdown .dropdown-menu {
  padding: 10px;
  background: #FFF;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border: 1px solid #E8E8E8;
}
.dropdown .dropdown-menu .dropdown-item {
  padding: 5px 10px;
  color: #323737;
  background: #FFF;
  border-radius: 5px;
}
.dropdown .dropdown-menu .dropdown-item:hover {
  color: #262A2A;
  background: #F6F6F6;
}

.time-text p {
  font-weight: 500;
  white-space: nowrap;
  margin-left: 15px;
}

.activity-title {
  margin-bottom: 10px;
  display: inline-flex;
  align-items: center;
}
.activity-title h4 {
  font-weight: 600;
  margin: 0 15px 10px 0;
  padding: 0 15px 0 0;
  position: relative;
}
.activity-title h4::after {
  content: "";
  background-color: #E8E8E8;
  width: 1px;
  height: 24px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 767.98px) {
  .activity-title h4::after {
    content: none;
  }
}
@media (max-width: 767.98px) {
  .activity-title {
    display: block;
  }
}

.active-list ul {
  margin-bottom: 10px;
}
.active-list ul li {
  display: inline-block;
  margin-right: 10px;
}
.active-list ul li a {
  width: 34px;
  height: 34px;
  border-radius: 5px;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #262A2A;
}
.active-list ul li a:hover, .active-list ul li a.active {
  background-color: #00918E;
  border-color: #00918E;
  color: #FFF;
}
.active-list ul li:last-child {
  margin-right: 0;
}

.radio-activity li {
  display: inline-block;
}
.radio-activity li .active-type input[type=radio] {
  display: none;
}
.radio-activity li .active-type input[type=radio] ~ label {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  margin: 0 10px 5px 0;
  padding: 8px 20px;
  border-radius: 5px;
  color: #262A2A;
  cursor: pointer;
}
.radio-activity li .active-type input[type=radio] ~ label i {
  margin-right: 5px;
}
.radio-activity li .active-type input[type=radio]:checked ~ label {
  border-color: #00918E;
  color: #00918E;
}
.radio-activity li:last-child {
  margin-right: 0;
}

.label-add {
  color: #E41F07;
  margin-bottom: 5px;
  font-weight: 500;
}
.label-add i {
  margin-right: 8px;
}
.label-add:hover {
  color: rgb(178.5191489362, 24.2723404255, 5.4808510638);
}

.tab-activity {
  border-radius: 5px;
  margin: 0 0 20px;
  padding: 15px 15px 0;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
}
.tab-activity ul li {
  display: inline-block;
  margin-right: 20px;
}
.tab-activity ul li a {
  padding: 10px 5px 10px;
  font-weight: 500;
  border-bottom: 4px solid #FFF;
  display: inline-block;
}
.tab-activity ul li a span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-left: 10px;
  color: #262A2A;
  font-weight: 600;
  font-size: 10px;
}
.tab-activity ul li a.active {
  color: #E41F07;
  border-color: #E41F07;
}

.comment-wrap {
  margin: 0 0 15px;
  padding: 15px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  border: 1px solid #E8E8E8;
  border-radius: 5px;
}
.comment-wrap h6 {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
  color: #6F6F6F;
}
.comment-wrap p span {
  color: #4A00E5;
}
.comment-wrap:last-child {
  margin-bottom: 0;
}

.activity-badge {
  color: #FFF;
  padding: 5px 7px;
  font-size: 12px;
  border-radius: 5px;
}
.activity-badge i {
  margin-right: 5px;
}

.title-head {
  font-weight: 500;
  color: #262A2A;
}

.tasks-activity.tasks > ul {
  margin-top: 15px;
}
.tasks-activity.tasks > ul .task-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
}
.tasks-activity.tasks > ul .task-wrap.pending::before {
  background-color: #676DFF;
}
.tasks-activity.tasks > ul .task-wrap.warning::before {
  background-color: #FDA700;
}
.tasks-activity.tasks > ul .task-wrap.success::before {
  background-color: #5CB85C;
}
.tasks-activity.tasks > ul .task-wrap .task-info .task-icon {
  margin: 0 20px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-info .task-checkbox {
  margin: 0 20px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-info .task-checkbox .checkboxs .checkmarks {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.tasks-activity.tasks > ul .task-wrap .task-info .set-star {
  margin: 0 20px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-info p {
  font-weight: 500;
}
.tasks-activity.tasks > ul .task-wrap .task-info .badge {
  font-weight: 600;
  font-size: 12px;
  margin: 0 5px 10px 0;
  padding: 5px 7px;
  color: #FFF;
}
.tasks-activity.tasks > ul .task-wrap .task-info .badge:last-child {
  margin-right: 0;
}
.tasks-activity.tasks > ul .task-wrap .task-actions ul li {
  margin: 0 10px 10px 0;
}
.tasks-activity.tasks > ul .task-wrap .task-actions ul li .badge-tag {
  padding: 5px 4px;
}
.tasks-activity.tasks > ul .task-wrap .task-actions ul li:last-child {
  margin-right: 0;
}

.all-read .checkboxs .checkmarks {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}

.task-drops .dropdown-toggle {
  border: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 600;
  box-shadow: none;
}
.task-drops .dropdown-toggle.show {
  border: 0;
}
@media (max-width: 767.98px) {
  .task-drops .dropdown-toggle {
    font-size: 16px;
  }
}

.badge-purple-light {
  color: #4A00E5 !important;
  background: #F3EDFF !important;
}

.task-wrapper {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
  padding-bottom: 15px;
}
.task-wrapper .tasks-activity.tasks > ul {
  margin-bottom: 15px;
}
.task-wrapper:last-child {
  padding-bottom: 0;
}
.task-wrapper:last-child .tasks-activity.tasks > ul {
  margin-bottom: 0;
}
.task-wrapper .task-accordion {
  font-size: 18px;
  font-weight: 600;
  position: relative;
  display: block;
}
@media (max-width: 767.98px) {
  .task-wrapper .task-accordion h4 {
    font-size: 16px;
  }
}
.task-wrapper .task-accordion span {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-left: 10px;
  color: #262A2A;
  font-weight: 600;
  font-size: 10px;
}
.task-wrapper .task-accordion::before {
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  font-size: 14px;
  font-weight: 600;
}
.task-wrapper .task-accordion:not(.collapsed)::before {
  content: "\\f078";
}
.task-wrapper:last-child {
  border: 0;
  margin-bottom: 0;
}

.preloader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999999;
  width: 100%;
  height: 100%;
  background: #FFF;
  display: flex;
  align-items: center;
  justify-content: center;
}
.preloader .loader {
  width: 64px;
  height: 64px;
  position: relative;
  animation: rotate 1.5s ease-in infinite alternate;
}
.preloader .loader::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  color: #3C2371;
  background: currentColor;
  width: 64px;
  height: 32px;
  border-radius: 0 0 50px 50px;
}
.preloader .loader::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 10%;
  background: #00918E;
  width: 8px;
  height: 64px;
  animation: rotate 1.2s linear infinite alternate-reverse;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
.toggle-content-view {
  margin-bottom: 24px;
}
.toggle-content-view h5 {
  font-size: 20px;
  font-weight: 700;
  color: #262A2A;
  margin-bottom: 5px;
}
.toggle-content-view p {
  color: #6F6F6F;
  font-size: 14px;
}

.details-propsal h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 24px;
}
.details-propsal h6 {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 12px;
}
.details-propsal h3 {
  color: #3C2371;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}
.details-propsal span {
  color: #6F6F6F;
  font-size: 14px;
  display: block;
}
.details-propsal.details-propsals ul li {
  width: 33.3%;
}
.details-propsal ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 20px;
}
.details-propsal ul li {
  width: 25%;
  margin-bottom: 10px;
}
.details-propsal ul li h5 {
  color: #565E5E;
  font-weight: 400;
  margin-bottom: 5px;
}
.details-propsal ul li h6 {
  color: #262A2A;
  font-weight: 400;
}
.details-propsal ul li img {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border-radius: 5px;
}
.details-propsal ul li .btn {
  padding: 3px 15px;
}

.attached-div h5 {
  font-size: 16px;
  margin-bottom: 12px;
}

.attached-div {
  padding-bottom: 15px;
}

.attachement-download {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #E8E8E8;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 12px;
}

.attachement-download-icon span {
  background: #E41F07;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #fff;
  border-radius: 5px;
}

.attachement-download-img {
  display: flex;
  align-items: center;
}

.attachement-download-content {
  margin-left: 10px;
}
.attachement-download-content h5 {
  font-size: 14px;
  margin-bottom: 3px;
  font-weight: 600;
}
.attachement-download-content h6 {
  font-size: 14px;
  font-weight: 400;
}

.table-view {
  margin-bottom: 24px;
  border: 1px solid #E8E8E8;
  border-radius: 10px;
}
.table-view th {
  background: #E8E8E8;
}

.table-view {
  margin-bottom: 24px;
  border: 1px solid #E8E8E8;
  border-radius: 10px;
}
.table-view th {
  background: #E8E8E8;
}

.subtotal-div {
  background: #F9F9FC;
  padding: 24px;
}
.subtotal-div ul li {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.subtotal-div ul li h5 {
  font-size: 14px;
  color: #6F6F6F;
  font-weight: 400;
  margin: 0;
}
.subtotal-div ul li h6 {
  font-size: 16px;
  color: #262A2A;
  font-weight: 600;
  margin: 0;
}
.subtotal-div ul li + li {
  margin-top: 15px;
}

.terms-condition {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #E8E8E8;
}
.terms-condition h2 {
  font-size: 14px;
  font-weight: 600;
  color: #262A2A;
  margin-bottom: 15px;
}
.terms-condition p {
  color: #6F6F6F;
  font-size: 14px;
  padding-bottom: 15px;
}

.contact-type h6 {
  font-weight: 600;
}
.contact-type ul {
  border: 0;
  display: inline;
}
.contact-type ul li {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
}
.contact-type ul li h5 {
  position: relative;
  width: 40%;
  color: #6F6F6F;
  font-size: 14px;
  margin: 0;
}
.contact-type ul li h5:after {
  position: absolute;
  content: ":";
  right: 8px;
  top: 0px;
}
.contact-type ul li h6 {
  position: relative;
  width: 60%;
  color: #262A2A;
  font-size: 14px;
  margin: 0;
}

.renewal-history h4 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
}

.renewal-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #E8E8E8;
  padding: 24px;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  border-radius: 5px;
  margin-bottom: 15px;
}
.renewal-content .renewal-content-history {
  width: 80%;
}
.renewal-content .contact-type h6 {
  color: #424848;
  margin-bottom: 15px;
}
.renewal-content .contact-type ul {
  flex-wrap: wrap;
  display: flex;
}
.renewal-content .contact-type ul li {
  width: 50%;
}
.renewal-content .contact-type ul li h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.renewal-content .contact-type ul li h5 {
  font-size: 14px;
  font-weight: 400;
}

.toogle-header-select .select2-container {
  min-width: 150px !important;
}
.toogle-header-select .select2-container--default .select2-results__option--selected {
  color: #fff;
}
.toogle-header-select .toggle-btn {
  min-width: 26px;
}

.btn-downloads {
  font-size: 14px !important;
  border: 1px solid #E8E8E8;
  padding: 10px 15px;
  color: #262A2A !important;
  font-weight: 500;
  border-radius: 5px;
}
.btn-downloads:hover {
  background: #E41F07;
  color: #FFF !important;
}

.input-table.input-table-descripition input {
  width: 130px;
}
.input-table input {
  border: 1px solid #E8E8E8;
  height: 30px;
  border-radius: 5px;
  width: 75px;
  padding: 5px;
}
.input-table select {
  border: 1px solid #E8E8E8;
  height: 30px;
  border-radius: 5px;
  width: 75px;
}

.upload-signature {
  position: relative;
}
.upload-signature input {
  width: 100%;
  height: 42px;
  opacity: 0;
  z-index: 9;
}
.upload-signature a {
  border: 1px dashed #E8E8E8;
  border-radius: 5px;
  position: absolute;
  width: 100%;
  height: 42px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #6F6F6F;
  left: 0;
  padding: 10px;
  background: #fff;
}

.toggle-header-popup .btn-dropdowns {
  min-width: 125px;
  border: 1px solid #E8E8E8;
  padding: 8px 12px;
  font-size: 14px !important;
  color: #6F6F6F !important;
}
.toggle-header-popup .btn-dropdowns.dropdown-toggle:after {
  top: -2px;
  position: relative;
  font-size: 12px;
}
.toggle-header-popup .btn-dropdowns.dropdown-toggle-contract {
  min-width: 150px;
}
.toggle-header-popup .btn-dropdowns:hover {
  color: #FFF !important;
  background: #E41F07;
}
.toggle-header-popup .btn-dropdowns:active, .toggle-header-popup .btn-dropdowns:focus {
  color: #FFF !important;
}
.toggle-header-popup .dropdown-item {
  font-size: 14px !important;
  color: #6F6F6F !important;
}

.toggle-popup-sent .sidebar-layout .sidebar-header a, .toggle-popup-draft .sidebar-layout .sidebar-header a, .toggle-popup-declined .sidebar-layout .sidebar-header a {
  font-size: 14px;
  color: #fff;
}

.signature-contant {
  padding: 15px 0;
  border-top: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
}
.signature-contant p {
  color: #B5B5B5;
  margin: 0;
}

.pay-now .btn {
  height: 42px;
}

.sidebar .sidebar-inner {
  width: 100% !important;
}

.activities-list ul li {
  background: #F6F6F6;
  padding: 15px 10px;
  margin-bottom: 20px;
}
.activities-list ul li:last-child {
  margin-bottom: 0;
}
.activities-list ul li .activity-name h5 {
  font-size: 14px;
  font-weight: 500;
  color: #262A2A;
  margin-bottom: 5px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.activities-list ul li .activity-name p {
  font-size: 14px;
  margin-bottom: 15px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}
.activities-list ul li .activity-name .badge {
  color: #FFF;
  padding: 5px 7px;
  font-size: 12px;
  border-radius: 5px;
}
.activities-list ul li .activity-name .badge i {
  margin-right: 5px;
}
.activities-list ul li .user-activity {
  display: flex;
  align-items: center;
}
@media (max-width: 767.98px) {
  .activities-list ul li .user-activity {
    margin: 20px 0;
  }
}
.activities-list ul li .user-activity span {
  flex-shrink: 0;
  display: inline-flex;
  margin-right: 5px;
}
.activities-list ul li .user-activity span img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.activities-list ul li .user-activity h6 {
  margin-bottom: 0;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
}

@media (max-width: 575.98px) {
  .card-select ul {
    align-items: start !important;
  }
}

.campaign-card {
  overflow-x: auto;
}
.campaign-card ul {
  width: max-content;
}
.campaign-card ul .campaign-wrap {
  background-color: #F9F9FC;
  margin: 0 0 15px;
  padding: 15px 15px 5px;
}
.campaign-card ul .campaign-wrap .campaign-info {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  white-space: nowrap;
  border-bottom: 1px solid #E8E8E8;
  margin: 0 0 15px 0;
}
.campaign-card ul .campaign-wrap .campaign-info h5 {
  font-weight: 600;
  margin-bottom: 5px;
}
.campaign-card ul .campaign-wrap .campaign-info .campaign-name {
  margin: 0 50px 10px 0;
}
.campaign-card ul .campaign-wrap .campaign-info .list-progress {
  margin-bottom: 10px;
}
.campaign-card ul .campaign-wrap .campaign-action {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  flex-wrap: wrap;
}
.campaign-card ul .campaign-wrap .campaign-action .project-mem {
  margin-bottom: 10px;
}
.campaign-card ul .campaign-wrap .campaign-date {
  margin-bottom: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.campaign-card ul .campaign-wrap .campaign-date .badge {
  margin: 0 15px 0 0;
}
.campaign-card ul .campaign-wrap:last-child {
  margin-bottom: 0;
}

.priority.badge-tag {
  color: #262A2A;
  min-width: 80px;
  text-align: left;
  font-weight: 600;
}
.priority.badge-tag i {
  margin-right: 4px;
}
.priority.badge-tag.badge-danger-light i {
  color: #FC0027;
}
.priority.badge-tag.badge-success-light i {
  color: #5CB85C;
}
.priority.badge-tag.badge-warning-light i {
  color: #FDA700;
}

.task-wrap {
  border: 1px solid #E8E8E8;
  margin: 0 0 10px;
  padding: 15px 15px 5px;
  position: relative;
  border-radius: 5px;
}
.task-wrap::before {
  content: "";
  background-color: #FC0027;
  width: 3px;
  height: 100%;
  border-radius: 5px;
  position: absolute;
  top: 0;
  left: 0;
}
.task-wrap:last-child {
  margin-bottom: 0;
}

.task-info {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-wrap: wrap;
}
.task-info p {
  display: inline-block;
  margin: 0 24px 10px 0;
}
.task-info p i {
  color: #6F6F6F;
  margin-right: 10px;
}
.task-info p {
  color: #262A2A;
}
.task-info .badge {
  margin: 0 10px 10px 0;
}
.task-info .badge:last-child {
  margin-right: 0;
}
.task-info .badge.badge-pill i {
  margin-right: 5px;
}

.task-actions {
  float: right;
}
.task-actions ul {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-wrap: wrap;
}
.task-actions ul li {
  margin: 0 24px 10px 0;
  color: #262A2A;
}
.task-actions ul li:last-child {
  margin-right: 0;
}
.task-actions ul li.task-time i {
  margin-right: 5px;
}
.task-actions ul li.task-date i {
  margin-right: 5px;
}
.task-actions ul li.task-owner {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.task-actions ul li.task-owner .task-user {
  margin-right: 10px;
  height: 24px;
}
.task-actions ul li.task-owner .task-user img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
@media (max-width: 767.98px) {
  .task-actions {
    float: left;
  }
}

.select-priority {
  position: relative;
}
.select-priority .select-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: 99999;
  color: #E41F07;
}
.select-priority .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
}

.project-name {
  margin-bottom: 15px;
}
.project-name p {
  font-weight: 500;
  margin-bottom: 5px;
}
.project-name h4 {
  font-weight: 600;
}

.con-sidebar-title .priority {
  margin-bottom: 15px;
}
.con-sidebar-title p {
  font-weight: 500;
  color: #262A2A;
  margin-bottom: 15px;
}
.con-sidebar-title.border-line {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 20px;
}

.kanban-list-items {
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
  margin: 0 20px 20px 0;
  padding: 15px;
  width: 100%;
  min-width: 315px;
}
.kanban-list-items:last-child {
  margin-right: 0;
}

.icons-social a {
  width: 30px;
  height: 30px;
  background: #F6F6F6;
  border-radius: 50%;
  color: #262A2A;
}
.icons-social a:hover {
  background: #FFEEEC;
  color: #E41F07;
}

.kanban-drag-wrap > div:last-child .kanban-card {
  margin-bottom: 0;
}

.pipeline-progress .progress {
  background: transparent;
  width: 70px;
  height: 5px;
}
.pipeline-progress .progress .progress-bar {
  width: 70px;
  height: 5px;
  border-radius: 5px;
}
.pipeline-progress .progress .progress-bar.progress-bar-success {
  background: #5CB85C;
}
.pipeline-progress .progress .progress-bar.progress-bar-violet {
  background: #4A00E5;
}
.pipeline-progress .progress .progress-bar.progress-bar-info {
  background: #1ECBE2;
}
.pipeline-progress .progress .progress-bar.progress-bar-warning {
  background: #FDA700;
}
.pipeline-progress .progress .progress-bar.progress-bar-green {
  background: #00918E;
}
.pipeline-progress .progress .progress-bar.progress-bar-danger {
  background: #FC0027;
}
.pipeline-progress span {
  margin-left: 10px;
  color: #262A2A;
  font-weight: 500;
}

.pipe-title .add-stage {
  color: #E41F07;
  font-weight: 500;
  margin-bottom: 15px;
  display: inline-block;
}
.pipe-title .add-stage i {
  margin-right: 8px;
}

.priority-info .dropdown .dropdown-toggle {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  border-radius: 5px;
  padding: 5px 10px;
  font-weight: 500;
}
.priority-info .dropdown .dropdown-toggle[aria-expanded=true] > i {
  transition: all 0.2s ease;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}
.priority-info .dropdown .dropdown-toggle::after {
  content: none;
}
.priority-info .dropdown .dropdown-toggle span {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.priority-info .dropdown .dropdown-toggle span i {
  font-size: 10px;
}
.priority-info .dropdown a {
  font-size: 14px;
  color: #262A2A;
}
.priority-info .dropdown a span {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.priority-info .dropdown a span i {
  font-size: 10px;
}
.priority-info .dropdown .dropdown-menu {
  width: 100%;
}

.select-pipeline {
  position: relative;
  margin-right: 8px;
}
.select-pipeline .pipe-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  z-index: 99999;
  transform: translateY(-50%);
  color: #262A2A;
}
.select-pipeline .select2-container .select2-selection.select2-selection--single {
  height: 40px;
  border-radius: 5px;
  color: #262A2A;
  font-weight: 500;
}
.select-pipeline .select2-container .select2-selection.select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
  line-height: 40px;
  color: #262A2A;
  font-weight: 500;
  padding-right: 30px;
}
.select-pipeline .select2-container .select2-selection.select2-selection--single .select2-selection__arrow {
  height: 40px;
}

.pipeline-list {
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.pipeline-list ul {
  margin-bottom: 15px;
}
.pipeline-list ul li {
  display: inline-block;
}
.pipeline-list ul li:first-child a {
  border-radius: 10px 0 0 10px;
}
.pipeline-list ul li:last-child a {
  border-radius: 0;
}
.pipeline-list ul li a {
  margin: 0 0 3px;
  padding: 12px 25px 12px 50px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  text-align: center;
  background: #F6F6F6;
  color: #262A2A;
  position: relative;
  min-width: 185px;
}
.pipeline-list ul li a::after {
  content: "";
  position: absolute;
  top: 0;
  right: -23px;
  width: 45px;
  height: 45px;
  -webkit-transform: scale(0.707) rotate(45deg);
  -ms-transform: scale(0.707) rotate(45deg);
  -moz-transform: scale(0.707) rotate(45deg);
  -transform: scale(0.707) rotate(45deg);
  z-index: 1;
  background: #F6F6F6;
  box-shadow: 2px -2px 0 1px #fff, 3px -3px 0 2px rgba(255, 255, 255, 0.1);
  border-radius: 0 5px 0 50px;
}
.pipeline-list ul li a.bg-info {
  color: #FFF;
}
.pipeline-list ul li a.bg-info::after {
  background: #1ECBE2;
}
.pipeline-list ul li a.bg-info:hover {
  background: #1ECBE2 !important;
}
.pipeline-list ul li a.bg-warning {
  color: #FFF;
}
.pipeline-list ul li a.bg-warning::after {
  background: #FDA700;
}
.pipeline-list ul li a.bg-warning:hover {
  background: #FDA700 !important;
}
.pipeline-list ul li a.bg-pending {
  color: #FFF;
  background: #4A00E5 !important;
}
.pipeline-list ul li a.bg-pending::after {
  background: #4A00E5;
}
.pipeline-list ul li a.bg-pending:hover {
  background: #4A00E5 !important;
}
.pipeline-list ul li a.bg-pink {
  color: #FFF;
}
.pipeline-list ul li a.bg-pink::after {
  background: #EA00B7;
}
.pipeline-list ul li a.bg-pink:hover {
  background: #EA00B7 !important;
}
.pipeline-list ul li a.bg-success {
  color: #FFF;
}
.pipeline-list ul li a.bg-success::after {
  background: #5CB85C;
}
.pipeline-list ul li a.bg-success:hover {
  background: #5CB85C !important;
}
.pipeline-list ul li a.bg-danger {
  color: #FFF;
}
.pipeline-list ul li a.bg-danger::after {
  background: #FC0027;
}
.pipeline-list ul li a.bg-danger:hover {
  background: #FC0027 !important;
}
.pipeline-list ul li a.bg-gray {
  color: #FFF;
  background: #E0E2E7;
}
.pipeline-list ul li a.bg-gray::after {
  background: #E0E2E7;
}
.pipeline-list ul li a.bg-gray:hover {
  background: #E0E2E7 !important;
}
@media (max-width: 575.98px) {
  .pipeline-list ul li a {
    width: calc(100% - 25px);
  }
}
@media (max-width: 575.98px) {
  .pipeline-list ul li {
    display: block;
  }
}

.campaign-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin: 0 0 24px;
  padding: 24px;
  border-radius: 5px;
}
@media (max-width: 1399.98px) {
  .campaign-box {
    margin: 0 0 24px;
    padding: 15px;
  }
}
.campaign-box .campaign-img {
  display: flex;
  align-items: center;
}
.campaign-box .campaign-img span {
  width: 44px;
  height: 44px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FFF;
  margin-right: 10px;
}
.campaign-box .campaign-img p {
  color: #262A2A;
  font-weight: 500;
}
.campaign-box h2 {
  color: #6F6F6F;
}
@media (max-width: 1399.98px) {
  .campaign-box h2 {
    font-size: 24px;
  }
}
@media (max-width: 991.98px) {
  .campaign-box h2 {
    font-size: 20px;
  }
}
.campaign-box.bg-danger-light {
  background-color: #FFEEEC;
}
.campaign-box.bg-danger-light span {
  background-color: #FC0027;
}
.campaign-box.bg-warning-light {
  background-color: #FFF7D8;
}
.campaign-box.bg-warning-light span {
  background-color: #FFA201;
}
.campaign-box.bg-purple-light {
  background-color: #F3EDFF;
}
.campaign-box.bg-purple-light span {
  background-color: #3C2371;
}
.campaign-box.bg-success-light {
  background-color: #E0F5D7;
}
.campaign-box.bg-success-light span {
  background-color: #00918E;
}

.campaign-tab {
  margin: 0 0 20px;
  padding: 15px 15px 0;
  box-shadow: 0px 4px 74px 0px rgba(208, 208, 208, 0.2509803922);
  background-color: #FFF;
  border-radius: 5px;
}
.campaign-tab ul li {
  margin-right: 15px;
}
.campaign-tab ul li a {
  position: relative;
  font-weight: 500;
  border-bottom: 4px solid #FFF;
  padding: 10px 10px 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.campaign-tab ul li a.active {
  border-color: #E41F07;
}
.campaign-tab ul li a span {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #E8E8E8;
  border-radius: 50%;
  margin-left: 10px;
  font-size: 10px;
  font-weight: 600;
  color: #6F6F6F;
}
.campaign-tab ul li:last-child {
  margin-right: 0;
}

ul.project-mem {
  display: inline-flex;
  align-items: center;
}
ul.project-mem li {
  margin-left: -10px;
  display: inline-flex;
}
ul.project-mem li a {
  width: 24px;
  height: 24px;
}
ul.project-mem li:first-child {
  margin-left: 0;
}
ul.project-mem li a img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #FFF;
}
ul.project-mem li.more-set a {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #FFF;
  border: 1px solid #E8E8E8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 12px;
  font-weight: 600;
  color: #6F6F6F;
}

.list-progress li {
  display: inline-block;
  margin-right: 15px;
}
.list-progress li h6 {
  font-weight: 600;
}
.list-progress li p {
  font-size: 12px;
  font-weight: 600;
  color: #6F6F6F;
}
.list-progress li:last-child {
  margin-right: 0;
}

.form-wrap .checkmarks.mem-plane-check {
  top: 3px;
}

.table-imgname.flag-image img {
  width: 24px;
  height: 18px;
  border-radius: 5px;
}

.table-imgname.flag-image {
  display: flex;
  align-items: center;
}

.location-flag-img {
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

.table-imgname.flag-image span {
  font-weight: 500;
  color: #262A2A;
}

#delete_request td span.badge {
  cursor: pointer;
}

.wh-14 {
  width: 14px;
  height: 14px;
}

/******* Vendors ******/
.select2-container {
  min-width: 100% !important;
  z-index: 99;
}
.select2-container .select2-selection--single {
  height: 40px;
}

.select2-container--default .select2-selection--single {
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  border-radius: 5px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #6F6F6F;
  line-height: 38px;
  border-radius: 5px;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 400;
  padding-right: 25px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered span {
  display: inline-flex;
  align-items: center;
}
.select2-container--default .select2-selection--single .select2-selection__rendered span img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}
.select2-container--default .select2-selection--single .select {
  width: 219px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 40px;
  right: 6px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
  position: absolute;
  top: 50%;
  left: 50%;
  border-color: #637381;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  height: 0;
  margin-left: -6px;
  margin-top: -3px;
  width: 0;
  transform: rotate(45deg) translateY(-50%);
  -webkit-transform: rotate(45deg) translateY(-50%);
  -ms-transform: rotate(45deg) translateY(-50%);
}

.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #000;
  border-width: 2px 0 0 2px;
  margin-top: 3px;
  padding: 3px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #E41F07;
  color: #FFF;
}

.select2-container--focus .select2-selection--single {
  background: #FFF !important;
  border-color: #E41F07;
}

span.select2-container.select2-container--default.select2-container--open {
  z-index: 9999;
}

.select2-container--default .select2-selection--single .select2-selection__rendered,
.select2-container--default .select2-selection--multiple {
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

.select2-container--classic .select2-selection--single,
.select2-container--default .select2-selection--single,
.select2-container--default .select2-selection--single .select2-selection__rendered,
.select2-container--default .select2-selection--single .select2-selection__arrow,
.select2-container--default .select2-selection--multiple,
.select2-container--classic .select2-selection--single .select2-selection__arrow,
.select2-container--classic .select2-selection--single .select2-selection__rendered {
  border-color: #E8E8E8;
  color: #6F6F6F;
  height: 40px;
  line-height: 40px;
}

.select2-container--default .select2-selection--multiple {
  line-height: 27px;
  height: auto;
  min-height: 40px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice {
  padding-left: 5px;
  padding-right: 20px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__display span {
  display: inline-flex;
  align-items: center;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__display span img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  right: 0;
  left: auto;
}

.select2-results__option span {
  display: inline-flex;
  align-items: center;
}
.select2-results__option span img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}

.select2-container--classic .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  background-color: #F6F6F6;
  border-color: #F6F6F6;
  color: #6F6F6F;
  border-radius: 5px;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #E8E8E8;
}

table.dataTable {
  margin: 0 !important;
  width: 100% !important;
}

table.dataTable > thead .sorting:after,
table.dataTable > thead .sorting_asc:after,
table.dataTable > thead .sorting_desc:after,
table.dataTable > thead .sorting_asc_disabled:after,
table.dataTable > thead .sorting_desc_disabled:after {
  right: 0.5em !important;
  content: "\\f175" !important;
  font-family: "Font Awesome 5 Free";
  bottom: 12px !important;
  color: #BABFC7 !important;
  font-size: 12px !important;
  opacity: 1 !important;
  position: absolute;
  font-weight: 600;
  line-height: 1px !important;
}

table.dataTable > thead .sorting:before,
table.dataTable > thead .sorting_asc:before,
table.dataTable > thead .sorting_desc:before,
table.dataTable > thead .sorting_asc_disabled:before,
table.dataTable > thead .sorting_desc_disabled:before {
  right: 13px !important;
  content: "\\f176" !important;
  font-family: "Font Awesome 5 Free";
  top: 50% !important;
  transform: translateY(-50%);
  color: #BABFC7 !important;
  font-size: 12px !important;
  opacity: 1 !important;
  position: absolute;
  font-weight: 600;
  line-height: 1px !important;
}

.dataTables_paginate .paging_numbers, #dataTables_paginate .paging_numbers {
  float: right;
}

.dataTables_info {
  padding-right: 15px;
  font-size: 12px;
  color: #424848;
  font-weight: 600;
}

.custom-select {
  min-width: 80px;
}

.dataTables_paginate .pagination, #dataTables_paginate .pagination {
  justify-content: end;
  -webkit-justify-content: end;
  -ms-flex-pack: end;
}
.dataTables_paginate .pagination li, #dataTables_paginate .pagination li {
  margin: 0 2px;
}
.dataTables_paginate .pagination li a, #dataTables_paginate .pagination li a {
  background: #FFF;
  border-color: transparent;
  border-radius: 5px !important;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6F6F6F;
}
.dataTables_paginate .pagination li a:hover, #dataTables_paginate .pagination li a:hover {
  background: #00918E;
  color: #FFF;
}
.dataTables_paginate .pagination li.active a.page-link, #dataTables_paginate .pagination li.active a.page-link {
  background: #00918E;
  border-color: #00918E;
  border-radius: 5px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dataTables_paginate .pagination li.previous.disabled, .dataTables_paginate .pagination li.previous, #dataTables_paginate .pagination li.previous.disabled, #dataTables_paginate .pagination li.previous {
  width: auto;
  margin: 0 13px 0 0;
}
.dataTables_paginate .pagination li.previous.disabled a, .dataTables_paginate .pagination li.previous a, #dataTables_paginate .pagination li.previous.disabled a, #dataTables_paginate .pagination li.previous a {
  background-color: transparent;
  border: 0;
  width: auto;
  padding: 0;
}
.dataTables_paginate .pagination li.previous.disabled a i, .dataTables_paginate .pagination li.previous a i, #dataTables_paginate .pagination li.previous.disabled a i, #dataTables_paginate .pagination li.previous a i {
  margin-right: 8px;
}
.dataTables_paginate .pagination li.previous.disabled a:hover, .dataTables_paginate .pagination li.previous a:hover, #dataTables_paginate .pagination li.previous.disabled a:hover, #dataTables_paginate .pagination li.previous a:hover {
  color: #00918E;
}
.dataTables_paginate .pagination li.next.disabled, .dataTables_paginate .pagination li.next, #dataTables_paginate .pagination li.next.disabled, #dataTables_paginate .pagination li.next {
  width: auto;
  margin: 0 0 0 13px;
}
.dataTables_paginate .pagination li.next.disabled a, .dataTables_paginate .pagination li.next a, #dataTables_paginate .pagination li.next.disabled a, #dataTables_paginate .pagination li.next a {
  background-color: transparent;
  border: 0;
  width: auto;
  padding: 0;
}
.dataTables_paginate .pagination li.next.disabled a i, .dataTables_paginate .pagination li.next a i, #dataTables_paginate .pagination li.next.disabled a i, #dataTables_paginate .pagination li.next a i {
  margin-left: 8px;
}
.dataTables_paginate .pagination li.next.disabled a:hover, .dataTables_paginate .pagination li.next a:hover, #dataTables_paginate .pagination li.next.disabled a:hover, #dataTables_paginate .pagination li.next a:hover {
  color: #00918E;
}
@media (max-width: 767.98px) {
  .dataTables_paginate .pagination, #dataTables_paginate .pagination {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }
}

.dataTables_length, #dataTables_length .dataTables_paginate,
#dataTables_paginate {
  margin-top: 15px !important;
}

.dataTables_length label, #dataTables_length label {
  display: flex;
  align-items: center;
  color: #6F6F6F;
  font-size: 14px;
}
.dataTables_length label .form-select, #dataTables_length label .form-select {
  width: 73px;
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  color: #262A2A;
  margin: 0 8px;
}
@media (max-width: 767.98px) {
  .dataTables_length label, #dataTables_length label {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    margin-bottom: 10px;
  }
}

@media (max-width: 767.98px) {
  .datatable-length {
    text-align: center;
  }
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 23px;
}

table.dataTable thead > tr > th.no-sort.sorting_asc:before {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting_asc::after {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting:before {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting::after {
  display: none;
}

.custom-table .table-responsive {
  border: 1px solid #E8E8E8;
  border-radius: 6px;
}

table.table.dataTable > tbody > tr {
  border-color: #E8E8E8;
}
table.table.dataTable > tbody > tr td {
  color: #6F6F6F;
}
table.table.dataTable > thead > tr {
  border-color: #E8E8E8;
}
table.table.dataTable > thead > tr th {
  color: #262A2A;
  font-size: 14px;
  font-weight: 500;
}

.active > .page-link, .page-link.active {
  z-index: unset;
}

a {
  text-decoration: none;
  color: #262a2a;
}

.ant-tooltip {
  display: none;
}

.data-table-card .ant-table-content .ant-table-tbody tr:nth-of-type(2n + 1) {
  background-color: #fff;
}
.data-table-card .ant-table-content .ant-table-tbody td {
  padding: 0.5rem;
}

.ant-table-cell-row-hover {
  background-color: #fff;
  background: #fff;
}

.ant-pagination-item.ant-pagination-item-1.ant-pagination-item-active {
  background: #00918e;
  border-color: #00918e;
  color: #fff;
}

h4,
.h4 {
  font-size: 1.125rem;
}

.daterangepicker td.active,
.daterangepicker td.active:hover {
  background-color: #00918e;
  color: #fff;
}

.daterangepicker .calendar-table td.in-range {
  background-color: #fff;
}

.applyBtn.btn.btn-sm.btn-primary {
  color: #fff;
  background-color: #00918e;
  border: 1px solid #00918e;
}

.css-1u9des2-indicatorSeparator {
  display: none;
}

div .badge-status {
  border-radius: 5px;
  font-size: 12px;
  padding: 4px 8px;
  min-width: 64px;
  color: #FFF;
}

div .bg-success {
  background-color: #5CB85C !important;
}
div .bg-success.bg-opacity-10 {
  background-color: rgba(92, 184, 92, 0.1) !important;
}
div .bg-success.bg-opacity-25 {
  background-color: rgba(92, 184, 92, 0.25) !important;
}
div .bg-success.bg-opacity-50 {
  background-color: rgba(92, 184, 92, 0.5) !important;
}
div .bg-success.bg-opacity-75 {
  background-color: rgba(92, 184, 92, 0.75) !important;
}
div .bg-success.bg-opacity-100 {
  background-color: #5cb85c !important;
}

:where(.css-dev-only-do-not-override-djtmh8).ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {
  background-color: #fff;
}

.css-1p3m7a8-multiValue {
  background-color: #f6f6f6;
  border-color: #f6f6f6;
  color: #6f6f6f;
  border-radius: 5px;
}

.stickybar {
  top: 0;
  position: sticky;
}

.select-details .css-1dimb5e-singleValue,
.select-details .css-1jqq78o-placeholder {
  padding-left: 15px;
}

div.css-13cymwt-control,
div.css-t3ipsp-control {
  min-width: 120px;
  border-color: #e8e8e8;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
  height: 41px;
  border-radius: 5px;
}

div.css-t3ipsp-control:hover {
  border-color: transparent;
}

span.p-dropdown-label.p-inputtext span {
  font-family: "Noto Sans", sans-serif;
}

.deals-details.react-datepicker__input-container {
  width: 450px !important;
}

div.react-datepicker-wrapper {
  display: block;
  padding: 0;
  border: 0;
}

span.form-icon {
  z-index: 1;
}

.img-checked {
  padding: 10px;
  background: rgb(49, 132, 199);
  color: white;
  border-radius: 20px;
  font-weight: bolder;
  position: relative;
  /* margin-top: 2px ; */
}

.section-notes-slider .notes-slider .slick-list .slick-slide div {
  margin-left: 12px !important;
}

.page-add-notes {
  display: flex;
  flex-wrap: wrap;
}

.visible .input-blocks .css-b62m3t-container .css-1dimb5e-singleValue {
  margin-left: 25px !important;
}

[data-layout-mode=dark_mode] .css-13cymwt-control {
  background-color: #1d1d42;
  border: 1px solid #67748E;
}

[data-layout-mode=dark_mode] .css-t3ipsp-control {
  background-color: #1d1d42;
}

[data-layout-mode=dark_mode] .css-1nmdiq5-menu {
  background-color: #1d1d42;
}

.form-sorts.dropdown .radio-btn-items {
  margin-top: 10px;
}

.select__control {
  background-color: #e41f07 !important;
  border-color: #e41f07 !important;
}

.select__control:hover {
  border-color: #e41f07 !important;
}

.p-dropdown-label.p-inputtext .p-d-flex.p-ai-center img,
.p-dropdown-item-label .p-d-flex.p-ai-center,
.p-dropdown-label.p-inputtext .p-clearfix img,
.p-dropdown-item-label .p-clearfix img {
  width: 16px;
  height: 16px;
  border-radius: 5px;
  margin-right: 5px;
}

.p-d-flex.p-ai-center {
  display: flex;
  align-items: center;
}

.p-dropdown-items-wrapper ul.p-dropdown-items,
.p-dropdown-panel.p-component.p-ripple-disabled.p-connected-overlay-enter-done {
  z-index: 100000000000 !important;
}

.swiper-container .slick-list {
  margin-left: -236px;
}

.p-dropdown.p-component.p-inputwrapper {
  height: 42px;
  line-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: #e8e8e8;
  color: #6f6f6f;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

div.p-clearfix {
  display: flex;
  align-items: center;
}

div.p-clearfix span,
span.p-dropdown-label.p-inputtext.p-placeholder {
  font-size: 14px;
}

.p-dropdown-trigger svg {
  width: 13px;
}

div.rti--container {
  border-color: #e8e8e8;
  color: #6f6f6f;
  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);
}

span.rti--tag button {
  font-size: 10px;
}

.filter-dropdown-menu.dropdown-menu.dropdown-menu-md-end.show,
.filter-dropdown-menu.dropdown-menu {
  z-index: 11;
}

span.ant-picker-suffix {
  display: none !important;
}

.stickybar {
  position: sticky;
  top: 0;
}

.right-user-side.chat-rooms.theiaStickySidebar {
  max-height: 500px;
  overflow: auto;
}

.send-chat.comman-icon i.feather.feather-send {
  color: #fff;
}

.chat-footer form {
  background-color: #fff;
}

.nav.flex-column.nav-pills.todo-inbox i {
  margin-right: 10px;
}

.select-priority .css-1jqq78o-placeholder,
.select-priority .css-1dimb5e-singleValue {
  padding-left: 15px;
}

.form-sort .css-1jqq78o-placeholder,
.form-sort .css-1dimb5e-singleValue {
  padding-left: 20px;
}

.form-sort.select-bluk.space-not-select .css-1jqq78o-placeholder,
.form-sort.select-bluk.space-not-select .css-1dimb5e-singleValue {
  padding: 0;
}

.owl-carousel.folders-carousel.owl-theme .slick-slide > div,
.owl-carousel.files-carousel.owl-theme .slick-slide > div {
  margin-right: 10px;
}

[data-theme=dark] .ant-table-content table,
[data-theme=dark] .ant-table-thead tr th,
[data-theme=dark] .ant-pagination.ant-table-pagination.ant-table-pagination-right {
  background-color: #171724;
  color: #a3a6a6;
}

[data-theme=dark] .table tbody tr td .table-avatar a,
[data-theme=dark] td.ant-table-cell {
  color: #a3a6a6;
}

td .badge-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rsw-editor select {
  display: none;
}

.custom-table {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}

.join-contents .slick-slider div.slick-slide > div {
  margin-right: 10px;
}

.custom-react-clr {
  color: #6f6f6f;
}

div.popover {
  z-index: 9999;
}

div.rc-slider-track,
.rc-slider-tracks {
  background-color: #ed5565;
}

div.rc-slider-handle {
  border: solid 2px #ed5565;
}

span.rc-slider-dot-active {
  border-color: #ed5565;
}

div.rc-slider-handle:active {
  border-color: #ed5565;
  box-shadow: 0 0 5px #ed5565;
  cursor: grabbing;
}

.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: #ed5565;
  box-shadow: 0 0 0 5px #ed5565;
}

div.rc-slider-handle:hover {
  border-color: #ed5565;
}

div.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: #ed5565;
  box-shadow: 0 0 0 5px #ed5565;
}

[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {
  background-color: #171724;
}
[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody > tr > th,
[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-tbody > tr > td {
  border-color: #393947;
}
[data-theme=dark] :where(.css-11xg00t).ant-table-wrapper .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {
  background: #171724;
}
[data-theme=dark] :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {
  background: #171724;
}
[data-theme=dark] .custom-table {
  border: 1px solid #393947;
}
[data-theme=dark] .css-13cymwt-control {
  background-color: #171724;
  border: 1px solid #393947;
}
[data-theme=dark] .react-datepicker__month-container,
[data-theme=dark] .react-datepicker__header {
  background-color: #393947;
}
[data-theme=dark] .css-t3ipsp-control {
  background: #171724;
  border: 1px solid #393947;
  color: #a3a6a6;
}
[data-theme=dark] .css-1dimb5e-singleValue {
  color: #a3a6a6;
}
[data-theme=dark] .css-b62m3t-container div.css-1nmdiq5-menu {
  background-color: #393947 !important;
}
[data-theme=dark] .react-select-29-listbox {
  background-color: #393947;
}
[data-theme=dark] .input-blocks input[type=text] {
  background: #1d1d42 !important;
}
[data-theme=dark] .p-dropdown.p-component.p-inputwrapper {
  background-color: #171724;
  border: 1px solid #393947;
  box-shadow: none;
}
[data-theme=dark] .p-dropdown-item {
  background-color: #171724;
  border: 1px solid #393947;
}
[data-theme=dark] .rti--container {
  background-color: #171724;
  border: 1px solid #393947;
  box-shadow: none;
}
[data-theme=dark] .rti--tag {
  background-color: #171724;
}
[data-theme=dark] .rti--input {
  background-color: #171724;
}

[data-sidebar=green] .clinicdropdown.theme a {
  background-color: #005351;
}

[data-sidebar=blue] .clinicdropdown.theme a {
  background-color: #2f0093;
}

[data-sidebar=dark] .clinicdropdown.theme a {
  background-color: #28283e;
}

[data-theme=dark] .header .header-left .logo img.white-logo {
  display: block;
}

[data-theme=dark] .chat-footer form {
  background-color: #28283e;
}

[data-theme=dark] .sidebar .sidebar-menu .clinicdropdown.theme a {
  background-color: #28283e;
}

[data-theme=dark] .rsw-toolbar {
  background: grey;
}

div.css-b62m3t-container .react-select__option--is-focused {
  background-color: #e41f07;
  color: #fff;
}

div.css-b62m3t-container .react-select__option--is-selected {
  background-color: #e41f07;
  color: #fff;
}

.submenu .ti-ticket:before {
  content: "\\eb3d";
}

.form-icon .ti-search:before {
  content: "\\eb1c";
}

.form-icon .ti-calendar:before {
  content: "\\ea53";
}

i.ti-trash:before {
  content: "\\eb41";
}

[data-theme=dark] .header .header-left #toggle_btn {
  color: #fff;
}

i.ti-lock:before {
  content: "\\eae2";
}

i.ti-bell:before {
  content: "\\ea35";
}

[data-theme=dark] .login-wrapper .form-control {
  background-color: #ffffff;
  border-color: #e8e8e8;
}

[data-theme=dark] div.css-13cymwt-control,
[data-theme=dark] div.css-t3ipsp-control {
  border-color: none;
  box-shadow: none;
}

.mini-sidebar.expand-menu .subdrop ~ ul {
  display: block !important;
}

.mini-sidebar .subdrop ~ ul {
  display: none !important;
}

.sidebar .sidebar-menu > ul li .submenu.submenu-two > ul li a {
  margin-left: 30px;
}

.ti.ti-eye:before {
  content: "\\ea9a";
}

.ti.ti-user:before {
  content: "\\eb4d";
}

div.sidebar-themesettings .input-themeselect input[type=radio]:checked ~ label .checkboxs-theme::before {
  content: "\\f00c";
  font-family: "Font Awesome 5 Free";
  color: #fff;
  font-weight: 700;
  font-size: 10px;
  right: 4px;
  position: absolute;
  top: -16px;
  z-index: 9;
}

.ti-check:before {
  content: "\\ea5e" !important;
}

.ti-arrow-down:before {
  content: "\\ea16" !important;
}

.select-pipeline .react-select__value-container {
  padding-left: 28px !important;
}

.modal-open .offcanvas.offcanvas-end {
  width: 700px !important;
}

.ant-table {
  font-family: "Noto Sans", sans-serif !important;
}

.ti-shield:before {
  content: "\\eb24" !important;
}

.swal2-popup {
  font-size: 0.75rem !important;
}

.swal2-title {
  margin: 0px 20px !important;
}

.swal2-html-container {
  margin: 0px 40px !important;
}

.divider {
  border-top: 1px solid #dee2e6;
  margin: 1rem 0;
}

.profile-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid #ccc;
}

.profile-image-rect {
  width: 50px; /* Set the width */
  height: 35px; /* Set the height */
  object-fit: cover; /* Maintain aspect ratio and cover the container */
  border-radius: 5px; /* Slight rounding for aesthetic purposes */
  border: 1px solid #ccc; /* Optional: Add a light border */
}

.fixed-table-width {
  width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/style/scss/main.scss","webpack://./src/style/scss/layout/_common.scss","webpack://./src/style/scss/utils/_variables.scss","webpack://./src/style/scss/utils/_mixins.scss","webpack://./src/style/scss/layout/_content.scss","webpack://./src/style/scss/layout/_header.scss","webpack://./src/style/scss/layout/_sidebar.scss","webpack://./src/style/scss/layout/_theme.scss","webpack://./src/style/scss/layout/_theme-settings.scss","webpack://./src/style/scss/layout/_notification.scss","webpack://./src/style/scss/components/_avatar.scss","webpack://./src/style/scss/components/_boostrap.scss","webpack://./src/style/scss/components/_button.scss","webpack://./src/style/scss/components/_badge.scss","webpack://./src/style/scss/components/_border.scss","webpack://./src/style/scss/components/_calendar.scss","webpack://./src/style/scss/components/_chart.scss","webpack://./src/style/scss/components/_call.scss","webpack://./src/style/scss/components/_chat.scss","webpack://./src/style/scss/components/_dropdown.scss","webpack://./src/style/scss/components/_email.scss","webpack://./src/style/scss/components/_file-manager.scss","webpack://./src/style/scss/components/_icons.scss","webpack://./src/style/scss/components/_progress.scss","webpack://./src/style/scss/components/_pagination.scss","webpack://./src/style/scss/components/_typography.scss","webpack://./src/style/scss/components/_alerts.scss","webpack://./src/style/scss/components/_popovers.scss","webpack://./src/style/scss/components/_forms.scss","webpack://./src/style/scss/components/_notes.scss","webpack://./src/style/scss/components/_todo.scss","webpack://./src/style/scss/components/_tables.scss","webpack://./src/style/scss/components/_accordion.scss","webpack://./src/style/scss/components/_breadcrumb.scss","webpack://./src/style/scss/components/_cards.scss","webpack://./src/style/scss/components/_tooltips.scss","webpack://./src/style/scss/components/_navs-tabs.scss","webpack://./src/style/scss/components/_ribbon.scss","webpack://./src/style/scss/components/_popup.scss","webpack://./src/style/scss/components/_grid.scss","webpack://./src/style/scss/base/_base.scss","webpack://./src/style/scss/base/_background.scss","webpack://./src/style/scss/pages/_contact.scss","webpack://./src/style/scss/pages/_dashboard.scss","webpack://./src/style/scss/pages/_error.scss","webpack://./src/style/scss/pages/_login.scss","webpack://./src/style/scss/pages/_settings.scss","webpack://./src/style/scss/pages/_report.scss","webpack://./src/style/scss/pages/_activity.scss","webpack://./src/style/scss/pages/_tasks.scss","webpack://./src/style/scss/pages/_analytics.scss","webpack://./src/style/scss/pages/_project.scss","webpack://./src/style/scss/pages/_leads.scss","webpack://./src/style/scss/pages/_campaign.scss","webpack://./src/style/scss/pages/_membership-plans.scss","webpack://./src/style/scss/vendors/_select2.scss","webpack://./src/style/scss/vendors/_datatables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,oBAAA;AAKA,qBAAA;ACLA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;AFcJ;;AEZA;EACI,mBCqKO;AHtJX;;AEbA;EACI,mBCWM;AHKV;;AEdA;EACI,mBC+JO;AH9IX;;AEdI;EACI,eCwVO;AHvUf;;AEdA;EACI,wBAAA;AFiBJ;;AEfA;EAAU,yBAAA;AFmBV;;AEjBA;EACI,yBAAA;AFoBJ;;AEhBQ;EACI,qBCwIA;AHrHZ;;AEdI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBCzBE;ED0BF,6BAAA;EACA,WAAA;EACA,WCLA;EDMA,gBCtCe;EDuCf,UAAA;AFiBR;AEhBQ;EACI,mBCuNE;AHrMd;;AEdA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;AFiBJ;;AEfA;EACI,mBC6GO;AH3FX;;AEhBA;EACI,mBC7CM;AHgEV;;AEjBA;EACI,mBCuGO;AHnFX;;AEjBI;EACI,eCgSO;AH5Qf;;AEjBA;EACI,wBAAA;AFoBJ;;AElBA;EACI,yBAAA;AFqBJ;;AEnBA;EACI,yBAAA;AFsBJ;;AEjBQ;EACI,qBC8EA;AH1DZ;;AEhBA;EACI,kBAAA;AFmBJ;AElBI;EACI,yBAAA;EACA,kBAAA;EACA,6DAAA;EACA,gBCvDA;EDwDA,gBCzFa;ED4Fb,oBAAA;EAGA,mBAAA;EEDL,iBFEmC;AFoBtC;AIjFI;EFiDA;IEUD,iBFIuC;EFsBxC;AACF;AErBQ;EACI,iBAAA;AFuBZ;AErBQ;EACI,cCyJE;AHlId;AErBQ;EACI,yBAAA;AFuBZ;AI/FI;EFiDA;IA0BQ,WAAA;EFwBV;AACF;AEtBI;EACI,aAAA;EACA,kBAAA;EACA,gBCnFA;EDoFA,yBAAA;EACA,8DAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;AFwBR;AIhHI;EF8EA;IAYQ,gBAAA;EF0BV;AACF;AIrHI;EF8EA;IAeQ,YAAA;IACA,OAAA;EF4BV;AACF;AEzBQ;EACI,cAAA;EACA,UAAA;AF2BZ;AExBI;EAGI,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AF0BR;AEzBQ;EACI,mBAAA;AF2BZ;AE1BY;EACI,iBAAA;AF4BhB;AIjJI;EFkHI;IAMQ,eCkMD;EHrKb;AACF;AE3BQ;EACI,cC5HH;ED6HG,mBAAA;AF6BZ;AE5BY;EACI,cCxJN;AHsLV;AE1BI;EACI,mBAAA;AF4BR;AE1BY;EACI,aAAA;EACA,mBAAA;EACA,cCLL;EDMK,gBC5KO;ED6KP,kBAAA;EACA,kBAAA;AF4BhB;AE3BgB;EACI,gBAAA;EACA,kCAAA;EE7FlB,kBF8FoC;EE7FpC,QF6F8C;EE1F9C,OF0F+D;EEnI/D,2BFoIqC;EEnIrC,mCFmIqC;EElIrC,+BFkIqC;EACnB,eCsKL;AHrIf;AE/BgB;EACI,kBAAA;AFiCpB;AEhCoB;EACI,gBAAA;AFkCxB;AE3BQ;EACI,iBAAA;EACA,eCwJG;EDvJH,gBCnMW;EDoMX,kBAAA;EACA,WAAA;AF6BZ;AIhMI;EF8JI;IAOQ,kBAAA;EF+Bd;AACF;AE7BQ;EACI,mBCrDA;EDsDA,yBAAA;AF+BZ;;AE3BA;EAGI,aAAA;EAGA,mBAAA;EACA,eAAA;EACA,mBAAA;AF8BJ;AE7BI;EACI,qBAAA;AF+BR;AE9BQ;EACI,eAAA;AFgCZ;;AE3BI;EACI,mBC9EI;ED+EJ,kBAAA;EACA,aAAA;EACA,gBAAA;AF8BR;AE7BQ;EACI,mBAAA;AF+BZ;AE9BY;EACI,eAAA;AFgChB;AE7BQ;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;AF+BZ;AE9BY;EACI,UAAA;EACA,mBCzON;ED0OM,WAAA;AFgChB;AE9BY;EACI,4CAAA;EACA,kBAAA;AFgChB;AE9BY;EACI,mBCjPN;EDkPM,kBAAA;AFgChB;AE9BY;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AFgChB;AE/BgB;EACI,gBAAA;AFiCpB;AE/BgB;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AFiCpB;AE/BgB;EACI,kBAAA;EACA,MAAA;EACA,iBAAA;EACA,aAAA;AFiCpB;AE/BgB;EACI,cAAA;AFiCpB;AEhCoB;EACI,cCvHZ;AHyJZ;AEjCwB;EACI,cCnQlB;AHsSV;AEhCoB;EACI,gBAAA;AFkCxB;AE/BgB;EACI,cAAA;AFiCpB;AEhCoB;EACI,gBAAA;EACA,eC2DT;ED1DS,gBClSH;AHoUrB;;AK7UA;ED2FE,yBC1FsB;EDsGrB,mBCrG0B;EDsG1B,iBCtGuC;ED6FxC,kBC5FoB;EDgGpB,OChG4C;EDwF5C,yBCvFsB;ALsVxB;AI7SI;EC7CJ;IDuGG,SCjG8B;IDkG9B,iBClGkC;ELyVnC;AACF;AKxVI;EDgGD,aC/FmC;EAC9B,iBAAA;AL0VR;AIvTI;ECrCA;IDgGD,oBC5FuC;EL4VxC;AACF;;AMzWA;EACI,YAAA;EACA,YAAA;EACA,gBHwCI;ECoDN,eE3FoB;EF4FpB,ME5F0B;EF6F1B,QE7F4B;EF+F5B,OE/FmC;EFuFnC,yBEtFsB;ANiXxB;AM9WY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;ANgXhB;AM5WI;EFyFD,UExFoC;EAC/B,kBAAA;AN8WR;AM7WQ;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBH0IA;EGzIA,iBAAA;EACA,mBAAA;EACA,kBH0TO;EGzTP,cHuJD;AHwNX;AI5VI;EE3BI;IAUQ,YAAA;ENiXd;AACF;AMhXY;EACI,cH6IL;AHqOX;AM9WY;EACI,UAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EFkFd,kBEjF+B;EACjB,eAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,cH8HL;EClFT,kBE3CgC;EF4ChC,QE5CyC;EF6CzC,WE7C6C;EFM7C,2BELiC;EFMjC,mCENiC;EFOjC,+BEPiC;ANoXnC;AInZI;EEmCA;IAEQ,SAAA;IACA,QAAA;IACA,UAAA;IACA,gBAAA;IACA,kBAAA;IACA,UAAA;IACA,SAAA;IACA,cAAA;IACA,kBHgRO;IG/QP,8DHuRI;ICpPb,SElCiC;IFmCjC,UEnCoC;IFsBrC,yBErB8B;IFZ9B,2BEa6B;IFZ7B,mCEY6B;IFX7B,+BEW6B;ENuX7B;AACF;AIlZI;EEYA;IAiBQ,gBAAA;ENyXV;AACF;AMvXI;EACI,mBAAA;EACA,UAAA;EACA,0BAAA;EFtBN,wBEuByB;EFtBzB,gCEsByB;EFrBzB,4BEqByB;EFUzB,yBET0B;AN6X5B;AM3XI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBHzDA;EC6DL,eEHmC;EFVpC,yBEW0B;AN+X5B;AM9XQ;EACI,qBAAA;EACA,cAAA;ANgYZ;AM/XY;EACI,YAAA;EACA,cAAA;ANiYhB;AMhYgB;EACI,aAAA;ANkYpB;AIncI;EE0DI;IAWQ,kBAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;ENkYd;EMjYc;IACI,YAAA;ENmYlB;AACF;AMhYQ;EACI,aAAA;ANkYZ;AIldI;EEuCA;IA4CQ,kBAAA;IACA,WAAA;ENmYV;AACF;AIxdI;EE0FI;IACI,aAAA;ENiYV;AACF;AIpfI;EEuHI;IACI,eH0NG;IGzNH,YAAA;IACA,kBAAA;ENgYV;EM/XU;IACI,qBAAA;IACA,WAAA;ENiYd;EMhYc;IACI,sBH1GZ;IG2GY,cAAA;IACA,WAAA;IACA,WAAA;IACA,WAAA;IFlDjB,eEmDyC;IF3B1C,mBE4BmC;ENkYnC;EMjYkB;IACI,WAAA;ENmYtB;AACF;AM9XI;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;ANgYR;AM/XQ;EACI,yBHpJF;EGqJE,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;ANiYZ;AMhYY;EACI,WAAA;ANkYhB;AM5XY;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;AN8XhB;AM5XoB;EACI,kBAAA;EACA,SAAA;EFpItB,wBEqIyC;EFpIzC,gCEoIyC;EFnIzC,4BEmIyC;ANgY3C;AM9XoB;EACG,aAAA;ANgYvB;AM9XoB;EF1IlB,yBE2IyC;EF1IzC,iCE0IyC;EFzIzC,6BEyIyC;ANkY3C;AM5XI;EACI,gBAAA;EACA,kBHsIW;EGrIX,YAAA;AN8XR;AI/hBI;EE8JA;IAKQ,gBAAA;ENgYV;AACF;AM9XY;EACI,gBAAA;EACA,eAAA;ANgYhB;AM/XgB;EACI,cAAA;EACA,YAAA;EACA,gBH9KZ;EG+KY,kBHyHD;AHwQnB;AMhYoB;EACI,mBH5DZ;AH8bZ;AMhYoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ANkYxB;AMjYwB;EACI,eHkIb;EGjIa,WH5LpB;EG6LoB,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBHsGT;EGnGS,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;ANmY5B;AMhY4B;EACI,gBH/OT;EGgPS,cH1ErB;EG2EqB,gBAAA;ANkYhC;AMhY4B;EACI,gBHtPX;EGuPW,cHUnB;AHwXb;AIrlBI;EEiNwB;IAIQ,eHkGrB;EHkSb;AACF;AM5XI;EFnKD,YEoKmC;AN8XtC;AM7XQ;EAGI,aAAA;EFxKT,sBEyKuC;AN+X1C;AM9XY;EACI,eH/QC;EGgRD,cH9PJ;EG+PI,gBH3QK;AH2oBrB;AM9XY;EACI,eHpRC;EGqRD,cH3GL;AH2eX;AM9XY;EACI,iBAAA;ANgYhB;AM9XY;EACI,aAAA;ANgYhB;AM1XY;EACI,0BAAA;EACA,SAAA;AN4XhB;AMvXI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;ANyXR;AInoBI;EE4QQ;IAEQ,aAAA;ENyXlB;AACF;AMtXQ;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;ANwXZ;AIxpBI;EEkRI;IAgBQ,SAAA;EN0Xd;AACF;AMxXM;EACE,cAAA;EACA,cAAA;EACA,eAAA;AN0XR;AMxXM;EAGE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WHtTA;EGuTA,WAAA;EACA,YAAA;EACA,kBHjBW;EGkBX,gBH1Ve;EG2Vf,eAAA;EACA,eAAA;AN0XR;AIprBI;EE0SE;IAkBM,eAAA;EN4XV;AACF;AM3XQ;EACI,kBHzBO;AHsZnB;AM1XM;EACE,eHVO;EGWP,gBHtWe;EGuWf,cAAA;EACA,aAAA;EACA,mBAAA;AN4XR;AM1XM;EACE,iBAAA;AN4XR;AMzXI;EACI,kBAAA;EACA,iBAAA;AN2XR;AM1XQ;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EF7SV,yBE8S8B;AN8XhC;AI1tBI;EEgVI;IAcQ,aAAA;ENgYd;AACF;AM/XY;EACI,kBAAA;EACA,WAAA;EACA,mBH5XN;EG6XM,WAAA;EACA,YAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;ANiYhB;AM9XgB;EACI,eAAA;EACA,gBAAA;ANgYpB;AM9XgB;EACI,eAAA;EACA,gBAAA;ANgYpB;AM7XY;EACI,iBAAA;EACA,oBAAA;AN+XhB;AM9XgB;EACI,cAAA;ANgYpB;AIxvBI;EEoXQ;IAOQ,gBAAA;ENiYlB;AACF;AMhYgB;EACI,WAAA;EACA,cAAA;ANkYpB;AM/XoB;EACI,cH5Zd;AH6xBV;AM5XgB;EACI,SAAA;EACA,aAAA;AN8XpB;AM3XY;EACI,kBAAA;EACA,iBAAA;AN6XhB;AM3XY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBHxSJ;EGySI,cHxRL;EGyRK,kBHvHG;EGwHH,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AN6XhB;AM5XgB;EACI,mBH3SR;AHyqBZ;AM1XgB;EACI,iBAAA;AN4XpB;AMvXgB;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;ANyXpB;AMxXoB;EACI,WHrbhB;EGsbgB,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBHnJL;AH6gBnB;AMxXoB;EACI,WH9bhB;EG+bgB,gBH9dL;ECmFjB,kBE4YwC;EF3YxC,QE2YiD;EF1YjD,UE0YqD;EAC/B,mBHxdd;EGydc,WAAA;EACA,YAAA;EACA,eH9IT;EGiJS,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AN4XxB;AM1XoB;EACI,eHnJT;AH+gBf;AM1XoB;EACI,mBHted;EGuec,sBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AN4XxB;AMxXqB;EAGG,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AN0XxB;AMzXwB;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;AN2X5B;AM1X4B;EF1azB,iBE2a2D;AN4X9D;AMxXoB;EACI,aAAA;EACA,gBAAA;AN0XxB;AMzXwB;EFlbrB,kBEmbuD;EAC9B,cAAA;EACA,mBAAA;EACA,gBAAA;AN2X5B;AM1X4B;EACI,WHrfxB;AHi3BR;AM1X4B;EACI,sDAAA;AN4XhC;AMxX4B;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AN0XhC;AMjXI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EF/cL,kBEgdmC;EFzbpC,gBE0buB;ANmXzB;AI/3BI;EEugBA;IAOQ,aAAA;ENqXV;AACF;AMpXQ;EACI,cH1iBF;EG2iBE,eH7NG;EG8NH,gBHpjBO;EGqjBP,yBAAA;EF1dT,SE2diC;EF1djC,YE0doC;EFncrC,kBEoc2B;ANuX7B;AMtXY;EACI,mBHjjBN;EGkjBM,WH3hBR;AHm5BR;AMpXI;EACI,aAAA;EACA,WAAA;ANsXR;AIr5BI;EE6hBA;IAIQ,cH1jBF;IG2jBE,eHpOG;IGqOH,YAAA;IACA,iBAAA;IACA,WAAA;IACA,WAAA;IF3eT,eE4euC;IFrfxC,kBEsf4B;IFrf5B,MEqfqC;IFlfrC,OEkfiD;IACvC,cAAA;EN0XV;AACF;AMvXI;EACI,aAAA;EACA,WHjjBA;EGkjBA,eHpPO;EGqPP,YAAA;EACA,iBAAA;EFvfL,eEwfmC;ANyXtC;AI56BI;EE6iBA;IAQQ,cAAA;EN2XV;AACF;AMxXQ;EACI,kBAAA;AN0XZ;AIp7BI;EEyjBI;IAGQ,aAAA;EN4Xd;AACF;AM3XY;EACI,0CAAA;EACA,2CAAA;EACA,YAAA;EFtgBb,4BEugB2C;EFhf5C,mBEif+B;AN6XjC;AM5XgB;EACI,+BAAA;AN8XpB;AM3XY;EACI,6BAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EF1hBd,kBE2hBgC;EF1hBhC,ME0hByC;EFzhBzC,QEyhB2C;AN+X7C;AI58BI;EEklBY;IACI,cAAA;IFjiBlB,kBEkiBoC;IF9hBpC,OE8hB4D;EN8X5D;EM7XkB;IACI,sBHxlBhB;EHu9BN;EM7XkB;IACI,6BAAA;IACA,yBAAA;IACA,gBAAA;IFziBtB,kBE0iBwC;IFziBxC,MEyiBiD;IFxiBjD,QEwiBmD;IFjiBlD,iBEkiBmD;ENiYpD;AACF;AM5XI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AN8XR;AM7XQ;EACI,oBAAA;EACA,iBAAA;EACA,mBAAA;AN+XZ;AM9XY;EACI,cAAA;EACA,oBAAA;ANgYhB;AM3XQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eHpUG;EGqUH,cHzfD;EG0fC,aAAA;EACA,gCAAA;EACA,gBAAA;AN6XZ;AM5XY;EACI,0BAAA;AN8XhB;AM5XY;EACI,0BAAA;EACA,gBAAA;AN8XhB;AM5XY;EACI,kBAAA;EACA,qBAAA;AN8XhB;AM5XY;EACI,eHnVD;EGoVC,iBAAA;AN8XhB;AI5gCI;EEspBgB;IACI,aAAA;ENyXtB;EMtXc;IACI,wBAAA;ENwXlB;AACF;AMlXY;EACI,YAAA;ANoXhB;AMhXI;EACI,qBAAA;EACA,kBAAA;ANkXR;AMjXQ;EACI,WAAA;EFzlBV,kBE0lB2B;ANmX7B;AMjXQ;EACI,sBAAA;EACA,YAAA;EACA,WAAA;EFvnBT,SEwnBiC;EFhoBlC,kBEioB4B;EF/nB5B,QE+nB0C;EF9nB1C,YE8nB4C;EFjmB5C,kBEkmB2B;EACjB,qBAAA;EACA,mBH3sBF;AHgkCV;AMlXI;EACI,WH5rBA;EG6rBA,aAAA;EACA,YAAA;EACA,eH/XO;EGgYP,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EFvoBL,eEwoBmC;EFjpBpC,kBEkpBwB;EFjpBxB,MEipBiC;EFhpBjC,QEgpBmC;ANsXrC;AI1jCI;EEyrBA;IAaQ,cAAA;ENwXV;AACF;AMvXQ;EACI,cHluBF;EGmuBE,UAAA;ANyXZ;AMxXY;EACI,aAAA;AN0XhB;AMvXQ;EACI,UAAA;ANyXZ;AMxXY;EACI,cH/kBL;EGglBK,iBAAA;EFxpBb,eEypB2C;AN0X9C;;AMrXA;EACI,WAAA;ANwXJ;;AIzmCI;EEsvBQ;IACI,mBAAA;IACA,8BAAA;IACA,sCAAA;IACA,4BAAA;ENuXd;EMpXM;IAGI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,WAAA;IFrrBT,UEsrBuC;IAC9B,sBAAA;ENsXV;EMrXU;IACI,cAAA;IACA,iBAAA;ENuXd;EMrXU;IACI,aAAA;ENuXd;EMpXM;IACI,wBAAA;ENsXV;EMpXM;IACI,wBAAA;ENsXV;EMnXU;IACI,wBAAA;ENqXd;EMjXU;IACI,yBAAA;ENmXd;EMjXU;IACI,yBAAA;ENmXd;EMjXU;IACI,aAAA;ENmXd;EMjXU;IACI,cAAA;ENmXd;EMjXU;IACG,UAAA;ENmXb;EMjXU;IF3tBT,eE4tB2C;IAC9B,aAAA;ENmXd;EM9WU;IACI,aAAA;ENgXd;AACF;AM5WA;EACI,kBAAA;EACA,mBAAA;AN8WJ;AM7WI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBHrrBI;EGsrBJ,UAAA;AN+WR;AM3WY;EACI,WAAA;EACA,YAAA;EACA,mBHpsBJ;EGqsBI,yBAAA;EACA,eH9fD;EG+fC,kBHnhBG;EGohBH,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AN6WhB;AM5WgB;EACI,eH3gBL;EG4gBK,cHlsBT;EGmsBS,kBHjiBD;EGkiBC,iBAAA;EACA,WAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AN8WpB;AM7WoB;EACI,WHt1BhB;EGu1BgB,mBH12Bd;AHytCV;AM7WoB;EACI,WH11BhB;EG21BgB,mBHrtBb;AHokCX;AM1WQ;EACI,kBAAA;AN4WZ;AM3WY;EACI,eAAA;AN6WhB;AM3WY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eHrjBD;EGsjBC,kBH1kBG;EG2kBH,6BAAA;AN6WhB;AM3WY;EACI,cH92BR;EG+2BQ,mBHluBF;EGmuBE,yBAAA;AN6WhB;AM5WgB;EACI,WH13BZ;EG23BY,mBHn3BZ;AHiuCR;AM3WY;EACI,cHn3BL;EGo3BK,mBH3sBH;AHwjCb;AM5WgB;EACI,WHl4BZ;EGm4BY,mBHv3BT;AHquCX;AM3WY;EACI,cH55BJ;EG65BI,mBH9tBF;AH2kCd;AM5WgB;EACI,WH14BZ;EG24BY,mBHh6BR;AH8wCZ;;AMxWA;EACI,aAAA;AN2WJ;AI3vCI;EE+4BJ;IAGQ,cAAA;EN6WN;AACF;;AO7yCA;EAGI,aAAA;EACA,sBJuCI;EItCJ,aAAA;EACA,aAAA;EHyFF,eGxFoB;EHyFpB,SGzF0B;EH2F1B,SG3FoC;EH4FpC,OG5FsC;EHoFtC,yBGnFsB;EACpB,YAAA;APqzCJ;AIjxCI;EG7CJ;IAWQ,mBAAA;IHgFN,yBG/E0B;IACpB,aAAA;IACA,gBJ6BA;EH4xCN;AACF;AI3xCI;EG7CJ;IAiBQ,WAAA;EP2zCN;AACF;AO1zCI;EACI,mCAAA;AP4zCR;AInyCI;EG1BA;IAGQ,sBAAA;EP8zCV;AACF;AO5zCI;EH+ED,aG9EmC;AP8zCtC;AO7zCQ;EACI,mBAAA;AP+zCZ;AO9zCW;EACK,mBJkIJ;EIjII,kBJoTG;EInTH,aAAA;APg0ChB;AO/zCgB;EACI,WAAA;EACA,YAAA;EACA,kBJ+SD;AHkhCnB;AO/zCgB;EACI,iBAAA;EACA,SAAA;APi0CpB;AOh0CoB;EACI,eJ6TT;EI5TS,gBJhCD;EIiCC,cJ+NV;EI9NU,kBAAA;APk0CxB;AOh0CoB;EACI,eJqTT;EIpTS,gBJxCH;EIyCG,cJwNX;EIvNW,gBAAA;APk0CxB;AO5zCY;EACI,kCAAA;AP8zChB;AO1zCY;EACI,mBAAA;AP4zChB;AO1zCoB;EACI,WJvBhB;AHm1CR;AO1zCoB;EACI,cAAA;AP4zCxB;AOzzCgB;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AP2zCpB;AOzzCgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EHoBjB,kBGnB+C;EAC9B,kBAAA;EACA,cJjER;AH43CZ;AO1zCoB;EACI,cAAA;AP4zCxB;AO1zCoB;EACI,cAAA;AP4zCxB;AOzzCoB;EACI,oCAAA;EACA,cAAA;EACA,kBAAA;AP2zCxB;AO1zCwB;EACI,WJzDpB;AHq3CR;AO1zCwB;EACI,iGAAA;AP4zC5B;AO1zCwB;EACI,cAAA;AP4zC5B;AO1zCwB;EACI,mBAAA;AP4zC5B;AO3zC4B;EACI,qBAAA;AP6zChC;AOzzCoB;EACI,eJkPT;EIjPS,gBJ3GH;EI4GG,cJwDb;AHmwCX;AOvzCoB;EACI,oCAAA;EACA,kBAAA;APyzCxB;AOxzCwB;EACI,iGAAA;AP0zC5B;AOxzCwB;EACI,cAAA;AP0zC5B;AOrzCoB;EACI,aAAA;APuzCxB;AOrzC4B;EACG,gBJhIV;EIiIU,eJvId;EIwIc,kBAAA;EACA,cAAA;EHrC5B,yBGsC0D;EAC9B,kBAAA;APuzC/B;AOlzCgB;EACI,cAAA;EACA,mBAAA;APozCpB;AOnzCoB;EACI,kBAAA;EACA,kBAAA;EACA,gBAAA;APqzCxB;AOpzCwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBJzJP;EI0JO,eJkMb;EIjMa,cJQjB;EIPiB,kBAAA;EACA,WAAA;EH9DzB,YG+DuD;APszC1D;AOrzC4B;EACI,cJQrB;EIPqB,eJ6LjB;EI5LiB,mBJXpB;EIYoB,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;APuzChC;AOrzC4B;EACI,eJkLjB;EIjLiB,gBJ3KX;EI4KW,mBAAA;EACA,cJNrB;EIOqB,iBAAA;APuzChC;AOrzC4B;EACI,cJvKtB;EIwKsB,mBJjIlB;EIkIkB,kBJsJb;AHiqCnB;AOtzCgC;EACI,cJ3K1B;AHm+CV;AOtzCgC;EACI,mBJ9K1B;EI+K0B,WJxJ5B;AHg9CR;AOrzC4B;EACI,cJnLtB;AH0+CV;AOtzCgC;EACI,cJrL1B;AH6+CV;AOjzC4B;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;APmzChC;AOlzCgC;EACI,WJ1K5B;EI2K4B,mBAAA;APozCpC;AOlzCgC;EACI,cAAA;APozCpC;AO7yCgB;EACI,gBJtNG;EIuNH,eJiIL;EIhIK,cJvDT;EIwDS,kBAAA;EACA,yBAAA;AP+yCpB;AO5yCoB;EACI,aAAA;AP8yCxB;AO1yCoB;EACI,aAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;AP4yCxB;AOxyCY;EACI,kBAAA;AP0yChB;AOxyCoB;EACI,SAAA;AP0yCxB;AOxyC4B;EACI,kBAAA;EACA,eJzPf;EI0Pe,uBAAA;EACA,kBAAA;AP0yChC;AOzyCgC;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AP2yCpC;AOzyCgC;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;AP2yCpC;AOryCwB;EACI,mBJzHhB;AHg6CZ;AOtyC4B;EACI,mBJ1PzB;EI2PyB,WJhPxB;AHwhDR;AOtyC4B;EACI,uBAAA;APwyChC;AOryCwB;EACI,mBJvOd;EIwOc,kBAAA;APuyC5B;AOtyC4B;EACI,mBJjRtB;EIkRsB,WJ3PxB;AHmiDR;AOtyC4B;EACI,cJrRtB;AH6jDV;AOryCgC;EACI,+BAAA;EACA,gCAAA;APuyCpC;AO5xCY;EACI,gBAAA;AP8xChB;AO7xCgB;EACI,mBAAA;EACA,iBAAA;AP+xCpB;AOxxC4B;EACI,iBAAA;AP0xChC;AOnxCgC;EACI,iBAAA;APqxCpC;AO7wCwB;EACA,iBAAA;EACA,mBAAA;EACA,eJpVP;EIqVO,cJ7EZ;AH41CZ;AO9wCwB;EACI,WAAA;EACA,kCAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EHhO1B,mBGiO2C;EHjQ3C,kBGkQ4C;EHjQ5C,SGiQqD;EH9PrD,OG8PoE;APkxCtE;AOhxC4B;EACI,cJhVtB;AHkmDV;AOjxCgC;EACA,mBAAA;EACA,sBAAA;APmxChC;AO3wCQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,eJnBG;EIoBH,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EHhSV,kBGiS4B;EHhS5B,SGgSqC;EH/RrC,WG+R0C;EHtU1C,0BGuU6B;EHtU7B,kCGsU6B;EHrU7B,8BGqU6B;EHtS7B,yBGuS8B;APmxChC;AOlxCY;EACI,WAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;APoxChB;AOlxCY;EACI,WAAA;APoxChB;AOnxCgB;EACI,WAAA;APqxCpB;AOhxCY;EH9VV,wBG+ViC;EH9VjC,gCG8ViC;EH7VjC,4BG6ViC;EACnB,mBAAA;APoxChB;AOhxCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EH/TL,aGgUmC;EAC9B,cJnZI;EIoZJ,kBAAA;APkxCR;AOjxCQ;EACI,cJxZF;EIyZE,uBAAA;EACA,kBAAA;APmxCZ;AOlxCY;EACI,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,mBAAA;EHpVd,kBGqVgC;EHpVhC,SGoVyC;EHnVzC,QGmV8C;APsxChD;AOjxCI;EACI,YAAA;EH/SN,4CAAA;AJqkDF;AOnxCI;EACI,YAAA;EACA,YAAA;EHpWN,yBGqW0B;EACpB,aAAA;APuxCR;AI3qDI;EGgZA;IAMQ,wBAAA;EPyxCV;AACF;AOxxCQ;EACI,uBAAA;EACA,4BAAA;AP0xCZ;AIprDI;EGwZI;IAIQ,sBAAA;EP4xCd;AACF;AO1xCQ;EHpWL,uBGqWuC;AP4xC1C;AI5rDI;EG+ZI;IHpWL,aGuW0C;EP8xC3C;AACF;AO5xCQ;EACI,eJlHG;EImHH,cJvSD;EIwSC,yBAAA;EACA,gBJ1cO;EI2cP,mBAAA;AP8xCZ;AO5xCQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AP8xCZ;AO3xCoB;EACI,iEAAA;EACA,WJtbhB;AHmtDR;AO1xCgB;EACI,gBJ5dC;EI6dD,eJleH;EImeG,cJjdR;AH6uDZ;AO3xCoB;EACI,cJrdd;AHkvDV;AOxxCQ;EAGI,2BAAA;EACA,qBAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,eJ9IG;EI+IH,mCAAA;EACA,kCAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBJhfO;EC8CjB,0BGmc6B;EHlc7B,kCGkc6B;EHjc7B,8BGic6B;AP4xC/B;AO3xCY;EACI,gBAAA;AP6xChB;AOxxCI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AP0xCR;AOtxCY;EHvdV,wBGwdiC;EHvdjC,gCGudiC;EHtdjC,4BGsdiC;AP0xCnC;AOrxCQ;EAGI,aAAA;EAEA,sBAAA;EH7ZV,gBG8Z2B;EACjB,gCAAA;EHtbT,eGubuC;EHpcxC,yBGqc8B;APyxChC;AOxxCY;EACI,qCAAA;EACA,WJxfR;AHkxDR;AOxxCY;EACI,gBAAA;EACA,gBJ7hBK;AHuzDrB;AOpxCQ;EACI,WAAA;EACA,gBJriBS;EIsiBT,cAAA;EHjbV,kBGkb2B;EH1c1B,gBG2ckC;EH1clC,aG0c4C;APuxC/C;AOtxCY;EACI,iEAAA;EACA,WJ1gBR;AHkyDR;AOvxCgB;EACI,WJ5gBZ;AHqyDR;AOtxCY;EACI,iBAAA;APwxChB;;AI7zDI;EG+iBI;IACI,iBAAA;EPkxCV;EOhxCM;IACI,aAAA;EPkxCV;EO/wCU;IACI,UAAA;IACA,yBAAA;EPixCd;EOhxCc;IACG,SAAA;EPkxCjB;EO5wCc;IACI,YAAA;EP8wClB;EOxwCc;IACI,UAAA;IACA,yBAAA;EP0wClB;EOrwCkB;IACI,aAAA;EPuwCtB;EOlwCM;IACI,aAAA;EPowCV;EO7vC0B;IACI,aAAA;EP+vC9B;EO5vCsB;IACI,aAAA;EP8vC1B;EO5vCsB;IACI,eAAA;EP8vC1B;EOxvCM;IACI,WAAA;IACA,gBAAA;EP0vCV;EOvvCU;IACI,cAAA;EPyvCd;EOjvCkB;IACI,cAAA;EPmvCtB;EOhvCc;IACI,cAAA;EPkvClB;EO9uCM;IACI,cAAA;IH7jBV,yBG8jB8B;EPkvC9B;EOhvCM;IACI,YAAA;EPkvCV;EO7uC0B;IACI,qBAAA;IACA,cAAA;EP+uC9B;EO5uCsB;IACI,kBAAA;EP8uC1B;EO1uCc;IACI,cAAA;EP4uClB;EOxuCM;IACI,YAAA;EP0uCV;EOvuCE;IAGI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,WAAA;EPyuCN;AACF;AOtuCI;EACI,sBAAA;APwuCR;;AOpuCI;EACI,uBAAA;APuuCR;AOpuCQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBJ3sBS;EI4sBT,eJhXG;EIiXH,cAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;APsuCZ;AOpuCQ;EACI,aAAA;EACA,uBAAA;APsuCZ;AOhuCY;EACI,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;APkuChB;AOhuCY;EACI,kBAAA;EACA,sBAAA;APkuChB;;AO3tCI;EACI,cAAA;AP8tCR;;AO1tCI;EACI,cAAA;AP6tCR;;AO1tCA;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EHlqBF,eGmqBoB;EHlqBpB,SGkqB0B;EH/pB1B,OG+pByC;AP+tC3C;AO9tCI;EACI,cAAA;APguCR;;AO5tCI;EACI,wBAAA;AP+tCR;;AO3tCI;EACI,yBAAA;AP8tCR;;AO3tCA;EACI,yBAAA;AP8tCJ;;AOntCgC;EACI,iBAAA;APstCpC;AO/sCoC;EACI,iBAAA;APitCxC;;AOnsCQ;EACI,UAAA;EACA,SAAA;EACA,QAAA;APssCZ;;AQ5/DI;EACI,yBL8BD;AHi+DP;AQ5/DgB;EACI,yBAAA;AR8/DpB;AQ7/DoB;EACI,WLmChB;AH49DR;AQv/D4B;EACI,cLiBpB;AHw+DZ;AQl/De;EACK,+BAAA;EACA,gCAAA;ARo/DpB;;AQ5+DI;EACI,yBAAA;AR++DR;AQ5+DgB;EACI,yBAAA;AR8+DpB;AQ5+DwB;EACI,WLCpB;AH6+DR;AQ5+DwB;EACI,cAAA;AR8+D5B;AQz+Da;EACG,WLRR;AHm/DR;AQv+DoB;EACI,WLbhB;AHs/DR;AQr+D4B;EACI,WLlBxB;AHy/DR;AQr+DoC;EACI,yBAAA;ARu+DxC;AQr+DoC;EACI,cAAA;ARu+DxC;AQr+DoC;EACI,+BAAA;EACA,gCAAA;ARu+DxC;AQp+DgC;EACI,WLhC5B;AHsgER;AQ99De;EACK,4BAAA;EACA,6BAAA;ARg+DpB;;AQz9DI;EACI,yBAAA;AR49DR;AQz9DgB;EACI,yBAAA;AR29DpB;AQz9DwB;EACI,WLzDpB;AHohER;AQz9DwB;EACI,cAAA;AR29D5B;AQt9Da;EACG,WLlER;AH0hER;AQp9DoB;EACI,WLvEhB;AH6hER;AQl9D4B;EACI,WL5ExB;AHgiER;AQl9DoC;EACI,yBAAA;ARo9DxC;AQl9DoC;EACI,cAAA;ARo9DxC;AQl9DoC;EACI,+BAAA;EACA,gCAAA;ARo9DxC;AQj9DgC;EACI,WL1F5B;AH6iER;AQ38De;EACK,4BAAA;EACA,6BAAA;AR68DpB;;AQp8DI;EACI,mBAFM;EAGN,yBAAA;ARu8DR;AQt8DQ;EACI,mBAAA;EACA,qBAAA;ARw8DZ;;AQh8DQ;EACI,8BAAA;EACA,gCAAA;ARm8DZ;AQz7DgC;EACI,cAhBtB;EAiBsB,mBAhBhB;AR28DpB;AQ17DqC;EACG,cAnB1B;AR+8Dd;AQ17DoC;EACI,mBAtB1B;ARk9Dd;AQz7DgC;EACI,cA1BtB;ARq9Dd;AQ17DoC;EACI,cA5B1B;ARw9Dd;AQr7DwB;EACI,mBAnCR;AR09DpB;AQl7DgC;EACI,uBAAA;ARo7DpC;AQh7DwB;EACI,uBAAA;EACA,cAhDd;ARk+Dd;AQj7D4B;EACI,mBAlDlB;ARq+Dd;AQj7D4B;EACI,cArDlB;ARw+Dd;AQj7D4B;EACI,+BAAA;EACA,gCAAA;ARm7DhC;AQ16DI;EACI,mBAnEM;AR++Dd;AQ16DI;EACI,mBAtEM;ARk/Dd;AQ16DI;EACI,cAzEM;EA0EN,gCAAA;AR46DR;AQ16DI;;;EAGI,mBA/EM;EAgFN,qBAhFM;AR4/Dd;AQ16DI;EACI,qBAnFM;EAoFN,yBApFM;ARggEd;AQ16DI;EACI,mBAvFM;ARmgEd;AQ16DI;EACI,cA1FM;EA2FN,qBA3FM;ARugEd;AQ16DI;EACI,mBA9FM;EA+FN,qBA/FM;AR2gEd;AQ16DI;EACI,mBAlGM;EAmGN,yBAAA;AR46DR;AQ16DI;EACI,mBAtGM;EAuGN,WL9NA;AH0oER;AQ16DI;;EAEI,mBA3GM;ARuhEd;AQ16DI;EACI,yBA9GM;EA+GN,yBAAA;AR46DR;AQ16DI;EACI,yBAlHM;EAmHN,qBAnHM;AR+hEd;AQ16DI;EACI,cAtHM;ARkiEd;AQ16DI;EACI,oCAAA;EACA,yBAAA;AR46DR;;AQp6DQ;EACI,8BAAA;EACA,gCAAA;ARu6DZ;AQ75DgC;EACI,cAhBtB;EAiBsB,mBAhBhB;AR+6DpB;AQ95DqC;EACG,cAnB1B;ARm7Dd;AQ95DoC;EACI,mBAtB1B;ARs7Dd;AQ75DgC;EACI,cA1BtB;ARy7Dd;AQ95DoC;EACI,cA5B1B;AR47Dd;AQz5DwB;EACI,mBAnCR;AR87DpB;AQt5DgC;EACI,uBAAA;ARw5DpC;AQp5DwB;EACI,uBAAA;EACA,cAhDd;ARs8Dd;AQr5D4B;EACI,mBAlDlB;ARy8Dd;AQr5D4B;EACI,cArDlB;AR48Dd;AQr5D4B;EACI,+BAAA;EACA,gCAAA;ARu5DhC;AQ94DI;EACI,mBAnEM;ARm9Dd;AQ94DI;EACI,mBAtEM;ARs9Dd;AQ94DI;EACI,cAzEM;EA0EN,gCAAA;ARg5DR;AQ94DI;;;EAGI,mBA/EM;EAgFN,qBAhFM;ARg+Dd;AQ94DI;EACI,qBAnFM;EAoFN,yBApFM;ARo+Dd;AQ94DI;EACI,mBAvFM;ARu+Dd;AQ94DI;EACI,cA1FM;EA2FN,qBA3FM;AR2+Dd;AQ94DI;EACI,mBA9FM;EA+FN,qBA/FM;AR++Dd;AQ94DI;EACI,mBAlGM;EAmGN,yBAAA;ARg5DR;AQ94DI;EACI,mBAtGM;EAuGN,WL7VA;AH6uER;AQ94DI;;EAEI,mBA3GM;AR2/Dd;AQ94DI;EACI,yBA9GM;EA+GN,yBAAA;ARg5DR;AQ94DI;EACI,yBAlHM;EAmHN,qBAnHM;ARmgEd;AQ94DI;EACI,cAtHM;ARsgEd;AQ94DI;EACI,oCAAA;EACA,yBAAA;ARg5DR;;AQz4DQ;EACI,8BAAA;EACA,gCAAA;AR44DZ;AQl4DgC;EACI,cAhBtB;EAiBsB,mBAhBhB;ARo5DpB;AQn4DqC;EACG,cAnB1B;ARw5Dd;AQn4DoC;EACI,mBAtB1B;AR25Dd;AQl4DgC;EACI,cA1BtB;AR85Dd;AQn4DoC;EACI,cA5B1B;ARi6Dd;AQ93DwB;EACI,mBAnCR;ARm6DpB;AQ33DgC;EACI,uBAAA;AR63DpC;AQz3DwB;EACI,uBAAA;EACA,cAhDd;AR26Dd;AQ13D4B;EACI,mBAlDlB;AR86Dd;AQ13D4B;EACI,cArDlB;ARi7Dd;AQ13D4B;EACI,+BAAA;EACA,gCAAA;AR43DhC;AQn3DI;EACI,mBAnEM;ARw7Dd;AQn3DI;EACI,mBAtEM;AR27Dd;AQn3DI;EACI,cAzEM;EA0EN,gCAAA;ARq3DR;AQn3DI;;;EAGI,mBA/EM;EAgFN,qBAhFM;ARq8Dd;AQn3DI;EACI,qBAnFM;EAoFN,yBApFM;ARy8Dd;AQn3DI;EACI,mBAvFM;AR48Dd;AQn3DI;EACI,cA1FM;EA2FN,qBA3FM;ARg9Dd;AQn3DI;EACI,mBA9FM;EA+FN,qBA/FM;ARo9Dd;AQn3DI;EACI,mBAlGM;EAmGN,yBAAA;ARq3DR;AQn3DI;EACI,mBAtGM;EAuGN,WL3dA;AHg1ER;AQn3DI;;EAEI,mBA3GM;ARg+Dd;AQn3DI;EACI,yBA9GM;EA+GN,yBAAA;ARq3DR;AQn3DI;EACI,yBAlHM;EAmHN,qBAnHM;ARw+Dd;AQn3DI;EACI,cAtHM;AR2+Dd;AQn3DI;EACI,oCAAA;EACA,yBAAA;ARq3DR;;AQh3DI;EACI,yBL/fD;EKggBC,cL9fI;AHi3EZ;AQj3DI;EACI,WLxfA;AH22ER;AQj3DI;EACI,yBLtgBD;AHy3EP;AQl3DQ;EACI,yBLxgBL;AH43EP;AQl3DgB;EACI,aAAA;ARo3DpB;AQn3DoB;EACI,cAAA;ARq3DxB;AQj3DY;EACI,WLvgBR;AH03ER;AQh3DQ;EACI,yBLthBL;EKuhBK,gBAAA;ARk3DZ;AQj3DY;EACI,WL9gBR;AHi4ER;AQj3DY;EACI,qBL3hBF;AH84Ed;AQl3DgB;EACI,WLnhBZ;AHu4ER;AQ/2DQ;EACI,qBLniBE;AHo5Ed;AQ72DgB;EACI,gCAAA;AR+2DpB;AQ92DoB;EACI,WLhiBhB;AHg5ER;AQ92DoB;EACI,WLniBhB;AHm5ER;AQ92DoB;EACI,WLtiBhB;AHs5ER;AQ52D4B;EACI,yBAAA;AR82DhC;AQ12D4B;EACI,WLhjBxB;AH45ER;AQ12D4B;EACI,cL3jBf;AHu6EjB;AQx2DoB;EACI,eLhQT;EKiQS,iBAAA;EACA,cLvbb;AHiyEX;AQr2DY;EACI,mBL3kBT;AHk7EP;AQn2DY;EACI,qBL/kBF;EKglBE,uBAAA;ARq2DhB;AQn2DY;EACI,cLjlBC;AHs7EjB;AQ/1DoB;EACI,uBAAA;EACA,kBLzSL;AH0oEnB;AQh2DwB;EACI,uBAAA;ARk2D5B;AQ/1D4B;EACI,WLvlBxB;AHw7ER;AQ91DgC;EACI,WL3lB5B;EK4lB4B,gBAAA;ARg2DpC;AQ91DgC;EACI,gBLjoBf;EKkoBe,cLxmBnB;AHw8EjB;AQv1DI;EACI,yBLrnBD;AH88EP;AQt1DgB;EACI,yBAAA;ARw1DpB;AQv1DoB;EACI,WLhnBhB;AHy8ER;AQj1D4B;EACI,cLloBpB;AHq9EZ;AQ50De;EACK,+BAAA;EACA,gCAAA;AR80DpB;AQz0DI;EACI,mBAAA;EACA,WLzoBA;AHo9ER;AQz0DI;EACI,mBAAA;EACA,qBAAA;EACA,WL9oBA;AHy9ER;AQz0DI;EACI,WLjpBA;AH49ER;AQz0DI;EACI,mBL/pBD;AH0+EP;AQ10DQ;EACI,qBLhqBE;AH4+Ed;AQ30DY;EACI,WLxpBR;AHq+ER;AQ10DQ;EACI,mBLhqBF;EKiqBE,qBLvqBE;AHm/Ed;AQ30DY;EACI,qBLzqBF;AHs/Ed;AQ50DgB;EACI,WLjqBZ;AH++ER;AQ10DQ;EACI,qBLhrBE;EKirBF,mBLlrBL;AH8/EP;AQ30DY;EACI,qBLnrBF;AHggFd;AQz0DI;;;EAGI,cLzrBI;AHogFZ;AQx0DQ;EACI,uBAAA;AR00DZ;AQt0DQ;EACI,cLlsBA;AH0gFZ;AQr0DI;;;EAGI,qBLzsBM;EK0sBN,gBAAA;EACA,yBAAA;EACA,cL3sBI;AHkhFZ;AQt0DQ;;;EACI,cL7sBA;AHuhFZ;AQt0DQ;EACI,qBLntBE;EKotBF,yBAAA;EACA,cLptBA;EKqtBA,gBAAA;ARw0DZ;AQl0DgB;EACI,cL5tBR;AHgiFZ;AQ9zDQ;EACI,qBLpuBE;AHoiFd;AQ5zDQ;EACI,qBLzuBE;EK0uBF,yBAAA;EACA,cL1uBA;EK2uBA,gBAAA;AR8zDZ;AQ3zDI;;EAEI,cLhvBI;AH6iFZ;AQ1zDQ;EACI,qBLrvBE;EKsvBF,yBAAA;EACA,cLtvBA;AHkjFZ;AQzzDI;;EAEI,qBL5vBM;EK6vBN,gBAAA;EACA,yBAAA;EACA,cL9vBI;AHyjFZ;AQzzDI;EACI,qBLlwBM;AH6jFd;AQzzDI;EACI,yBAAA;AR2zDR;AQzzDI;EACI,qBLxwBM;EKywBN,mBL1wBD;EK2wBC,gBAAA;EACA,cL1wBI;AHqkFZ;AQxzDQ;EACI,kBLrwBJ;EKswBI,WLtwBJ;AHgkFR;AQvzDI;EACI,yBAAA;ARyzDR;AQtzDQ;EACI,qBLxxBE;EKyxBF,mBL1xBL;EK2xBK,gBAAA;ARwzDZ;AQvzDY;EACI,gBAAA;EACA,yBAAA;EACA,mBL/xBT;EKgyBS,cL9xBJ;AHulFZ;AQvzDY;EACI,gBAAA;ARyzDhB;AQrzDI;;;EAGI,qBLzyBM;EK0yBN,mBL3yBD;AHkmFP;AQpzDQ;EACI,cL7yBA;AHmmFZ;AQrzDY;EACI,cL/yBJ;AHsmFZ;AQpzDQ;EACI,qBLpzBE;AH0mFd;AQnzDI;EACI,mBLzzBD;EK0zBC,qBLzzBM;AH8mFd;AQnzDI;;;;;;;;;EAUI,qBLr0BM;EKs0BN,mBLv0BD;EKw0BC,gBAAA;ARozDR;AQlzDI;EACI,yBLp0BE;EKq0BF,gBAAA;ARozDR;AQjzDQ;EACI,qBL/0BE;EKg1BF,cL/0BA;AHkoFZ;AQhzDI;EACI,qBLp1BM;AHsoFd;AQ9yDY;EACI,cLx1BJ;EKy1BI,gBAAA;ARgzDhB;AQ9yDY;EACI,cL51BJ;EK61BI,qBL91BF;AH8oFd;AQ5yDI;EACI,gBAAA;AR8yDR;AQ5yDI;EACI,cLr2BI;EKs2BJ,qBLv2BM;EKw2BN,mBLz2BD;EK02BC,gBAAA;AR8yDR;AQzyDwB;EACI,WLr2BpB;AHgpFR;AQlyDoB;EACI,cLx3BZ;AH4pFZ;AQ/xDQ;EACI,qBL/3BE;AHgqFd;AQ9xDI;EACI,qBLn4BM;AHmqFd;AQ7xDQ;EACI,cLt4BA;EKu4BA,qBLx4BE;EKy4BF,mBL14BL;AHyqFP;AQ7xDQ;EACI,cL34BA;EK44BA,qBL74BE;EK84BF,mBL/4BL;AH8qFP;AQ5xDI;EACI,cLj5BI;EKk5BJ,qBLn5BM;EKo5BN,mBLr5BD;AHmrFP;AQxxDoB;EACI,cL15BZ;AHorFZ;AQpxDI;EACI,cLj6BI;EKk6BJ,qBLn6BM;EKo6BN,mBLr6BD;AH2rFP;AQpxDI;EACI,cLt6BI;EKu6BJ,mBAAA;ARsxDR;AQpxDI;EACI,yBAAA;ARsxDR;AQpxDI;EACI,cL76BI;AHmsFZ;AQpxDI;EACI,qBLj7BM;AHusFd;AQpxDI;EACI,qBLp7BM;AH0sFd;AQpxDI;EACI,mBLp8BE;EKq8BF,WL96BA;AHosFR;AQpxDI;EACI,uBAAA;ARsxDR;AQpxDI;EACI,qBL97BM;EK+7BN,mBLh8BD;AHstFP;AQnxDY;EACI,WLz7BR;AH8sFR;AQjxDI;EACI,yBAAA;ARmxDR;AQjxDI;EACI,mBAAA;ARmxDR;AQjxDY;EACI,WLp8BR;AHutFR;AQjxDY;EACI,WLv8BR;AH0tFR;AQjxDY;EACI,qBLp9BF;EKq9BE,uBAAA;EACA,WL58BR;AH+tFR;AQhxDQ;EACI,WLh9BJ;AHkuFR;AQ/wDI;EACI,WLp9BA;AHquFR;AQ/wDI;EACI,qBLj+BM;EKk+BN,mBLn+BD;AHovFP;AQhxDQ;EACI,qBLp+BE;EKq+BF,mBAAA;ARkxDZ;AQ/wDI;EACI,qBLz+BM;EK0+BN,mBAAA;ARixDR;AQ/wDI;EACI,qBL7+BM;AH8vFd;AQ/wDI;EACI,mBL1+BE;EK2+BF,gBAAA;ARixDR;AQhxDQ;EACI,8BAAA;ARkxDZ;AQhxDQ;EACI,mBAAA;EACA,gBAAA;ARkxDZ;AQhxDQ;EACI,mBAAA;ARkxDZ;AQjxDY;EACI,qBL5/BF;AH+wFd;AQjxDY;EACI,qBL//BF;AHkxFd;AQhxDQ;EACI,qBLngCE;AHqxFd;AQjxDY;EACI,WL3/BR;AH8wFR;AQjxDY;EACI,cLvgCJ;AH0xFZ;AQhxDQ;EACI,cL3gCA;AH6xFZ;AQ/wDI;EACI,cL/gCI;AHgyFZ;AQ9wDQ;EACI,qBLphCE;AHoyFd;AQ7wDI;EACI,mBLzhCD;EK0hCC,qBLzhCM;EK0hCN,cLzhCI;AHwyFZ;AQ9wDQ;EACI,mBL7hCL;EK8hCK,qBL7hCE;EK8hCF,cL7hCA;AH6yFZ;AQ7wDI;EACI,mBLniCD;AHkzFP;AQ7wDI;EACI,mBLtiCD;EKuiCC,qBLtiCM;EKuiCN,cLtiCI;AHqzFZ;AQ7wDI;EACI,qBL1iCM;AHyzFd;AQ5wDQ;EACI,mBL/iCL;EKgjCK,qBL/iCE;EKgjCF,WLtiCJ;AHozFR;AQ7wDY;EACQ,mBL7iCP;EK8iCO,WLziCZ;AHwzFR;AQ9wDoB;EACI,WL3iChB;AH2zFR;AQ1wDQ;EACI,qBL7jCL;AHy0FP;AQtwDY;EACI,mBLpkCT;AH40FP;AQtwDa;EACG,qBLtkCF;AH80Fd;AQvwDiB;EACG,qBLxkCN;AHi1Fd;AQxwDoB;EACI,mBL3kCjB;EK4kCiB,WLjkChB;EKkkCgB,qBL5kCV;AHs1Fd;AQpwDoB;EACI,mBLplCjB;EKqlCiB,cLllCP;EKmlCO,qBLrlCV;AH21Fd;AQlwDY;EACI,qBL1lCF;AH81Fd;AQnwDgB;EACI,qBL5lCN;AHi2Fd;AQpwDoB;EACI,qBL9lCV;AHo2Fd;AQrwDwB;EACI,mBLjmCrB;EKkmCqB,WLvlCpB;EKwlCoB,qBLlmCd;AHy2Fd;AQjwDwB;EACI,mBL1mCrB;EK2mCqB,cLxmCX;EKymCW,qBL3mCd;AH82Fd;AQ1vDY;EACI,cAAA;AR4vDhB;AQ9vDQ;EAII,WL7mCJ;AH02FR;AQ1vDY;EACI,WLjnCR;EKknCQ,yBAAA;EACA,gBAAA;EACA,mBAAA;AR4vDhB;AQ3vDgB;EACI,gCAAA;EACA,+BAAA;AR6vDpB;AQ1vDY;EACI,qBLroCF;EKsoCE,mBLvoCT;AHm4FP;AQ3vDgB;EACI,uBAAA;EACA,WL/nCZ;AH43FR;AQxvDI;;;EAGI,qBLjpCM;AH24Fd;AQxvDI;EACI,qBLppCM;EKqpCN,mBLtpCD;EKupCC,cLrpCI;EKspCJ,gBAAA;AR0vDR;AQzvDQ;EACI,qBLzpCE;EK0pCF,mBL3pCL;EK4pCK,cL1pCA;AHq5FZ;AQzvDQ;EACI,qBL9pCE;EK+pCF,mBLhqCL;EKiqCK,cL/pCA;AH05FZ;AQxvDI;EACI,mBLpqCM;EKqqCN,cLpqCI;EKqqCJ,qBLtqCM;AHg6Fd;AQvvDQ;EACI,cLzqCA;AHk6FZ;AQtvDI;EACI,ULpqCA;AH45FR;AQtvDI;EACI,WLvqCA;AH+5FR;AQvvDQ;EACI,cLhsCF;AHy7FV;AQtvDI;EACI,qBLvrCM;AH+6Fd;AQtvDI;EACI,qBL1rCM;AHk7Fd;AQtvDI;EACI,qBL7rCM;AHq7Fd;AQnvDgB;EACI,cLjsCH;AHs7FjB;AQpvDoB;EACI,WL3rChB;AHi7FR;AQpvDoB;EACI,mBLpsCP;EKqsCO,WL/rChB;AHq7FR;AQ/uDQ;EACI,yBL5sCC;EK6sCD,qBLltCE;EKmtCF,WLzsCJ;AH07FR;AQhvDY;EACI,+DLltCH;EKmtCG,qBLttCF;EKutCE,WL7sCR;AH+7FR;AQ7uDI;EACI,qBL7tCM;EK8tCN,mBLxtCE;AHu8FV;AQ7uDY;EACI,WLvtCR;AHs8FR;AQvuDoB;EACI,WLhuChB;AHy8FR;AQhuDgB;EACI,WL1uCZ;AH48FR;AQ7tDI;EACI,mBLnvCE;EKovCF,qBLpvCE;AHm9FV;AQ7tDY;EACI,WLpvCR;AHm9FR;AQ3tDI;EACI,mBL5vCE;EK6vCF,qBLpwCM;AHi+Fd;AQ3tDY;EACI,WL7vCR;AH09FR;AQztDI;EACI,sBAAA;AR2tDR;AQxtDQ;EACI,mBLjxCL;EKkxCK,qBLjxCE;AH2+Fd;AQztDY;EACI,WLzwCR;AHo+FR;AQvtDI;EACI,WL9wCA;AHu+FR;AQvtDI;EACI,sBAAA;ARytDR;AQttDQ;EACI,qBL/xCE;EKgyCF,WLtxCJ;AH8+FR;AQptDQ;EACI,mBL/xCF;EKgyCE,qBLtyCE;AH4/Fd;AQrtDY;EACK,qBLxyCH;AH+/Fd;AQrtDY;EACI,WLjyCR;AHw/FR;AQntDI;EACI,qBLhzCM;AHqgGd;AQntDI;EACI,qBLnzCM;EKozCN,mBLrzCD;AH0gGP;AQltDQ;EACI,mBLzzCL;AH6gGP;AQjtDI;EACI,mBLtzCE;EKuzCF,qBL7zCM;AHghGd;AQhtDQ;EACI,cL/zCK;AHihGjB;AQjtDY;EACI,mBL/zCC;EKg0CD,WL1zCR;AH6gGR;AQ/sDI;EACI,mBLp0CK;EKq0CL,qBL10CM;EK20CN,WLj0CA;AHkhGR;AQ7sDY;EACI,mBL30CH;EK40CG,qBLj1CF;AHgiGd;AQ9sDgB;EACI,mBL90CP;EK+0CO,WL10CZ;AH0hGR;AQ/sDoB;EACI,WL50ChB;AH6hGR;AQ3sDI;EACI,mBLt1CE;EKu1CF,qBL91CM;AH2iGd;AQ1sDgB;EACI,WLx1CZ;AHoiGR;AQ1sDgB;EACI,mBLr2CN;AHijGd;AQxsDQ;EACK,qBL12CC;AHojGd;AQvsDI;EACI,mBLv2CE;EKw2CF,qBL/2CM;AHwjGd;AQvsDY;EACI,yBL32CN;AHojGV;AQpsDgB;EACI,mBLn3CP;AHyjGb;AQ/rDY;EACI,qBLh4CF;EKi4CE,mBL53CH;EK63CG,gBAAA;ARisDhB;AQ3rDY;EACI,mBLn4CN;EKo4CM,qBL14CF;AHukGd;AQzrDY;EACI,cL74CC;AHwkGjB;AQvrDI;EACI,mBL74CE;EK84CF,qBLr5CM;AH8kGd;AQvrDY;EACK,mBLj5CP;EKk5CO,qBLz5CH;AHklGd;AQxrDiB;EACG,mBLp5CV;EKq5CU,qBL55CN;AHslGd;AQprDQ;EACI,cLj6CK;AHulGjB;AQrrDY;EACI,mBL95CN;EK+5CM,WL55CR;AHmlGR;AQlrDQ;EACI,6BAAA;ARorDZ;AQnrDY;EACI,mBL16CC;EK26CD,cL76CC;AHkmGjB;AQlrDQ;EACI,mBL/6CK;EKg7CL,cLl7CK;AHsmGjB;AQjrDI;EACI,qBLx7CM;AH2mGd;AQjrDa;EACG,mBLp7CN;EKq7CM,WLl7CR;AHqmGR;AQ/qDI;EACI,mBL77CS;AH8mGjB;AQ/qDI;EACI,cLl8CS;AHmnGjB;AQhrDS;EACG,mBL/7CF;EKg8CE,WL77CJ;AH+mGR;AQ/qDI;EACI,qBL38CM;AH4nGd;AQ9qDQ;EACI,qBL/8CE;AH+nGd;AQ5qDI;;EAEI,qBLr9CM;AHmoGd;AQ5qDI;;;EAGI,mBLt9CS;EKu9CT,qBL39CM;AHyoGd;AQ5qDI;EACI,sBAAA;AR8qDR;AQ5qDI;EACI,qBLj+CM;AH+oGd;AQ7qDQ;EACI,mBL59CF;AH2oGV;AQ9qDY;EACI,mBL99CN;EK+9CM,qBLt+CF;AHspGd;AQ3qDI;EACI,qBL5+CM;EK6+CN,WLn+CA;AHgpGR;AQ3qDI;EACI,qBLh/CM;AH6pGd;AQ3qDI;EACI,qBLn/CM;EKo/CN,cLl/CS;AH+pGjB;AQ3qDI;EACI,cLr/CS;AHkqGjB;AQ3qDI;EACI,qBL1/CM;AHuqGd;AQ5qDQ;EACI,WLl/CJ;AHgqGR;AQ3qDI;EACI,mBLz/CE;EK0/CF,qBLjgDM;AH8qGd;AQ5qDQ;EACI,cLjgDK;AH+qGjB;AQ5qDQ;EACI,qBLtgDE;AHorGd;AQ7qDY;EACI,qBLxgDF;AHurGd;AQ3qDI;EACI,mBLtgDE;AHmrGV;AQ1qDgB;EACI,yBAAA;AR4qDpB;AQ3qDoB;EACI,cLhiDd;AH6sGV;AQ3qDoB;EACK,qBLthDX;AHmsGd;AQvqDI;EACI,mBLthDE;EKuhDF,qBL9hDM;EK+hDN,cL7hDS;AHssGjB;AQvqDI;;EAEI,WLzhDA;AHksGR;AQtqDQ;EACI,yBLhiDF;AHwsGV;AQvqDY;EACI,yBLniDN;EKoiDM,qBL1iDF;AHmtGd;AQrqDI;EACI,mBLxiDE;AH+sGV;AQrqDI;EACI,mBL3iDE;EK4iDF,qBLnjDM;AH0tGd;AQrqDI;EACI,qBLtjDM;AH6tGd;AQrqDI;EACI,cL/0CM;AHs/Fd;AQrqDI;EACI,qBL5jDM;EK6jDN,cL3jDS;AHkuGjB;AQrqDI;EACI,6BAAA;ARuqDR;AQrqDI;EACI,qBLnkDM;AH0uGd;AQrqDI;EACI,yBLhkDE;AHuuGV;AQtqDQ;EACI,uBAAA;ARwqDZ;AQtqDgB;EACI,WLjkDZ;AHyuGR;AQnqDI;EACI,mBL1kDE;AH+uGV;AQpqDQ;EACI,WLzkDJ;AH+uGR;AQnqDI;EACI,mBLhlDE;AHqvGV;AQpqDQ;EACI,qBLzlDE;AH+vGd;AQrqDY;EACI,WLjlDR;AHwvGR;AQlqDQ;EACI,mBLlmDL;EKmmDK,WLxlDJ;AH4vGR;AQnqDY;EACI,qBLpmDF;AHywGd;AQjqDY;EACI,qBLzmDF;AH4wGd;AQ9pDQ;EACI,mBL1mDC;EK2mDD,qBLhnDE;EKinDF,WLvmDJ;AHuwGR;AQ7pDI;EACI,mBLrnDM;AHoxGd;AQ7pDI;EACI,qBLxnDM;AHuxGd;AQ9pDQ;EACI,WLhnDJ;AHgxGR;AQ7pDI;EACI,mBLznDK;EK0nDL,qBL/nDM;EKgoDN,WLtnDA;AHqxGR;AQ7pDI;EACI,gBAAA;AR+pDR;AQ9pDQ;EACI,cLnoDK;EKooDL,qBLtoDE;AHsyGd;AQ7pDI;EACI,qBL1oDM;AHyyGd;AQ7pDI;EACI,qBL7oDM;AH4yGd;AQ5pDQ;EACI,WLvoDJ;AHqyGR;AQ3pDI;EACI,WL3oDA;AHwyGR;AQ3pDI;EACI,yBLjpDE;EKkpDF,qBLzpDM;AHszGd;AQ5pDQ;EACI,qBL3pDE;AHyzGd;AQ7pDY;EACI,WLnpDR;AHkzGR;AQ5pDQ;EACI,WLvpDJ;AHqzGR;AQ5pDQ;EACI,yBL9pDF;AH4zGV;AQ7pDY;EACI,qBLtqDF;AHq0Gd;AQ9pDgB;EACI,WL9pDZ;AH8zGR;AQ7pDY;EACI,WLlqDR;AHi0GR;AQ3pDI;EACI,qBLjrDM;AH80Gd;AQ3pDI;EACI,yBL7qDE;AH00GV;AQ5pDQ;EACI,qBLtrDE;AHo1Gd;AQ5pDQ;EACI,qBLzrDE;AHu1Gd;AQ3pDI;EACI,yBLtrDE;EKurDF,qBL9rDM;EK+rDN,gBAAA;AR6pDR;AQ3pDI;EACI,yBL3rDE;EK4rDF,qBLnsDM;AHg2Gd;AQ5pDQ;EACI,cLnsDK;AHi2GjB;AQ3pDI;EACI,yBLlsDE;EKmsDF,qBL1sDM;AHu2Gd;AQ1pDQ;EACI,yBLvsDF;EKwsDE,gBAAA;AR4pDZ;AQ1pDQ;EACI,qBLltDE;AH82Gd;AQ1pDQ;EACI,qBLrtDE;AHi3Gd;AQzpDI;EACI,yBLltDE;AH62GV;AQzpDI;EACI,qBL5tDM;EK6tDN,yBLttDE;AHi3GV;AQzpDI;EACI,uBAAA;AR2pDR;AQzpDI;EACI,yBL5tDE;AHu3GV;AQzpDI;EACI,yBL/tDE;AH03GV;AQzpDI;EACI,yBLluDE;EKmuDF,qBL1uDM;EK2uDN,gBAAA;AR2pDR;AQzpDI;EACI,yBLvuDE;AHk4GV;AQzpDI;EACI,yBL1uDE;EK2uDF,qBLlvDM;AH64Gd;AQzpDI;EACI,WL3uDA;AHs4GR;AQxpDQ;EACI,WL/uDJ;AHy4GR;AQxpDQ;EACI,cL1vDK;AHo5GjB;AQvpDI;EACI,WLtvDA;AH+4GR;AQvpDI;EACI,yBAAA;ARypDR;AQvpDI;EACI,WL5vDA;AHq5GR;AQvpDI;EACI,qBLzwDM;AHk6Gd;AQvpDI;EACK,cL1wDQ;AHm6GjB;AQvpDI;EACI,yBLxwDE;EKywDF,qBLhxDM;AHy6Gd;AQxpDQ;EACI,qBLlxDE;AH46Gd;AQxpDQ;EACI,qBLrxDE;AH+6Gd;AQzpDY;EACI,cLrxDC;AHg7GjB;;AQppDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARupDR;AQtpDQ;EACI,qCAAA;ARwpDZ;;AQlpDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARqpDR;AQppDQ;EACI,qCAAA;ARspDZ;;AQhpDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARmpDR;AQlpDQ;EACI,qCAAA;ARopDZ;;AQ9oDI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;ARipDR;AQhpDQ;EACI,qCAAA;ARkpDZ;;AQ7oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,qBLr1DM;EKs1DN,cLp1DS;AHo+GjB;AQ9oDI;EACI,mBL11DD;EK21DC,qBL11DM;AH0+Gd;AQ9oDI;EACI,8BAAA;ARgpDR;AQ9oDI;EACI,mBL31DK;AH2+Gb;AQ9oDI;EACI,mBL91DK;AH8+Gb;AQ9oDI;EACI,mBLv2DD;AHu/GP;AQ9oDI;EACI,uBAAA;ARgpDR;AQ9oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,gCAAA;ARgpDR;AQ9oDI;EACI,gCAAA;EACA,WL/2DA;AH+/GR;AQ7oDQ;EACI,WLn3DJ;AHkgHR;;AS7iHA;EACI,eAAA;EACA,OAAA;EACA,aAAA;EACC,2BAAA;EACD,YAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;ATgjHJ;AS/iHI;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;EACA,8BAAA;ATijHR;AShjHQ;EAEI,qCAAA;ATkjHZ;;AS7iHA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;ATgjHJ;;AS9iHA;EACI,WAAA;ATijHJ;;AS/iHA;EACI,eAAA;EACA,aAAA;EACA,MAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;ATkjHJ;ASjjHI;EACI,QAAA;ATmjHR;ASjjHI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,gCAAA;ATmjHR;ASljHQ;EACI,cNgHD;EM/GC,eAAA;ATojHZ;ASjjHI;EACI,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;ATmjHR;ASljHQ;EACI,gCAAA;EACA,mBAAA;ATojHZ;ASnjHY;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;ATqjHhB;ASjjHI;EACI,mBN0EI;EMzEJ,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;ATmjHR;ASljHQ;EACI,aAAA;ATojHZ;AShjHwB;EACI,yBNtDnB;EMuDmB,qBNvDnB;EMwDmB,WAAA;ATkjH5B;AShjHwB;EACI,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;ATkjH5B;AS5iHQ;EACI,YAAA;AT8iHZ;AS5iHQ;EACI,kBAAA;EACA,WAAA;EACA,cAAA;AT8iHZ;AS7iHY;EACI,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AT+iHhB;;AS1iHA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,MAAA;EACA,WAAA;EACA,cAAA;AT6iHJ;AS5iHI;EACI,OAAA;AT8iHR;;AS3iHA;EACI,cAAA;AT8iHJ;AS7iHI;EACI,aAAA;EACA,mBAAA;AT+iHR;AS5iHgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AT8iHpB;AS7iHoB;EACI,mBN/Id;AH8rHV;AS7iHoB;EACI,mBNhJZ;AH+rHZ;AS7iHoB;EACI,mBAAA;AT+iHxB;AS7iHoB;EACI,mBAAA;AT+iHxB;AS5iHgB;EACI,aAAA;AT8iHpB;AS3iH4B;EACI,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;AT6iHhC;ASviHY;EACI,iBAAA;ATyiHhB;;ASpiHA;EACI,gBAAA;ATuiHJ;AStiHI;EACI,aAAA;EACA,mBAAA;ATwiHR;ASviHQ;EACI,UAAA;ATyiHZ;ASxiHY;EACI,iBAAA;AT0iHhB;ASxiHY;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AT0iHhB;ASxiHY;EACI,mBN1DJ;EM2DI,yBAAA;EACA,cN7CL;AHulHX;ASziHgB;EACI,mBN1DR;AHqmHZ;ASxiHY;EACI,mBNjLR;EMkLQ,WAAA;AT0iHhB;ASziHgB;EACI,mBAAA;AT2iHpB;;AUlxHA;ENwGG,aMvG+B;EAC9B,gCAAA;AVqxHJ;AUpxHI;EACI,ePoWO;EOnWP,gBPMe;EOLf,WPsCA;EOrCA,gBAAA;AVsxHR;;AUlxHI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AVqxHR;AUnxHI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AVqxHR;AUpxHQ;EACI,aAAA;EACA,gCAAA;EACA,ePpBK;AH0yHjB;AUrxHY;EACI,gBAAA;AVuxHhB;AUrxHY;EACI,cAAA;EN2Eb,aM1E2C;AVuxH9C;AUrxHY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBP+SG;EO9SH,kBAAA;AVuxHhB;AUtxHgB;EACI,kBP4SD;AH4+GnB;AUtxHgB;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AVwxHpB;AUrxHY;EACI,cP8HL;EO7HK,gBPzCK;AHg0HrB;AUrxHY;EACI,gBP5CK;EO6CL,cPqHL;ECrER,eM/CqC;AVuxHxC;AUrxHY;EACI,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,cP4GL;EO3GK,kBAAA;ENsCb,eMrCqC;ENsCrC,mBMtC8C;AVwxHjD;AUvxHgB;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,UAAA;EACA,8BAAA;EACA,mBPmGT;EOlGS,kBPyQD;AHghHnB;AUtxHY;EACI,ePqRD;EOpRC,cPkGL;EC1ER,SMvBqC;AVwxHxC;AUtxHY;EAGI,oBAAA;EAGA,mBAAA;EACA,yBAAA;EACA,kBPyPG;EOxPH,aAAA;EACA,kBAAA;AVwxHhB;AUvxHgB;EACI,kBAAA;AVyxHpB;AUxxHoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,cPrFd;EOsFc,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBPqOL;AHqjHnB;AUvxHgB;EACI,mBAAA;AVyxHpB;AUxxHoB;EACI,eP+OT;EO9OS,cP4Db;EO3Da,gBAAA;AV0xHxB;AUxxHoB;EACI,eP0OT;EOzOS,cPgJX;AH0oHb;AUtxHY;EACI,ePoOD;EOnOC,iBAAA;EACA,cP6CL;AH2uHX;AUtxHY;EACI,SAAA;EACA,UAAA;EACA,kBAAA;AVwxHhB;AUvxHgB;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AVyxHpB;AUvxHgB;ENpCb,mBMqC+C;AVyxHlD;AUxxHoB;EACI,cPiCb;EOhCa,WAAA;EACA,gBPvIH;EOwIG,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AV0xHxB;AUxxHoB;EACI,cPoBb;EOnBa,YAAA;EACA,ePsMT;AHolHf;AUxxHoB;EACI,cPiBb;EOhBa,ePoMT;EOnMS,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AV0xHxB;;AUnxHA;EACI,mBPdQ;EOeR,iBAAA;ENtED,aMuE+B;AVsxHlC;AUrxHI;EACI,gBPtKe;EOuKf,kBAAA;AVuxHR;AUtxHQ;EACI,eAAA;AVwxHZ;AUrxHI;EACI,cPPG;AH8xHX;AUtxHQ;EACI,cPdD;AHsyHX;AUrxHI;EACI,cP1KE;AHi8HV;AUtxHQ;EACI,uDAAA;AVwxHZ;;AUpxHA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AVuxHJ;;AUrxHA;ENjGG,mBMkG+B;AVwxHlC;AUvxHI;EACI,cP5BG;EO6BH,WAAA;EACA,gBPpMa;EOqMb,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AVyxHR;AUvxHI;EACI,cPzCG;EO0CH,YAAA;EACA,ePyIO;AHgpHf;AUvxHI;EACI,cP5CG;EO6CH,ePuIO;EOtIP,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AVyxHR;;AUtxHA;EACI,WAAA;AVyxHJ;AUxxHI;EACI,kBAAA;AV0xHR;AUxxHI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AV0xHR;AUzxHQ;EACI,sBPrMJ;EOsMI,kBAAA;EACA,yBAAA;EN3IT,gBM4IiC;EN3IjC,uBM2I6C;EACpC,ePkHG;AH0qHf;AU3xHY;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EN1Jd,kBM2JgC;EN1JhC,SM0JyC;ENvJzC,SMuJwD;AV+xH1D;AU7xHY;EACI,sBPlNR;EOmNQ,kBAAA;ENvJb,kBMwJqC;ENvJrC,UMuJiD;AVgyHpD;AU9xHY;EACI,cPrFL;EOsFK,cAAA;EACA,eP+FD;EO9FC,iBAAA;AVgyHhB;AU9xHY;EACI,WP5NR;AH4/HR;AU9xHY;EACI,cPrPJ;EOsPI,gBPjQO;EOkQP,ePyFD;AHusHf;AU/xHgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AViyHpB;;ACpiIA,0BAAA;AUdA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBR0UY;EQzUZ,WRmCI;EQlCJ,gBRCiB;AHqjIrB;AWrjII;EACI,WRgCA;AHuhIR;AWrjII;EACI,WAAA;EACA,YAAA;EACA,kBRiUQ;AHsvHhB;AWrjII;EACI,kBAAA;AXujIR;AWtjIQ;EACI,kBAAA;AXwjIZ;AWrjII;EACI,gBAAA;AXujIR;AWtjIQ;EACI,gBAAA;AXwjIZ;AWrjII;EACI,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AXujIR;AWpjIQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,UAAA;AXsjIZ;AWnjII;EACI,yBRjCE;AHslIV;AWnjII;EACI,yBRiHG;AHo8HX;AWnjII;EACI,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AXqjIR;AWpjIQ;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;AXsjIZ;AWnjII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AXqjIR;AWpjIQ;EACI,eAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;AXsjIZ;AWnjIY;EACI,aAAA;EACA,cAAA;AXqjIhB;AWjjII;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AXmjIR;AWljIQ;EACI,eAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AXojIZ;AWjjIY;EACI,cAAA;EACA,eAAA;AXmjIhB;AWhjIQ;EACI,aAAA;EACA,cAAA;AXkjIZ;AW/iII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AXijIR;AWhjIQ;EACI,uBAAA;EACA,wBAAA;AXkjIZ;AW/iIY;EACI,aAAA;EACA,cAAA;AXijIhB;AW9iIQ;EACI,aAAA;EACA,cAAA;AXgjIZ;AW7iII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AX+iIR;AW9iIQ;EACI,sBAAA;EACA,uBAAA;AXgjIZ;AW7iIY;EACI,cAAA;EACA,eAAA;AX+iIhB;AW3iII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AX6iIR;AW5iIQ;EACI,sBAAA;EACA,sBAAA;AX8iIZ;AW3iIY;EACI,cAAA;EACA,eAAA;EACA,wBAAA;AX6iIhB;AW1iIgB;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AX4iIpB;AWviII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AXyiIR;AWxiIQ;EACI,sBAAA;EACA,sBAAA;AX0iIZ;AWviIY;EACI,cAAA;EACA,eAAA;EACA,wBAAA;AXyiIhB;;AWpiIA;EACI,UAAA;AXuiIJ;AWriIQ;EACI,uBAAA;AXuiIZ;AWtiIY;EACI,UAAA;AXwiIhB;AWniIQ;EACI,cAAA;EACA,eAAA;AXqiIZ;AWpiIY;EACI,kBAAA;AXsiIhB;AWniIQ;EACI,mBAAA;AXqiIZ;AWjiIQ;EACI,WAAA;EACA,YAAA;AXmiIZ;AWliIY;EACI,iBAAA;AXoiIhB;AWjiIQ;EACI,uBAAA;AXmiIZ;AW/hIQ;EACI,aAAA;EACA,cAAA;AXiiIZ;AWhiIY;EACI,iBAAA;AXkiIhB;AW9hII;EACI,uCAAA;EACA,qCAAA;EACA,sBAAA;EACA,gCAAA;AXgiIR;AW/hIQ;EACI,+BAAA;AXiiIZ;AW/hIQ;EACI,UAAA;EACA,gCAAA;AXiiIZ;;AW7hIA;EAGC,oBAAA;AXgiID;AW/hIC;EACC,eAAA;EACA,gBAAA;AXiiIF;AWhiIE;;EAEC,sBAAA;EACA,iBAAA;AXkiIH;AW9hIE;EACC,uBAAA;AXgiIH;AW/hIG;EACC,UAAA;AXiiIJ;AW5hIE;EACC,cAAA;EACA,eAAA;AX8hIH;AW7hIG;EACC,kBAAA;AX+hIJ;AW5hIE;EACC,mBAAA;AX8hIH;AW1hIE;EACC,WAAA;EACA,YAAA;AX4hIH;AW3hIG;EACC,iBAAA;AX6hIJ;AW1hIE;EACC,uBAAA;AX4hIH;;AWxhIA;EACI,WAAA;EACA,YAAA;AX2hIJ;;AY70IA;;EAEC,yBT0BS;ESzBT,kBAAA;AZg1ID;;AY90IA;EACC,4BTsBS;AH2zIV;;AY/0IA;EACI,uBAAA;AZk1IJ;;AYh1IA;EACI,gCAAA;AZm1IJ;;AYh1IA;EACC,cT6BQ;AHszIT;AYl1IC;EACE,kCAAA;AZo1IH;;AYj1IA;EACC,qBTgJW;AHosIZ;;Aa12IA;EACI,WV0CI;EUzCJ,yBVkBM;EUjBN,qBViBM;EUhBN,eViWW;EUhWX,eVgWW;AH6gIf;;Aa32IA;EACI,mBVYM;EUXN,WVkCI;EUjCJ,eV2VW;EU1VX,eV0VW;EUzVX,kBAAA;ET4FD,iBS3F+B;ET8EhC,yBS7EsB;Abg3IxB;Aa/2II;EACI,4DVKQ;EUJR,WV0BA;AHu1IR;AIr1II;EStCJ;IAaQ,eAAA;IACA,gBAAA;Ebk3IN;AACF;;Aah3IA;EACI,mBViPS;EUhPT,WViBI;EUhBJ,eV0UW;EUzUX,gBVhBe;EUiBf,kBAAA;ET2ED,iBS1E+B;ET6DhC,yBS5DsB;Abq3IxB;Aap3II;EACI,mBVXI;EUYJ,WVSA;AH62IR;AI32II;ESrBJ;IAaQ,eAAA;IACA,gBAAA;Ebu3IN;AACF;;Aar3IA;EACI,mBVtBM;ECoFP,iBS7D+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBV1Ce;EU2Cf,eV8SW;EU7SX,kBAAA;EACA,kBAAA;Abw3IJ;Aav3II;EACI,4DVtCQ;EUuCR,WVjBA;AH04IR;Aav3II;EACI,kBAAA;EACA,WAAA;EACA,YAAA;Aby3IR;;Aat3IA;EACI,mBV/CQ;ECkFT,iBSlC+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBVrEe;EUsEf,eVmRW;EUlRX,kBAAA;EACA,kBAAA;Aby3IJ;Aax3II;EACI,mBV2FG;EU1FH,WV5CA;AHs6IR;Aax3II;EACI,kBAAA;EACA,WAAA;EACA,YAAA;Ab03IR;;Aav3IA;EACI,mBVlEK;EC0EN,iBSP+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBVhGe;EUiGf,eVwPW;EUvPX,kBAAA;EACA,kBAAA;Ab03IJ;Aaz3II;EACI,mBVnFC;EUoFD,WVvEA;AHk8IR;Aaz3II;EACI,kBAAA;EACA,WAAA;EACA,YAAA;Ab23IR;;Aav3IA;EACI,iBAAA;EACA,WAAA;EACA,gBVlHe;EUmHf,eVsOW;EUrOX,kBAAA;Ab03IJ;Aaz3II;EACI,WAAA;EACA,YAAA;Ab23IR;;Aax3IA;EACI,yBVnHM;EUoHN,qBVpHM;AH++IV;;Aaz3IA;EACI,yBVvHM;EUwHN,qBVxHM;EUyHN,WVlGI;AH89IR;;Aaz3II;EACI,SAAA;Ab43IR;;Aav3IQ;EACI,6BAAA;EACA,yBAAA;Ab03IZ;Aaz3IY;EACI,cVpIJ;AH+/IZ;;Aap3IQ;EACI,kBAAA;Abu3IZ;;Aan3IA;EACI,YAAA;Abs3IJ;;Aap3IA;EACI,eAAA;Abu3IJ;Aat3II;EACI,UAAA;EACA,gBAAA;Abw3IR;;Aar3IA;EACI,kBVkKe;EUjKf,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBV3KmB;AHmiJvB;Aav3II;EACI,2BAAA;Aby3IR;Aav3II;EACI,oBAAA;Aby3IR;Aav3II;EACI,qBAAA;EACA,kBAAA;Aby3IR;Aav3II;EACI,uBAAA;EACA,kBAAA;Aby3IR;Aar3IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHshJR;Aat3IY;EAKI,kEAAA;EACA,kEAAA;EACA,WVvKR;AH2hJR;Aa/3IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHgiJR;Aah4IY;EAKI,8CAAA;EACA,8CAAA;EACA,WVvKR;AHqiJR;Aaz4IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AH0iJR;Aa14IY;EAKI,mEAAA;EACA,mEAAA;EACA,WVvKR;AH+iJR;Aan5IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHojJR;Aap5IY;EAKI,oEAAA;EACA,oEAAA;EACA,WVvKR;AHyjJR;Aa75IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AH8jJR;Aa95IY;EAKI,+CAAA;EACA,+CAAA;EACA,WVvKR;AHmkJR;Aav6IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHwkJR;Aax6IY;EAKI,uCAAA;EACA,uCAAA;EACA,WVvKR;AH6kJR;Aaj7IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHklJR;Aal7IY;EAKI,gEAAA;EACA,gEAAA;EACA,WVvKR;AHulJR;Aa37IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AH4lJR;Aa57IY;EAKI,0CAAA;EACA,0CAAA;EACA,WVvKR;AHimJR;Aar8IQ;EACI,sBAAA;EACA,sBAAA;EACA,WV/JJ;AHsmJR;Aat8IY;EAKI,uBAAA;EACA,uBAAA;EACA,WVvKR;AH2mJR;Aa/8IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHgnJR;Aah9IY;EAKI,8CAAA;EACA,8CAAA;EACA,WVvKR;AHqnJR;Aaz9IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AH0nJR;Aa19IY;EAKI,sCAAA;EACA,sCAAA;EACA,WVvKR;AH+nJR;Aan+IQ;EACI,yBAAA;EACA,yBAAA;EACA,WV/JJ;AHooJR;Aap+IY;EAKI,mEAAA;EACA,mEAAA;EACA,WVvKR;AHyoJR;Aa99II;EACI,yBVtDI;EUuDJ,yBAAA;EACA,cVxCG;AHwgJX;Aa/9IQ;EAKI,6CAAA;EACA,yBAAA;EACA,cVhDD;AH6gJX;;Aav9II;EACE,wBAAA;Ab09IN;;Aat9II;EACE,qBAAA;Aby9IN;;Aar9II;EACE,uBAAA;Abw9IN;;Aap9II;EACE,mBAAA;Abu9IN;Aar9II;EACE,mBAAA;Abu9IN;Aar9II;EACE,mBAAA;Abu9IN;Aar9II;EACE,mBAAA;Abu9IN;;Aan9II;EACE,aAAA;EACA,eAAA;Abs9IN;Aap9II;EACE,cAAA;EACA,eAAA;EACA,iBAAA;Abs9IN;Aap9II;EACE,cAAA;EACA,eAAA;EACA,iBAAA;Abs9IN;;Aal9II;EACE,6BAAA;Abq9IN;;Aah9IM;;;;EAIE,6BAAA;Abm9IR;;Aa98IE;EACE,yBAAA;Abi9IJ;;Aa/8IE;EACE,gBAAA;Abk9IJ;;Aah9IA;EACI,4BAAA;Abm9IJ;;Aaj9IE;EACE,4BAAA;Abo9IJ;;Aaj9IE;EACE,0BAAA;Abo9IJ;;Aal9IE;EACE,0BAAA;Abq9IJ;;Aal9IE;EACE,uCAAA;EACA,cVrSM;AH0vJV;Aap9II;EAGE,yBVzSI;EU0SJ,WVnRE;EUoRF,qBV3SI;AH+vJV;Aah9IE;EACE,wCAAA;EACA,cV/SQ;AHiwJZ;Aaj9II;EAGE,yBVnTM;EUoTN,WV/RE;EUgSF,qBVrTM;AHswJZ;Aa98IE;EACE,wCAAA;EACA,cVpTM;AHowJV;Aa/8II;EAGE,yBVxTI;EUyTJ,WV1SE;EU2SF,qBV1TI;AHywJV;Aa58IE;EACE,yCAAA;EACA,cVjUG;AH+wJP;Aa78II;EAGE,yBVrUC;EUsUD,WVrTE;EUsTF,qBVvUC;AHoxJP;Aa18IE;EACE,wCAAA;EACA,cV9UM;AH0xJV;Aa38II;EAGE,yBVlVI;EUmVJ,WVhUE;EUiUF,qBVpVI;AH+xJV;Aax8IE;EACE,uCAAA;EACA,cVnVK;AH6xJT;Aaz8II;EAGE,yBVvVG;EUwVH,WV3UE;EU4UF,qBVzVG;AHkyJT;;Aap8IE;EACE,6BAAA;EACA,cV1WM;EU2WN,yBAAA;Abu8IJ;Aat8II;EACE,cV7WI;EU8WJ,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,8BAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;Abu8IJ;Aat8II;EACE,mBVxXI;AHg0JV;Aar8IE;EACE,6BAAA;EACA,cV3XQ;EU4XR,yBAAA;Abu8IJ;Aat8II;EACE,cV9XM;EU+XN,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,6BAAA;EACA,cV/XM;EUgYN,yBAAA;Abu8IJ;Aat8II;EACE,cVlYI;EUmYJ,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,6BAAA;EACA,cV3YG;EU4YH,yBAAA;Abu8IJ;Aat8II;EACE,cV9YC;EU+YD,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,6BAAA;EACA,cVvZM;EUwZN,yBAAA;Abu8IJ;Aat8II;EACE,cV1ZI;EU2ZJ,yBAAA;EACA,6BAAA;Abw8IN;Aar8IE;EACE,6BAAA;EACA,cV3ZK;EU4ZL,yBAAA;Abu8IJ;Aat8II;EACE,cV9ZG;EU+ZH,yBAAA;EACA,6BAAA;Abw8IN;;Aan8IE;EACE,6BAAA;Abs8IJ;;Aan8IA;EACI,oCAAA;EACA,yBAAA;Abs8IJ;Aar8II;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;Abm8IR;;Aah8IA;EACI,oCAAA;EACA,yBAAA;Abm8IJ;Aal8II;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;Abg8IR;;Aa77IA;EACI,oCAAA;EACA,yBAAA;Abg8IJ;Aa/7II;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;Ab67IR;;Aa17IA;EACI,oCAAA;EACA,yBAAA;Ab67IJ;Aa57II;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;Ab07IR;;Aav7IA;EACI,oCAAA;EACA,yBAAA;Ab07IJ;Aaz7II;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,sBAAA;Abu7IR;;Aap7IA;EACI,oCAAA;EACA,yBAAA;Abu7IJ;Aat7II;EAKI,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,sBAAA;Abo7IR;;Aaj7IA;EACI,yBAAA;EACA,yBAAA;Abo7IJ;Aan7II;EAKI,yBV1fA;EU2fA,yBAAA;EACA,yBAAA;Abi7IR;;Aa96IA;EACI,oCAAA;EACA,yBAAA;Abi7IJ;Aah7II;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,sBAAA;Ab86IR;;Aa36IA;EACI,oCAAA;EACA,yBAAA;Ab86IJ;Aa76II;EAKG,4CAAA;EACA,qBV3iBG;AHs9JV;;Aax6IA;EACI,oCAAA;EACA,yBAAA;Ab26IJ;Aa16II;EAKG,6CAAA;EACA,qBVrjBK;AH69JZ;;Aar6IA;EACI,oCAAA;EACA,yBAAA;Abw6IJ;Aav6II;EAKG,6CAAA;EACA,qBV/jBG;AHo+JV;;Aal6IA;EACI,oCAAA;EACA,yBAAA;Abq6IJ;Aap6II;EAKG,4CAAA;EACA,qBVrkBE;AHu+JT;;Aa/5IA;EACI,oCAAA;EACA,yBAAA;Abk6IJ;Aaj6II;EAKG,6CAAA;EACA,qBVnlBG;AHk/JV;;Aa55IA;EACI,oDAAA;EACA,yBAAA;Ab+5IJ;Aa95II;EAKG,8CAAA;EACA,qBVjmBA;AH6/JP;;Aaz5IA;EACI,qDAAA;EACA,yBAAA;Ab45IJ;Aa35II;EAKG,+CAAA;EACA,qBV9lBC;EU+lBD,qBV9XM;AHuxJb;;Aat5IA;EACI,kDAAA;EACA,sBAAA;Aby5IJ;Aax5II;EAKG,4CAAA;EACA,qBVpnBA;AH0gKP;;Aal5IE;EACE,sBAAA;EACA,oBAAA;Abq5IJ;Aap5II;EACE,mBV9nBG;EU+nBH,WVlnBE;EUmnBF,gCAAA;EACA,oBAAA;EACA,0BAAA;Abs5IN;;Aah5II;EACE,sBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;Abm5IN;Aal5IM;EACE,8BAAA;EACA,sBAAA;EACA,gCAAA;EACA,oBAAA;EACA,0BAAA;Abo5IR;;Aa/4IA;EACE,yBVtdW;EUudX,qBVvdW;EUwdX,cV3oBO;EU4oBP,eVpVa;EUqVb,gBVhrBmB;EUirBnB,kBAAA;ETnlBC,iBSolB6B;ETjmB9B,yBSkmBoB;EAGpB,mBAAA;EAGA,oBAAA;Abo5IF;AI1iKI;ESwoBJ;IT7kBG,iBS6lBiC;Ebs5IlC;AACF;;Aan5IA;EACE,mBVvpBM;EUwpBN,yBAAA;EThnBA,yBSinBoB;EAGpB,mBAAA;EAGA,oBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;Abw5IF;Aav5IE;EACI,mBAAA;EACA,qBAAA;EACA,WV9qBE;AHukKR;AIrkKI;ES4pBJ;IAmBM,eAAA;Eb05IJ;AACF;;ActnKI;EACI,iCAAA;EACA,2CAAA;EACA,cXgBE;AHymKV;;AcnnKQ;EACI,mBAAA;EACA,2CAAA;EACA,WX8BJ;AHwlKR;AcpnKQ;EACI,iCAAA;EACA,2CAAA;EACA,cXyOG;AH64Jf;;Ac9nKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AHmmKR;Ac/nKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AHw5Jf;;AczoKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AH8mKR;Ac1oKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AHm6Jf;;AcppKQ;EACI,mBAAA;EACA,6CAAA;EACA,WX8BJ;AHynKR;AcrpKQ;EACI,mCAAA;EACA,6CAAA;EACA,cXyOG;AH86Jf;;Ac/pKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AHooKR;AchqKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AHy7Jf;;Ac1qKQ;EACI,mBAAA;EACA,2CAAA;EACA,WX8BJ;AH+oKR;Ac3qKQ;EACI,iCAAA;EACA,2CAAA;EACA,cXyOG;AHo8Jf;;AcrrKQ;EACI,mBAAA;EACA,2CAAA;EACA,WX8BJ;AH0pKR;ActrKQ;EACI,iCAAA;EACA,2CAAA;EACA,cXyOG;AH+8Jf;;AchsKQ;EACI,mBAAA;EACA,8CAAA;EACA,WX8BJ;AHqqKR;AcjsKQ;EACI,oCAAA;EACA,8CAAA;EACA,cXyOG;AH09Jf;;Ac3sKQ;EACI,gBAAA;EACA,wCAAA;EACA,WX8BJ;AHgrKR;Ac5sKQ;EACI,8BAAA;EACA,wCAAA;EACA,WXyOG;AHq+Jf;;ActtKQ;EACI,mBAAA;EACA,2CAAA;EACA,WX8BJ;AH2rKR;AcvtKQ;EACI,iCAAA;EACA,2CAAA;EACA,cXyOG;AHg/Jf;;AcjuKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AHssKR;AcluKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AH2/Jf;;Ac5uKQ;EACI,mBAAA;EACA,4CAAA;EACA,WX8BJ;AHitKR;Ac7uKQ;EACI,kCAAA;EACA,4CAAA;EACA,cXyOG;AHsgKf;;Ac3uKA;EACI,wBAAA;EACA,0BAAA;EACA,gBXdmB;EWenB,qBAAA;EACA,kBXsTY;EWrTZ,cXqJO;AHylKX;Ac7uKI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;Ad+uKR;Ac7uKI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;Ad+uKR;Ac7uKI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;Ad+uKR;Ac7uKI;EACI,eXwTO;EWvTP,iBAAA;EACA,iBAAA;Ad+uKR;Ac7uKI;EACI,eXqTO;EWpTP,iBAAA;EACA,iBAAA;Ad+uKR;;Ac3uKA;EACI,mBXuKS;EWtKT,cXbK;AH2vKT;;Ac3uKA;EACI,oCAAA;Ad8uKJ;Ac7uKI;EACI,yBXkJK;AH6lKb;;Ac5uKA;EACI,oCAAA;Ad+uKJ;Ac9uKI;EACI,yBXiIM;AH+mKd;;Ac7uKA;EACI,oCAAA;AdgvKJ;Ac/uKI;EACI,yBXgHG;AHioKX;;Ac9uKA;EACI,oCAAA;AdivKJ;AchvKI;EACI,yBX2IM;AHumKd;;Ac/uKA;EACI,oCAAA;EACA,cX2HS;AHunKb;;AchvKA;EACC,8BAAA;EACG,sBAAA;AdmvKJ;;AcjvKA;EACI,mBXvCO;EWwCP,WXpDI;AHwyKR;;AclvKA;EACI,kBAAA;EACA,eXgQW;EW/PX,gBAAA;EACA,eAAA;EACA,WX3DI;AHgzKR;;AcnvKA;EACI,kBAAA;EACA,eXyPW;EWxPX,gBAAA;EACA,gBXnGiB;AHy1KrB;AcrvKI;EACI,mBXkFM;EWjFN,cXvFE;AH80KV;AcrvKI;EACI,mBXmGM;EWlGN,cXvFE;AH80KV;AcrvKI;EACI,mBX0GK;EWzGL,cX1EC;AHi0KT;AcrvKI;EACI,mBXgFK;EW/EL,cX7FC;AHo1KT;;Ael3KA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBZoCI;AHi1KR;;Aen3KA;EACI,oCAAA;Afs3KJ;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,iCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,kDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,kDAAA;Afw3KZ;Aet3KQ;EACI,8BAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,kDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,kDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,8CAAA;Afw3KZ;Aet3KQ;EACI,+CAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,oCAAA;EACA,UAAA;Afu3KR;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,gDAAA;Afw3KZ;Aet3KQ;EACI,iDAAA;Afw3KZ;Aet3KQ;EACI,gCAAA;Afw3KZ;Aer3KI;EACI,mCAAA;Afu3KR;Aer3KI;EACI,oCAAA;Afu3KR;Aer3KI;EACI,mCAAA;Afu3KR;Aer3KI;EACI,oCAAA;Afu3KR;Aer3KI;EACI,iCAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,4BAAA;Afu3KR;Aer3KI;EACI,wBAAA;Afu3KR;Aer3KI;EACI,wBAAA;Afu3KR;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,2BAAA;Afu3KR;Aer3KI;EACI,2BAAA;Afu3KR;Aer3KI;EACI,iCAAA;Afu3KR;Aer3KI;EACI,iCAAA;Afu3KR;Aer3KI;EACI,oBAAA;Afu3KR;Aer3KI;EACI,gCAAA;Afu3KR;Aer3KI;EACI,+BAAA;Afu3KR;Aer3KI;EACI,8BAAA;Afu3KR;Aer3KI;EACI,iCAAA;Afu3KR;;Aep3KA;EACI,wCAAA;Afu3KJ;Aet3KI;EACI,mCAAA;Afw3KR;Aet3KI;EACI,mCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;Aet3KI;EACI,gCAAA;Afw3KR;;Aer3KA;EACI,+CAAA;Afw3KJ;Aev3KI;EACI,0CAAA;Afy3KR;Aev3KI;EACI,0CAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;Aev3KI;EACI,gCAAA;Afy3KR;;Aet3KA;EACI,2CAAA;Afy3KJ;Aex3KI;EACI,sCAAA;Af03KR;Aex3KI;EACI,sCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;Aex3KI;EACI,gCAAA;Af03KR;;Aev3KA;EACI,iDAAA;Af03KJ;Aez3KI;EACI,4CAAA;Af23KR;Aez3KI;EACI,4CAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;Aez3KI;EACI,gCAAA;Af23KR;;Aex3KA;EACI,wBAAA;Af23KJ;;Aez3KA;EACI,uBAAA;Af43KJ;;Ae13KA;EACI,wBAAA;Af63KJ;;Ae33KA;EACI,sBAAA;Af83KJ;;Ae53KA;EACI,wBAAA;Af+3KJ;;Ae73KA;EACI,uBAAA;Afg4KJ;;Ae93KA;EACI,wBAAA;Afi4KJ;;Ae/3KA;EACI,qBAAA;Afk4KJ;;Aeh4KA;EACI,wBAAA;Afm4KJ;;Aej4KA;EACI,uBAAA;Afo4KJ;;Ael4KA;EACI,wBAAA;Afq4KJ;;Aen4KA;EACI,sBAAA;Afs4KJ;;Aep4KA;EACI,6BAAA;Afu4KJ;;AgBn0LA;EACI,6BAAA;EACA,YAAA;EZsGD,kBYrG4B;AhBs0L/B;;AgBp0LA;EACC,qBbqKU;EapKP,sBboCI;AHmyLR;;AgBr0LA;EACI,iBAAA;AhBw0LJ;;AgBt0LA;EACC,WAAA;EACA,gBAAA;AhBy0LD;;AgBv0LA;EACI,qBAAA;AhB00LJ;;AgBx0LA;EACC,gBAAA;AhB20LD;;AgBz0LA;EACC,ebiVc;EahVd,gBbbsB;EactB,iCAAA;EACA,iBAAA;EACA,yBAAA;AhB40LD;;AgB10LA;EACC,iCAAA;AhB60LD;;AgB30LA;EACC,gBbUO;AHo0LR;;AgB50LA;;;;;EAKC,UAAA;AhB+0LD;;AgB70LA;EACC,mBbuHW;EatHX,ebyTc;EaxTd,iBAAA;EACA,eAAA;EACA,yBAAA;AhBg1LD;;AgB90LA;;;;;;;EAOC,qBAAA;AhBi1LD;;AgB/0LA;;EAEI,gBAAA;AhBk1LJ;;AgBh1LA;EACC,mBAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,uBAAA;AhBm1LD;;AgBj1LA;EACC,oBAAA;EACA,eb4Rc;AHwjLf;;AgBl1LA;EACC,mBAAA;AhBq1LD;;AgBn1LA;EACC,mBAAA;AhBs1LD;;AgBp1LA;;;EAGC,oCAAA;EACA,sBAAA;EACA,4BAAA;AhBu1LD;;AgBr1LA;EACC,mBAAA;AhBw1LD;;AgBt1LA;EACC,gBbnDO;AH44LR;;AgBv1LA;EACC,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AhB01LD;;AgBx1LA;EACC,kBAAA;EACA,gBbhGkB;EaiGlB,iCAAA;AhB21LD;;AgBz1LA;EACC,kBAAA;EACA,gBbrGkB;EasGlB,iCAAA;AhB41LD;;AgB11LA;EACC,YAAA;AhB61LD;;AgB31LA;EACC,kBAAA;EACA,gBAAA;AhB81LD;;AgB51LA;EACI,mBAAA;EACA,eb2OW;Ea1OX,gBbnHmB;EaoHnB,gBAAA;EACA,kBAAA;AhB+1LJ;;AiB/9LA;EACI,aAAA;AjBk+LJ;;AiBh+LA;EACI,wBAAA;AjBm+LJ;;AiBj+LA;;EAEI,gBAAA;AjBo+LJ;;AiBl+LA;EACI,sBAAA;AjBq+LJ;;AiBn+LA;EACI,aAAA;AjBs+LJ;;AkBn/LI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBfmCA;EelCA,kBAAA;EACA,mBAAA;EACA,aAAA;EdgFN,yBc/E0B;AlBw/L5B;AkBv/LQ;EACI,sBf8BJ;EC+CN,yBc5E8B;AlB2/LhC;AkBz/LQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBfiBJ;EehBI,2BAAA;EACA,mBAAA;EACA,kBAAA;AlB2/LZ;AkB1/LY;EACI,WAAA;EACA,cfeT;AH6+LP;AkBx/LY;EACI,efjCC;EekCD,gBf3BO;Ee4BP,WfKR;EeJQ,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AlB0/LhB;AkBx/LY;EACI,efkTD;EejTC,cf0NH;AHgyLb;;AkBn/LQ;EACI,gBAAA;EACA,SAAA;EACA,kBAAA;AlBs/LZ;AkBr/LY;EACI,mBfxCN;AH+hMV;AkBt/LgB;EACI,WfnBZ;AH2gMR;AkBr/LY;EACI,cf9CN;AHqiMV;AkBn/LY;EACI,cfnDN;EeoDM,WAAA;EACA,gBAAA;EACA,ef4RD;AHytLf;;AkB9+LQ;EACI,kBAAA;EACA,mBAAA;AlBi/LZ;AkBh/LY;EACI,mBAAA;AlBk/LhB;AkBh/LY;EACI,Wf7CR;Ee8CQ,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBk/LhB;AkBj/LgB;EAGI,aAAA;EACA,kBAAA;EACA,aAAA;AlBm/LpB;AkBh/LY;EACI,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;AlBk/LhB;AkBj/LgB;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EAGA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;AlBm/LpB;AkBl/LoB;EACI,qBAAA;EACA,kBAAA;EACA,kBAAA;AlBo/LxB;AkBn/LwB;EACI,iBAAA;AlBq/L5B;AkBn/LwB;EACI,Wf/FpB;EegGoB,gBfhGpB;EeiGoB,mBAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,efiNb;EehNa,mBAAA;AlBq/L5B;AIjmMI;Ec4FoB;IAkBQ,WAAA;IACA,YAAA;ElBu/L9B;AACF;AkBt/L4B;EACI,cf2GnB;AH64Lb;AkBt/L4B;EACI,WfvHxB;EewHwB,mBfrIvB;AH6nMT;AkBv/LgC;EACI,Wf1H5B;AHmnMR;AkB/+LwB;EACI,efwLb;AHyzLf;AkB1+LQ;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;AlB4+LZ;AkB3+LY;EACI,ef8KD;Ee7KC,gBflLO;EemLP,mBAAA;AlB6+LhB;AI9nMI;Ec8IQ;IAKQ,efwKL;EHu0Lb;AACF;AkB7+LY;EACI,mBAAA;AlB++LhB;AkB7+LoB;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AlB++LxB;AkB9+LwB;EACI,kBAAA;AlBg/L5B;AkB9+LwB;EACI,WflKpB;EemKoB,ef3MX;Ee4MW,gBfrML;EesMK,gBAAA;AlBg/L5B;AkB3+LY;EACI,ef6ID;Ee5IC,cfkDH;AH27Lb;AkB1+LgB;EACI,mBfxMV;EeyMU,8BAAA;EACA,WfnLZ;EeoLY,ef3NH;Ee4NG,yBAAA;EACA,gBftNG;EeuNH,gBAAA;EACA,iBAAA;AlB4+LpB;AkB3+LoB;EACI,mBfvMf;EewMe,sBAAA;EACA,cfnNd;AHgsMV;;AkBt+LA;EAGI,aAAA;AlBy+LJ;AkBx+LI;EACI,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlB0+LR;AkBz+LQ;EACI,UAAA;EACA,kBAAA;AlB2+LZ;AIzrMI;Ec4MI;IAIQ,aAAA;IACA,iBAAA;ElB6+Ld;AACF;AkB1+LI;EACI,QAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlB4+LR;AkB3+LQ;EACI,QAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlB6+LZ;AkB1+LoB;EACI,gBAAA;AlB4+LxB;AkB3+LwB;EACI,cfnQlB;EeoQkB,WAAA;AlB6+L5B;AkBv+LQ;EACI,QAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AlBy+LZ;AkBx+LY;EACI,UAAA;AlB0+LhB;AkBz+LgB;EACI,aAAA;EACA,gCAAA;EACA,4BAAA;AlB2+LpB;AkBx+LY;EACI,UAAA;EACA,UAAA;AlB0+LhB;AI7uMI;EciQQ;IAIQ,WAAA;ElB4+LlB;AACF;AkBz+LQ;EACI,UAAA;EACA,UAAA;AlB2+LZ;AItvMI;EcyQI;IAIQ,WAAA;ElB6+Ld;AACF;;AkBz+LA;EACI,oCAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AlB4+LJ;AkBx+LgB;EACI,WAAA;EACA,YAAA;EACA,cAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB0+LpB;AIjxMI;Ec2RY;IAcQ,WAAA;IACA,YAAA;ElB4+LtB;AACF;AkBv+LI;EACI,mBf1UE;Ee2UF,cAAA;EACA,UAAA;AlBy+LR;AkBt+LgB;EACI,WfzTZ;Ee0TY,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBw+LpB;AI1yMI;EcsTY;IAcQ,WAAA;IACA,YAAA;ElB0+LtB;AACF;AkBr+LI;EACI,mBfrWE;EesWF,YAAA;EACA,mBAAA;EACA,YAAA;AlBu+LR;AkBp+LgB;EACI,WfrVZ;EesVY,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBs+LpB;AIp0MI;EckVY;IAcQ,WAAA;IACA,YAAA;ElBw+LtB;AACF;AkBv+LoB;EACI,efxCT;AHihMf;;AkBj+LI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBo+LR;AIz1MI;Ec4WA;IAWQ,cAAA;ElBs+LV;AACF;AkBr+LQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBu+LZ;AkBt+LY;EACI,iBAAA;AlBw+LhB;AkBv+LgB;EACI,eAAA;AlBy+LpB;AkBv+LgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WfxZZ;EeyZH,ef7FU;AHskMf;AkBx+LoB;EACI,yBfzaf;Ee0ae,qBf1af;Ee2ae,Wf9ZhB;Ee+ZF,WAAA;EACe,YAAA;EACf,cAAA;EACA,efpGS;AH8kMf;AkBx+LoB;EACI,WfrahB;EesagB,mBfnbf;Eeobe,qBfpbf;AH85MT;AkBz+LwB;EACI,WfzapB;AHo5MR;AkBt+LoB;EACI,mBftcd;Eeucc,qBfvcd;Eewcc,WfjbhB;AHy5MR;AkBv+LwB;EACI,iCAAA;AlBy+L5B;AI15MI;EcyXI;IA8DQ,kBAAA;IACA,uBAAA;ElBu+Ld;AACF;AIh6MI;Ec0bQ;IAEQ,kBAAA;ElBw+LlB;AACF;;AkBn+LA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EAGA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AlBs+LJ;AIr7MI;EckcJ;IAeQ,cAAA;ElBw+LN;AACF;AI17MI;EcmdA;IAEQ,kBAAA;ElBy+LV;AACF;AkBx+LQ;EACI,ef5JG;Ee6JH,gBf1fO;Ee2fhB,cftVQ;EeuVC,kBAAA;AlB0+LZ;AIr8MI;EcudI;IAMQ,eflKD;EH8oMb;AACF;AkBz+LY;EACI,efzKD;Ee0KC,gBfvgBK;EewgBL,cfvQH;EewQG,kBAAA;AlB2+LhB;AkB1+LgB;EACI,iBAAA;AlB4+LpB;AIn9MI;EcieQ;IASQ,mBAAA;ElB6+LlB;AACF;AkBz+LI;EAGI,aAAA;AlB2+LR;AkB1+LQ;EACI,mBAAA;EACA,kBAAA;EACA,WfxfJ;EeyfI,yBAAA;EACA,kBAAA;EACA,gBf1hBO;Ee2hBP,efniBK;AH+gNjB;AkB3+LG;EACC,mBfrhBM;EeshBN,yBAAA;AlB6+LJ;AI1+MI;EcmfI;IAaQ,efzMD;EHurMb;AACF;AkB5/LQ;EAiBI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBg/LZ;AkB/+LY;EACI,eAAA;AlBi/LhB;AkB7+LY;EACI,WAAA;EACA,YAAA;EACA,mBfvZJ;EewZI,kBAAA;EACA,cfrTH;EesTT,efxNW;Ee2NC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB++LhB;AkB9+LI;EACC,mBfvjBK;EewjBL,WfjiBG;AHihNR;;AkB1+LA;EACI,kBAAA;EACA,kBAAA;AlB6+LJ;AkB5+LI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,yBf5jBC;Ee6jBD,WAAA;EACA,YAAA;EACA,mBAAA;AlB8+LR;AkB5+LI;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBfzjBA;Ee0jBA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,wDAAA;EACA,gEAAA;AlB8+LR;;AkB1+LA;EACC,WAAA;AlB6+LD;;AkB3+LA;EACI,WAAA;EACA,cAAA;AlB8+LJ;;AkB5+LA;EACC,kBAAA;EACA,mBAAA;AlB++LD;AkB9+LI;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlBg/LR;AkB7+LQ;EACI,aAAA;AlB++LZ;;AkB3+LA;EACI,WfzlBI;Ee0lBJ,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlB8+LJ;AkB7+LI;EACI,gBfzoBW;Ee0oBX,ef3SO;Ee4SP,Wf5mBA;AH2lNR;;AkB5+LA;EAGI,aAAA;AlB++LJ;;AkB7+LA;;EAEI,aAAA;AlBg/LJ;;AkB7+LI;EACI,gBf5pBa;Ee6pBb,efjUO;EekUP,mBAAA;EACA,Wf5nBA;AH4mNR;AkB9+LI;EACI,efnUO;EeoUP,gBAAA;EACA,WfjoBA;EekoBA,gBflqBW;AHkpNnB;;AkB7+LA;EACC,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACG,oCAAA;EACA,mBAAA;EACA,iBAAA;AlBg/LJ;AkB/+LI;EACI,gBfhrBa;EeirBb,efrVO;EesVP,cflbK;EembL,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AlBi/LR;AIpoNI;Ec4oBA;IASQ,ef9VG;EHi1Mb;AACF;AkBj/LI;EACI,gBf3pBA;Ee4pBA,YAAA;EACA,YAAA;AlBm/LR;AkBl/LQ;EACI,cfzhBD;Ee0hBC,efxWG;AH41Mf;;AkB/+LI;EACI,8BAAA;EACA,YAAA;EACA,YAAA;AlBk/LR;AkBj/LQ;EACI,Wf1qBJ;AH6pNR;;AkB/+LA;EACI,kBAAA;EdxpBF,kBAAA;EAcE,QAAA;EACA,SAAA;EAGA,gCAAA;AJ8nNJ;AkBr/LQ;EACI,8BAAA;EACA,iBAAA;EACA,mBAAA;AlBu/LZ;AkBt/LY;EACI,WAAA;EACA,YAAA;EACA,sBAAA;AlBw/LhB;AkBv/LgB;EACI,kBAAA;AlBy/LpB;AkBv/LgB;EACI,iBAAA;AlBy/LpB;AkBv/LgB;EACI,cAAA;EACA,eAAA;EACA,gBfnuBG;EeouBH,mBAAA;AlBy/LpB;;AkBn/LA;EACC,kBAAA;EACA,YAAA;EACA,WAAA;AlBs/LD;AIjsNI;EcwsBJ;IAKQ,WAAA;IACA,WAAA;ElBw/LN;AACF;AkBv/LI;EACI,cfpfK;EeqfL,WAAA;EACA,YAAA;EACA,gBfttBA;EeutBA,mBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBy/LR;AkBx/LQ;EACI,YAAA;AlB0/LZ;AkBt/LgB;EACI,cfpvBX;AH4uNT;AkBh/LgB;EACI,oCAAA;AlBk/LpB;AkBj/LoB;EACI,WflvBhB;AHquNR;;AkBx+LgB;EACI,8BAAA;AlB2+LpB;AkB1+LoB;EACI,WfhwBhB;AH4uNR;;AkBp+LI;EACI,SAAA;EACA,UAAA;AlBu+LR;AkBr+LI;EACI,SAAA;EACA,WAAA;EAGA,aAAA;AlBu+LR;;AkBj+LY;EACI,ef9dD;Ee+dF,gBf3zBQ;AH+xNrB;;AkB59LY;EACI,efxeD;EeyeC,gBfr0BK;AHoyNrB;;AkB19LA;EACC,cAAA;EACA,kBAAA;AlB69LD;;AkB39LA;EACC,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACG,6BAAA;EACH,UAAA;AlB89LD;;AkB59LA;;;EAGI,yBAAA;AlB+9LJ;;AkB79LA;EACI,mBAAA;EACH,mBAAA;EACG,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;EACA,oBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACH,UAAA;AlBg+LD;;AkB99LA;EAGC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AlBi+LD;AkBh+LI;EACI,qBAAA;AlBk+LR;;AkB/9LA;EACC,YAAA;EACG,aAAA;EACA,8BAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlBk+LJ;;AkB/9LI;EACI,YAAA;EACA,WAAA;AlBk+LR;;AkB99LI;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlBi+LR;;AkB79LI;EACI,kBAAA;EACA,WAAA;AlBg+LR;;AkB59LI;EACI,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;AlB+9LR;AkB99LQ;EACI,aAAA;AlBg+LZ;AkB79LI;EACI,kBAAA;AlB+9LR;AkB79LI;EACI,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EAGA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;AlB+9LR;AIz3NI;Ec64BA;IAeQ,WAAA;ElBi+LV;AACF;AI93NI;Ec64BA;IAkBQ,iBAAA;ElBm+LV;AACF;AIn4NI;Ec64BA;IAqBQ,iBAAA;ElBq+LV;AACF;AkBp+LQ;EACI,iBAAA;AlBs+LZ;AI34NI;Eco6BI;IAGQ,kBAAA;ElBw+Ld;AACF;AIh5NI;Ec64BA;IA8BQ,WAAA;IACA,iBAAA;ElBy+LV;AACF;;AIt5NI;Eck7BA;IAEO,UAAA;ElBu+LT;AACF;AkBt+LQ;EACI,kBAAA;AlBw+LZ;AI/5NI;Ecs7BI;IAGQ,iBAAA;ElB0+Ld;AACF;AkBx+LQ;EACI,iBAAA;AlB0+LZ;AIv6NI;Ec+7BY;IACI,iBAAA;ElB2+LlB;AACF;;AkBp+LQ;EACI,YAAA;AlBu+LZ;;AkBj+LQ;EACI,kBAAA;AlBo+LZ;AkBl+LQ;EACI,iBAAA;AlBo+LZ;AIv7NI;Ecq9BI;IAEQ,eAAA;ElBo+Ld;AACF;;AkBh+LA;EACC,Wf/9BO;Eeg+BJ,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AlBm+LJ;AkBl+LI;EACI,Wfr+BA;AHy8NR;;AkBj+LA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,efvqBW;EewqBd,gBf7gCkB;EeghCf,aAAA;EAGA,mBAAA;EAGA,uBAAA;AlBo+LJ;;AkBl+LA;EACC,aAAA;AlBq+LD;;AkBn+LA;EACI,oBAAA;AlBs+LJ;;AkBp+LA;EACI,UAAA;AlBu+LJ;AIr+NI;Ec6/BJ;IAGQ,UAAA;ElBy+LN;AACF;AI1+NI;EckgCA;IAEQ,iBAAA;ElB0+LV;AACF;AI/+NI;EcugCA;IAEQ,kBAAA;ElB0+LV;AACF;;AkBt+LA;EACC,eAAA;EACA,uBAAA;AlBy+LD;;AkBv+LA;EACC,kBAAA;EACA,SAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;AlB0+LD;;AkBx+LA;EACC,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AlB2+LD;;AkBv+LQ;EACI,aAAA;AlB0+LZ;AkBz+LY;EACI,cAAA;EACA,oBAAA;AlB2+LhB;;AkBt+LA;EACC,6BAAA;EACA,UAAA;AlBy+LD;;AkBv+LA;EACC;IAAM,cAAA;ElB2+LL;EkB1+LD;IAAI,kBAAA;ElB6+LH;AACF;AkB3+LI;EAGI,aAAA;EAGA,mBAAA;EACA,qBAAA;EACA,iBAAA;AlB6+LR;AIxiOI;EcmjCA;IAUQ,cAAA;ElB++LV;AACF;AkB7+LY;EACI,SAAA;EACA,mBAAA;AlB++LhB;AkB7+LY;EACI,UAAA;EACA,YAAA;EACA,aAAA;AlB++LhB;AItjOI;EcokCQ;IAKQ,WAAA;ElBi/LlB;AACF;AkB9+LQ;EACI,UAAA;AlBg/LZ;AI9jOI;Ec6kCI;IAGQ,UAAA;ElBk/Ld;AACF;AInkOI;Ec6kCI;IAMQ,WAAA;ElBo/Ld;AACF;AkBj/LI;EACI,sBAAA;EACA,aAAA;AlBm/LR;;AkBh/LA;EACC,cAAA;AlBm/LD;;AkBj/LA;EACC,SAAA;AlBo/LD;;AkBl/LA;EACC,WAAA;AlBq/LD;;AkBn/LA;EACC,mBAAA;EACA,WfzmCO;AH+lOR;;AkBn/LI;EACI,aAAA;AlBs/LR;AkBp/LI;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;AlBs/LR;AkBr/LQ;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AlBu/LZ;AkBt/LY;EACI,aAAA;AlBw/LhB;;AkBn/LA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AlBs/LJ;AkBr/LC;EACC,0CAAA;EACA,qBAAA;EACA,oBAAA;EACA,Wf1oCM;Ee2oCN,efj1Ba;Eek1Bb,gBf5qCqB;Ee6qCrB,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AlBu/LF;AkBt/LE;EACC,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,sBfxpCK;EeypCL,WAAA;EACA,YAAA;EACA,mBAAA;AlBw/LH;AkBt/LE;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,yBf/qCM;EegrCN,UAAA;EACA,WAAA;EACA,mBAAA;EACA,wDAAA;EACA,gEAAA;AlBw/LH;;AkBn/LA;EACC;IACC,kBAAA;ElBs/LA;AACF;AkB9+LA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;AlBq/LD;;AkBn/LA;EACC,yBf7jCU;Ee8jCP,oBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AlBs/LJ;;AkBp/LA;EACC,kBAAA;EACG,SAAA;EACA,SAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,gBf3sCI;Ee4sCJ,mBAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AlBu/LJ;;AkBr/LA;EACC,WAAA;EACG,WAAA;EACA,kBAAA;EACA,SAAA;EACA,mBf7uCM;Ee8uCN,YAAA;EACA,mBAAA;EACA,aAAA;AlBw/LJ;;AkBt/LA;EACC,WAAA;EACG,YAAA;EACA,mBAAA;EACA,mBftvCM;EeuvCN,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AlBy/LJ;;AkBv/LA;EACC,WAAA;EACG,aAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;AlB0/LJ;;AkBv/LA;EACC,kBAAA;EACA,gBAAA;EACA,WAAA;AlB0/LD;;AkBv/LA;EACC,WfxvCO;EeyvCP,gBAAA;EACA,ef77Bc;Ee87Bd,gBAAA;AlB0/LD;;AkBx/LA;EACI,aAAA;AlB2/LJ;AkB1/LI;EACI,eAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AlB4/LR;AI7vOI;Ec6vCA;IAMQ,eAAA;ElB8/LV;AACF;AkB1/LoB;EACI,cfnwChB;AH+vOR;AkBv/LQ;EACI,iBAAA;EACA,2BAAA;AlB0/LZ;AkBx/LY;EACI,QAAA;EACA,gBAAA;AlB0/LhB;AkBz/LgB;EACI,yBf7pCR;Ee8pCQ,kBAAA;AlB2/LpB;AkB1/LoB;EACI,2BAAA;EACA,mCAAA;AlB4/LxB;AkB1/LoB;EACI,kBAAA;AlB4/LxB;AkB1/L4B;EACI,iBAAA;AlB4/LhC;AkB3/LgC;EACI,iBAAA;AlB6/LpC;AkB3/LgC;EACI,kBAAA;AlB6/LpC;AkB1/L4C;EAEI,iBAAA;EACA,kBf5yCxC;AHwyOR;AkBz/LwC;EACI,kBAAA;Ed1xC1C,kBAAA;EAcE,QAAA;EACA,SAAA;EAGA,gCAAA;AJywOJ;AkB//L4C;EACI,WfpzCxC;AHqzOR;AkB7/LoC;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AlB+/LxC;AkB9/LwC;EACI,Wf9zCpC;Ee+zCoC,eAAA;AlBggM5C;AkB7/LoC;EACI,kBAAA;AlB+/LxC;AkBz/LoB;EACI,oCAAA;EACA,8BAAA;EACA,eAAA;EACA,iCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;AlB2/LxB;AkBv/LY;EACI,uBAAA;AlBy/LhB;AkBv/LY;EACI,QAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,+BAAA;AlBy/LhB;AkBt/LwB;EACI,cf/1CpB;AHu1OR;AkBl/LQ;EACI,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AlBo/LZ;AkBn/LY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AlBq/LhB;AkBl/LQ;EACI,yBfhwCA;EeiwCA,kBAAA;EACA,kBAAA;EACA,gBf/5CS;Eeg6CT,kBAAA;EACA,kBAAA;AlBo/LZ;AkBn/LY;EACI,efzkCD;Ee0kCC,cf7vCL;Ee8vCK,kBAAA;EACA,gBAAA;EACA,gBfv6CK;AH45OrB;AkBn/LY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,ef5lCD;Ee6lCC,gBfp7CK;Eeq7CL,cf54CR;Ee64CQ,gBAAA;AlBq/LhB;AkBp/LgB;EACI,WAAA;AlBs/LpB;AkBn/LY;EACI,oCAAA;EACA,+BAAA;EACA,iCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AlBq/LhB;AkBj/LY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;EACA,gBfp9CK;Eeq9CL,cfrtCH;AHwsOb;AkBl/LI;EACC,eAAA;EACA,cAAA;AlBo/LL;AkB/+LI;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AlBi/LR;AkBh/LQ;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,yBfj8CJ;Eek8CI,WAAA;EACA,WAAA;AlBk/LZ;AkBh/LQ;EACI,yBft8CJ;Eeu8CI,cfv8CJ;Eew8CI,efvpCG;EewpCH,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBfp/CW;Eeq/CX,kBAAA;AlBk/LZ;;AkB3+LY;EACI,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,gBAAA;EACA,oBAAA;AlB8+LhB;AkB7+LgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB++LpB;AkB5+LoB;EACI,WAAA;EACA,cfx+ChB;AHs9OR;AkB1+LY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gCAAA;EACA,oBAAA;AlB4+LhB;AkBz+LwB;EACI,cf3/CpB;Ee4/CoB,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;AlB2+L5B;AkB1+L4B;EACI,mBfjiDtB;EekiDsB,qBfliDtB;AH8gPV;AkB3+LgC;EACI,Wf7gD5B;AH0/OR;AkB1+L4B;EACI,WAAA;AlB4+LhC;AkBn+LQ;EACI,YAAA;AlBq+LZ;AkBp+LY;EACI,aAAA;EACA,gBAAA;EACA,yBf7zCN;Ee8zCM,4BAAA;AlBs+LhB;AkBr+LgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBu+LpB;AkBt+LoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBfnkDd;EeokDc,mBAAA;EACA,ef5vCT;Ee6vCS,WfvjDhB;EewjDgB,iBAAA;AlBw+LxB;AkBp+LY;EACI,aAAA;AlBs+LhB;AkBr+LgB;EACI,sBAAA;EACA,aAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,gBAAA;AlBu+LpB;AkBt+LoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AlBw+LxB;AkBv+LwB;EACI,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AlBy+L5B;AkBv+LwB;EACI,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AlBy+L5B;AkBx+L4B;EACI,MAAA;EACA,eAAA;AlB0+LhC;AkBx+L4B;EACI,kBAAA;AlB0+LhC;AkBv+LwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,YAAA;AlBy+L5B;AkBx+L4B;EACI,aAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlB0+LhC;AkBz+LgC;EACI,efn0CrB;Eeo0CqB,gBfjqDf;EekqDe,kBAAA;EACA,cfl6CvB;Eem6CuB,mBAAA;EACA,gBAAA;EACA,uBAAA;AlB2+LpC;AkBz+LgC;EACI,ef/0CrB;Eeg1CqB,cfrpD3B;EewpD2B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlB2+LpC;AkB1+LoC;EACI,WAAA;EACA,YAAA;AlB4+LxC;AkBt+LoC;EACI,cfrqD/B;AH6oPT;AkBn+LgC;EACI,efx2CrB;Eey2CqB,cfzhDzB;Ee0hDyB,gBfjsDf;AHsqPrB;AkBn+LgC;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,yBfpsD1B;EeqsD0B,Wf9qD5B;Ee+qD4B,kBAAA;EACA,iBAAA;EACA,eAAA;AlBq+LpC;AkBl+L4B;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlBo+LhC;AkBl+LoC;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cfnkD7B;EeokD6B,mBAAA;AlBo+LxC;AkBn+LwC;EACI,cftkDjC;AH2iPX;AkB19LI;EACI,sCAAA;AlB49LR;AkB39LQ;EACI,sCAAA;AlB69LZ;AkB19LI;EACI,gBf9tDA;Ee+tDN,8DAAA;EACA,yBAAA;EACM,mBAAA;EACA,aAAA;AlB49LR;AkB39LQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACT,yBf5gDO;AHy+OV;AkB39LgB;EACI,efp7CL;Eeq7CK,gBflxDG;EemxDH,cf7mDT;Ee8mDS,gBAAA;AlB69LpB;AkBz9LgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AlB29LpB;AkB19LoB;EACI,mBf9xDd;AH0vPV;AkB39LwB;EACI,WfzwDpB;AHsuPR;AkB19LoB;EACI,WAAA;EACA,cf3xDf;AHuvPT;AkBv9LE;EACC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,gBfzxDK;AHkvPR;AkBx9LG;EAGa,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACZ,kBAAA;AlB09LJ;AkBz9LI;EACC,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AlB29LL;AkB19LK;EACC,cf1kDO;AHsiPb;AkBz9LI;EACC,cAAA;EACA,UAAA;AlB29LL;AkBz9LI;EACC,cAAA;EACA,UAAA;AlB29LL;AkBz9LI;EACC,WAAA;EACA,aAAA;AlB29LL;AkB19LK;EAGC,aAAA;EAGA,mBAAA;EACA,eflgDS;AH89Of;AkBz9LI;EACC,UAAA;AlB29LL;AkB19LK;EAGmB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EAClB,WAAA;EACA,YAAA;EACA,mBft2DI;Eeu2DJ,mBAAA;AlB49LN;AkB39LM;EACC,mBAAA;AlB69LP;AkB59LO;EACC,Wfp1DA;AHkzPR;AkB39LM;EACC,WAAA;EACA,Wfz1DC;AHszPR;AkBz9LI;EACC,mBAAA;EACA,iBAAA;EACA,gBfh2DG;Eei2DH,0CAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AlB29LL;AkB19LK;EACC,ef74DW;Ee84DX,yBAAA;AlB49LN;;AkBp9LI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;AlBu9LR;AkBr9LI;EACI,QAAA;EAGA,6BAAA;AlBu9LR;AIp1PI;Ecy3DA;IAMQ,WAAA;IAGA,aAAA;IACA,8BAAA;IACA,sCAAA;IACA,4BAAA;ElBy9LV;AACF;AkBx9LQ;EACI,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlB09LZ;AkBz9LY;EACI,yBf56DN;AHu4PV;AkB19LgB;EACI,Wfv5DZ;AHm3PR;AkBz9LY;EACI,cf5rDH;AHupPb;;AkBt9LA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AlBy9LJ;AkBx9LI;EAGI,aAAA;EAGA,mBAAA;EACA,6BAAA;EACA,qCAAA;EACA,2BAAA;EACA,WAAA;AlB09LR;AkBz9LQ;EACI,kBAAA;AlB29LZ;AkBx9LoB;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AlB09LxB;AI15PI;Ecw7DgB;IAUQ,YAAA;IACA,aAAA;IACA,WAAA;IACA,UAAA;ElB49L1B;AACF;AIl6PI;Ecw7DgB;IAgBQ,YAAA;IACA,aAAA;IACA,UAAA;IACA,SAAA;ElB89L1B;AACF;AkB19LY;EACI,YAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AlB49LhB;AIh7PI;Ecg9DQ;IAMQ,YAAA;IACA,aAAA;ElB89LlB;AACF;AIt7PI;Ecg9DQ;IAUQ,WAAA;IACA,YAAA;ElBg+LlB;AACF;AkB/9LgB;EACI,WAAA;EACA,kBAAA;AlBi+LpB;AkB79LgB;EACI,ef5qDL;Ee6qDK,Wfv+DZ;Eew+DY,gBf1gEC;Ee2gED,0BAAA;EACA,kBAAA;EACA,gBAAA;AlB+9LpB;AIx8PI;Ecm+DY;IAQQ,gBAAA;ElBi+LtB;AACF;AkB99LY;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EAGA,gCAAA;EACA,UAAA;AlBg+LhB;AIv9PI;Ec++DQ;IAUQ,WAAA;ElBk+LlB;AACF;AkBj+LgB;EACI,yBfrhEV;EeshEU,Wf//DZ;AHk+PR;;AkB79LA;EACI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBf34DO;Ee44DP,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;AlBg+LJ;AkB99LQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,mBAAA;EACA,gBfxhEJ;EeyhEI,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBg+LZ;;AkB59LA;EACI,WAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBf3iEI;Ee4iEJ,kBAAA;EACA,yBAAA;AlB+9LJ;;AkB79LA;EAEI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AlBg+LJ;;AkB99LA;EACI,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;AlBi+LJ;;AkB99LA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlBi+LJ;AIxiQI;EcwkEA;IAEQ,eAAA;IACD,sBAAA;ElBk+LT;AACF;AkBj+LQ;EACI,mBAAA;AlBm+LZ;AkBl+LY;EACI,eAAA;AlBo+LhB;AkBh+LI;EACI,kBAAA;EACA,cAAA;AlBk+LR;AkBj+LQ;EACI,eAAA;AlBm+LZ;AkBj+LQ;EACI,eAAA;AlBm+LZ;AI9jQI;Ec0lEI;IAGQ,aAAA;ElBq+Ld;AACF;AkBn+LQ;EACI,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBf9mEJ;Ee+mEI,kBAAA;EACA,YAAA;AlBq+LZ;AkBp+LY;EACI,cf5+DL;AHk9PX;AkBp+LY;EACI,mBAAA;AlBs+LhB;AkBp+LY;EACI,kBAAA;AlBs+LhB;AkBp+LY;EACI,yBfr/DL;Ees/DK,Wf5nER;Ee6nEQ,aAAA;EACA,gBf7pEG;Ee8pEH,eftqEC;AH4oQjB;AkBr+LgB;EACI,yBfxpEV;AH+nQV;AkBr+LgB;EACI,WAAA;EACA,iBAAA;EACA,WftoEZ;AH6mQR;AI3mQI;EcwnEQ;IAeQ,YAAA;IACA,efjrEH;EHypQf;AACF;AkBt+LY;EACI,cf1oET;AHknQP;AkBr+LQ;EACI,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBf7pEJ;Ee8pEI,kBAAA;EACA,iBAAA;AlBu+LZ;AkBt+LY;EACI,kBAAA;AlBw+LhB;;AmBnrQI;EACF,qCAAA;AnBsrQF;AmBnrQQ;EACI,chBoQC;AHi7Pb;AmBjrQI;EAGI,aAAA;EAGA,mBAAA;AnBmrQR;AmBjrQI;EACI,iBAAA;AnBmrQR;AmBjrQI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBmrQR;AmBjrQI;EACI,cAAA;AnBmrQR;AmBjrQI;EACI,kBAAA;AnBmrQR;AmBjrQI;EACI,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AnBmrQR;AmBhrQI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;EAGA,6BAAA;AnBkrQR;AmBhrQI;EACI,kBAAA;EACA,YAAA;AnBkrQR;AmBhrQI;EACI,kBAAA;EACA,YAAA;AnBkrQR;AmBhrQI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AnBkrQR;AmBhrQI;EAGI,aAAA;EAGA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AnBkrQR;AmBhrQI;EACI,UAAA;EACN,aAAA;EACA,mBAAA;AnBkrQF;AmBhrQI;EACI,mBAAA;AnBkrQR;AmBhrQI;EACI,ehBiQO;EgBhQP,cAAA;AnBkrQR;AmB/qQI;EACI,kBAAA;EACA,qBAAA;EACA,qBAAA;AnBirQR;AmB/qQI;EACI,aAAA;AnBirQR;AmB/qQI;EACI,iBAAA;AnBirQR;AmB/qQI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnBirQR;AmB9qQE;EACC,sBAAA;AnBgrQH;AmB9qQE;EACC,iBAAA;AnBgrQH;AIvwQI;EesFF;IAGE,cAAA;EnBkrQF;AACF;AmBhrQE;EACC,aAAA;EACA,gCAAA;EACA,gBAAA;AnBkrQH;AmB/qQG;EACC,ehBwNW;EgBvNX,chBgCO;EgB/BP,gBhBtIe;AHuzQnB;AmB9qQE;EACC,sCAAA;AnBgrQH;AmB9qQE;EACC,ehB4MY;EgB3MZ,eAAA;EACA,iBAAA;EACA,gBhBlJkB;EgBmJlB,cAAA;AnBgrQH;AmB9qQE;EACC,ehBuMY;EgBtMZ,cAAA;AnBgrQH;AmB7qQE;EACC,YAAA;EACA,ehBkMY;EgBjMZ,cAAA;AnB+qQH;AmB5qQE;EACC,gBAAA;EACA,cAAA;AnB8qQH;AmB3qQE;;;EAGC,yBAAA;AnB6qQH;AmB3qQE;EACC,gBhB1IK;EgB2IL,yBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;AnB6qQH;AmB1qQE;EACC,SAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;AnB4qQH;AmB1qQE;EACC,ehB+JY;EgB9JZ,cAAA;AnB4qQH;AmB1qQE;;;EAGC,yBAAA;AnB4qQH;AmB1qQE;EACC,kBAAA;EAGA,aAAA;EAGA,mBAAA;AnB4qQH;AmB1qQE;EAGC,aAAA;EAGA,mBAAA;AnB4qQH;AmB9pQA;EACC;IAEC,kBAAA;EnB0qQA;EmBxqQD;IAEC,2BAAA;EnB0qQA;AACF;AmBxqQA;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,gBhBnNO;AH63QR;AmBzqQC;EACC,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACM,gEAAA;EACA,8BAAA;EACA,sDAAA;EACN,kBAAA;AnB2qQF;AmB1qQE;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AnB4qQH;AmB3qQG;EACC,kBAAA;AnB6qQJ;AmB3qQG;EACC,ehBmFW;EgBlFX,gBhBzQmB;EgB0QnB,kBAAA;EACA,cAAA;EACA,chBtGO;AHmxQX;AmBzqQG;EACC,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AnB2qQJ;AmBzqQK;EACC,ehBkES;EgBjET,chBnHK;EgBoHL,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;AnB2qQN;AmB1qQM;EACC,ehBwDQ;AHonQf;AmBzqQO;EACC,yBhB5IG;EgB6IH,qBhB7IG;AHwzQX;AmBnqQC;EACC,SAAA;EACA,aAAA;EACA,oBAAA;AnBqqQF;AmBpqQE;EACC,gBAAA;AnBsqQH;AmBpqQE;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,+BAAA;AnBsqQH;AmBrqQG;EACC,cAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AnBuqQJ;AmBtqQI;EACC,gBAAA;AnBwqQL;AmBtqQI;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;AnBwqQL;AmBvqQK;EACC,kBAAA;AnByqQN;AmBvqQK;EACC,ehBQS;EgBPT,gBAAA;AnByqQN;AmBvqQK;EACC,WhBvTE;EgBwTF,eAAA;EACA,eAAA;EACA,gBhB5Ve;AHqgRrB;AmBxqQM;EACC,+BAAA;AnB0qQP;AmBzqQO;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AnB2qQR;AmBtqQI;EACC,iCAAA;EACe,uCAAA;EACf,kBAAA;EACA,chBpMM;EgBqMN,ehBjBU;EgBkBV,gBhB9WgB;EgB+WhB,uDAAA;AnBwqQL;AmBvqQK;EACC,chBxUC;AHi/QP;AmBrqQK;EACC,chB9MK;EgB+ML,kBAAA;EACA,cAAA;AnBuqQN;AmBrqQK;EACC,mBAAA;AnBuqQN;AmBnqQK;EACC,aAAA;AnBqqQN;AmBhqQM;EACC,kBAAA;EACA,WhBrWC;EgBsWD,eAAA;EACA,gBhBxYc;EgByYd,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AnBkqQP;AmB5pQI;EACC,gBAAA;EACA,chB/OM;EgBgPN,gBhBtZkB;EgBuZlB,ehB5DU;AH0tQf;AmB7pQK;EACC,eAAA;EACA,chBxPK;EgByPL,gBhB7Ze;EgB8Zf,kBAAA;AnB+pQN;AmB3pQG;EACC,iBAAA;AnB6pQJ;AmB5pQI;EACC,yBAAA;AnB8pQL;AmB5pQI;EACC,iCAAA;EACe,oCAAA;EACf,chBlQM;EgBmQN,aAAA;AnB8pQL;AmB7pQK;EACC,2BAAA;EACA,mCAAA;AnB+pQN;AmB9pQM;EACC,chB5QI;AH46QX;AmB/pQO;EACC,chBzYD;AH0iRP;AmB5pQI;EACC,QAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,+BAAA;AnB8pQL;AmB7pQK;EACC,WAAA;EACA,kBAAA;AnB+pQN;AmB7pQK;EACC,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,6BAAA;EACA,oBAAA;EACA,chBrSK;AHo8QX;AmB5pQI;EACC,QAAA;EACA,gBAAA;AnB8pQL;AmB5pQI;EACC,uBAAA;AnB8pQL;AmB3pQG;EACC,kBAAA;AnB6pQJ;AmB5pQI;EACC,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;AnB8pQL;AmB7pQK;EACC,gBAAA;AnB+pQN;AmB5pQI;EACC,kBAAA;AnB8pQL;AmB5pQM;EACC,6BAAA;EACA,WAAA;EACA,kBAAA;AnB8pQP;AmBxpQM;EAEC,iBAAA;AnB0pQP;AmBtpQI;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AnBwpQL;AmBvpQK;EACC,WhBvdE;EgBwdF,eAAA;AnBypQN;AmBvpQK;EACC,gBAAA;AnBypQN;AmBtpQM;EACC,WAAA;AnBwpQP;AmBlpQI;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;AnBopQL;AmBnpQK;EACC,WhB5eE;EgB6eF,eAAA;EACA,chBzWK;AH8/QX;AmBnpQK;EACC,gBAAA;AnBqpQN;AmBlpQM;EACC,WAAA;AnBopQP;AmBrqQG;EAqBC,kBAAA;EACA,mBhB/XQ;EgBgYR,mBAAA;EACA,aAAA;EACA,kBAAA;AnBmpQJ;AmBlpQI;EACC,WAAA;EACA,YAAA;EACA,sBhBjgBG;EgBkgBH,kBAAA;AnBopQL;AmBnpQK;EACC,chBlYK;EgBmYL,ehBrMS;AH01Qf;AmBjpQK;EACC,chBpYK;EgBqYL,qBAAA;EACA,WAAA;EACA,ehBlNS;EgBmNT,gBhB/iBe;AHksRrB;AmBjpQK;EACC,chB/YK;EgBgZL,qBAAA;EACA,WAAA;AnBmpQN;AmBjpQK;EAGC,aAAA;EAGA,mBAAA;EACA,UAAA;EACA,gBAAA;AnBmpQN;AmBlpQM;EACC,gBAAA;EACA,chB1ZI;EgB2ZJ,ehBvOQ;EgBwOR,kBAAA;AnBopQP;AmBnpQO;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AnBqpQR;AmBlpQQ;EACC,aAAA;AnBopQT;AmBjpQO;EACC,chBzkBE;AH4tRV;AmBhpQM;EACC,kBAAA;AnBkpQP;AmB3oQC;EACC,yBAAA;UAAA,iBAAA;AnB6oQF;AmB3oQC;EACC,kBAAA;AnB6oQF;AmB5oQE;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;AnB8oQH;AIvtRI;EegkBF;IAWE,oBAAA;EnBgpQF;AACF;AmB9oQI;EACC,gBAAA;EACA,chBjdM;EgBkdN,ehBrRU;EgBsRV,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AnBgpQL;AmB/oQK;EACC,eAAA;AnBipQN;AmB9oQI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACe,mBhB3nBV;EgB4nBL,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;AnBgpQL;AmB/oQK;EACC,sBhB3mBE;EgB4mBF,qBhBveK;AHwnRX;AmBhpQM;EACC,chBzeI;AH2nRX;AmB/oQK;EACC,gBAAA;AnBipQN;AmB5oQI;EACC,chBnfM;EgBofN,eAAA;AnB8oQL;AmB1oQI;EACC,chBzfM;EgB0fN,ehBjUU;AH68Qf;AmB/oQG;EAKC,cAAA;EACA,UAAA;AnB6oQJ;AmB1oQI;EACC,chBjgBM;EgBkgBN,ehBzUU;EgB0UV,ehBzUU;AHq9Qf;AmBhpQG;EAMC,cAAA;EACA,UAAA;AnB6oQJ;AmB3oQG;EACC,kBAAA;AnB6oQJ;AmB5oQI;EACC,WAAA;EACA,YAAA;EACA,gBhBlpBG;EgBmpBH,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnB8oQL;AmB7oQK;EACC,yBhBhiBK;EgBiiBL,qBhBjiBK;AHgrRX;AmB7oQK;EACC,chB5hBK;EgB6hBL,ehBtWS;AHq/Qf;AmB1oQI;EACC,chBniBM;EgBoiBN,UAAA;AnB4oQL;AmB1oQI;EACC,chBviBM;EgBwiBN,UAAA;AnB4oQL;AmB1oQI;EACC,chB3iBM;EgB4iBN,UAAA;AnB4oQL;AmB1oQI;EACC,chB/iBM;EgBgjBN,UAAA;AnB4oQL;AmBnoQE;EACC,gBAAA;AnBqoQH;AmBjoQA;EACC,chB/jBU;EgBgkBV,ehB5Yc;AH+gRf;AmBjoQA;EACC,aAAA;EACA,eAAA;AnBmoQD;AmBjoQA;EACC,gBAAA;AnBmoQD;AmB/nQE;EACC,mBhBzuBO;EgB0uBP,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBhlBQ;EgBilBR,UAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,sBAAA;AnBioQH;AmBhoQG;EACC,mBAAA;EACA,WhBpuBI;AHs2RR;AmB9nQC;EACC,gCAAA;EACA,gBAAA;EACA,oBAAA;AnBgoQF;AmB5nQC;EACC,chB1mBS;EgB2mBT,ehBvba;EgBwbb,gBhBpxBmB;EgBqxBnB,mBAAA;EACA,cAAA;AnB8nQF;AmB3nQA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,ehBncc;EgBocd,WhB9vBO;EgB+vBP,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;AnB6nQD;AmB1nQC;EACC,WhB3wBM;EgB4wBN,yBhBrvBY;EgBsvBZ,qBhBrvBY;AHi3Rd;AmBznQA;EACC,eAAA;AnB2nQD;AmBznQA;EACC,yBhBppBU;EgBqpBV,qBhBppBU;EgBqpBV,6BAAA;EACA,2BAAA;AnB2nQD;AmBznQA;EACC,yBhB1pBU;EgB2pBV,qBhB1pBU;EgB2pBV,6BAAA;EACA,2BAAA;AnB2nQD;AmBznQA;EACC,ehBnec;AH8lRf;AmBznQA;EACC,gBAAA;AnB2nQD;AmBznQA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AnB2nQD;AmB1nQC;EACC,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,sBhBtzBM;EgBuzBN,chBjrBS;EgBkrBT,ehB7fa;EgB8fb,gBhB11BmB;AHs9RrB;AmB3nQE;EACC,qBhB5rBQ;AHyzRX;AmB3nQE;EACC,qBhB/rBQ;AH4zRX;AmB3nQE;EACC,qBhBlsBQ;AH+zRX;AmBznQA;EACC,UAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;AnB2nQD;AmBznQA;EACC,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;AnB2nQD;AmB1nQC;EACC,ehB/hBa;EgBgiBb,chBttBS;AHk1RX;AmBznQA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;AnB2nQD;AmB1nQC;EACC,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,sBhBh3BM;EgBi3BN,chB3uBS;EgB4uBT,ehBvjBa;EgBwjBb,gBhBp5BmB;AHghSrB;AmB3nQE;EACC,qBhBtvBQ;AHm3RX;AmB3nQE;EACC,qBhBzvBQ;AHs3RX;AmB3nQE;EACC,qBhB5vBQ;AHy3RX;AmBznQA;EACC,UAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;AnB2nQD;AmBznQA;EACC,kBAAA;AnB2nQD;AmBznQA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBzwBU;EgB0wBV,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;AnB2nQD;AmBznQA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBzxBU;EgB0xBV,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;AnB2nQD;AmBznQA;EACC,sBAAA;AnB2nQD;AmBznQA;EACC,YAAA;EACA,WAAA;AnB2nQD;AmBznQA;EACC,yBAAA;EACA,chBjzBU;EgBkzBV,kBAAA;EACA,eAAA;EACA,gBhBx9BoB;EgBy9BpB,gBAAA;EACA,oBAAA;AnB2nQD;AmBznQA;EACC,yBAAA;EACA,chB3zBU;EgB4zBV,kBAAA;EACA,cAAA;EACA,gBhBj+BoB;EgBk+BpB,gBAAA;EACA,mBAAA;AnB2nQD;AmBznQA;EACC,gBAAA;AnB2nQD;AmBxnQC;EACC,mBAAA;AnB0nQF;AmBvnQA;EACC,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AnBynQD;AmBvnQA;EAGC,aAAA;EAGA,mBAAA;EACA,kBAAA;AnBynQD;AmBvnQE;EAGC,aAAA;AnBynQH;AmBpnQC;EACC,kBAAA;AnBsnQF;AmBnnQA;EACC,aAAA;AnBqnQD;AmBpnQC;EACC,UAAA;EACA,mBAAA;AnBsnQF;AmBpnQC;EACC,UAAA;AnBsnQF;AmBnnQA;EACC,mBAAA;AnBqnQD;AmBpnQC;EACC,mBAAA;AnBsnQF;AmBnnQA;EACC,2BAAA;AnBsnQD;AmBnnQA;EAGC,aAAA;EAGA,mBAAA;AnBqnQD;AmBpnQC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AnBsnQF;AmBrnQE;EACC,WAAA;AnBunQH;AmBpnQC;EACC,chBv4BS;EgBw4BT,ehBntBa;EgBotBb,gBhBhjCmB;EgBijCnB,gBAAA;AnBsnQF;AmBpnQG;EACC,chBn2BU;AHy9Rd;AmBhnQC;EAGC,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;AnBknQF;AmBhnQG;EACC,WAAA;EACA,YAAA;EACA,mBhBhkCM;EgBikCN,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBknQJ;AmB9mQC;EACC,gBAAA;EACA,chBn7BS;EgBo7BT,ehBhwBa;EgBiwBb,gBhB7lCmB;EgB8lCnB,gBAAA;AnBgnQF;AmB9mQC;EACC,kBAAA;AnBgnQF;AmB5mQC;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;AnB8mQF;AmB7mQE;EACC,WhBzkCK;EgB0kCL,eAAA;AnB+mQH;AmB7mQE;EACC,gBAAA;AnB+mQH;AmB5mQG;EACC,WAAA;AnB8mQJ;AmB1mQC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnB4mQF;AmB1mQC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB4mQF;AmB3mQE;EACC,WAAA;EACA,UAAA;EACA,YAAA;AnB6mQH;AmB5mQG;EACC,kBAAA;AnB8mQJ;AmB5mQK;EACC,WAAA;AnB8mQN;AmBzmQE;EACC,WAAA;AnB2mQH;AmBrmQE;EACC,SAAA;EACA,YAAA;AnBumQH;AmBtmQG;EACC,mBAAA;EACA,iBAAA;AnBwmQJ;AmBlmQG;EACC,chB5/BO;EgB6/BP,ehBl0BW;EgBm0BX,mBAAA;EACA,iBAAA;EACA,gBhBlqCmB;AHswSvB;AmBlmQG;EACC,YAAA;EACA,UAAA;AnBomQJ;AmBnmQI;EACC,qBhBpgCM;EgBqgCN,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,wBAAA;EACA,gCAAA;AnBqmQL;AmBjmQE;EACC,yBhBnhCQ;AHsnSX;AmBjmQE;EACC,sBAAA;EACA,gBAAA;AnBmmQH;AmB7lQI;EACC,qBhBhiCM;EgBiiCN,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBhBpiCM;EgBqiCN,mBAAA;EACA,yBAAA;EACA,YAAA;AnB+lQL;AmBxlQG;EACC,QAAA;AnB0lQJ;AmBrlQE;EACC,gBAAA;AnBulQH;AmBnlQA;EACC,mBAAA;EACA,kBAAA;AnBqlQD;AmBllQC;EACC,kBAAA;EACA,chB9jCS;EgB+jCT,ehB34Ba;AH+9Rf;AmBhlQC;EACC,UAAA;EACA,gBAAA;EAGA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AnBklQF;AmBjlQE;EACC,gBAAA;AnBmlQH;AmBllQG;EACC,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,chB5lCO;EgB6lCP,gBhBrwCiB;EgBswCjB,ehB16BW;AH8/Rf;AmBnlQI;EACC,gBAAA;AnBqlQL;AmBjlQE;EACC,iBAAA;AnBmlQH;AmBhlQG;EACC,mBAAA;AnBklQJ;AmB9kQG;EACC,mBAAA;AnBglQJ;AmB3kQA;EACC,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AnB6kQD;AmB5kQC;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,yBhB3oCU;EgB4oCV,WAAA;EACA,WAAA;AnB8kQF;AmB3kQA;EACC,oBAAA;EACG,mBhBlpCQ;EgBmpCX,chBxoCU;EgByoCV,ehBr9Bc;EgBs9Bd,iBAAA;EACA,qBAAA;EACA,gBhBpzCoB;EgBqzCpB,kBAAA;EACA,yBAAA;AnB6kQD;AmB3kQA;EACC,iBAAA;AnB6kQD;AmB5kQC;EACC,iBAAA;AnB8kQF;AmB3kQA;EACC,eAAA;AnB6kQD;AmB5kQC;EACC,mBAAA;AnB8kQF;AmB5kQC;EACC,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AnB8kQF;AmB7kQE;EAGC,aAAA;EAGA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AnB+kQH;AmB9kQG;EACC,gBAAA;AnBglQJ;AmB9kQG;EACC,cAAA;EACA,kBAAA;AnBglQJ;AmB1kQC;EACC,kBAAA;EACA,chBzrCS;EgB0rCT,ehBrgCa;EgBsgCb,gBhBl2CmB;AH86SrB;AmB1kQC;EACC,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,chBrsCS;EgBssCT,ehBlhCa;AH8lSf;AmBzkQA;EACC,aAAA;EACA,cAAA;AnB2kQD;AmB1kQC;EACC,UAAA;AnB4kQF;AmB3kQE;EACC,gBAAA;EACA,mBAAA;AnB6kQH;AmB5kQG;EACC,kBAAA;AnB8kQJ;AmB5kQG;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnB8kQJ;AmB3kQM;EACC,chBluCI;AH+ySX;AmBrkQA;EAGC,aAAA;EAGA,mBAAA;AnBukQD;AmBtkQC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBwkQF;AmBvkQE;EACC,ehB1kCY;AHmpSf;AmBtkQC;EACC,ehB/kCa;EgBglCb,gBhB56CmB;EgB66CnB,chB7qCW;EgB8qCX,gBAAA;AnBwkQF;AmBrkQA;EACC,mBAAA;AnBukQD;AmBtkQC;EACC,chBnuCY;AH2ySd;AmBrkQA;EACC,6CAAA;AnBukQD;AmBtkQC;EACC,chBl5CK;AH09SP;AmBrkQA;EACC,mBAAA;AnBukQD;AmBtkQC;EACC,chB75CO;AHq+ST;AmBrkQA;EACC,mBAAA;AnBukQD;AmBtkQC;EACC,chB/xCS;AHu2SX;AmBrkQA;EACC,mBAAA;AnBukQD;AmBtkQC;EACC,chBrwCW;AH60Sb;AmBrkQA;EAGC,aAAA;EAGA,mBAAA;AnBukQD;AmBtkQC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,WhBz7CM;EgB07CN,eAAA;EACA,mBhBl9CQ;EgBq9CR,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AnBwkQF;AmBtkQC;EACC,cAAA;EACA,ehB7oCa;AHqtSf;AmBnkQE;EACC,ehBnpCY;EgBopCZ,iBAAA;EACA,WhBj9CK;EgBk9CL,6BAAA;EACA,SAAA;AnBqkQH;AmBnkQE;EACC,ehB1pCY;EgB2pCZ,iBAAA;EACA,chBj8CW;AHsgTd;AmB9jQG;EACC,WhB/9CI;EgBg+CJ,ehBpqCW;AHouSf;AmB3jQA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,ehB9qCc;EgB+qCd,mBAAA;EACA,WAAA;EACA,YAAA;AnB6jQD;AmB5jQC;EACC,mBAAA;EACA,qBhBl3CS;AHg7SX;AmB3jQA;EACC,gBAAA;EACA,SAAA;EACA,UAAA;AnB6jQD;AmB5jQC;EACC,qBAAA;EACA,iBAAA;AnB8jQF;AmB7jQE;EACC,chBr3CQ;EgBs3CR,ehB/rCY;AH8vSf;AmB3jQA;EACC,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,eAAA;EACA,gBAAA;AnB6jQD;AmB3jQE;EACC,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;AnB6jQH;AmB3jQE;EACC,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AnB6jQH;AmB5jQG;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,yBhBx6CO;EgBy6CP,ehB9uCW;EgB+uCX,gBhB3kDmB;EgB4kDnB,chBtiDK;AHomTT;AmB3jQE;EACC,gBAAA;AnB6jQH;AmBxjQG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnB0jQJ;AmBvjQE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnByjQH;AmBpjQC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,yBhBjkDO;AHunTT;AmBljQC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;AnBojQF;AmBhjQC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,yBhBnmDM;AHqpTR;AmB/iQA;EACC,chBloDS;AHmrTV;AmBhjQC;EACC,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,oCAAA;EACA,YAAA;AnBkjQF;AmBjjQE;EAEC,sBAAA;AnBmjQH;AmBjjQE;EAEC,sBAAA;AnBmjQH;AmB/iQA;EACC,mBAAA;EACA,iBAAA;EACA,gBhBvoDO;EgBwoDP,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AnBijQD;AmB9iQC;EACC,chB1gDS;EgB2gDT,YAAA;EACA,qBhBlhDS;AHkkTX;AmB1iQG;EACC,YAAA;AnB4iQJ;AmBviQA;EACC,chBxoDa;EgByoDb,ehBt2Cc;EgBu2Cd,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AnByiQD;AmBxiQC;EACC,ehB52Ca;AHs5Sf;AmBviQA;EACC,UAAA;EACA,SAAA;EACA,gBAAA;AnByiQD;AmBxiQC;EACC,eAAA;EACA,gCAAA;AnB0iQF;AmBziQE;EACC,chB3iDQ;EgB4iDR,chB5iDQ;EgB6iDR,ehBz3CY;EgB03CZ,iBAAA;AnB2iQH;AmBviQE;EACC,chBtsDM;AH+uTT;AmBriQE;EACC,chB3sDM;AHkvTT;AmBniQE;EACC,chBhtDM;AHqvTT;AmBjiQA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnBmiQD;AmBjiQA;EACC,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,SAAA;AnBmiQD;AmBjiQA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,yBhBjuDO;EgBkuDP,aAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;AnBmiQD;AmBliQC;EACC,sBhBvuDM;EgBwuDN,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AnBoiQF;AmBniQE;EACC,UAAA;AnBqiQH;AmBniQE;EACC,aAAA;EACA,iBAAA;EACA,mBAAA;AnBqiQH;AmBjiQE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBrnDQ;EgBsnDR,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;AnBmiQH;AmBliQG;EACC,chBlxDM;AHszTV;AmBliQG;EACC,chBnxDK;AHuzTT;AmB/hQA;EACC,YAAA;AnBiiQD;AmB/hQE;EACC,qBAAA;AnBiiQH;AmBniQC;EAIC,yBAAA;EACA,cAAA;AnBkiQF;AmB9hQC;EACC,uBAAA;AnBgiQF;AmB9hQC;EACC,SAAA;AnBgiQF;AmB7hQE;EACC,ehBj+CY;EgBk+CZ,gBhB/zDoB;EgBg0DpB,chB1pDQ;AHyrTX;AmB7hQE;EACC,eAAA;EACA,gBhBt0DkB;EgBu0DlB,chB/pDQ;AH8rTX;AmB1hQC;EACC,sBAAA;AnB4hQF;AmBzhQI;EACC,mBAAA;AnB2hQL;AmBvhQI;EACC,mBAAA;AnByhQL;AmBnhQA;EACC,mBAAA;AnBqhQD;AmBnhQA;EACC,eAAA;AnBqhQD;AmBnhQE;EACC,UAAA;EACA,gCAAA;AnBqhQH;AmBphQG;EACC,gBAAA;EACA,mBAAA;AnBshQJ;AmBrhQI;EACC,ehB5gDU;EgB6gDV,gBhB12DgB;EgB22DhB,chBnsDM;EgBosDN,kBAAA;AnBuhQL;AmBrhQI;EACC,ehBlhDU;EgBmhDV,gBhB/2DgB;EgBg3DhB,chBzsDM;EgB0sDN,kBAAA;AnBuhQL;AmBrhQI;EACC,ehBvhDU;EgBwhDV,gBhBt3DgB;EgBu3DhB,chB/sDM;AHsuTX;AmBrhQI;EACC,ehB7hDU;EgB8hDV,gBhB13DgB;EgB23DhB,chBrtDM;EgBstDN,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AnBuhQL;AmBthQK;EACC,chB5tDK;AHovTX;AmBrhQI;EACC,iBAAA;AnBuhQL;AmBjhQA;EACC,eAAA;AnBmhQD;AmBjhQA;EACC,eAAA;AnBmhQD;AmBjhQA;EACC,oBAAA;AnBmhQD;AmBjhQA;EACC,oBAAA;AnBmhQD;AmBhhQC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chBvvDS;EgBwvDT,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBhBtwDS;EgBuwDT,qBhBvwDS;AHyxTX;AmB3gQI;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,chB1wDM;EgB2wDN,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBhBzxDM;AHsyTX;AmBvgQA;EACC,yBAAA;AnBygQD;AmBvgQA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AnBygQD;AmBxgQC;EACC,gBAAA;AnB0gQF;AmBzgQE;EACC,chBryDQ;EgBsyDR,eAAA;EACA,gBhB38DkB;EgB48DlB,gBAAA;AnB2gQH;AmBvgQA;EACC,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,ehBpnDc;EgBqnDd,yBAAA;EAGA,iBAAA;EACA,ehB5nDc;EgB6nDd,gBhB39DoB;EgB49DpB,chBpzDU;EgBqzDV,kBAAA;AnBygQD;AmBxgQC;EACC,kBAAA;EACA,UAAA;EACA,eAAA;AnB0gQF;AmBvgQI;EACC,yBhB9zDM;AHu0TX;AmBxgQK;EACC,cAAA;AnB0gQN;AmBngQE;EACC,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AnBqgQH;AmBjgQA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBhB59DO;EgB69DP,yBAAA;EACA,kBAAA;AnBmgQD;AmBlgQC;EACC,WAAA;EACA,kBAAA;EACA,aAAA;AnBogQF;AmBhgQC;EACC,chBj2DS;EgBk2DT,ehB9qDa;EgB+qDb,gBhB1gEmB;AH4gUrB;AmB9/PC;EACC,oCAAA;AnBggQF;AmB5/PC;EACC,kCAAA;AnB8/PF;AmB3/PA;EACC,kBAAA;EACA,qBAAA;AnB6/PD;AmB3/PA;EACC,mBAAA;AnB6/PD;AmB3/PA;EACC,mBAAA;EACA,aAAA;EACA,mBAAA;AnB6/PD;AmB3/PA;EACC,sBAAA;EACA,uBAAA;EACA,sBAAA;AnB6/PD;AmB1/PC;EACC,WAAA;EACA,qBAAA;EACA,gBAAA;AnB4/PF;AmB3/PE;EACC,eAAA;EACA,YAAA;AnB6/PH;AmBz/PA;EACC,iBAAA;AnB2/PD;AmB1/PC;EACC,ehB1tDa;EgB2tDb,gBhBtjEqB;EgBujErB,chBj5DS;EgBk5DT,kBAAA;AnB4/PF;AmBx/PC;EACC,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnB0/PF;AmBv/PE;EACC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AnBy/PH;AmB//PC;EAQC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnB0/PF;AmBx/PG;EACC,mBhB5kEM;EgB6kEN,kBAAA;EACA,chBj7DO;EgBk7DP,WhBxjEI;AHkjUR;AmBx/PG;EACC,iBAAA;EACA,ehBlwDW;EgBmwDX,chBv7DO;EgBw7DP,gBhB/lEiB;EgBgmEjB,SAAA;EACA,kBAAA;EACA,mBhB/1DM;EgBg2DN,chB57DO;EgB67DP,kBAAA;AnB0/PJ;AmBz/PI;EACC,iBAAA;AnB2/PL;AmBt/PG;EACC,uBAAA;EACA,kBAAA;AnBw/PJ;AmBv/PI;EACC,kBAAA;EACA,WAAA;AnBy/PL;AmBt/PK;EACC,ehBrxDS;EgBsxDT,WhBplEE;AH4kUR;AmB3/PI;EAKC,kBAAA;EACA,WhBvlEG;EgBwlEH,eAAA;EACA,gBhB1nEgB;EgB2nEhB,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AnBy/PL;AmBr/PM;EACC,chBp+DI;AH29TX;AmBj/PI;EACC,iBAAA;AnBm/PL;AmB7+PA;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AnB++PD;AmB9+PC;EACC,gBAAA;AnBg/PF;AmB7+PA;EAGC,aAAA;EAGA,mBAAA;AnB++PD;AmB9+PC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;AnBg/PF;AmB/+PE;EACC,ehBv1DY;AHw0Tf;AmB5+PC;EACC,UAAA;EACA,gBAAA;EAGA,aAAA;EAGA,mBAAA;AnB8+PF;AmB7+PE;EACC,gBAAA;EACA,chBjiEQ;EgBkiER,ehB92DY;EgB+2DZ,gBhB3sEkB;EgB4sElB,kBAAA;AnB++PH;AmB9+PG;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;AnBg/PJ;AmB7+PI;EACC,aAAA;AnB++PL;AmB3+PE;EACC,kBAAA;AnB6+PH;AmB1+PC;EACC,chBzjES;EgB0jET,ehBr4Da;EgBs4Db,gBhBluEmB;AH8sUrB;AmBx+PC;EACC,chBhkES;AH0iUX;AmBv+PA;EACC,gBAAA;AnBy+PD;AmBx+PC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnB0+PF;AmBx+PC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB0+PF;AmBz+PE;EACC,WAAA;AnB2+PH;AmB1+PG;EACC,chBjtEK;EgBktEL,ehB35DW;AHu4Tf;AmBz+PE;EACC,iBAAA;AnB2+PH;AmBx+PC;EACC,gBhBhwEqB;EgBiwErB,WhBhuEM;EgBiuEN,ehBv6Da;EgBw6Db,mBAAA;AnB0+PF;AmBv+PA;EAGC,aAAA;EAGA,mBAAA;EACA,mBAAA;AnBy+PD;AmBr+PE;EACC,chB5mEQ;EgB6mER,ehBx7DY;EgBy7DZ,gBhBrxEkB;EgBsxElB,kBAAA;AnBu+PH;AmBn+PE;EACC,chBpnEQ;EgBqnER,ehBj8DY;EgBk8DZ,gBhB9xEkB;EgB+xElB,qBAAA;AnBq+PH;AmBj+PE;EACC,chB7nEQ;AHgmUX;AmB99PC;EACC,chBnoES;EgBooET,gBhB1yEmB;AH0wUrB;AmB79PA;EACC,cAAA;AnB+9PD;AmB99PC;EACC,kBAAA;EACA,kBAAA;AnBg+PF;AmB59PC;EACC,gBhBrzEqB;EgBszErB,WhBrxEM;EgBsxEN,ehB59Da;EgB69Db,mBAAA;AnB89PF;AmBn+PA;EAOC,gBAAA;AnB+9PD;AmB99PC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnBg+PF;AmB99PC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnBg+PF;AmB/9PE;EACC,chBlqEQ;EgBmqER,gBhBv0EkB;AHwyUrB;AmB/9PE;EACC,gBAAA;AnBi+PH;AmB99PC;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AnBg+PF;AmB/9PE;EACC,UAAA;EACA,QAAA;EACA,SAAA;AnBi+PH;AmB99PC;EACC,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBhB9rES;EgBgsET,gBAAA;AnBg+PF;AmB/9PE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,sBhB10EK;EgB40EL,gBAAA;AnBi+PH;AmB79PE;EACC,yBhB70EI;AH4yUP;AmB99PG;EAGC,2BAAA;AnBg+PJ;AmB79PE;EACC,2BAAA;AnB+9PH;AmB59PC;EACC,mBAAA;AnB89PF;AmB79PE;EACC,kBAAA;AnB+9PH;AmB39PA;EACC,gBAAA;EACA,aAAA;EACA,oBAAA;AnB69PD;AmB59PC;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnB89PF;AmB59PC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB89PF;AmB79PE;EACC,WAAA;EACA,cAAA;EACA,WAAA;AnB+9PH;AmB79PE;EACC,cAAA;EACA,WAAA;EACA,gBhBz5EkB;EgB05ElB,kBAAA;AnB+9PH;AmB99PG;EACC,chBx4EK;EgBy4EL,kBAAA;AnBg+PJ;AmB/9PI;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,ehBrkEU;AHsiUf;AmB79PE;EACC,gBAAA;AnB+9PH;AmB39PA;EACC,gBhB36EsB;EgB46EtB,gBAAA;AnB69PD;AmB59PC;EACC,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WhBl5EM;EgBm5EN,gBAAA;EACA,eAAA;EACA,mBAAA;AnB89PF;AmB39PA;EACC,iBAAA;AnB69PD;AmB59PC;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnB89PF;AmB39PA;EACC,iBAAA;AnB69PD;AmB39PE;EACC,0BAAA;EACA,aAAA;EACA,mBAAA;AnB69PH;AmB19PC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB49PF;AmB39PE;EACC,yBAAA;EACA,kBAAA;EACA,sBhBh7EK;EgBi7EL,aAAA;AnB69PH;AmB39PE;EACC,gBAAA;AnB69PH;AmBz9PE;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,ehBjoEY;EgBkoEZ,gBhB99EkB;EgB+9ElB,kBAAA;EACA,chBzzEQ;AHoxUX;AmBz9PE;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,chBh0EQ;EgBi0ER,ehB7oEY;EgB8oEZ,gBhB1+EkB;AHq8UrB;AmB5+PC;EAmBC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;AnB49PF;AmB19PC;EACC,qBAAA;EACA,chB90ES;EgB+0ET,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBhBx/EmB;EgBy/EnB,mBAAA;AnB49PF;AmB39PE;EACC,mBAAA;EACA,WhB39EK;AHw7UR;AmBz9PA;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnB29PD;AmB19PC;EACC,mBAAA;EACA,ehB1qEa;EgB2qEb,gBhBvgFmB;EgBwgFnB,chBj2ES;EgBo2ET,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnB49PF;AmBz9PA;EACC,iBAAA;EACA,oBAAA;AnB29PD;AmBx9PC;EACC,aAAA;EACA,mBAAA;EACA,YAAA;AnB09PF;AmBz9PE;EACC,chB33EQ;AHs1UX;AmBt9PC;EACC,chB73ES;AHq1UX;AmBr9PA;EACC,WAAA;EACA,YAAA;EACA,yBhBrgFM;EgBsgFN,yBAAA;EACA,kBAAA;EACA,WhB5gFO;EgB6gFP,ehBjtEc;EgBktEd,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AnBu9PD;AmBt9PC;EACC,WhBthFM;AH8+UR;AmBt9PC;EACC,WhBzhFM;AHi/UR;AmBp9PC;EACC,WhB9hFM;AHo/UR;AmBp9PC;EACC,WhBjiFM;AHu/UR;AmB39PA;EAOC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBhBj6EU;EgBk6EV,WhBviFO;EgBwiFP,eAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;AnBu9PD;AmBn9PE;EACC,chB/6EQ;EgBg7ER,SAAA;EACA,mBAAA;EACA,gBhBxlFkB;EgBylFlB,iBAAA;AnBq9PH;AmBp9PG;EACC,chBr7EO;AH24UX;AmBn9PE;EACC,iBAAA;AnBq9PH;AmBn9PE;EACC,uCAAA;EACA,chB77EQ;AHk5UX;AmBl9PC;EACC,oBAAA;EACA,kBAAA;AnBo9PF;AmBn9PE;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,yBhB78EQ;EgB88ER,WAAA;AnBq9PH;AmBh9PA;EACC,YAAA;AnBk9PD;AmB/8PA;EACC,kBAAA;AnBi9PD;AmB98PA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnBg9PD;AmB78PA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnB+8PD;AmB58PA;EACC,mBAAA;AnB88PD;AmB38PA;EACC,gBAAA;AnB68PD;AmB18PA;EACC,YAAA;EACA,aAAA;AnB48PD;AmBz8PA;EACC,iBAAA;EACA,gBAAA;AnB28PD;AmBx8PA;EACC,iBAAA;AnB08PD;AmBv8PA;EACC,YAAA;EACA,aAAA;AnBy8PD;AmBt8PA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oCAAA;EACA,iBAAA;EACA,ehB90Ec;AHsxUf;AmBr8PA;EACC,WhBjpFO;AHwlVR;AmBp8PA;EACC,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;AnBs8PD;AmBn8PA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;AnBq8PD;AmBl8PA;EACC,eAAA;AnBo8PD;AmBj8PA;EACC,qBAAA;AnBm8PD;AmBh8PA;EACC,yBAAA;EACA,qBAAA;AnBk8PD;AmB/7PA;EACC,qBAAA;AnBi8PD;AmB97PA;EACC,kBAAA;AnBg8PD;AmB77PA;EACC,gBAAA;EACA,qBAAA;AnB+7PD;AmB57PA;EACC,iBAAA;AnB87PD;AmB37PA;EACC,yBAAA;AnB67PD;AmB17PA;EACC,sBAAA;AnB47PD;AmBz7PA;EACC,2BAAA;EACA,gCAAA;AnB27PD;AmBx7PA;EACC,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AnB07PD;AmBv7PA;EACC,WhBrtFO;EgBstFP,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBhB9vFsB;AHurVvB;AmBt7PA;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;AnBw7PD;AmBr7PA;;EAEC,WAAA;EACA,YAAA;EACA,iBAAA;AnBu7PD;AmBp7PA;EACC,cAAA;EACA,aAAA;AnBs7PD;AmBn7PA;EACC,ehB57Ec;AHi3Uf;AmBl7PA;EACC,cAAA;EACA,aAAA;AnBo7PD;AmBj7PA;EACC,eAAA;AnBm7PD;AmBh7PA;EACC,aAAA;EACA,YAAA;AnBk7PD;AmB/6PA;EACC,kBAAA;AnBi7PD;AmB96PA;EACC,eAAA;EACA,mBAAA;AnBg7PD;AmB76PA;EACC,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,wBAAA;EACA,gCAAA;EACA,4BAAA;AnB+6PD;AmB56PA;EACC,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnB86PD;AmB36PA;EACC,gCAAA;EACA,oBAAA;AnB66PD;AmB16PA;EACC,gBAAA;AnB46PD;AmBz6PA;EACC,ehBl/Ec;AH65Uf;AmBt6PA;EACC,gBhBn1FoB;EgBo1FpB,cAAA;EACA,ehBx/Ec;EgBy/Ed,kBAAA;AnBw6PD;AmBr6PA;EACC,gBAAA;EACA,gBAAA;AnBu6PD;AmBp6PA;EACC,cAAA;EACA,SAAA;EACA,UAAA;AnBs6PD;AmBn6PA;EACC,ehBtgFc;AH26Uf;AmBl6PA;EACC,uBAAA;EACA,SAAA;AnBo6PD;AmBj6PA;EACC,sBAAA;AnBm6PD;AmBh6PA;EACC,sBAAA;AnBk6PD;AmB/5PA;EACI,eAAA;AnBi6PJ;AmB95PA;EACC,mBAAA;AnBg6PD;AmB75PA;EACI,qBAAA;AnB+5PJ;AmB55PA;EACI,eAAA;AnB85PJ;AmB55PA;EACC,aAAA;AnB85PD;AmB55PA;EACC,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AnB85PD;AmB55PA;EACC,UAAA;EACA,mBAAA;AnB85PD;AmB35PA;EACC,ehBxjFc;EgByjFd,gBhBl5FkB;EgBm5FlB,yBAAA;EACA,cAAA;EACA,gBAAA;AnB65PD;AmB15PA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,WhB93FO;EgB+3FP,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;AnB45PD;AmBz5PA;EACC,gBAAA;EACA,UAAA;EACA,SAAA;AnB25PD;AmBx5PA;EACC,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACG,uBAAA;EACA,+BAAA;AnB05PJ;AmBv5PA;EACC,iBAAA;AnBy5PD;AmBt5PA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,ehBtmFc;AH8/Uf;AmBt5PA;EACE,yBAAA;EACA,qBAAA;AnBw5PF;AmBr5PA;EACC,cAAA;EACA,gBhB98FoB;AHq2VrB;AmBp5PA;EACC,sBAAA;AnBs5PD;AmBp5PA;EAGI,aAAA;EAGH,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AnBs5PD;AmBp5PA;EACC,gBAAA;EACA,ehBpoFc;EgBqoFd,gBhBl+FsB;EgBq+FnB,aAAA;EAGH,mBAAA;AnBs5PD;AmBp5PA;EACC,ehB5oFc;AHkiVf;AmBp5PA;EACC,gBAAA;EACA,chBt+FS;EgBu+FT,gBhBj/FoB;AHu4VrB;AmBp5PA;EACC,cAAA;AnBs5PD;AmBn5PA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;AnBq5PD;AmBl5PA;EACC,eAAA;EACA,YAAA;EACA,mBAAA;AnBo5PD;AmBj5PA;EACC,cAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;AnBm5PD;AmBh5PA;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AnBk5PD;AmB/4PA;;EAEC,ehB/rFc;AHglVf;AmB94PA;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AnBg5PD;AmB74PA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AnB+4PD;AmB54PA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,WhB/gGO;EgBghGP,aAAA;EACA,mBAAA;EACA,uBAAA;AnB84PD;AmB34PA;;;EAGC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AnB64PD;AmB14PA;EACC,yBAAA;AnB44PD;AmBz4PA;EACC,yBAAA;AnB24PD;AmBx4PA;EACC,yBAAA;AnB04PD;AmBv4PA;EACC,4BAAA;AnBy4PD;AmBt4PA;EACC,6BAAA;AnBw4PD;AmBr4PA;EACC,ehB1vFc;AHioVf;AmBp4PA;EACC,cAAA;EACA,eAAA;AnBs4PD;AmBn4PA;EACC,4BAAA;AnBq4PD;AmBl4PA;EACC,6BAAA;AnBo4PD;AmBj4PA;EACC,eAAA;AnBm4PD;AmBh4PA;;;EAGC,iBAAA;AnBk4PD;AmB/3PA;EACC,aAAA;EACA,cAAA;AnBi4PD;AmB93PA;EACC,4BAAA;AnBg4PD;AmB73PA;EACC,6BAAA;AnB+3PD;AmB53PA;EACC,ehBpyFc;AHkqVf;AmB33PA;;;EAGC,iBAAA;AnB63PD;AmB13PA;EACC,cAAA;EACA,eAAA;AnB43PD;AmBz3PA;EACC,4BAAA;AnB23PD;AmBx3PA;EACC,6BAAA;AnB03PD;AmBv3PA;EACC,ehBtzFc;AH+qVf;AmBt3PA;;;EAGC,iBAAA;AnBw3PD;AmBr3PA;EACC,WAAA;EACA,YAAA;AnBu3PD;AmBp3PA;EACC,4BAAA;AnBs3PD;AmBn3PA;EACC,6BAAA;AnBq3PD;AmBl3PA;EACC,ehB30Fc;AH+rVf;AmBj3PA;;;EAGC,iBAAA;AnBm3PD;AmBh3PA;EACC,eAAA;EACA,gBAAA;AnBk3PD;AmB/2PA;EACC,4BAAA;AnBi3PD;AmB92PA;EACC,6BAAA;AnBg3PD;AmB72PA;EACC,ehBj2Fc;AHgtVf;AmB52PA;;;EAGC,iBAAA;AnB82PD;AmB32PA;EACC,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AnB62PD;AmB12PA;EACC,qBAAA;AnB42PD;AmBz2PA;EACC,kBAAA;AnB22PD;AmBx2PA;EACC,sBAAA;AnB02PD;AmBv2PA;EACC,kBAAA;AnBy2PD;AmBt2PA;EACC,wBAAA;AnBw2PD;AmBr2PA;EACC,UAAA;AnBu2PD;AmBp2PA;EACC,cAAA;AnBs2PD;AmBn2PA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;AnBq2PD;AmBl2PA;EACC,eAAA;AnBo2PD;AmBj2PA;EACC,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;AnBm2PD;AmBh2PA;EACC,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;AnBk2PD;AmB/1PA;EACC,yBAAA;AnBi2PD;AmB91PA;EACC,eAAA;AnBg2PD;AmB71PA;EACC,YAAA;EACA,cAAA;AnB+1PD;AmB51PA;EACC,iBAAA;EACA,eAAA;AnB81PD;AmB31PA;EACC,mBAAA;AnB61PD;AmB11PA;EACC,mBAAA;AnB41PD;AmBz1PA;EACC,mBAAA;AnB21PD;AmBx1PA;EACC,mBAAA;AnB01PD;AmBv1PA;EACC,mBAAA;AnBy1PD;AmBt1PA;EACC,mBAAA;AnBw1PD;AmBr1PA;EACC,mBAAA;AnBu1PD;AmBp1PA;EACC,mBAAA;AnBs1PD;AmBn1PA;EACC,kBAAA;AnBq1PD;AmBl1PA;EACC,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AnBo1PD;AmBj1PA;EACC,ehBh/Fc;AHm0Vf;AmBh1PA;EACI,gBAAA;EACA,gBAAA;EACA,yBAAA;AnBk1PJ;AmBh1PA;EACI,yBAAA;AnBk1PJ;AmBh1PA;EACC,aAAA;EACA,yBhB90GS;AHgqWV;AmBh1PA;EACC,yBhBj1GS;AHmqWV;AmB/0PA;EACC,aAAA;AnBi1PD;AmB90PA;EACC,iBAAA;AnBg1PD;AmB70PA;EACC,qBAAA;AnB+0PD;AmB50PA;EACC,aAAA;EACA,gBAAA;AnB80PD;AmB30PA;EACC,aAAA;EACA,qBAAA;AnB60PD;AI3pWI;Ee40GJ;IAIE,cAAA;EnB+0PA;AACF;AmB50PA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AnB80PD;AIxqWI;Eeo1GJ;IAQE,WAAA;EnBg1PA;AACF;AI7qWI;Eei2GH;IAEE,wBAAA;EnB80PD;AACF;AmB30PA;EACC,gBhB12GO;EgB22GP,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,0CAAA;AnB60PD;AI3rWI;Eeu2GJ;IASE,sBAAA;EnB+0PA;AACF;AmB50PA;EACC,aAAA;AnB80PD;AmB30PA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBhB95GsB;EgB+5GtB,yBAAA;AnB60PD;AmB10PA;EACC,wBAAA;AnB40PD;AmBz0PA;EACC,ehBxkGc;AHm5Vf;AmBx0PA;EACC,gBAAA;EACA,aAAA;AnB00PD;AmBv0PA;EACC,2BAAA;AnBy0PD;AmBt0PA;EACC,gBAAA;AnBw0PD;AmBr0PA;EACC,gBAAA;EACA,WAAA;EACA,6BAAA;AnBu0PD;AmBp0PA;EACC,0BAAA;AnBs0PD;AmBn0PA;EACC,SAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;AnBq0PD;AmBn0PA;EACC,iBAAA;AnBq0PD;AmBn0PA;EACC,gBhB38GsB;EgB48GtB,cAAA;EACA,ehBhnGc;EgBinGd,gBAAA;AnBq0PD;AmBl0PA;EACC,kBAAA;AnBo0PD;AmBj0PA;EACC,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AnBm0PD;AmBh0PA;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AnBk0PD;AmB/zPA;EACC,WhBv8GO;EgBw8GP,qBAAA;AnBi0PD;AmB9zPA;EACC,aAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnBg0PD;AmB7zPA;EACC,0CAAA;EACA,0CAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AnB+zPD;AmB5zPA;EACC,yBAAA;AnB8zPD;AmB3zPA;EACC,kBAAA;AnB6zPD;AmB1zPA;EACC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AnB4zPD;AmBzzPA;EACC,cAAA;AnB2zPD;AmBxzPA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AnB0zPD;AmBxzPA;EACC,2BAAA;EACA,aAAA;EACA,mBAAA;AnB0zPD;AmBvzPA;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,ehB3sGc;EgB4sGd,gBhBxiHoB;EgByiHpB,kBAAA;EACA,cAAA;AnByzPD;AmBtzPA;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,ehBxtGc;AHghWf;AmBtzPA;EACC,cAAA;AnBwzPD;AmBtzPA;EACC,kBAAA;EACA,kBAAA;AnBwzPD;AmBrzPA;EACC,yBAAA;EACA,gBhBhkHoB;EgBikHpB,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AnBuzPD;AmBrzPA;EACC,cAAA;AnBuzPD;AmBpzPA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,yBhB1kHS;EgB2kHT,WhBpjHO;EgBqjHP,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AnBszPD;AmBnzPA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;AnBqzPD;AmBlzPA;EACC,WhB3kHO;AH+3WR;AmBjzPA;EACC,WhB/kHO;AHk4WR;AmBhzPA;EACC,0CAAA;AnBkzPD;AmB/yPA;EACC,cAAA;AnBizPD;AmB9yPA;EACC,2BAAA;AnBgzPD;AmB9yPA;EAGI,aAAA;EAGH,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,kBAAA;AnBgzPD;AmB/yPC;EACC,cAAA;AnBizPF;AmB9yPA;EACC,WAAA;AnBgzPD;AmB9yPA;EACC,cAAA;AnBgzPD;AmB9yPA;EACC,gBAAA;AnBgzPD;AmB9yPA;EACC,kBAAA;AnBgzPD;AmB9yPA;EACC,aAAA;EACA,mBAAA;EACA,cAAA;EACA,ehB/zGc;EgBg0Gd,gBhB9pHoB;AH88WrB;AmB9yPA;EACC,ehBp0Gc;AHonWf;AmB7yPA;EACC,iBAAA;AnB+yPD;AmB7yPA;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;AnB+yPD;AmB7yPA;EACC,ehBh1Gc;EgBi1Gd,gBhB7qHoB;EgB8qHpB,cAAA;EACA,mBAAA;EAGG,aAAA;EAGH,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AnB+yPD;AmB7yPA;EACC,yBAAA;AnB+yPD;AmB7yPA;EACC,cAAA;EACA,ehBl2Gc;EgBm2Gd,gBhBjsHoB;EgBksHpB,mBAAA;AnB+yPD;AmB7yPA;EACC,cAAA;EACA,eAAA;EACA,gBhBvsHoB;EgBwsHpB,kBAAA;AnB+yPD;AmB7yPA;EACC,eAAA;EACA,cAAA;EACA,gBhB7sHoB;EgB8sHpB,gBAAA;AnB+yPD;AmB7yPA;EACC,gBAAA;AnB+yPD;AmB7yPA;EACC,cAAA;EACA,ehBz3Gc;EgB03Gd,gBhBrtHoB;AHogXrB;AmB7yPA;EACC,cAAA;AnB+yPD;AmB7yPA;EACC,mBAAA;AnB+yPD;AmB7yPA;EACC,cAAA;AnB+yPD;AmB7yPA;EACC,mBAAA;AnB+yPD;AmB7yPA;EACC,cAAA;AnB+yPD;AmB7yPA;EACC,mBAAA;AnB+yPD;AmB7yPA;EACC,cAAA;AnB+yPD;AmB7yPA;EACC,WAAA;EACA,YAAA;AnB+yPD;AmB7yPA;EACC,ehBt5Gc;EgBu5Gd,gBhBnvHoB;EgBovHpB,cAAA;EACA,gBAAA;AnB+yPD;AmB7yPA;EACC,mBAAA;AnB+yPD;AmB7yPA;EACC,cAAA;AnB+yPD;AmB7yPA;EACC,aAAA;AnB+yPD;AmB7yPA;EACC,iBAAA;AnB+yPD;AmB7yPA;EACC,cAAA;AnB+yPD;AmB7yPA;EACC,gBhBrwHsB;EgBswHtB,cAAA;EACA,ehB16Gc;AHytWf;AmB7yPA;EACC,ehBh7Gc;EgBi7Gd,gBhB7wHoB;EgB8wHpB,cAAA;AnB+yPD;AmB7yPA;EACC,0BAAA;AnB+yPD;AmB7yPA;EACC,0BAAA;AnB+yPD;AmB7yPA;EACC,gBhBrvHO;EgBsvHP,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AnB+yPD;AmB7yPA;EACC,aAAA;AnB+yPD;AmB7yPA;EACC,mBAAA;EACA,ehBr8Gc;EgBs8Gd,gBhBnyHoB;EgBoyHpB,cAAA;AnB+yPD;AmB7yPA;EACC,cAAA;EACA,ehB78Gc;EgB88Gd,gBhB1yHoB;AHylXrB;AmB7yPA;EACC,mBAAA;AnB+yPD;AmB7yPA;EACC,UAAA;AnB+yPD;AmB7yPA;EACC,kBAAA;AnB+yPD;AmB7yPA;EACC,kBAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;AnB+yPD;AmB7yPA;EAGI,aAAA;EAGH,mBAAA;AnB+yPD;AmB7yPA;EACC,iBAAA;AnB+yPD;AmB7yPA;EACC,6BAAA;EACA,WhBvyHO;AHslXR;AmB7yPA;EACC,cAAA;AnB+yPD;AmB7yPA;EACC,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACG,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;AnB+yPJ;AmB7yPA;EAGI,aAAA;EAGH,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AnB+yPD;AmB7yPA;EACC,UAAA;AnB+yPD;AmB7yPA;EACC,mBAAA;AnB+yPD;AmB7yPA;EACC,ehB3gHc;EgB4gHd,cAAA;AnB+yPD;AmB7yPA;EACC,qCAAA;AnB+yPD;AmB7yPA;EACC,aAAA;EACA,iBAAA;AnB+yPD;AmB7yPA;EACC,ehBzhHc;EgB0hHd,gBhBt3HoB;EgBu3HpB,cAAA;AnB+yPD;AmB7yPA;EACC,aAAA;AnB+yPD;AmB7yPA;EACC,kBAAA;AnB+yPD;;AmBzyPQ;EACI,sBhBn2HJ;EgBo2HI,gCAAA;AnB4yPZ;AmBzyPI;EACI,oCAAA;AnB2yPR;;AmBvyPI;EACI,aAAA;AnB0yPR;;AmBryPQ;EftzHL,SeuzHiC;EftzHjC,mBeszHmC;EAC1B,YAAA;AnByyPZ;AmBvyPQ;EAGL,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACS,chBzvHD;EgB0vHC,oBAAA;EACA,UAAA;Ef30HV,kBe40H4B;Ef30H5B,Me20HqC;Ef10HrC,We00HuC;Efz0HvC,Sey0H4C;AnB4yP9C;;AmBvyPI;EACI,+BAAA;EACA,gBAAA;EACA,UAAA;AnB0yPR;AmBzyPQ;EACI,gCAAA;Ef90HT,Se+0HiC;Ef90HjC,ae80HmC;Ef31HpC,oBe41H8B;AnB8yPhC;AmB7yPY;EACI,yBhBhxHL;AH+jXX;AmB7yPY;EACI,yBhBnxHL;AHkkXX;AmB7yPY;Efv1HT,kBew1HqC;EACxB,kBAAA;AnB+yPhB;AmB9yPgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AnBgzPpB;AmB7yPY;EAGF,aAAA;EACA,8BAAA;EACH,sCAAA;EACA,4BAAA;AnB+yPP;AmB9yPgB;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,chBlyHT;EgBmyHS,ehB7mHL;EgB8mHK,gBhBz8HD;AHyvXnB;AmB9yPgB;EACI,chBxyHT;EgByyHS,ehBr9HH;EgBs9HG,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnBgzPpB;AmB9yPgB;EACI,chBnzHT;EgBozHS,ehB9nHL;AH86Wf;AmB7yPoB;EACI,iBAAA;AnB+yPxB;;AmBvyPA;Efn5HE,oBeo5HsB;AnB4yPxB;AmB3yPI;EACI,+BAAA;EACA,gBAAA;AnB6yPR;AmBzyPQ;EACI,aAAA;Efh5HT,mBei5HiC;Efh5HjC,eeg5H8C;AnB4yPjD;AmBzyPI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AnB2yPR;AmB1yPQ;EACI,YAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;AnB4yPZ;AmBzyPI;Ef/5HD,qBeg6H6B;Ef/5H7B,Ue+5H2C;EACtC,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnB4yPR;AmB1yPI;Eft6HD,ceu6H6B;Eft6H7B,Ues6HoC;EAC/B,WAAA;AnB6yPR;AmB3yPY;EACI,mBAAA;AnB6yPhB;AmB5yPgB;EACI,QAAA;EACA,YAAA;EACA,WAAA;AnB8yPpB;AmB5yPgB;EAGL,aAAA;EAGJ,qBAAA;EAEA,sBAAA;Efz7HJ,kBe07HyC;Efz7HzC,Uey7HqD;AnB+yPxD;AmB9yPoB;Ef37HjB,Se47H6C;Ef37H7C,mBe27H+C;EAC1B,kBAAA;AnBizPxB;AmBhzPwB;Ef97HrB,ee+7HiD;Ef97HjD,Ue87HyD;AnBmzP5D;AmBjzPwB;Efj8HrB,Sek8HiD;Efj8HjD,Uei8HmD;AnBozPtD;AmBlzPwB;EACI,oCAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;Efn9H1B,kBeo9H4C;Efn9H5C,Mem9HqD;Efl9HrD,Yek9HuD;Efh9HvD,Ueg9HkE;AnBuzPpE;AmBrzPuB;Ef98HpB,Se+8HiD;Ef98HjD,kBe88HmD;Efv7HpD,mBew7H2C;EACjB,yBAAA;EACA,qBAAA;EACA,kBAAA;AnBwzP5B;AmBtzPwB;Ef77HtB,+Be87H2C;AnBwzP7C;AmBrzPoB;EAGR,aAAA;Ef59HT,ce69H6C;Ef59H7C,ce49HoD;EAC/B,WAAA;AnBwzPxB;AmBvzPwB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AnByzP5B;AmBxzP4B;Ef3+H1B,kBe4+HgD;Ef3+HhD,Me2+HyD;Ef1+HzD,Qe0+H2D;Efz+H3D,Sey+H6D;Efx+H7D,Oew+H+D;EACjC,gBhBhiIxB;EgBiiIwB,WAAA;EACA,YAAA;Efn/H9B,oBeo/HkD;AnBg0PpD;AmB7zPgC;EACI,UAAA;AnB+zPpC;AmB3zPuB;EACK,aAAA;AnB6zP5B;AmB1zPwB;EACI,eAAA;AnB4zP5B;AmB1zPwB;Ef//HtB,kBeggI4C;Ef//H5C,Qe+/HqD;Ef5/HrD,Se4/HmE;EACzC,gCAAA;EACA,UAAA;EftgI1B,oBeugI8C;EACpB,WhBxjIpB;EgByjIoB,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;AnBg0P5B;AmB7zPoB;EAGZ,aAAA;EACa,mBAAA;EACb,yBAAA;EACA,sBAAA;EfzgIL,ee0gI6C;EfzgI7C,UeygIqD;EAEhD,eAAA;EACgB,WAAA;EACA,2BAAA;EACA,gBAAA;AnBg0PxB;AmB/zPwB;EfhhIrB,SeihIiD;EfhhIjD,mBeghImD;EAC1B,kBAAA;AnBk0P5B;AmBh0P4B;Ef5hI1B,kBe6hIgD;Ef5hIhD,Qe4hIyD;Ef3hIzD,We2hI6D;EfzhI7D,SeyhIuE;EACzC,gCAAA;EACA,mBhB1mItB;EgB2mIsB,WAAA;EACA,WAAA;EACA,UAAA;AnBq0PhC;AmBl0PwB;EACI,4BAAA;AnBo0P5B;AmBl0PwB;EACI,chBx9HjB;AH4xXX;AmB/zPY;EACI,kBAAA;EACA,mBAAA;AnBi0PhB;AmBh0PgB;EACI,kBAAA;Ef1iIjB,kBe2iIyC;Ef1iIzC,Ue0iIoD;AnBm0PvD;AmBl0PoB;EACI,oCAAA;EACA,+BAAA;EACA,6BAAA;EACA,kCAAA;EACA,WAAA;EACA,SAAA;Ef1jItB,kBe2jIwC;Ef1jIxC,Qe0jIiD;EfzjIjD,WeyjIqD;EfvjIrD,UeujI+D;EACzC,QAAA;AnBu0PxB;AmBr0PoB;EftjIjB,SeujI6C;EftjI7C,kBesjI+C;Ef/hIhD,mBegiIuC;EACjB,yBhB5oId;EgB6oIc,cAAA;EACA,kBAAA;AnBw0PxB;AmBv0PwB;EACI,WhBznIpB;EC4DL,Se8jIiD;Ef7jIjD,Ue6jImD;AnB00PtD;AmBt0PgB;EACI,cAAA;AnBw0PpB;AmBv0PoB;EACI,eAAA;AnBy0PxB;AmBr0PY;EAGR,aAAA;EACM,mBAAA;EACN,yBAAA;EACA,sBAAA;EAEE,eAAA;EfjlIH,eeklIqC;EfjlIrC,UeilI6C;EAChC,WAAA;EACA,gBAAA;AnBw0PhB;AmBv0PgB;EACI,+BAAA;AnBy0PpB;AmBt0PY;EAGR,aAAA;Ef5lID,ce6lIqC;Ef5lIrC,ce4lI4C;EAC/B,WAAA;AnBy0PhB;AmBx0PgB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;AnB00PpB;AmBz0PoB;Ef3mIlB,kBe4mIwC;Ef3mIxC,Me2mIiD;Ef1mIjD,Qe0mImD;EfzmInD,SeymIqD;EfxmIrD,OewmIuD;EACjC,gBhBhqIhB;EgBiqIgB,WAAA;EACA,YAAA;EfnnItB,oBeonI0C;AnBi1P5C;AmB90PwB;EACI,UAAA;AnBg1P5B;AmB50Pe;EACK,aAAA;AnB80PpB;AmB30PgB;EACI,eAAA;AnB60PpB;AmB30PgB;Ef/nId,kBegoIoC;Ef/nIpC,Qe+nI6C;Ef5nI7C,Se4nI2D;EfrqI3D,gCesqIqC;EfrqIrC,wCeqqIqC;EfpqIrC,oCeoqIqC;EfroIrC,oBesoIsC;EACpB,UAAA;EACA,WhBxrIZ;EgByrIY,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;AnBm1PpB;AmB70PQ;EACI,ehB1uIK;EgB2uIL,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;AnB+0PZ;AmB90PY;EACI,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EfzpId,kBe0pIgC;EfzpIhC,QeypIyC;EfxpIzC,UewpI6C;EAC/B,WAAA;AnBk1PhB;AmBh1PY;EACI,yBAAA;EACA,WAAA;EACA,WAAA;EfxpIb,kBeypIqC;EfjqItC,kBekqIgC;EfjqIhC,QeiqIyC;Ef9pIzC,Se8pIuD;EACzC,WAAA;AnBo1PhB;;AmB90PA;EACI,sBhB9tII;EgB+tIJ,6BAAA;EfnqID,SeoqIyB;EfnqIzB,oBemqI2B;AnBk1P9B;AmBj1PI;EACI,+CAAA;EACA,oBAAA;EACA,gBAAA;AnBm1PR;;AIrjYI;EesuIA;IACI,QAAA;IACA,UAAA;IACA,mBAAA;EnBm1PN;EmBh1PE;If1rIF,kBe2rIwB;IfzrIxB,aeyrIwC;IAClC,UAAA;IACA,kBAAA;IACA,WAAA;EnBm1PN;EmBj1PE;IACI,aAAA;IACA,mBAAA;EnBm1PN;AACF;AmBh1PI;EACI,gBAAA;AnBk1PR;AmBh1PI;EACI,gBhB7xIW;EgB8xIX,chBznIG;EgB0nIH,ehBn8HO;AHqxXf;AIhlYI;Ee2vIA;IAKQ,ehBzyIK;EH6nYf;AACF;AmBl1PI;EACI,gBhBryIW;EgBsyIX,chBjoIG;EgBkoIH,ehB38HO;EgB48HP,kBAAA;AnBo1PR;AI3lYI;EemwIA;IAMQ,ehB98HG;EHoyXb;AACF;AmBp1PI;EACI,ehBtzIS;EgBuzIT,chB5oIG;EgB6oIH,gBhBnzIa;AHyoYrB;AIrmYI;Ee4wIA;IAKQ,ehB39HG;EHmzXb;AACF;AI1mYI;Ee4wIA;IAQQ,ehB99HG;IgB+9HH,mBAAA;EnB01PV;AACF;AmBx1PI;EACI,mBhBlzIE;EgBmzIF,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,UAAA;AnB01PR;AmBz1PQ;EACI,iEAAA;AnB21PZ;AmBx1PI;EACI,iBAAA;AnB01PR;AIroYI;Ee0yIA;IAGQ,cAAA;IACA,gBAAA;EnB41PV;AACF;AmB11PI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBhBj1IE;EgBk1IF,iBAAA;EACA,WhB5zIA;EgB6zIA,gBhB51IW;EgB61IX,ehBpgIO;EgBqgIb,YAAA;EACM,kBAAA;AnB41PR;AmB31PQ;EACI,WhBl0IJ;AH+pYR;AmB31PQ;EACI,+BAAA;AnB61PZ;AIhqYI;EeizIA;IAqBQ,kBAAA;EnB81PV;AACF;AmB71PQ;EACI,mBhB3mIE;AH08Xd;AmB71PQ;EACI,WAAA;EACA,YAAA;AnB+1PZ;AmB51PI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBhBntIG;EgBotIH,iBAAA;EACA,WhB31IA;EgB41IA,gBhB33IW;EgB43IX,ehBniIO;EgBoiIP,kBAAA;EACA,qBAAA;AnB81PR;AmB71PQ;EACI,+BAAA;AnB+1PZ;AI9rYI;Eeg1IA;IAkBQ,kBAAA;EnBg2PV;AACF;AmB/1PQ;EACI,mBhB93IF;AH+tYV;AmB/1PQ;EACI,WAAA;EACA,YAAA;AnBi2PZ;AmB91PI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBhBl4IC;EgBm4ID,iBAAA;EACA,WhBv3IA;EgBw3IA,gBhBv5IW;EgBw5IX,ehB/jIO;EgBgkIP,kBAAA;AnBg2PR;AmB/1PQ;EACI,+BAAA;AnBi2PZ;AI3tYI;Ee42IA;IAiBQ,kBAAA;EnBk2PV;AACF;AmBj2PQ;EACI,mBhB5vID;AH+lYX;AmBj2PQ;EACI,WAAA;EACA,YAAA;AnBm2PZ;AIvuYI;Eeu4IA;IAEQ,yBAAA;EnBk2PV;EmBj2PU;IACI,cAAA;EnBm2Pd;AACF;AI/uYI;Ee84II;IAES,cAAA;IACA,mBAAA;EnBm2Pf;AACF;AmBj2PQ;EACI,cAAA;AnBm2PZ;AmBh2PI;EACI,kBAAA;AnBk2PR;AmBh2PI;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;AnBk2PR;;AmB/1PA;EACI,UAAA;EACA,SAAA;AnBk2PJ;;AmB/1PC;EACC,aAAA;AnBk2PF;AmBh2PC;EACC,mBhB9sIQ;EgB+sIR,kBAAA;EACA,aAAA;AnBk2PF;AmBh2PG;EACC,mBhB58IM;EgB68IN,WAAA;EACA,YAAA;EACA,mBAAA;EAGY,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnBk2PhB;AmBj2PI;EACC,mBAAA;EACA,sBAAA;AnBm2PL;AmB/1PE;EACC,mBAAA;EACA,YAAA;EACA,aAAA;AnBi2PH;AmBh2PG;EACC,kBAAA;AnBk2PJ;;AmB71PA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;AnBg2PJ;AmB/1PC;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,sBhB19IM;EgB29IN,cAAA;EACA,YAAA;Efh6IC,aei6IuB;Efz4IxB,kBe04IiB;AnBi2PnB;AmBh2PE;EACC,qCAAA;AnBk2PH;AmBh2PE;EACC,qCAAA;AnBk2PH;AmBh2PE;EACC,qCAAA;AnBk2PH;;AmB91PA;EACC;IACC,UAAA;EnBi2PA;AACF;AmB71PC;EACC,WAAA;AnB+1PF;AmB71PC;EACC,chBxgJQ;AHu2YV;AmB71PC;EACC,chBrgJO;AHo2YT;;AmB31PC;EACC,aAAA;AnB81PF;AmB51PC;EACC,mBhB9xIQ;EgB+xIR,kBAAA;EACA,aAAA;AnB81PF;AmB51PG;EACC,mBhB5hJM;EgB6hJN,WAAA;EACA,YAAA;EACA,mBAAA;EAGY,aAAA;EACA,mBAAA;EACZ,sBAAA;EACY,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AnB81PhB;AmB71PI;EACC,mBAAA;EACA,sBAAA;AnB+1PL;AmB31PE;EACC,mBAAA;EACA,YAAA;EACA,aAAA;AnB61PH;AmB51PG;EACC,kBAAA;AnB81PJ;;AmBv1PE;EACC,ehB5uIY;EgB6uIZ,WhBtiJK;EgBuiJL,mBAAA;AnB01PH;AmBz1PG;EACC,cAAA;EACA,chB50IS;AHuqYb;AmBz1PG;EACC,gBAAA;AnB21PJ;;AIv4YI;EeijJJ;IAEG,wBAAA;EnBy1PD;AACF;;AI74YI;EesjJJ;IAEG,mBAAA;EnB01PD;AACF;;AoB77YG;EACC,WAAA;EACA,aAAA;ApBg8YJ;;AoB37YA;EACC,cAAA;ApB87YD;;AoB57YA;EACC,SAAA;ApB+7YD;;AoB17YE;EACI,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBhBiB;AH68YvB;AoB17YE;EACC,WjBYK;AHg7YR;AoBz7YC;EACC,oCjBnBoB;AH88YtB;;AoBv7YE;EACI,cjByIK;EiBxIL,yBAAA;EACA,iBAAA;EACA,kBjBwSa;EiBvSb,aAAA;EACA,mBAAA;EACA,6DAAA;ApB07YN;;AoBv7YA;EACE,qBjBoHU;EiBnHV,qDAAA;EACA,mBAAA;EACA,cjBqNW;EiBpNX,sBjBXM;EiBYN,UAAA;EACA,WAAA;ApB07YF;;AoBx7YA;EACE,qBjB2GU;AHg1YZ;;AoBx7YA;EACE,cjB2MW;AHgvYb;;AoBz7YA;EACE,cjBwMW;AHovYb;;AoB17YA;EACE,cjBqMW;EiBpMX,kBAAA;EACA,yBAAA;EACA,oBAAA;ApB67YF;AoB37YE;EAEE,cjB8LS;EiB7LT,YAAA;ApB47YJ;AoBz7YI;EAGE,cjB/DI;EiBgEJ,wCAAA;ApBy7YN;AoBt7YE;EACE,oCAAA;ApBw7YJ;;AoBr7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBxFqB;AHghZvB;;AoBt7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBlGqB;AH2hZvB;;AoBt7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjB7GqB;AHsiZvB;;AoBv7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBvHqB;AHijZvB;;AoBx7YA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBjBjIqB;AH4jZvB;;AoBz7YA;EACE,aAAA;ApB47YF;;AoBz7YA;EACE,yBjBnHK;EiBoHL,sCAAA;ApB47YF;AoB37YE;EACE,WjB3GI;AHwiZR;;AoBz7YC;EACC,mBAAA;ApB47YF;AoBz7YE;EACC,wBAAA;ApB27YH;AoBv7YE;EACC,wBAAA;ApBy7YH;AoBl6YE;EAbE,yBjB1JM;AH4kZV;AoBj7YI;EACE,+BAAA;ApBm7YN;AoBh7YM;EAIE,WjB5IA;AH2jZR;AoBx6YE;EAhBE,yBjBxJQ;AHmlZZ;AoB17YI;EACE,+BAAA;ApB47YN;AoBz7YM;EAIE,WjB5IA;AHokZR;AoB96YE;EAnBE,yBjBlJM;AHslZV;AoBn8YI;EACE,+BAAA;ApBq8YN;AoBl8YM;EAIE,WjB5IA;AH6kZR;AoBp7YE;EAtBE,yBjBpJG;AHimZP;AoB58YI;EACE,+BAAA;ApB88YN;AoB38YM;EAIE,WjB5IA;AHslZR;AoB17YE;EAzBE,yBjBtJM;AH4mZV;AoBr9YI;EACE,+BAAA;ApBu9YN;AoBp9YM;EAIE,WjB5IA;AH+lZR;AoBh8YE;EA5BE,yBjBhJK;AH+mZT;AoB99YI;EACE,+BAAA;ApBg+YN;AoB79YM;EAIE,WjB5IA;AHwmZR;;AoBl8YM;EAIE,kDAAA;EACA,cjBlME;AHooZV;AoB57YM;EAIE,mDAAA;EACA,cjB3MI;AHsoZZ;AoBr7YM;EAIE,mDAAA;EACA,cjBhNE;AHooZV;AoB96YM;EAIE,oDAAA;EACA,cjB7ND;AH0oZP;AoBv6YM;EAIE,0DAAA;EACA,cjB1OE;AHgpZV;AoBh6YM;EAIE,yDAAA;EACA,cjB/OC;AH8oZT;;AoB74YE;EACE,yCAAA;EAZA,2BAAA;ApB65YJ;AoB35YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApB05YR;AoBl5YE;EACE,yCAAA;EAhBA,2BAAA;ApBq6YJ;AoBn6YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApBk6YR;AoBt5YE;EACE,yCAAA;EApBA,2BAAA;ApB66YJ;AoB36YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApB06YR;AoB15YE;EACE,wCAAA;EAxBA,2BAAA;ApBq7YJ;AoBn7YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApBk7YR;AoB95YE;EACE,wCAAA;EA5BA,2BAAA;ApB67YJ;AoB37YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApB07YR;AoBl6YE;EACE,8CAAA;EAhCA,2BAAA;ApBq8YJ;AoBn8YM;EAIE,WjB/OA;EiBgPA,oCAAA;ApBk8YR;;AoBr6YA;EACE,SAAA;ApBw6YF;;AoBt6YA;EACE,gBAAA;EACA,cAAA;ApBy6YF;;AoBt6YA;EACE,gBAAA;ApBy6YF;;AoBt6YE;EACI,WAAA;EACA,YAAA;EACA,mBjBvKM;EiBwKN,yBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cjB5JK;AHqkZX;AoBx6YM;EACI,cjB9JC;AHwkZX;AoBz6YU;EACI,cjBhKH;AH2kZX;AoBt6YM;EACI,aAAA;ApBw6YV;AoBp6YU;EAGI,aAAA;EAGA,mBAAA;EhBzPX,YgB0PyC;EAC9B,kBAAA;EACA,cjBzFA;EiB0FA,mBAAA;ApBs6Yd;AoBr6Yc;EACI,iBAAA;ApBu6YlB;AoBr6Yc;EACI,mBjB1MN;EiB2MM,cjBhGJ;AHugZd;;AoBl6YA;EACE,oCjBjWoB;AHswZtB;AoBn6YM;EACI,cjBnMC;AHwmZX;AoBn6YM;EACI,cjBtMC;AH2mZX;;AoBh6YA;EACE,yBjB/VO;EiBgWP,cjBpLW;AHulZb;;AoBj6YA;EACE,yBjB9UM;AHkvZR;;AoBj6YE;EACI,mBAAA;ApBo6YN;;AoBj6YA;EACE,kBAAA;ApBo6YF;AoBn6YE;EACI,yBAAA;EACA,kBAAA;EACA,6DAAA;EACA,gBjBnWE;EiBoWF,gBjBrYe;EiBwYf,oBAAA;EAGA,mBAAA;EACA,gBAAA;EhB9SH,iBgB+SiC;ApBq6YpC;AoBp6YM;EACI,iBAAA;ApBs6YV;AoBp6YM;EACI,cjBjJI;AHujZd;AoBp6YM;EACI,yBAAA;ApBs6YV;AoBp6YM;EACI,ejB7DK;EiB8DL,gBAAA;ApBs6YV;AoBn6YU;EhB3UR,yBgB4UgC;EhB7WhC,yBgB8W+B;EhB7W/B,iCgB6W+B;EhB5W/B,6BgB4W+B;ApBy6YjC;AoBn6YU;EAGI,aAAA;EAGA,mBAAA;EhB5UX,YgB6UyC;EAC9B,kBAAA;ApBq6Yd;AoBp6Yc;EACI,iBAAA;ApBs6YlB;AoBp6Yc;EACI,mBjB3RN;EiB4RM,cjBjLJ;AHulZd;;AoBh6YA;EACE,yBAAA;EACA,aAAA;EACA,8DjB1Gc;AH6gZhB;;AqBx2ZA;EACI,qBAAA;EAEA,WAAA;EjBoGD,gBiBnGyB;EjBoGzB,UiBpGkC;ArB22ZrC;AqB12ZI;EACI,qBAAA;EACA,WAAA;ArB42ZR;AqB32ZQ;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBlBFW;EkBGX,0BAAA;EAGA,qBAAA;ArB62ZZ;AqB52ZY;EACI,kCAAA;ArB82ZhB;AqB52ZY;EACI,elBiVD;EkBhVC,mBAAA;EACA,cAAA;ArB82ZhB;;AqBz2ZA;EACI,mBAAA;ArB42ZJ;;AqBz2ZI;EACI,kBAAA;ArB42ZR;AqB12ZI;EACI,YAAA;ArB42ZR;AqB32ZQ;EACI,aAAA;ArB62ZZ;;AqBx2ZI;EACI,clBjBE;AH43ZV;AqBz2ZI;EACI,yBlB2HG;AHgvZX;AqBz2ZI;EACI,qBlBiHI;AH0vZZ;AqBv2ZY;EACI,elB6SD;EkB5SC,clBnCJ;EkBoCI,qBlB4GJ;AH6vZZ;;AqBn2ZI;;;EAGI,WlBvBA;EkBwBA,gBlBxDW;AH85ZnB;;AqBl2ZI;EACI,eAAA;EACA,YAAA;EACA,yBAAA;ArBq2ZR;AqBp2ZQ;EACI,gBAAA;ArBs2ZZ;;AsBn7ZA;EACI,cnByQS;AH6qZb;AsBr7ZI;EACI,YAAA;AtBu7ZR;AsBr7ZI;EACI,WAAA;AtBu7ZR;AsBt7ZQ;EACI,mBAAA;AtBw7ZZ;AsBt7ZQ;EACI,kBAAA;AtBw7ZZ;AsBn7ZY;EACI,oBAAA;EACA,mBAAA;AtBq7ZhB;AsBn7ZY;EACI,aAAA;AtBq7ZhB;AsBl7ZwB;EACI,QAAA;ElBiC1B,2BkBhC6C;ElBiC7C,mCkBjC6C;ElBkC7C,+BkBlC6C;AtBs7Z/C;AsBj7ZoB;EACI,kBAAA;AtBm7ZxB;AsB56ZQ;EACI,iBAAA;AtB86ZZ;AIz6ZI;EkBHI;IAEQ,aAAA;IACA,mBAAA;EtB86Zd;AACF;AI/6ZI;EkBGI;IAEQ,mBAAA;EtB86Zd;AACF;AIp7ZI;EkBQY;IAEQ,eAAA;EtB86ZtB;AACF;AIz7ZI;EkBgBA;IAEQ,6BAAA;EtB26ZV;AACF;AI97ZI;EkBgBA;IAKQ,yBAAA;EtB66ZV;AACF;AIn8ZI;EkBwBQ;IACI,aAAA;IACA,mBAAA;IACA,WAAA;EtB86Zd;AACF;AsB36ZI;EACI,yBAAA;EACA,8DnB4QK;EC3NX,kBkBhDuB;AtB66ZzB;AsB56ZQ;EACI,enBuRG;EmBtRH,gBnBtEO;EmBuEP,gCAAA;ElBoBT,kBkBnBiC;ElBoBjC,mBkBpB6C;AtB+6ZhD;AsB76ZQ;EACI,gBnB3EO;AH0/ZnB;AsB56ZY;EACI,WAAA;EACA,YAAA;EACA,WnBlDR;ECoFN,kBkBjC+B;AtB86ZjC;AsB76ZgB;EACI,qBnB4ET;EmB3ES,mBnB2ET;AHo2ZX;AsB56ZY;EACI,WAAA;AtB86ZhB;AsB56ZoB;EACI,enB8PT;AHgrZf;AsBv6ZgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cnBoJP;EmBnJO,enBnHH;EmBoHG,gBnB7GG;EC4FpB,iBkBkByC;ElBjBzC,iBkBiBoD;ElBMrD,kBkBLmC;EACjB,YAAA;AtB06ZpB;AsBz6ZoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WAAA;AtB26ZxB;AsBz6ZoB;EACI,mBnBsCb;EmBrCa,WnB5FhB;AHugaR;AsBt6ZQ;EACI,enBuNG;EmBtNH,gBnBpIS;EmBqIT,WAAA;EACA,YAAA;AtBw6ZZ;AsBt6ZQ;EACI,enBoNG;EmBnNH,gBnBzIW;EmB0IX,kBAAA;EACA,UAAA;AtBw6ZZ;AsBt6ZQ;EACI,WnB9GJ;EmB+GI,mBnBkBD;EC7CT,kBkB4B2B;EACjB,kBAAA;AtBw6ZZ;AsBv6ZY;ElB9DV,kBkB+DgC;ElB9DhC,MkB8DyC;ElB7DzC,QkB6D2C;AtB26Z7C;AsBx6ZgB;EACI,WnBvHZ;AHiiaR;AsBv6ZY;EACI,cnBsGJ;AHm0ZZ;AsBr6ZI;EACI,WAAA;ElB5CN,kBkB6CuB;AtBu6ZzB;AsBn6ZY;EACI,YAAA;EACA,YAAA;AtBq6ZhB;AsB55ZgB;EACI,YAAA;AtB85ZpB;AsBz5ZI;EACI,enBsKO;EmBrKP,gBnBxLe;AHmlavB;AsBz5ZI;EACI,enBiKO;EmBhKP,gBnB5Le;AHulavB;AsB15ZQ;EACI,cnB7BD;AHy7ZX;AsB35ZY;EACI,cnBvLN;AHolaV;AsBt5ZgB;ElBnFd,0BkBoFmC;AtBw5ZrC;AsBv5ZoB;EACI,WAAA;EACA,YAAA;ElBvFtB,mBkBwFuC;AtBy5ZzC;AsBx5ZwB;ElB7HtB,yBkB8H8C;AtB45ZhD;AsBv5ZoB;EACI,qBAAA;AtBy5ZxB;AsBn5ZI;ElBtGF,0BkBuGuB;EACjB,aAAA;EACA,gBnB7LA;EmB8LA,8DnBiHK;AHoyZb;AsBp5ZQ;EACI,cnB+BC;EmB9BD,enBwHG;AH8xZf;AsBn5ZI;EACI,yBAAA;EACA,8DnByGK;EC3NX,kBkBmHuB;EACjB,gBnBxMA;AH6laR;AsBp5ZQ;EACI,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AtBs5ZZ;AsBj5ZQ;EACI,cnBnFD;EmBoFC,WAAA;EACA,YAAA;ElBtKV,yBkBuK8B;ElBnI9B,mBkBoI2B;EAGjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AtBq5ZZ;AsBp5ZY;EACI,mBnB1PN;AHgpaV;AsBr5ZgB;EACI,WnBrOZ;AH4naR;AsBl5ZI;EACI,enB8EO;EmB7EP,gBnB5Qe;EmB6Qf,gBAAA;AtBo5ZR;AsBn5ZQ;EACI,cnB9GD;EmB+GC,iBAAA;EACA,enBwEG;AH60Zf;AsBl5ZY;EACI,enBoED;EmBnEC,kBAAA;EACA,qBAAA;EACA,cnBzBH;AH66Zb;AsBn5ZgB;EACI,WAAA;ElBtMlB,kBkBuMoC;ElBtMpC,QkBsM6C;ElBnM7C,OkBmM2D;ElB5O3D,2BkB6OqC;ElB5OrC,mCkB4OqC;ElB3OrC,+BkB2OqC;EACnB,UAAA;EACA,WAAA;EACA,mBnB9HT;EC7CT,kBkB4KmC;AtBy5ZrC;AsBl5ZY;EACI,cnBzCH;EmB0CG,WAAA;AtBo5ZhB;AsBj5ZgB;EACI,cnBpSV;AHuraV;AsB74ZI;EACI,YAAA;EACA,iCAAA;AtB+4ZR;AsB94ZQ;EACI,YAAA;EACA,gCAAA;EACA,gBAAA;AtBg5ZZ;AsB/4ZY;EACI,6BAAA;EACA,4BAAA;EACA,mBAAA;AtBi5ZhB;AsB/4ZY;EACI,gBAAA;EACA,YAAA;EACA,enB2BD;EmB1BC,gBnBnUO;EmBoUP,cnBnKL;EmBoKK,UAAA;EACA,qBAAA;EACA,WAAA;AtBi5ZhB;AsBh5ZgB;ElBxPd,yBkByPsC;EACpB,sBAAA;EACA,mBAAA;EACA,iCAAA;EACA,enBpVH;EmBqVG,gBnB7UD;EmB8UC,cnBhFP;EmBiFO,eAAA;EACA,WAAA;EACA,iBAAA;AtBo5ZpB;AsBl5ZgB;EACI,eAAA;AtBo5ZpB;AsBl5ZgB;EACI,UAAA;AtBo5ZpB;AsBj5ZoB;EACI,cnBnVd;AHsuaV;AsB/4ZY;EACI,YAAA;EACA,UAAA;AtBi5ZhB;AsB/4ZoB;EACI,eAAA;EACA,WAAA;EACA,YAAA;AtBi5ZxB;AsB94ZgB;EACI,iBAAA;AtBg5ZpB;AsBz4ZQ;EACI,8BAAA;AtB24ZZ;AsBz4ZQ;EACI,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8DnB5CC;EmB6CD,yBAAA;AtB24ZZ;AsBz4ZQ;EACI,UAAA;EACA,UAAA;EACA,qBAAA;AtB24ZZ;AsB14ZY;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AtB44ZhB;AsB34ZgB;EACI,kBAAA;EACA,WAAA;AtB64ZpB;AsB54ZoB;EACI,cnB5IX;AH0hab;AsB54ZoB;EACI,gBAAA;AtB84ZxB;AsB74ZwB;EACG,cnBvYjB;AHsxaV;AsBx4ZW;EACK,UAAA;AtB04ZhB;AsBt4ZY;EACI,UAAA;AtBw4ZhB;AsBp4ZoB;EACI,cnBnKX;EmBoKW,WAAA;AtBs4ZxB;AsBh4ZI;EACI,8DnB3FK;EmB4FL,YAAA;AtBk4ZR;AsBh4ZY;EACI,gBAAA;ElB1Td,kBkB2T+B;EACjB,eAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AtBk4ZhB;AIzxaI;EkB2YQ;IAcQ,mBAAA;IACA,qBAAA;EtBo4ZlB;AACF;AsBn4ZgB;EACI,cnBhMP;EmBiMO,mBnB9LV;EmB+LU,qBnB/LV;AHokaV;AsBn4ZgB;EACI,mBnBnST;EmBoSS,qBnBpST;EmBqSS,WnBtaZ;AH2yaR;AsB93ZoB;EACI,qBnBnTZ;AHmraZ;AsB13ZoB;EACI,mBAAA;EACA,enB7dP;EmB8dO,gBnBxdH;EmBydG,mBAAA;EACA,qBnB9TZ;AH0raZ;AsB33ZwB;EACI,enBleX;EmBmeW,gBnB7dP;AH01arB;AsB33ZgC;EACI,WAAA;EACA,YAAA;EACA,SAAA;AtB63ZpC;AsBp3ZI;EACI,enBlfS;AHw2ajB;;AsBn3ZA;EACI,aAAA;AtBs3ZJ;;AsBp3ZA;EACI,cnBnPS;AH0mab;;AsBr3ZA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AtBw3ZJ;AsBt3ZI;ElBraF,kBkBsawB;ElBraxB,QkBqaiC;ElBlajC,UkBka+C;ElB3c/C,2BkB4cyB;ElB3czB,mCkB2cyB;ElB1czB,+BkB0cyB;EACnB,YAAA;AtB43ZR;AsB13ZI;EACI,kBAAA;AtB43ZR;;AsBz3ZA;EACI,mBnBldU;AH80ad;AsB33ZI;EACI,mBnBpdM;AHi1ad;;AsB13ZA;EACI,mBnBzUS;AHssab;AsB53ZI;EACI,mBnB3UK;AHysab;;AsB33ZA;EACI,mBnBzVU;AHutad;AsB73ZI;EACI,mBnB3VM;AH0tad;;AsB53ZA;ElBxbG,kBkBybyB;ElBxbzB,kBkBwbqC;EACpC,gCAAA;AtBg4ZJ;;AsB93ZA;ElB5bG,kBkB6byB;ElB5bzB,mBkB4bqC;EACpC,gCAAA;AtBk4ZJ;;AsB/3ZI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;AtBk4ZR;AsBh4ZS;EACG,oBAAA;AtBk4ZZ;AsBh4ZQ;EACI,UAAA;AtBk4ZZ;AsB93ZQ;EACI,cnBhiBF;EmBiiBE,iBAAA;EACA,enBtNG;EmBuNH,gBnBjjBS;AHi7arB;AsB/3ZY;EACI,cnBziBN;AH06aV;AsB73ZI;EACE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AtB+3ZN;;AsB33ZA;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;AtB83ZF;;AsB33ZA;EACE;IAAqB,SAAA;IAAU,qBAAA;EtBg4Z/B;AACF;AsB93ZA;EACE,UAAA;EACA,mBAAA;AtBg4ZF;;AsB73ZA;EACI,mCAAA;EACA,4CAAA;AtBg4ZJ;;AsB73ZA;EACE,eAAA;EACA,YAAA;ElBheA,4BkBieiB;AtBg4ZnB;;AsB93ZA;EACI,kBAAA;EACA,mBnBzZS;EmB0ZT,YAAA;ElBteF,kBkBuemB;AtBi4ZrB;AsBh4ZI;EACI,enBlQO;AHooaf;AsBh4ZI;EACI,gBnB/lBW;AHi+anB;;AsB/3ZA;EACI,aAAA;AtBk4ZJ;AsBj4ZI;EACI,YAAA;EACA,aAAA;ElBnfN,mBkBofuB;EACjB,mBnB3kBA;EmB4kBA,cAAA;AtBm4ZR;;AsBh4ZA;EACI,eAAA;AtBm4ZJ;;AsBj4ZA;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,YAAA;EACA,gBnBvlBI;EmBwlBJ,eAAA;EACA,4BAAA;EACA,+BAAA;EACA,2FAAA;EACA,gBAAA;ElB5iBF,yBkB6iBsB;AtBs4ZxB;AIj+aI;EkB8kBJ;IAeQ,YAAA;IACA,aAAA;EtBw4ZN;AACF;AsBv4ZI;EACI,QAAA;ElBnjBN,yBkBojB0B;AtB24Z5B;AsBv4ZY;EACI,cnBtnBP;AH+/aT;AsBr4ZI;EACI,gBnB7oBW;AHohbnB;AsBr4ZI;EACI,enBnTO;AH0raf;AsBr4ZI;EACI,enBvTO;AH8raf;AsBr4ZI;EACK,enB5TM;EmB6TP,gBnBxpBe;AH+hbvB;AsBr4ZI;EACI,gCAAA;AtBu4ZR;AsBt4ZQ;EACI,iBAAA;EACA,enBlUG;EmBmUH,gBnB/pBW;ECoHrB,kBkB4iB2B;EACjB,YAAA;EACA,mBnBhaF;EmBiaE,cnBlgBD;AH04aX;AsBv4ZY;EACI,mBnB5pBN;EmB6pBM,WnBtoBR;AH+gbR;AsBj4ZoB;EACI,kBAAA;AtBm4ZxB;AsBh4ZwB;EACI,mBnBjblB;EmBkbkB,yBAAA;ElBhkB1B,kBkBikB2C;EACjB,YAAA;EACA,qBAAA;AtBk4Z5B;AsBj4Z4B;EACI,WAAA;EACA,YAAA;AtBm4ZhC;AsB/3ZoB;EACI,gBAAA;AtBi4ZxB;AsB33ZoB;EACI,oBAAA;EACA,iBAAA;EACA,kBAAA;AtB63ZxB;AsB13ZwB;EACI,kBAAA;EACA,mBAAA;EACA,+BAAA;AtB43Z5B;AsBx3ZwB;EACI,eAAA;EACA,gBAAA;AtB03Z5B;AsBv3ZoB;EACI,mBnB/sBd;EmBgtBc,WnBzrBhB;AHkjbR;AsBx3ZwB;EACI,mBnB1jBjB;AHo7aX;AsBn3ZI;EACI,cnBpeK;EmBqeL,enBzYO;AH8vaf;AsBn3ZI;EACI,gBnBtuBW;AH2lbnB;AsBp3ZQ;EACI,cnBxkBD;AH87aX;;AsBj3ZA;EACI,yBAAA;AtBo3ZJ;;AsBl3ZA;EACI,WAAA;EACA,YAAA;ElB/nBF,mBkBgoBmB;AtBq3ZrB;;AsBn3ZA;EACI,yBAAA;AtBs3ZJ;;AsBp3ZA;EACI,yBAAA;AtBu3ZJ;;AsBr3ZA;EACI,cnB9fS;AHs3ab;;AsBr3ZI;EACI,WAAA;AtBw3ZR;;AsBl3ZQ;EACI,enB3aG;EmB4aH,gBnBxwBO;AH6nbnB;AsBj3ZQ;EACI,enBxaG;EmByaH,gBnB9wBO;EmB+wBP,cnB1mBD;EmB2mBC,mBAAA;EACA,yBnBhhBF;EC9IR,mBkB+pB2B;AtBm3Z7B;AsBh3ZY;EACI,kBAAA;AtBk3ZhB;AsB/2ZQ;EACI,gBAAA;AtBi3ZZ;AsB12ZoB;EACI,kBAAA;AtB42ZxB;AsBr2ZI;EACI,iBAAA;EACA,enBjdO;EmBkdP,mBAAA;AtBu2ZR;AsBp2ZQ;EACI,gBAAA;AtBs2ZZ;AsBp2ZQ;EACI,YAAA;EACA,cAAA;AtBs2ZZ;AsBr2ZY;EACI,yBAAA;EACA,8DnBzeH;EC3NX,kBkBqsB+B;AtBu2ZjC;AsBr2ZY;EACI,enBjeD;AHw0af;AsBt2ZgB;EACI,oBAAA;AtBw2ZpB;AsBp2ZwB;EACI,iBAAA;AtBs2Z5B;AsBl2ZgB;EACI,eAAA;EACA,cnB9zBR;AHkqbZ;AsBl2ZgB;EACI,cnB7kBP;EmB8kBO,mBAAA;AtBo2ZpB;AsBj2ZY;EACI,enBtfD;EmBufC,yBnBhlBN;EC9IR,kBkB+tB+B;AtBm2ZjC;AsBh2ZgB;EACI,WAAA;AtBk2ZpB;AsBj2ZoB;EACI,WAAA;AtBm2ZxB;AsBl2ZwB;EACI,WAAA;AtBo2Z5B;AsB31ZY;EACI,kBAAA;EACA,aAAA;EACA,0BAAA;AtB61ZhB;AsB51ZgB;ElBpxBd,kBkBqxBoC;ElBpxBpC,MkBoxB6C;ElBnxB7C,QkBmxB+C;ElBjxB/C,OkBixBsD;EACpC,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AtBi2ZpB;AsB91ZY;EACI,enBxhBD;EmByhBC,gBnBn3BK;EmBo3BL,cnBpnBH;AHo9ab;AsB91ZY;EACI,enB1hBD;EmB2hBC,gBnBv3BO;EmBw3BP,cnB72BJ;EmB82BI,gBAAA;AtBg2ZhB;AsB91ZY;EACI,WAAA;ElBxwBd,kBkBywB+B;AtBg2ZjC;AsB71ZgB;ElBpyBb,kBkBqyByC;ElBpyBzC,akBoyBqD;ElB7wBtD,kBkB8wBmC;EACjB,yBAAA;AtBg2ZpB;AsB/1ZoB;EACI,WAAA;AtBi2ZxB;AsB91ZwB;EACI,enB7iBb;EmB8iBa,gBnB14BL;EmB24BK,cnBh4BhB;AHgubZ;AsB/1Z4B;EACI,cnBh4BtB;AHiubV;AsB71Z4B;EACI,cnBz4BtB;AHwubV;AsB31ZoB;EACI,gBAAA;AtB61ZxB;AsBt1ZQ;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;AtBw1ZZ;AsBt1ZQ;EACI,WAAA;ElBpzBV,kBkBqzB2B;AtBw1Z7B;;AsBj1ZY;EACI,WAAA;AtBo1ZhB;;AuBhxbA;EACI,UAAA;EAGE,aAAA;EAEA,eAAA;AvBmxbN;AuBlxbM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,epBoVO;ECzOb,mBmB1GuB;EACjB,yBAAA;EACA,cpBHE;ECmFP,WmB/E6B;EnBmH9B,wCAAA;AJoqbF;;AwB/ybA;EACI,yBrBqKQ;EqBpKR,eAAA;EACA,sBAAA;AxBkzbJ;;AwBhzbA;EACI,yBrBgKQ;AHmpbZ;;AwBjzbA;EACI,WrBkCI;EqBjCJ,yBrBUM;AH0ybV;;AwBjzbA;EACI;IACI,QAAA;ExBozbN;AACF;AwBlzbA;EACI,kBAAA;EACA,uBAAA;AxBozbJ;AwBnzbI;EACI,kBAAA;EACA,uBAAA;EACA,8BAAA;AxBqzbR;;AwBjzbI;EACI,iBAAA;AxBozbR;AwBlzbI;EACI,cAAA;AxBozbR;AwBlzbI;EACI,YAAA;AxBozbR;AwBlzbI;EACI,eAAA;AxBozbR;;AwBjzbA;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AxBozbJ;AwBlzbI;EACI,WAAA;AxBozbR;AwBjzbI;EACI,WAAA;AxBmzbR;AwBhzbI;EACI,WAAA;AxBkzbR;AwB/ybI;EACI,UAAA;AxBizbR;AwB9ybI;EACI,UAAA;AxBgzbR;;AwB7ybA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AxBgzbJ;AwB9ybI;EACI,WAAA;EACA,SAAA;EACA,kBAAA;AxBgzbR;AwB7ybI;EACI,WAAA;AxB+ybR;AwB5ybI;EACI,WAAA;AxB8ybR;AwB3ybI;EACI,UAAA;AxB6ybR;AwB1ybI;EACI,UAAA;AxB4ybR;;AwBzybA;EACI,iBAAA;EACA,kBAAA;AxB4ybJ;AwB3ybI;EACI,kBAAA;EACA,iBAAA;AxB6ybR;AwB5ybQ;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,qDAAA;EACA,gBrBtEJ;EqBuEI,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;AxB8ybZ;AwB5ybQ;EACI,6BAAA;EACA,+DAAA;AxB8ybZ;AwB5ybQ;EACI,6BAAA;EACA,6DAAA;AxB8ybZ;AwB5ybQ;EACI,6BAAA;EACA,0DAAA;AxB8ybZ;AwB5ybQ;EACI,6BAAA;EACA,6DAAA;AxB8ybZ;AwB5ybQ;EACI,6BAAA;EACA,4DAAA;AxB8ybZ;AwB3ybI;EACI,eAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBrB7HE;EqB8HF,kDAAA;EACA,mBAAA;EACA,gBrBzIe;EqB0If,WrB1GA;EqB2GA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;AxB6ybR;AwB5ybQ;EACI,WAAA;EACA,0CAAA;EACA,+CAAA;EACA,6CAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;AxB8ybZ;AwB5ybQ;EACI,yBrB9IA;AH47bZ;AwB7ybY;EACI,0CAAA;AxB+ybhB;AwB5ybQ;EACI,yBrBlJF;AHg8bV;AwB7ybY;EACI,0CAAA;AxB+ybhB;AwB5ybQ;EACI,yBrBpJF;AHk8bV;AwB7ybY;EACI,0CAAA;AxB+ybhB;AwB5ybQ;EACI,yBrBxJH;AHs8bT;AwB7ybY;EACI,0CAAA;AxB+ybhB;AwB5ybQ;EACI,yBrBlKL;AHg9bP;AwB7ybY;EACI,0CAAA;AxB+ybhB;;AwBzybI;EACI,oCAAA;AxB4ybR;;AwBzybA;EACI,kBAAA;EACH,4BAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACG,yBrBtKI;AHk9bR;;AwB1ybA;EACC,uBAAA;AxB6ybD;;AwB3ybA;EACC,uBAAA;AxB8ybD;;AwB5ybA;EACC,uBAAA;AxB+ybD;;AwB7ybA;EACI,iBAAA;EACA,uBAAA;AxBgzbJ;AwB/ybI;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AxBizbR;AwBhzbQ;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,sBrB7LJ;EqB8LI,kBAAA;AxBkzbZ;AwBhzbQ;EACI,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBrBtMJ;EqBuMI,mBAAA;EACA,gBrBxOW;EqByOX,crBhOF;EqBiOE,kBAAA;EACA,kBAAA;EACA,2BAAA;AxBkzbZ;AwBjzbY;EACI,8BAAA;EACA,crBpOJ;AHuhcZ;AwBjzbY;EACI,8BAAA;EACA,crBlON;AHqhcV;AwBjzbY;EACI,8BAAA;EACA,crBxOT;AH2hcP;AwBjzbY;EACI,8BAAA;EACA,crB9ON;AHiicV;AwBjzbY;EACI,8BAAA;EACA,crB5OP;AH+hcT;;AwB7ybI;EACI,uCAAA;EACA,sBAAA;AxBgzbR;AwB/ybQ;EACI,wCAAA;AxBizbZ;AwBhzbY;EACI,crBhQJ;AHkjcZ;AwB/ybQ;EACI,wCAAA;AxBizbZ;AwBhzbY;EACI,crBhQN;AHkjcV;AwB/ybQ;EACI,yCAAA;AxBizbZ;AwBhzbY;EACI,crBxQT;AH0jcP;AwB/ybQ;EACI,wCAAA;AxBizbZ;AwBhzbY;EACI,crBhRN;AHkkcV;AwB/ybQ;EACI,uCAAA;AxBizbZ;AwBhzbY;EACI,crBhRP;AHkkcT;AwB/ybQ;EACI,sBAAA;AxBizbZ;AwB/ybQ;EACI,kBAAA;EACA,0BAAA;EACA,gBrB5SW;EqB6SX,mBAAA;EACA,crBrSF;AHslcV;;AyB1mcA;EACI,ctByQS;EsBxQT,sBtByCI;EsBxCJ,yBAAA;AzB6mcJ;AyB5mcI;EACI,gBAAA;EACA,yBtBmCA;AH2kcR;AyB5mcI;EACI,ctBWE;EsBVF,yBtB+BA;EsB9BA,qBtB2JI;AHm9bZ;;AyB3mcA;EACI,WtB4BI;EsB3BJ,yBtBIM;EsBHN,qBtBGM;AH2mcV;;AyB5mcA;EACI,ctBsPS;EsBrPT,sBtBsBI;EsBrBJ,qBtBgJQ;EsB/IR,YAAA;AzB+mcJ;;AyBzmcY;EACI,gBAAA;AzB4mchB;AyB1mcY;EACI,gBAAA;AzB4mchB;AyB1mcY;EACI,gBAAA;AzB4mchB;AyB1mcY;EACI,gBAAA;AzB4mchB;;AyBtmcI;EACI,iBAAA;AzBymcR;AyBxmcQ;EACI,SAAA;EACA,kBtBgSI;EsB/RJ,oBAAA;AzB0mcZ;AyBzmcY;EACI,gBtBzCO;AHopcvB;AyBvmcY;EACI,kBtBwRA;EsBvRA,yBtBtCN;EsBuCM,WtBhBR;AHyncR;AyBtmcgB;EACI,kBtBkRJ;EsBjRI,yBtB5CV;EsB6CU,WtBtBZ;AH8ncR;AyBnmcY;EACI,yBtB9BR;EsB+BQ,ctBpDN;AHypcV;;AyBhmcA;EACI,kBtBmQY;AHg2bhB;AyBlmcI;EACI,iBAAA;AzBomcR;AyBnmcQ;EACI,oBAAA;EACA,oBAAA;AzBqmcZ;AyBlmcY;EACI,sBtB5CR;EsB6CQ,ctBpEN;EsBqEM,kBAAA;EACA,iBAAA;AzBomchB;AyBnmcgB;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,yBtB9EV;AHmrcV;AyBhmcY;EACI,6BAAA;AzBkmchB;;AyB7lcA;EACI,mBAAA;EACA,gBAAA;EACA,mBAAA;AzBgmcJ;AyB/lcI;EACI,iBAAA;AzBimcR;AyBhmcQ;EACI,SAAA;EACA,mBAAA;EACA,oBAAA;AzBkmcZ;AyBjmcY;EACI,gBtB7GO;AHgtcvB;AyB/lcY;EACI,yBtBzGN;EsB0GM,WtBnFR;AHorcR;AyB9lcgB;EACI,yBtB9GV;AH8scV;AyB3lcY;EACI,yBtB/FR;AH4rcR;;AyBtlcQ;EACI,oBAAA;EACA,oBAAA;EACA,kBtB+LI;AH05bhB;AyBxlcY;EACI,gBtBzIO;AHmucvB;AyBtlcY;EACI,SAAA;EACA,kBtBuLA;EsBtLA,yBtBvIN;EsBwIM,WtBjHR;AHyscR;AyBrlcgB;EACI,yBtB5IV;AHmucV;AyBllcY;EACI,6BAAA;AzBolchB;;A0B1vcA;;;;;;;;;;;;EAYE,cvB+PY;EuB9PZ,oCvBGoB;EuBFpB,gBvBFiB;EuBGjB,gBAAA;A1B6vcF;;A0B3vcA;;EAEE,eAAA;A1B8vcF;;A0B5vcA;;EAEE,kBAAA;A1B+vcF;;A0B7vcA;;EAEE,iBAAA;A1BgwcF;;A0B9vcA;;EAEE,mBAAA;A1BiwcF;;A0B/vcA;;EAEE,eAAA;A1BkwcF;;A0BhwcA;;EAEE,mBAAA;A1BmwcF;;A0BjwcA;EACE,oBAAA;A1BowcF;;A0BlwcA;EACE,mBAAA;A1BqwcF;;A0BnwcA;EACE,mBAAA;A1BswcF;;A0BlwcA;EACE,oBAAA;A1BqwcF;;A0BnwcA;EACE,mBAAA;A1BswcF;;A0BpwcA;EACE,oBAAA;A1BuwcF;;A0BrwcA;EACE,kBAAA;A1BwwcF;;A0BtwcA;EACE,oBAAA;A1BywcF;;A0BvwcA;EACE,mBAAA;A1B0wcF;;A0BxwcA;EACE,oBAAA;A1B2wcF;;A0BzwcA;EACE,iBAAA;A1B4wcF;;A0B1wcA;EACE,oBAAA;A1B6wcF;;A0B3wcA;EACE,mBAAA;A1B8wcF;;A0B5wcA;EACE,oBAAA;A1B+wcF;;A0B7wcA;EACE,kBAAA;A1BgxcF;;A0B9wcA;EACE,oBAAA;A1BixcF;;A0B/wcA;EACE,mBAAA;A1BkxcF;;A0BhxcA;EACE,oBAAA;A1BmxcF;;A0BjxcA;EACE,eAAA;A1BoxcF;;A0BlxcA;EACE,oBAAA;A1BqxcF;;A0BnxcA;EACE,mBAAA;A1BsxcF;;A0BpxcA;EACE,oBAAA;A1BuxcF;;A0BrxcA;EACE,kBAAA;A1BwxcF;;A0BtxcA;EACE,oBAAA;A1ByxcF;;A0BvxcA;EACE,mBAAA;A1B0xcF;;A0BxxcA;EACE,oBAAA;A1B2xcF;;A0BzxcA;EACE,iBAAA;A1B4xcF;;A0B1xcA;EACE,oBAAA;A1B6xcF;;A0B3xcA;EACE,mBAAA;A1B8xcF;;A0B5xcA;EACE,oBAAA;A1B+xcF;;A0B7xcA;EACE,kBAAA;A1BgycF;AIz3cI;EsBwFJ;IAGI,kBAAA;E1BkycF;AACF;;A0BhycA;EACE,oBAAA;A1BmycF;;A0BhycA;EACE,mBAAA;A1BmycF;;A0BjycA;EACE,eAAA;A1BoycF;;A0BlycA;EACE,mBAAA;A1BqycF;;A0BnycA;EACE,kBAAA;A1BsycF;;A0BpycA;EACE,mBAAA;A1BuycF;;A0BrycA;EACE,iBAAA;A1BwycF;;A0BtycA;EACE,kBAAA;A1ByycF;AI95cI;EsBoHJ;IAGI,mBAAA;E1B2ycF;AACF;AIn6cI;EsBoHJ;IAMI,mBAAA;E1B6ycF;AACF;;A0B3ycA;EACE,yBAAA;A1B8ycF;;A0B5ycA;EACE,yBAAA;A1B+ycF;;A0B7ycA;EACE,yBAAA;EACA,UAAA;A1BgzcF;A0B/ycE;EACE,wCAAA;A1BizcJ;A0B/ycE;EACE,wCAAA;A1BizcJ;A0B/ycE;EACE,uCAAA;A1BizcJ;;A0B9ycA;EACE,yBAAA;EACA,UAAA;A1BizcF;;A0B/ycA;EACE,yBAAA;EACA,UAAA;A1BkzcF;;A0BhzcA;EACE,yBAAA;EACA,UAAA;A1BmzcF;;A0BjzcA;EACE,yBAAA;EACA,UAAA;A1BozcF;;A0BlzcA;EACE,yBAAA;EACA,UAAA;A1BqzcF;;A0BnzcA;EACE,yBAAA;A1BszcF;;A0BpzcA;EACE,yBAAA;A1BuzcF;;A0BrzcA;EACE,yBAAA;A1BwzcF;;A0BtzcA;EACE,yBAAA;A1ByzcF;;A0BvzcA;EACE,yBAAA;A1B0zcF;;A0BxzcA;EACE,yBAAA;A1B2zcF;;A0BzzcA;EACE,yBAAA;A1B4zcF;;A0B1zcA;EACE,yBAAA;A1B6zcF;;A0B3zcA;EACE,yBAAA;A1B8zcF;;A0B5zcA;EACE,yBAAA;A1B+zcF;;A0B7zcA;EACE,sBAAA;A1Bg0cF;;A0B9zcA;EACE,sBAAA;A1Bi0cF;;A0B/zcA;EACE,sBAAA;A1Bk0cF;;A0Bh0cA;EACE,sBAAA;A1Bm0cF;;A0Bj0cA;EACE,cvBnFS;AHu5cX;;A0Bl0cA;EACE,cvBrFS;AH05cX;;A0Bn0cA;EACE,cvBvFS;AH65cX;;A0Bp0cA;EACE,cvBzFS;AHg6cX;;A0Br0cA;EACE,cvB3FS;AHm6cX;;A0Bt0cA;EACE,cvB7FS;AHs6cX;;A0Bv0cA;EACE,cvB/FS;AHy6cX;;A0Bx0cA;EACE,cvBjGS;AH46cX;;A0Bz0cA;EACE,cvBnGS;AH+6cX;;A0B10cA;EACE,cvBtGS;EuBuGT,eAAA;EACA,qBAAA;EtB9LA,yBsB+LoB;A1B+0ctB;A0B90cE;EACE,cvBxQM;ECuER,yBsBkMsB;A1Bk1cxB;A0Bh1cE;EACE,UAAA;A1Bk1cJ;;A0B/0cA;EACE,yBAAA;A1Bk1cF;A0Bj1cE;EAGE,yBAAA;A1Bi1cJ;;A0B90cA;EACE,yBAAA;A1Bi1cF;A0Bh1cE;EAGE,yBAAA;A1Bg1cJ;;A0B70cA;EACE,yBAAA;A1Bg1cF;A0B/0cE;EAGE,yBAAA;A1B+0cJ;;A0B50cA;EACE,yBAAA;A1B+0cF;A0B90cE;EAGE,yBAAA;A1B80cJ;;A0B30cA;EACE,yBAAA;A1B80cF;A0B70cE;EAGE,yBAAA;A1B60cJ;;A0B10cA;EACE,yBAAA;A1B60cF;A0B50cE;EAGE,yBAAA;A1B40cJ;;A0Bz0cA;EACE,yBAAA;A1B40cF;A0B30cE;EAGE,yBAAA;A1B20cJ;;A0Bx0cA;EACE,yBAAA;A1B20cF;A0B10cE;EAGE,yBAAA;A1B00cJ;;A0Bt0cE;EACE,gCAAA;A1By0cJ;;A0Br0cA;EACE,yBAAA;A1Bw0cF;;A0Bt0cA;EACE,gBAAA;EACA,8BAAA;EACA,kBAAA;A1By0cF;A0Bx0cE;EACE,+BAAA;EACA,cAAA;A1B00cJ;;A0Bv0cA;EACE,kBAAA;EACA,gBvB5WqB;EuB6WrB,aAAA;EACA,kBvBxCc;EuByCd,kBAAA;A1B00cF;A0Bz0cE;EACE,gBAAA;EACA,0BvB5WW;EuB6WX,UAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;A1B20cJ;A0Bz0cE;EACE,uCAAA;EACA,sCAAA;A1B20cJ;A0B10cI;EACE,4BAAA;A1B40cN;A0Bz0cE;EACE,wCAAA;EACA,sCAAA;A1B20cJ;A0B10cI;EACE,6BAAA;A1B40cN;A0Bz0cE;EACE,yCAAA;EACA,sCAAA;A1B20cJ;A0B10cI;EACE,8BAAA;A1B40cN;A0Bz0cE;EACE,wCAAA;EACA,sCAAA;A1B20cJ;A0B10cI;EACE,6BAAA;A1B40cN;A0Bz0cE;EACE,wCAAA;EACA,sCAAA;A1B20cJ;A0B10cI;EACE,6BAAA;A1B40cN;A0Bz0cE;EACE,uCAAA;EACA,sCAAA;A1B20cJ;A0B10cI;EACE,4BAAA;A1B40cN;;A0Bt0cE;EACE,+DAAA;A1By0cJ;A0Bv0cE;EACE,0DAAA;A1By0cJ;A0Bv0cE;EACE,wDAAA;A1By0cJ;;A0Br0cA;EACE;IACE,WAAA;E1Bw0cF;AACF;A0Bp0cE;EACE,gCAAA;EACA,iCAAA;A1Bs0cJ;;A0Bn0cA;EACE,0BAAA;A1Bs0cF;;A0Bp0cA;EACE,UAAA;A1Bu0cF;;A0Br0cA;EACE,WAAA;A1Bw0cF;;A0Bt0cA;EACI,kBAAA;EACA,kBAAA;A1By0cJ;;A2B5xdA;EACE,yBAAA;EACA,kBxB+Uc;EwB9Ud,oBAAA;A3B+xdF;A2B9xdE;EACE,0CAAA;A3BgydJ;A2B9xdE;EACE,exBiWW;AH+7cf;A2B9xdE;EACE,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A3BgydJ;A2B/xdI;EACE,exBuVS;EwBtVT,iBAAA;A3BiydN;A2B9xdE;EACE,gBAAA;A3BgydJ;A2B9xdE;EACE,gBxBdmB;AH8ydvB;;A2B5xdE;EACE,0CAAA;A3B+xdJ;;A2BpxdA;EACE,wCAAA;EACA,cxBfQ;EwBgBR,oCAAA;A3BuxdF;A2BtxdE;EACE,cxBlBM;AH0ydV;A2BtxdE;EACE,cxBrBM;AH6ydV;A2BvxdI;EAhBF,yBxBNQ;EwBOR,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3B0ydF;;A2B1xdA;EACE,uCAAA;EACA,cxBrCQ;EwBsCR,mCAAA;A3B6xdF;A2B5xdE;EACE,cxBxCM;AHs0dV;A2B5xdE;EACD,cxB3CS;AHy0dV;A2B5xdE;EACE,cxB9CM;AH40dV;A2B7xdI;EAjCF,yBxBdQ;EwBeR,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3Bi0dF;;A2BhydA;EACE,wCAAA;EACA,cxBpDU;EwBqDV,oCAAA;A3BmydF;A2BlydE;EACE,cxBvDQ;AH21dZ;A2BlydE;EACE,cxB1DQ;AH81dZ;A2BnydI;EA/CF,yBxBZU;EwBaV,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3Bq1dF;;A2BtydA;EACE,wCAAA;EACA,cxBhEQ;EwBiER,oCAAA;A3ByydF;A2BxydE;EACE,cxBnEM;AH62dV;A2BxydE;EACE,cxBtEM;AHg3dV;A2BzydI;EA7DF,yBxBVQ;EwBWR,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3By2dF;;A2B5ydA;EACE,yCAAA;EACA,cxB5EK;EwB6EL,qCAAA;A3B+ydF;A2B9ydE;EACE,cxB/EG;AH+3dP;A2B9ydE;EACE,cxBlFG;AHk4dP;A2B/ydI;EA3EF,yBxBRK;EwBSL,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3B63dF;;A2BlzdA;EACE,uCAAA;EACA,cxBtFO;EwBuFP,mCAAA;A3BqzdF;A2BpzdE;EACE,cxBzFK;AH+4dT;A2BpzdE;EACE,cxB5FK;AHk5dT;A2BrzdI;EAzFF,yBxBJO;EwBKP,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3Bi5dF;;A2BxzdA;EACE,yBxBxFM;EwByFN,cxBwIW;EwBvIX,qBxB1FM;AHq5dR;A2B1zdE;EACE,cxBqIS;AHurdb;A2B1zdE;EACE,cxBkIS;AH0rdb;A2B3zdI;EAvGF,yBxBOM;EwBNN,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3Bq6dF;;A2B9zdA;EACE,uCAAA;EACA,cxB0HW;EwBzHX,mCAAA;A3Bi0dF;A2Bh0dE;EACE,cxBuHS;AH2sdb;A2Bh0dE;EACE,WxB3GI;AH66dR;A2Bj0dI;EArHF,yBxBFK;EwBGL,WxBQM;EwBPN,UAAA;EACA,mBAAA;EACA,8DxBoTW;EwBnTX,gBAAA;A3By7dF;;A2B5zdA;EAPE,yBxBzIQ;EwB0IR,WxBnHM;EwBoHN,qBxB3IQ;AHk9dV;A2Bt0dE;EACE,WxBtHI;AH87dR;;A2Bl0dA;EAVE,yBxBvIU;EwBwIV,WxBnHM;EwBoHN,qBxBzIU;AHy9dZ;A2B/0dE;EACE,WxBtHI;AHu8dR;;A2Bx0dA;EAbE,yBxBjIQ;EwBkIR,WxBnHM;EwBoHN,qBxBnIQ;AH49dV;A2Bx1dE;EACE,WxBtHI;AHg9dR;;A2B90dA;EAhBE,yBxBnIK;EwBoIL,WxBnHM;EwBoHN,qBxBrIK;AHu+dP;A2Bj2dE;EACE,WxBtHI;AHy9dR;;A2Bp1dA;EAnBE,yBxBrIQ;EwBsIR,WxBnHM;EwBoHN,qBxBvIQ;AHk/dV;A2B12dE;EACE,WxBtHI;AHk+dR;;A2B11dA;EAtBE,yBxB/HO;EwBgIP,WxBnHM;EwBoHN,qBxBjIO;AHq/dT;A2Bn3dE;EACE,WxBtHI;AH2+dR;;A2Bh2dA;EACE,yBxB9IM;EwB+IN,cxBkFW;EwBjFX,qBxBnBU;AHs3dZ;;A2Bj2dA;EA9BE,yBxB7HK;EwB8HL,WxBnHM;EwBoHN,qBxB/HK;AHkgeP;A2Bl4dE;EACE,WxBtHI;AH0/dR;;A2B/1dA;EAPE,sBxBpJM;EwBqJN,cxB5KQ;EwB6KR,qBxB7KQ;AHuheV;A2Bz2dE;EACE,cxB/KM;AH0heV;;A2Br2dA;EAVE,sBxBpJM;EwBqJN,cxB1KU;EwB2KV,qBxB3KU;AH8heZ;A2Bl3dE;EACE,cxB7KQ;AHiieZ;;A2B32dA;EAbE,sBxBpJM;EwBqJN,cxBtKK;EwBuKL,qBxBvKK;AHmieP;A2B33dE;EACE,cxBzKG;AHsieP;;A2Bj3dA;EAhBE,sBxBpJM;EwBqJN,cxBpKQ;EwBqKR,qBxBrKQ;AH0ieV;A2Bp4dE;EACE,cxBvKM;AH6ieV;;A2Bv3dA;EAnBE,sBxBpJM;EwBqJN,cxBxKQ;EwByKR,qBxBzKQ;AHujeV;A2B74dE;EACE,cxB3KM;AH0jeV;;A2B73dA;EAtBE,sBxBpJM;EwBqJN,cxBlKO;EwBmKP,qBxBnKO;AH0jeT;A2Bt5dE;EACE,cxBrKK;AH6jeT;;A2Bn4dA;EACE,sBxB9KM;EwB+KN,cxBgDW;EwB/CX,qBxBlLM;AHwjeR;;A2Bp4dA;EA9BE,sBxBpJM;EwBqJN,cxBhKK;EwBiKL,qBxBjKK;AHukeP;A2Br6dE;EACE,cxBnKG;AH0keP;;A2Bh4dA;EATE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3B64dF;A2B54dE;EACE,cxBmCS;AH22db;A2Bz4dE;EACD,cxBzNS;AHomeV;;A2Bx4dA;EAfE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3B25dF;A2B15dE;EACE,cxBmCS;AHy3db;A2Bj5dE;EACD,cxB7NW;AHgneZ;;A2Bh5dA;EArBE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3By6dF;A2Bx6dE;EACE,cxBmCS;AHu4db;A2Bz5dE;EACD,cxB7NS;AHwneV;;A2Bx5dA;EA3BE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3Bu7dF;A2Bt7dE;EACE,cxBmCS;AHq5db;A2Bj6dE;EACD,cxBjOQ;AHooeT;;A2Bh6dA;EAjCE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3Bq8dF;A2Bp8dE;EACE,cxBmCS;AHm6db;;A2Bx6dA;EApCE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3Bg9dF;A2B/8dE;EACE,cxBmCS;AH86db;;A2Bh7dA;EAvCE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3B29dF;A2B19dE;EACE,cxBmCS;AHy7db;;A2Bx7dA;EA1CE,sDAAA;EACA,cxB6CW;EwB5CX,sBxBxLM;EwByLN,yBAAA;EACA,mBAAA;A3Bs+dF;A2Br+dE;EACE,cxBmCS;AHo8db;;A2Bh8dA;EACE,mBAAA;EACA,sBxBrOM;EwBsON,SAAA;EACA,gBAAA;EACA,cxBTW;AH48db;A2Bl8dE;EACE,wBAAA;EACA,cxBPS;EwBQT,iBAAA;A3Bo8dJ;A2Bl8dE;EACD,exBwFc;EwBvFX,sBAAA;A3Bo8dJ;A2Bn8dC;EACC,exBqFa;AHg3df;A2Bl8dE;EACE,UAAA;EACA,sBAAA;A3Bo8dJ;A2Bl8dE;EACE,0CAAA;A3Bo8dJ;A2Bn8dC;EACC,cxBnRQ;AHwteV;A2Bl8dE;EACE,0CAAA;A3Bo8dJ;A2Bn8dC;EACC,cxBvRU;AH4teZ;A2Bl8dE;EACE,0CAAA;A3Bo8dJ;A2Bn8dC;EACC,cxBvRQ;AH4teV;A2Bl8dE;EACE,0CAAA;A3Bo8dJ;A2Bn8dC;EACC,cxB3RO;AHgueT;;A2Bj8dA;EACE,aAAA;EACA,mBAAA;A3Bo8dF;A2Bn8dE;EACE,oCAAA;A3Bq8dJ;;A2Bl8dA;EACE;IACE,qBAAA;E3Bq8dF;AACF;A2Bn8dA;EACI,UAAA;A3Bq8dJ;;A2Bn8dA;EACI,UAAA;A3Bs8dJ;;A2Bp8dA;EACI,YAAA;A3Bu8dJ;;A2Br8dA;EACI,YAAA;A3Bw8dJ;;A2Bt8dA;EACI,YAAA;A3By8dJ;;A2Bv8dA;EACI,YAAA;A3B08dJ;;A2Bx8dA;EACI,YAAA;A3B28dJ;;A2Bz8dA;EACI,YAAA;A3B48dJ;;A2B18dA;EACI,YAAA;A3B68dJ;;A2B38dA;EACI,YAAA;A3B88dJ;;A2B58dA;EACI,YAAA;A3B+8dJ;;A4BvzeA;EACE,+BAAA;EACA,kCAAA;EACA,+BAAA;EACA,+BAAA;EACA,iCAAA;EACA,mCAAA;A5B0zeF;;A4BxzeA;EACE,sBzBkCM;EyBjCN,yBAAA;EACA,8DzB+UW;EyB9UX,iBAAA;EACA,kBzBoUc;EyBnUd,YAAA;A5B2zeF;A4B1zeE;EACE,sBzB2BI;EyB1BJ,mCAAA;A5B4zeJ;A4B1zeE;EACE,czBsPS;AHskeb;A4B1zeE;EACE,qBAAA;A5B4zeJ;;A4BzzeA;;;;EAIE,yBzBWM;AHizeR;;A4B1zeA;;;;EAIE,2BzBKM;AHwzeR;;A4B3zeA;;;;EAIE,0BzBDM;AH+zeR;;A4B5zeA;;;;;;EAME,4BzBTM;AHw0eR;;A4B3zeE;EACE,yBzBnCM;EyBoCN,WzBbI;AH20eR;A4B5zeE;EAEE,4BzBxCM;AHq2eV;;A4Bn0eE;EACE,yBzBjCQ;EyBkCR,WzBbI;AHm1eR;A4Bp0eE;EAEE,4BzBtCQ;AH22eZ;;A4B30eE;EACE,yBzB3BM;EyB4BN,WzBbI;AH21eR;A4B50eE;EAEE,4BzBhCM;AH62eV;;A4Bn1eE;EACE,yBzB7BG;EyB8BH,WzBbI;AHm2eR;A4Bp1eE;EAEE,4BzBlCG;AHu3eP;;A4B31eE;EACE,yBzB/BM;EyBgCN,WzBbI;AH22eR;A4B51eE;EAEE,4BzBpCM;AHi4eV;;A4Bn2eE;EACE,yBzBzBK;EyB0BL,WzBbI;AHm3eR;A4Bp2eE;EAEE,4BzB9BK;AHm4eT;;A4B/0eE;EACI,yBAAA;A5Bk1eN;A4Bj1eI;EACE,yBzBjEI;EyBkEJ,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5Bm1eN;A4Bj1eI;EACE,yBzBvEI;EyBwEJ,WzBjDE;EyBkDF,gCAAA;A5Bm1eN;A4Bh1eE;EAIE,yBzBhFM;AH+5eV;A4B70eE;EAIE,2BzBtFM;AHk6eV;A4B10eE;EAIE,0BzB5FM;AHq6eV;A4Bv0eE;EAME,4BzBpGM;AHw6eV;;A4B12eE;EACI,yBAAA;A5B62eN;A4B52eI;EACE,yBzB/DM;EyBgEN,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5B82eN;A4B52eI;EACE,yBzBrEM;EyBsEN,WzBjDE;EyBkDF,gCAAA;A5B82eN;A4B32eE;EAIE,yBzB9EQ;AHw7eZ;A4Bx2eE;EAIE,2BzBpFQ;AH27eZ;A4Br2eE;EAIE,0BzB1FQ;AH87eZ;A4Bl2eE;EAME,4BzBlGQ;AHi8eZ;;A4Br4eE;EACI,yBAAA;A5Bw4eN;A4Bv4eI;EACE,yBzBzDI;EyB0DJ,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5By4eN;A4Bv4eI;EACE,yBzB/DI;EyBgEJ,WzBjDE;EyBkDF,gCAAA;A5By4eN;A4Bt4eE;EAIE,yBzBxEM;AH68eV;A4Bn4eE;EAIE,2BzB9EM;AHg9eV;A4Bh4eE;EAIE,0BzBpFM;AHm9eV;A4B73eE;EAME,4BzB5FM;AHs9eV;;A4Bh6eE;EACI,yBAAA;A5Bm6eN;A4Bl6eI;EACE,yBzB3DC;EyB4DD,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5Bo6eN;A4Bl6eI;EACE,yBzBjEC;EyBkED,WzBjDE;EyBkDF,gCAAA;A5Bo6eN;A4Bj6eE;EAIE,yBzB1EG;AH0+eP;A4B95eE;EAIE,2BzBhFG;AH6+eP;A4B35eE;EAIE,0BzBtFG;AHg/eP;A4Bx5eE;EAME,4BzB9FG;AHm/eP;;A4B37eE;EACI,yBAAA;A5B87eN;A4B77eI;EACE,yBzB7DI;EyB8DJ,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5B+7eN;A4B77eI;EACE,yBzBnEI;EyBoEJ,WzBjDE;EyBkDF,gCAAA;A5B+7eN;A4B57eE;EAIE,yBzB5EM;AHugfV;A4Bz7eE;EAIE,2BzBlFM;AH0gfV;A4Bt7eE;EAIE,0BzBxFM;AH6gfV;A4Bn7eE;EAME,4BzBhGM;AHghfV;;A4Bt9eE;EACI,yBAAA;A5By9eN;A4Bx9eI;EACE,yBzBvDG;EyBwDH,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5B09eN;A4Bx9eI;EACE,yBzB7DG;EyB8DH,WzBjDE;EyBkDF,gCAAA;A5B09eN;A4Bv9eE;EAIE,yBzBtEK;AH4hfT;A4Bp9eE;EAIE,2BzB5EK;AH+hfT;A4Bj9eE;EAIE,0BzBlFK;AHkifT;A4B98eE;EAME,4BzB1FK;AHqifT;;A4Bj/eE;EACI,yBAAA;A5Bo/eN;A4Bn/eI;EACE,yBzBxCG;EyByCH,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5Bq/eN;A4Bn/eI;EACE,yBzB9CG;EyB+CH,WzBjDE;EyBkDF,gCAAA;A5Bq/eN;A4Bl/eE;EAIE,yBzBvDK;AHwifT;A4B/+eE;EAIE,2BzB7DK;AH2ifT;A4B5+eE;EAIE,0BzBnEK;AH8ifT;A4Bz+eE;EAME,4BzB3EK;AHijfT;;A4B5gfE;EACI,yBAAA;A5B+gfN;A4B9gfI;EACE,yBzBrCC;EyBsCD,oDAAA;EACA,WzB5CE;EyB6CF,gCAAA;A5BghfN;A4B9gfI;EACE,yBzB3CC;EyB4CD,WzBjDE;EyBkDF,gCAAA;A5BghfN;A4B7gfE;EAIE,yBzBpDG;AHgkfP;A4B1gfE;EAIE,2BzB1DG;AHmkfP;A4BvgfE;EAIE,0BzBhEG;AHskfP;A4BpgfE;EAME,4BzBxEG;AHykfP;;A4Bp+eI;EACI,uCAAA;A5Bu+eR;A4Bt+eM;EACE,uCAAA;EACA,iDAAA;EACA,czBtIE;EyBuIF,gBAAA;A5Bw+eR;A4Bt+eM;EACE,uCAAA;EACA,czB3IE;AHmnfV;A4Br+eI;EAIE,uCAAA;A5Bo+eN;A4Bl+eI;EAIE,yCAAA;A5Bi+eN;A4B/9eI;EAIE,wCAAA;A5B89eN;A4B59eI;EAME,0CAAA;A5By9eN;;A4Br9eI;EACI,wCAAA;A5Bw9eR;A4Bv9eM;EACE,wCAAA;EACA,kDAAA;EACA,czB7KI;EyB8KJ,gBAAA;A5By9eR;A4Bv9eM;EACE,wCAAA;EACA,czBlLI;AH2ofZ;A4Bt9eI;EAIE,iDAAA;A5Bq9eN;A4Bn9eI;EAIE,0CAAA;A5Bk9eN;A4Bh9eI;EAIE,kDAAA;A5B+8eN;A4B78eI;EAME,oDAAA;A5B08eN;;A4Bt8eI;EACI,wCAAA;A5By8eR;A4Bx8eM;EACE,wCAAA;EACA,kDAAA;EACA,czBhNE;EyBiNF,gBAAA;A5B08eR;A4Bx8eM;EACE,wCAAA;EACA,czBrNE;AH+pfV;A4Bv8eI;EAIE,wCAAA;A5Bs8eN;A4Bp8eI;EAIE,0CAAA;A5Bm8eN;A4Bj8eI;EAIE,yCAAA;A5Bg8eN;A4B97eI;EAME,2CAAA;A5B27eN;;A4Bv7eI;EACI,yCAAA;A5B07eR;A4Bz7eM;EACE,yCAAA;EACA,mDAAA;EACA,czB3PD;EyB4PC,gBAAA;A5B27eR;A4Bz7eM;EACE,yCAAA;EACA,czBhQD;AH2rfP;A4Bx7eI;EAIE,yCAAA;A5Bu7eN;A4Br7eI;EAIE,2CAAA;A5Bo7eN;A4Bl7eI;EAIE,0CAAA;A5Bi7eN;A4B/6eI;EAME,4CAAA;A5B46eN;;A4Bx6eI;EACI,wCAAA;A5B26eR;A4B16eM;EACE,wCAAA;EACA,kDAAA;EACA,czBtSE;EyBuSF,gBAAA;A5B46eR;A4B16eM;EACE,wCAAA;EACA,czB3SE;AHutfV;A4Bz6eI;EAIE,wCAAA;A5Bw6eN;A4Bt6eI;EAIE,0CAAA;A5Bq6eN;A4Bn6eI;EAIE,yCAAA;A5Bk6eN;A4Bh6eI;EAME,2CAAA;A5B65eN;;A4Bz5eI;EACI,uCAAA;A5B45eR;A4B35eM;EACE,uCAAA;EACA,iDAAA;EACA,czBzUC;EyB0UD,gBAAA;A5B65eR;A4B35eM;EACE,uCAAA;EACA,czB9UC;AH2ufT;A4B15eI;EAIE,uCAAA;A5By5eN;A4Bv5eI;EAIE,yCAAA;A5Bs5eN;A4Bp5eI;EAIE,wCAAA;A5Bm5eN;A4Bj5eI;EAME,0CAAA;A5B84eN;;A4B14eI;EACI,8CAAA;A5B64eR;A4B54eM;EACE,8CAAA;EACA,wDAAA;EACA,czBnWC;EyBoWD,gBAAA;A5B84eR;A4B54eM;EACE,8CAAA;EACA,czBxWC;AHsvfT;A4B34eI;EAIE,8CAAA;A5B04eN;A4Bx4eI;EAIE,gDAAA;A5Bu4eN;A4Br4eI;EAIE,+CAAA;A5Bo4eN;A4Bl4eI;EAME,iDAAA;A5B+3eN;;A4B33eI;EACI,4CAAA;A5B83eR;A4B73eM;EACE,4CAAA;EACA,sDAAA;EACA,czBzYD;EyB0YC,gBAAA;A5B+3eR;A4B73eM;EACE,4CAAA;EACA,czB9YD;AH6wfP;A4B53eI;EAIE,4CAAA;A5B23eN;A4Bz3eI;EAIE,8CAAA;A5Bw3eN;A4Bt3eI;EAIE,6CAAA;A5Bq3eN;A4Bn3eI;EAME,+CAAA;A5Bg3eN;;A4B72eA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;ExBxXD,cwByXyB;ExBxXzB,oBwBwXiC;A5Bi3epC;A4Bh3eI;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBzB3TK;EC5ET,kBwBwYwB;ExBvYxB,MwBuYiC;ExBrYjC,SwBqYwC;ExBpYxC,SwBoY0C;A5Bq3e5C;A4Bn3eI;EACE,kBAAA;EACA,mBAAA;A5Bq3eN;A4Bp3eM;EACI,YAAA;EACD,cAAA;A5Bs3eT;A4Bp3eM;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;ExBtXR,sBwBuX2B;ExB3W3B,yCAAA;AJoufF;A4Bv3eY;EACI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;ExBhad,kBwBiakC;ExBhalC,SwBga2C;ExB/Z3C,WwB+ZgD;A5B23elD;A4Bz3ec;EACI,YAAA;EACA,qBAAA;ExBrahB,kBwBsaoC;ExBrapC,SwBqa6C;ExBpa7C,WwBoakD;EAClC,iCAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;A5B63elB;;A4Bx3eA;EACE,WAAA;A5B23eF;;A4Bz3eA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WzB9eM;EyB+eN,gBAAA;ExB3ZA,kBwB4ZmB;ExB5bnB,kBwB6boB;ExB5bpB,SwB4b6B;ExBzb7B,SwByb4C;A5B83e9C;;A4B53eA;EACE,YAAA;A5B+3eF;A4B93eE;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;A5Bg4eN;A4B93eI;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;A5Bg4eR;;A4B73eA;EACE,yBzB1hBQ;AH05fV;;A4B93eA;EACE,yBzBzhBQ;AH05fV;;A4B/3eA;EACE,yBzBxhBQ;AH05fV;;A4Bh4eA;EACE,yBzBzhBO;AH45fT;;A4Bj4eA;EACE,yBzBhiBK;AHo6fP;;A4Bl4eA;EACE,aAAA;EACA,cAAA;EACA,oBAAA;A5Bq4eF;;A4Bn4eA;;EAEE,gBAAA;A5Bs4eF;;A4Bp4eA;EACE,eAAA;A5Bu4eF;;A6B78fA;EACI,mBAAA;A7Bg9fJ;;A6B98fA;EACI,e1BiWW;E0BhWX,gB1BKiB;E0BJjB,c1BqQU;AH4sfd;;A6B/8fA;EACE,qB1B6JU;E0B5JV,c1BgQW;E0B/PX,yB1B2QgB;E0B1QhB,e1ByVa;E0BxVb,gB1BJmB;E0BKnB,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,6DAAA;EACA,gBAAA;A7Bk9fF;A6Bj9fE;EACE,gBAAA;EACA,qB1BiJQ;E0BhJR,sB1BqBI;E0BpBJ,sDAAA;EACA,c1BkPS;AHiufb;;A6Bh9fA;EACE,sBAAA;EACA,gBAAA;A7Bm9fF;A6Bl9fE;EACE,kCAAA;A7Bo9fJ;A6Bl9fE;EACE,+BAAA;A7Bo9fJ;;A6Bj9fA;EACI,e1B+TW;E0B9TX,gB1B7BiB;E0B8BjB,c1BmOU;ECnKX,gByB/D+B;A7Bo9flC;;A6Bl9fA;EACE,e1ByTa;E0BxTb,gB1BnCmB;E0BoCnB,c1B6NY;AHwvfd;;A6Bn9fA;EACE,c1B8NW;AHwvfb;;A6Bn9fA;EACE,yB1BZM;E0BaN,SAAA;A7Bs9fF;A6Bp9fE;EACE,yB1BhBI;AHs+fR;;A6Bn9fA;EACE,uCAAA;EACA,SAAA;EACA,c1B3CQ;AHiggBV;A6Bp9fE;EACE,uCAAA;EACA,c1B/CM;AHqggBV;;A6Bn9fA;EACE,eAAA;EACA,cAAA;EACA,kB1BwQc;E0BvQd,gBAAA;EACA,UAAA;A7Bs9fF;;A6Bp9fA;;;;EAIE,c1B8LW;AHyxfb;;A6Br9fA;EACE,6BAAA;A7Bw9fF;;A6Bt9fA;EACE,6DAAA;A7By9fF;;A6Bv9fA;EACE,yB1B4LgB;E0B3LhB,yBAAA;EACA,c1B8KW;E0B7KX,e1BzFe;E0B0Ff,yDAAA;EACA,wBAAA;EACA,cAAA;EACA,6DAAA;A7B09fF;A6Bz9fE;EACE,sB1BxDI;E0ByDJ,wBAAA;EACA,sBAAA;EACA,yBAAA;A7B29fJ;A6B19fI;EACE,mBAAA;A7B49fN;A6Bz9fE;EACE,yCAAA;EACA,c1BzFM;AHojgBV;A6Bz9fE;EACE,yCAAA;EACA,c1B7FM;AHwjgBV;A6Bz9fE;EACE,yCAAA;EACA,c1BjGM;AH4jgBV;A6Bz9fE;EACE,yCAAA;EACA,c1BrGM;AHgkgBV;;A6Bx9fA;EACE,aAAA;EACA,cAAA;EACA,sB1BpFM;E0BqFN,yBAAA;A7B29fF;A6B19fE;EACE,yB1B9GM;E0B+GN,qB1B/GM;AH2kgBV;A6Bz9fI;EACE,6BAAA;EACA,qB1BpHI;AH+kgBV;A6Bv9fI;EACE,yB1BvHM;E0BwHN,qB1BxHM;AHilgBZ;A6Br9fI;EACE,yB1BvHI;E0BwHJ,qB1BxHI;AH+kgBV;A6Bn9fI;EACE,yB1B/HC;E0BgID,qB1BhIC;AHqlgBP;A6Bj9fI;EACE,yB1BvII;E0BwIJ,qB1BxII;AH2lgBV;A6B/8fI;EACE,yB1BvIG;E0BwIH,qB1BxIG;AHylgBT;A6B78fI;EACE,yB1BlIE;E0BmIF,qB1BnIE;AHklgBR;A6B38fI;EACE,yB1BjJC;E0BkJD,qB1BlJC;AH+lgBP;A6B18fE;EACE,gBAAA;A7B48fJ;;A6Bz8fA;EACE,sBAAA;EACA,kBAAA;EACA,6BAAA;A7B48fF;A6B18fE;EACE,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,c1B9KM;E0B+KN,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;A7B48fJ;A6Bx8fI;EACE,c1BtLM;AHgogBZ;A6Br8fI;EACE,c1BtLI;AH6ngBV;A6Bl8fI;EACE,c1B9LC;AHkogBP;A6B/7fI;EACE,c1BtMI;AHuogBV;A6B57fI;EACE,c1BtMG;AHoogBT;A6Bz7fI;EACE,c1BjME;AH4ngBR;A6Bt7fI;EACE,c1BhNC;AHwogBP;;A6Bp7fA;EACE,sBAAA;EACA,kBAAA;EACA,6BAAA;A7Bu7fF;A6Br7fE;EACE,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,c1BzOM;E0B0ON,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,eAAA;A7Bu7fJ;A6Bn7fI;EACE,c1BjPM;AHsqgBZ;A6Bh7fI;EACE,c1BjPI;AHmqgBV;A6B76fI;EACE,c1BzPC;AHwqgBP;A6B16fI;EACE,c1BjQI;AH6qgBV;A6Bv6fI;EACE,c1BjQG;AH0qgBT;A6Bp6fI;EACE,c1B5PE;AHkqgBR;A6Bj6fI;EACE,c1B3QC;AH8qgBP;;A6B/5fA;EACE,W1BrQM;E0BsQN,yB1B7RQ;E0B8RR,qB1B9RQ;AHgsgBV;;A6Bh6fA;EACE,qCAAA;EACA,UAAA;EACA,gBAAA;A7Bm6fF;;A6Bj6fA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;A7Bo6fF;;A6Bl6fA;;;;;EAKE,gBAAA;A7Bq6fF;;A6Bj6fI;;EACE,yB1BhSE;E0BiSF,c1BhEO;AHq+fb;;A6Bl6fA;EACE,c1BpEW;AHy+fb;;A6Bn6fA;EACE,c1BvEW;E0BwEX,yB1BlEmB;AHw+frB;;A6Bp6fA;EACE,yB1BrEmB;AH4+frB;;A6Bn6fI;EAEE,4BAAA;EACA,qDAAA;EAAA,6CAAA;A7Bq6fN;A6Bl6fE;EACE,iBAAA;EACA,gB1BvViB;E0BwVjB,YAAA;EACA,c1BzFS;E0B0FT,yBAAA;EACA,qDAAA;EAAA,6CAAA;A7Bo6fJ;A6Bl6fE;EACE,iBAAA;EACA,gB1B/ViB;E0BgWjB,YAAA;EACA,c1BjGS;AHqggBb;A6Bl6fE;EACE,iBAAA;EACA,gB1BrWiB;E0BsWjB,YAAA;EACA,c1BvGS;AH2ggBb;A6Bl6fE;EACE,iBAAA;EACA,gB1B3WiB;E0B4WjB,YAAA;EACA,c1B7GS;AHihgBb;;A6Bj6fA;EACE,iBAAA;EACA,uBAAA;A7Bo6fF;;A6Bl6fA;EACE,eAAA;EACA,oBAAA;A7Bq6fF;;A6Bj6fE;EACE,cAAA;EACA,eAAA;A7Bo6fJ;A6Bh6fI;EACE,cAAA;A7Bk6fN;A6B95fE;EACE,2BAAA;EACA,kBAAA;EACA,uBAAA;A7Bg6fJ;;A6B35fE;EACE,cAAA;EACA,eAAA;A7B85fJ;A6B15fI;EACE,aAAA;A7B45fN;A6Bx5fE;EACE,2BAAA;EACA,eAAA;EACA,uBAAA;A7B05fJ;;A6Bv5fA;EACE,cAAA;EACA,gBAAA;EACA,yB1BlYM;E0BmYN,6BAAA;EACA,0BAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;A7B05fF;A6Bx5fE;EACE,kBAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,sB1BjZI;E0BkZJ,qDAAA;EACA,eAAA;EACA,yBAAA;A7B05fJ;A6Bx5fI;EACE,aAAA;EACA,6BAAA;A7B05fN;A6Bv5fI;EACE,cAAA;EACA,2BAAA;EACA,c1B1LO;AHmlgBb;A6Bt5fI;EAEE,kBAAA;EACA,mBAAA;EACA,gB1Btce;E0Bucf,qBAAA;EACA,yBAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;A7Bu5fN;A6Bn5fE;EACE,yCAAA;A7Bq5fJ;A6Bn5fI;EACE,yB1BzcI;AH81gBV;A6Bn5fM;EACE,c1B5cE;AHi2gBV;A6Bj5fI;EACE,wCAAA;A7Bm5fN;A6Bj5fM;EACE,yB1BldI;AHq2gBZ;A6Bj5fQ;EACE,c1BrdE;AHw2gBZ;A6B94fI;EACE,wCAAA;A7Bg5fN;A6B94fM;EACE,yB1BxdE;AHw2gBV;A6B94fQ;EACE,c1B3dA;AH22gBV;A6B34fI;EACE,yCAAA;A7B64fN;A6B34fM;EACE,yB1BteD;AHm3gBP;A6B34fQ;EACE,c1BzeH;AHs3gBP;A6Bx4fI;EACE,wCAAA;A7B04fN;A6Bx4fM;EACE,yB1BpfE;AH83gBV;A6Bx4fQ;EACE,c1BvfA;AHi4gBV;A6Br4fI;EACE,uCAAA;A7Bu4fN;A6Br4fM;EACE,yB1B1fC;AHi4gBT;A6Br4fQ;EACE,c1B7fD;AHo4gBT;A6Bl4fI;EACE,0CAAA;A7Bo4fN;A6Bl4fM;EACE,yB1B3fA;AH+3gBR;A6Bl4fQ;EAEE,c1BzRG;AH4pgBb;A6B93fI;EACE,uCAAA;A7Bg4fN;A6B93fM;EACE,yB1BjhBD;AHi5gBP;A6B93fQ;EACE,W1BzgBF;AHy4gBR;A6B33fI;EACE,4BAAA;A7B63fN;A6B13fI;EACE,4BAAA;A7B43fN;A6B13fM;EACE,uBAAA;EACA,6BAAA;A7B43fR;A6Bx3fI;EACE,4BAAA;A7B03fN;A6Bx3fM;EACE,yBAAA;EACA,4BAAA;A7B03fR;A6Br3fE;EACE,gBAAA;EACA,eAAA;A7Bu3fJ;A6Br3fI;EACE,eAAA;EACA,gBAAA;A7Bu3fN;A6Br3fM;EACE,2BAAA;EACA,uBAAA;A7Bu3fR;A6Bl3fE;EACE,gBAAA;EACA,aAAA;A7Bo3fJ;A6Bl3fI;EACE,cAAA;A7Bo3fN;A6Bl3fM;EACE,yBAAA;EACA,2BAAA;A7Bo3fR;;A6B/2fA;EACE,aAAA;A7Bk3fF;;A6Bh3fA;EACE,eAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;A7Bm3fF;;A6Bh3fA;EACE,mB1BpmBQ;E0BqmBR,W1B9kBM;AHi8gBR;;A6Bh3fA;EACE,mB1BvmBU;E0BwmBV,W1BnlBM;AHs8gBR;;A6Bh3fA;EACE,mB1BtmBQ;E0BumBR,W1BxlBM;AH28gBR;;A6Bh3fA;EACE,mB1B7mBK;E0B8mBL,W1B7lBM;AHg9gBR;;A6Bh3fA;EACE,mB1BpnBQ;E0BqnBR,W1BlmBM;AHq9gBR;;A6Bh3fA;EACE,mB1BnnBO;E0BonBP,W1BvmBM;AH09gBR;;A6Bh3fA;EACE,mB1B7mBM;E0B8mBN,W1B5mBM;AH+9gBR;;A6Bh3fA;EACE,mB1B3nBK;E0B4nBL,W1BjnBM;AHo+gBR;;A6Bh3fA;EACE,mBAAA;EACA,YAAA;A7Bm3fF;;A6Bh3fE;EACE,mB1BtZS;E0BuZT,2DAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;A7Bm3fJ;A6Bh3fE;EACE,gB1BvoBI;E0BwoBJ,mBAAA;EACA,iDAAA;EACA,WAAA;EACA,cAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,2BAAA;EACA,gCAAA;EACA,aAAA;A7Bk3fJ;;A6B/2fA;EACE,mBAAA;EACA,uBAAA;A7Bk3fF;;A6B/2fA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;A7Bk3fF;;A6B/2fA;EACE,wBAAA;A7Bk3fF;;A6B/2fA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;A7Bk3fF;;A6B/2fA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;A7Bk3fF;;A6B/2fA;EACE,uBAAA;A7Bk3fF;;A6B/2fA;EACE,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;A7Bk3fF;;A6B72fI;;EACE,6BAAA;A7Bi3fN;;A6B72fA;;;EAGE,0BAAA;A7Bg3fF;;A6B52fI;EACE,c1BhuBI;E0BiuBJ,UAAA;A7B+2fN;A6B52fI;EACE,yBAAA;A7B82fN;A6B52fI;EACE,yBAAA;A7B82fN;A6Bz2fI;EACE,c1B5uBM;E0B6uBN,UAAA;A7B22fN;A6Bx2fI;EACE,yBAAA;A7B02fN;A6Bx2fI;EACE,yBAAA;A7B02fN;A6Br2fI;EACE,c1BpvBI;E0BqvBJ,UAAA;A7Bu2fN;A6Bp2fI;EACE,yBAAA;A7Bs2fN;A6Bp2fI;EACE,yBAAA;A7Bs2fN;A6Bj2fI;EACE,c1BpwBC;E0BqwBD,UAAA;A7Bm2fN;A6Bh2fI;EACE,yBAAA;A7Bk2fN;A6Bh2fI;EACE,yBAAA;A7Bk2fN;A6B71fI;EACE,c1BpxBI;E0BqxBJ,UAAA;A7B+1fN;A6B51fI;EACE,yBAAA;A7B81fN;A6B51fI;EACE,yBAAA;A7B81fN;A6Bz1fI;EACE,c1B5xBG;E0B6xBH,UAAA;A7B21fN;A6Bx1fI;EACE,yBAAA;A7B01fN;A6Bx1fI;EACE,yBAAA;A7B01fN;;A6Bt1fA;;;;EAIE,sB1B/xBM;E0BgyBN,kB1B1fc;AHm1gBhB;;A6Bv1fA;EACE,gBAAA;EACA,mBAAA;A7B01fF;A6Bx1fE;EACE,SAAA;A7B01fJ;A6Bt1fI;EACE,uBAAA;EACA,kBAAA;A7Bw1fN;A6Br1fI;EACE,uBAAA;EACA,c1B9kBO;E0B+kBP,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;A7Bu1fN;A6Br1fM;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;A7Bu1fR;A6Bp1fM;EAEE,6BAAA;A7Bq1fR;A6Bl1fM;EACE,yBAAA;EACA,mBAAA;EACA,c1B/1BE;E0Bg2BF,6BAAA;A7Bo1fR;A6Bl1fQ;EACE,yBAAA;A7Bo1fV;A6B90fE;EACE,aAAA;A7Bg1fJ;;A6B70fA;;EAEE,qB1B32BQ;E0B42BR,gBAAA;A7Bg1fF;;A6B90fA;;EAEE,qB1Bh3BQ;AHishBV;;A6B/0fA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;A7Bk1fF;;A6B/0fE;EACE,iCAAA;EACA,gBAAA;A7Bk1fJ;;A6B90fE;;;;EAIE,cAAA;A7Bi1fJ;;A6B90fA;EACE,uBAAA;EACA,2EAAA;A7Bi1fF;;A6B/0fA;EAKE,cAAA;A7B80fF;;A6B50fA;EACE,yB1Bj4BM;AHgthBR;;A6B50fE;EACE,uBAAA;A7B+0fJ;;A6B30fA;EACE,qBAAA;A7B80fF;;A6B50fA;EACE,qBAAA;A7B+0fF;;A6B70fA;EACE,kBAAA;EACA,MAAA;A7Bg1fF;;A6B90fA;EACE,8BAAA;A7Bi1fF;;A6B/0fA;;;EAGE,gB1Bx7BmB;AH0whBrB;;A6Bh1fA;EACE,cAAA;A7Bm1fF;;A6B10fM;EACE,iBAAA;A7B60fR;;A6Bt0fI;EAKE,eAAA;A7Bq0fN;;A6Bh0fE;EACE,YAAA;A7Bm0fJ;A6Bj0fE;EACE,YAAA;EACA,gBAAA;A7Bm0fJ;;A6B/zfE;EACE,YAAA;A7Bk0fJ;A6Bh0fE;EACE,YAAA;EACA,gBAAA;A7Bk0fJ;;A6B/zfA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,oBAAA;EACA,gBAAA;A7Bk0fF;;A6Bh0fA;EACE,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,kBAAA;A7Bm0fF;A6Bl0fE;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;A7Bo0fN;;A6Bj0fA;EACE,yBAAA;EACA,kBAAA;A7Bo0fF;;A6Bl0fA;EACE,yB1Bp+BO;E0Bq+BP,qB1Br+BO;AH0yhBT;;A6Bn0fI;EACE,cAAA;A7Bs0fN;;A6Bp0fI;EACE,YAAA;EACA,WAAA;EzB17BJ,kByB27BsB;EzB17BtB,MyB07BgC;EzBv7BhC,OyBu7B+C;A7By0fjD;;A6Bv0fI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;A7B00fN;;A6Bx0fI;EACE,SAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;EACA,kCAAA;EACA,W1B5/BE;E0B6/BF,gB1B7hCiB;E0B8hCjB,eAAA;A7B20fN;;A6Bz0fA;;EAEE,kBAAA;EACA,aAAA;A7B40fF;;A6B10fA;;EAGE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,c1Bv4BS;AHmthBX;;A6B10fA;;EAEE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,gB1BzhCM;AHs2hBR;;A6B30fA;EACE,mB1BlhCO;E0BmhCP,qB1BnhCO;AHi2hBT;;A6B50fA;;EAEE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gB1BpiCM;E0BqiCN,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EAEA,yBAAA;A7B+0fF;;A6B70fA;EACE,UAAA;EAEA,mBAAA;A7Bg1fF;;A6B90fA;EACE,UAAA;EAEA,mBAAA;A7Bi1fF;;A6B/0fA;EACE,qB1Bl8BU;E0Bm8BV,6DAAA;EACA,kBAAA;EACA,e1BhwBa;E0BiwBb,c1B51BW;E0B61BX,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;A7Bk1fF;A6Bj1fE;EACI,mB1B/8BM;E0Bg9BN,c1Bt2BO;E0Bu2BP,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,e1B/wBS;AHkmhBf;;A8Bt8hBI;EACI,aAAA;A9By8hBR;A8Bx8hBQ;EACI,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;A9B08hBZ;AIp6hBI;E0B1CI;IAMQ,sBAAA;IACA,kBAAA;E9B48hBd;AACF;A8B38hBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,W3BiBR;E2BhBQ,WAAA;EACA,YAAA;EACA,YAAA;A9B68hBhB;AI77hBI;E0BjCQ;IAmBQ,aAAA;E9B+8hBlB;AACF;A8B58hBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gB3BLJ;E2BMI,sDAAA;A9B88hBZ;AIl9hBI;E0BVI;IAgBQ,sBAAA;IACA,kBAAA;E9Bg9hBd;AACF;A8B/8hBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bi9hBhB;AIh+hBI;E0BSQ;IAQQ,mBAAA;E9Bm9hBlB;AACF;AIr+hBI;E0BSQ;IAWQ,gBAAA;IACA,sBAAA;IACA,uBAAA;E9Bq9hBlB;AACF;A8Bp9hBgB;EACI,iBAAA;EACA,YAAA;A9Bs9hBpB;A8Bl9hBgC;EACI,6BAAA;A9Bo9hBpC;A8B78hBgB;EACI,mB3ByFT;E2BxFS,iBAAA;EACA,W3B3CZ;E2B4CY,e3B+QL;E2B9QK,gB3B/EC;E2BgFD,kBAAA;EACA,YAAA;EACA,mBAAA;A9B+8hBpB;A8B98hBoB;EACI,mB3BzEd;AHyhiBV;AIhgiBI;E0BsCY;IAaQ,cAAA;E9Bi9hBtB;AACF;A8B78hBgB;EACI,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;A9B+8hBpB;A8B38hBQ;EACI,kBAAA;EACA,oBAAA;EACA,gCAAA;A9B68hBZ;A8B58hBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A9B88hBhB;A8B58hBoB;EACI,c3BlGf;E2BmGe,e3BqOT;E2BpOS,gB3BzHH;AHukiBrB;A8B78hBwB;EACI,iBAAA;A9B+8hB5B;A8B18hBY;EACI,aAAA;EACA,kBAAA;EACA,oCAAA;A9B48hBhB;A8B38hBgB;EACI,oCAAA;A9B68hBpB;A8B38hBgB;EACI,mCAAA;A9B68hBpB;A8B38hBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9B68hBpB;A8B38hBwB;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3BvIlB;E2BwIkB,e3BhKX;E2BiKW,gB3B1JL;E2B2JK,aAAA;EACA,mBAAA;A9B68hB5B;A8B58hB4B;EACI,cAAA;EACA,iBAAA;A9B88hBhC;A8B58hB4B;EACI,cAAA;EACA,yBAAA;A9B88hBhC;A8B58hB4B;EACI,c3BnJvB;E2BoJuB,yBAAA;A9B88hBhC;A8B18hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,c3BhBb;AH49hBX;A8B18hB4B;EACI,c3BfrB;AH29hBX;A8B38hBgC;EACI,c3BjBzB;AH89hBX;A8Bt8hBgB;EACI,cAAA;A9Bw8hBpB;A8Bt8hBwB;EACI,mBAAA;EACA,c3BjCjB;E2BkCiB,e3BwJb;E2BvJa,gB3BrML;E2BsMK,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bw8hB5B;A8Bv8hB4B;EACI,c3B1LtB;AHmoiBV;A8Br8hBoB;EACI,c3B+CX;E2B9CW,e3B0IT;E2BzIS,gB3BpNH;E2BqNG,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bu8hBxB;A8Bp8hBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9Bs8hBpB;A8Br8hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bu8hBxB;A8Bt8hBwB;EACI,kBAAA;A9Bw8hB5B;A8Bv8hB4B;EACI,WAAA;EACA,YAAA;EACA,aAAA;A9By8hBhC;A8Bx8hBgC;EACI,oBAAA;A9B08hBpC;A8Bp8hB4B;EACI,iBAAA;A9Bs8hBhC;A8Br8hBgC;EACI,c3B9O1B;E2B+O0B,wBAAA;EACA,eAAA;A9Bu8hBpC;A8Bp8hB4B;EACI,iBAAA;A9Bs8hBhC;A8Br8hBgC;EACI,c3BlP1B;E2BmP0B,wBAAA;EACA,eAAA;A9Bu8hBpC;A8Bp8hB4B;EACI,iBAAA;A9Bs8hBhC;A8Br8hBgC;EACI,cAAA;EACA,wBAAA;EACA,eAAA;A9Bu8hBpC;A8Bn8hBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,e3BkEb;E2BjEa,gB3B5RP;E2B6RO,kBAAA;A9Bq8hB5B;A8Bn8hBgC;EACI,iBAAA;A9Bq8hBpC;A8Bl8hB4B;EACI,c3BrRtB;AHytiBV;A8Bl8hB4B;EACI,c3BpRtB;AHwtiBV;A8Bh8hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bk8hBxB;A8Bh8hB4B;EACI,c3BjStB;E2BkSsB,WAAA;EACA,YAAA;EACA,kBAAA;A9Bk8hBhC;A8Bh8hB4B;EACI,c3BrSvB;E2BsSuB,WAAA;EACA,YAAA;A9Bk8hBhC;A8B37hBQ;EACI,iBAAA;A9B67hBZ;A8B57hBY;EACI,kBAAA;EACA,0CAAA;EACA,gB3BtSR;E2BuSQ,sDAAA;EACA,aAAA;EACA,mBAAA;A9B87hBhB;A8B77hBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9B+7hBpB;A8B77hBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3B/UlB;E2BgVkB,e3BxWX;E2ByWW,gB3BlWL;AHiyiBvB;A8B97hB4B;EACI,cAAA;EACA,iBAAA;A9Bg8hBhC;A8B97hB4B;EACI,cAAA;EACA,yBAAA;A9Bg8hBhC;A8B97hB4B;EACI,c3BzVvB;E2B0VuB,yBAAA;A9Bg8hBhC;A8B37hBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,c3BvNjB;AHopiBX;A8B57hB4B;EACI,WAAA;EACA,YAAA;EACA,c3B9HnB;AH4jiBb;A8Bz7hBgC;EACI,W3BnW5B;AH8xiBR;A8Br7hBgB;EACI,eAAA;EACA,gCAAA;A9Bu7hBpB;A8Br7hBwB;EACI,c3B5OjB;E2B6OiB,e3BnDb;E2BoDa,gB3BhZL;E2BiZK,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bu7hB5B;A8Bt7hB4B;EACI,c3BtYtB;AH8ziBV;A8Bp7hBoB;EACI,c3B7JX;E2B8JW,e3BlET;E2BmES,gB3BhaH;E2BiaG,mBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bs7hBxB;A8Br7hBwB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;A9Bu7hB5B;A8Bp7hBoB;EACI,c3B9KX;E2B+KW,e3BnFT;E2BoFS,gB3BjbH;E2BkbG,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Bs7hBxB;A8Bn7hBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A9Bq7hBpB;A8Bp7hBoB;EACI,iBAAA;A9Bs7hBxB;A8Bp7hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bs7hBxB;A8Br7hBwB;EACI,kBAAA;A9Bu7hB5B;A8Br7hBgC;EACI,oBAAA;A9Bu7hBpC;A8Bl7hB4B;EACI,iBAAA;A9Bo7hBhC;A8Bn7hBgC;EACI,c3B1c1B;E2B2c0B,wBAAA;EACA,eAAA;A9Bq7hBpC;A8Bl7hB4B;EACI,iBAAA;A9Bo7hBhC;A8Bn7hBgC;EACI,c3B9c1B;E2B+c0B,wBAAA;EACA,eAAA;A9Bq7hBpC;A8Bl7hB4B;EACI,iBAAA;A9Bo7hBhC;A8Bn7hBgC;EACI,cAAA;EACA,wBAAA;EACA,eAAA;A9Bq7hBpC;A8Bj7hBwB;EACI,cAAA;EACA,e3BpJb;E2BqJa,gB3BlfP;E2BmfO,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bm7hB5B;A8Bj7hBgC;EACI,iBAAA;A9Bm7hBpC;A8Bh7hB4B;EACI,c3BjftB;AHm6iBV;A8Bh7hB4B;EACI,c3BhftB;AHk6iBV;A8B96hBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bg7hBxB;A8B96hB4B;EACI,c3B/QnB;E2BgRmB,WAAA;EACA,YAAA;EACA,kBAAA;A9Bg7hBhC;A8B96hB4B;EACI,c3BjgBvB;E2BkgBuB,WAAA;EACA,YAAA;A9Bg7hBhC;;A8Br6hBQ;EACI,c3BhYD;AHwyiBX;;A8Bl6hBI;EACI,WAAA;EACA,YAAA;EACA,c3B5SK;AHitiBb;;A8Bl6hBA;EACI,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,e3BzNW;E2B0NX,gB3BnjBe;E2BojBf,W3BrhBI;E2BshBJ,cAAA;A9Bq6hBJ;A8Bp6hBI;EACI,cAAA;EACA,gB3BzhBA;AH+7iBR;;A8Bl6hBI;EACI,yBAAA;A9Bq6hBR;A8Bl6hBQ;EACI,uBAAA;A9Bo6hBZ;;A8B/5hBI;EACI,kBAAA;A9Bk6hBR;A8Bh6hBY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;A9Bk6hBhB;;A8B35hBA;EACI,+BAAA;A9B85hBJ;;A8B35hBI;EACI,cAAA;A9B85hBR;A8B55hBY;EACI,c3B7bL;E2B8bK,e3BrQD;E2BsQC,gB3BnmBK;E2BomBL,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;A9B85hBhB;A8B75hBgB;EACI,mB3BldR;E2BmdQ,c3BlcT;AHi2iBX;A8B95hBoB;EACI,c3Bpcb;AHo2iBX;A8B15hBQ;EACI,iBAAA;A9B45hBZ;A8B15hBQ;EACI,WAAA;EACA,YAAA;EACA,c3BvXC;AHmxiBb;;A8Bv5hBI;EACI,mBAAA;EACA,0CAAA;EACA,gB3B9lBA;E2B+lBA,c3B7dG;E2B8dH,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;A9B05hBR;A8Bz5hBQ;EACI,mBAAA;EACA,mB3B/nBF;E2BgoBE,W3BzmBJ;AHogjBR;;A8Bn5hBgB;EACI,6BAAA;A9Bs5hBpB;;A8B/4hBA;EACI,WAAA;A9Bk5hBJ;;A8Bh5hBA;EACI,oBAAA;A9Bm5hBJ;;A8Bj5hBA;EACI,aAAA;EACA,oBAAA;A9Bo5hBJ;;A8Bj5hBI;EACI,oBAAA;A9Bo5hBR;;A8B/4hBQ;EACI,yBAAA;EACA,oBAAA;A9Bk5hBZ;;A8B94hBA;EACI,WAAA;A9Bi5hBJ;;A8B/4hBA;EACI,2BAAA;A9Bk5hBJ;;A8Bh5hBA;EACI,uBAAA;A9Bm5hBJ;;A8Bj5hBA;EACI,c3B3bS;E2B4bT,e3BhWW;E2BiWX,gB3B9rBiB;AHkljBrB;;A8Bj5hBI;EACI,SAAA;EACA,kBAAA;A9Bo5hBR;;A8Bj5hBA;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gB3BzqBI;E2B0qBJ,oBAAA;A9Bo5hBJ;A8Bn5hBI;EACI,gCAAA;A9Bq5hBR;A8Bp5hBQ;EACI,e3BjXG;E2BkXH,gB3B9sBO;E2B+sBP,c3B9iBD;E2B+iBC,mBAAA;EACA,aAAA;EACA,mBAAA;A9Bs5hBZ;A8Br5hBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,c3BzdH;AHg3iBb;A8Bn5hBI;EACI,eAAA;EACA,gCAAA;A9Bq5hBR;A8Bp5hBQ;EACI,eAAA;A9Bs5hBZ;A8Br5hBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,aAAA;A9Bu5hBhB;A8Bt5hBgB;EACI,mBAAA;EACA,mB3B5kBT;AHo+iBX;A8Bv5hBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9By5hBxB;A8Bv5hBoB;EACI,W3BrtBhB;AH8mjBR;A8Br5hBgB;EACI,e3B/ZL;E2BgaK,gB3B3vBG;E2B4vBH,c3B7fP;E2B8fO,gBAAA;EACA,aAAA;EACA,mBAAA;A9Bu5hBpB;A8Bt5hBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9Bw5hBxB;A8Br5hBgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mB3BrwBV;E2BswBU,W3B/uBZ;AHsojBR;A8Bj5hBI;EACI,gBAAA;EACA,aAAA;A9Bm5hBR;A8Bl5hBQ;EACI,e3B7bG;E2B8bH,gB3B1xBW;E2B2xBX,c3BznBD;AH6gjBX;A8Bl5hBQ;EACI,eAAA;A9Bo5hBZ;A8Bn5hBY;EACI,mBAAA;A9Bq5hBhB;A8Bj5hBoB;EACI,iBAAA;A9Bm5hBxB;A8Bl5hBwB;EACI,wBAAA;EACA,eAAA;A9Bo5hB5B;A8Bj5hBoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;A9Bm5hBxB;A8B94hBoB;EACI,iBAAA;A9Bg5hBxB;A8B/4hBwB;EACI,wBAAA;EACA,eAAA;A9Bi5hB5B;A8B94hBoB;EACI,c3B1yBd;E2B2yBc,aAAA;EACA,mBAAA;A9Bg5hBxB;A8B34hBoB;EACI,iBAAA;A9B64hBxB;A8B54hBwB;EACI,wBAAA;EACA,eAAA;A9B84hB5B;A8B34hBoB;EACI,c3B7zBd;E2B8zBc,aAAA;EACA,mBAAA;A9B64hBxB;A8Bx4hBoB;EACI,iBAAA;A9B04hBxB;A8Bz4hBwB;EACI,wBAAA;EACA,eAAA;A9B24hB5B;A8Bx4hBqB;EACG,cAAA;EACA,aAAA;EACA,mBAAA;A9B04hBxB;A8Br4hBoB;EACI,iBAAA;A9Bu4hBxB;A8Bt4hBwB;EACI,wBAAA;EACA,eAAA;A9Bw4hB5B;A8Br4hBqB;EACG,c3Bt0Bf;E2Bu0Be,aAAA;EACA,mBAAA;A9Bu4hBxB;A8Bl4hBoB;EACI,iBAAA;A9Bo4hBxB;A8Bn4hBwB;EACI,wBAAA;EACA,eAAA;A9Bq4hB5B;A8Bl4hBoB;EACI,c3Bp2Bf;E2Bq2Be,aAAA;EACA,mBAAA;A9Bo4hBxB;A8B/3hBoB;EACI,iBAAA;A9Bi4hBxB;A8Bh4hBwB;EACI,wBAAA;EACA,eAAA;A9Bk4hB5B;A8B/3hBoB;EACI,c3Br3Bd;E2Bs3Bc,aAAA;EACA,mBAAA;A9Bi4hBxB;A8Bv+hBY;EA0GO,e3BjjBJ;E2BkjBI,gB3B/4BE;E2Bg5BF,aAAA;EACA,mBAAA;A9Bg4hBnB;A8B/3hBgB;EACI,gBAAA;A9Bi4hBpB;;A8B13hBI;EACI,aAAA;EACA,mBAAA;A9B63hBR;A8B53hBQ;EACI,WAAA;EACA,YAAA;A9B83hBZ;A8B73hBY;EACI,mBAAA;A9B+3hBhB;;A8B13hBA;EACI,eAAA;EACA,gCAAA;A9B63hBJ;A8B13hBY;EACG,aAAA;EACA,sBAAA;EACA,mBAAA;EACC,aAAA;EACA,e3BnlBD;E2BolBC,gB3B/6BO;E2Bg7BP,c3BjrBH;E2BkrBG,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;A9B43hBhB;A8B33hBgB;EACI,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,W3B15BZ;AHuxjBR;A8B53hBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9B83hBxB;A8B33hBgB;EACI,mBAAA;EACA,W3Bn6BZ;AHgyjBR;A8B13hBgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9B43hBpB;A8B13hBgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mB3B18BV;E2B28BU,W3Bp7BZ;AHgzjBR;;A8Bp3hBA;EACI,mB3B18BK;E2B28BL,W3B97BI;E2B+7BJ,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A9Bu3hBJ;A8Bt3hBI;EACI,aAAA;EACA,mBAAA;A9Bw3hBR;A8Bv3hBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A9By3hBZ;;A8Br3hBA;EACI,aAAA;EACA,kBAAA;EACA,gB3Bn9BI;AH20jBR;A8Bv3hBI;EACI,mBAAA;A9By3hBR;A8Bv3hBI;EACI,kBAAA;A9By3hBR;A8Bx3hBQ;EACI,c3Bx1BD;E2By1BC,e3B7pBG;E2B8pBH,gB3B3/BO;E2B4/BP,kBAAA;A9B03hBZ;A8Bx3hBQ;EACI,c3BjwBC;E2BkwBD,e3BtqBG;E2BuqBH,gB3BpgCS;E2BqgCT,kBAAA;A9B03hBZ;A8Bv3hBI;EACI,kBAAA;A9By3hBR;;A8Bt3hBA;EACI,aAAA;EACA,mBAAA;A9By3hBJ;A8Bx3hBI;EACI,e3BjrBO;E2BkrBP,gB3B9gCW;E2B+gCX,c3B92BG;E2B+2BH,gBAAA;EACA,kBAAA;A9B03hBR;A8Bx3hBI;EACI,e3B1rBO;E2B2rBP,gB3BxhCa;E2ByhCb,cAAA;A9B03hBR;;A8Bv3hBA;EACI,mBAAA;EACA,uCAAA;A9B03hBJ;A8Bz3hBI;EACI,e3BlsBO;E2BmsBP,gB3B/hCe;E2BgiCf,c3B93BG;E2B+3BH,mBAAA;A9B23hBR;A8Bz3hBI;EACI,e3BzsBO;E2B0sBP,gB3BviCa;E2BwiCb,c3BvyBK;E2BwyBL,mBAAA;A9B23hBR;A8Bv3hBY;EACI,cAAA;EACA,iBAAA;A9By3hBhB;A8B53hBQ;EAKI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3BliCF;E2BmiCE,e3B1tBG;E2B2tBH,gB3BrjCW;E2BsjCX,oBAAA;EACA,mBAAA;A9B03hBZ;;A8Bt3hBA;EACI,yB3BziCK;AHk6jBT;;A8Bn3hBiB;EACG,c3BhjCX;E2BijCW,kBAAA;A9Bs3hBpB;A8Bp3hBiB;EACG,c3BtjCV;AH46jBV;;A8B72hBY;EACI,cAAA;EACA,iBAAA;A9Bg3hBhB;A8Bn3hBQ;EAKI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c3BrkCH;E2BskCG,e3B/vBG;E2BgwBH,gB3B1lCW;E2B2lCX,oBAAA;EACA,mBAAA;A9Bi3hBZ;;A8B72hBA;EACI,uBAAA;EACA,iBAAA;EACA,kBAAA;A9Bg3hBJ;A8B/2hBI;EACI,mBAAA;A9Bi3hBR;A8B/2hBI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;A9Bi3hBR;A8Bh3hBQ;EACI,kBAAA;EACA,mB3B1lCH;E2B2lCG,W3B9kCJ;AHg8jBR;;A8B72hBA;EACI,eAAA;A9Bg3hBJ;;A8B72hBI;EACI,mBAAA;A9Bg3hBR;A8B/2hBQ;EACI,aAAA;EACA,mBAAA;EACA,c3B73BC;E2B83BD,WAAA;EACA,YAAA;A9Bi3hBZ;A8Bh3hBY;EACI,iBAAA;A9Bk3hBhB;A8B72hBgB;EACI,iBAAA;EACA,mBAAA;EACA,c3Bz4BP;E2B04BO,e3BhpCH;E2BipCG,gB3B3oCC;E2B4oCD,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;A9B+2hBpB;A8B92hBoB;EACI,mB3BzoCd;E2B0oCc,W3BnnChB;AHm+jBR;A8B72hBgB;EACI,mB3B9oCV;E2B+oCU,W3BxnCZ;E2BynCY,oBAAA;A9B+2hBpB;;A8Bt2hBY;EACI,UAAA;EACA,YAAA;EACA,WAAA;A9By2hBhB;A8Bx2hBgB;EACI,6BAAA;EACA,WAAA;EACA,YAAA;A9B02hBpB;A8Bz2hBoB;EACI,c3BzgCb;AHo3jBX;A8Bz2hBoB;EACI,6BAAA;A9B22hBxB;A8B12hBwB;EACI,c3BvqClB;AHmhkBV;;A8Bn2hBI;EACI,kBAAA;A9Bs2hBR;A8Bp2hBI;EACI,WAAA;A9Bs2hBR;;A8Bn2hBA;EACI,aAAA;A9Bs2hBJ;;A8Bp2hBA;EACI,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;A9Bu2hBJ;;A8Br2hBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A9Bw2hBJ;A8Bv2hBI;EACI,kBAAA;EACA,kBAAA;A9By2hBR;A8Bx2hBQ;EACI,YAAA;EACA,yDAAA;EACA,8BAAA;EACA,YAAA;E1BnmCV,kB0BomC2B;EACjB,aAAA;A9B02hBZ;A8Bz2hBY;EACI,W3B1rCR;AHqikBR;AIpikBI;E0BirCI;IAWQ,YAAA;E9B42hBd;AACF;AIzikBI;E0BirCI;IAcQ,YAAA;E9B82hBd;AACF;AI9ikBI;E0BirCI;IAiBQ,WAAA;E9Bg3hBd;AACF;A8B92hBQ;E1BnnCN,mB0BqnC2B;E1BrpC3B,kB0BspC4B;E1BrpC5B,M0BqpCqC;E1BppCrC,Q0BopCuC;EAC7B,SAAA;A9Bi3hBZ;A8Bh3hBY;EACI,WAAA;EACA,YAAA;A9Bk3hBhB;;A8B72hBA;EACI,aAAA;EACA,eAAA;A9Bg3hBJ;;A+BhnkBA;EACI,kBAAA;A/BmnkBJ;A+BlnkBI;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;A/BonkBR;A+BnnkBQ;EACI,sCAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;A/BqnkBZ;A+BjnkBgB;EACI,qB5BGV;E4BFU,yB5BEV;AHinkBV;;A+B7mkBA;EACI,mB5BqJO;E4BpJP,W5BiBI;E4BhBJ,e5B0UW;E4BzUX,gB5BhBe;E4BiBf,kBAAA;E3B8DF,yB2B7DsB;A/BknkBxB;A+BjnkBI;EACI,mBAAA;EACA,W5BUA;AHymkBR;AIvmkBI;E2BrBJ;IAYQ,eAAA;E/BonkBN;AACF;;A+BlnkBA;EACI,iBAAA;A/BqnkBJ;;A+BnnkBA;EACI,mB5BvBM;E4BwBN,W5BDI;E4BEJ,e5BwTW;E4BvTX,gB5BlCe;E4BmCf,kBAAA;E3B4CF,yB2B3CsB;A/BwnkBxB;A+BvnkBI;EACI,4D5B7BQ;E4B8BR,W5BRA;AHiokBR;AI/nkBI;E2BHJ;IAYQ,eAAA;E/B0nkBN;AACF;;A+BvnkBI;EACI,aAAA;A/B0nkBR;;A+BvnkBA;EACI,gBAAA;A/B0nkBJ;;A+BxnkBA;EACI,c5B2GO;E4B1GP,e5BqSW;E4BpSX,gB5BxDe;E4ByDf,gBAAA;A/B2nkBJ;;A+BznkBA;EACI,SAAA;EACA,SAAA;A/B4nkBJ;;A+B1nkBA;EACI,cAAA;A/B6nkBJ;;A+B3nkBA;EACI,mBAAA;A/B8nkBJ;;A+B5nkBA;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;A/B+nkBJ;A+B5nkBY;EACI,c5BoFL;AH0ikBX;A+B1nkBI;EACI,aAAA;EACA,mBAAA;A/B4nkBR;A+B3nkBQ;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;A/B6nkBZ;A+B5nkBY;EACI,WAAA;EACA,YAAA;EACA,c5BmKH;AH29jBb;A+B3nkBQ;EACI,e5B4PG;E4B3PH,gB5BjGW;E4BkGX,c5BgED;E4B/DC,gBAAA;EACA,iBAAA;A/B6nkBZ;A+B3nkBQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yB5BnGF;E4BoGE,mBAAA;EACA,W5B9EJ;E4B+EI,eAAA;EACA,gB5BhHW;E4BiHX,gBAAA;A/B6nkBZ;;A+BznkBA;EACI,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,gB5BzFI;E4B0FJ,aAAA;EACA,mBAAA;EACA,mBAAA;A/B4nkBJ;AIttkBI;E2BmFJ;IASQ,sBAAA;E/B8nkBN;AACF;A+B7nkBI;EACI,aAAA;EACA,mBAAA;A/B+nkBR;A+B7nkBY;EACI,e5BuND;E4BtNC,gB5BrIG;E4BsIH,c5B2BL;E4B1BK,kBAAA;A/B+nkBhB;A+B7nkBY;EACI,eAAA;EACA,gB5B7IK;E4B8IL,c5BkHH;E4BjHG,gBAAA;A/B+nkBhB;A+B5nkBQ;EACI,UAAA;A/B8nkBZ;AI9ukBI;E2B+GI;IAGQ,WAAA;E/BgokBd;AACF;A+B/nkBY;EACI,mBAAA;A/BiokBhB;A+BhokBgB;EACI,kBAAA;EACA,aAAA;A/BkokBpB;A+B7nkBI;EACI,UAAA;A/B+nkBR;AI7vkBI;E2B6HA;IAGQ,WAAA;IACA,cAAA;E/BiokBV;AACF;A+BhokBQ;EACI,aAAA;EACA,mBAAA;A/BkokBZ;A+BjokBY;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,e5B8KD;E4B7KC,gB5B7KO;E4B8KP,c5B3JP;E4B4JO,kBAAA;A/BmokBhB;A+BjokBY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5BqKD;E4BpKC,gB5BtLO;E4BuLP,cAAA;A/BmokBhB;A+BjokBY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5B6JD;E4B5JC,gB5B9LO;E4B+LP,cAAA;A/BmokBhB;A+BjokBY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5BqJD;E4BpJC,gB5BtMO;E4BuMP,c5BtLN;AHyzkBV;A+BjokBY;EACI,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,e5B6ID;E4B5IC,gB5B9MO;E4B+MP,c5BlMN;AHq0kBV;A+BhokBgB;EACI,cAAA;EACA,iBAAA;A/BkokBpB;A+B3nkBQ;EACI,kCAAA;A/B6nkBZ;A+B3nkBQ;EACI,kCAAA;A/B6nkBZ;A+B1nkBI;EACI,UAAA;EACA,oBAAA;A/B4nkBR;A+B3nkBQ;EACI,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;A/B6nkBZ;A+B1nkBY;EACI,c5B3EL;AHuskBX;;A+BtnkBI;EACI,6BAAA;A/BynkBR;;A+BtnkBA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;A/BynkBJ;A+BxnkBI;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;EACA,c5BJK;E4BKL,2BAAA;EACA,mBAAA;A/B0nkBR;AI71kBI;E2BqNJ;IAiBQ,gBAAA;E/B2nkBN;AACF;;A+BznkBA;EACI,kBAAA;A/B4nkBJ;;A+B1nkBA;EACI,kBAAA;A/B6nkBJ;A+B5nkBI;EACI,kBAAA;A/B8nkBR;A+B7nkBQ;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,c5B1BC;AHypkBb;;A+B1nkBI;EACI,uBAAA;EACA,mBAAA;A/B6nkBR;A+B5nkBQ;EACI,eAAA;A/B8nkBZ;A+B7nkBY;EACI,uBAAA;EACA,UAAA;A/B+nkBhB;A+B7nkBoB;EACI,gBAAA;A/B+nkBxB;A+B3nkBY;EACI,WAAA;A/B6nkBhB;A+BxnkBwB;EACI,c5BpDf;AH8qkBb;A+BpnkBQ;EACI,UAAA;A/BsnkBZ;A+BpnkBQ;EACI,gBAAA;A/BsnkBZ;A+BpnkBgB;EACI,gBAAA;A/BsnkBpB;;AgCv6kBA;EACE,c7BoPW;AHsrkBb;;AgCx6kBA;EACE,iDAAA;AhC26kBF;;AgC54kBA;EACE,c7B4MW;E6B3MX,qB7BuGU;E6BtGV,mBAAA;AhC+4kBF;AgC94kBE;EACE,mBAAA;AhCg5kBJ;AgC54kBM;EACE,gB7B7Da;AH28kBrB;AgC14kBE;;EAEE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;AhC44kBJ;AgC14kBE;EACE,gB7BzEmB;E6B0EnB,eAAA;AhC44kBJ;AgC14kBE;EACE,eAAA;AhC44kBJ;AgC14kBE;EACE,c7ByEQ;E6BxER,sCAAA;AhC44kBJ;AgC14kBE;EACI,yB7B3EI;E6B4EJ,W7BrDE;AHi8kBR;AgC14kBE;EACI,yB7B7EM;E6B8EN,W7BzDE;AHq8kBR;AgC14kBE;EACI,yB7B7EC;E6B8ED,W7B7DE;AHy8kBR;AgC14kBE;EACI,yB7B/EI;E6BgFJ,W7BjEE;AH68kBR;AgC14kBE;EACI,yB7BjFG;E6BkFH,W7BrEE;AHi9kBR;AgC14kBE;EACI,yB7B3FI;E6B4FJ,W7BzEE;AHq9kBR;AgC14kBE;EACI,yB7BvFC;E6BwFD,W7B7EE;AHy9kBR;AgC14kBE;EACI,yB7BmCM;E6BlCN,c7B5FC;AHw+kBP;AgC14kBE;EA7HA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;AhC0glBF;AgCzglBE;EACE,2CAAA;EACA,mDAAA;EACA,W7B+BI;AH4+kBR;AgCzglBE;EACE,2CAAA;EACA,mDAAA;EACA,W7ByBI;AHk/kBR;AgCzglBE;EACE,2CAAA;EACA,6CAAA;EACA,W7BoBI;AHu/kBR;AgCj6kBE;EAhIA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,8CAAA;EACA,yDAAA;EACA,sDAAA;EACA,qDAAA;EACA,oDAAA;AhCoilBF;AgCnilBE;EACE,2CAAA;EACA,qDAAA;EACA,W7B+BI;AHsglBR;AgCnilBE;EACE,2CAAA;EACA,qDAAA;EACA,W7ByBI;AH4glBR;AgCnilBE;EACE,2CAAA;EACA,+CAAA;EACA,W7BoBI;AHihlBR;AgCx7kBE;EAnIA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;AhC8jlBF;AgC7jlBE;EACE,2CAAA;EACA,mDAAA;EACA,W7B+BI;AHgilBR;AgC7jlBE;EACE,2CAAA;EACA,mDAAA;EACA,W7ByBI;AHsilBR;AgC7jlBE;EACE,2CAAA;EACA,6CAAA;EACA,W7BoBI;AH2ilBR;AgC/8kBE;EAtIA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;AhCwllBF;AgCvllBE;EACE,2CAAA;EACA,mDAAA;EACA,W7B+BI;AH0jlBR;AgCvllBE;EACE,2CAAA;EACA,mDAAA;EACA,W7ByBI;AHgklBR;AgCvllBE;EACE,2CAAA;EACA,6CAAA;EACA,W7BoBI;AHqklBR;AgCt+kBE;EAzIA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,2CAAA;EACA,sDAAA;EACA,mDAAA;EACA,kDAAA;EACA,iDAAA;AhCknlBF;AgCjnlBE;EACE,2CAAA;EACA,kDAAA;EACA,W7B+BI;AHollBR;AgCjnlBE;EACE,2CAAA;EACA,kDAAA;EACA,W7ByBI;AH0llBR;AgCjnlBE;EACE,2CAAA;EACA,4CAAA;EACA,W7BoBI;AH+llBR;AgC7/kBE;EA5IA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,oDAAA;EACA,iDAAA;EACA,gDAAA;EACA,+CAAA;AhC4olBF;AgC3olBE;EACE,2CAAA;EACA,gDAAA;EACA,W7B+BI;AH8mlBR;AgC3olBE;EACE,2CAAA;EACA,gDAAA;EACA,W7ByBI;AHonlBR;AgC3olBE;EACE,2CAAA;EACA,0CAAA;EACA,W7BoBI;AHynlBR;AgCphlBE;EA/IA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,0CAAA;EACA,qDAAA;EACA,kDAAA;EACA,iDAAA;EACA,gDAAA;AhCsqlBF;AgCrqlBE;EACE,2CAAA;EACA,iDAAA;EACA,W7B+BI;AHwolBR;AgCrqlBE;EACE,2CAAA;EACA,iDAAA;EACA,W7ByBI;AH8olBR;AgCrqlBE;EACE,2CAAA;EACA,2CAAA;EACA,W7BoBI;AHmplBR;AgC3ilBE;EAlJA,sB7B0CM;E6BzCN,W7B0CM;E6BzCN,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,oDAAA;EACA,iDAAA;EACA,gDAAA;EACA,+CAAA;AhCgslBF;AgC/rlBE;EACE,2CAAA;EACA,gDAAA;EACA,W7B+BI;AHkqlBR;AgC/rlBE;EACE,2CAAA;EACA,gDAAA;EACA,W7ByBI;AHwqlBR;AgC/rlBE;EACE,2CAAA;EACA,0CAAA;EACA,W7BoBI;AH6qlBR;AgChklBM;;;;;;EAME,mCAAA;AhCkklBR;AgC9jlBM;;;;;;EAME,qCAAA;AhCgklBR;AgC5jlBM;;;;;;EAME,oCAAA;AhC8jlBR;AgC1jlBM;;;;;;EAME,oCAAA;AhC4jlBR;AgCxjlBM;;;;;;EAME,oCAAA;AhC0jlBR;AgCtjlBM;;;;;;EAME,mCAAA;AhCwjlBR;AgCpjlBE;EACE,kDAAA;EACA,c7BoDS;AHkglBb;AgCpjlBE;EACE,iDAAA;EACA,c7BgDS;AHsglBb;AgCpjlBE;EACE,6BAAA;AhCsjlBJ;AgCpjlBE;EACE,6BAAA;EACA,c7ByCS;AH6glBb;AgCpjlBE;EACE,6BAAA;EACA,c7BqCS;AHihlBb;AgCnjlBI;EAvMF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;AhC6vlBF;AgC9jlBI;EA1MF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,8CAAA;EACA,wDAAA;EACA,sDAAA;EACA,8BAAA;EACA,qDAAA;EACA,oDAAA;EACA,4BAAA;EACA,0CAAA;AhC2wlBF;AgCzklBI;EA7MF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;AhCyxlBF;AgCpllBI;EAhNF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;AhCuylBF;AgC/llBI;EAnNF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,2CAAA;EACA,qDAAA;EACA,mDAAA;EACA,8BAAA;EACA,kDAAA;EACA,iDAAA;EACA,4BAAA;EACA,0CAAA;AhCqzlBF;AgC1mlBI;EAtNF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,+CAAA;EACA,4BAAA;EACA,0CAAA;AhCm0lBF;AgCrnlBI;EAzNF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,0CAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,gDAAA;EACA,4BAAA;EACA,0CAAA;AhCi1lBF;AgCholBI;EA5NF,sB7BUM;E6BTN,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,+CAAA;EACA,4BAAA;EACA,0CAAA;AhC+1lBF;;AgCzolBA;EAnNE,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,WAAA;EACA,2CAAA;EACA,sBAAA;AhCg2lBF;;AgCtplBA;EAtNE,sBAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,sDAAA;EACA,8BAAA;EACA,qDAAA;EACA,6BAAA;EACA,oDAAA;EACA,4BAAA;EACA,WAAA;EACA,6CAAA;EACA,sBAAA;AhCg3lBF;;AgCnqlBA;EAzNE,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,WAAA;EACA,2CAAA;EACA,sBAAA;AhCg4lBF;;AgChrlBA;EA5NE,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,8BAAA;EACA,mDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EACA,WAAA;EACA,2CAAA;EACA,sBAAA;AhCg5lBF;;AgC7rlBA;EA/NE,sBAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,+CAAA;EACA,4BAAA;EACA,WAAA;EACA,wCAAA;EACA,sBAAA;AhCg6lBF;;AgC1slBA;EAlOE,sBAAA;EACA,8BAAA;EACA,2CAAA;EACA,qDAAA;EACA,mDAAA;EACA,8BAAA;EACA,kDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EACA,WAAA;EACA,0CAAA;EACA,sBAAA;AhCg7lBF;;AgCvtlBA;EArOE,sBAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,+CAAA;EACA,4BAAA;EACA,WAAA;EACA,wCAAA;EACA,sBAAA;AhCg8lBF;;AgCpulBA;EAxOE,sBAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EACA,WAAA;EACA,yCAAA;EACA,sBAAA;AhCg9lBF;;AgChvlBE;EACE,kCAAA;AhCmvlBJ;;AgC/ulBE;EACE,sBAAA;AhCkvlBJ;;AgC/ulBA;EACI,SAAA;AhCkvlBJ;AgC/ulBY;EACI,c7B1HL;E6B2HK,e7B2DD;AHsrlBf;AgC/ulBoB;EACI,SAAA;AhCivlBxB;AgC9ulBgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AhCgvlBpB;AgC/ulBoB;EACI,gBAAA;AhCivlBxB;AgC7ulBoB;EACI,8CAAA;AhC+ulBxB;AgC3ulBgB;EACI,c7BzSR;E6B0SQ,e7BqCL;E6BpCK,gB7BxTC;E6ByTD,mBAAA;AhC6ulBpB;AgC5ulBoB;EACI,iBAAA;EACA,cAAA;AhC8ulBxB;AgC5ulBoB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AhC8ulBxB;AgC5ulBoB;EACI,c7BzTd;AHuimBV;AgC3ulBgB;EACI,cAAA;AhC6ulBpB;AgC5ulBoB;EACI,c7B7TZ;AH2imBZ;AgC5ulBoB;EACI,cAAA;EACA,e7BeT;E6BdS,gB7B9UH;E6B+UG,c7B/EX;AH6zlBb;AgC5ulBoB;EACI,kBAAA;AhC8ulBxB;AgC3ulBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,e7BPL;E6BQK,yBAAA;EACA,gB7BpWC;E6BqWD,kBAAA;AhC6ulBpB;AgC1ulBY;EACI,gB7BxWO;E6ByWP,c7B9VJ;E6B+VI,e7BfD;E6BgBC,mBAAA;AhC4ulBhB;AgC1ulBY;EACI,c7B5UP;AHwjmBT;AgC1ulBY;EACI,gBAAA;AhC4ulBhB;AgC3ulBgB;EACI,e7BtBL;E6BuBK,c7BhNT;E6BiNS,gB7BrXG;E6BsXH,gBAAA;AhC6ulBpB;AgCxulBY;EACI,gB7B3XG;E6B4XH,c7BlXJ;E6BmXI,e7BrYC;E6BsYD,6BAAA;AhC0ulBhB;AgCvulBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCyulBZ;AgCxulBY;EACI,iBAAA;EACA,kBAAA;AhC0ulBhB;AgCrulBY;EACI,oBAAA;AhCuulBhB;AgChulBQ;EACI,kBAAA;AhCkulBZ;AgCjulBY;EACI,gBAAA;AhCmulBhB;AgC5tlBY;EACI,kBAAA;AhC8tlBhB;AgCxtlBY;EACI,kBAAA;AhC0tlBhB;;AgChtlBY;EACI,mBAAA;AhCmtlBhB;;AgC9slBA;EACI,iBAAA;AhCitlBJ;AI1mmBI;E4BwZJ;IAGQ,gBAAA;IACA,mBAAA;EhCmtlBN;AACF;;AgCjtlBA;EACI,0BAAA;AhCotlBJ;;AgCjtlBI;EACI,aAAA;AhCotlBR;;AgChtlBI;;;EAGI,wBAAA;AhCmtlBR;;AgChtlBA;EACI,e7BzHW;AH40lBf;;AgCjtlBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCotlBJ;AgCntlBI;EACI,c7BhdI;E6BidJ,gB7B7da;AHkrmBrB;AgCntlBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AhCqtlBR;;AgCjtlBI;EACI,sBAAA;EACA,kBAAA;AhCotlBR;;AgC/slBQ;EACI,YAAA;AhCktlBZ;AgC/slBI;EACI,WAAA;EACA,YAAA;AhCitlBR;;AgC7slBI;EACI,UAAA;AhCgtlBR;AgC9slBI;EACI,oBAAA;AhCgtlBR;AgC9slBI;EACI,aAAA;AhCgtlBR;AgC/slBQ;EACI,SAAA;EACA,UAAA;AhCitlBZ;AgC7slBQ;EACI,oBAAA;EACA,gBAAA;AhC+slBZ;;AgC1slBI;EACI,yBAAA;EACA,8BAAA;AhC6slBR;AgC3slBY;EACI,yBAAA;AhC6slBhB;AgCvslBQ;EACI,gBAAA;AhCyslBZ;AgCtslBY;EACI,c7B1hBJ;E6B2hBI,gB7BriBG;E6BsiBH,6BAAA;EACA,yBAAA;AhCwslBhB;AgCpslBY;EACI,sB7B7gBR;AHmtmBR;AgCpslBY;EACI,c7BriBJ;E6BsiBI,gB7BhjBG;AHsvmBnB;;AgChslBI;EACI,cAAA;AhCmslBR;AgClslBQ;EACI,kBAAA;AhCoslBZ;;AgC9rlBQ;EACI,WAAA;EACA,YAAA;AhCislBZ;;AgC7rlBA;EACI,yBAAA;AhCgslBJ;AgC/rlBI;EACI,+BAAA;EACA,8BAAA;EACA,aAAA;EACA,gB7B3kBW;E6B4kBX,e7BjPO;AHk7lBf;;AgC7rlBI;EACI,+BAAA;EACA,8BAAA;EACA,iBAAA;EACA,c7BtVK;AHshmBb;;AgC7rlBA;EACI,yBAAA;AhCgslBJ;AgC/rlBI;EACI,iBAAA;EACA,gB7B3lBW;E6B4lBX,e7BjQO;AHk8lBf;AgC/rlBI;EACI,c7BjWK;AHkimBb;;AgC9rlBA;EACI,cAAA;AhCislBJ;AgC/rlBQ;EACI,2BAAA;EACA,mBAAA;EACA,0BAAA;AhCislBZ;AgC9rlBI;EACI,kBAAA;AhCgslBR;;AI3wmBI;E4B8kBJ;IAEQ,cAAA;IACA,kBAAA;EhCgslBN;AACF;;AgC7rlBI;EACI,c7B/mBE;E6BgnBF,gB7BxnBW;E6BynBX,e7B7RO;AH69lBf;;AgC5rlBI;EACI,0BAAA;AhC+rlBR;AgC7rlBI;EACI,UAAA;AhC+rlBR;AgC7rlBI;EACI,SAAA;EACA,4BAAA;AhC+rlBR;AgC9rlBQ;EACI,aAAA;AhCgslBZ;AgC/rlBY;EACI,gBAAA;EACA,sBAAA;AhCislBhB;;AgC5rlBA;EACE,SAAA;AhC+rlBF;AgC5rlBU;EACI,c7BjfH;E6BkfG,e7B5TC;AH0/lBf;AgC5rlBkB;EACI,SAAA;AhC8rlBtB;AgC3rlBc;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AhC6rlBlB;AgC5rlBkB;EACI,gBAAA;AhC8rlBtB;AgC1rlBkB;EACI,8CAAA;AhC4rlBtB;AgCxrlBc;EACI,c7B3aJ;E6B4aI,e7BlVH;E6BmVG,gB7B/qBG;E6BgrBH,mBAAA;AhC0rlBlB;AgCzrlBkB;EACI,iBAAA;EACA,cAAA;AhC2rlBtB;AgCzrlBkB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AhC2rlBtB;AgCzrlBkB;EACI,c7BhrBZ;AH22mBV;AgC1rlBsB;EACI,c7BlrBhB;AH82mBV;AgCxrlBc;EACI,cAAA;AhC0rlBlB;AgCzrlBkB;EACI,c7BvrBV;AHk3mBZ;AgCzrlBkB;EACI,cAAA;EACA,e7B3WP;E6B4WO,gB7BxsBD;E6BysBC,c7BzcT;AHoomBb;AgCzrlBkB;EACI,kBAAA;AhC2rlBtB;AgCxrlBc;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,e7BjYH;E6BkYG,yBAAA;EACA,gB7B9tBG;E6B+tBH,kBAAA;AhC0rlBlB;AgCvrlBU;EACI,gB7BluBS;E6BmuBT,c7BxtBF;E6BytBE,e7BzYC;E6B0YD,mBAAA;AhCyrlBd;AgCvrlBU;EACI,c7BtsBL;AH+3mBT;AgCvrlBU;EACI,gBAAA;AhCyrlBd;AgCxrlBc;EACI,e7BhZH;E6BiZG,c7B1kBP;E6B2kBO,gB7B/uBK;E6BgvBL,gBAAA;AhC0rlBlB;AgCrrlBU;EACI,gB7BrvBK;E6BsvBL,c7B5uBF;E6B6uBE,e7B/vBG;E6BgwBH,6BAAA;AhCurlBd;AgCprlBM;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCsrlBV;AgCrrlBU;EACI,iBAAA;EACA,kBAAA;AhCurlBd;AgClrlBU;EACI,oBAAA;AhCorlBd;AgC7qlBM;EACI,kBAAA;AhC+qlBV;AgC9qlBU;EACI,gBAAA;AhCgrlBd;AgCzqlBU;EACI,kBAAA;AhC2qlBd;AgCrqlBU;EACI,kBAAA;AhCuqlBd;AgCnqlBE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AhCqqlBJ;;AgC9plBU;EAGI,aAAA;AhCiqlBd;AgChqlBc;EACI,0CAAA;EACV,sB7BzxBA;E6B0xBU,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AhCkqlBlB;AgCjqlBkB;EACI,c7BlyBf;E6BmyBe,WAAA;EACA,YAAA;AhCmqlBtB;AgCjqlBkB;EACG,c7B5kBR;E6B6kBQ,WAAA;EACC,YAAA;AhCmqlBtB;AgCjqlBkB;EACI,c7B7zBb;E6B8zBa,WAAA;EACA,YAAA;AhCmqlBtB;AgCjqlBkB;EACI,WAAA;EACA,YAAA;AhCmqlBtB;AgCjqlBkB;EACI,c7BrzBf;E6BszBe,WAAA;EACA,YAAA;AhCmqlBtB;AgChqlBkB;EACI,c7Bp1BV;E6Bq1BU,WAAA;EACA,YAAA;AhCkqlBtB;AgC5plBM;EACI,gBAAA;AhC8plBV;AgC5plBc;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AhC8plBlB;AgC7plBkB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AhC+plBtB;AgCzplBE;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AhC2plBN;AgC1plBM;EACI,UAAA;AhC4plBV;AgCxplBE;EACI,gBAAA;AhC0plBN;AgCxplBE;EACI,YAAA;AhC0plBN;AgCxplBE;EACI,YAAA;AhC0plBN;;AgCjplBwB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,c7BxqBf;AH4zmBb;AgCnplB4B;EACI,mB7B9wBpB;E6B+wBoB,c7B3qBnB;AHg0mBb;;AiC1knBA;EACI,sB9B0CI;E8BzCJ,c9BwQS;E8BvQT,qBAAA;EACA,kBAAA;EACA,gB9BKiB;AHwknBrB;AiC3knBQ;EACI,gBAAA;AjC6knBZ;AiC3knBQ;EACI,c9B+PC;E8B9PD,yB9BoQS;E8BnQT,gBAAA;AjC6knBZ;AiC5knBY;EACI,gBAAA;EACA,cAAA;EACA,eAAA;AjC8knBhB;AiC1knBI;EACI,c9BoPK;E8BnPL,yB9ByPa;E8BxPb,gBAAA;AjC4knBR;AiC1knBI;EACI,mCAAA;EACA,gBAAA;AjC4knBR;AiC1knBI;EACI,sBAAA;AjC4knBR;AiC1knBI;EACI,gBAAA;EACA,0B9BlBO;E8BmBP,e9B+TO;E8B9TP,cAAA;EACA,sB9BKA;E8BJA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,c9B+NK;AH62mBb;;AiCzknBA;EACI,qBAAA;EACA,oBAAA;EACA,c9B8NS;AH82mBb;;AiC1knBA;EACI,c9BsNS;E8BrNT,sB9BVI;E8BWJ,yBAAA;AjC6knBJ;;AiC1knBI;EACI,0BAAA;AjC6knBR;AiC3knBI;EACI,qCAAA;EACA,kB9BmRQ;E8BlRR,gBAAA;AjC6knBR;;AiC1knBA;EACI,mCAAA;EACA,kCAAA;AjC6knBJ;;AiC3knBA;EACI,+BAAA;EACA,gCAAA;AjC8knBJ;;AiC1knBQ;EACI,uCAAA;EACA,c9B1DF;AHuonBV;AiC5knBY;EACI,yB9B5DN;E8B6DM,W9BtCR;AHonnBR;AiC5knBY;EACI,sB9BzCR;E8B0CQ,c9BqLH;AHy5mBb;AiC7knBgB;EACI,yB9ByLC;E8BxLD,c9BkLP;AH65mBb;AiCzknBQ;EACI,wCAAA;EACA,c9B1EA;AHqpnBZ;AiC1knBY;EACI,yB9B5EJ;E8B6EI,W9BxDR;AHoonBR;AiC1knBY;EACI,sB9B3DR;E8B4DQ,c9BmKH;AHy6mBb;AiC3knBgB;EACI,yB9BuKC;E8BtKD,c9BgKP;AH66mBb;AiCvknBQ;EACI,wCAAA;EACA,c9B1FF;AHmqnBV;AiCxknBY;EACI,yB9B5FN;E8B6FM,W9B1ER;AHopnBR;AiCxknBY;EACI,sB9B7ER;E8B8EQ,c9BiJH;AHy7mBb;AiCzknBgB;EACI,yB9BqJC;E8BpJD,c9B8IP;AH67mBb;AiCrknBQ;EACI,uCAAA;EACA,c9BtGH;AH6qnBT;AiCtknBY;EACI,yB9BxGP;E8ByGO,W9B5FR;AHoqnBR;AiCtknBY;EACI,sB9B/FR;E8BgGQ,c9B+HH;AHy8mBb;AiCvknBgB;EACI,yB9BmIC;E8BlID,c9B4HP;AH68mBb;AiCnknBQ;EACI,wCAAA;EACA,c9B1HF;AH+rnBV;AiCpknBY;EACI,yB9B5HN;E8B6HM,W9B9GR;AHornBR;AiCpknBY;EACI,sB9BjHR;E8BkHQ,c9B6GH;AHy9mBb;AiCrknBgB;EACI,yB9BiHC;E8BhHD,c9B0GP;AH69mBb;AiCjknBQ;EACI,yCAAA;EACA,c9B9IL;AHitnBP;AiClknBY;EACI,yB9BhJT;E8BiJS,W9BhIR;AHosnBR;AiClknBY;EACI,sB9BnIR;E8BoIQ,c9B2FH;AHy+mBb;AiCnknBgB;EACI,yB9B+FC;E8B9FD,c9BwFP;AH6+mBb;;AiC7jnBQ;EACI,yB9BvKF;E8BwKE,W9BjJJ;AHitnBR;AiC/jnBY;EACI,sB9BnJR;E8BoJQ,c9B3KN;AH4unBV;AiC/jnBY;EACI,sB9BvJR;E8BwJQ,c9BuEH;AH0/mBb;AiChknBgB;EACI,yB9B2EC;E8B1ED,c9BoEP;AH8/mBb;AiC5jnBQ;EACI,yB9BvLA;E8BwLA,W9BnKJ;AHiunBR;AiC7jnBY;EACI,sB9BrKR;E8BsKQ,c9B3LJ;AH0vnBZ;AiC7jnBY;EACI,sB9BzKR;E8B0KQ,c9BqDH;AH0gnBb;AiC9jnBgB;EACI,yB9ByDC;E8BxDD,c9BkDP;AH8gnBb;AiC1jnBQ;EACI,yB9BvMF;E8BwME,W9BrLJ;AHivnBR;AiC3jnBY;EACI,sB9BvLR;E8BwLQ,c9B3MN;AHwwnBV;AiC3jnBY;EACI,sB9B3LR;E8B4LQ,c9BmCH;AH0hnBb;AiC5jnBgB;EACI,yB9BuCC;E8BtCD,c9BgCP;AH8hnBb;AiCxjnBQ;EACI,yB9BnNH;E8BoNG,W9BvMJ;AHiwnBR;AiCzjnBY;EACI,sB9BzMR;E8B0MQ,c9BvNP;AHkxnBT;AiCzjnBY;EACI,sB9B7MR;E8B8MQ,c9BiBH;AH0inBb;AiC1jnBgB;EACI,yB9BqBC;E8BpBD,c9BcP;AH8inBb;AiCtjnBQ;EACI,yB9BvOF;E8BwOE,W9BzNJ;AHixnBR;AiCvjnBY;EACI,sB9B3NR;E8B4NQ,c9B3ON;AHoynBV;AiCvjnBY;EACI,sB9B/NR;E8BgOQ,c9BDH;AH0jnBb;AiCxjnBgB;EACI,yB9BGC;E8BFD,c9BJP;AH8jnBb;AiCpjnBQ;EACI,yB9B3PL;E8B4PK,W9B3OJ;AHiynBR;AiCrjnBY;EACI,sB9B7OR;E8B8OQ,c9B/PT;AHsznBP;AiCrjnBY;EACI,sB9BjPR;E8BkPQ,c9BnBH;AH0knBb;AiCtjnBgB;EACI,yB9BfC;E8BgBD,c9BtBP;AH8knBb;;AiChjnBQ;EACI,yBAAA;AjCmjnBZ;AiCjjnBQ;EACI,sB9BjQJ;E8BkQI,c9BzRF;E8B0RE,qBAAA;AjCmjnBZ;AiCljnBY;EACI,sB9BrQR;E8BsQQ,c9B7RN;E8B8RM,yBAAA;AjCojnBhB;AiCljnBY;EACI,mCAAA;AjCojnBhB;AiC/inBQ;EACI,yBAAA;AjCijnBZ;AiC/inBQ;EACI,sB9BnRJ;E8BoRI,c9BzSA;E8B0SA,qBAAA;AjCijnBZ;AiChjnBY;EACI,sB9BvRR;E8BwRQ,c9B7SJ;E8B8SI,yBAAA;AjCkjnBhB;AiChjnBY;EACI,mCAAA;AjCkjnBhB;AiC7inBQ;EACI,yBAAA;AjC+inBZ;AiC7inBQ;EACI,sB9BrSJ;E8BsSI,c9BzTF;E8B0TE,qBAAA;AjC+inBZ;AiC9inBY;EACI,sB9BzSR;E8B0SQ,c9B7TN;E8B8TM,yBAAA;AjCgjnBhB;AiC9inBY;EACI,mCAAA;AjCgjnBhB;AiC3inBQ;EACI,yBAAA;AjC6inBZ;AiC3inBQ;EACI,sB9BvTJ;E8BwTI,c9BrUH;E8BsUG,qBAAA;AjC6inBZ;AiC5inBY;EACI,sB9B3TR;E8B4TQ,c9BzUP;E8B0UO,yBAAA;AjC8inBhB;AiC5inBY;EACI,mCAAA;AjC8inBhB;AiCzinBQ;EACI,yBAAA;AjC2inBZ;AiCzinBQ;EACI,sB9BzUJ;E8B0UI,c9BzVF;E8B0VE,qBAAA;AjC2inBZ;AiC1inBY;EACI,sB9B7UR;E8B8UQ,c9B7VN;E8B8VM,yBAAA;AjC4inBhB;AiC1inBY;EACI,mCAAA;AjC4inBhB;AiCvinBQ;EACI,yBAAA;AjCyinBZ;AiCvinBQ;EACI,sB9B3VJ;E8B4VI,c9B7WL;E8B8WK,qBAAA;AjCyinBZ;AiCxinBY;EACI,sB9B/VR;E8BgWQ,c9BjXT;E8BkXS,yBAAA;AjC0inBhB;AiCxinBY;EACI,mCAAA;AjC0inBhB;;AiCninBQ;EACI,aAAA;AjCsinBZ;;AiChinBQ;EACI,4BAAA;AjCminBZ;AiClinBY;EACI,kBAAA;EACA,4BAAA;AjCoinBhB;;AiC5hnBY;EACI,YAAA;EACA,0B9B1ZD;E8B2ZC,yB9B5JK;AH2rnBrB;AiC7hnBY;EACI,gBAAA;EACZ,0B9B/ZW;E8BgaC,sB9BtYR;AHq6nBR;;AiCvhnBY;EACI,uCAAA;EACA,wDAAA;AjC0hnBhB;AiCzhnBgB;EACI,uCAAA;EACA,W9BnZZ;AH86nBR;AiCxhnBY;EACI,uCAAA;EACA,sBAAA;EACA,wDAAA;AjC0hnBhB;AiCthnBY;EACI,wCAAA;EACA,yDAAA;AjCwhnBhB;AiCvhnBgB;EACI,wCAAA;EACA,W9BlaZ;AH27nBR;AiCthnBY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjCwhnBhB;AiCphnBY;EACI,wCAAA;EACA,yDAAA;AjCshnBhB;AiCrhnBgB;EACI,wCAAA;EACA,W9BjbZ;AHw8nBR;AiCphnBY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjCshnBhB;AiClhnBY;EACI,yCAAA;EACA,0DAAA;AjCohnBhB;AiCnhnBgB;EACI,yCAAA;EACA,W9BhcZ;AHq9nBR;AiClhnBY;EACI,yCAAA;EACA,sBAAA;EACA,0DAAA;AjCohnBhB;AiChhnBY;EACI,wCAAA;EACA,yDAAA;AjCkhnBhB;AiCjhnBgB;EACI,wCAAA;EACA,W9B/cZ;AHk+nBR;AiChhnBY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;AjCkhnBhB;AiC9gnBY;EACI,uCAAA;EACA,wDAAA;AjCghnBhB;AiC/gnBgB;EACI,uCAAA;EACA,W9B9dZ;AH++nBR;AiC9gnBY;EACI,uCAAA;EACA,sBAAA;EACA,wDAAA;AjCghnBhB;;AkC9hoBE;EACE,8CAAA;EACA,sCAAA;AlCiioBJ;;AkC5hoBI;EACE,8CAAA;EACA,sCAAA;AlC+hoBN;;AkCzhoBI;EACE,c/B8PO;AH8xnBb;AkCzhoBI;EACE,c/BDI;AH4hoBV;;AkCvhoBA;EACE,c/BqPW;E+BpPX,YAAA;AlC0hoBF;;AkCvhoBE;EACE,c/BgPS;E+B/OT,gBAAA;EACA,qCAAA;AlC0hoBJ;;AkCthoBE;EACE,c/ByOS;E+BxOT,gBAAA;EACA,qCAAA;AlCyhoBJ;;AkCrhoBE;EACE,c/BkOS;E+BjOT,YAAA;AlCwhoBJ;;AkCphoBE;EACE,c/B4NS;E+B3NT,YAAA;AlCuhoBJ;;AkCnhoBE;EACE,c/BsNS;E+BrNT,gBAAA;EACA,qCAAA;AlCshoBJ;;AkClhoBE;EACE,WAAA;EACA,aAAA;AlCqhoBJ;;AkClhoBA;EACE,kBAAA;EACA,kB/B2Qc;AH0wnBhB;AkCnhoBE;EACC,W/B9BK;AHmjoBR;AkCjhoBI;EACD,W/BnCK;AHsjoBR;AkCjhoBE;EACC,W/BtCK;E+BuCL,YAAA;AlCmhoBH;AkChhoBM;EACE,W/B3CA;AH6joBR;AkChhoBG;EACC,W/B9CI;AHgkoBR;;AkC7goBA;EACE,YAAA;AlCghoBF;;AkC7goBE;EACE,iBAAA;AlCghoBJ;;AmCnnoBA;EACI,mBAAA;EACA,sBhCyCI;EgCxCJ,gCAAA;EACA,kBAAA;EACA,kBhC8Ue;EgC7Uf,SAAA;EACA,8DhCoVY;EgCnVZ,cAAA;AnCsnoBJ;AmCrnoBI;EACI,aAAA;AnCunoBR;AmCrnoBI;EACI,ehC2VO;EgC1VP,gBhCFW;EgCGX,0BAAA;AnCunoBR;AmCrnoBI;EACI,qBhCoJI;EgCnJJ,kBAAA;EACA,uBAAA;EACA,aAAA;AnCunoBR;AmCtnoBQ;EACI,mBAAA;AnCwnoBZ;AmCtnoBQ;EACI,sBAAA;EACA,mBAAA;EACA,gBAAA;AnCwnoBZ;AmCrnoBI;EACI,qBhCsII;EgCrIJ,uBAAA;EACA,0BAAA;AnCunoBR;;AmCnnoBE;EACI,qBAAA;AnCsnoBN;;AmClnoBE;EACA,kBhCqSc;EgCpSd,SAAA;EACA,sBhCHM;EgCIN,kBAAA;EACA,wBAAA;EACA,WAAA;AnCqnoBF;AmCpnoBE;EACE,qBAAA;EACA,wCAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AnCsnoBJ;AmCrnoBI;EACE,oCAAA;AnCunoBN;AmCrnoBI;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBhCtDa;EgCuDb,0BAAA;AnCunoBN;AmCtnoBM;EACE,mBAAA;EACA,uBAAA;AnCwnoBR;AmCpnoBE;EACE,wCAAA;EACA,qCAAA;EACA,oBAAA;EACA,ehC1Ea;AHgsoBjB;AmCpnoBE;EACE,eAAA;EACA,chCwLS;AH87nBb;AmCpnoBE;EACE,kBAAA;AnCsnoBJ;AmCnnoBE;EACE,mBAAA;AnCqnoBJ;AmCnnoBE;EACE,WAAA;EACA,YAAA;AnCqnoBJ;AmCnnoBE;EACE,kBAAA;EACA,gBAAA;EACA,+BAAA;AnCqnoBJ;AmCpnoBI;EACE,oDAAA;AnCsnoBN;AmCpnoBI;EACE,sDAAA;AnCsnoBN;AmCpnoBI;EACE,SAAA;AnCsnoBN;AmCpnoBI;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AnCsnoBN;AmCnnoBE;EACE,yBhCnGM;EgCoGN,WhC7EI;AHksoBR;AmCpnoBI;EACE,qDAAA;EACA,WhChFE;EgCiFF,oDAAA;AnCsnoBN;AmCrnoBM;EACE,sBhCnFA;AH0soBR;AmCpnoBI;EACE,WhCvFE;AH6soBR;AmCpnoBI;EACE,qDAAA;EACA,WhC3FE;EgC4FF,sDAAA;AnCsnoBN;AmCnnoBE;EACE,yBhCrHQ;EgCsHR,WhCjGI;AHstoBR;AmCpnoBI;EACE,qDAAA;EACA,WhCpGE;EgCqGF,oDAAA;AnCsnoBN;AmCrnoBM;EACE,sBhCvGA;AH8toBR;AmCpnoBI;EACE,WhC3GE;AHiuoBR;AmCpnoBI;EACE,qDAAA;EACA,WhC/GE;EgCgHF,sDAAA;AnCsnoBN;AmCnnoBE;EACE,yBhCnIM;EgCoIN,WhCrHI;AH0uoBR;AmCpnoBI;EACE,qDAAA;EACA,WhCxHE;EgCyHF,oDAAA;AnCsnoBN;AmCrnoBM;EACE,sBhC3HA;AHkvoBR;AmCpnoBI;EACE,WhC/HE;AHqvoBR;AmCpnoBI;EACE,qDAAA;EACA,WhCnIE;EgCoIF,sDAAA;AnCsnoBN;AmCnnoBE;EACE,yBhCzJG;EgC0JH,WhCzII;AH8voBR;AmCpnoBI;EACE,qDAAA;EACA,WhC5IE;EgC6IF,oDAAA;AnCsnoBN;AmCrnoBM;EACE,sBhC/IA;AHswoBR;AmCpnoBI;EACE,WhCnJE;AHywoBR;AmCpnoBI;EACE,qDAAA;EACA,WhCvJE;EgCwJF,sDAAA;AnCsnoBN;AmCnnoBE;EACE,yBhC/KM;EgCgLN,WhC7JI;AHkxoBR;AmCpnoBI;EACE,qDAAA;EACA,WhChKE;EgCiKF,oDAAA;AnCsnoBN;AmCrnoBM;EACE,sBhCnKA;AH0xoBR;AmCpnoBI;EACE,WhCvKE;AH6xoBR;AmCpnoBI;EACE,qDAAA;EACA,WhC3KE;EgC4KF,sDAAA;AnCsnoBN;AmCnnoBE;EACE,yBhC7LK;EgC8LL,WhCjLI;AHsyoBR;AmCpnoBI;EACE,qDAAA;EACA,WhCpLE;EgCqLF,oDAAA;AnCsnoBN;AmCrnoBM;EACE,sBhCvLA;AH8yoBR;AmCpnoBI;EACE,WhC3LE;AHizoBR;AmCpnoBI;EACE,qDAAA;EACA,WhC/LE;EgCgMF,sDAAA;AnCsnoBN;AmCnnoBE;EACE,yBhCtMI;EgCuMJ,chC0BS;AH2loBb;AmCpnoBI;EACE,gDAAA;EACA,chCuBO;EgCtBP,yBhC9EM;AHosoBZ;AmCpnoBI;EACE,chCmBO;AHmmoBb;AmCpnoBI;EACE,gDAAA;EACA,chCeO;EgCdP,2BhCtFM;AH4soBZ;AmCnnoBE;EACE,yBhChOG;EgCiOH,WhCtNI;AH20oBR;AmCpnoBI;EACE,qDAAA;EACA,WhCzNE;EgC0NF,oDAAA;AnCsnoBN;AmCrnoBM;EACE,sBhC5NA;AHm1oBR;AmCpnoBI;EACE,WhChOE;AHs1oBR;AmCpnoBI;EACE,qDAAA;EACA,WhCpOE;EgCqOF,sDAAA;AnCsnoBN;AmCnnoBE;EACE,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;AnCqnoBJ;AmCnnoBE;EACE,aAAA;AnCqnoBJ;AmClnoBI;EACE,cAAA;AnConoBN;AmClnoBI;EACE,aAAA;AnConoBN;AmCjnoBE;EACE,eAAA;EACA,MAAA;EACA,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,aAAA;EACA,SAAA;AnCmnoBJ;;AmChnoBA;EACI,ehCiEW;EgChEX,chCvIO;AH0voBX;;AmCjnoBA;EACE,gBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBhCjRM;EgCkRN,0CAAA;AnConoBF;;AmClnoBA;EACE,2CAAA;EACA,qCAAA;AnCqnoBF;;AmCnnoBA;EACE,0CAAA;EACA,oCAAA;AnCsnoBF;;AmCpnoBA;EACE,yCAAA;EACA,mCAAA;AnCunoBF;;AmCrnoBA;EACE,yBhChDS;EgCiDT,WhChSM;EgCiSN,yBAAA;AnCwnoBF;AmCvnoBE;EAGE,oCAAA;EACA,sBAAA;EACA,oCAAA;AnCunoBJ;;AmCpnoBA;EACE,mBAAA;EAiBA,mGAAA;EAQA,mHAAA;EACA,WhCrUM;EgCsUN,6BAAA;AnCkmoBF;AmCjmoBE;EAGE,WhC1UI;EgC2UJ,6BAAA;AnCimoBJ;;AmC9loBA;EACE,yBhC/FQ;EgCgGR,WhChVM;EgCiVN,yBAAA;AnCimoBF;AmChmoBE;EAGE,oCAAA;EACA,sBAAA;EACA,oCAAA;AnCgmoBJ;;AmC7loBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AnCgmoBJ;;AmC9loBA;EACI,gCAAA;AnCimoBJ;;AmC9loBA;EAEM;IACI,8BAAA;EnCgmoBR;AACF;AmC7loBA;EAEM;IACI,8BAAA;EnC8loBR;AACF;AoCt/oBI;EACE,yBjCiBI;AHu+oBV;AoCt/oBI;EAEE,yBjCaI;AH0+oBV;AoCr/oBI;EAEE,2BjCSI;AH6+oBV;AoCp/oBI;EAEE,0BjCKI;AHg/oBV;AoCn/oBI;EAEE,4BjCCI;AHm/oBV;AoCrgpBI;EACE,yBjCmBM;AHo/oBZ;AoCrgpBI;EAEE,yBjCeM;AHu/oBZ;AoCpgpBI;EAEE,2BjCWM;AH0/oBZ;AoCngpBI;EAEE,0BjCOM;AH6/oBZ;AoClgpBI;EAEE,4BjCGM;AHggpBZ;AoCphpBI;EACE,yBjCyBI;AH6/oBV;AoCphpBI;EAEE,yBjCqBI;AHggpBV;AoCnhpBI;EAEE,2BjCiBI;AHmgpBV;AoClhpBI;EAEE,0BjCaI;AHsgpBV;AoCjhpBI;EAEE,4BjCSI;AHygpBV;AoCnipBI;EACE,yBjCuBC;AH8gpBP;AoCnipBI;EAEE,yBjCmBC;AHihpBP;AoClipBI;EAEE,2BjCeC;AHohpBP;AoCjipBI;EAEE,0BjCWC;AHuhpBP;AoChipBI;EAEE,4BjCOC;AH0hpBP;AoCljpBI;EACE,yBjCqBI;AH+hpBV;AoCljpBI;EAEE,yBjCiBI;AHkipBV;AoCjjpBI;EAEE,2BjCaI;AHqipBV;AoChjpBI;EAEE,0BjCSI;AHwipBV;AoC/ipBI;EAEE,4BjCKI;AH2ipBV;AoCjkpBI;EACE,yBjC2BG;AHwipBT;AoCjkpBI;EAEE,yBjCuBG;AH2ipBT;AoChkpBI;EAEE,2BjCmBG;AH8ipBT;AoC/jpBI;EAEE,0BjCeG;AHijpBT;AoC9jpBI;EAEE,4BjCWG;AHojpBT;AoChlpBI;EACE,yBjC6BC;AHqjpBP;AoChlpBI;EAEE,yBjCyBC;AHwjpBP;AoC/kpBI;EAEE,2BjCqBC;AH2jpBP;AoC9kpBI;EAEE,0BjCiBC;AH8jpBP;AoC7kpBI;EAEE,4BjCaC;AHikpBP;AoCvjpBI;EACE,WAAA;ApCyjpBN;AoClmpBI;EACE,yBjCsCE;AH8jpBR;AoClmpBI;EAEE,yBjCkCE;AHikpBR;AoCjmpBI;EAEE,2BjC8BE;AHokpBR;AoChmpBI;EAEE,0BjC0BE;AHukpBR;AoC/lpBI;EAEE,4BjCsBE;AH0kpBR;AoCnkpBI;EACE,cjCyNO;AH42oBb;;AqCtnpBA;EACI,yBAAA;ArCynpBJ;AqCxnpBI;EACE,oBAAA;ArC0npBN;;AqCvnpBE;EACE,clCmQS;EkClQT,kBlCyUY;EkCxUZ,gBlCEmB;AHwnpBvB;AqCznpBI;EACE,uCAAA;EACA,clCQI;AHmnpBV;;AqCxnpBE;EACE,clC0PS;AHi4oBb;AqC1npBI;EACE,clCwPO;EkCvPP,YAAA;ArC4npBN;;AqCznpBE;;EAEE,clCJM;AHgopBV;;AqC1npBE;EACE,clC+OS;EkC9OT,YAAA;ArC6npBJ;;AqC3npBE;EACE,4BAAA;ArC8npBJ;;AqC5npBE;EACE,clCwOS;AHu5oBb;;AqC3npBM;;EAEE,WlCGA;AH2npBR;AqC3npBI;;EAEE,WlCFE;AH+npBR;;AqC1npBE;;EAEE,WlCPI;EkCQJ,yBlC/BM;AH4ppBV;;AqC1npBA;EACE,SAAA;ArC6npBF;AqC5npBE;EACE,0BAAA;ArC8npBJ;AqC7npBI;EACE,oBAAA;ArC+npBN;AqC3npBI;EACI,uCAAA;EACA,clC7CE;AH0qpBV;AqC5npBQ;EACE,iCAAA;ArC8npBV;AqC3npBI;EACI,uBAAA;EACA,clCpDE;AHirpBV;;AqCxnpBE;EACE,yCAAA;ArC2npBJ;AqC1npBI;EACE,uCAAA;EACA,qCAAA;EACA,clC9DI;AH0rpBV;;AqCvnpBE;EACE,gBAAA;ArC0npBJ;AqCxnpBE;EACE,uCAAA;ArC0npBJ;AqCxnpBE;EACE,6BAAA;EACA,mCAAA;EACA,clC5EM;AHsspBV;;AqCvnpBA;EACE,SAAA;ArC0npBF;AqCznpBE;EACE,clCyKS;EkCxKT,SAAA;ArC2npBJ;AqCznpBE;EACE,kBAAA;ArC2npBJ;AqC1npBI;EACE,yBlCnEE;EkCoEF,clC6JO;EkC5JP,SAAA;ArC4npBN;AqC1npBI;EAEE,SAAA;ArC2npBN;AqCznpBI;EACI,yBlC5EA;EkC6EA,clCoJK;AHu+oBb;;AqCvnpBA;EACE,SAAA;ArC0npBF;AqCznpBE;EACE,clCkJS;EkCjJT,SAAA;EACA,kBAAA;ArC2npBJ;AqCxnpBI;EACE,yBlC/GI;EkCgHJ,WlCzFE;EkC0FF,SAAA;ArC0npBN;AqCxnpBI;EAEE,SAAA;EACA,yBlCtHI;EkCuHJ,WlChGE;AHytpBR;;AqCrnpBA;EACE,SAAA;ArCwnpBF;AqCtnpBI;EACE,yBAAA;EACA,mCAAA;EACA,6BAAA;EACA,clClII;AH0vpBV;;AqCpnpBA;EACE,oBAAA;ArCunpBF;AqCtnpBE;EACE,yBAAA;ArCwnpBJ;AqCvnpBI;EACE,oBAAA;ArCynpBN;AqCvnpBI;EACE,6BAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBlC3Je;AHoxpBrB;AqCxnpBM;EACE,iCAAA;EACA,clCpJE;EkCqJF,6BAAA;ArC0npBR;AqCxnpBM;EACE,6BAAA;EACA,6BAAA;EACA,clC1JE;AHoxpBV;;AqCrnpBA;EACE,SAAA;ArCwnpBF;AqCvnpBE;EACE,yBAAA;ArCynpBJ;AqCxnpBI;EACE,oBAAA;ArC0npBN;AqCxnpBI;EACE,6BAAA;EACA,clCxKI;EkCyKJ,yBAAA;EACA,iBAAA;ArC0npBN;AqCznpBM;EACE,mBlC5KE;EkC6KF,WlCtJA;EkCuJA,yBAAA;ArC2npBR;AqCznpBM;EACE,yBAAA;EACA,6BAAA;EACC,clCnLC;AH8ypBV;;AqCtnpBA;EACE,SAAA;ArCynpBF;AqCxnpBE;EACE,yBAAA;ArC0npBJ;AqCznpBI;EACE,oBAAA;ArC2npBN;AqCznpBI;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,clCsDO;EkCrDP,yBlCjLE;AH4ypBR;AqC1npBM;EACE,eAAA;ArC4npBR;AqC1npBM;EACE,yBlC3ME;EkC4MF,WlCrLA;EkCsLA,kBAAA;ArC4npBR;AqC3npBQ;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,yBlCtNA;AHm1pBV;AqC3npBQ;EACE,WlClMF;AH+zpBR;AqC1npBM;EACE,clC7NE;AHy1pBV;;AqCvnpBA;EACE,SAAA;ArC0npBF;AqCznpBE;EACE,SAAA;EACA,yBAAA;ArC2npBJ;AqC1npBI;EACE,oBAAA;ArC4npBN;AqC1npBI;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,wBAAA;ArC4npBN;AqC3npBM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBlCtPE;EkCuPF,WlChOA;EkCiOA,uBAAA;EACA,gBlCnQa;AHg4pBrB;AqC3npBM;EACE,mBlC5PE;EkC6PF,yBAAA;EACA,WlCvOA;AHo2pBR;AqC5npBQ;EACE,mBlChQA;EkCiQA,yBAAA;EACA,WlC3OF;AHy2pBR;AqC5npBQ;EACE,gBlC9OF;EkC+OE,clCtQA;AHo4pBV;AqC3npBM;EACE,yBAAA;EACA,clC3QE;EkC4QA,uBAAA;ArC6npBV;;AqCxnpBA;EACE,mBAAA;EACA,gBAAA;EACA,yBlC/PM;EkCgQN,kBAAA;EACA,sBAAA;ArC2npBF;AqC1npBE;EACE,yBAAA;ArC4npBJ;AqC3npBI;EACE,oBAAA;ArC6npBN;AqC1npBE;EACE,kBAAA;EACA,qBAAA;ArC4npBJ;AqC3npBI;EACE,oCAAA;EACA,sBAAA;EACA,8DlCmCO;EkClCP,+BAAA;ArC6npBN;;AqCvnpBQ;EACA,uBAAA;EACA,clC5SE;AHs6pBV;;AqCpnpBA;EACE,mBAAA;ArCunpBF;AqCtnpBE;EACE,yBAAA;ArCwnpBJ;AqCvnpBI;EACE,oBAAA;ArCynpBN;AqCvnpBI;EACE,SAAA;ArCynpBN;AqCxnpBM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBlC3SA;EkC4SA,clC3EK;EkC4EL,qBAAA;ArC0npBR;AqCxnpBM;EACE,SAAA;EACA,uBAAA;EACA,clCvUE;AHi8pBV;AqCznpBQ;EACE,clCzUA;AHo8pBV;AqCxnpBM;EACE,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,clChVE;AH08pBV;AqCznpBQ;EACE,uCAAA;EACA,clCnVA;AH88pBV;AqCznpBQ;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBlC7VA;EkC8VA,mBAAA;ArC2npBV;;AqCrnpBA;EACE,mBAAA;ArCwnpBF;AqCvnpBE;EACE,kBAAA;EACA,yBAAA;ArCynpBJ;AqCxnpBI;EACE,oBAAA;ArC0npBN;AqCxnpBI;EACE,kBAAA;EACA,SAAA;EACA,kBAAA;ArC0npBN;AqCznpBM;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,yBlCnWA;EkCoWA,kBAAA;ArC2npBR;AqCznpBM;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBlChXA;EkCiXA,kBAAA;EACA,yBAAA;ArC2npBR;AqCznpBM;EACE,YAAA;ArC2npBR;AqCznpBM;EACE,YAAA;ArC2npBR;AqCznpBM;EACE,YAAA;ArC2npBR;AqCznpBM;EACE,SAAA;EACA,uBAAA;EACA,clCvZE;AHkhqBV;AqCznpBM;EACE,6BAAA;EACA,SAAA;EACA,clC5ZE;AHuhqBV;AqC1npBQ;EACE,yBlC9ZA;AH0hqBV;AqC1npBQ;EACE,qBlCjaA;EkCkaA,clClaA;AH8hqBV;;AqCrnpBE;EACE,SAAA;ArCwnpBJ;AqCvnpBI;EACE,yBAAA;ArCynpBN;AqCxnpBM;EACE,oBAAA;ArC0npBR;AqCvnpBI;EACE,SAAA;ArCynpBN;AqCxnpBM;EACE,SAAA;EACA,uBAAA;EACA,clCtbE;AHgjqBV;AqCxnpBM;EACE,6BAAA;EACA,SAAA;EACA,clC3bE;EkC4bF,kBAAA;EACA,gBAAA;ArC0npBR;AqCznpBQ;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,yBlCxcA;EkCycA,yBAAA;ArC2npBV;AqCznpBQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBlCldA;AH6kqBV;;AqCrnpBA;EACE,yBAAA;EACA,yBlC1dQ;EkC2dR,WlCpcM;EkCqcN,aAAA;EACE,kBAAA;ArCwnpBJ;;AqCrnpBE;EACE,yBAAA;ArCwnpBJ;AqCvnpBI;EACE,oBAAA;ArCynpBN;AqCvnpBI;EACE,mBlCteI;AH+lqBV;;AqCrnpBA;EACE,SAAA;EACA,sBlCrdM;EkCsdN,kBAAA;EACA,clC9eQ;EkC+eR,eAAA;ArCwnpBF;AqCvnpBE;EACE,SAAA;EACA,yBAAA;ArCynpBJ;AqCxnpBI;EACE,oBAAA;ArC0npBN;AqCxnpBI;EACE,clCvfI;EkCwfJ,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBlCrgBe;EkCwgBf,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArC0npBN;AqCznpBM;EACE,SAAA;EACA,yBlCpgBE;EkCqgBF,WlC9eA;EkC+eA,SAAA;EACA,wDAAA;ArC2npBR;AqCznpBM;EAEE,SAAA;ArC0npBR;;AqCpnpBE;EACE,wBAAA;EACA,mBAAA;EACA,clCzRS;EkC0RT,gBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArCunpBJ;AqCtnpBI;EAEE,uCAAA;EACA,clC/hBI;AHspqBV;;AqChnpBM;EACE,uCAAA;EACA,clCxiBE;AH2pqBV;;AqC9mpBA;EAEI;IACE,sBAAA;ErCgnpBJ;AACF;AqC5mpBA;EACI,gBAAA;ArC8mpBJ;AqC5mpBQ;EACI,mBAAA;ArC8mpBZ;AqC3mpBI;EACI,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;ArC6mpBR;AqC5mpBQ;EACE,qBlC5aC;AH0hqBX;AqC1mpBQ;EACI,clC9aD;EkC+aC,wBAAA;ArC4mpBZ;AqC3mpBY;EACI,yBAAA;EACA,4BlC5kBN;EkC6kBM,6BAAA;EjCtgBd,yBiCugBkC;ArC+mpBpC;;AqCzmpBI;EACI,sBlC9jBA;EkC+jBA,SAAA;ArC4mpBR;AqC3mpBQ;EACI,yBlCxlBF;EkCylBE,qBlCzlBF;EkC0lBE,WlCnkBJ;AHgrqBR;;AqCvmpBQ;EACI,yBAAA;EACA,clClmBF;AH4sqBV;AqCrmpBY;EACI,uBAAA;ArCumpBhB;AqCtmpBgB;EACI,yBlC1mBV;EC2GR,gBiCggBmC;ArCwmpBrC;AqCtmpBgB;EACI,yBlC9mBV;EkC+mBU,6BAAA;EjCpgBlB,gBiCqgBmC;ArCwmpBrC;AqCjmpBY;EACI,uBAAA;ArCmmpBhB;AqClmpBgB;EACI,4BlC1nBV;EkC2nBU,uBAAA;EjChhBlB,gBiCihBmC;ArCompBrC;AqC/lpBI;EACI,sBlC3mBA;EkC4mBA,SAAA;ArCimpBR;AqC7lpBoB;EACI,yBlCxoBd;EkCyoBc,qBlCzoBd;EkC0oBc,WlCnnBhB;ECoFN,mBiCgiBuC;ArC+lpBzC;AqCxlpBgB;EACI,yBlCnpBV;EkCopBU,qBlCppBV;EkCqpBU,WlC9nBZ;ECoFN,gBiC2iBmC;ArC0lpBrC;;AqCnlpBI;EACI,clC9pBE;AHovqBV;;AqChlpBY;EACI,elClVD;AHq6pBf;;AqC7kpBI;EACI,gBAAA;EACA,mBAAA;ArCglpBR;AqC/kpBQ;EACI,clC7qBA;ECkFT,iBiC4lBuC;EAC9B,elC9VG;EkC+VH,gBlC1rBO;EkC2rBP,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mDAAA;ArCilpBZ;AqC/kpBY;EACI,yBAAA;ArCilpBhB;AqC/kpBY;EACI,yBAAA;ArCilpBhB;AqC/kpBY;EACI,SAAA;EACA,gCAAA;EACA,mBlClsBN;EkCmsBM,WlC5qBR;AH6vqBR;;AqC3kpBI;EACI,gBAAA;EjCvnBL,gBiCwnB6B;ArC8kpBhC;AqC7kpBQ;EACI,WlCrrBJ;EkCsrBI,elC9tBK;EkC+tBL,gBlCvtBO;EkCwtBP,SAAA;EACA,mBlC1jBD;EkC2jBC,kBAAA;EjC9nBT,iBiC+nBuC;EjCxmBxC,kBiCymB2B;EjC7oB3B,yBiC8oB8B;ArCilpBhC;AqChlpBY;EACI,mBlCvtBN;EkCwtBM,WlCjsBR;AHmxqBR;;AIjxqBI;EiCqsBA;IACI,gBAAA;IACA,kBAAA;IACA,sBlC1sBA;IC6DL,ciC8oBmC;IjCvnBpC,kBiCwnBuB;ErCglpBvB;AACF;AsCx0qBA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,WnCuCM;EmCtCN,UAAA;AtC00qBF;AsCz0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;AtC20qBJ;AsCz0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCWK;EmCVL,enCiVW;EmChVX,cAAA;EACA,sBAAA;EACA,4BAAA;AtC20qBJ;AsC10qBI;EAEE,kBAAA;EACA,WAAA;AtC20qBN;AsCz0qBI;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBnCJG;AH+0qBT;AsCz0qBI;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBnCZG;AHu1qBT;;AsCv0qBA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WnCRM;EmCSN,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AtC00qBF;AsCz0qBE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AtC20qBJ;AsCz0qBE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AtC20qBJ;AsCz0qBE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EACA,WnClCI;EmCmCJ,yCAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AtC20qBJ;;AsCx0qBA;EACE,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,UAAA;AtC20qBF;AsC10qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;AtC40qBJ;AsC10qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCxEK;EmCyEL,enC8PW;EmC7PX,cAAA;EACA,sBAAA;EACA,4BAAA;AtC40qBJ;AsC30qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBnCrFG;AHk6qBT;AsC30qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBnC9FG;AH26qBT;;AsCz0qBA;EACE,WnCtFM;EmCuFN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;AtC40qBF;;AsCz0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtC40qBJ;;AsCx0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtC20qBJ;;AsCv0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;AtC00qBJ;;AsCt0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCy0qBJ;;AsCr0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCw0qBJ;;AsCp0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCu0qBJ;;AsCn0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCs0qBJ;;AsCl0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtCq0qBJ;;AsCj0qBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCo0qBJ;;AsCj0qBA;EACE,WnC5NM;EmC6NN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;AtCo0qBF;;AsCj0qBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCo0qBJ;;AsCh0qBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCm0qBJ;;AsC/zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;AtCk0qBJ;;AsC9zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCi0qBJ;;AsC7zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtCg0qBJ;;AsC5zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC+zqBJ;;AsC3zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC8zqBJ;;AsC1zqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC6zqBJ;;AsCzzqBE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;AtC4zqBJ;;AsCzzqBA;EACE,WnClWM;EmCmWN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,UAAA;EACA,enCrCa;AHi2qBf;AsC3zqBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;AtC6zqBJ;;AsC1zqBA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;AtC6zqBF;AsC5zqBE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,WnChYI;EmCiYJ,iCAAA;EACA,yCAAA;EACA,0BAAA;EACA,kBAAA;AtC8zqBJ;;AsC3zqBA;EACE,uBAAA;EACA,wBAAA;AtC8zqBF;AsC7zqBE;EACE,sBAAA;EACA,sBAAA;EACA,yBAAA;AtC+zqBJ;AsC9zqBI;EACE,wBAAA;EACA,wBAAA;EACA,yBAAA;AtCg0qBN;;AsC5zqBA;EACE,qBAAA;EACA,wBAAA;AtC+zqBF;AsC9zqBE;EACE,sBAAA;EACA,oBAAA;EACA,wBAAA;AtCg0qBJ;AsC/zqBI;EACE,yBAAA;EACA,sBAAA;EACA,yBAAA;AtCi0qBN;;AsC7zqBA;EACE,uBAAA;EACA,sBAAA;AtCg0qBF;AsC/zqBE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AtCi0qBJ;AsCh0qBI;EACE,yBAAA;EACA,wBAAA;EACA,uBAAA;AtCk0qBN;;AsC9zqBA;EACE,qBAAA;EACA,sBAAA;AtCi0qBF;AsCh0qBE;EACE,wBAAA;EACA,oBAAA;EACA,yBAAA;AtCk0qBJ;AsCj0qBI;EACE,wBAAA;EACA,sBAAA;EACA,uBAAA;AtCm0qBN;;AsC/zqBA;EACE,wBAAA;EACA,yBAAA;AtCk0qBF;AsCj0qBE;EACE,qCAAA;EACA,sCAAA;EACA,qBAAA;EACA,qBAAA;AtCm0qBJ;AsCj0qBE;EACE,qCAAA;EACA,sCAAA;EACA,oBAAA;EACA,sBAAA;AtCm0qBJ;AsCj0qBE;EACE,qBAAA;EACA,uBAAA;EACA,yBAAA;AtCm0qBJ;;AsCh0qBA;EACE,wBAAA;EACA,uBAAA;AtCm0qBF;AsCl0qBE;EACE,qCAAA;EACA,oCAAA;EACA,qBAAA;EACA,mBAAA;AtCo0qBJ;AsCl0qBE;EACE,qCAAA;EACA,oCAAA;EACA,oBAAA;EACA,wBAAA;AtCo0qBJ;AsCl0qBE;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;AtCo0qBJ;;AsCj0qBA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WnC7eM;AHizrBR;AsCn0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCq0qBJ;AsCn0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC3gBM;EmC4gBN,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,UAAA;AtCq0qBJ;AsCp0qBI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnCrhBI;EmCshBJ,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;AtCs0qBN;AsCp0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBnCtiBI;AH42rBV;AsCn0qBE;EACE,WnC3hBI;EmC4hBJ,enChOW;EmCiOX,yBAAA;EACA,uBAAA;AtCq0qBJ;;AsCl0qBA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WnCriBM;AH02rBR;AsCp0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCs0qBJ;AsCp0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCjkBK;EmCkkBL,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,UAAA;AtCs0qBJ;AsCr0qBI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnC3kBG;EmC4kBH,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;AtCu0qBN;AsCr0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBnC5lBG;AHm6rBT;AsCp0qBE;EACE,WnCnlBI;EmColBJ,enCxRW;EmCyRX,yBAAA;EACA,uBAAA;AtCs0qBJ;;AsCn0qBA;EACE,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WnC7lBM;AHm6rBR;AsCr0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCu0qBJ;AsCr0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC/nBM;EmCgoBN,eAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,UAAA;AtCu0qBJ;AsCt0qBI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnCzoBI;EmC0oBJ,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;AtCw0qBN;AsCt0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBnC1pBI;AHk+rBV;AsCr0qBE;EACE,WnC3oBI;EmC4oBJ,enChVW;EmCiVX,yBAAA;EACA,uBAAA;AtCu0qBJ;;AsCp0qBA;EACE,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,WnCrpBM;AH49rBR;AsCt0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;AtCw0qBJ;AsCt0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCrrBG;EmCsrBH,eAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,UAAA;AtCw0qBJ;AsCv0qBI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBnC/rBC;EmCgsBD,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;AtCy0qBN;AsCv0qBI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBnChtBC;AHyhsBP;AsCt0qBE;EACE,WnCnsBI;EmCosBJ,enCxYW;EmCyYX,yBAAA;EACA,uBAAA;AtCw0qBJ;;AsCr0qBA;EACE,kBAAA;EACA,wBAAA;EACA,WnC5sBM;AHohsBR;AsCv0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,uCAAA;EACA,qCAAA;EACA,wCAAA;AtCy0qBJ;AsCv0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC/uBM;EmCgvBN,eAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;AtCy0qBJ;AsCv0qBE;EACE,WnCnuBI;EmCouBJ,enCxaW;EmCyaX,yBAAA;EACA,uBAAA;AtCy0qBJ;;AsCt0qBA;EACE,kBAAA;EACA,wBAAA;EACA,WnC5uBM;EmC6uBN,WAAA;AtCy0qBF;AsCx0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;AtC00qBJ;AsCx0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnC1wBK;EmC2wBL,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AtC00qBJ;AsCx0qBE;EACE,WnCpwBI;EmCqwBJ,enCzcW;EmC0cX,yBAAA;EACA,uBAAA;AtC00qBJ;;AsCv0qBA;EACE,kBAAA;EACA,sBAAA;EACA,WnC7wBM;EmC8wBN,WAAA;AtC00qBF;AsCz0qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;AtC20qBJ;AsCz0qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCnzBQ;EmCozBR,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AtC20qBJ;AsCz0qBE;EACE,WnCryBI;EmCsyBJ,enC1eW;EmC2eX,yBAAA;EACA,uBAAA;AtC20qBJ;;AsCx0qBA;EACE,kBAAA;EACA,uBAAA;EACA,WnC9yBM;AHynsBR;AsC10qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,sBAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;AtC40qBJ;AsC10qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCl1BM;EmCm1BN,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AtC40qBJ;AsC10qBE;EACE,WnCt0BI;EmCu0BJ,enC3gBW;EmC4gBX,yBAAA;EACA,uBAAA;AtC40qBJ;;AsCz0qBA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WnCh1BM;AH4psBR;AsC30qBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;AtC60qBJ;AsC30qBE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBnCx3BM;EmCy3BN,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;AtC60qBJ;AsC30qBE;EACE,WnCx2BI;EmCy2BJ,enC7iBW;EmC8iBX,yBAAA;EACA,uBAAA;AtC60qBJ;;AsCx0qBI;EACE,kBAAA;EACA,WAAA;AtC20qBN;;AsCv0qBA;EACE,WnCv3BM;EmCw3BN,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,enC7jBa;AHu4rBf;AsCz0qBE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;AtC20qBJ;;AsCx0qBA;EACE,gBAAA;AtC20qBF;;AsCx0qBE;EACE,WnC94BI;EmC+4BJ,yBnCt6BM;EmCu6BN,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtC20qBJ;AsC10qBI;EACE,kBAAA;AtC40qBN;AsC30qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtC60qBR;AsC30qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtC60qBR;AsC30qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iDAAA;EACA,iCnCp8BE;EmCq8BF,gCnCr8BE;EmCs8BF,+BnCt8BE;EmCu8BF,sCAAA;EACA,yBAAA;AtC60qBR;AsC30qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnC/8BE;EmCg9BF,oCAAA;EACA,+BnCj9BE;EmCk9BF,kCnCl9BE;EmCm9BF,uBAAA;AtC60qBR;;AsCv0qBE;EACE,WnCn8BI;EmCo8BJ,yBnCz9BQ;EmC09BR,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtC00qBJ;AsCz0qBI;EACE,kBAAA;AtC20qBN;AsC10qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtC40qBR;AsC10qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtC40qBR;AsC10qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCt/BI;EmCu/BJ,gCnCv/BI;EmCw/BJ,+BnCx/BI;EmCy/BJ,sCAAA;EACA,yBAAA;AtC40qBR;AsC10qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCjgCI;EmCkgCJ,oCAAA;EACA,+BnCngCI;EmCogCJ,kCnCpgCI;EmCqgCJ,uBAAA;AtC40qBR;;AsCt0qBE;EACE,WnCv/BI;EmCw/BJ,yBnCvgCM;EmCwgCN,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCy0qBJ;AsCx0qBI;EACE,kBAAA;AtC00qBN;AsCz0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtC20qBR;AsCz0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtC20qBR;AsCz0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCpiCE;EmCqiCF,gCnCriCE;EmCsiCF,+BnCtiCE;EmCuiCF,sCAAA;EACA,yBAAA;AtC20qBR;AsCz0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,8BAAA;EACA,uBAAA;EACA,uBAAA;AtC20qBR;;AsCr0qBE;EACE,WnC5iCI;EmC6iCJ,yBnC1jCK;EmC2jCL,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;AtCw0qBJ;AsCv0qBI;EACE,kBAAA;AtCy0qBN;AsCx0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;AtC00qBR;AsCx0qBM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;AtC00qBR;AsCx0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCnCvlCC;EmCwlCD,oCAAA;EACA,+BnCzlCC;EmC0lCD,kCnC1lCC;EmC2lCD,uBAAA;AtC00qBR;AsCx0qBM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,gCAAA;EACA,yBAAA;EACA,uBAAA;AtC00qBR;;AsCn0qBI;EACE,WAAA;EACA,YAAA;AtCs0qBN;;AsCj0qBE;EACE,aAAA;AtCo0qBJ;;AsCh0qBE;EACE,WAAA;EACA,YAAA;AtCm0qBJ;;AsC/zqBE;EACE,WAAA;EACA,YAAA;AtCk0qBJ;;AsC9zqBE;EACE,WAAA;EACA,YAAA;AtCi0qBJ;;AsC7zqBE;EACE,WAAA;EACA,YAAA;AtCg0qBJ;;AsC5zqBE;EACE,cnC/9BS;EmCg+BT,mBnCx+BS;AHuysBb;;AsC3zqBE;EACE,mBnCv/BU;EmCw/BV,cnCj/BU;AH+ysBd;;AsC3zqBA;EACE;IACE,8BAAA;EtC8zqBF;AACF;AsC3zqBE;EACE,wBAAA;AtC6zqBJ;AsC1zqBE;EACE,yBAAA;AtC4zqBJ;AsCzzqBE;EACE,yBAAA;AtC2zqBJ;AsCxzqBE;EACE,wBAAA;AtC0zqBJ;AsCvzqBE;EACE,yBAAA;AtCyzqBJ;AsCtzqBE;EACE,wBAAA;AtCwzqBJ;AsCrzqBE;EACE,wBAAA;AtCuzqBJ;AsCpzqBE;EACE,yBAAA;AtCszqBJ;AsCnzqBE;EACE,wBAAA;AtCqzqBJ;AsClzqBE;EACE,yBAAA;AtCozqBJ;AsCjzqBE;EACE,yBAAA;AtCmzqBJ;;AuC5htBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,eAAA;AvC+htBR;AuC9htBQ;EnCqHN,kBmCpH2B;EACjB,UAAA;EACA,mBAAA;EACA,cAAA;AvCgitBZ;AIjgtBI;EmCnCI;IAMQ,UAAA;EvCkitBd;AACF;AuCjitBY;EACI,yBAAA;EnC4Gd,mBmC3G+B;EACjB,cAAA;EACA,aAAA;EACA,kBAAA;AvCmitBhB;;AuC5htBI;EACI,yBAAA;EACA,8DAAA;EACA,kBAAA;AvC+htBR;AuC7htBI;EACI,gBpCxBW;AHujtBnB;AIthtBI;EmCVA;IAGQ,epCiUG;EHgusBb;AACF;AuC9htBE;EACC,YAAA;AvCgitBH;AuC7htBI;EACI,qBpCuHI;EoCtHJ,gCAAA;EACA,8BAAA;AvC+htBR;AuC9htBQ;;EAII,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,cpCmJC;EoClJD,UAAA;EACA,epCoSG;EoCnSH,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBpCvDO;EoCwDP,6BAAA;EnC2DV,mBmC1D2B;AvCgitB7B;AuC/htBY;;EACI,6BAAA;EACA,WpC7BR;AH+jtBR;AuC7htBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,cpCpEF;AHmmtBV;AuC9htBY;EACI,iBAAA;AvCgitBhB;AuC9htBY;EACI,mBpCzEN;EoC0EM,WpCnDR;AHmltBR;AuC/htBgB;EACI,+BAAA;AvCiitBpB;AuC7htBQ;EACI,mBpC/EA;AH8mtBZ;AuC9htBY;EnCqCV,sCAAA;EmCnCc,yBAAA;AvCkitBhB;AuC7htBI;EACI,SAAA;EACA,iBAAA;EACA,iBAAA;AvC+htBR;AuC5htBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AvC8htBR;AuC5htBI;EACI,iBAAA;AvC8htBR;AuC5htBI;EACI,iBAAA;AvC8htBR;AuC5htBI;EACI,oCAAA;AvC8htBR;AuC5htBI;EACI,+CAAA;AvC8htBR;;AuC3htBA;EACI,sBAAA;AvC8htBJ;;AuC5htBA;EACI,4BAAA;AvC+htBJ;;AuC3htBI;EACI,0BAAA;AvC8htBR;AuC3htBQ;EACI,qBAAA;EACA,UAAA;EACA,oBAAA;AvC6htBZ;AuC3htBQ;EACI,mBAAA;EACA,UAAA;AvC6htBZ;AuCzhtBQ;EACI,0BAAA;EACA,UAAA;EACA,sDAAA;AvC2htBZ;AuCzhtBQ;EACI,wBAAA;EACA,UAAA;AvC2htBZ;AuCvhtBQ;EACI,0BAAA;EACA,UAAA;EACA,oBAAA;AvCyhtBZ;AuCvhtBQ;EACI,wBAAA;EACA,UAAA;AvCyhtBZ;AuCrhtBQ;EACI,kCAAA;EACA,UAAA;AvCuhtBZ;AuCrhtBQ;EACI,oBAAA;AvCuhtBZ;AuCrhtBQ;EACI,gCAAA;EACA,UAAA;AvCuhtBZ;AuCphtBI;EAGI,mBAAA;AvCshtBR;AuCrhtBQ;EAEI,4BAAA;EACA,2CAAA;EACA,UAAA;AvCuhtBZ;AuCrhtBQ;EACI,4BAAA;EACA,wCAAA;EACA,UAAA;AvCuhtBZ;AuCphtBI;EACI,mBAAA;AvCshtBR;AuCrhtBQ;EAEI,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;AvCuhtBZ;AuCrhtBQ;EACI,wBAAA;EACA,UAAA;AvCuhtBZ;AuCphtBI;EACI,mBAAA;AvCshtBR;AuCrhtBQ;EAEI,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;AvCuhtBZ;AuCrhtBQ;EACI,wBAAA;EACA,UAAA;AvCuhtBZ;AuCnhtBQ;EACI,mBAAA;EACA,UAAA;EACA,oBAAA;AvCqhtBZ;AuCnhtBQ;EACI,mBAAA;EACA,UAAA;AvCqhtBZ;AuClhtBI;EACI,mBAAA;AvCohtBR;AuCnhtBQ;EAEI,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;AvCqhtBZ;AuCnhtBQ;EACI,wBAAA;EACA,UAAA;AvCqhtBZ;AuClhtBI;EACI,mBAAA;AvCohtBR;AuCnhtBQ;EAEI,4BAAA;EACA,0CAAA;EACA,wBAAA;EACA,UAAA;EACA,6BAAA;AvCqhtBZ;AuCnhtBQ;EACI,uCAAA;EACA,UAAA;AvCqhtBZ;AuClhtBI;EACI,mBAAA;AvCohtBR;AuCnhtBQ;EAEI,4BAAA;EACA,4DAAA;EACA,wBAAA;EACA,UAAA;EACA,oBAAA;AvCqhtBZ;AuCnhtBQ;EACI,uDAAA;EACA,UAAA;AvCqhtBZ;;AuCjhtBA;EACI,uBAAA;AvCohtBJ;;AuClhtBA;EACI,wBAAA;AvCqhtBJ;;AuCnhtBA;EACI,wBAAA;AvCshtBJ;;AuCnhtBI;EACI,YAAA;AvCshtBR;AuCrhtBQ;EACI,cpC7CC;EoC8CD,epC6CG;EoC5CH,gBpChTS;AHu0tBrB;AuCrhtBQ;EACI,WAAA;EACA,YAAA;AvCuhtBZ;AuCthtBY;EACI,UAAA;EACA,WAAA;AvCwhtBhB;AuClhtBoB;EACI,QAAA;EACA,UAAA;EACA,WAAA;AvCohtBxB;AuC7gtBI;EACI,cAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AvC+gtBR;AuC9gtBQ;EACI,UAAA;EACA,6CAAA;EACC,QAAA;EACD,WAAA;EACA,YAAA;AvCghtBZ;AuC9gtBQ;EACI,mBAAA;AvCghtBZ;AuC7gtBG;EACK,mBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AvC+gtBR;AuC9gtBQ;EACI,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EAGA,yBAAA;EACA,+BAAA;EACA,uCAAA;EACA,mCAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,kBAAA;AvCghtBZ;;AuC3gtBI;EnC3RD,kBmC4R6B;EnC3R7B,iBmC2RyC;AvC+gtB5C;AuC9gtBQ;EACI,eAAA;AvCghtBZ;;AuC1gtBQ;EnCpSL,SmCqSiC;EnCpSjC,UmCoSoC;EAC3B,gBpClWJ;EoCmWI,yBAAA;EACA,kBAAA;EACA,cpCpOD;EoCqOC,gBpCxYS;EoCyYT,epC7CG;EoC8CH,6DAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EAIA,oBAAA;AvC8gtBZ;AuC7gtBY;EACI,yBAAA;EACA,mBpC9YN;EoC+YM,WpCxXR;EoC4XQ,oBAAA;EAGA,0BAAA;AvC+gtBhB;;AwCz7tBA;EACE,oBAAA;AxC47tBF;AwC37tBE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;AxC67tBJ;;AwC17tBA;EACE,oBAAA;AxC67tBF;;AwC37tBA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AxC87tBF;;AwC57tBA;EACE,iBAAA;EACA,aAAA;EACA,WrCuBM;AHw6tBR;;AwC77tBA;EACE,gBAAA;AxCg8tBF;;ACz6tBA,qBAAA;AwC/CA;EACC,oCtCeqB;EsCdrB,etCmWc;EsClWd,ctCuQY;EsCtQZ,gBAAA;EACA,yBtCwQS;EsCvQT,gBAAA;EACA,kBAAA;AzC49tBD;;AyC19tBA;EACC,oCtCMqB;AHu9tBtB;;AyC39tBA;EACE,mBtCOQ;EsCNR,WtC6BM;EsC5BN,iBAAA;AzC89tBF;;AyC59tBA;EACC,eAAA;EACA,YAAA;EACA,uBAAA;AzC+9tBD;;AyC79tBA;EACC,aAAA;AzCg+tBD;;AyC99tBA;ErCkEE,yBqCjEmB;AzCm+tBrB;AyCl+tBC;EACC,2BAAA;AzCo+tBF;;AyCj+tBA;EACC,mBAAA;AzCo+tBD;AyCn+tBC;EACC,gBAAA;AzCq+tBF;;AyCl+tBA;EACC,gBtC1BkB;AH+/tBnB;;AyCn+tBA;EACG,ctCkOW;EsCjOX,oCtC1BmB;EsC2BrB,gBtC/BkB;EsCgChB,gBAAA;AzCs+tBH;;AyCp+tBA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;AzCu+tBF;;AyCr+tBA;EACE,gBAAA;AzCw+tBF;AyCv+tBC;EACE,gBAAA;EACA,kBAAA;AzCy+tBH;AyCx+tBG;EACE,uBAAA;AzC0+tBL;AyCv+tBC;EACE,mBAAA;EACA,kBAAA;AzCy+tBH;AyCx+tBG;EACE,wBAAA;AzC0+tBL;AyCv+tBC;EACE,gBAAA;EACA,eAAA;AzCy+tBH;AyCx+tBG;EACE,sBAAA;EACA,qBAAA;AzC0+tBL;AyCz+tBK;;;EAGE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AzC2+tBP;AyCx+tBK;EACE,etCiRQ;EsChRR,QAAA;AzC0+tBP;AyCj+tBe;EACI,gBAAA;AzCm+tBnB;;A0CtkuBA;EACI,oCAAA;A1CykuBJ;;A0CvkuBA;EACI,oCAAA;A1C0kuBJ;;A0CxkuBA;EACI,oCAAA;A1C2kuBJ;;A0CzkuBA;EACI,oCAAA;EACA,sBAAA;A1C4kuBJ;;A0C1kuBA;EACI,oCAAA;EACA,sBAAA;A1C6kuBJ;;A0C3kuBA;EACI,oCAAA;EACA,sBAAA;A1C8kuBJ;;A0C5kuBA;EACI,oCAAA;A1C+kuBJ;;A0C7kuBA;EACI,oCAAA;A1CgluBJ;;A0C9kuBA;EACI,oCAAA;A1CiluBJ;;A0C/kuBA;EACI,mBvCkIQ;AHg9tBZ;;A0ChluBA;EACI,oCAAA;A1CmluBJ;;A0CjluBA;EACI,iCAAA;A1ColuBJ;;A0ClluBA;EACI,oCAAA;A1CqluBJ;;A0CnluBA;EACI,oCAAA;A1CsluBJ;;A0CpluBA;EACI,oCAAA;A1CuluBJ;;A0CrluBA;EACI,oCAAA;A1CwluBJ;;A0CtluBA;EACI,oCAAA;A1CyluBJ;;A0CvluBA;EACI,oCAAA;A1C0luBJ;;A0CxluBA;EACI,oCAAA;A1C2luBJ;;A0CzluBA;EACI,mBvC0NW;AHk4tBf;;A0C1luBA;EACI,oCAAA;A1C6luBJ;A0C5luBI;EACI,kDAAA;A1C8luBR;A0C5luBI;EACI,mDAAA;A1C8luBR;A0C5luBI;EACI,kDAAA;A1C8luBR;A0C5luBI;EACI,mDAAA;A1C8luBR;A0C5luBI;EACI,oCAAA;A1C8luBR;;A0C3luBA;EACI,oCAAA;A1C8luBJ;A0C7luBI;EACI,mDAAA;A1C+luBR;A0C7luBI;EACI,oDAAA;A1C+luBR;A0C7luBI;EACI,mDAAA;A1C+luBR;A0C7luBI;EACI,oDAAA;A1C+luBR;A0C7luBI;EACI,oCAAA;A1C+luBR;;A0C5luBA;EACI,oCAAA;A1C+luBJ;A0C9luBI;EACI,oDAAA;A1CgmuBR;A0C9luBI;EACI,qDAAA;A1CgmuBR;A0C9luBI;EACI,oDAAA;A1CgmuBR;A0C9luBI;EACI,qDAAA;A1CgmuBR;A0C9luBI;EACI,oCAAA;A1CgmuBR;;A0C7luBA;EACI,oCAAA;A1CgmuBJ;A0C/luBI;EACI,mDAAA;A1CimuBR;A0C/luBI;EACI,oDAAA;A1CimuBR;A0C/luBI;EACI,mDAAA;A1CimuBR;A0C/luBI;EACI,oDAAA;A1CimuBR;A0C/luBI;EACI,oCAAA;A1CimuBR;;A0C9luBA;EACI,oCAAA;A1CimuBJ;A0ChmuBI;EACI,mDAAA;A1CkmuBR;A0ChmuBI;EACI,oDAAA;A1CkmuBR;A0ChmuBI;EACI,mDAAA;A1CkmuBR;A0ChmuBI;EACI,oDAAA;A1CkmuBR;A0ChmuBI;EACI,oCAAA;A1CkmuBR;;A0C/luBA;EACI,oCAAA;A1CkmuBJ;A0CjmuBI;EACI,kDAAA;A1CmmuBR;A0CjmuBI;EACI,mDAAA;A1CmmuBR;A0CjmuBI;EACI,kDAAA;A1CmmuBR;A0CjmuBI;EACI,mDAAA;A1CmmuBR;A0CjmuBI;EACI,oCAAA;A1CmmuBR;;A0ChmuBA;EACI,oCAAA;A1CmmuBJ;A0ClmuBI;EACI,kDAAA;A1ComuBR;A0ClmuBI;EACI,mDAAA;A1ComuBR;A0ClmuBI;EACI,kDAAA;A1ComuBR;A0ClmuBI;EACI,mDAAA;A1ComuBR;A0ClmuBI;EACI,oCAAA;A1ComuBR;;A0CjmuBA;EACI,oCAAA;A1ComuBJ;A0CnmuBI;EACI,qDAAA;A1CqmuBR;A0CnmuBI;EACI,sDAAA;A1CqmuBR;A0CnmuBI;EACI,qDAAA;A1CqmuBR;A0CnmuBI;EACI,sDAAA;A1CqmuBR;A0CnmuBI;EACI,oCAAA;A1CqmuBR;;A0ChmuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AH4wuBR;;A0CtmuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHkxuBR;;A0C5muBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHwxuBR;;A0ClnuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AH8xuBR;;A0CxnuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHoyuBR;;A0C9nuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AH0yuBR;;A0CpouBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHgzuBR;;A0C1ouBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHszuBR;;A0ChpuBI;EACI,iCAAA;EACA,iCAAA;EACA,WvCzKA;AH4zuBR;;A0CtpuBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHk0uBR;;A0C5puBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AHw0uBR;;A0ClquBI;EACI,oCAAA;EACA,oCAAA;EACA,WvCzKA;AH80uBR;;A0ClquBA;EACI,yBvC3JU;EuC4JV,cvCrMM;AH02uBV;;A0CnquBA;EACI,yBvCpJY;EuCqJZ,cvCvMQ;AH62uBZ;;A0CpquBA;EACI,yBvC/BU;EuCgCV,cvCzMM;AHg3uBV;;A0CrquBA;EACI,yBvCxBS;EuCyBT,cvCvMK;AH+2uBT;;A0CtquBA;EACI,yBvCjBU;EuCkBV,cvC7MM;AHs3uBV;;A0CvquBA;EACI,yCAAA;EACA,cvCnNG;AH63uBP;;A0CxquBA;EACI,0CAAA;EACA,cvCyBS;AHkpuBb;;A0CzquBA;EACI,uCAAA;EACA,WvC1MI;AHs3uBR;;A0C1quBA;EACE,cvCkBW;AH2puBb;;A0C1quBA;EACE,0EAAA;EACA,WvClNM;AH+3uBR;;A0C3quBA;EACE,0EAAA;EACA,WvCtNM;AHo4uBR;;A0C5quBA;EACE,0EAAA;EACA,WvC1NM;AHy4uBR;;A0C7quBA;EACE,0EAAA;EACA,WvC9NM;AH84uBR;;A0C9quBA;EACE,0EAAA;EACA,WvClOM;AHm5uBR;;A0C/quBA;EACE,0EAAA;EACA,WvCtOM;AHw5uBR;;A0ChruBA;EACE,0EAAA;EACA,WvC1OM;AH65uBR;;A0CjruBA;EACE,0EAAA;EACA,WvC9OM;AHk6uBR;;A0ClruBA;EACE,0EAAA;EACA,WvClPM;AHu6uBR;;A0CnruBA;EACE,0EAAA;EACA,WvCrPM;AH26uBR;;A0CpruBA;EACE,0EAAA;EACA,WvC1PM;AHi7uBR;;A0CrruBA;EACE,sBvC7PM;EuC8PN,yBAAA;EACA,cvCtRQ;AH88uBV;;A0CtruBA;EACE,sBvClQM;EuCmQN,yBAAA;EACA,cvCzRU;AHk9uBZ;;A0CvruBA;EACE,sBvCvQM;EuCwQN,yBAAA;EACA,cvCxRQ;AHk9uBV;;A0CxruBA;EACE,sBvC5QM;EuC6QN,yBAAA;EACA,cvC/RK;AH09uBP;;A0CzruBA;EACE,sBvCjRM;EuCkRN,yBAAA;EACA,cvCtSQ;AHk+uBV;;A0C1ruBA;EACE,sBvCtRM;EuCuRN,yBAAA;EACA,cvCrSO;AHk+uBT;;A0C3ruBA;EACE,sBvC3RM;EuC4RN,yBAAA;EACA,cvCxSK;AHs+uBP;;A0C5ruBA;EACE,sBvChSM;EuCiSN,oCAAA;EACA,sBAAA;A1C+ruBF;;A0C7ruBA;EACI,kDAAA;EACA,yBAAA;A1CgsuBJ;A0C/ruBI;EACI,kDAAA;EACA,yBAAA;A1CisuBR;;A0C9ruBA;EACI,mDAAA;EACA,yBAAA;A1CisuBJ;A0ChsuBI;EACI,mDAAA;EACA,yBAAA;A1CksuBR;;A0C/ruBA;EACI,oDAAA;EACA,yBAAA;A1CksuBJ;A0CjsuBI;EACI,oDAAA;EACA,yBAAA;A1CmsuBR;;A0ChsuBA;EACI,mDAAA;EACA,yBAAA;A1CmsuBJ;A0ClsuBI;EACI,mDAAA;EACA,yBAAA;A1CosuBR;;A0CjsuBA;EACI,mDAAA;EACA,yBAAA;A1CosuBJ;A0CnsuBI;EACI,mDAAA;EACA,yBAAA;A1CqsuBR;;A0ClsuBA;EACI,kDAAA;EACA,yBAAA;A1CqsuBJ;A0CpsuBI;EACI,kDAAA;EACA,yBAAA;A1CssuBR;;A0CnsuBA;EACI,qDAAA;EACA,yBAAA;A1CssuBJ;A0CrsuBI;EACI,qDAAA;EACA,yBAAA;A1CusuBR;;A0CpsuBA;EACI,yBvC/NO;AHs6uBX;;A0CrsuBA;EACI,yBvCjOO;AHy6uBX;;A0CtsuBA;EACI,yBvCnOO;AH46uBX;;A0CvsuBA;EACI,yBvCrOO;AH+6uBX;;A0CxsuBA;EACI,yBvCvOO;AHk7uBX;;A0CzsuBA;EACI,yBvCzOO;AHq7uBX;;A0C1suBA;EACI,yBvC3OO;AHw7uBX;;A0C3suBA;EACI,yBvC7OO;AH27uBX;;A0C5suBA;EACI,yBvC/OO;AH87uBX;;A0C7suBA;EACI,avC/YM;AH+lvBV;;A0C9suBA;EACI,avChZQ;AHimvBZ;;A0C/suBA;EACI,avCjZM;AHmmvBV;;A0ChtuBA;EACI,avC9YK;AHimvBT;;A0CjtuBA;EACI,avCnZM;AHumvBV;;A0CltuBA;EACI,UvCvYI;AH4lvBR;;A0CntuBA;EACI,UvCzYI;AH+lvBR;;A0CptuBA;EACI,avC1YG;AHimvBP;;A0CrtuBA;EACI,avCvYK;AH+lvBT;;A0CttuBA;EACI,avCjZK;AH0mvBT;;A0CvtuBA;EACI,avC5YK;AHsmvBT;;A0CxtuBA;EACI,avC1aG;AHqovBP;;A0CztuBA;EACI,avC/YK;AH2mvBT;;A0C1tuBA;EACE,avCjaM;AH8nvBR;;A0C3tuBA;EACE,avC7aK;AH2ovBP;;A0C5tuBA;EACE,avChaK;AH+nvBP;;A0C7tuBA;EACE,avCzMW;AHy6uBb;;A0C9tuBA;EACE,WAAA;EACA,YAAA;EACA,kBvCvIc;EuCwId,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;A1CiuuBF;;A0C/tuBA;EACE,uBAAA;EACA,kBvC/Ic;EuCgJd,8DvCvIW;AHy2uBb;;A0ChuuBA;EACI,WAAA;EACA,YAAA;EACA,kBvCrJY;EuCsJZ,qBAAA;EACA,sBAAA;A1CmuuBJ;;A0CjuuBA;EACI,8BAAA;EACA,gCAAA;A1CouuBJ;;A0CluuBA;EACI,cvClcK;AHuqvBT;;A0CnuuBA;EACI,mBvCnVQ;AHyjvBZ;;A0CpuuBA;EACI,mBvCvVQ;AH8jvBZ;;A0CruuBA;EACI,mBvC9SS;AHshvBb;;A0CtuuBA;EACI,8BAAA;EACA,sBAAA;A1CyuuBJ;;A0CvuuBA;EACI,8BAAA;A1C0uuBJ;;A0CxuuBA;EACI,mBvC9cK;AHyrvBT;;A0CzuuBA;EACI,yBAAA;A1C4uuBJ;;A0C1uuBA;EACI,yBAAA;A1C6uuBJ;;ACjsvBA,qBAAA;A0CpDA;EACI,mBAAA;A3CyvvBJ;A2CxvvBI;EACI,gBxCQe;EwCPf,mBAAA;A3C0vvBR;AIjtvBI;EuC3CA;IAIQ,exCkWG;EH05uBb;AACF;AIttvBI;EuC3CA;IAOQ,mBAAA;E3C8vvBV;AACF;A2C7vvBQ;EACI,mBAAA;EACA,kBAAA;EvC0FT,iBuCzFiC;EvC0FjC,YuC1F4C;EACnC,cxC8BH;EwC7BG,exCmVG;EwClVH,gBxCNW;AHswvBvB;AIpuvBI;EuCzBA;IAEQ,aAAA;E3C+vvBV;AACF;A2C7vvBI;EACI,mBAAA;A3C+vvBR;AI5uvBI;EuCpBA;IAGO,aAAA;E3CiwvBT;AACF;A2ChwvBQ;EACI,WAAA;EACA,YAAA;EACA,gBxCUJ;EwCTI,cxC+ID;EwC5IC,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;A3CkwvBZ;A2CjwvBY;EACI,mBxCGR;EwCFQ,WxCNR;AHywvBR;A2CjwvBY;EACI,eAAA;A3CmwvBhB;AI1wvBI;EuCfI;IAyBQ,4BAAA;E3CowvBd;E2CnwvBc;IACI,0BAAA;E3CqwvBlB;AACF;A2CjwvBI;EACI,aAAA;A3CmwvBR;;A2C/vvBI;EACI,cxCkGI;AHgqvBZ;A2CjwvBQ;EACI,cxClBH;AHqxvBT;;A2C7vvBQ;EACI,cxCzBH;AHyxvBT;;A2C5vvBA;EACI,kBAAA;A3C+vvBJ;A2C9vvBI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,2BAAA;EACA,cxCyFG;AHuqvBX;A2C9vvBI;EvCcD,0BuCbmC;A3CgwvBtC;A2C/vvBQ;EvCYL,0BuCXuC;A3CiwvB1C;;A2C7vvBA;EACI,kBAAA;A3CgwvBJ;A2C/vvBI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;EACA,cxCyEG;AHwrvBX;A2C/vvBI;EvCFD,0BuCGmC;A3CiwvBtC;;A2C9vvBA;EACI,yBAAA;EACA,kBAAA;EvCRD,YuCS+B;EAG1B,oBAAA;EAGA,mBAAA;A3CiwvBR;A2ChwvBI;EACI,WAAA;EACA,YAAA;EACA,gBxChFA;EwCiFA,cxCqDG;EwClDH,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A3CkwvBR;A2CjwvBQ;EACI,0BAAA;A3CmwvBZ;A2CjwvBQ;EACI,0BAAA;A3CmwvBZ;A2CjwvBQ;EACI,mBxC1FJ;EwC2FI,WxCnGJ;AHs2vBR;;A2C/vvBA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;A3CkwvBJ;A2CjwvBI;EACI,OAAA;A3CmwvBR;;A2ChwvBA;EACI,eAAA;EACA,WAAA;EACA,aAAA;EACA,+BAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;A3CmwvBJ;A2ClwvBI;EACI,OAAA;A3CowvBR;;A2CjwvBA;EAGI,aAAA;EAGA,mBAAA;EACA,kBAAA;A3CowvBJ;A2CnwvBI;EACI,0BAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;A3CqwvBR;A2CpwvBQ;EAGI,aAAA;A3CswvBZ;A2CpwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3CswvBZ;A2CpwvBQ;EACI,mBxC/KH;EwCgLG,WxCnKJ;EwCoKI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EvC5HV,kBuC6H4B;EvC5H5B,SuC4HsC;EvC3HtC,WuC2H4C;A3CwwvB9C;A2CpwvBQ;EACI,mBAAA;A3CswvBZ;A2CnwvBI;EACI,mBxCLK;EwCML,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;A3CqwvBR;A2CpwvBQ;EvClIL,iBuCmIuC;EAC9B,eAAA;EACA,cxChMH;EwCiMG,qBAAA;A3CswvBZ;A2CrwvBY;EACI,kBAAA;A3CuwvBhB;A2CpwvBQ;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A3CswvBZ;;A2ClwvBA;EACI,gBxCnNI;EwCoNJ,yBAAA;EACA,kBAAA;EACA,8DAAA;EACA,mBAAA;A3CqwvBJ;A2CpwvBI;EvC3JD,4BuC4JmC;EAC9B,gBxC3Pa;EwC8Pb,aAAA;EAGA,mBAAA;EACA,kBAAA;A3CswvBR;A2CrwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;A3CuwvBZ;A2CrwvBQ;EACI,cxC5GD;AHm3vBX;A2CrwvBQ;EACI,gBAAA;EACA,kCAAA;EvClMV,kBuCmM4B;EvClM5B,QuCkMsC;EvCjMtC,WuCiM2C;EvCxO3C,2BuCyO6B;EvCxO7B,mCuCwO6B;EvCvO7B,+BuCuO6B;EACnB,exCiEG;EwChEH,gBxC1RW;AHqiwBvB;A2CxwvBY;EACI,gBAAA;A3C0wvBhB;A2CxwvBY;EACI,mBxCxRN;EwCyRM,WxClQR;AH4gwBR;A2CtwvBI;EACI,6BAAA;EvC3ML,qBuC4M6B;EvC3M7B,iBuC2M4C;A3CywvB/C;A2CtwvBQ;EACI,mBAAA;A3CwwvBZ;A2CvwvBY;EACI,gBAAA;A3CywvBhB;AIrhwBI;EuC2QQ;IAGQ,mBAAA;E3C2wvBlB;AACF;;A2CrwvBI;EACI,exCkCO;EwCjCP,gBxCzTe;EwC0Tf,kBxCcW;EC5OhB,kBuC+N6B;EvC9N7B,iBuC8NyC;A3CywvB5C;A2CxwvBQ;EACI,eAAA;A3C0wvBZ;;A2CrwvBI;EACI,oBAAA;A3CwwvBR;A2CtwvBI;EACI,kBAAA;A3CwwvBR;A2CvwvBQ;EACI,eAAA;A3CywvBZ;;A2CpwvBI;EACI,mBAAA;EACA,exCeO;AHwvvBf;A2CrwvBI;EACI,gBAAA;EvCtPL,cuCuP6B;A3CuwvBhC;A2CrwvBI;EACI,exCMO;EwCLP,gBAAA;A3CuwvBR;AI5jwBI;EuCmTA;IAIQ,exCCG;EHwwvBb;AACF;A2CvwvBI;EACI,gBAAA;A3CywvBR;;A2CtwvBA;EACI,mBxClKS;EwCmKT,cxC/UK;EwCgVL,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,exCNW;AH+wvBf;A2CxwvBI;EACI,mBxC3JK;EwC4JL,cxC/UC;AHylwBT;;A2CvwvBA;EACI,kBAAA;EvCzRD,gBuC0RyB;EvCzRzB,auCyRmC;EAClC,8DxCvCY;AHkzvBhB;A2C1wvBI;EvC5RD,euC6R6B;EvC5R7B,UuC4RsC;A3C6wvBzC;A2C3wvBY;EACI,mBxCvOJ;AHo/vBZ;A2C1wvBQ;EACI,WAAA;EACA,kBAAA;EvCpST,YuCqSuC;EAC9B,uBAAA;A3C4wvBZ;A2C1wvBgB;EACI,WAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;A3C4wvBpB;A2C1wvBgB;EACI,mBxCnYV;EwCoYU,qBxCpYV;AHgpwBV;A2CzwvBY;EAGI,aAAA;EAGA,mBAAA;A3C2wvBhB;A2C1wvBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3C4wvBpB;A2C1wvBgB;EACI,cxC/JP;EwCgKO,exCrEL;AHi1vBf;A2CxwvBQ;EACI,yBxC/QA;AHyhwBZ;A2CxwvBQ;EACI,gBAAA;A3C0wvBZ;;A2CpwvBQ;EACI,gBAAA;EACA,sCAAA;A3CuwvBZ;;A2CnwvBA;EACI;IvCrYF,yBuCsYuB;IvCrYvB,iCuCqYuB;IvCpYvB,6BuCoYuB;E3CwwvBvB;AACF;A2CtwvBA;EACI,kBAAA;A3CwwvBJ;A2CvwvBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;A3CywvBR;A2CvwvBI;EACI,6BAAA;A3CywvBR;;A2CrwvBI;EACI,aAAA;EACA,mBAAA;A3CwwvBR;A2CtwvBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;A3CwwvBhB;A2CvwvBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3CywvBpB;A2CvwvBgB;EACI,mBxCldV;EwCmdU,WxC5bZ;EwC6bY,exCvIL;AHg5vBf;A2CvwvBgB;EACI,kBAAA;A3CywvBpB;A2CrwvBgB;EACI,cAAA;A3CuwvBpB;;A2CjwvBA;EACI,cxCzdK;AH6twBT;;A2ClwvBA;EACI,kBAAA;A3CqwvBJ;A2CpwvBI;EACI,kBAAA;A3CswvBR;A2CrwvBQ;EACI,cxCpPC;EwCqPD,kBAAA;EACA,qBAAA;EvCzZT,mBuC0ZiC;EvCzZjC,mBuCyZ8C;A3CwwvBjD;A2CvwvBY;EACI,cxCzPH;AHkgwBb;A2CxwvBgB;EACI,cxCjfV;EwCkfU,iBAAA;A3C0wvBpB;A2CxwvBgB;EACI,cxCrfV;AH+vwBV;A2CvwvBY;EACI,eAAA;A3CywvBhB;A2CvwvBY;EACI,eAAA;A3CywvBhB;A2CxwvBgB;EACI,aAAA;A3C0wvBpB;A2CvwvBY;EACI,YAAA;EvCvbd,kBuCwbgC;EvCvbhC,MuCub0C;EvCpb1C,OuCobyD;A3C2wvB3D;A2CzwvBY;EACI,iBAAA;A3C2wvBhB;A2C1wvBgB;EACI,aAAA;A3C4wvBpB;A2CxwvBgB;EACI,WxCtfZ;AHgwwBR;A2C5wvBY;EAII,WxCxfR;AHmwwBR;A2C1wvBgB;EACI,WxC1fZ;AHswwBR;A2CvwvBI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;A3CywvBR;A2CxwvBQ;EvC3cL,kBuC4ciC;A3C0wvBpC;A2CvwvBY;EACI,qBAAA;EACA,iBAAA;A3CywvBhB;A2CxwvBgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBxClhBZ;EwCmhBY,cxCnTN;EwCsTM,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A3C0wvBpB;A2CzwvBoB;EACI,mBxCrjBd;EwCsjBc,WxC/hBhB;AH0ywBR;A2CxwvBgB;EACI,eAAA;A3C0wvBpB;;A2CpwvBA;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;A3CuwvBJ;A2CtwvBI;EACI,mBAAA;A3CwwvBR;A2CvwvBQ;EACI,eAAA;A3CywvBZ;A2CtwvBI;EvC3fD,oBuC4f6B;EvC3f7B,gBuC2f2C;EACtC,exC/PO;EwCgQP,gBxC5lBa;AHq2wBrB;A2CxwvBQ;EACI,mBxCpcA;EwCqcA,cxC5bD;AHsswBX;A2CxwvBQ;EACI,iBAAA;A3C0wvBZ;A2CvwvBI;EACI,mBAAA;A3CywvBR;A2CxwvBQ;EACI,gBxCtmBW;EwCumBX,WxCvkBJ;EwCwkBI,qBAAA;A3C0wvBZ;A2CzwvBY;EACI,qBAAA;EACA,kBAAA;EvC9gBb,iBuC+gB2C;EAC9B,WxC7kBR;AHw1wBR;A2CvwvBI;EACI,eAAA;EACA,cxChjBQ;AHyzwBhB;A2CxwvBQ;EACI,aAAA;A3C0wvBZ;A2CvwvBI;EACI,kBAAA;EACA,iBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exCtSO;EwCuSP,gBxCnoBa;AH44wBrB;A2CxwvBQ;EACI,iBAAA;A3C0wvBZ;A2CvwvBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBxC/fI;EwCggBJ,yBAAA;EACA,cxCtZM;AH+pwBd;A2CxwvBQ;EACI,mBxC/oBF;EwCgpBE,WxCznBJ;AHm4wBR;A2CxwvBQ;EACI,kBAAA;EACA,gBxC7nBJ;EwC8nBI,yBAAA;EACA,cxCtnBH;AHg4wBT;A2CvwvBI;EACI,mBAAA;A3CywvBR;A2CxwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBxCjpBJ;EwCkpBI,yBAAA;A3C0wvBZ;A2CzwvBY;EACI,mBxCzhBJ;EwC0hBI,cxC/gBL;AH0xwBX;A2CxwvBQ;EAGI,aAAA;EAGA,mBAAA;EvCjmBT,YuCkmBuC;EAC9B,kBAAA;EACA,cxCjcE;AH2swBd;A2CzwvBY;EACI,iBAAA;A3C2wvBhB;A2CzwvBY;EACI,mBxCjjBJ;EwCkjBI,cxCvcF;AHktwBd;;A2CtwvBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exCzXW;AHkowBf;A2CxwvBI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBxC5kBI;EwC6kBJ,cxCleM;EwCmeN,kBAAA;EACA,cAAA;A3C0wvBR;;A2CrwvBQ;EACI,cxCzkBD;AHi1wBX;A2CvwvBY;EACI,cxCnuBN;AH4+wBV;A2CtwvBQ;EACI,iBAAA;A3CwwvBZ;;A2CnwvBI;EAGI,aAAA;A3CswvBR;A2CrwvBQ;EACI,gBAAA;EACA,qBAAA;A3CuwvBZ;A2CrwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3CuwvBZ;;A2CnwvBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;A3CswvBJ;A2CrwvBI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cxCpvBC;AH2/wBT;A2CtwvBQ;EACI,cxC/wBF;AHuhxBV;;A2CnwvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3CswvBR;A2CrwvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;A3CuwvBZ;A2CrwvBQ;EACI,exC3dG;EwC4dH,gBxCvzBS;EwCwzBT,kBAAA;A3CuwvBZ;A2CpwvBQ;EACI,exCjeG;EwCkeH,gBAAA;A3CswvBZ;A2CjwvBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;A3CmwvBhB;A2ChwvBgB;EACI,iBAAA;EACA,cxCzzBV;AH2jxBV;;A2C3vvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3C8vvBR;A2C7vvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3C+vvBZ;A2C7vvBQ;EACI,gBAAA;A3C+vvBZ;;A2C1vvBI;EACI,qBAAA;A3C6vvBR;A2C5vvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBxCn1BJ;EwCo1BI,cxC9sBD;AH48wBX;A2C7vvBY;EACI,mBxChtBL;EwCitBK,WxCv1BR;AHslxBR;;A2CzvvBI;EACI,iBAAA;EACA,qBAAA;A3C4vvBR;A2C3vvBQ;EACI,exCziBG;EwC0iBH,gBxCn4BS;EwCo4BT,kBAAA;EvCtyBT,iBuCuyBuC;EAC9B,qBAAA;A3C6vvBZ;A2C3vvBQ;EACI,eAAA;A3C6vvBZ;;A2CzvvBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,cxCj3BK;AH6mxBT;A2C3vvBI;EACI,exClkBO;AH+zwBf;;AIvnxBI;EuC63BJ;IAEQ,cAAA;E3C6vvBN;AACF;A2C5vvBI;EACI,qBAAA;EvCx0BL,kBuCy0B6B;A3C8vvBhC;A2C7vvBQ;EACI,cxCtwBD;EwCywBC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACC,uBAAA;EACD,+BAAA;EACA,qBAAA;EACA,exCvlBG;EwCwlBH,gBxCn7BS;EwCo7BT,6BAAA;EACA,kBAAA;EvCv1BT,yBuCw1BuC;A3C+vvB1C;A2C9vvBY;EACI,cxC96BN;EwC+6BM,qBxC/6BN;AH+qxBV;A2C9vvBY;EACI,iBAAA;A3CgwvBhB;AIzpxBI;EuCi4BA;IA4BQ,cAAA;E3CgwvBV;AACF;;A2C7vvBA;EACI,kBAAA;A3CgwvBJ;A2C/vvBG;EACK,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;A3CiwvBR;A2C/vvBI;EACI,kBAAA;A3CiwvBR;A2C/vvBI;EACI,WAAA;A3CiwvBR;;A2C9vvBA;EACI,mBxChwBS;EwCiwBT,cxCp7BK;EwCq7BL,kBAAA;EACA,qBAAA;EACA,exC/nBW;EC9PZ,gBuC83ByB;EvC73BzB,gBuC63BmC;A3CkwvBtC;A2CjwvBI;EACI,iBAAA;A3CmwvBR;;A2C5vvBgB;EACI,gBAAA;A3C+vvBpB;;A2CzvvBA;EACI,yBAAA;EACA,kBAAA;EvCh5BD,gBuCi5ByB;EvCh5BzB,sBuCg5BmC;A3C6vvBtC;A2C5vvBI;EACI,gBxCh/Ba;EwCi/Bb,kBAAA;A3C8vvBR;A2C5vvBI;EACI,mBAAA;A3C8vvBR;A2C7vvBQ;EACI,cxC/0BD;EwCk1BC,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exClqBG;AHi6wBf;A2C9vvBY;EACI,aAAA;A3CgwvBhB;A2C7vvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3C+vvBZ;A2C7vvBQ;EACI,eAAA;A3C+vvBZ;A2C5vvBY;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,exCxrBD;EwCyrBC,cxC72BL;AH2mxBX;;A2CxvvBI;EACI,aAAA;A3C2vvBR;;A2CxvvBA;EACI,aAAA;EACA,mBAAA;A3C2vvBJ;;A2CxvvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6DAAA;EvCj9BL,gBuCk9B6B;EvCj9B7B,auCi9BuC;EAClC,kBAAA;A3C4vvBR;A2C3vvBQ;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;A3C6vvBZ;A2C5vvBY;EACI,gBxC7jCK;EwC8jCL,kBAAA;A3C8vvBhB;A2C5vvBY;EACI,gBAAA;A3C8vvBhB;AI5xxBI;EuC8gCI;IAmBQ,kBAAA;E3C+vvBd;AACF;A2C7vvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WxC1iCJ;EwC6iCI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;A3C+vvBZ;A2C9vvBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;A3CgwvBhB;A2C7vvBQ;EACI,mBxCx8BA;AHusxBZ;A2C9vvBY;EACI,gBxC/jCR;AH+zxBR;A2C7vvBQ;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,cxC/2BE;EwCg3BF,mBxC39BA;AH0txBZ;AI70xBI;EuCggCA;IvCt8BD,gBuCuhCiC;IvCthCjC,auCshC2C;E3CiwvB5C;AACF;A2C/vvBI;EACI,mBxCn+BI;EwCo+BJ,kBAAA;EvC5hCL,gBuC6hC6B;EvC5hC7B,auC4hCuC;A3CkwvB1C;A2CjwvBQ;EACI,mBAAA;A3CmwvBZ;A2CjwvBQ;EACI,gBxC9lCJ;EwC+lCI,kBxC/lCJ;EwCgmCI,kBAAA;EACA,cxC39BD;EwC49BC,exCtyBG;EwCuyBH,gBxCroCS;EC8FlB,SuCwiCiC;EvCviCjC,iBuCuiCoC;A3CowvBvC;A2CnwvBY;EACI,iBAAA;A3CqwvBhB;A2CnwvBY;EACI,mBxCt/BJ;AH2vxBZ;;A2ChwvBA;EACI,eAAA;A3CmwvBJ;A2ClwvBI;EvCpjCD,qBuCqjC6B;EvCpjC7B,iBuCojC4C;A3CqwvB/C;A2CpwvBQ;EACI,eAAA;A3CswvBZ;A2CpwvBQ;EACI,gBAAA;A3CswvBZ;;A2ClwvBA;EACI,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;A3CqwvBJ;A2CpwvBI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A3CswvBR;A2CpwvBI;EACI,mBxCr9BK;EwCs9BL,cxCzoCC;EwC0oCD,exCl1BO;EwCm1BP,qBAAA;EACA,kBAAA;EvCllCL,cuCmlC6B;EvCllC7B,iBuCklCqC;EAChC,kBAAA;A3CuwvBR;A2CtwvBQ;EACI,kBAAA;A3CwwvBZ;;A2CpwvBA;EACI,mBxCpiCQ;EwCqiCR,0BAAA;EACA,kBAAA;EACA,kBAAA;A3CuwvBJ;A2CtwvBI;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A3CwwvBR;A2CtwvBI;EACI,exCp2BO;EwCq2BP,mBAAA;A3CwwvBR;A2CtwvBI;EACI,exC92BO;EwC+2BP,gBAAA;A3CwwvBR;A2CtwvBI;EACI,kBAAA;EvC/mCL,kBuCgnCmC;A3CwwvBtC;;A2CrwvBA;EACI,mBxC7jCQ;EwC8jCR,yBAAA;EvCtnCD,euCunCyB;EvCtnCzB,auCsnCkC;EACjC,kBAAA;A3CywvBJ;A2CxwvBI;EACI,exC53BO;EwC63BP,gBxCxtCa;EwCytCb,kBAAA;A3C0wvBR;A2CxwvBI;EACI,exCj4BO;EwCk4BP,gBAAA;A3C0wvBR;A2CzwvBQ;EACI,cxCxjCD;AHm0xBX;A2CxwvBI;EACI,WAAA;EvCtoCL,kBuCuoC6B;A3C0wvBhC;A2CxwvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A3C0wvBR;;A2CvwvBA;EACI,gBxClvCmB;EwCmvCnB,mBAAA;A3C0wvBJ;;A2CvwvBI;EACI,mBAAA;A3C0wvBR;A2CzwvBQ;EACI,exC/5BG;AH0qxBf;A2CzwvBQ;EACI,gBAAA;A3C2wvBZ;;A2CvwvBA;EACI,mBxCxmCQ;EwCymCR,yBAAA;EACA,kBAAA;EvCvqCD,gBuCwqCyB;EvCvqCzB,oBuCuqCmC;A3C2wvBtC;A2C1wvBI;EACI,mBAAA;A3C4wvBR;A2C1wvBI;EACI,gBxCzwCe;AHqhyBvB;AIn/xBI;EuCsuCA;IAGQ,exC/6BG;EH6rxBb;AACF;;A2C3wvBA;EACI,exCp7BW;EwCq7BX,cxChwCM;AH8gyBV;;A2C3wvBI;EACI,mBAAA;A3C8wvBR;A2C7wvBQ;EACI,cAAA;EACA,gBxCzxCS;EwC0xCT,kBAAA;A3C+wvBZ;;A2C3wvBA;EACI,cxC3wCK;AHyhyBT;;A2C5wvBA;EACI,yBAAA;EACA,mBxC5mCU;EwC6mCV,kBAAA;EvCvsCD,gBuCwsCyB;EvCvsCzB,auCusCmC;A3CgxvBtC;A2C/wvBI;EACI,cxChoCG;EwCioCH,gBAAA;A3CixvBR;A2ChxvBQ;EACI,iBAAA;A3CkxvBZ;;A2C9wvBA;EACI,aAAA;A3CixvBJ;A2ChxvBI;EACI,cAAA;A3CkxvBR;;A2C9wvBI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;A3CixvBR;AItiyBI;EuCkxCA;IAKQ,sBAAA;E3CmxvBV;AACF;A2ClxvBQ;EACI,mBAAA;EACA,mBxCxqCA;EwCyqCA,kBAAA;EACA,aAAA;EACA,mBAAA;A3CoxvBZ;AIljyBI;EuCyxCI;IAOQ,WAAA;IACA,mBAAA;E3CsxvBd;AACF;A2CrxvBY;EACI,iBAAA;A3CuxvBhB;A2CpxvBgB;EACI,gBAAA;EACA,gBxC50CC;EwC60CD,exCl/BL;EwCm/BK,cxC5qCT;AHk8xBX;A2CnxvBY;EACI,mBxCx0CN;EwCy0CM,WxClzCR;AHukyBR;A2CpxvBgB;EACI,WxCpzCZ;AH0kyBR;;A2ChxvBA;EACI,yBAAA;EvC/vCD,euCgwCyB;EvC/vCzB,sBuC+vCkC;EACjC,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;A3CoxvBJ;A2CnxvBI;EvCpxCF,kBuCqxCwB;EvCpxCxB,MuCoxCkC;EvCjxClC,OuCixCiD;EAC3C,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBxCl2CI;AHynyBZ;A2CrxvBI;EACI,cxC1sCG;EwC2sCH,gBxCl3Ca;EwCm3Cb,mBAAA;A3CuxvBR;A2CrxvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;A3CuxvBR;A2CtxvBQ;EvChyCL,qBuCiyCgC;A3CwxvBnC;A2CvxvBW;EACK,iBAAA;A3CyxvBhB;A2CvxvBW;EACK,eAAA;A3CyxvBhB;A2CrxvBI;EACI,gBAAA;A3CuxvBR;;A2CnxvBI;EACI,kBAAA;A3CsxvBR;A2CrxvBQ;EACI,eAAA;A3CuxvBZ;;A2CnxvBA;EACI,gBAAA;A3CsxvBJ;;A2CpxvBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EvCh0CD,euCi0CyB;EvCh0CzB,uBuCg0CkC;EACjC,kBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A3CwxvBJ;A2CvxvBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3CyxvBR;A2CxxvBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A3C0xvBZ;A2CvxvBI;EACI,gBxCj7Ce;EwCk7Cf,cxC/5CC;AHwryBT;;A2CrxvBI;EACI,aAAA;EACA,SAAA;A3CwxvBR;A2CtxvBI;EACI,cAAA;A3CwxvBR;A2CtxvBI;EACI,mBAAA;EACA,uBAAA;EACA,YAAA;A3CwxvBR;A2CvxvBQ;EACI,iBAAA;A3CyxvBZ;A2CrxvBQ;EACI,yBAAA;EACA,iCAAA;EACA,6BAAA;A3CuxvBZ;;A2CnxvBA;EACI,cAAA;A3CsxvBJ;A2CnxvBY;EACI,yBxC16CR;AH+ryBR;;A2ChxvBA;EACI,UAAA;A3CmxvBJ;;A2CjxvBA;EACI,YAAA;A3CoxvBJ;;A2CjxvBI;EACI,cxCzzCG;EwC0zCH,gBxCj+Ca;AHqvyBrB;A2CnxvBQ;EACI,cxCz9CF;EwC09CE,0BAAA;A3CqxvBZ;;A2CjxvBA;EACI,cxCl0CO;EwCm0CP,gBxC1+CiB;AH8vyBrB;;A2CjxvBI;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;A3CoxvBR;AIluyBI;EuC08CA;IAMQ,sBAAA;E3CsxvBV;AACF;;A2CjxvBQ;EACI,8BAAA;A3CoxvBZ;;A4CvxyBI;EACI,iBAAA;A5C0xyBR;A4CzxyBO;EACK,kBAAA;EACA,YAAA;A5C2xyBZ;A4CxxyBY;EACI,YAAA;A5C0xyBhB;A4CzxyBgB;EACI,iBAAA;A5C2xyBpB;A4CzxyBgB;EACI,YAAA;A5C2xyBpB;;A4CnxyBI;EACI,aAAA;EACA,mBAAA;A5CsxyBR;A4CpxyBY;EACI,iBAAA;A5CsxyBhB;;A4ChxyBA;EACI,YAAA;A5CmxyBJ;AIxwyBI;EwCZJ;IAGQ,eAAA;E5CqxyBN;AACF;A4CpxyBI;EACI,sBzCIA;EyCHA,yBAAA;EACA,czCoCQ;EyCnCR,ezC8TO;EyC7TP,eAAA;ExC4DL,iBwC3D6B;ExC4D7B,oBwC5DwC;A5CuxyB3C;A4CtxyBQ;EACI,czCgCI;AHwvyBhB;AIzxyBI;EwCPA;IAWQ,eAAA;IxCsDT,iBwCrDiC;IxCsDjC,oBwCtD4C;E5C0xyB7C;AACF;;AIhyyBI;EwCUA;IAEQ,kBAAA;E5CyxyBV;AACF;AItyyBI;EwCUA;IAKQ,eAAA;E5C2xyBV;AACF;;A4CxxyBA;EACI,oBAAA;EACA,mBAAA;A5C2xyBJ;AIhzyBI;EwCmBJ;IAIQ,sBAAA;IACA,gBAAA;E5C6xyBN;AACF;AItzyBI;EwCmBJ;IAQQ,sBAAA;IACA,aAAA;IACA,kBAAA;E5C+xyBN;AACF;A4C9xyBI;EACI,iBAAA;EACA,kBAAA;A5CgyyBR;AIj0yBI;EwC+BA;IAIQ,cAAA;E5CkyyBV;AACF;A4C/xyBQ;EACI,4BAAA;EACA,sBzC3CJ;EyC4CI,yBAAA;EACA,czCbI;EyCcJ,ezC4QG;EyC3QH,qBAAA;EACA,mBAAA;A5CiyyBZ;;A4C5xyBI;EACI,gBAAA;A5C+xyBR;;A4C3xyBI;EACI,iBAAA;EACA,YAAA;A5C8xyBR;;A4C1xyBI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;A5C6xyBR;;A4C1xyBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;A5C6xyBJ;;A4CzxyBQ;EACI,YAAA;EACA,gBAAA;A5C4xyBZ;A4C3xyBY;EACI,UAAA;EACA,QAAA;A5C6xyBhB;A4C3xyBY;EACI,YAAA;EACA,gBAAA;A5C6xyBhB;A4C1xyBQ;EACI,kBAAA;A5C4xyBZ;;A6Cn6yBA;EACI,gB1C0CI;AH43yBR;;A6Cp6yBA;EACI,kBAAA;A7Cu6yBJ;AI93yBI;EyC1CJ;IAGQ,aAAA;E7Cy6yBN;AACF;A6Cx6yBI;EACI,eAAA;EACA,MAAA;EACA,OAAA;A7C06yBR;A6Cx6yBI;EACI,eAAA;EACA,YAAA;EACA,QAAA;A7C06yBR;A6Cx6yBI;EACI,YAAA;A7C06yBR;;A6Cv6yBA;EACI,gBAAA;A7C06yBJ;;A8Cj8yBA;EACE,gB3C0CM;AH05yBR;;A8Cj8yBE;EACE,kBAAA;A9Co8yBJ;A8Cn8yBI;EACE,e3CiWS;ECzQb,kB0CvFsB;E1CwFtB,Q0CxFgC;E1CyFhC,W0CzFqC;EACjC,2BAAA;A9Cu8yBN;;A8Cn8yBA;EACE,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A9Cs8yBF;A8Cr8yBE;EAGE,oBAAA;EAGA,mBAAA;EACA,eAAA;EACA,c3CgJO;E2C/IP,gBAAA;A9Cu8yBJ;A8Ct8yBI;EACE,aAAA;A9Cw8yBN;A8Cv8yBM;EACE,mB3ChBI;AHy9yBZ;A8Cx8yBQ;EACE,MAAA;A9C08yBV;A8Ct8yBI;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,mDAAA;EACA,mB3C6GM;E2C5GN,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,kB3C4Ra;AH4qyBnB;A8Cv8yBM;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,kB3CpBA;E2CqBA,8CAAA;EACA,+BAAA;EACA,mDAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;A9Cy8yBR;;A8Cp8yBA;EACE,kBAAA;EACA,c3CjCO;AHw+yBT;A8Ct8yBE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,mB3CtCK;ECaP,mB0C0BqB;E1CzBrB,2B0CyBqB;E1CxBrB,uB0CwBqB;E1COrB,yB0CNsB;E1CUtB,kB0CToB;E1CYpB,Y0CZ0C;E1Ca1C,O0CbgD;A9C88yBlD;A8C58yBE;E1C9BA,mB0C+BqB;E1C9BrB,2B0C8BqB;E1C7BrB,uB0C6BqB;A9Cg9yBvB;A8C98yBE;EACE,c3C/CK;AH+/yBT;;A8C78yBA;EACE,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9Cg9yBF;;A8C98yBA;EACE,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9Ci9yBF;;A8C/8yBA;EACE,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9Ck9yBF;;A8Ch9yBA;EACE,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A9Cm9yBF;;A8Cj9yBA;EACE,kBAAA;EACA,c3CrGQ;E2CsGR,gB3ChHmB;AHokzBrB;A8Cn9yBE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,mB3C3GM;ECsCR,mB0CsEqB;E1CrErB,2B0CqEqB;E1CpErB,uB0CoEqB;E1CrCrB,yB0CsCsB;E1ClCtB,kB0CmCoB;E1ChCpB,Y0CgC0C;E1C/B1C,O0C+BgD;A9C29yBlD;A8Cz9yBE;E1C1EA,mB0C2EqB;E1C1ErB,2B0C0EqB;E1CzErB,uB0CyEqB;A9C69yBvB;A8C39yBE;EACE,yBAAA;A9C69yBJ;;A8C19yBA;EACE,6CAAA;EACA,2BAAA;A9C69yBF;AI7jzBI;E0C8FJ;IAII,sBAAA;E9C+9yBF;AACF;;A8C79yBA;EACE,gBAAA;EACA,YAAA;A9Cg+yBF;;A8C99yBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,c3CuBS;E2CtBT,e3C6Ma;E2C1Mb,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E1CrCA,kB0CsCiB;E1C3GjB,2B0C4GmB;E1C3GnB,mC0C2GmB;E1C1GnB,+B0C0GmB;E1CvEnB,kB0CwEkB;E1CvElB,Q0CuE4B;E1CtE5B,W0CsEiC;A9Cq+yBnC;A8Cp+yBE;EACE,c3CrJM;AH2nzBV;;A8Cn+yBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,c3CCS;E2CAT,e3CuLa;E2CpLb,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E1C3DA,kB0C4DiB;E1CjIjB,2B0CkImB;E1CjInB,mC0CiImB;E1ChInB,+B0CgImB;E1C7FnB,kB0C8FkB;E1C7FlB,Q0C6F4B;E1C5F5B,W0C4FiC;A9C0+yBnC;A8Cz+yBE;EACE,c3C3KM;AHspzBV;;A8Cx+yBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,c3CrBS;E2CsBT,e3CiKa;E2C9Jb,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E1CjFA,kB0CkFiB;E1CvJjB,2B0CwJmB;E1CvJnB,mC0CuJmB;E1CtJnB,+B0CsJmB;E1CnHnB,kB0CoHkB;E1CnHlB,Q0CmH4B;E1ClH5B,W0CkHiC;A9C++yBnC;A8C9+yBE;EACE,c3CjMM;AHirzBV;;A8C7+yBA;EACE,kBAAA;EACA,e3CtNe;AHsszBjB;;A8C9+yBA;EACE,kBAAA;EACA,kBAAA;EACA,c3C6CU;E2C5CV,e3C5Ne;E2C6Nf,gB3CxNmB;E2CyNnB,mBAAA;A9Ci/yBF;A8Ch/yBE;EACE,kBAAA;EACA,e3CjOa;E2CkOb,c3CoCS;E2CnCT,gB3C3Ne;AH6szBnB;A8Cj/yBI;EACE,WAAA;EACA,mB3CkCM;E2CjCN,WAAA;EACA,WAAA;E1C7IJ,kB0C8IsB;E1C7ItB,S0C6IgC;E1C1IhC,W0C0IkD;A9Cq/yBpD;AIrrzBI;E0C2LA;IAOI,WAAA;E9Cu/yBN;AACF;A8Cr/yBI;EACE,WAAA;EACA,mB3CwBM;E2CvBN,WAAA;EACA,WAAA;E1CvJJ,kB0CwJsB;E1CvJtB,S0CuJgC;E1CtJhC,Y0CsJsC;A9Cy/yBxC;AInszBI;E0CqMA;IAOI,WAAA;E9C2/yBN;AACF;;A8Cv/yBA;EACE,gBAAA;A9C0/yBF;;A8Cx/yBA;EACE,WAAA;EACA,YAAA;A9C2/yBF;AIjtzBI;E0CoNJ;IAII,WAAA;IACA,YAAA;E9C6/yBF;AACF;;A8C3/yBA;EACE,kBAAA;A9C8/yBF;AI3tzBI;E0C4NJ;IAGI,aAAA;E9CggzBF;AACF;A8C//yBE;EACE,eAAA;EACA,MAAA;EACA,OAAA;A9CigzBJ;A8C//yBE;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;A9CigzBJ;;A+CvxzBI;EACI,e5CsWO;E4CrWP,gB5CQe;E4CPf,mBAAA;A/C0xzBR;AIjvzBI;E2C5CA;IAKQ,e5CiWG;I4ChWF,mBAAA;E/C4xzBX;AACF;A+C1xzBI;EACI,c5CiKG;E4C9JH,oBAAA;EAGA,mBAAA;EACA,kB5CiUW;E4ChUX,aAAA;EACA,WAAA;EACA,kBAAA;A/C4xzBR;A+C3xzBQ;EACI,mB5CyIA;E4CxIA,c5CyJD;AHoozBX;A+C5xzBY;EACI,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,e5CsUD;E4CrUC,QAAA;EACA,2BAAA;EACA,WAAA;A/C8xzBhB;A+C3xzBQ;EACI,c5C6ID;AHgpzBX;;A+CzxzBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/C4xzBJ;A+C3xzBI;EACI,YAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kB5C8RW;E4C7RX,0BAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A/C6xzBR;A+C5xzBQ;EACI,c5C2GD;E4C1GC,kBAAA;A/C8xzBZ;A+C1xzBQ;EAGI,oBAAA;EAGA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,c5ClCH;E4CmCG,mB5CgJC;E4C/ID,yBAAA;EACA,kB5CiQO;E4ChQP,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;A/C4xzBZ;A+C3xzBY;EACI,W5C7CR;E4C8CQ,mB5C5CP;E4C6CO,yBAAA;EACA,oBAAA;A/C6xzBhB;A+C3xzBY;EACI,e5CyQD;E4CxQC,iBAAA;A/C6xzBhB;A+C3xzBY;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;A/C6xzBhB;A+C1xzBQ;EACI,gB5CtGS;E4CuGT,c5C2DD;AHiuzBX;A+CzxzBI;EACI,aAAA;A/C2xzBR;A+CzxzBI;EACI,WAAA;EACA,YAAA;EACA,kB5CyNW;E4CxNX,cAAA;EACA,kBAAA;EACA,gB5ClFA;E4CmFA,iBAAA;A/C2xzBR;A+CzxzBI;EACI,aAAA;A/C2xzBR;A+CzxzBI;EACI,WAAA;EACA,YAAA;EACA,e5C2NO;E4C1NP,W5C5FA;E4C6FA,mB5C1GC;E4C2GD,yBAAA;EACA,kB5CyMW;E4CxMX,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A/C2xzBR;A+CzxzBI;EACI,sC5CnHO;E4CoHP,4CAAA;A/C2xzBR;;A+CnxzBoB;EACI,cAAA;A/CsxzBxB;A+CnxzBgB;EACI,e5CuML;E4CtMK,aAAA;A/CqxzBpB;A+C/wzBgB;EACI,gB5C9JC;E4C+JD,c5CQT;E4CPS,aAAA;A/CixzBpB;A+C9wzBoB;EACI,iBAAA;A/CgxzBxB;;A+CxwzBI;EACI,kBAAA;A/C2wzBR;;A+CxwzBA;EACI,WAAA;EACA,YAAA;EACA,gB5ClJI;E4CmJJ,yBAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,c5CxBO;AHmyzBX;A+C1wzBI;EACI,mB5CxJA;E4CyJA,W5CjKA;AH66zBR;;A+CxwzBI;EACI,mBAAA;A/C2wzBR;A+C1wzBQ;EACI,e5CkJG;E4CjJH,gB5C1MS;AHs9zBrB;A+C1wzBQ;EACI,e5C4IG;AHgozBf;A+CzwzBI;EACI,mBAAA;A/C2wzBR;A+CzwzBI;EACI,gBAAA;A/C2wzBR;;A+CxwzBA;EACI,mB5CnEQ;E4CoER,kBAAA;EACA,yBAAA;EACA,kBAAA;E3C9HD,gB2C+HyB;E3C9HzB,a2C8HmC;A/C4wzBtC;AIr8zBI;E2CoLJ;I3C1HG,gB2CiI6B;I3ChI7B,a2CgIuC;E/C+wzBxC;AACF;A+C9wzBI;EACI,qB5CnNE;AHm+zBV;A+C/wzBQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,c5C5CE;E4C6CF,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sB5C5MJ;E4C+MI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A/CixzBZ;A+C7wzBQ;EACI,6BAAA;A/C+wzBZ;A+C9wzBY;EACI,yB5CvGJ;AHu3zBZ;;A+C1wzBI;EACI,0BAAA;A/C6wzBR;A+C3wzBI;EACI,W5CrOA;E4CsOA,iBAAA;A/C6wzBR;;A+C1wzBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/C6wzBJ;A+C5wzBI;EACI,iBAAA;A/C8wzBR;A+C7wzBQ;EACI,yB5C/HA;ECjCV,kB2CiK2B;EACjB,c5CrHD;E4CsHC,gB5CxRS;EC8FlB,iB2C2LuC;EAC9B,qBAAA;A/C+wzBZ;A+C9wzBY;EACI,yB5CnPR;E4CoPQ,sBAAA;A/CgxzBhB;;A+C3wzBA;EACI,eAAA;A/C8wzBJ;A+C7wzBI;EACI,gB5CpQA;E4CqQA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;A/C+wzBR;A+C9wzBQ;EACI,YAAA;A/CgxzBZ;AIzh0BI;E2CwQI;IAGO,YAAA;E/CkxzBb;AACF;A+ChxzBQ;EACI,eAAA;A/CkxzBZ;A+ChxzBQ;EACI,gB5CrTS;E4CsTT,e5CqCG;E4CpCH,c5ChJD;E4CiJC,gBAAA;EACA,cAAA;A/CkxzBZ;A+ChxzBQ;EACI,qB5ClTF;AHok0BV;A+CjxzBY;EACI,c5CpTN;AHuk0BV;;A+C7wzBI;EACI,aAAA;EACA,mBAAA;A/CgxzBR;A+C/wzBQ;EACI,kBAAA;A/CixzBZ;A+ChxzBY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yB5CnUN;E4CoUM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;A/CkxzBhB;A+CjxzBgB;EACI,yB5CnSN;AHsj0Bd;A+ClxzBoB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,yB5C/Ud;E4CgVc,kBAAA;EACA,UAAA;A/CoxzBxB;A+CjxzBgB;EACI,yB5CnVR;AHsm0BZ;A+ClxzBoB;EACI,yB5CrSR;AHyj0BhB;A+CnxzBwB;EACI,yB5CvVhB;AH4m0BZ;A+CjxzBgB;EACI,yB5C3TT;AH8k0BX;A+ClxzBoB;EACI,wCAAA;A/CoxzBxB;A+CnxzBwB;EACI,yB5C/TjB;AHol0BX;A+CjxzBgB;EACI,yB5CtUX;AHyl0BT;A+ClxzBoB;EACI,yB5C1OX;AH8/zBb;A+CnxzBwB;EACI,yB5C1UnB;AH+l0BT;A+CjxzBgB;EACI,yB5CvVX;AH0m0BT;A+ClxzBoB;EACI,yB5CtKX;AH07zBb;A+CnxzBwB;EACI,yB5C3VnB;AHgn0BT;A+ChxzBY;EACI,eAAA;A/CkxzBhB;;A+C7wzBA;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/CgxzBJ;;A+C9wzBA;EACI,kBAAA;A/CixzBJ;A+ChxzBI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;E3CrSN,kB2CsSuB;EACjB,c5CrPG;E4CsPH,gB5C7Za;EC8FlB,gB2CgUmC;A/CkxzBtC;A+CjxzBQ;EACI,iBAAA;E3C3SV,kB2C4S2B;EACjB,WAAA;EACA,YAAA;A/CmxzBZ;;A+C9wzBI;E3C3UD,iB2C4U6B;A/CixzBhC;A+ChxzBQ;EACI,yB5C3QD;E4C4QC,c5CrQD;EClDT,kB2CwT2B;E3C/U1B,iB2CgVuC;EAC9B,qBAAA;A/CkxzBZ;A+CjxzBY;EACI,yB5CpYL;E4CqYK,W5CjZR;AHoq0BR;A+ChxzBQ;EACI,eAAA;A/CkxzBZ;;A+C7wzBI;EACI,gB5C5ba;E4C6bb,mBAAA;A/CgxzBR;A+C9wzBI;EACI,mBAAA;A/CgxzBR;A+C7wzBQ;EACI,e5CvGG;E4CwGH,gB5CpcW;AHmt0BvB;;A+C3wzBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;A/C8wzBJ;A+C7wzBI;EACI,mBAAA;A/C+wzBR;;A+C5wzBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A/C+wzBJ;;A+C7wzBA;EACI,mBAAA;A/CgxzBJ;A+C/wzBI;EACI,gB5Cpea;AHqv0BrB;A+C/wzBI;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;A/CixzBR;;A+C9wzBA;EACI,yBAAA;A/CixzBJ;;A+C9wzBI;EACI,cAAA;A/CixzBR;AI/t0BI;E2C6cA;IAGQ,iBAAA;E/CmxzBV;AACF;A+CjxzBY;EACI,iBAAA;A/CmxzBhB;AIvu0BI;E2CmdQ;IAGS,gBAAA;IACA,mBAAA;E/CqxzBnB;AACF;;A+ChxzBA;EACI,WAAA;EACA,YAAA;A/CmxzBJ;;AgD/x0BA;EACI,cAAA;EACA,gBAAA;AhDky0BJ;;AgD7x0BY;EACI,aAAA;AhDgy0BhB;AgD5x0BI;EACI,c7CoKG;E6CnKH,yBAAA;EACA,iBAAA;EACA,kB7CmUW;E6ClUX,aAAA;EACA,mBAAA;EACA,6DAAA;AhD8x0BR;AgD7x0BQ;EACI,aAAA;EACA,cAAA;EACA,gCAAA;EACA,+BAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;E5CqGV,yB4CpGoC;E5CqGpC,iC4CrGoC;E5CsGpC,6B4CtGoC;E5C4DpC,yB4C3D8B;E5C0B9B,wB4CzB6B;E5C0B7B,gC4C1B6B;E5C2B7B,4B4C3B6B;AhDqy0B/B;AgDny0BQ;E5CuBN,0B4CtB6B;E5CuB7B,kC4CvB6B;E5CwB7B,8B4CxB6B;AhDuy0B/B;AgDpy0BI;EACI,aAAA;EACA,gB7CEA;E6CDA,6C7CkTQ;E6CjTR,yBAAA;AhDsy0BR;AgDry0BQ;EACI,iBAAA;EACA,c7CkID;E6CjIC,gB7CJJ;E6CKI,kB7CmSO;AHog0BnB;AgDty0BY;EACI,c7C+HL;E6C9HK,mB7C6GJ;AH2r0BZ;;AiD110BC;EACC,gB9CQmB;E8CPnB,mBAAA;EACA,iBAAA;AjD610BF;;AiD110BA;EACC,mBAAA;EAGA,oBAAA;EAGA,mBAAA;AjD610BD;AiD510BC;EACC,gB9CLqB;EC4FpB,qB6CtFuB;E7CuFvB,mB6CvFsC;EACvC,kBAAA;AjD+10BF;AiD910BE;EACC,WAAA;EACA,yB9CiJS;E8ChJT,UAAA;EACA,YAAA;E7CwED,kB6CvEmB;E7CwEnB,M6CxE6B;E7CyE7B,Q6CzEgC;AjDk20BlC;AI700BI;E6C1BF;IAOE,aAAA;EjDo20BF;AACF;AIl10BI;E6CtCJ;IAwBE,cAAA;EjDo20BA;AACF;;AiDj20BC;EACC,mBAAA;AjDo20BF;AiDn20BE;EACC,qBAAA;EACA,kBAAA;AjDq20BH;AiDp20BG;EACC,WAAA;EACA,YAAA;E7CqFF,kB6CpFmB;EACjB,yBAAA;EAGS,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,c9C2HF;AH2u0BX;AiDr20Ba;EACC,yB9CLN;E8CMM,qB9CNN;E8COM,W9CfN;AHs30BR;AiDp20BG;EACC,eAAA;AjDs20BJ;;AiDh20BE;EACC,qBAAA;AjDm20BH;AiDj20BI;EACC,aAAA;AjDm20BL;AiDl20BK;EACC,yBAAA;EACA,6DAAA;E7C4BH,oB6C3B2B;E7C4B3B,iB6C5ByC;E7CmD1C,kB6ClDqB;EACjB,c9CmGK;E8ClGL,eAAA;AjDq20BN;AiDp20BM;EACC,iBAAA;AjDs20BP;AiDl20BM;EACC,qB9CnCC;E8CoCD,c9CpCC;AHw40BR;AiD/10BG;EACC,eAAA;AjDi20BJ;;AiD710BA;EACC,c9C9ES;E8C+ET,kBAAA;EACA,gB9C1FoB;AH070BrB;AiD/10BC;EACC,iBAAA;AjDi20BF;AiD/10BC;EACC,uD9CpFc;AHq70BhB;;AiD910BA;E7CmBE,kB6ClBgB;E7CNf,gB6COsB;E7CNtB,oB6CMgC;EAClC,8DAAA;AjDk20BD;AiDh20BE;EACC,qBAAA;EACA,kBAAA;AjDk20BH;AiDj20BG;E7CZA,sB6Ca+B;EAC9B,gB9C5GiB;E8C6GjB,6BAAA;EACA,qBAAA;AjDm20BJ;AiDl20BI;EACC,WAAA;EACA,YAAA;E7CIH,kB6CHoB;EAChB,yBAAA;EAGQ,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,c9CyCH;E8CxCG,gB9C9HS;E8C+HT,e9CuNC;AH6o0Bf;AiDl20BI;EACC,c9CzHK;E8C0HL,qB9C1HK;AH890BV;;AiD910BA;E7C7CG,gB6C8CsB;E7C7CtB,a6C6CgC;EAClC,8DAAA;EACA,yBAAA;E7CxBC,kB6CyBgB;AjDk20BlB;AiDj20BC;EACC,e9C6Ma;E8C5Mb,gB9ClJmB;E8CmJnB,mBAAA;EACA,c9CeS;AHo10BX;AiDh20BE;EACC,c9CpHM;AHs90BT;AiD/10BC;EACC,gBAAA;AjDi20BF;;AiD910BA;EACC,W9C9HO;EC6DL,gB6CkE4B;EAC9B,e9CwLc;ECpOb,kB6C6CgB;AjDi20BlB;AiDh20BC;EACC,iBAAA;AjDk20BF;;AiD/10BA;EACC,gB9CxKoB;E8CyKpB,c9CFU;AHo20BX;;AkDnh1BE;EACC,gBAAA;AlDsh1BH;AkDrh1BG;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;AlDuh1BJ;AkDrh1BK;EACC,yB/CgCG;AHu/0BT;AkDnh1BK;EACC,yB/CMI;AH+g1BV;AkDjh1BK;EACC,yB/CHI;AHsh1BV;AkD/g1BK;EACC,qBAAA;AlDih1BN;AkD/g1BK;EACC,qBAAA;AlDih1BN;AkDhh1BM;EACC,QAAA;E9CqBL,2B8CpBwB;E9CqBxB,mC8CrBwB;E9CsBxB,+B8CtBwB;AlDoh1B1B;AkDjh1BK;EACC,qBAAA;AlDmh1BN;AkDjh1BK;EACC,gB/CnCe;AHsj1BrB;AkDjh1BK;EACC,gB/CrCiB;E+CsCjB,e/CkTS;EC5PZ,oB8CrD2B;E9CsD3B,gB8CtDyC;EACtC,W/CRE;AH4h1BR;AkDnh1BM;EACC,eAAA;AlDqh1BP;AkD/g1BM;E9C4CH,qB8C3C4B;AlDih1B/B;AkDhh1BO;EACC,gBAAA;AlDkh1BR;AkDhh1BO;EACC,eAAA;AlDkh1BR;;AkDvg1BE;EACC,QAAA;E9CnBD,2B8CoBoB;E9CnBpB,mC8CmBoB;E9ClBpB,+B8CkBoB;AlD4g1BtB;;AkDvg1BC;EACC,SAAA;EACA,UAAA;EACA,e/CkRa;E+CjRb,gB/C5EqB;E+C6ErB,gBAAA;AlD0g1BF;AkDzg1BE;EACC,SAAA;AlD2g1BH;AIxj1BI;E8CsCH;IAUE,e/C0QY;EHkw0Bb;AACF;;AkDzg1BA;EACC,yBAAA;EACA,8BAAA;AlD4g1BD;;AkD1g1BA;EACC,gCAAA;EACA,mBAAA;EACA,oBAAA;AlD6g1BD;AkD1g1BI;EACC,mBAAA;AlD4g1BL;AkDxg1BC;EACC,iBAAA;AlD0g1BF;AkDvg1BI;EACC,gBAAA;AlDyg1BL;AkDpg1BC;EACC,e/C6Oa;E+C5Ob,gB/CjHqB;E+CkHrB,kBAAA;EACA,cAAA;AlDsg1BF;AIvl1BI;E8CkFF;IAEE,e/CsOW;EHiy0Bb;AACF;AkDrg1BE;EACC,WAAA;EACA,YAAA;E9CPD,kB8CQkB;EACjB,yBAAA;EAGA,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,c/C8BQ;E+C7BR,gB/CzIoB;E+C0IpB,e/C4MY;AH2z0Bf;AkDrg1BE;EACU,gBAAA;EACA,kCAAA;E9C1DV,kB8C2D4B;E9C1D5B,Q8C0DsC;E9CzDtC,W8CyD2C;E9ChG3C,2B8CiG6B;E9ChG7B,mC8CgG6B;E9C/F7B,+B8C+F6B;EACnB,e/CyMG;E+CxMH,gB/ClJW;AH6p1BvB;AkDxg1BY;EACI,gBAAA;AlD0g1BhB;AkDtg1BC;EACC,SAAA;EACA,gBAAA;AlDwg1BF;;AkDng1BA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AlDsg1BD;AkDrg1BC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iDAAA;AlDug1BF;AkDrg1BG;EACD,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,c/C3IS;E+C4IT,wBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;AlDug1BF;AkDrg1BG;EACD,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,mB/C1JM;E+C2JN,UAAA;EACA,YAAA;EACA,wDAAA;AlDug1BF;;AkDlg1BE;EACD;IAAO,yBAAA;ElDsg1BN;AACF;AkDpg1BA;EACI,mBAAA;AlDsg1BJ;AkDrg1BC;EACC,eAAA;EACA,gBAAA;EACA,c/C7CS;E+C8CT,kBAAA;AlDug1BF;AkDrg1BC;EACC,c/CtDS;E+CuDT,eAAA;AlDug1BF;;AkDng1BC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AlDsg1BF;AkDpg1BC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AlDsg1BF;AkDpg1BC;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AlDsg1BF;AkDpg1BC;EACC,cAAA;EACA,eAAA;EACA,cAAA;AlDsg1BF;AkDlg1BG;EACC,YAAA;AlDog1BJ;AkDhg1BC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;EACA,mBAAA;AlDkg1BF;AkDjg1BE;EACC,UAAA;EACA,mBAAA;AlDmg1BH;AkDlg1BG;EACC,c/C/FO;E+CgGP,gBAAA;EACA,kBAAA;AlDog1BJ;AkDlg1BG;EAEC,c/ClGO;E+CmGP,gBAAA;AlDmg1BJ;AkDjg1BG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AlDmg1BJ;AkDjg1BG;EACC,iBAAA;AlDmg1BJ;;AkD7/0BC;EACC,eAAA;EACA,mBAAA;AlDgg1BF;;AkD7/0BA;EACC,oBAAA;AlDgg1BD;;AkD9/0BA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACH,mBAAA;AlDig1BD;;AkD9/0BC;EACC,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AlDig1BF;;AkD9/0BA;EACI,aAAA;EACA,mBAAA;AlDig1BJ;;AkD//0BA;EACI,iBAAA;AlDkg1BJ;AkDjg1BC;EACC,eAAA;EACA,kBAAA;EACA,gBAAA;AlDmg1BF;AkDjg1BC;EACC,eAAA;EACA,gBAAA;AlDmg1BF;;AkD//0BA;EACI,mBAAA;EACA,yBAAA;EACA,mBAAA;AlDkg1BJ;AkDjg1BC;EACC,mBAAA;AlDmg1BF;;AkDhg1BA;EACC,mBAAA;EACG,yBAAA;EACA,mBAAA;AlDmg1BJ;AkDlg1BC;EACC,mBAAA;AlDog1BF;;AkDjg1BA;EACI,mBAAA;EACA,aAAA;AlDog1BJ;AkDlg1BE;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AlDog1BH;AkDng1BG;EACC,eAAA;EACA,c/ChMO;E+CiMP,gBAAA;EACA,SAAA;AlDqg1BJ;AkDng1BG;EACC,eAAA;EACA,c/CjMO;E+CkMP,gBAAA;EACA,SAAA;AlDqg1BJ;AkDng1BG;EACC,gBAAA;AlDqg1BJ;;AkDhg1BA;EACC,gBAAA;EACA,iBAAA;EACA,6BAAA;AlDmg1BD;AkDlg1BC;EACC,eAAA;EACA,gBAAA;EACA,c/ClNS;E+CmNT,mBAAA;AlDog1BF;AkDlg1BC;EACC,c/C3NS;E+C4NT,eAAA;EACA,oBAAA;AlDog1BF;;AkDhg1BC;EACC,gBAAA;AlDmg1BF;AkDjg1BC;EACC,SAAA;EACA,eAAA;AlDmg1BF;AkDlg1BE;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AlDog1BH;AkDng1BG;EACC,kBAAA;EACA,UAAA;EACA,c/C/OO;E+CgPP,eAAA;EACA,SAAA;AlDqg1BJ;AkDpg1BI;EACC,kBAAA;EACA,YAAA;EACA,UAAA;EACA,QAAA;AlDsg1BL;AkDng1BG;EACC,kBAAA;EACA,UAAA;EACA,c/CvPO;E+CwPP,eAAA;EACA,SAAA;AlDqg1BJ;;AkD//0BC;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;AlDkg1BF;;AkD//0BA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,8DAAA;EACA,kBAAA;EACH,mBAAA;AlDkg1BD;AkDjg1BC;EACC,UAAA;AlDmg1BF;AkDhg1BE;EACC,c/CtRQ;E+CuRR,mBAAA;AlDkg1BH;AkDhg1BE;EACC,eAAA;EACA,aAAA;AlDkg1BH;AkDjg1BG;EACC,UAAA;AlDmg1BJ;AkDlg1BI;EACC,SAAA;EACA,eAAA;EACA,gBAAA;AlDog1BL;AkDlg1BI;EACC,eAAA;EACA,gBAAA;AlDog1BL;;AkD7/0BC;EACC,2BAAA;AlDgg1BF;AkD9/0BC;EACC,WAAA;AlDgg1BF;AkD9/0BC;EACC,eAAA;AlDgg1BF;;AkD7/0BA;EACC,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AlDgg1BD;AkD//0BC;EACC,mB/CzdQ;E+C0dR,sBAAA;AlDig1BF;;AkD3/0BE;EACC,YAAA;AlD8/0BH;AkD3/0BC;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AlD6/0BF;AkD3/0BC;EACC,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AlD6/0BF;;AkD1/0BA;EACC,kBAAA;AlD6/0BD;AkD5/0BC;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AlD8/0BF;AkD5/0BC;EACC,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,c/C3WS;E+C4WT,OAAA;EACA,aAAA;EACA,gBAAA;AlD8/0BF;;AkD1/0BC;EACC,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,0BAAA;EACA,yBAAA;AlD6/0BF;AkD5/0BE;EACC,SAAA;EACA,kBAAA;EACA,eAAA;AlD8/0BH;AkD5/0BE;EACC,gBAAA;AlD8/0BH;AkD5/0BE;EACC,sBAAA;EACA,mB/C1hBO;AHwh2BV;AkD5/0BE;EACC,sBAAA;AlD8/0BH;AkD3/0BC;EACC,0BAAA;EACA,yBAAA;AlD6/0BF;;AkDx/0BC;EACC,eAAA;EACA,WAAA;AlD2/0BF;;AkDv/0BA;EACC,eAAA;EACA,6BAAA;EACA,gCAAA;AlD0/0BD;AkDz/0BC;EACC,cAAA;EACA,SAAA;AlD2/0BF;;AkDv/0BC;EACC,YAAA;AlD0/0BF;;AkDt/0BC;EACC,sBAAA;AlDy/0BF;;AmDxk2BQ;EACI,mBhD6JA;EgD5JA,kBAAA;EACA,mBAAA;AnD2k2BZ;AmD1k2BY;EACI,gBAAA;AnD4k2BhB;AmDzk2BgB;EACI,ehD0VL;EgDzVK,gBhDFC;EgDGD,chDoKT;EgDnKS,kBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AnD2k2BpB;AmDzk2BgB;EACI,ehD+UL;EgD9UK,mBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AnD2k2BpB;AmDzk2BgB;EACI,WhDYZ;EC6DL,gB+CxE+C;EAC9B,ehDkUL;ECpOb,kB+C7FmC;AnD2k2BrC;AmD1k2BoB;EACI,iBAAA;AnD4k2BxB;AmDxk2BY;EACI,aAAA;EACA,mBAAA;AnD0k2BhB;AIvk2BI;E+CLQ;IAIQ,cAAA;EnD4k2BlB;AACF;AmD1k2BgB;EACI,cAAA;EACA,oBAAA;EACA,iBAAA;AnD4k2BpB;AmD3k2BoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AnD6k2BxB;AmD1k2BgB;EACI,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AnD4k2BpB;;AI9l2BI;E+CyBA;IAEQ,6BAAA;EnDwk2BV;AACF;;AmDrk2BA;EACI,gBAAA;AnDwk2BJ;AmDvk2BI;EACI,kBAAA;AnDyk2BR;AmDxk2BQ;EACI,yBhD8EA;ECxDT,gB+CrBiC;E/CsBjC,sB+CtB2C;AnD2k2B9C;AmD1k2BY;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,sCAAA;EACA,mBAAA;EACA,gCAAA;EACA,kBAAA;AnD4k2BhB;AmD3k2BgB;EACI,gBhDnFG;EgDoFH,kBAAA;AnD6k2BpB;AmD3k2BgB;EACI,qBAAA;AnD6k2BpB;AmD3k2BgB;EACI,mBAAA;AnD6k2BpB;AmD1k2BY;EACI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,sCAAA;EACA,eAAA;AnD4k2BhB;AmD3k2BgB;EACI,mBAAA;AnD6k2BpB;AmD1k2BY;EACI,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;AnD4k2BhB;AmD3k2BgB;EACI,kBAAA;AnD6k2BpB;AmD1k2BY;EACI,gBAAA;AnD4k2BhB;;AoD1s2BC;EACC,cjD+KS;EiD9KT,eAAA;EACA,gBAAA;EACA,gBjDMqB;AHus2BvB;AoD5s2BE;EACC,iBAAA;ApD8s2BH;AoD3s2BG;EACC,cjDmBK;AH0r2BT;AoDzs2BG;EACC,cjDQM;AHms2BV;AoDvs2BG;EACC,cjDOM;AHks2BV;;AoDps2BA;EACC,yBAAA;EhD4EE,gBgD3EsB;EhD4EtB,sBgD5EgC;EAClC,kBAAA;EhDkGC,kBgDjGgB;ApDws2BlB;AoDvs2BC;EACC,WAAA;EACA,yBjDHO;EiDIP,UAAA;EACA,YAAA;EhD4FA,kBgD3FiB;EhD2DjB,kBgD1DkB;EhD2DlB,MgD3D4B;EhD8D5B,OgD9D2C;ApD2s2B7C;AoDzs2BC;EACC,gBAAA;ApD2s2BF;;AoDxs2BA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;ApD2s2BD;AoD1s2BC;EACC,qBAAA;EACA,qBAAA;ApD4s2BF;AoD3s2BE;EACC,cjDuHQ;EiDtHR,kBAAA;ApD6s2BH;AoDlt2BC;EAOE,cjDyHQ;AHql2BX;AoD5s2BC;EACC,qBAAA;ApD8s2BF;AoD7s2BE;EACC,eAAA;ApD+s2BH;AoD5s2BG;EACC,iBAAA;ApD8s2BJ;;AoDzs2BA;EACC,YAAA;ApD4s2BD;AoD3s2BC;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;ApD6s2BF;AoD5s2BE;EACC,qBAAA;EACA,cjDiGQ;AH6m2BX;AoD7s2BG;EACC,eAAA;ApD+s2BJ;AoD5s2BI;EACC,iBAAA;ApD8s2BL;AoD1s2BI;EACC,iBAAA;ApD4s2BL;AoDxs2BG;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;ApD0s2BJ;AoDzs2BI;EACC,kBAAA;EACA,YAAA;ApD2s2BL;AoD1s2BK;EACC,WAAA;EACA,YAAA;EhDsBJ,kBgDrBqB;ApD4s2BvB;AIzw2BI;EgDyBJ;IA2CE,WAAA;EpDys2BA;AACF;;AoDvs2BA;EACC,kBAAA;ApD0s2BD;AoDzs2BC;EhDvBC,kBgDwBkB;EhDvBlB,QgDuB4B;EhDpB5B,UgDoB6C;EhD7D7C,2BgD8DmB;EhD7DnB,mCgD6DmB;EhD5DnB,+BgD4DmB;EACnB,cAAA;EACA,cjDtGQ;AHqz2BV;AoD7s2BC;EACC,kBAAA;ApD+s2BF;;AoD5s2BA;EACC,mBAAA;ApD+s2BD;AoD9s2BC;EACC,gBjDzHmB;EiD0HnB,kBAAA;ApDgt2BF;AoD9s2BC;EACC,gBjD5HqB;AH402BvB;;AoD5s2BC;EACC,mBAAA;ApD+s2BF;AoD7s2BC;EACC,gBjDrImB;EiDsInB,cjDiCS;EiDhCT,mBAAA;ApD+s2BF;AoD7s2BC;EACC,gCAAA;EACA,mBAAA;ApD+s2BF;;AqDp22BA;EACI,yBAAA;EACA,6DAAA;EACA,kBAAA;EjDoGD,qBiDnGyB;EjDoGzB,aiDpGwC;EACvC,WAAA;EACA,gBAAA;ArDw22BJ;AqDv22BI;EACI,eAAA;ArDy22BR;;AqDr22BI;EACI,WAAA;EACA,YAAA;EACA,mBlDmJI;EkDlJJ,kBAAA;EACA,clD0PM;AH8m2Bd;AqDv22BQ;EACI,mBlDuLC;EkDtLD,cAAA;ArDy22BZ;;AqDl22BY;EACI,gBAAA;ArDq22BhB;;AqD912BI;EACI,uBAAA;EACA,WAAA;EACA,WAAA;ArDi22BR;AqDh22BQ;EACI,WAAA;EACA,WAAA;EACA,kBAAA;ArDk22BZ;AqDj22BY;EACI,mBlDpBN;AHu32BV;AqDj22BY;EACI,mBlDFP;AHq22BT;AqDj22BY;EACI,mBlDxBT;AH232BP;AqDj22BY;EACI,mBlDzBN;AH432BV;AqDj22BY;EACI,mBlDLR;AHw22BR;AqDj22BY;EACI,mBlD7BP;AHg42BT;AqD/12BI;EACI,iBAAA;EACA,clDgHG;EkD/GH,gBlDxDa;AHy52BrB;;AqD712BI;EACI,clDnDE;EkDoDF,gBlD9Da;EkD+Db,mBAAA;EACA,qBAAA;ArDg22BR;AqD/12BQ;EACI,iBAAA;ArDi22BZ;;AqD312BQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6DAAA;EACA,kBAAA;EjDUT,iBiDTuC;EAC9B,gBlDtFS;AHo72BrB;AqD512BgB;EjDPd,yBiDQsC;EjDzCtC,yBiD0CqC;EjDzCrC,iCiDyCqC;EjDxCrC,6BiDwCqC;ArDk22BvC;AqD/12BY;EACI,aAAA;ArDi22BhB;AqD/12BY;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArDi22BhB;AqDh22BgB;EACI,elD+OL;AHmn2Bf;AqD912BQ;EACI,elD8OG;EkD7OH,clDyDD;AHuy2BX;AqD/12BY;EAGG,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ArDi22Bf;AqDh22Be;EACI,eAAA;ArDk22BnB;AqD912BQ;EACI,WAAA;ArDg22BZ;;AqD512BA;EACI,kBAAA;EACA,iBAAA;ArD+12BJ;AqD912BI;EjD9CF,kBiD+CwB;EjD9CxB,QiD8CkC;EjD3ClC,UiD2CmD;EAC7C,cAAA;EACA,2BAAA;EACA,clDgCG;AHk02BX;AqD912BY;EACI,YAAA;EACA,kBAAA;EACA,clDyBL;EkDxBK,gBlD/IK;AH++2BrB;AqD/12BgB;EACI,kBAAA;EACA,iBAAA;EACA,clDoBT;EkDnBS,gBlDpJC;EkDqJD,mBAAA;ArDi22BpB;AqD/12BgB;EACI,YAAA;ArDi22BpB;;AqD312BA;EACI,gCAAA;EACA,mBAAA;ArD812BJ;AqD712BI;EACI,mBAAA;ArD+12BR;AqD912BQ;EACI,qBAAA;ArDg22BZ;AqD912BgB;EACI,4BAAA;ArDg22BpB;AqD512BgB;EACI,gBAAA;ArD812BpB;AqD312BY;EjDlFT,eiDmFqC;EjDlFrC,4BiDkF8C;EACjC,elD0KD;EkDzKC,gBlDlLK;EkDmLL,qBAAA;EACA,kBAAA;EACA,mBlD/BJ;EkDgCI,clD2EF;EkD1EE,kBAAA;EACA,gBAAA;ArD812BhB;AqD712BgB;EACI,WAAA;EjDrGlB,kBiDsGoC;EjDrGpC,MiDqG8C;EjDpG9C,YiDoGgD;EAC9B,WAAA;EACA,YAAA;EACA,6CAAA;EACA,yCAAA;EACA,0CAAA;EACA,sCAAA;EACA,UAAA;EACA,mBlD7CR;EkD+CQ,wEAAA;EACA,2BAAA;ArDi22BpB;AqD/12BgB;EACI,WlDxKZ;AHyg3BR;AqDh22BoB;EACI,mBlD3LjB;AH6h3BP;AqDh22BoB;EACI,8BAAA;ArDk22BxB;AqD/12BgB;EACI,WlDjLZ;AHkh3BR;AqDh22BoB;EACI,mBlDlMd;AHoi3BV;AqDh22BoB;EACI,8BAAA;ArDk22BxB;AqD/12BgB;EACI,WlD1LZ;EkD2LY,8BAAA;ArDi22BpB;AqDh22BoB;EACI,mBlD3Lf;AH6h3BT;AqDh22BoB;EACI,8BAAA;ArDk22BxB;AqD/12BgB;EACI,WlDpMZ;AHqi3BR;AqDh22BoB;EACI,mBlDnMjB;AHqi3BP;AqDh22BoB;EACI,8BAAA;ArDk22BxB;AqD/12BgB;EACI,WlD7MZ;AH8i3BR;AqDh22BoB;EACI,mBlDlOd;AHok3BV;AqDh22BoB;EACI,8BAAA;ArDk22BxB;AqD/12BgB;EACI,WlDtNZ;AHuj3BR;AqDh22BoB;EACI,mBlDrOf;AHuk3BT;AqDh22BoB;EACI,8BAAA;ArDk22BxB;AqD/12BgB;EACI,WlD/NZ;EkDgOY,mBlDYL;AHq12Bf;AqDh22BoB;EACI,mBlDUT;AHw12Bf;AqDh22BoB;EACI,8BAAA;ArDk22BxB;AIrk3BI;EiD4IQ;IA2FQ,wBAAA;ErDk22BlB;AACF;AI1k3BI;EiDgII;IA2GQ,cAAA;ErDm22Bd;AACF;;AsD5n3BA;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;ElD8FE,gBkD7FsB;ElD8FtB,akD9FgC;ElDqHjC,kBkDpHgB;AtDgo3BlB;AI9l3BI;EkD7CJ;IlDuGG,gBkD1FuB;IlD2FvB,akD3FiC;EtDmo3BlC;AACF;AsDlo3BC;EAGC,aAAA;EAGA,mBAAA;AtDoo3BF;AsDno3BE;EACC,WAAA;EACA,YAAA;ElDuGD,kBkDtGkB;EAGjB,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WnDQK;EmDPL,kBAAA;AtDqo3BH;AsDno3BE;EACC,cnD0IQ;EmDzIR,gBnD9BkB;AHmq3BrB;AsDlo3BC;EACC,cnDgIS;AHog3BX;AIno3BI;EkDFH;IAGE,enD6TY;EHy02Bb;AACF;AIxo3BI;EkDFH;IAME,enDwTY;EHg12Bb;AACF;AsDto3BC;EACC,yBnDqJW;AHm/2Bb;AsDvo3BE;EACC,yBnDzBM;AHkq3BT;AsDto3BC;EACC,yBnD0JY;AH8+2Bd;AsDvo3BE;EACC,yBnDvCS;AHgr3BZ;AsDto3BC;EACC,yBnD+JW;AHy+2Bb;AsDvo3BE;EACC,yBnDZQ;AHqp3BX;AsDto3BC;EACC,yBnDyHY;AH+g3Bd;AsDvo3BE;EACC,yBnDtBK;AH+p3BR;;AsDro3BA;ElD0BG,gBkDzBsB;ElD0BtB,oBkD1BgC;EAClC,8DAAA;EACA,sBnDrCO;ECoFN,kBkD9CgB;AtDyo3BlB;AsDvo3BE;EACC,kBAAA;AtDyo3BH;AsDxo3BG;EACC,kBAAA;EACA,gBnD7EiB;EmD8EjB,6BAAA;ElDgBD,uBkDf+B;EAGrB,oBAAA;EAGN,mBAAA;EACH,uBAAA;EACG,+BAAA;EACA,qBAAA;AtD0o3BP;AsDzo3BI;EACC,qBnDhFK;AH2t3BV;AsDzo3BI;EACC,WAAA;EACA,YAAA;EAGS,oBAAA;EAGH,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;ElDaT,kBkDZ0B;EACjB,iBAAA;EACA,enD4OI;EmD3OJ,gBnD3GY;EmD4GZ,cnDqDA;AHsl3BX;AsDxo3BG;EACC,eAAA;AtD0o3BJ;;AsDro3BA;EAGC,oBAAA;EAGA,mBAAA;AtDwo3BD;AsDvo3BG;EACC,kBAAA;EACF,oBAAA;AtDyo3BF;AsDxo3BE;EACC,WAAA;EACA,YAAA;AtD0o3BH;AsDxo3BI;EACC,cAAA;AtD0o3BL;AsDvo3BK;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AtDyo3BN;AsDro3BK;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBnDnHE;EmDoHF,yBAAA;EAGF,oBAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,enD0LW;EmDzLX,gBnD/JmB;EmDgKnB,cnDCO;AHso3BX;;AsDjo3BC;EACC,qBAAA;EACA,kBAAA;AtDoo3BF;AsDno3BE;EACC,gBnD1KoB;AH+y3BvB;AsDno3BE;EACC,eAAA;EACA,gBnD9KoB;EmD+KpB,cnDdQ;AHmp3BX;AsDno3BE;EACC,eAAA;AtDqo3BH;;AuDj03BC;EACC,QAAA;AvDo03BF;;AuDj03BA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AvDo03BD;;AuDl03BA;EACC,aAAA;EACA,mBAAA;AvDq03BD;;AuDl03BA;EACC,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AvDq03BD;;AuDn03BA;EACC,gBAAA;EACA,cAAA;AvDs03BD;;AuDj03BG;EACC,eAAA;AvDo03BJ;;AuD/z3BA;EACC,WAAA;EACA,YAAA;AvDk03BD;;ACty3BA,uBAAA;AuDpEA;EACI,0BAAA;EACA,WAAA;AxD823BJ;AwD723BI;EACI,YAAA;AxD+23BR;;AwD323BI;EACI,yDAAA;EpDsHN,kBoDrHuB;AxD823BzB;AwD723BQ;EACI,crD8PC;EqD7PD,iBAAA;EpDkHV,kBoDjH2B;EACjB,kBAAA;EACA,erDqVG;EqDpVH,gBrDRS;EqDST,mBAAA;AxD+23BZ;AwD923Ba;EAGG,oBAAA;EAGA,mBAAA;AxDg33BhB;AwD/23BgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AxDi33BpB;AwD723BQ;EACI,YAAA;AxD+23BZ;AwD723BQ;EACI,YAAA;EACA,UAAA;AxD+23BZ;;AwD323BA;EpDoDE,kBoDnDoB;EpDoDpB,QoDpD6B;EpDuD7B,SoDvD2C;EACzC,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,QAAA;EpDMF,yCoDLqB;EpDMrB,iDoDNqB;EpDOrB,6CoDPqB;AxDk33BvB;;AwDh33BA;EACI,kBrDZI;EqDaJ,yBAAA;EACA,eAAA;EpD8CD,YoD7C+B;AxDm33BlC;;AwDj33BA;EACI,mBrD1CM;EqD2CN,WrDpBI;AHw43BR;;AwDj33BI;EACI,2BAAA;EACA,qBrDhDE;AHo63BV;;AwDj33BA;EACI,aAAA;AxDo33BJ;;AwDl33BA;;EAEI,6DAAA;AxDq33BJ;;AwDn33BA;;;;;;;EAOI,qBrDiFQ;EqDhFR,crDoLS;EqDnLT,YAAA;EACA,iBAAA;AxDs33BJ;;AwDp33BA;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;AxDu33BJ;AwDt33BI;EACI,iBAAA;EACA,mBAAA;AxDw33BR;AwDr33BQ;EAGI,oBAAA;EAGA,mBAAA;AxDu33BZ;AwDt33BY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AxDw33BhB;AwDp33BI;EACI,QAAA;EACA,UAAA;AxDs33BR;;AwDl33BI;EAGQ,oBAAA;EAGA,mBAAA;AxDq33BZ;AwDp33BY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AxDs33BhB;;AwDl33BA;;;EAGI,yBrDsBQ;EqDrBR,qBrDqBQ;EqDpBR,crDgCO;EqD/BP,kBAAA;AxDq33BJ;;AwDn33BA;EACI,qBrDsBQ;AHg23BZ;;AyDtg4BA;EACI,oBAAA;EACA,sBAAA;AzDyg4BJ;;AyDvg4BA;;;;;EAKI,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBtDNmB;EsDOnB,2BAAA;AzD0g4BJ;;AyDxg4BA;;;;;EAKI,sBAAA;EACA,2BAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBtDvBmB;EsDwBnB,2BAAA;AzD2g4BJ;;AyDxg4BI;EACI,YAAA;AzD2g4BR;;AyDxg4BA;EACI,mBAAA;EACA,etDuTW;EsDtTX,ctDkIO;EsDjIP,gBtDnCmB;AH8i4BvB;;AyDzg4BA;EACI,eAAA;AzD4g4BJ;;AyDxg4BI;EACI,oBAAA;EACA,4BAAA;EACA,kBAAA;AzD2g4BR;AyD1g4BQ;ErD8CL,aqD7CiC;AzD4g4BpC;AyD3g4BY;EACI,gBtDjBR;EsDkBQ,yBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,ctDwGL;AHq63BX;AyD5g4BgB;EACI,mBtDnBZ;EsDoBY,WtD5BZ;AH0i4BR;AyD3g4BY;EACI,mBtDxBR;EsDyBQ,qBtDzBR;EC4EN,kBqDlD+B;EACjB,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzD6g4BhB;AyD3g4BY;EACI,WAAA;EACA,kBAAA;AzD6g4BhB;AyD5g4BgB;EACI,6BAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AzD8g4BpB;AyD7g4BoB;EACI,iBAAA;AzD+g4BxB;AyD7g4BoB;EACI,ctD7ChB;AH4j4BR;AyD3g4BY;EACI,WAAA;EACA,kBAAA;AzD6g4BhB;AyD5g4BgB;EACI,6BAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AzD8g4BpB;AyD7g4BoB;EACI,gBAAA;AzD+g4BxB;AyD7g4BoB;EACI,ctD7DhB;AH4k4BR;AIll4BI;EqDQA;IAiEQ,uBAAA;IACA,+BAAA;IACA,qBAAA;EzD6g4BV;AACF;;AyD1g4BA;;EAEI,2BAAA;AzD6g4BJ;;AyD1g4BI;EAGI,aAAA;EAGA,mBAAA;EACA,ctDkIK;EsDjIL,etD4NO;AHiz3Bf;AyD5g4BQ;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,ctDmCD;EsDlCC,aAAA;AzD8g4BZ;AIhn4BI;EqDoFA;IAiBQ,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,mBAAA;EzD+g4BV;AACF;;AIxn4BI;EqD4GJ;IAEQ,kBAAA;EzD+g4BN;AACF;;AyD5g4BA;EACI,iBAAA;AzD+g4BJ;;AyD7g4BA;EACI,aAAA;AzDgh4BJ;;AyD9g4BA;EACI,aAAA;AzDih4BJ;;AyD/g4BA;EACI,aAAA;AzDkh4BJ;;AyDhh4BA;EACI,aAAA;AzDmh4BJ;;AyDjh4BA;EACI,yBAAA;EACA,kBAAA;AzDoh4BJ;;AyDhh4BQ;EACI,qBtDfA;AHki4BZ;AyDlh4BY;EACI,ctDXL;AH+h4BX;AyDhh4BI;EACI,qBtDtBI;AHwi4BZ;AyDjh4BY;EACI,ctDbL;EsDcK,etDsKD;EsDrKC,gBtDtLK;AHys4BrB;;AyD/g4BA;EACI,cAAA;AzDkh4BJ;;AA/s4BA;EACE,qBAAA;EACA,cAAA;AAkt4BF;;AA/s4BA;EACE,aAAA;AAkt4BF;;AA3s4BQ;EACE,sBAAA;AA8s4BV;AA1s4BM;EACE,eAAA;AA4s4BR;;AAts4BA;EACE,sBAAA;EACA,gBAAA;AAys4BF;;AArs4BA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AAws4BF;;AAps4BA;;EAEE,mBAAA;AAus4BF;;AAns4BA;;EAEE,yBAAA;EACA,WAAA;AAss4BF;;AAns4BA;EACE,sBAAA;AAss4BF;;AAns4BA;EACE,WAAA;EACA,yBAAA;EACA,yBAAA;AAss4BF;;AAls4BA;EACE,aAAA;AAqs4BF;;AAjs4BA;EACE,kBAAA;EACA,eGuRa;EHtRb,gBAAA;EACA,eAAA;EACA,WGpCM;AHwu4BR;;AAjs4BA;EACE,oCAAA;AAos4BF;AAls4BE;EACE,mDAAA;AAos4BJ;AAjs4BE;EACE,oDAAA;AAms4BJ;AAhs4BE;EACE,mDAAA;AAks4BJ;AA/r4BE;EACE,oDAAA;AAis4BJ;AA9r4BE;EACE,oCAAA;AAgs4BJ;;AAxr4BA;EAIE,sBAAA;AAwr4BF;;AAtq4BA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAyq4BF;;AAtq4BA;EACE,MAAA;EACA,gBAAA;AAyq4BF;;AArq4BA;;EAEE,kBAAA;AAwq4BF;;AArq4BA;;EAEE,gBAAA;EACA,qBAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;AAwq4BF;;AArq4BA;EACE,yBAAA;AAwq4BF;;AAtq4BA;EACE,oCAAA;AAyq4BF;;AArq4BA;EACE,uBAAA;AAwq4BF;;AArq4BA;EACE,cAAA;EACA,UAAA;EACA,SAAA;AAwq4BF;;AArq4BA;EACE,UAAA;AAwq4BF;;AArq4BA;EACE,aAAA;EAEA,6BAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAuq4BF;;AApq4BA;EACE,4BAAA;AAuq4BF;;AApq4BA;EACE,aAAA;EACA,eAAA;AAuq4BF;;AApq4BA;EACE,4BAAA;AAuq4BF;;AApq4BA;EACE,yBAAA;EACA,yBAAA;AAuq4BF;;AApq4BA;EACE,yBAAA;AAuq4BF;;AApq4BA;EACE,yBAAA;AAuq4BF;;AAjq4BA;EACE,gBAAA;AAoq4BF;;AAjq4BA;EACE,oCAAA;EACA,gCAAA;AAoq4BF;;AAjq4BA;EACE,gCAAA;AAoq4BF;;AA9p4BA;;;;EAIE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAiq4BF;;AA9p4BA;EACE,aAAA;EACA,mBAAA;AAiq4BF;;AA9p4BA;;EAEE,gCAAA;AAiq4BF;;AA9p4BA;EACE,mBAAA;AAiq4BF;;AA9p4BA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;EACA,6DAAA;AAiq4BF;;AA9p4BA;EACE,aAAA;EACA,mBAAA;AAiq4BF;;AA9p4BA;;EAEE,eAAA;AAiq4BF;;AA9p4BA;EACE,WAAA;AAiq4BF;;AA9p4BA;EACE,qBAAA;EACA,cAAA;EACA,6DAAA;AAiq4BF;;AA9p4BA;EACE,eAAA;AAiq4BF;;AA9p4BA;;EAEE,WAAA;AAiq4BF;;AA9p4BA;EACE,wBAAA;AAiq4BF;;AA9p4BA;EACE,gBAAA;EACA,MAAA;AAiq4BF;;AA9p4BA;EACE,iBAAA;EACA,cAAA;AAiq4BF;;AA9p4BA;EACE,WAAA;AAiq4BF;;AA9p4BA;EACE,sBAAA;AAiq4BF;;AA9p4BA;EACE,kBAAA;AAiq4BF;;AA9p4BA;;EAEE,kBAAA;AAiq4BF;;AA9p4BA;;EAEE,kBAAA;AAiq4BF;;AA9p4BA;;EAEE,UAAA;AAiq4BF;;AA9p4BA;;EAEE,kBAAA;AAiq4BF;;AA9p4BA;;;EAIE,yBAAA;EACA,cAAA;AAgq4BF;;AA7p4BA;;EAEE,cAAA;AAgq4BF;;AA3p4BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AA8p4BF;;AA5p4BA;EACE,aAAA;AA+p4BF;;AA7p4BA;EACE,yBAAA;EACA,kBAAA;AAgq4BF;;AA9p4BA;EACE,kBAAA;AAiq4BF;;AA/p4BA;EACE,cAAA;AAkq4BF;;AAhq4BA;EACE,aAAA;AAmq4BF;;AAjq4BA;;EAEE,yBAAA;AAoq4BF;;AAlq4BA;EACE,yBAAA;AAqq4BF;;AAnq4BA;EACE,qBAAA;AAsq4BF;;AApq4BA;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;AAuq4BF;;AArq4BA;EACE,qBAAA;EACA,6BAAA;AAwq4BF;;AAtq4BA;EACE,qBAAA;AAyq4BF;;AAvq4BA;EACE,qBAAA;EACA,6BAAA;AA0q4BF;;AAvq4BE;EAIE,yBAAA;AAuq4BJ;AArq4BE;;EAQE,qBAAA;AAiq4BJ;AA/p4BE;EAIE,mBAAA;AA8p4BJ;AA5p4BE;EAGE,mBAAA;AA4p4BJ;AA1p4BE;EACE,yBAAA;AA4p4BJ;AA1p4BE;EACE,yBAAA;EACA,yBAAA;AA4p4BJ;AA1p4BE;;EAEE,yBAAA;AA4p4BJ;AAzp4BE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AA2p4BJ;AAzp4BE;EACE,cAAA;AA2p4BJ;AAzp4BE;EACE,oCAAA;AA2p4BJ;AAzp4BE;EACE,yBAAA;AA2p4BJ;AAzp4BE;EACE,8BAAA;AA2p4BJ;AAzp4BE;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;AA2p4BJ;AAzp4BE;EACE,yBAAA;EACA,yBAAA;AA2p4BJ;AAzp4BE;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;AA2p4BJ;AAzp4BE;EACE,yBAAA;AA2p4BJ;AAzp4BE;EACE,yBAAA;AA2p4BJ;;AAtp4BI;EACE,yBAAA;AAyp4BN;;AAnp4BI;EACE,yBAAA;AAsp4BN;;AAhp4BI;EACE,yBAAA;AAmp4BN;;AA/o4BA;EACE,cAAA;AAkp4BF;;AAhp4BA;EACE,yBAAA;AAmp4BF;;AAjp4BA;EACE,yBAAA;AAop4BF;;AAjp4BA;EACE,gBAAA;AAop4BF;;AAlp4BA;EACE,yBAAA;EACA,WAAA;AAqp4BF;;AAnp4BA;EACE,yBAAA;EACA,WAAA;AAsp4BF;;AAnp4BA;EACE,gBAAA;AAsp4BF;;AApp4BA;EACE,gBAAA;AAup4BF;;AArp4BA;EACE,gBAAA;AAwp4BF;;AAtp4BA;EACE,gBAAA;AAyp4BF;;AAvp4BA;EACE,WAAA;AA0p4BF;;AAxp4BA;EACE,gBAAA;AA2p4BF;;AAzp4BA;EACE,gBAAA;AA4p4BF;;AA1p4BA;EACE,yBAAA;EACA,qBAAA;AA6p4BF;;AA3p4BA;;EAEE,kBAAA;EACA,gBAAA;AA8p4BF;;AA5p4BA;EACE,yBAAA;AA+p4BF;;AA7p4BA;EACE,wBAAA;AAgq4BF;;AA9p4BA;EACE,iBAAA;AAiq4BF;;AA/p4BA;EACE,gBAAA;AAkq4BF;;AAhq4BA;EACE,gBAAA;AAmq4BF;;AAjq4BA;EAKE,gBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AAgq4BF;;AA7p4BA;EACE,2BAAA;AAgq4BF;;AA9p4BA;EACE,2BAAA;AAiq4BF;;AA/p4BA;EACE,6BAAA;AAkq4BF;;AAhq4BA;EACE,uBAAA;AAmq4BF;;AAjq4BA;EACE,+CAAA;AAoq4BF;;AAlq4BA;EACE,2BAAA;AAqq4BF;;AAlq4BA;EACE,6BAAA;AAqq4BF;;AAlq4BA;EACE,2BAAA;AAqq4BF;;AAlq4BA;EACE,2BAAA;AAqq4BF;;AAlq4BA;EACE,6BAAA;EACA,cAAA;AAqq4BF;;AAlq4BA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAqq4BF;;AAlq4BA;EACE,WAAA,EAAA,kBAAA;EACA,YAAA,EAAA,mBAAA;EACA,iBAAA,EAAA,kDAAA;EACA,kBAAA,EAAA,2CAAA;EACA,sBAAA,EAAA,iCAAA;AAqq4BF;;AAlq4BA;EACE,YAAA;AAqq4BF","sourcesContent":["@import \"./style/scss/main.scss\";\n@import \"primereact/resources/themes/lara-light-indigo/theme.css\";\n@import \"primeicons/primeicons.css\";\n@import \"primereact/resources/primereact.css\";\n@import \"primereact/resources/themes/lara-light-indigo/theme.css\";\n@import \"react-time-picker/dist/TimePicker.css\";\n@import \"react-clock/dist/Clock.css\";\n@import \"react-datepicker/dist/react-datepicker.css\";\na {\n  text-decoration: none;\n  color: #262a2a;\n}\n\n.ant-tooltip {\n  display: none;\n}\n\n.data-table-card {\n  .ant-table-content {\n    .ant-table-tbody {\n      tr {\n        &:nth-of-type(2n + 1) {\n          background-color: #fff;\n        }\n      }\n\n      td {\n        padding: 0.5rem;\n      }\n    }\n  }\n}\n\n.ant-table-cell-row-hover {\n  background-color: #fff;\n  background: #fff;\n}\n\n//ant datatable pagination\n.ant-pagination-item.ant-pagination-item-1.ant-pagination-item-active {\n  background: #00918e;\n  border-color: #00918e;\n  color: #fff;\n}\n\n// manage columns in datatable page\nh4,\n.h4 {\n  font-size: 1.125rem;\n}\n\n// date range picker\n.daterangepicker td.active,\n.daterangepicker td.active:hover {\n  background-color: #00918e;\n  color: #fff;\n}\n\n.daterangepicker .calendar-table td.in-range {\n  background-color: #fff;\n}\n\n.applyBtn.btn.btn-sm.btn-primary {\n  color: #fff;\n  background-color: #00918e;\n  border: 1px solid #00918e;\n}\n\n// react-select plugin\n.css-1u9des2-indicatorSeparator {\n  display: none;\n}\n\n//compaign data table\ndiv .badge-status {\n  border-radius: 5px;\n  font-size: $font-size-12;\n  padding: 4px 8px;\n  min-width: 64px;\n  color: $white;\n}\n\ndiv .bg-success {\n  background-color: $success !important;\n\n  &.bg-opacity-10 {\n    background-color: rgba($success, 0.1) !important;\n  }\n\n  &.bg-opacity-25 {\n    background-color: rgba($success, 0.25) !important;\n  }\n\n  &.bg-opacity-50 {\n    background-color: rgba($success, 0.5) !important;\n  }\n\n  &.bg-opacity-75 {\n    background-color: rgba($success, 0.75) !important;\n  }\n\n  &.bg-opacity-100 {\n    background-color: rgba($success, 1) !important;\n  }\n}\n\n// compaign page datatable\n// .list-progress {\n//   width: 380px;\n// }\n:where(.css-dev-only-do-not-override-djtmh8).ant-table-wrapper\n  .ant-table-tbody\n  .ant-table-row.ant-table-row-selected\n  > .ant-table-cell {\n  background-color: #fff;\n}\n\n// multi-select\n// .css-1xc3v61-indicatorContainer svg {\n//   display: none;\n// }\n\n// .css-15lsz6c-indicatorContainer svg {\n//   display: none;\n// }\n\n// .css-tj5bde-Svg {\n//   background-color: #F6F6F6;\n//   border-color: #F6F6F6;\n//   color: #6F6F6F;\n//   border-radius: 5px;\n// }\n.css-1p3m7a8-multiValue {\n  background-color: #f6f6f6;\n  border-color: #f6f6f6;\n  color: #6f6f6f;\n  border-radius: 5px;\n}\n\n.stickybar {\n  top: 0;\n  position: sticky;\n}\n\n// select\n.select-details .css-1dimb5e-singleValue,\n.select-details .css-1jqq78o-placeholder {\n  padding-left: 15px;\n}\n\ndiv.css-13cymwt-control,\ndiv.css-t3ipsp-control {\n  min-width: 120px;\n  border-color: #e8e8e8;\n  box-shadow: 0px 4px 4px 0px rgba(219, 219, 219, 0.2509803922);\n  height: 41px;\n  border-radius: 5px;\n}\n\ndiv.css-t3ipsp-control:hover {\n  border-color: transparent;\n}\nspan.p-dropdown-label.p-inputtext span {\n  font-family: \"Noto Sans\", sans-serif;\n}\n\n// datepicker\n.deals-details.react-datepicker__input-container {\n  width: 450px !important;\n}\n\ndiv.react-datepicker-wrapper {\n  display: block;\n  padding: 0;\n  border: 0;\n}\n\nspan.form-icon {\n  z-index: 1;\n}\n\n.img-checked {\n  padding: 10px;\n  // width: 30px;\n  background: rgb(49, 132, 199);\n  color: white;\n  border-radius: 20px;\n  font-weight: bolder;\n  position: relative;\n  /* margin-top: 2px ; */\n}\n\n.section-notes-slider .notes-slider .slick-list .slick-slide div {\n  margin-left: 12px !important;\n}\n\n.page-add-notes {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.visible .input-blocks .css-b62m3t-container .css-1dimb5e-singleValue {\n  margin-left: 25px !important;\n}\n\n[data-layout-mode=\"dark_mode\"] .css-13cymwt-control {\n  background-color: #1d1d42;\n  border: 1px solid#67748E;\n}\n\n[data-layout-mode=\"dark_mode\"] .css-t3ipsp-control {\n  background-color: #1d1d42;\n}\n\n[data-layout-mode=\"dark_mode\"] .css-1nmdiq5-menu {\n  background-color: #1d1d42;\n}\n\n// .bx-microphone:before {\n//   content: \"\\eb89\";\n// }\n.form-sorts.dropdown .radio-btn-items {\n  margin-top: 10px;\n}\n\n.select__control {\n  background-color: #e41f07 !important;\n  border-color: #e41f07 !important;\n}\n\n.select__control:hover {\n  border-color: #e41f07 !important;\n}\n\n// .slick-slide {\n//   margin-right: 5px;\n// }\n.p-dropdown-label.p-inputtext .p-d-flex.p-ai-center img,\n.p-dropdown-item-label .p-d-flex.p-ai-center,\n.p-dropdown-label.p-inputtext .p-clearfix img,\n.p-dropdown-item-label .p-clearfix img {\n  width: 16px;\n  height: 16px;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n\n.p-d-flex.p-ai-center {\n  display: flex;\n  align-items: center;\n}\n\n.p-dropdown-items-wrapper ul.p-dropdown-items,\n.p-dropdown-panel.p-component.p-ripple-disabled.p-connected-overlay-enter-done {\n  z-index: 100000000000 !important;\n}\n\n.swiper-container .slick-list {\n  margin-left: -236px;\n}\n\n.p-dropdown.p-component.p-inputwrapper {\n  height: 42px;\n  line-height: 42px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-color: #e8e8e8;\n  color: #6f6f6f;\n  box-shadow: 0px 4px 4px 0px #dbdbdb40;\n}\n\ndiv.p-clearfix {\n  display: flex;\n  align-items: center;\n}\n\ndiv.p-clearfix span,\nspan.p-dropdown-label.p-inputtext.p-placeholder {\n  font-size: 14px;\n}\n\n.p-dropdown-trigger svg {\n  width: 13px;\n}\n\ndiv.rti--container {\n  border-color: #e8e8e8;\n  color: #6f6f6f;\n  box-shadow: 0px 4px 4px 0px #dbdbdb40;\n}\n\nspan.rti--tag button {\n  font-size: 10px;\n}\n\n.filter-dropdown-menu.dropdown-menu.dropdown-menu-md-end.show,\n.filter-dropdown-menu.dropdown-menu {\n  z-index: 11;\n}\n\nspan.ant-picker-suffix {\n  display: none !important;\n}\n\n.stickybar {\n  position: sticky;\n  top: 0;\n}\n\n.right-user-side.chat-rooms.theiaStickySidebar {\n  max-height: 500px;\n  overflow: auto;\n}\n\n.send-chat.comman-icon i.feather.feather-send {\n  color: #fff;\n}\n\n.chat-footer form {\n  background-color: #fff;\n}\n\n.nav.flex-column.nav-pills.todo-inbox i {\n  margin-right: 10px;\n}\n\n.select-priority .css-1jqq78o-placeholder,\n.select-priority .css-1dimb5e-singleValue {\n  padding-left: 15px;\n}\n\n.form-sort .css-1jqq78o-placeholder,\n.form-sort .css-1dimb5e-singleValue {\n  padding-left: 20px;\n}\n\n.form-sort.select-bluk.space-not-select .css-1jqq78o-placeholder,\n.form-sort.select-bluk.space-not-select .css-1dimb5e-singleValue {\n  padding: 0;\n}\n\n.owl-carousel.folders-carousel.owl-theme .slick-slide > div,\n.owl-carousel.files-carousel.owl-theme .slick-slide > div {\n  margin-right: 10px;\n}\n\n[data-theme=\"dark\"] .ant-table-content table,\n[data-theme=\"dark\"] .ant-table-thead tr th,\n[data-theme=\"dark\"]\n  .ant-pagination.ant-table-pagination.ant-table-pagination-right {\n  background-color: #171724;\n  color: #a3a6a6;\n}\n\n[data-theme=\"dark\"] .table tbody tr td .table-avatar a,\n[data-theme=\"dark\"] td.ant-table-cell {\n  color: #a3a6a6;\n}\n// a#theme-settings i {\n//   color: #262a2a;\n// }\ntd .badge-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.rsw-editor select {\n  display: none;\n}\n.custom-table {\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n}\n.join-contents .slick-slider div.slick-slide > div {\n  margin-right: 10px;\n}\n.custom-react-clr {\n  color: #6f6f6f;\n}\ndiv.popover {\n  z-index: 9999;\n}\ndiv.rc-slider-track,\n.rc-slider-tracks {\n  background-color: #ed5565;\n}\ndiv.rc-slider-handle {\n  border: solid 2px #ed5565;\n}\nspan.rc-slider-dot-active {\n  border-color: #ed5565;\n}\ndiv.rc-slider-handle:active {\n  border-color: #ed5565;\n  box-shadow: 0 0 5px #ed5565;\n  cursor: grabbing;\n}\n.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: #ed5565;\n  box-shadow: 0 0 0 5px #ed5565;\n}\ndiv.rc-slider-handle:hover {\n  border-color: #ed5565;\n}\ndiv.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: #ed5565;\n  box-shadow: 0 0 0 5px #ed5565;\n}\n[data-theme=\"dark\"] {\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper\n    .ant-table-tbody\n    .ant-table-row\n    > .ant-table-cell-row-hover {\n    background-color: #171724;\n  }\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper\n    .ant-table-tbody\n    > tr\n    > th,\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper\n    .ant-table-tbody\n    > tr\n    > td {\n    border-color: #393947;\n  }\n  :where(.css-11xg00t).ant-table-wrapper\n    .ant-table-tbody\n    .ant-table-row\n    > .ant-table-cell-row-hover {\n    background: #171724;\n  }\n  :where(.css-dev-only-do-not-override-11xg00t).ant-table-wrapper\n    .ant-table-thead\n    th.ant-table-column-has-sorters:hover {\n    background: #171724;\n  }\n  .custom-table {\n    border: 1px solid #393947;\n  }\n  .css-13cymwt-control {\n    background-color: #171724;\n    border: 1px solid #393947;\n  }\n  .react-datepicker__month-container,\n  .react-datepicker__header {\n    background-color: #393947;\n  }\n\n  .css-t3ipsp-control {\n    background: #171724;\n    border: 1px solid #393947;\n    color: #a3a6a6;\n  }\n  .css-1dimb5e-singleValue {\n    color: #a3a6a6;\n  }\n  .css-b62m3t-container div.css-1nmdiq5-menu {\n    background-color: #393947 !important;\n  }\n  .react-select-29-listbox {\n    background-color: #393947;\n  }\n  .input-blocks input[type=\"text\"] {\n    background: #1d1d42 !important;\n  }\n  .p-dropdown.p-component.p-inputwrapper {\n    background-color: #171724;\n    border: 1px solid #393947;\n    box-shadow: none;\n  }\n  .p-dropdown-item {\n    background-color: #171724;\n    border: 1px solid #393947;\n  }\n  .rti--container {\n    background-color: #171724;\n    border: 1px solid #393947;\n    box-shadow: none;\n  }\n  .rti--tag {\n    background-color: #171724;\n  }\n  .rti--input {\n    background-color: #171724;\n  }\n}\n[data-sidebar=\"green\"] {\n  .clinicdropdown.theme {\n    a {\n      background-color: #005351;\n    }\n  }\n}\n[data-sidebar=\"blue\"] {\n  .clinicdropdown.theme {\n    a {\n      background-color: #2f0093;\n    }\n  }\n}\n[data-sidebar=\"dark\"] {\n  .clinicdropdown.theme {\n    a {\n      background-color: #28283e;\n    }\n  }\n}\n[data-theme=\"dark\"] .header .header-left .logo img.white-logo {\n  display: block;\n}\n[data-theme=\"dark\"] .chat-footer form {\n  background-color: #28283e;\n}\n[data-theme=\"dark\"] .sidebar .sidebar-menu .clinicdropdown.theme a {\n  background-color: #28283e;\n}\n\n[data-theme=\"dark\"] .rsw-toolbar {\n  background: grey;\n}\ndiv.css-b62m3t-container .react-select__option--is-focused {\n  background-color: #e41f07;\n  color: #fff;\n}\ndiv.css-b62m3t-container .react-select__option--is-selected {\n  background-color: #e41f07;\n  color: #fff;\n}\n\n.submenu .ti-ticket:before {\n  content: \"\\eb3d\";\n}\n.form-icon .ti-search:before {\n  content: \"\\eb1c\";\n}\n.form-icon .ti-calendar:before {\n  content: \"\\ea53\";\n}\ni.ti-trash:before {\n  content: \"\\eb41\";\n}\n[data-theme=\"dark\"] .header .header-left #toggle_btn {\n  color: #fff;\n}\ni.ti-lock:before {\n  content: \"\\eae2\";\n}\ni.ti-bell:before {\n  content: \"\\ea35\";\n}\n[data-theme=\"dark\"] .login-wrapper .form-control {\n  background-color: #ffffff;\n  border-color: #e8e8e8;\n}\n[data-theme=\"dark\"] div.css-13cymwt-control,\n[data-theme=\"dark\"] div.css-t3ipsp-control {\n  border-color: none;\n  box-shadow: none;\n}\n.mini-sidebar.expand-menu .subdrop ~ ul {\n  display: block !important;\n}\n.mini-sidebar .subdrop ~ ul {\n  display: none !important;\n}\n.sidebar .sidebar-menu > ul li .submenu.submenu-two > ul li a {\n  margin-left: 30px;\n}\n.ti.ti-eye:before {\n  content: \"\\ea9a\";\n}\n.ti.ti-user:before {\n  content: \"\\eb4d\";\n}\ndiv.sidebar-themesettings\n  .input-themeselect\n  input[type=\"radio\"]:checked\n  ~ label\n  .checkboxs-theme::before {\n  content: \"\\f00c\";\n  font-family: \"Font Awesome 5 Free\";\n  color: #fff;\n  font-weight: 700;\n  font-size: 10px;\n  right: 4px;\n  position: absolute;\n  top: -16px;\n  z-index: 9;\n}\n\n.ti-check:before {\n  content: \"\\ea5e\" !important;\n}\n.ti-arrow-down:before {\n  content: \"\\ea16\" !important;\n}\n.select-pipeline .react-select__value-container {\n  padding-left: 28px !important;\n}\n.modal-open .offcanvas.offcanvas-end {\n  width: 700px !important;\n}\n.ant-table {\n  font-family: \"Noto Sans\", sans-serif !important;\n}\n.ti-shield:before {\n  content: \"\\eb24\" !important;\n}\n\n.swal2-popup {\n  font-size: 0.75rem !important;\n}\n\n.swal2-title {\n  margin: 0px 20px !important;\n}\n\n.swal2-html-container {\n  margin: 0px 40px !important;\n}\n\n.divider {\n  border-top: 1px solid #dee2e6;\n  margin: 1rem 0;\n}\n\n.profile-image {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n}\n\n.profile-image-rect {\n  width: 50px; /* Set the width */\n  height: 35px; /* Set the height */\n  object-fit: cover; /* Maintain aspect ratio and cover the container */\n  border-radius: 5px; /* Slight rounding for aesthetic purposes */\n  border: 1px solid #ccc; /* Optional: Add a light border */\n}\n\n.fixed-table-width {\n  width: 100px;\n}\n","/****** Utils ******/\n@import \"utils/variables\";\n@import \"utils/mixins\";\n\n\n/****** Layout ******/\n@import \"layout/common\";\n@import \"layout/content\";\n@import \"layout/header\";\n@import \"layout/sidebar\";\n@import \"layout/theme\";\n@import \"layout/theme-settings\";\n@import \"layout/notification\";\n\n/******* Components ******/\n@import \"components/avatar\";\n@import \"components/boostrap\";\n@import \"components/button\";\n@import \"components/badge\";\n@import \"components/border\";\n@import \"components/calendar\";\n@import \"components/chart\";\n@import \"components/call\";\n@import \"components/chat\";\n@import \"components/dropdown\";\n@import \"components/email\";\n@import \"components/file-manager\";\n@import \"components/icons\";\n@import \"components/progress\";\n@import \"components/pagination\";\n@import \"components/font\";\n@import \"components/typography\";\n@import \"components/alerts\";\n@import \"components/popovers\";\n@import \"components/forms\";\n@import \"components/notes\";\n@import \"components/todo\";\n@import \"components/tables\";\n@import \"components/accordion\";\n@import \"components/breadcrumb\";\n@import \"components/cards\";\n@import \"components/tooltips\";\n@import \"components/navs-tabs\";\n@import \"components/ribbon\";\n@import \"components/popup\";\n@import \"components/grid\";\n\n/******* Base *******/\n@import \"base/base\";\n@import \"base/background\";\n\n\n/******* Pages ******/\n@import \"pages/contact\";\n@import \"pages/dashboard\";\n@import \"pages/error\";\n@import \"pages/login\";\n@import \"pages/settings\";\n@import \"pages/report\";\n@import \"pages/activity\";\n@import \"pages/tasks\";\n@import \"pages/analytics\";\n@import \"pages/project\";\n@import \"pages/leads\";\n@import \"pages/campaign\";\n@import \"pages/membership-plans\";\n\n\n/******* Vendors ******/\n@import \"vendors/select2\";\n@import \"vendors/datatables\";\n\n","::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n    border-radius: 50px !important;\n}\n::-webkit-scrollbar-track {\n    background: $gray-300;\n}\n::-webkit-scrollbar-thumb {\n    background: $primary;\n}\n::-webkit-scrollbar-thumb:hover {\n    background: $gray-300;\n}\n.swal2-header{\n    .swal2-title{\n        font-size: $font-size-18;\n    }\n}\n.none{\n    display: none !important;\n}\n.text-red{color: $danger !important;\n}\n.text-green{\n    color: $success !important;\n}\n.input-blocks{\n    input[type=text]{\n        &:focus{\n            border-color: $input-border;\n        }\n    }\n}\n.input-group{\n    .scanner-set {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        background: $primary;\n        border-radius: 5px !important;\n        width: 40px;\n        color: $white;\n        font-weight: $font-weight-semibold;\n        padding: 0;\n        &:hover{\n            background: $title-color;\n        }\n    }\n}\n::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n    border-radius: 50px !important;\n}\n::-webkit-scrollbar-track {\n    background: $gray-300;\n}\n::-webkit-scrollbar-thumb {\n    background: $primary;\n}\n::-webkit-scrollbar-thumb:hover {\n    background: $gray-300;\n}\n.swal2-header{\n    .swal2-title{\n        font-size: $font-size-18;\n    }\n}\n.none{\n    display: none !important;\n}\n.text-red{\n    color: $danger !important;\n}\n.text-green{\n    color: $success !important; \n}\n\n.input-blocks{\n    input[type=text]{\n        &:focus{\n            border-color: $input-border;\n        }\n    }\n}\n.form-sorts {\n    position: relative;\n    & > a {\n        border: 1px solid $light-900;\n        border-radius: 5px;\n        box-shadow: 0px 4px 4px 0px #DBDBDB40;\n        background: $white;\n        font-weight: $font-weight-medium;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        @include margin-padding(null, 9px 21px);               \n        @include respond-below(custom991) {\n            @include margin-padding(null, 9px 12px);\n        }\n        i {\n            margin-right: 8px;\n        }   \n        &:hover {\n            color: $title-color;\n        }\n        &.show {\n            border: 1px solid #0092E4;\n        }  \n        @include respond-below(custom575) {\n            width: 100%;\n        }  \n    }\n    .filter-dropdown-menu {\n        padding: 24px;\n        border-radius: 5px;\n        background: $white;\n        border: 1px solid $light-900;\n        box-shadow: 0px 4px 24px 0px #BCBCBC40;\n        position: absolute;\n        z-index: 1;\n        min-width: 400px;\n        right: 0;\n        top: 40px;\n        @include respond-below(custom767) {\n            min-width: 270px;\n        }\n        @include respond-below(custom575) {\n            right: unset;\n            left: 0;\n        }\n    }\n    &.table-filter-show {\n        .filter-dropdown-menu {\n            display: block;\n            opacity: 1;\n        }\n    }\n    .filter-set-head {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        margin-bottom: 14px;\n        h4 {\n            margin-bottom: 10px;\n            i {\n                margin-right: 8px;\n            }\n            @include respond-below(custom991) {\n                font-size: $font-size-16;\n            }\n        }\n        a {\n            color: $purple;\n            margin-bottom: 10px;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .filter-set-content {\n        margin-bottom: 24px;\n        .filter-set-content-head {\n            a {\n                display: flex;\n                align-items: center;\n                color: $gray-900;\n                font-weight: $font-weight-semibold;\n                position: relative;\n                padding-left: 16px;\n                &::before {\n                    content: \"\\f054\";\n                    font-family: 'Font Awesome 5 Free';\n                    @include position(absolute, 50%, null, null, 0);\n                    @include transform(translateY(-50%));\n                    font-size: $font-size-14;\n                } \n                &:not(.collapsed) {  \n                    padding-left: 20px;                  \n                    &::before {\n                        content: \"\\f078\";\n                    }\n                }\n            }\n        }\n    }\n    .filter-reset-btns {\n        a {\n            padding: 6px 10px;\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n            border-radius: 5px;\n            width: 100%;\n            @include respond-below(custom575) {\n                padding: 10px 30px;\n            }\n        }\n        .btn-light {\n            background: $light-400;\n            border: 1px solid $light-900;\n        }\n    }\n}\n.radio-btn-items {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-bottom: 14px;\n    .radio-btn {\n        margin: 0 30px 10px 0;\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n.filter-set-contents {\n    .filter-content-list {\n        background: $light-200;\n        border-radius: 5px;\n        padding: 15px;\n        margin-top: 15px;\n        .form-wrap {\n            margin-bottom: 15px;\n            .form-control {\n                max-width: 100%;\n            }\n        }\n        ul {\n            max-height: 150px;\n            overflow-y: auto;\n            padding: 1px 0;\n            &::-webkit-scrollbar {\n                width: 3px;\n                background: $primary;\n                height: 1px;\n            }\n            &::-webkit-scrollbar-track {\n                box-shadow: inset 0 0 5px rgb(231, 231, 231); \n                border-radius: 4px;\n            }\n            &::-webkit-scrollbar-thumb {\n                background: $primary; \n                border-radius: 4px;\n            }\n            li {\n                position: relative;\n                display: flex;\n                margin-bottom: 15px;\n                &:last-child {\n                    margin-bottom: 0;\n                }\n                .checkboxs {\n                    padding-left: 0;\n                    display: flex;\n                    align-items: center;\n                }\n                .checkboxs .checkmarks {\n                    position: relative;\n                    top: 0;\n                    margin-right: 5px;\n                    display: flex;\n                }\n                .rating {\n                    margin-left: 0;\n                    i {\n                        color: $light-900;\n                        &.filled {\n                            color: $warning;\n                        }\n                    }\n                    span {\n                        margin-left: 5px;\n                    }\n                }\n                .collapse-inside-text {\n                    margin-left: 0;\n                    h5 {\n                        margin-bottom: 0;\n                        font-size: $font-size-14;\n                        font-weight: $font-weight-normal;\n                    }\n                }\n            }\n        }\n    }\n}\n\n","// Font import\n@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap');\n\n// Base Font\n$font-size-base: 14px;\n$font-size-sm: $font-size-base * .875;\n$font-size-lg: $font-size-base * 1.25;\n$font-weight-lighter: lighter;\n$font-weight-light: 300;\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n$font-weight-bolder: bolder;\n\n// Font Family\n$font-family-primary: \"Noto Sans\", sans-serif;\n$font-awesome: \"Fontawesome\";\n\t\n// Theme Colors Variables\n$primary: #E41F07;\n$primary-hover: darken($primary, 10%);\n$secondary: #FFA201;\n$secondary-hover: darken($secondary, 10%);\n$success: #5CB85C;\n$success-hover: darken($success, 10%);\n$info: #1ECBE2;\n$info-hover: darken($info, 10%);\n$warning: #FDA700;\n$warning-hover: darken($warning, 10%);\n$danger: #FC0027;\n$danger-hover: darken($danger, 10%);\n$dark: #171724;\n$dark-border: #393947;\n$dark-text: #a3a6a6;\n$dark-textcolor: #B5B5B5;\n$dark-hover: darken($dark, 10%);\n$darkmode-hover: #28283D;\n$dark-input: #1A1A25;\n$dark-bg: #1E1E2D;\n$gray-bg: #28283E;\n$light: #FDFDFE;\n$light-hover: darken($light, 10%);\n$white: #FFF;\n$black: #000;\n$purple: #4A00E5;\n$pink: #EA00B7;\n$blue: #339DFF;\n$teal: #02a8b5;\n$violet: #676DFF;\n$cyan: #299cdb;\n$green: #00918E;\n$orange: #FF9D0A;\n$indigo: #0092E4;\n$indigo-hover: darken($indigo, 10%);\n$tertiary: #3C2371;\n$yellow: #ffff00;\n\n// Primary\n$primary-100: #FCE9E6;\n$primary-200: #FAD2CD;\n$primary-300: #F7BCB5;\n$primary-400: #F4A59C;\n$primary-500: #F28F83;\n$primary-600: #EF796A;\n$primary-700: #EC6251;\n$primary-800: #E94C39;\n$primary-900: #E73520;\n\n// Secondary\n$secondary-100: #FFF6E6;\n$secondary-200: #FFECCC;\n$secondary-300: #FFE3B3;\n$secondary-400: #FFDA99;\n$secondary-500: #FFD180;\n$secondary-600: #FFC767;\n$secondary-700: #FFBE4D;\n$secondary-800: #FFB534;\n$secondary-900: #FFAB1A;\n\n// Tertiary\n$tertiary-100: #ECE9F1;\n$tertiary-200: #D8D3E3;\n$tertiary-300: #C5BDD4;\n$tertiary-400: #B1A7C6;\n$tertiary-500: #9E91B8;\n$tertiary-600: #8A7BAA;\n$tertiary-700: #77659C;\n$tertiary-800: #634F8D;\n$tertiary-900: #50397F;\n\n// Green\n$green-100: #E6F4F4;\n$green-200: #CCE9E8;\n$green-300: #B3DEDD;\n$green-400: #99D3D2;\n$green-500: #80C8C7;\n$green-600: #66BDBB;\n$green-700: #4DB2B0;\n$green-800: #33A7A5;\n$green-900: #1A9C99;\n\n// Blue\n$blue-100: #EBF5FF;\n$blue-200: #D6EBFF;\n$blue-300: #C2E2FF;\n$blue-400: #ADD8FF;\n$blue-500: #99CEFF;\n$blue-600: #85C4FF;\n$blue-700: #70BAFF;\n$blue-800: #5CB1FF;\n$blue-900: #47A7FF;\n\n// Orange\n$orange-100: #FFF5E7;\n$orange-200: #FFEBCE;\n$orange-300: #FFE2B6;\n$orange-400: #FFD89D;\n$orange-500: #FFCE85;\n$orange-600: #FFC46C;\n$orange-700: #FFBA54;\n$orange-800: #FFB13B;\n$orange-900: #FFA723;\n\n// Pink\n$pink-100: #FDE6F8;\n$pink-200: #FBCCF0;\n$pink-300: #F9B3E9;\n$pink-400: #F799E2;\n$pink-500: #F580DB;\n$pink-600: #F266D3;\n$pink-700: #F04DCC;\n$pink-800: #EE33C5;\n$pink-900: #EC1ABD;\n\n// Violet\n$violet-100: #F0F0FF;\n$violet-200: #E1E2FF;\n$violet-300: #D1D3FF;\n$violet-400: #C2C5FF;\n$violet-500: #B3B6FF;\n$violet-600: #A4A7FF;\n$violet-700: #9599FF;\n$violet-800: #858AFF;\n$violet-900: #767CFF;\n\n// Indigo\n$indigo-100: #E6F4FC;\n$indigo-200: #CCE9FA;\n$indigo-300: #B3DEF7;\n$indigo-400: #99D3F4;\n$indigo-500: #80C9F2;\n$indigo-600: #66BEEF;\n$indigo-700: #4DB3EC;\n$indigo-800: #33A8E9;\n$indigo-900: #1A9DE7;\n\n// Light\n$light-100: #FAFAFA;\n$light-200: #F9F9FC;\n$light-300: #F6F6F6;\n$light-400: #F5F5F5;\n$light-500: #F6F6F6;\n$light-600: #F4F4F4;\n$light-700: #F2ECFF;\n$light-800: #EAEAEA;\n$light-900: #E8E8E8;\n\n// Gray\n$gray-100: #C0C0C0;\n$gray-200: #9B9B9B;\n$gray-300: #898989;\n$gray-400: #6F6F6F;\n$gray-500: #6F7A7A;\n$gray-600: #565E5E;\n$gray-700: #424848;\n$gray-800: #323737;\n$gray-900: #262A2A;\n\n// Info\n$info-100: #E9FAFC;\n$info-200: #D2F5F9;\n$info-300: #BCEFF6;\n$info-400: #A5EAF3;\n$info-500: #8FE5F1;\n$info-600: #78E0EE;\n$info-700: #62DBEB;\n$info-800: #4BD5E8;\n$info-900: #35D0E5;\n\n// Success\n$success-100: #EFF8EF;\n$success-200: #E0F5D7;\n$success-300: #CEEACE;\n$success-400: #BEE3BE;\n$success-500: #AEDCAE;\n$success-600: #9DD49D;\n$success-700: #8DCD8D;\n$success-800: #7DC67D;\n$success-900: #6CBF6C;\n\n// Danger\n$danger-100: #FFEEEC;\n$danger-200: #FECCD4;\n$danger-300: #FEB3BE;\n$danger-400: #FE99A9;\n$danger-500: #FE8093;\n$danger-600: #FD667D;\n$danger-700: #FD4D68;\n$danger-800: #FD3352;\n$danger-900: #FC1A3D;\n\n// Warning\n$warning-100: #FFF7D8;\n$warning-200: #FFEDCC;\n$warning-300: #FEE5B3;\n$warning-400: #FEDC99;\n$warning-500: #FED380;\n$warning-600: #FECA66;\n$warning-700: #FEC14D;\n$warning-800: #FDB933;\n$warning-900: #FDB01A;\n\n// Purple\n$purple-100: #F3EDFF;\n$purple-200: #DBCCFA;\n$purple-300: #C9B3F7;\n$purple-400: #B799F5;\n$purple-500: #A580F2;\n$purple-600: #9266EF;\n$purple-700: #804DED;\n$purple-800: #6E33EA;\n$purple-900: #5C1AE8;\n\n\n\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n);\n\n$theme-colors: (\n    \"primary\": $primary,\n    \"secondary\": $secondary,\n    \"success\": $success,\n    \"info\": $info,\n    \"warning\": $warning,\n    \"danger\": $danger,\n    \"dark\": $dark,\n    \"light\": $light,\n    \"black\": $black,\n    \"purple\": $purple,\n    \"yellow\": $yellow,\n    \"teal\": $teal\n);\n\n$text-color: #6F6F6F;\n$title-color: #262A2A;\n$sub-title: #B8BCC9;\n$body-bg: #F9F9FC;\n$wrapper-bg: #f1f5f6;\n$text-muted: #9595b5;\n$default-background: #f7f8f9;\n$black-bg: #141432;\n$card-dark-bg: #1d1d42;\n$navy: #353570;\n$theme-title: #97A2D2;\n$input-bg: #2c2c50;\n$form-control-bg: #ffffff;\n$background-3: #E0E2E7;\n\n// Social Icons Colors\n$facebook: #3B5998;\n$twitter: #00ACEE;\n$google: #DD4B39;\n$telegram: #0088CC;\n$linkedin: #0E76A8;\n$youtube: #C4302B;\n$instagram: #3F729B;\n$reddit: #C6C6C6;\n$pinterest: #cc2127;\n$vk: #2B587A;\n$rss: #EE802F;\n$skype: #00AFF0;\n$xing: #126567;\n$tumblr: #34526F;\n$email: #6567A5;\n$delicious: #205CC0;\n$stumbleupon: #F74425;\n$digg: #191919;\n$blogger: #FC4F08;\n$flickr: #FF0084;\n$vimeo: #86C9EF;\n$yahoo: #720E9E;\n$gplus: #DD4B39;\n$appstore: #000;\n\n// Gradient Variables\n$primary-gradient: linear-gradient(to right, $primary 0%, #8e77fa 100%);\n$secondary-gradient: linear-gradient(to right, $secondary 0%, #28b7f9 100%);\n$success-gradient: linear-gradient(to right,$success 0%, #5cf9e2 100%);\n$warning-gradient: linear-gradient(to right, $warning 0%, #fbc434 100%);\n$danger-gradient: linear-gradient(to right,$danger 0%, #fd4a68  100%);\n$info-gradient: linear-gradient(to right, $info 0%, #00f2fe  100%);\n$pink-gradient: linear-gradient(to right, $pink 0%, #FFA795 100%);\n$teal-gradient: linear-gradient(to right, $teal 0%, #0695DD 100%);\n$orange-gradient: linear-gradient(to right,$orange 0%,#FBB034 100%);\n$purple-gradient: linear-gradient(to right, $purple 0%, #9b25b7 100%);\n$light-gradient: linear-gradient(to right, $light 0%, #D1D6DE 100%);\n$dark-gradient: linear-gradient(to right, $dark 0%, #54505D 100%);\n\n// Style Anchor Elements\n$link-color: $primary;\n$link-decoration: none;\n$link-shade-percentage: 20%;\n$link-hover-color: darken($link-color, 10%);\n$link-hover-decoration: null;\n$spacer: 1rem;\n\n// Border\n$border-width: 1px;\n$border-style: solid;\n$border-color: $light-900;\n$default-border: $light-900;\n$input-border: $light-900;\n\n// Border Radius\n$border-radius: 4px;\n$border-radius-sm: 3px;\n$border-radius-lg: 5px;\n$border-radius-xl: 8px;\n$border-radius-xxl: 12px;\n$rounded: 50%;\n$rounded-pill: 1.5rem;\n\n// Box Shadow\n$box-shadow: 0px 4px 54px 0px #E0E0E040;\n$box-shadow-sm: 0px 4px 74px 0px #D0D0D040;\n$box-shadow-lg: 0 5px 10px rgba(30, 32, 37, 0.12);\n\n// Font Size\n$font-size-8: 8px;\n$font-size-9: 9px;\n$font-size-10: 10px;\n$font-size-11: 11px;\n$font-size-12: 12px;\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-15: 15px;\n$font-size-16: 16px;\n$font-size-18: 18px;\n$font-size-20: 20px;\n$font-size-22: 22px;\n$font-size-24: 24px;\n$font-size-26: 26px;\n$font-size-28: 28px;\n$font-size-30: 30px;\n$font-size-32: 32px;\n$font-size-34: 34px;\n$font-size-36: 36px;\n$font-size-40: 40px;\n$font-size-42: 42px;\n$font-size-50: 50px;\n$font-size-54: 54px;\n$font-size-60: 60px;\n\n$h1-font-size: 28px;\n$h2-font-size: 24px;\n$h3-font-size: 20px;\n$h4-font-size: 18px;\n$h5-font-size: 16px;\n$h6-font-size: 14px;\n\n","$breakpoints: (\n  custom575: 575.98px,\n  custom767: 767.98px,\n  custom768: 768px,\n  custom991: 991.98px,\n  custom992: 992px,\n  custom1199: 1199.98px,\n  custom1399: 1399.98px,\n  custom1280: 1280px,\n);\n\n// Respond Above\n\n@mixin respond-above($breakpoint) {\n\n  // If the breakpoint exists in the map.\n  @if map-has-key($breakpoints, $breakpoint) {\n\n    // Get the breakpoint value.\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n    // Write the media query.\n    @media (min-width: $breakpoint-value) {\n      @content;\n    }\n\n  // If the breakpoint doesn't exist in the map.\n  } @else {\n\n    // Log a warning.\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\n  }\n}\n\n// Respond Above\n\n@mixin respond-below($breakpoint) {\n\n  // If the breakpoint exists in the map.\n  @if map-has-key($breakpoints, $breakpoint) {\n\n    // Get the breakpoint value.\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n    // Write the media query.\n    @media (max-width: $breakpoint-value) {\n      @content;\n    }\n\n  // If the breakpoint doesn't exist in the map.\n  } @else {\n\n    // Log a warning.\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\n  }\n}\n\n@mixin transform($property) {\n  transform: $property;\n  -webkit-transform: $property;\n  -ms-transform: $property;\n}\n\n// Define vertical, horizontal, or both position\n\n@mixin position-alignment($position) {\n  position: absolute;\n  @if $position == 'vertical' {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n  }\n  @else if $position == 'horizontal' {\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translate(-50%);\n  }\n  @else if $position == 'both' {\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n  }\n}\n\n@mixin transition($property) {\n  -webkit-transition: $property;\n  -ms-transition: $property;\n  transition: $property;\n}\n\n@mixin position($position-value,$top-value,$right-value,$bottom-value,$left-value){\n  position: $position-value;\n  top: $top-value;\n  right: $right-value;\n  bottom: $bottom-value;\n  left: $left-value;\n}\n\n@mixin margin-padding($margin, $padding) {\n   margin: $margin;\n   padding:$padding;\n}\n\n@mixin placeholder-color($color) {\n  &::-webkit-input-placeholder { /* WebKit browsers */\n      color: $color;\n      opacity: 1;\n  }\n  &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */\n      color: $color;\n      opacity: 1;\n  }\n  &::-moz-placeholder { /* Mozilla Firefox 19+ */\n      color: $color;\n      opacity: 1;\n  }\n  &:-ms-input-placeholder { /* Internet Explorer 10+ */\n      color: $color;\n      opacity: 1;\n  }\n}\n\n@mixin rounded($unit) {\n  border-radius: $unit;\n}\n\n@mixin transform-origin($property) {\n  transform-origin: $property;\n  -webkit-transform-origin: $property;\n  -ms-transform-origin: $property;\n}\n\n@mixin box-shadow($inset:inset,$horizontaloffset:10px,$verticaloffset:10px,$blur:10px,$spread:10px,$color: #000000) {\n  -webkit-box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\n  -moz-box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\n  box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\n}\n\n%animation-effect {   \n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n  -o-transition: all 0.5s;\n  transition: all 0.5s;\n}\n",".page-wrapper {\n    @include transition(all 0.5s ease);\n    @include margin-padding( 0 0 0 276px, 56px 0 0);\n    @include position(relative,null,null,null,0);\n    @include transition(all 0.2s ease);\n    @include respond-below(custom991) {\n        @include margin-padding( 0 , 60px 0 0);\n    }\n    .content {\n        @include margin-padding(null, 24px);\n        padding-bottom: 0;\n        @include respond-below(custom991) {\n            @include margin-padding(null, 15px 15px 0);\n        }\n    }\n}\n",".header {\n    height: 56px;\n    z-index: 999;\n    background: $white;\n    @include position(fixed,0,0,null,0);\n    @include transition(all 0.5s ease);\n    .flag-nav {\n        > a {\n            img {\n                border-radius: 50%;\n                width: 22px;\n                height: 22px;\n            }\n        }\n    }\n    .searchinputs {\n        @include margin-padding(null,  0);\n        position: relative;\n        input {\n            width: 335px;\n            height: 42px;\n            border: 1px solid $light-300;\n            background: $light-300;\n            padding: 5px 10px;\n            padding-right: 35px;\n            border-radius: $border-radius-lg;\n            color: $gray-900;\n            @include respond-below(custom1199) {\n                width: 170px;\n            }\n            &::placeholder {\n                color: $gray-400;\n            }\n        }   \n        .search-addon {\n            button {\n                z-index: 9;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                @include rounded(5px);\n                cursor: pointer;\n                background: transparent;\n                border: 0;\n                padding: 0;\n                color: $gray-900;\n                @include position(absolute,50%,16px,null,null);\n                @include transform(translateY(-50%));\n            }\n        }\n    }\n    .dropdown-menu {\n        @include respond-above(custom992) {\n            top: 85px;\n            right: 0;\n            left: auto;\n            min-width: 200px;\n            visibility: hidden;\n            opacity: 0;\n            border: 0;\n            display: block;\n            border-radius: $border-radius-lg;\n            box-shadow: $box-shadow-sm;\n            @include margin-padding(0, 0);\n            @include transition(all 0.4s ease);\n            @include transform(translateY(20px));\n        }\n        @include respond-below(custom991) {\n            transition: none;\n        }\n    }\n    .dropdown-menu.show {\n        visibility: visible;\n        opacity: 1;\n        margin-top: 8px !important;\n        @include transform(translateY(0));\n        @include transition(all 0.4s ease);\n    }\n    .header-left {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        float: left;\n        height: 56px;\n        position: relative;\n        text-align: center;\n        width: 276px;\n        z-index: 1;\n        background: $white;\n        @include margin-padding(null, 0 15px);\n        @include transition(all 0.5s ease);\n        .logo {\n            display: inline-block;\n            line-height: 0;\n            img{\n                width: 130px;\n                display: block;\n                &.white-logo{\n                    display: none;\n                }\n            }\n            @include respond-below(custom991) {\n                text-align: center;\n                width: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                img{\n                    width: 140px;\n                }\n            }\n        }\n        .logo-small{\n            display: none;\n        }\n        @include respond-below(custom991) {\n            position: absolute;\n            width:100%;\n        }\n    }\n\n    @include respond-below(custom991) {\n       .header-left {\n        #toggle_btn {\n            display: none;\n        }\n       }\n    }\n    @include respond-above(custom991) {\n        #toggle_btn {\n            font-size: $font-size-18;\n            padding: 4px;\n            border-radius:6px;\n            .bar-icon {\n                display: inline-block;\n                width: 21px;\n                span {\n                    background-color: $white;\n                    display: block;\n                    float: left;\n                    height: 2px;\n                    width: 21px;\n                    @include margin-padding(0 0 5px, null);\n                    @include rounded(50px);\n                    &:nth-child(2) {\n                        width: 15px;\n                    }\n                }\n            }\n        }\n    }\n    .bar-icon {\n        display: inline-block;\n        width: 31px;\n        margin-top: 20px;\n        span {\n            background-color: $primary;\n            display: block;\n            float: left;\n            height: 3px;\n            margin-bottom: 7px;\n            width: 31px;\n            border-radius: 2px;\n            transition: all 0.5s;\n            &:nth-child(2) {\n                width: 16px;\n            }\n        }\n    }\n    .menu-opened{\n        .slide-nav{\n            .bar-icon {\n                display: inline-block;\n                width: 31px;\n                margin-top: 20px;\n                span {\n                    &:first-child {\n                        position: relative;\n                        top: 10px;\n                        @include transform(rotate(45deg));\n                     }\n                    &:nth-child(2) {\n                       display:none;\n                    }\n                    &:last-child {\n                        @include transform(rotate(135deg));\n                     }\n                }\n            } \n        }\n    }\n    .menus-info {\n        min-width: 500px;\n        border-radius: $border-radius-lg;\n        padding: 8px;\n        @include respond-below(custom1199) {\n            min-width: 430px;\n        }\n        .menu-list {\n            li {\n                margin-bottom: 0;\n                margin-right: 0;\n                a {\n                    display: block;\n                    padding: 8px;\n                    background: $white;\n                    border-radius: $border-radius-lg;\n                    &:hover {\n                        background: $light-300;\n                    }\n                    .menu-details {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        .menu-list-icon {\n                            font-size: $font-size-18;\n                            color: $white;\n                            width: 36px;\n                            min-width: 36px;\n                            height: 36px;\n                            padding: 5px;\n                            margin-right: 8px;\n                            border-radius: $border-radius-lg;\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            justify-content: center;\n                            -webkit-justify-content: center;\n                            -ms-flex-pack: center;\n                        }\n                        .menu-details-content {\n                            p {\n                                font-weight: $font-weight-semibold;\n                                color: $gray-900;\n                                margin-bottom: 0;\n                            }\n                            span {\n                                font-weight: $font-weight-normal;\n                                color: $text-color;\n                                @include respond-below(custom1199) {\n                                    font-size: $font-size-13;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .profilename {\n        @include margin-padding(null, 0px);\n        .profileset {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            @include margin-padding(null, 10px 10px 3px);\n            h6 {\n                font-size: $font-size-base;\n                color: $secondary;\n                font-weight: $font-weight-medium;\n            }\n            h5 {\n                font-size: $font-size-base;\n                color: $gray-600;\n            }\n            .profilesets {\n                margin-left: 10px;\n            }\n            .user-img img {\n                margin-top: 0;\n            }\n        }\n    }\n    .show{\n        .user-info {\n            &::after{\n                transform: rotate(-140deg);\n                top: 10px;\n            }  \n        }\n    }\n    \n    .user-info {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        position: relative;\n        padding: 0;\n        span {\n            &.user-detail {\n                @include respond-below(custom1199) {\n                    display: none;\n                }\n            }\n        }\n        &::after {\n            content: \"\";\n            width: 8px;\n            height: 8px;\n            border-top: 0;\n            border-left: 0;\n            border-right: 2px solid #1B2950;\n            border-bottom: 2px solid #1B2950;\n            border-radius: 1px;\n            transform: rotate(45deg);\n            transition: all 0.5s;\n            top: 8px;\n            position: absolute;\n            right: 12px;\n            display: none;\n            @include respond-below(custom1199) {\n                top:  12px;\n            }\n        }\n      .user-role {\n        display: block;\n        color: #67748E;\n        font-size: 12px;\n      }\n      .user-letter {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        color: $white;\n        width: 36px;\n        height: 36px;\n        border-radius: $border-radius-lg;\n        font-weight: $font-weight-semibold;\n        font-size: $font-size-15;\n        margin-right: 0;\n        @include respond-below(custom1199) {\n            margin-right: 0;\n        }\n        img {\n            border-radius: $border-radius-lg;\n        }\n      }\n      .user-name {\n        font-size: $font-size-15;\n        font-weight: $font-weight-semibold;\n        color: #1B2950;\n        display: flex;\n        align-items: center;\n      }\n      .user-name img {\n        margin-left: 10px;\n      }\n    }\n    .header-user {\n        padding: 15px 24px;\n        display: contents;\n        .user-menu {\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin: 0;\n            position: relative;\n            height: 100%;\n            border-bottom: 0;\n            padding:0 24px;\n            @include transition(all 0.5s ease);\n            @include respond-below(custom991) {\n                display: none;\n            }\n            .status {\n                position: absolute;\n                content: \"\";\n                background: $primary;\n                width: 10px;\n                height: 10px;\n                border-radius: 50px;\n                top: 3px;\n                right: 3px;\n            }\n            .header-title{\n                h3{\n                    font-size: 24px;\n                    font-weight: 700;\n                }\n                h6{\n                    font-size: 12px;\n                    font-weight: 600;\n                }\n            }\n            > li {\n                margin-left: 10px;\n                margin-inline-end: 0;\n                &:first-child{\n                    margin-left:0;\n                }\n                @include respond-below(custom1199) {\n                    margin-left: 8px;\n                }\n                svg {\n                    width: 18px;\n                    color: #67748E;            \n                }\n                a:hover{\n                    svg {\n                        color: $primary;\n                    }\n                }\n            }\n            .dropdown-toggle{\n                &::after {\n                    border: 0;\n                    display: none;\n                }\n            }\n            .nav-searchinputs {\n                margin-right: auto;\n                margin-left: 25px;\n            }\n            .nav-item-box > a {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                background: $light-300;\n                color: $gray-900;\n                border-radius: $border-radius-lg;\n                width: 36px;\n                height: 36px;\n                position: relative;\n                border: 0;\n                &:hover {\n                    background: $light-800;\n                }\n            }\n            .nav-item-email {\n                &.nav-item-box {\n                    margin-left: 15px;\n                }\n            }\n            &.nav{\n               > li{\n                >  a{\n                    padding: 0;\n                    display: flex;\n                    line-height: normal;\n                    color: #3E4265;\n                    &.btn-header-list{\n                        color: $white;\n                        width: 36px;\n                        height: 36px;\n                        display: flex;\n                        align-items: center;\n                        justify-content: center;\n                        border-radius: $border-radius-lg;\n                    }\n                    .badge {\n                        color: $white;\n                        font-weight: $font-weight-bold;\n                        @include position(absolute,4px,4px,null,null);\n                        background: $primary;\n                        width: 15px;\n                        height: 15px;\n                        font-size: $font-size-10;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n                    }\n                    i {\n                        font-size: $font-size-18;\n                    }\n                    .badge-success {\n                        background: $success;\n                        border: 3px solid #FFF;\n                        padding: 0;\n                        top: inherit;\n                        bottom: -3px;\n                        right: -3px;\n                    }\n                }\n                &.flag-nav{\n                     a{\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        .dropdown-menu {\n                            max-height: 150px;\n                            min-width: 120px;\n                            overflow-y: auto;\n                            .dropdown-item {\n                                @include margin-padding(null, 5px 15px);\n                            }\n                        }\n                    }\n                    .dropdown-menu {\n                        padding: 15px;\n                        min-width: 210px;\n                        .dropdown-item {\n                            @include margin-padding(null, 10px 10px);\n                            color: #67748E;                    \n                            border-radius: 10px;\n                            transition: none;\n                            &.active{\n                                color: $white;\n                            }\n                            &.active,&:hover{\n                                background: #F7F7F7  no-repeat calc(100% - 12px) center;\n                            }\n                        }\n                        a{\n                            img{\n                                width: 20px;\n                                height: 20px;\n                                border-radius: 50%;\n                                margin-right: 10px;\n                            }\n                        }\n                    }\n                }\n                }\n            }\n        }\n    }\n    .page-title-box {\n        float: left;\n        height: 60px;\n        margin-bottom: 0;\n        @include margin-padding(null, 17px 20px);\n        @include rounded(0);\n        @include respond-below(custom991) {\n            display: none;\n        }\n        a {\n            color: $primary;\n            font-size: $font-size-11;\n            font-weight: $font-weight-bold;\n            border: 1px solid $primary;\n            @include margin-padding(0, 5px);\n            @include rounded(5px);\n            &:hover{\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n    .mobile_btn {\n        display: none;\n        float: left;\n        @include respond-below(custom991) {\n            color: $primary;\n            font-size: $font-size-24;\n            height: 60px;\n            line-height: 60px;\n            width: 60px;\n            z-index: 10;\n            @include margin-padding(null, 0 20px);\n            @include position(absolute,0,null,null,0);\n            display: block;\n        }\n       \n    }\n    .responsive-search {\n        display: none;\n        color: $white;\n        font-size: $font-size-20;\n        height: 60px;\n        line-height: 60px;\n        @include margin-padding(null, 0 15px);\n        @include respond-below(custom991) {\n            display: block;\n        }\n    }\n    .top-nav-search {\n        form {\n            position: relative;\n            @include respond-below(custom991) {\n                display: none;\n            }\n            .form-control {\n                background-color: rgba(255, 255, 255, 0.1);\n                border: 1px solid rgba(255, 255, 255, 0.15);\n                height: 40px;\n                @include margin-padding(null, 10px 50px 10px 15px);\n                @include rounded(50px);\n                &::-webkit-input-placeholder {\n                    color: rgba(255, 255, 255, 0.7);\n                }\n            }\n            .btn {\n                background-color: transparent;\n                border-color: transparent;\n                color: rgba(255, 255, 255, 0.7);\n                min-height: 40px;\n                @include position(absolute,0,0,null,null);\n            }\n        }\n        @include respond-below(custom991) {\n            &.active{\n                form {\n                    display: block;\n                    @include position(absolute,null,null,null,0);\n                    .form-control {\n                        background-color: $white;\n                    }\n                    .btn {\n                        background-color: transparent;\n                        border-color: transparent;\n                        min-height: 40px;\n                        @include position(absolute,0,0,null,null);\n                        @include margin-padding(null, 7px 15px);\n                    }\n                }\n            }\n        }\n    }\n    .userset {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        .usernames{\n            line-height: initial;\n            text-align: right;\n            padding-right: 10px;\n            span {\n                display: block;\n                line-height: initial;\n            }\n        } \n    }\n    .menu-drop-user {\n        .dropdown-item {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            font-size: $font-size-14;\n            color: $gray-900;\n            padding: 10px;\n            border-bottom: 1px solid $light-400;\n            border-radius: 0;\n            &:first-child {\n                border-radius: 5px 5px 0 0;\n            }\n            &:last-child {\n                border-radius: 0 0 5px 5px;\n                border-bottom: 0;\n            }\n            &:hover {\n                padding-left: 20px;\n                letter-spacing: 0.5px;\n            }\n            i {\n                font-size: $font-size-16;\n                margin-right: 8px;\n            }\n        }\n    }\n    .has-arrow{\n        .dropdown-toggle{\n            @include respond-below(custom991) {\n                > span{\n                    &:nth-child(2) {\n                        display: none;\n                    }\n                }\n                &:after{\n                    display: none !important;\n                }\n            }\n        }\n    }\n    .profilename {\n        .user-img {\n            .status {\n                bottom: 10px;\n            }\n        }\n    }\n    .user-img {\n        display: inline-block;\n        position: relative;\n        img {\n            width: 38px;\n            @include rounded(50%);\n        }\n        .status {\n            border: 2px solid $white;\n            height: 10px;\n            width: 10px;\n            @include margin-padding(0, null);\n            @include position(absolute,null,0,30px,null);\n            @include rounded(50%);\n            display: inline-block;\n            background: $success;\n        }\n    }\n    .mobile-user-menu {\n        color: $white;\n        display: none;\n        float: right;\n        font-size: $font-size-24;\n        height: 60px;\n        line-height: 60px;\n        text-align: right;\n        width: 60px;\n        z-index: 10;\n        @include margin-padding(null, 0 20px);\n        @include position(absolute,0,0,null,null);\n        @include respond-below(custom991) {\n            display: block;\n        }\n        a{\n            color: $primary;\n            padding: 0;\n            &::after{\n                display: none;\n            }\n        }\n        .dropdown-menu{\n            padding: 0;\n            a{\n                color:$gray-800;\n                line-height: 40px; \n                @include margin-padding(null, 0 10px);\n            }\n        }\n    }\n}\n.logo-small img {\n    width: 30px;\n}\n@include respond-above(custom992) {\n    .mini-sidebar{\n        &.expand-menu{\n            .header-left {\n                flex-direction:row;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n            }\n        }\n        .header-left {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            width: 80px;\n            @include margin-padding(null, 0);\n            flex-direction:column;\n            .logo-small{\n                display: block;\n                padding: 10px 0 0;\n            }\n            .logo{\n                display: none;\n            }\n        }\n        .menu-arrow{\n            display: none !important;\n        }\n        .chat-user{\n            display: none !important;\n        }\n        .user-menu{\n            .badge{\n                display: flex !important;\n            }  \n        }\n        &.expand-menu{\n            .menu-arrow{\n                display: block !important;\n            }\n            .chat-user{\n                display: block !important;\n            }\n            .logo-small{\n                display: none;\n            }\n            .logo{\n                display: block;\n            }\n            #toggle_btn{\n               opacity: 1;\n            }\n            .header-left{\n                @include margin-padding(null, 0 15px);\n                display: flex;\n            }\n            \n        }\n        .noti-dot{\n            &:before{\n                display: none;\n            }\n        }\n    }\n}\n.nav-list {\n    position: relative;\n    padding-right: 15px;\n    &::before {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 0;\n        width: 1px;\n        height: 20px;\n        background: $light-900;\n        z-index: 1;\n    }\n    .nav {\n        .dark-mode-list {\n            .dark-mode-toggle {\n                width: 66px;\n                height: 36px;\n                background: $light-200;\n                border: 1px solid $light-900;\n                font-size: $font-size-16;\n                border-radius: $border-radius-lg;\n                padding: 3px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n                i {\n                    font-size: $font-size-16;\n                    color: $gray-900;\n                    border-radius: $border-radius-lg;\n                    line-height: 26px;\n                    width: 26px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    &.light-mode.active {\n                        color: $white;\n                        background: $success;\n                    }\n                    &.dark-mode.active {\n                        color: $white;\n                        background: $gray-900;\n                    }\n                }\n            }\n        }\n        li {\n            margin-right: 10px;\n            &:last-child {\n                margin-right: 0;\n            }\n            .btn {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                width: 36px;\n                height: 36px;\n                font-size: $font-size-16;\n                border-radius: $border-radius-lg;\n                border: 1px solid transparent;\n            }\n            .btn-header-list {\n                color: $green;\n                background: $success-200;\n                border: 1px solid $green;\n                &:hover {\n                    color: $white;\n                    background: $green;\n                }\n            }\n            .btn-help {\n                color: $tertiary;\n                background: $purple-100;\n                &:hover {\n                    color: $white;\n                    background: $tertiary;\n                }\n            }\n            .btn-chart-pie {\n                color: $secondary;\n                background: $warning-100;\n                &:hover {\n                    color: $white;\n                    background: $secondary;\n                }\n            }\n        }\n    }\n}       \n.mobile-show {\n    display: none;\n    @include respond-below(custom991) {\n        display: block;\n    }\n}\n",".sidebar {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    background-color: $white;\n    margin-top: 0;\n    z-index: 1001;\n    @include position(fixed,56px,null,0,0);\n    @include transition(all 0.5s ease);\n    width: 276px;\n    @include respond-below(custom991) {\n        margin-left: -575px;\n        @include transition(all 0.4s ease);\n        z-index: 1041;\n        background: $white;\n    }\n    @include respond-below(custom575) {\n        width: 100%;\n    }\n    .slimScrollDiv {\n        border-right: 1px solid transparent;\n        @include respond-below(custom575) {\n            width: 100% !important;\n        }\n    }\n    .sidebar-menu{\n        @include margin-padding(null, 15px);\n        .clinicdropdown{\n            margin-bottom: 24px;\n           > a {\n                background: $light-300;\n                border-radius: $border-radius-lg;\n                padding: 10px;\n                img{\n                    width: 42px;\n                    height: 42px;\n                    border-radius: $border-radius-lg;\n                }\n                .user-names{\n                    margin-left: 10px;\n                    flex: 1;\n                    h5{\n                        font-size: $font-size-16;\n                        font-weight: $font-weight-semibold;\n                        color: $title-color;\n                        margin-bottom: 2px;\n                    }\n                    h6 {\n                        font-size: $font-size-14;\n                        font-weight: $font-weight-normal;\n                        color: $text-color;\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n        .submenu-two{\n            .subdrop.active{\n                background: transparent !important;\n            }    \n        }\n        > ul{\n            > li{\n                margin-bottom: 24px;\n                &.active{\n                    a{\n                        color: $white;\n                    }\n                    svg {\n                        color: #FE9F43\n                    }\n                }\n                svg {\n                    min-width: 16px;\n                    width:  16px;\n                    height:  16px;\n                    margin-right: 10px;\n                }\n                > a{\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    @include margin-padding(null, 10px 15px);\n                    position: relative;\n                    color: $secondary;\n                    svg{\n                        color: #637381;\n                    }\n                    img{\n                        color: #637381;\n                    }\n                    \n                    &.active{\n                        background: rgba(254, 159, 67, 0.08);\n                        color: #FE9F43;\n                        border-radius: 5px;\n                        svg{\n                            color: $white;\n                        }\n                        img {\n                            filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);\n                        }\n                        span{\n                            color: #FE9F43;\n                        }\n                        .menu-arrow{\n                            background: #FFEDDC;\n                            &::before{\n                                border-color: #FE9F43;\n                            }\n                        }\n                    }\n                    span {\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-medium;\n                        color: $gray-600;\n                    }\n                }\n                &.active {\n                    a {\n                        background: rgba(254, 159, 67, 0.08);\n                        border-radius: 5px;\n                        img{\n                            filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);\n                        }\n                        span{\n                            color: #FE9F43;\n                        }\n                    }\n                }\n                &.submenu {\n                    ul {\n                        display: none;\n                       li {\n                            a {\n                               font-weight: $font-weight-medium;\n                               font-size: $font-size-base;\n                               position: relative;\n                               display: block;\n                               @include margin-padding(null, 8px 8px 8px 40px);\n                               padding-left: 30px;\n                           }\n                       }\n                    }\n                }\n                ul {\n                    display: block;\n                    margin-bottom: 24px;\n                    li {\n                        margin-bottom: 5px;\n                        border-radius: 5px;\n                        overflow: hidden;\n                        a {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            font-weight: $font-weight-normal;\n                            font-size: $font-size-14;\n                            color: $gray-400;\n                            position: relative;\n                            width: 100%;\n                            @include margin-padding(null, 8px);\n                            i {\n                                color: $gray-900;\n                                font-size: $font-size-16;\n                                background: $light-300;\n                                border-radius: 5px;\n                                width: 26px;\n                                height: 26px;\n                                display: flex;\n                                align-items: center;\n                                justify-content: center;\n                            }\n                            span {\n                                font-size: $font-size-15;\n                                font-weight: $font-weight-medium;\n                                white-space: nowrap;\n                                color: $gray-900;\n                                margin-left: 10px;\n                            }\n                            &.active {\n                                color: $primary;\n                                background: $primary-100;\n                                border-radius: $border-radius-lg;\n                                span {\n                                    color: $primary;\n                                }\n                                i {\n                                    background: $primary;\n                                    color: $white;\n                                }\n                            }\n                            &:hover{\n                                color: $primary;\n                                span {\n                                    color: $primary;\n                                }\n                            }\n                        }  \n                    }\n                    > li {\n                        &.active a{\n                            &.subdrop{\n                                background: #FFEEEC;\n                                border-radius: 5px;\n                                color: #E41F07;\n                                i{\n                                    color:$white;\n                                    background:#E41F07;\n                                }\n                                span {\n                                    color: #E41F07;\n                                    \n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu-hdr {\n                    font-weight: $font-weight-semibold;\n                    font-size: $font-size-12;\n                    color: $gray-400;\n                    margin: 0 0 14px 0;\n                    text-transform: uppercase;\n                }\n                &:first-child {\n                    h6 {\n                        margin-top: 0;\n                    }\n                }\n                .submenu {\n                    ul {\n                        display: none;\n                        border: 0;\n                        padding-top: 0;\n                        padding-bottom: 0;\n                    }\n                }\n            }\n            li {\n                margin-bottom: 5px;\n                .submenu > {\n                    ul {\n                        margin: 0;\n                        li {\n                            a {\n                                padding-left: 44px;\n                                font-size: $font-size-base;\n                                background: transparent;\n                                position: relative;\n                                &:after{\n                                    position: absolute;\n                                    content: \"\";\n                                    background-color: #898989;\n                                    width: 7px;\n                                    height: 7px;\n                                    border-radius: 50px;\n                                    left: 16px;\n                                    top: 14px;\n                                }\n                                &:before{\n                                    position: absolute;\n                                    content: \"\";\n                                    background-color: #898989;\n                                    width: 0.5px;\n                                    height: 8px;\n                                    left: 19px;\n                                    top: 0px;\n                                }\n                            }\n                        }\n                    }\n                    a {\n                        &.subdrop {\n                            background: $light-200;\n                            i {\n                                background: $dark;\n                                color: $white;\n                            }\n                            &.submenu-two{\n                                background: transparent;\n                            }\n                        }\n                        &.active {\n                            background: $primary-100;\n                            border-radius: 5px;\n                            i {\n                                background: $primary;\n                                color: $white;\n                            }\n                            span {\n                                color: $primary;\n                            }\n                            .menu-arrow {\n                                &::before {\n                                    border-right: 2px solid $primary;\n                                    border-bottom: 2px solid $primary;\n                                }\n                            }\n                        }\n                    }\n                }\n                \n            }\n\n        }\n        .submenu-open {\n            &:last-child {\n                margin-bottom: 0;\n                ul {\n                    border-bottom: none;\n                    padding-bottom: 0;\n                }\n            }\n            .submenu {\n                &.submenu-two {\n                    ul {\n                        li {\n                            a {\n                                margin-left: 45px;\n                            }\n                        }\n                    }\n                    &.submenu-three {\n                        ul {\n                            li {\n                                a {\n                                    margin-left: 65px;\n                                }\n                            }\n                        }\n                    }\n                }\n                ul {\n                    li {\n                        a {\n                        margin-left: 25px;\n                        padding-bottom: 4px;\n                        font-size: $font-size-base;\n                        color: $sub-title;\n                        &::after{\n                            content: \"\";\n                            background: rgba(50, 71, 92, 0.38);\n                            width: 8px;\n                            height: 8px;\n                            border: 2px solid $white;\n                            @include rounded(50px);\n                            @include position(absolute,16px,null,null,0);\n                            }\n                            &:hover{\n                                color:$primary;\n                                &:after{\n                                background: #FE9F43;\n                                border: 2px solid #FDB;\n                                }\n                            }\n                        }\n                    }\n                } \n            } \n        }               \n        .menu-arrow {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            text-rendering: auto;\n            line-height: 40px;\n            font-size: $font-size-18;\n            line-height: 16px;\n            width: 16px;\n            height: 16px;\n            border-radius: 50%;\n            @include position(absolute,12px,10px,null,null);\n            @include transform(translate(0, 0));\n            @include transition(all 0.2s ease);\n            &::before {\n                height: 8px;\n                width: 8px;\n                border-top: 0;\n                content: \"\";\n                border-left: 0;\n                border-right: 2px solid $gray-900;\n                border-bottom: 2px solid $gray-900;\n                transform: rotate(-45deg);\n                position: absolute;\n                left: 5px;\n                top: 5px;\n            }\n            &.inside-submenu {\n                right: 10px;\n                &.inside-submenu-two {\n                    right: 60px;\n                }\n            }\n        }\n        &.subdrop{\n            .menu-arrow {\n                @include transform(rotate(90deg));                            \n                background: #FFEDDC;\n            }\n        }\n    }\n    .nav-link {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        @include margin-padding(null, 10px);\n        color: $secondary;\n        position: relative;\n        &.active{\n            color: $primary;\n            background: transparent;\n            position: relative;\n            &:after{\n                content: \"\";\n                border-width:10px;\n                border-color: transparent $primary transparent transparent;\n                border-style: solid;\n                @include position(absolute,36px,0,null,null);\n            }\n        }\n        \n    }\n    .sidebar-left {\n        width: 100px;\n        @include box-shadow(null, 5px, 0px, 15px, null, rgba(0, 0, 0, .05));\n    }\n    .sidebar-right {\n        width: 250px;\n        height: 100%;\n        @include transition(all 0.2s ease);\n        display: none;\n        @include respond-below(custom991) {\n            width: calc(100% - 70px);\n        }\n        .slimScrollDiv {\n            width: 250px !important;\n            overflow: visible !important;\n            @include respond-below(custom991) {\n                width: 100% !important;\n            }\n        }\n        .tab-content {\n            @include margin-padding(null, 20px 20px 40px);\n            @include respond-below(custom991) {\n                @include margin-padding(null,10px);\n            }\n        }\n        p {\n            font-size: $font-size-10;\n            color: $gray-500;\n            text-transform: uppercase;\n            font-weight: $font-weight-bold;\n            margin-bottom: 10px;\n        }\n        ul {\n            list-style: none;\n            padding: 0;\n            margin: 0;\n            li {\n                &.active{\n                    a{\n                        background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\n                        color: $white;\n                    }\n                }\n                a {\n                    font-weight: $font-weight-normal;\n                    font-size: $font-size-base;\n                    color: $secondary;\n                    &.active {\n                        color: $primary;\n                    }\n                }\n            }\n        }\n        .menu-arrow {\n            -webkit-transition: -webkit-transform 0.15s;\n            -o-transition: -o-transform 0.15s;\n            transition: transform .15s;\n            display: inline-block;\n            font-family: 'Font Awesome 5 Free';\n            text-rendering: auto;\n            line-height: 40px;\n            font-size: $font-size-18;\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            line-height: 18px;\n            top: 0px;\n            position: relative;\n            font-weight: $font-weight-bold;\n            @include transform(translate(0, 0));\n            &:before {\n                content: \"\\f105\";\n                \n            }\n        }\n    }\n    .sub-menu a {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n    }\n    li {\n        a.subdrop {\n            .menu-arrow {\n                @include transform(rotate(90deg));\n            }\n        }\n    }\n    .nav-items{\n        .nav-link {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-direction: column;\n            flex-direction: column;\n            @include rounded(0);\n            border-bottom: 1px solid $gray-400;\n            @include margin-padding(null, 20px 0);\n            @include transition(all 0.4s ease);\n            &:hover{\n                box-shadow: 0  0 0 150px $violet inset;\n                color: $white;\n            }  \n            span{\n                margin-top: 15px;\n                font-weight:$font-weight-medium;\n            }\n        }\n       \n    }\n    .sidemenu {\n        a {\n            width: 100%;\n            font-weight: $font-weight-medium;\n            display: block;\n            @include rounded(5px);\n            @include margin-padding( 0 0 10px, 10px);\n            &:hover{\n                background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\n                color: $white;\n                svg{\n                    color:$white;\n                }\n            }\n            svg {\n                stroke-width: 1px;\n            }\n           \n        }\n    }\n}\n\n\n@include respond-above(custom991) {\n    .mini-sidebar {\n        .page-wrapper {\n            margin-left: 80px;\n        }\n        .user-names{\n            display: none;\n        }\n        .header-left {\n            #toggle_btn{\n                opacity: 1;\n                transform: rotate(180deg);\n                &:after {\n                   border:0;\n                }\n            }\n        }\n        .sidebar {\n            .sidebar-menu {\n                .clinicdropdown > a {\n                    padding: 5px;\n                }\n            }\n        }\n        &.expand-menu{\n            .header-left {\n                #toggle_btn{\n                    opacity: 1;\n                    transform: rotate(180deg);\n                }\n            }  \n            .sidebar {\n                .sidebar-menu{\n                    .clinicdropdown > a {\n                        padding: 10px ;\n                    }\n                }\n            }\n        }\n        .sidebar-right {\n            display: none;\n        }\n        .sidebar {\n            .sidebar-menu{\n                  ul{\n                    li{\n                        a {\n                            span{\n                                display:none;\n                            }\n                        }\n                        .submenu-hdr {\n                            display:none;\n                        }                                                       \n                        svg {\n                            margin-right:0;\n                        }\n                    }\n                }\n            } \n        }\n        .sidebar{\n            width: 80px;\n            overflow: hidden;\n        }\n        &.expand-menu{\n            .sidebar {\n                display:block\n            }\n        }\n    }\n    .expand-menu{\n        &.mini-sidebar{\n            .sidebar{\n                .sidebar-menu{\n                    .submenu-hdr {\n                        display:block;\n                    }\n                }\n                .user-names{\n                    display: block;\n                }\n            }\n        }\n        .sidebar-right {\n            display: block;\n            @include transition(all 0.2s ease);\n        }\n        .sidebar {\n            width: 276px;\n            .sidebar-menu{\n               ul{\n                   > li{\n                        > a {\n                            span{\n                                display:inline-block;\n                                line-height: 0;\n                            }\n                        }                        \n                        svg {\n                            margin-right:10px;\n                        }\n                    }\n                }\n                .submenu-hdr {\n                    display:block;\n                }\n            }\n        }\n        .header-left{\n            width: 276px;\n        }\n    }\n    #toggle_btn {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        float: left;\n    }\n}\nbody.mini-sidebar.expand-menu{\n    .sidebar .sidebar-menu > ul > li ul li a{\n        justify-content: start;\n    }\n}\nbody.mini-sidebar{\n    .sidebar .sidebar-menu > ul > li ul li a{\n        justify-content: center;\n    }\n    .sidebar {\n        .sidebar-menu > ul > li.submenu-open ul li a {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            font-weight: $font-weight-medium;\n            font-size: $font-size-15;\n            color: #67748E;\n            position: relative;\n            width: 100%;\n            padding: 10px;\n        }\n        .sidebar-menu > ul > li ul > li.active a{\n            padding: 10px;\n            justify-content: center;\n        }\n    }\n     \n    &.expand-menu {\n        .sidebar {\n            .sidebar-menu > ul > li.submenu-open ul li a {\n                justify-content: left;\n                -webkit-justify-content: left;\n                -ms-flex-pack: left;\n                padding-left:  18px;\n            }\n            .sidebar-menu > ul > li ul > li.active a{\n                padding: 10px 15px;\n                justify-content: start;\n            }\n        }\n    }\n}\n\n.sidebarrightmenu{\n    .sidebar-right{\n        display: block;\n    }\n}\n.slide-nav{\n    .sidebar {\n        margin-left: 0;\n    }\n}\n.sidebar-overlay {\n    display: none;\n    height: 100%;\n    width: 100%;\n    z-index: 99;\n    background-color: rgba(0, 0, 0, 0.6);\n    @include position(fixed,60px,null,null,0);\n    &.opened {\n        display: block;\n    }\n}\n.mini-sidebar{\n    .active.subdrop ~ ul{\n        display: none !important;\n    }\n}\n.mini-sidebar.expand-menu{\n    .active.subdrop ~ ul{\n        display: block !important;\n    }\n}\n.active.subdrop ~ ul{\n    display: block !important;\n}\n\n.sidebar {\n\t.sidebar-menu {\n\t\t>ul {\n\t\t\tli {\n\t\t\t\t.submenu {\n                    &.submenu-two {\n                        >ul {\n                            li {\n                                a {\n                                    margin-left: 30px;\n                                }\n                            }\n                        }\n                        &.submenu-three {\n                            >ul {\n                                li {\n                                    a {\n                                        margin-left: 60px;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n                \n\t\t\t}\n\t\t}\n\t}\n}\n.mini-sidebar {\n    .header {\n        #toggle_btn {\n            opacity: 0;\n            height: 0;\n            width: 0;\n        }\n    }\n}"," [data-sidebar=\"dark\"]{\n    .sidebar {\n        background-color:$dark;\n        .sidebar-menu {\n            .clinicdropdown {\n                a{\n                    background-color:#000000;\n                    .user-names h5{\n                        color: $white;\n                    }\n                }\n            }\n            ul{\n                > li {\n                    ul {\n                        li a {\n                            span{\n                                color: $dark-text;\n                            }\n                        }\n                    }\n                }\n            }\n            .menu-arrow{\n               &:before{\n                    border-right: 2px solid $dark-text;\n                    border-bottom: 2px solid $dark-text;\n               }\n            }\n        }\n    }\n}\n\n [data-sidebar=\"blue\"]{\n    .sidebar {\n        background-color:#3C2371;\n        .sidebar-menu {\n            .clinicdropdown {\n                a{\n                    background-color:#2f0093;\n                    .user-names {\n                        h5{\n                            color: $white;\n                        }\n                        h6{\n                            color: #e4e4e4;\n                        }\n                    }\n                }\n            }\n             > ul > li .submenu-hdr{\n                color: $white;\n            }\n            ul{\n                > li {\n                    .submenu-hdr{\n                        color: $white;\n                    }\n                    ul {\n                        li {\n                            a {\n                                color: $white;\n                                &.active{\n                                    i{\n                                        background-color:#3C2371;\n                                    }\n                                    span{\n                                        color: #3C2371;\n                                    }\n                                    .menu-arrow::before {\n                                        border-right: 2px solid #3C2371;\n                                        border-bottom: 2px solid #3C2371;\n                                    }\n                                }\n                                span{\n                                    color: $white;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            .menu-arrow{\n               &:before{\n                    border-right: 2px solid $white;\n                    border-bottom: 2px solid $white;\n               }\n            }\n        }\n    }\n}\n [data-sidebar=\"green\"]{\n    .sidebar {\n        background-color:#00918E;\n        .sidebar-menu {\n            .clinicdropdown {\n                a{\n                    background-color:#005351;\n                    .user-names {\n                        h5{\n                            color: $white;\n                        }\n                        h6{\n                            color: #e4e4e4;\n                        }\n                    }\n                }\n            }\n             > ul > li .submenu-hdr{\n                color: $white;\n            }\n            ul{\n                > li {\n                    .submenu-hdr{\n                        color: $white;\n                    }\n                    ul {\n                        li {\n                            a {\n                                color: $white;\n                                &.active{\n                                    i{\n                                        background-color:#00918E;\n                                    }\n                                    span{\n                                        color: #00918E;\n                                    }\n                                    .menu-arrow::before {\n                                        border-right: 2px solid #00918E;\n                                        border-bottom: 2px solid #00918E;\n                                    }\n                                }\n                                span{\n                                    color: $white;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            .menu-arrow{\n               &:before{\n                    border-right: 2px solid $white;\n                    border-bottom: 2px solid $white;\n               }\n            }\n        }\n    }\n}\n\n[data-color=\"red\"]{\n    $primary: #E41F07;\n    .btn-primary {\n        background: $primary;\n        border: 1px solid $primary;\n        &:hover {\n            background: #c11a06;\n            border-color: #c11a06;\n        }\n    }\n}\n [data-color=\"yellow\"]{\n    $primary: #FFA201;\n    $secondary-100: #FFF6E6;\n    .btn-primary {\n        &:hover {\n            background: #FF9901 !important;\n            border-color: #FF9901 !important;\n        }\n    }\n    .sidebar {\n        .sidebar-menu {\n            > ul {\n                > li {\n                    ul {\n                        li {\n                            a{\n                                &.active{\n                                    color: $primary;\n                                    background: $secondary-100;\n                                     span{\n                                        color: $primary;\n                                     }\n                                    i {\n                                        background:  $primary;\n                                    }\n                                }\n                                &:hover {\n                                    color: $primary;\n                                    span{\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .submenu  {\n                        .subdrop.active {\n                            background: $secondary-100;\n                            \n                        }\n                        ul{\n                            li{\n                                a.active{\n                                    background: transparent;\n                                }\n                            }\n                        }\n                        > a.active{\n                            background: transparent;\n                            color: $primary;\n                            i {\n                                background:  $primary;\n                            }\n                            span{\n                                color: $primary;\n                            }\n                            .menu-arrow::before {\n                                border-right: 2px solid $primary;\n                                border-bottom: 2px solid $primary;\n                            }\n                        }\n                    }\n                }\n                \n            }\n        }\n    }\n    .user-accordion-item .accordion-wrap:not(.collapsed) span{\n        background: $primary;\n    }\n    .page-header .btn-added{\n        background: $primary;\n    }\n    .settings-menu .nav li a.active {\n        color: $primary;\n        border-bottom: 4px solid $primary;\n    }\n    .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover, \n    .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover, \n    .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover{\n        background: $primary;\n        border-color: $primary;\n    }\n    .todo-inbox-check .checkboxs input:checked ~ .checkmarks {\n        border-color: $primary;\n        background-color: $primary;\n    }\n    .custom-pagination .paginations .page-wrap li a.active {\n        background: $primary;\n    }\n    .contact-nav li a:hover, .contact-nav li a.active {\n        color: $primary;\n        border-color: $primary;\n    }\n    .dataTables_paginate .pagination li.active a.page-link, #dataTables_paginate .pagination li.active a.page-link {\n        background:  $primary;\n        border-color:  $primary;\n    }\n    .btn-primary {\n        background: $primary;\n        border: 1px solid $primary;\n    }\n    .select2-container--default .select2-results__option--selected{\n        background: $primary;\n        color: $white;\n    }\n    .view-icons a.active, \n    .view-icons a:hover{\n        background: $primary;\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n    }\n    .form-check-input:checked {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .breadcrumb .breadcrumb-item.active {\n        color: $primary;\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n    }\n}\n\n [data-color=\"blue\"]{\n    $primary: #3C2371;\n    $secondary-100: #ECE9F1;\n    .btn-primary {\n        &:hover {\n            background: #3B4971 !important;\n            border-color: #3B4971 !important;\n        }\n    }\n    .sidebar {\n        .sidebar-menu {\n            > ul {\n                > li {\n                    ul {\n                        li {\n                            a{\n                                &.active{\n                                    color: $primary;\n                                    background: $secondary-100;\n                                     span{\n                                        color: $primary;\n                                     }\n                                    i {\n                                        background:  $primary;\n                                    }\n                                }\n                                &:hover {\n                                    color: $primary;\n                                    span{\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .submenu  {\n                        .subdrop.active {\n                            background: $secondary-100;\n                            \n                        }\n                        ul{\n                            li{\n                                a.active{\n                                    background: transparent;\n                                }\n                            }\n                        }\n                        > a.active{\n                            background: transparent;\n                            color: $primary;\n                            i {\n                                background:  $primary;\n                            }\n                            span{\n                                color: $primary;\n                            }\n                            .menu-arrow::before {\n                                border-right: 2px solid $primary;\n                                border-bottom: 2px solid $primary;\n                            }\n                        }\n                    }\n                }\n                \n            }\n        }\n    }\n    .user-accordion-item .accordion-wrap:not(.collapsed) span{\n        background: $primary;\n    }\n    .page-header .btn-added{\n        background: $primary;\n    }\n    .settings-menu .nav li a.active {\n        color: $primary;\n        border-bottom: 4px solid $primary;\n    }\n    .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover, \n    .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover, \n    .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover{\n        background: $primary;\n        border-color: $primary;\n    }\n    .todo-inbox-check .checkboxs input:checked ~ .checkmarks {\n        border-color: $primary;\n        background-color: $primary;\n    }\n    .custom-pagination .paginations .page-wrap li a.active {\n        background: $primary;\n    }\n    .contact-nav li a:hover, .contact-nav li a.active {\n        color: $primary;\n        border-color: $primary;\n    }\n    .dataTables_paginate .pagination li.active a.page-link, #dataTables_paginate .pagination li.active a.page-link {\n        background:  $primary;\n        border-color:  $primary;\n    }\n    .btn-primary {\n        background: $primary;\n        border: 1px solid $primary;\n    }\n    .select2-container--default .select2-results__option--selected{\n        background: $primary;\n        color: $white;\n    }\n    .view-icons a.active, \n    .view-icons a:hover{\n        background: $primary;\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n    }\n    .form-check-input:checked {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .breadcrumb .breadcrumb-item.active {\n        color: $primary;\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n    }\n}\n [data-color=\"green\"]{\n    $primary: #00918E;\n    $secondary-100: #E6F4F4;\n    .btn-primary {\n        &:hover {\n            background: #005e5c !important;\n            border-color: #005e5c !important;\n        }\n    }\n   .sidebar {\n        .sidebar-menu {\n            > ul {\n                > li {\n                    ul {\n                        li {\n                            a{\n                                &.active{\n                                    color: $primary;\n                                    background: $secondary-100;\n                                     span{\n                                        color: $primary;\n                                     }\n                                    i {\n                                        background:  $primary;\n                                    }\n                                }\n                                &:hover {\n                                    color: $primary;\n                                    span{\n                                        color: $primary;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                    .submenu  {\n                        .subdrop.active {\n                            background: $secondary-100;\n                            \n                        }\n                        ul{\n                            li{\n                                a.active{\n                                    background: transparent;\n                                }\n                            }\n                        }\n                        > a.active{\n                            background: transparent;\n                            color: $primary;\n                            i {\n                                background:  $primary;\n                            }\n                            span{\n                                color: $primary;\n                            }\n                            .menu-arrow::before {\n                                border-right: 2px solid $primary;\n                                border-bottom: 2px solid $primary;\n                            }\n                        }\n                    }\n                }\n                \n            }\n        }\n    }\n    .user-accordion-item .accordion-wrap:not(.collapsed) span{\n        background: $primary;\n    }\n    .page-header .btn-added{\n        background: $primary;\n    }\n    .settings-menu .nav li a.active {\n        color: $primary;\n        border-bottom: 4px solid $primary;\n    }\n    .toggle-popup .sidebar-layout .sidebar-header .toggle-btn:hover, \n    .toggle-popup1 .sidebar-layout .sidebar-header .toggle-btn:hover, \n    .toggle-popup2 .sidebar-layout .sidebar-header .toggle-btn:hover{\n        background: $primary;\n        border-color: $primary;\n    }\n    .todo-inbox-check .checkboxs input:checked ~ .checkmarks {\n        border-color: $primary;\n        background-color: $primary;\n    }\n    .custom-pagination .paginations .page-wrap li a.active {\n        background: $primary;\n    }\n    .contact-nav li a:hover, .contact-nav li a.active {\n        color: $primary;\n        border-color: $primary;\n    }\n    .dataTables_paginate .pagination li.active a.page-link, #dataTables_paginate .pagination li.active a.page-link {\n        background:  $primary;\n        border-color:  $primary;\n    }\n    .btn-primary {\n        background: $primary;\n        border: 1px solid $primary;\n    }\n    .select2-container--default .select2-results__option--selected{\n        background: $primary;\n        color: $white;\n    }\n    .view-icons a.active, \n    .view-icons a:hover{\n        background: $primary;\n    }\n    .btn.btn-primary {\n        background-color: $primary;\n        border: 1px solid $primary;\n    }\n    .form-check-input:checked {\n        background-color: $primary;\n        border-color: $primary;\n    }\n    .breadcrumb .breadcrumb-item.active {\n        color: $primary;\n    }\n    .btn-outline-primary {\n        border: 1px solid $primary !important;\n        color: $primary !important;\n    }\n}\n\n [data-theme=\"dark\"]{\n    body{\n        background-color:$dark;\n        color: $dark-text;\n    }\n    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {\n        color: $white;\n    }\n    .header{\n        background-color:$dark;\n        .header-left{\n            background-color:$dark;\n            .logo{\n                img{\n                    display: none;\n                    &.white-logo{\n                        display: block;\n                    }\n                }\n            }\n            #toggle_btn{\n                color: $white;\n            }\n        }\n        .dropdown-menu{\n            background-color:$dark;\n            box-shadow: none;\n            a{\n                color: $white;\n            }\n            .topnav-dropdown-header {\n                border-color: $dark-border;\n                .notification-title{\n                    color: $white;\n                }\n                \n            }\n        }\n        .menu-drop-user .dropdown-item{\n            border-color: $dark-border;\n        }\n        .notification-dropdown {\n            .notification-list {\n                li {\n                    border-bottom: 1px solid $dark-border;\n                    .noti-title {\n                        color: $white;\n                    }\n                    .noti-details {\n                        color: $white;\n                    }\n                    p.noti-time {\n                        color: $white;\n                    }\n                    .noti-pdf {\n                        .noti-pdf-icon {\n                            span {\n                                border: 1px solid $dark-border;\n                            }\n                        }\n                        .noti-pdf-text {\n                            p {\n                                color: $white;\n                            }\n                            span {\n                                color: $dark-textcolor;\n                            }\n                        }\n                    }\n                    .notification-time {\n                        font-size: $font-size-12;\n                        line-height: 1.35;\n                        color: $gray-600;\n                    }\n                    \n                }\n            }\n            .topnav-dropdown-footer{\n                background: $dark;\n            }\n        }\n        .searchinputs {\n            input{\n                border-color: $dark-border;\n                background: transparent;\n            }\n            .search-addon button{\n                color: $dark-textcolor;\n            }\n        }\n        .menus-info {\n            .menu-list {\n                li {\n                    a {\n                        background: transparent;\n                        border-radius: $border-radius-lg;\n                        &:hover {\n                            background: transparent;\n                        }\n                        .menu-details {\n                            .menu-list-icon {\n                                color: $white;\n                            }\n                            .menu-details-content {\n                                p {\n                                    color: $white;\n                                    margin-bottom: 0;\n                                }\n                                span {\n                                    font-weight: $font-weight-normal;\n                                    color: $dark-textcolor;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .sidebar {\n        background-color:$dark;\n        .sidebar-menu {\n            .clinicdropdown {\n                a{\n                    background-color:#28283E;\n                    .user-names h5{\n                        color: $white;\n                    }\n                }\n            }\n            ul{\n                > li {\n                    ul {\n                        li a {\n                            span{\n                                color: $dark-text;\n                            }\n                        }\n                    }\n                }\n            }\n            .menu-arrow{\n               &:before{\n                    border-right: 2px solid $dark-text;\n                    border-bottom: 2px solid $dark-text;\n               }\n            }\n        }\n    }\n    .contact-grid.proposals-grid .grid-head .table-action .action-icon{\n        background: #393947;\n        color: $white;\n    }\n    .contact-grid.proposals-grid .grid-footer {\n        background: #171724;\n        border-color: #393947;\n        color: $white;\n    }\n    .title-head {\n        color: $white;\n    }\n    .sidebar-themesettings {\n        background: $dark;\n        .themesettings-header {\n            border-color: $dark-border;\n            h4 {\n                color: $white;\n            }\n        } \n        .themesettings-inner {\n            background: $dark-bg;\n            border-color: $dark-border;\n            .themesettings-content {\n                border-color: $dark-border;\n                h6 {\n                    color: $white;\n                }\n            }\n        }\n        .input-themeselect {\n            border-color: $dark-border;\n            background: $dark;\n            .checkboxs-theme:after {\n                border-color: $dark-border;\n            }\n        }\n    }\n    .form-check-label,\n    .form-label,\n    .sub-header{\n        color: $dark-text;\n    }\n    .form-select {\n        option{\n            background: transparent;\n        }\n    }\n    .icon-form{\n        .form-icon {\n            color: $dark-text;\n        }\n    }\n    .drop-down > a,\n    .export-dropdwon > a,\n    .form-sorts > a{\n        border-color: $dark-border;\n        box-shadow: none;\n        background-color: #1A1A25;\n        color: $dark-text;\n        &:hover{\n            color: $dark-text;\n        }\n    }\n    .manage-dropdwon {\n        .dropdown-menu{\n            border-color: $dark-border;\n            background-color: #1A1A25;\n            color: $dark-text;\n            box-shadow: none;\n        }\n    }\n    .form-sorts {\n        .filter-set-content {\n            .filter-set-content-head {\n                a{\n                    color: $dark-text;\n                }\n            }\n        }\n    }\n    .header-set .select2-container--default {\n        .select2-selection--single {\n            border-color: $dark-border;\n        }\n    }\n    .form-sorts {\n        .filter-dropdown-menu{\n            border-color: $dark-border;\n            background-color: #1A1A25;\n            color: $dark-text;\n            box-shadow: none;\n        }\n    }\n    .status-radio:checked + label, \n    .status-radio:not(:checked) + label{\n        color: $dark-text;\n    }\n    .filter-set-contents {\n        .filter-content-list{\n            border-color: $dark-border;\n            background-color: #1A1A25;\n            color: $dark-text;\n        }\n    }\n    .dataTables_length label .form-select,\n     #dataTables_length label .form-select{\n        border-color: $dark-border;\n        box-shadow: none;\n        background-color: #1A1A25;\n        color: $dark-text;\n    }\n    .view-icons{\n        border-color: $dark-border;\n    }\n    .toast {\n        background-color: #1A1A25;\n    }\n    .select2-selection--multiple{\n        border-color: $dark-border;\n        background: $dark;\n        box-shadow: none;\n        color: $dark-text;\n    }\n    .twitter-bs-wizard {\n        .twitter-bs-wizard-nav .step-icon{\n            border-color: $white;\n            color: $white;\n        }\n    }\n    .text-dark {\n        color: $dark-text !important;\n    }\n    .select2-container--default {\n        .select2-selection--single{\n            border-color: $dark-border;\n            background: $dark;\n            box-shadow: none;\n            .select2-selection__rendered{\n                box-shadow: none;\n                border:1px solid $dark-border;\n                background: $dark;\n                color: $dark-text;\n            }\n            .select2-selection__arrow{\n                box-shadow: none;\n            }\n        }\n    }\n    .toggle-popup .sidebar-layout, \n    .toggle-popup1 .sidebar-layout, \n    .toggle-popup2 .sidebar-layout{\n        border-color: $dark-border;\n        background: $dark;\n    }\n    .user-accordion-item {\n        .accordion-wrap{\n            color: $dark-text;\n            &:hover {\n                color: $dark-text;\n            }\n        }\n        .content-collapse {\n            border-color: $dark-border;\n        }\n    }\n    .bootstrap-tagsinput{\n        background: $dark;\n        border-color: $dark-border;\n    }\n    .user-accordion-item,\n    .files-wrap,\n    .contact-wrap,\n    .notes-activity .note-download,\n    .contact-tab-wrap,\n    .contact-tab-view,\n    .calls-box,\n    .notes-activity .reply-box ,\n    .note-download\n    {\n        border-color: $dark-border;\n        background: $dark;\n        box-shadow: none;\n    }\n    .contact-sidebar, .contact-tab-view {\n        background-color: $dark-bg;\n        box-shadow: none;\n    }\n    .action-drop{\n        .dropdown-toggle{\n            border-color: $dark-border;\n            color: $dark-text;\n        }\n    }\n    .upcoming-info{\n        border-color: $dark-border;\n    }\n    .calls-box {\n        .caller-info {\n            .calls-user p span {\n                color: $dark-text;\n                font-weight: 500;\n            }\n            .calls-action .dropdown-toggle{\n                color: $dark-text;\n                border-color: $dark-border;\n            }\n        }\n    }\n    .bootstrap-tagsinput{\n        box-shadow: none;\n    }\n    .contact-grid {\n        color: $dark-text;\n        border-color: $dark-border;\n        background: $dark;\n        box-shadow: none;\n        .grid-head {\n            .users-profile {\n                .name-user {\n                    h6 {\n                        a{\n                            color: $white;\n                        }\n                    }\n                }\n            }\n        }\n        .grid-body{\n            .address-info{\n                p{\n                    i{\n                        color: $dark-text; \n                    }\n                }\n            }\n        }\n        .grid-footer{\n            border-color: $dark-border; \n        }\n    }\n    .company-info li span{\n        border-color: $dark-border; \n    }\n    .contacts-action{\n        .btn-icon,.btn-icon.rating{\n            color: $dark-text;\n            border-color: $dark-border;\n            background: $dark;\n        }\n        .act-dropdown > a{\n            color: $dark-text;\n            border-color: $dark-border;\n            background: $dark;\n        }\n    }\n    .social-info li a{\n        color: $dark-text;\n        border-color: $dark-border;\n        background: $dark; \n    }\n    .view-header {\n        .form-sort{\n            .select2-container {\n                .select2-selection {\n                    .select2-selection__rendered{\n                        color: $dark-text; \n                    }\n                }\n            }\n        }\n    }\n    .basic-info li span{\n        color: $dark-text;\n        border-color: $dark-border;\n        background: $dark; \n    }\n    .badge-day{\n        color: $dark-text;\n        background: #3d3d64; \n    }\n    .contact-nav li a {\n        border-color: transparent;\n    }\n    .upcoming-info .dropdown .dropdown-toggle{\n        color: $dark-text;\n    }\n    .contact-sidebar ul,.view-header,.activity-wrap{\n        border-color: $dark-border;\n    }\n    .search-section{\n        border-color: $dark-border;\n    }\n    .select2-container--default .select2-results__option--selected{\n        background: $primary;\n        color: $white;\n    }\n    .form-floating > .form-control:not(:placeholder-shown) ~ label::after{\n        background: transparent;\n    }\n    .select2-dropdown{\n        border-color: $dark-border;\n        background: $dark;\n       \n        ul{\n            li{\n                color: $white;\n            }\n        }\n    }\n    .btn-outline-light{\n        color: $dark-text !important;\n    }\n    .page-wrapper {\n        background: #151525;\n        .page-header{\n            h3{\n                color: $white;\n            }\n            h4{\n                color: $white;\n            }\n            .head-icons a{\n                border-color: $dark-border;\n                background: transparent;\n                color: $white;\n            }\n        }\n        .page-title{\n            color: $white;\n        }\n    }\n    .note-editable.card-block{\n        color: $white;\n    }\n    .accordion-item{\n        border-color: $dark-border;\n        background: $dark;\n        .accordion-body{\n            border-color: $dark-border;\n            background: #28283E;\n        }\n    }\n    .accordion-button{\n        border-color: $dark-border;\n        background: #28283E;\n    }\n    .seprator-lg {\n        border-color: $dark-border;\n    }\n    .card{\n        background: $dark-bg;\n        box-shadow: none;\n        &.bg-white {\n            background: $dark-bg !important;\n        }\n        &.main-card{\n            background: #28283E;\n            box-shadow: none;\n        }\n        &.custom-card{\n            background: #28283E;\n            .card-header{\n                border-color: $dark-border;\n            }\n            .card-footer{\n                border-color: $dark-border;\n            }\n        }\n        .card-header {\n            border-color: $dark-border;\n            .card-title{\n                color: $white;\n            }\n            .card-text{\n                color: $dark-text;\n            }\n        }\n        .card-body{\n            color: $dark-text;\n        }\n    }\n    .col-form-label{\n        color: $dark-text;\n    }\n    .custom-table{\n        .table-responsive{\n            border-color: $dark-border;\n        }\n    }\n    .btn-purple-light{\n        background:$dark;\n        border-color: $dark-border;\n        color: $dark-text;\n        &:hover{\n            background:$dark;\n            border-color: $dark-border;\n            color: $dark-text;\n        }\n    }\n    .note-toolbar{\n        background:$dark;\n    }\n    .note-btn-group .note-btn{\n        background:$dark;\n        border-color: $dark-border;\n        color: $dark-text;\n    }\n    .note-toolbar{\n        border-color: $dark-border;\n    }\n    .table-action {\n        .action-icon{\n            background:$dark;\n            border-color: $dark-border;\n            color: $white;\n            &:hover {\n                    background: $dark-input;\n                    color: $white;\n                    i {\n                        color: $white;\n                    }\n                }\n        }\n    }\n    .toggle-popup {\n        .sidebar-layout .sidebar-header{\n            border-color: $dark;\n        }\n    }\n    table{\n        \n        &.table{\n            &.table-primary{\n                background:$dark;\n            }\n             thead  {\n                border-color: $dark-border;\n                 tr {\n                    border-color: $dark-border;\n                    th{\n                        background: $dark;\n                        color: $white;\n                        border-color: $dark-border;\n                    }\n                }\n            }\n            tbody{\n                tr{\n                    td{\n                        background:$dark;\n                        color: $dark-textcolor;\n                        border-color: $dark-border;\n                    }\n                }\n            }\n            &.dataTable {\n                border-color: $dark-border;\n                > thead  {\n                    border-color: $dark-border;\n                    >  tr {\n                        border-color: $dark-border;\n                        th{\n                            background: $dark;\n                            color: $white;\n                            border-color: $dark-border;\n                        }\n                    }\n                }\n                tbody{\n                    tr{\n                        td{\n                            background:$dark;\n                            color: $dark-textcolor;\n                            border-color: $dark-border;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .statistic-header {\n        h4{\n            i{\n                color:#B5B5B5;\n            }\n            color: $white;\n        }\n        .statistic-dropdown {\n            .dropdown-toggle {\n                color: $white;\n                border: 1px solid #1A1A25;\n                box-shadow: none;\n                background:  #1A1A25;\n                &:after{\n                    border-bottom: 2px solid #B5B5B5;\n                    border-right: 2px solid #B5B5B5;\n                }\n            }\n            .dropdown-menu{\n                border-color: $dark-border;\n                background: $dark;\n                a{\n                    background: transparent;\n                    color: $white;\n                }\n            }\n        }\n    }\n    .toggle-popup .sidebar-layout .sidebar-header, \n    .toggle-popup1 .sidebar-layout .sidebar-header, \n    .toggle-popup2 .sidebar-layout .sidebar-header {\n        border-color:$dark-border;\n    }\n    .form-control,.form-select{\n        border-color:$dark-border;\n        background: $dark;\n        color: $dark-text;\n        box-shadow: none; \n        &:disabled{\n            border-color:$dark-border;\n            background: $dark;\n            color: $dark-text;\n        }\n        &:focus{\n            border-color:$dark-border;\n            background: $dark;\n            color: $dark-text;\n        }\n    }\n    .input-group-text{\n        background:$dark-border;\n        color: $dark-text;\n        border-color:$dark-border;\n    }\n    .radio,.checkbox{\n        label{\n            color: $dark-text;\n        }\n    }\n    .apexcharts-text tspan{\n        fill: $white;\n    }\n    a {\n        color: $white;\n        &.label-add {\n            color: $primary;\n        }\n    }\n    .settings-sub-header {\n        border-color: $dark-border;\n    }\n    .profile-details {\n        border-color: $dark-border;\n    }\n    .profile-upload .profile-upload-img {\n        border-color: $dark-border; \n    }\n    .settings-sidebar {\n        ul {\n            li {\n                a {\n                    color: $dark-textcolor;\n                    &:hover {\n                        color: $white;\n                    }\n                    &.active {\n                        background: $darkmode-hover;    \n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    .btn {\n        &.btn-light {\n            background-color: $dark-input;\n            border-color: $dark-border;\n            color: $white;\n            &:hover {\n                background-color: $dark-hover;\n                border-color: $dark-border;\n                color: $white;\n            }\n            \n        }       \n    }\n    .security-grid {\n        border-color: $dark-border;\n        background: $dark-bg;\n        .security-heading {\n            h5 {\n                color: $white;\n            }\n        }\n    }\n    .notification-wrap {\n        ul {\n            li {\n                .security-checkbox {\n                    .checkboxs {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    .notificaion-table .table {\n         tbody {\n            tr {\n                td { \n                    color: $white;\n                }\n            }\n        }\n    }\n    .integration-grid {\n        background: $gray-bg;\n        border-color: $gray-bg;\n        .integration-content { \n            p {\n                color: $white;\n            }\n        }\n    }\n    .storage-wrap {\n        background: $gray-bg;\n        border-color: $dark-border;\n        .storage-icon {\n            h6 {\n                color: $white;\n            }\n        }\n    }\n    .black-text {\n        color: $white !important;\n    }\n    .theme-type-images {\n        .theme-image {\n            background: $dark;  \n            border-color: $dark-border;\n            span {\n                color: $white;\n            }\n        }\n    }\n    .table tbody tr td a {\n        color: $white;\n    }\n    .text-black {\n        color: $white !important;\n    }\n    .lang-flag {\n        a {\n            border-color: $dark-border;\n            color: $white;\n        }\n    }\n    .modal {\n        .modal-content {\n            background: $dark-bg;\n            border-color: $dark-border;\n            .modal-header {\n                 border-color: $dark-border;\n            }\n            .col-form-label {\n                color: $white;\n            }\n        }\n    }\n    .drag-attach {\n        border-color: $dark-border;\n    }\n    .upload-file {\n        border-color: $dark-border;\n        background: $dark;  \n    }\n    .lang-type li {\n        a {\n            background: $dark;  \n        }\n    }\n    .dropdown-menu {\n        background: $dark-bg;\n        border-color: $dark-border;\n    }\n    .table-action .dropdown-menu {\n        a {\n            color: $dark-textcolor;\n            &:hover {\n                background: $darkmode-hover;\n                color: $white;\n            }\n        }\n    }\n    .btn-add {\n        background: $dark-input;\n        border-color: $dark-border;\n        color: $white;\n    }\n    .settings-sub-header.setting-item {\n        .table-action {\n            .action-icon {\n                background: $dark-input;\n                border-color: $dark-border;\n                &:hover {\n                    background: $dark-input;\n                    color: $white;\n                    i {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    .mail-wrapper {\n        background: $gray-bg;\n        border-color: $dark-border;\n        .mail-wrap {\n            .email-action .info-icon {\n                &:hover {\n                    color: $white;\n                }\n                &::after {\n                    background: $dark-border;\n                }\n            }\n        }\n        .mail-collapse {\n             border-color: $dark-border;\n         }\n    }\n    .bank-box {\n        background: $gray-bg;\n        border-color: $dark-border;\n        &.active {\n            &::after {\n                background-color: $gray-bg;\n            }\n        }\n        .table-action {\n            .action-icon {\n                &:hover {\n                    background: $dark-input;\n                }\n            }\n        }\n    }\n    .custom-modal {\n        .modal-header {\n            .btn-close {\n                border-color: $dark-border;\n                background: $dark-input;\n                box-shadow: none;\n            }\n        }\n    }\n    .storage-wrap {\n        .storage-icon {\n            .system-app-icon {\n                background: $dark-bg;\n                border-color: $dark-border;\n            }\n        }\n        .setting-gateway {\n            a {\n                color: $dark-textcolor;\n            }\n        }\n    }\n    .ip-wrap {\n        background: $gray-bg;\n        border-color: $dark-border;\n        .table-action {\n            .action-icon {\n                 background: $gray-bg;\n                 border-color: $dark-border;\n                 &:hover {\n                    background: $gray-bg;\n                    border-color: $dark-border;\n                 }\n            }\n        }\n    }\n    .action-drop {\n        .dropdown-item {\n            color: $dark-textcolor;\n            &:hover {\n                background: $gray-bg;\n                color: $white;\n            }\n        }\n    }\n    .notes-activity .note-download {\n        &:hover {\n            background-color: transparent;\n            a {\n                background: $darkmode-hover;\n                color: $dark-textcolor;\n            }\n        }\n        a {\n            background: $darkmode-hover;\n            color: $dark-textcolor;\n        }\n    }\n    .calls-box .caller-info .calls-action .dropdown-menu {\n        border-color: $dark-border;\n        .dropdown-item {\n             &:hover {\n                background: $gray-bg;\n                color: $white;\n            }\n        }\n    }\n    .bootstrap-tagsinput .tag {\n        background: $darkmode-hover;\n    }\n    .contacts-action .act-dropdown .dropdown-item {\n        color: $dark-textcolor;\n         &:hover {\n            background: $gray-bg;\n            color: $white;\n        }\n    }\n    .profile-pic-upload .profile-pic {\n        border-color: $dark-border;\n    }\n    .contact-wrap .contact-profile {\n        .avatar.company-avatar {\n            border-color: $dark-border;\n        }\n\n    }\n    .select2-container--default.select2-container--focus .select2-selection--multiple,\n    .select2-container--default .select2-selection--multiple {\n        border-color: $dark-border;\n    }\n    .select2-container--classic .select2-selection--multiple .select2-selection__choice, \n    .select2-container--default .select2-selection--multiple .select2-selection__choice, \n    .select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n        background: $darkmode-hover;\n        border-color: $dark-border;\n    }\n    .title-name {\n        color: $white !important;\n    }\n    .kanban-list-items {\n        border-color: $dark-border;\n        .kanban-list-head {\n            background: $gray-bg;\n            .kanban-action-btns .table-action .action-icon {\n                background: $gray-bg;\n                border-color: $dark-border;\n            }\n\n        }\n    }\n    .email-header .btn-white {\n        border-color: $dark-border;\n        color: $white;\n    }\n    .pipeline-list {\n        border-color: $dark-border;\n    }\n    .priority-info .dropdown .dropdown-toggle {\n        border-color: $dark-border;\n        color: $dark-textcolor;\n    }\n    .priority-info .dropdown a {\n        color: $dark-textcolor;\n    }\n    .pipeline-item {\n        border-color: $dark-border;\n        p {\n            color: $white;\n        }\n    }\n    .kanban-card {\n        background: $gray-bg;\n        border-color: $dark-border;\n        .kanban-card-body ul li {\n            color: $dark-textcolor;\n        }\n        .kanban-card-footer {\n            border-color: $dark-border;\n            span {\n                border-color: $dark-border;\n            }\n        }\n    }\n    .campaign-tab {\n        background: $gray-bg;\n        ul {\n            li {\n                a {\n                    border-color: transparent;\n                    &.active {\n                        color: $primary;\n                    }\n                    span {\n                         border-color: $dark-border;\n                    }\n                }\n            }\n        }\n    }\n    ul.project-mem li.more-set a {\n        background: $gray-bg;\n        border-color: $dark-border;\n        color: $dark-textcolor;\n    }\n    .pipeline-progress span, .task-info p,\n    .con-sidebar-title p, .task-actions ul li {\n        color: $white;\n    }\n    .contact-grid.project {\n        .grid-head {\n            background-color: $gray-bg;\n            .users-profile .con-avatar {\n                background-color: $dark-bg;\n                border-color: $dark-border;\n            }\n        }\n    }\n    .access-wrap li:hover {\n        background: $gray-bg;\n    }\n    .task-wrap {\n        background: $gray-bg;\n        border-color: $dark-border;\n    }\n    .rate-icon, .con-sidebar-title.border-line {\n        border-color: $dark-border;\n    }\n    .pipeline-list ul li a.bg-gray {\n        color: $title-color;\n    }\n    .task-wrapper .task-accordion span {\n        border-color: $dark-border;\n        color: $dark-textcolor;\n    }\n    .task-drops .dropdown-toggle {\n        background-color: transparent;\n    }\n    .task-wrapper {\n        border-color: $dark-border;\n    }\n    .card.analytics-card {\n        background-color: $dark-bg;\n        .card-header {\n            background: transparent;\n            .select2-container--default .select2-selection--single {\n                .select2-selection__rendered {\n                    color: $white;\n                }\n            }\n        }\n    }\n    .activities-list ul li {\n        background: $gray-bg;\n        .activity-name h5 {\n            color: $white;\n        }\n    }\n    .campaign-card ul .campaign-wrap {\n        background: $gray-bg;\n        .campaign-info {\n            border-color: $dark-border;\n            h5 {\n                color: $white;\n            } \n        }\n    }\n    .card.analytics-card .card-body .table {\n        th {\n            background: $dark;\n            color: $white;\n            &:first-child,&:last-child {\n                border-color: $dark-border;\n            }\n        }\n        td {\n            &:first-child, &:last-child  {\n                border-color: $dark-border;\n            }\n        }\n    }\n    .active-list ul li {\n        a {\n            background: $dark-input;\n            border-color: $dark-border;\n            color: $white;\n        }\n    }\n    .activity-title h4::after {\n        background: $dark-border;\n    }\n    .header-set {\n        border-color: $dark-border;\n        .select2-container--default .select2-selection--single .select2-selection__rendered {\n            color: $white;\n        }\n    }\n    .radio-activity li .active-type input[type=radio] ~ label {\n        background: $dark-input;\n        border-color: $dark-border;\n        color: $white;\n    }\n    .tab-activity {\n        box-shadow: none;\n        ul li a span {\n            color: $dark-textcolor;\n            border-color: $dark-border;\n        }\n    }\n    .report-header {\n        border-color: $dark-border;\n    }\n    .location-flag-img {\n        border-color: $dark-border;        \n    }\n    .table-imgname.flag-image {\n        span {\n            color: $white;\n        }\n    }\n    .membership-plans .plan-selected h4 {\n        color: $white;\n    }\n    .membership-plan-grid {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        .plan-price-head {\n            border-color: $dark-border;\n            .plan-type {\n                color: $white;\n            }\n        }\n        .plans-features ul li {\n            color: $white;\n        }\n        &.active {\n            background-color: $dark-bg;\n            .plan-price-head {\n                border-color: $dark-border;\n                .plan-type {\n                    color: $white;\n                }\n            }\n            .plans-features ul li {\n                color: $white;\n            }\n        }\n    }\n    .file-manager aside {\n        border-color: $dark-border;\n    }\n    .notes-dash {\n        background-color: $gray-bg;\n        .notes-top-head {\n            border-color: $dark-border;\n        }\n        .notes-top-head-submenu {\n            border-color: $dark-border;\n        }\n    }\n    .notes-page-wrapper .content .section-card-body .notes-card-details {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        box-shadow: none;\n    }\n    .search-set .search-input input[type=search] {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        &::placeholder {\n            color: $dark-textcolor;\n        }\n    }\n    .todo-wrapper-list {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n    }\n    .notes-page-wrapper .content {\n        .section-bulk-wrap {\n            background-color: $gray-bg;\n            box-shadow: none;\n        }\n        .page-add-notes {\n            border-color: $dark-border;\n        }\n        .section-notes-slider {\n            border-color: $dark-border;\n        }\n    }\n    .fc-day {\n        background-color: $gray-bg;\n    }\n    .file-manager .folders {\n        border-color: $dark-border;\n        background-color: $gray-bg;\n    }\n    .file-manager .accordion .accordion-item .accordion-body {\n        background: transparent;\n    }\n    table tbody td.action-table-data a {\n        background-color: $gray-bg;\n    }\n    .main-chat-blk .chat {\n        background-color: $gray-bg;\n    }\n    .main-chat-blk .chat .chat-header {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        box-shadow: none;\n    }\n    .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {\n        background-color: $gray-bg;\n    }\n    .main-chat-blk .chat-page-wrapper .left-chat-title {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n    }\n    .main-chat-blk .chat .chat-header .user-details h5 {\n        color: $white;\n    }\n    .main-chat-blk .sidebar .user-list li .users-list-body {\n        h5 {\n            color: $white;\n        }\n        p {\n            color: $dark-textcolor;\n        }\n    }\n    .main-chat-blk .chat-page-wrapper .setting-title-head h4 {\n        color: $white;\n    }\n    .main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {\n        color: $dark-textcolor !important;\n    }\n    .main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {\n        color: $white;\n    }\n    .main-chat-blk .sidebar .user-list li a {\n        border-color: $dark-border;\n    }\n    .main-chat-blk .last-seen {\n         color: $dark-textcolor;\n    }\n    .daterangepicker {\n        background-color: $gray-bg;\n        border-color: $dark-border;\n        &.show-ranges.ltr .drp-calendar.left {\n            border-color: $dark-border;\n        }\n        .drp-buttons {\n            border-color: $dark-border;\n            .btn-default {\n                color: $dark-textcolor;\n            }\n        }\n    } \n}\n\n[data-sidebar=\"sidebarbg1\"]{\n    .sidebar {\n        background-image: url(../../../../public/assets/img/theme/bg-1.png);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        .sidebar-menu{\n            background: rgba(255,255,255,0.85);\n        }\n    }\n}\n\n[data-sidebar=\"sidebarbg2\"]{\n    .sidebar {\n        background-image: url(../../../../public/assets/img/theme/bg-2.png);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        .sidebar-menu{\n            background: rgba(255,255,255,0.85);\n        }\n    }\n}\n\n[data-sidebar=\"sidebarbg3\"]{\n    .sidebar {\n        background-image: url(../../../../public/assets/img/theme/bg-3.png);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        .sidebar-menu{\n            background: rgba(255,255,255,0.85);\n        }\n    }\n}\n\n[data-sidebar=\"sidebarbg4\"]{\n    .sidebar {\n        background-image: url(../../../../public/assets/img/theme/bg-4.png);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: 50% 50%;\n        background-color: transparent;\n        .sidebar-menu{\n            background: rgba(255,255,255,0.85);\n        }\n    }\n}\n[data-theme=\"dark\"]{\n    .border,.border-top,.border-bottom,.border-start,.border-end {\n        border-color: $dark-border !important;\n    }\n    .dropdown .dropdown-toggle {\n        border-color: $dark-border;\n        color: $dark-textcolor;\n    }\n    .dropdown .dropdown-menu {\n        background: $dark;\n        border-color: $dark-border;\n    }\n    .bg-white {\n        background: $dark !important;\n    }\n    .bg-light-200,.bg-light-300,.bg-light-400 {\n        background: $dark-input;\n    }\n    .dropdown .dropdown-menu .dropdown-item {\n        background: $dark-input;\n    }\n    .offcanvas {\n        background: $dark;\n    }\n    .accordion-button:after {\n        background: transparent;\n    }\n    .bg-success.border {\n        border-color: $success !important;\n    }\n    .bg-purple.border {\n        border-color: $purple !important;\n    }\n    .bg-warning.border {\n        border-color: $warning !important;\n    }\n    .bg-danger.border {\n        border-color: $danger !important;\n    }\n    .btn-close {\n        --bs-btn-close-color: $dark-text;\n        color: $white;\n    }\n    .input-themeselect{\n        span{\n            color: $white;\n        }\n    }\n}\n \n",".sidebar-contact {\n    position: fixed;\n    top: 0%;\n    right: -350px;\n     transform: translateY(-50%); \n    width: 350px;\n    height: auto;\n    background: #fff;\n    box-sizing: border-box;\n    transition: 0.5s;\n    z-index: 9999;\n    .toggle-theme {\n        position: absolute;\n        width: 35px;\n        text-align: center;\n        cursor: pointer;\n        background: #fed713;\n        top: 225px;\n        right: 350px;\n        padding: 6px;\n        height: 35px;\n        color: #000;\n        border-top-left-radius: 3px;\n        border-bottom-left-radius: 3px;\n        .fa-spin {\n            -webkit-animation: fa-spin 2s infinite linear;\n            animation: fa-spin 2s infinite linear;\n        }\n    }\n    \n}      \n#theme-settings{\n    width: 26px;\n    height: 26px;\n    border: 1px solid $light-900;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50px;\n} \n.input-themeselect label {\n    width: 100%;\n}                                                                \n.sidebar-themesettings{\n    position: fixed;\n    right: -380px;\n    top: 0;\n    background: #fff;\n    transition: all 0.5s;\n    width: 380px;\n    height: 100vh;\n    z-index: 99999;\n    padding: 15px;\n    overflow: auto;\n    max-width: 100%;\n    &.open{\n        right: 0; \n    }\n    .themesettings-header{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding-bottom: 20px;\n        border-bottom: 1px solid $light-900;\n        h4{\n            color: $gray-900;\n            font-size: 18px;\n        }\n    }\n    .themesettings-inner{\n        padding: 24px;\n        background: #fff;\n        border: 1px solid $light-900;\n        border-radius: 5px;\n        margin-top: 15px;\n        padding-bottom: 9px;\n        .themesettings-content{\n            border-bottom: 1px solid $light-900;\n            margin-bottom: 15px;\n            h6{\n                font-size: 14px;\n                font-weight: 600;\n                color: #000; \n                margin-bottom: 15px;\n            }\n        }\n    }\n    .input-themeselect{\n        background: $light-500;\n        padding: 10px;\n        border-radius: 10px;\n        border:1px solid $light-900;\n        margin-bottom: 15px;\n        input[type=\"radio\"]{\n            display: none;\n            &:checked{\n                ~ label{\n                    .checkboxs-theme{\n                        &:after{\n                            background-color: $purple;\n                            border-color: $purple;\n                            content: \"\";\n                        }\n                        &::before{\n                            content: \"\\f00c\";\n                            font-family: \"Font Awesome 5 Free\";\n                            color: #fff;\n                            font-weight: 700;\n                            font-size: 10px;\n                            right: 4px;\n                            position: absolute;\n                            top: -14px;\n                            z-index: 9;\n                        }\n                    } \n                }\n            }\n        }\n        img{\n            height: 80px;\n        }\n        .checkboxs-theme{\n            position: relative;\n            width: 100%;\n            display: block;\n            &:after{\n                position: absolute;\n                content: \"\";\n                border: 1px solid #E8E8E8;\n                width: 16px;\n                height: 16px;\n                border-radius: 5px;\n                right: 0;\n                top: -17px;\n            }\n        }\n    }\n}\n.sidebar-themeoverlay{\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    background: rgba(0,0,0,0.75);\n    top: 0;\n    left: -100%;\n    z-index: 10000;\n    &.open{\n        left: 0;\n    }\n}\n.theme-colorsset{\n    margin: 15px 0;\n    ul{\n        display: flex;\n        align-items: center;\n        li{\n            .input-themeselects{\n                label{\n                    width: 30px;\n                    height: 30px;\n                    border-radius: 2px;\n                    position: relative;\n                    &.red-clr{\n                        background: $primary;\n                    }\n                    &.yellow-clr{\n                        background: $secondary;\n                    }\n                    &.blue-clr{\n                        background: #3C2371;\n                    }\n                    &.green-clr{\n                        background: #00918E;\n                    }\n                }\n                input[type=\"radio\"]{\n                    display: none;\n                    &:checked{\n                        ~ label{\n                            &:after{\n                                content: \"\\f00c\";\n                                font-family: \"Font Awesome 5 Free\";\n                                color: #fff;\n                                font-weight: 700;\n                                font-size: 12px;\n                                display: flex;\n                                align-items: center;\n                                justify-content: center;\n                                top: 50%;\n                                left: 50%;\n                                transform: translate(-50%,-50%);\n                                position: absolute;\n                            }\n                        }\n                    }\n                }\n            }\n            + li{\n                margin-left: 10px;\n            }\n        }\n    }\n}\n.themesettings-footer{\n    margin-top: 15px;\n    ul{\n        display: flex;\n        align-items: center;\n        li{\n            width: 50%;\n            + li{\n                margin-left: 10px;\n            }\n            .btn{\n                width: 100%;\n                font-size: 14px;\n                font-weight: 600;\n                padding: 8px;\n            }\n            .btn-cancel{\n                background: $light-500;\n                border: 1px solid $light-900;\n                color: $gray-900;\n                &:hover {\n                    background: $light-900;\n                }\n            }\n            .btn-reset{\n                background: $green;\n                color: #fff;\n                &:hover {\n                    background: #005e5c;\n                }\n            }\n        }\n    }\n}",".topnav-dropdown-header {\n    @include margin-padding(null, 15px);\n    border-bottom: 1px solid $light-900;\n    .notification-title {\n        font-size: $font-size-18;\n        font-weight: $font-weight-semibold;\n        color: $black;\n        margin-bottom: 0;\n    }\n}\n.notification-dropdown {\n    .noti-content {\n        width: 440px;\n        height: 390px;\n        overflow-y: auto;\n        position: relative;\n    }\n    .notification-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        li {\n            margin-top: 0;\n            border-bottom: 1px solid $light-600;\n            font-size: $font-size-base;\n            &:last-child {\n                border-bottom: 0;\n            }\n            a {\n                display: block;\n                @include margin-padding(null, 15px);\n            }\n            .avatar {\n                width: 36px;\n                height: 36px;\n                margin: 0 16px 0 0;\n                border-radius: $border-radius-lg;\n                position: relative;\n                img {\n                    border-radius: $border-radius-lg;\n                }\n                .badge {\n                    display: inline-block;\n                    position: absolute;\n                    top: -7px;\n                    left: -7px;\n                    padding: 4px;\n                }\n            }\n            .noti-title {\n                color: $gray-800;\n                font-weight: $font-weight-medium;\n            }\n            .noti-details {\n                font-weight: $font-weight-medium;\n                color: $gray-400;\n                @include margin-padding(0 0 8px, null);\n            }\n            .noti-sub-details {\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                display: -webkit-box;\n                color: $gray-400;\n                position: relative;\n                @include margin-padding(0 0 8px, 0 0 0 15px);\n                &::before {\n                    content: \"\";\n                    position: absolute;\n                    left: 0;\n                    width: 4px;\n                    height: -webkit-fill-available;\n                    background: $gray-400;\n                    border-radius: $border-radius-lg;\n                } \n            }\n            p.noti-time {\n                font-size: $font-size-12;\n                color: $gray-900;\n                @include margin-padding(0, null);\n            }\n            .noti-pdf {\n                display: -webkit-inline-box;\n                display: -ms-inline-flexbox;\n                display: inline-flex;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n                border: 1px solid $light-900;\n                border-radius: $border-radius-lg;\n                padding: 10px;\n                margin-bottom: 8px;\n                .noti-pdf-icon {\n                    margin-right: 10px;\n                    span {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n                        color: $primary;\n                        width: 24px;\n                        min-width: 24px;\n                        height: 24px;\n                        border: 1px solid $light-900;\n                        border-radius: $border-radius-lg;\n                    }\n                }\n                .noti-pdf-text {\n                    line-height: normal;\n                    p {\n                        font-size: $font-size-12;\n                        color: $gray-900;\n                        margin-bottom: 0;\n                    }\n                    span {\n                        font-size: $font-size-12;\n                        color: $text-color;\n                    }\n                }\n            }\n            .notification-time {\n                font-size: $font-size-12;\n                line-height: 1.35;\n                color: $gray-600;\n            }\n            .list-item {\n                border: 0;\n                padding: 0;\n                position: relative;\n                .list-left {\n                    height: 48px;\n                    position: absolute;\n                    width: 48px;\n                }\n                .list-body {\n                    @include margin-padding(null, 0 0 0 50px);\n                    .message-author {\n                        color: $gray-800;\n                        float: left;\n                        font-weight: $font-weight-medium;\n                        width: 175px;\n                        display: block;\n                        max-width: 100%;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        white-space: nowrap;\n                    }\n                    .message-time {\n                        color: $gray-600;\n                        float: right;\n                        font-size: $font-size-11;\n                    }\n                    .message-content {\n                        color: $gray-800;\n                        font-size: $font-size-13;\n                        display: block;\n                        max-width: 100%;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        white-space: nowrap;\n                    }\n                }\n            }\n        }\n    }\n}\n.topnav-dropdown-footer {\n    background: $light-200;\n    text-align: right;\n    @include margin-padding(null, 15px);\n    a {\n        font-weight: $font-weight-semibold;\n        margin-right: 15px;\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n    .view-link {\n        color: $gray-900;\n        &:hover {\n            color: $gray-400;\n        }\n    }\n    .clear-link {\n        color: $primary;\n        &:hover {\n            color: darken($primary, 10%);\n        }\n    }\n}\n.list-left {\n    height: 48px;\n    position: absolute;\n    width: 48px;\n}\n.list-body {\n    @include margin-padding(null, 0 0 0 50px);\n    .message-author {\n        color: $gray-800;\n        float: left;\n        font-weight: $font-weight-medium;\n        width: 175px;\n        display: block;\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    .message-time {\n        color: $gray-600;\n        float: right;\n        font-size: $font-size-11;\n    }\n    .message-content {\n        color: $gray-800;\n        font-size: $font-size-13;\n        display: block;\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n}\n.activity {\n    width: 100%;\n    .activity-box {\n        position: relative;\n    }\n    .activity-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        position: relative;\n        li {\n            background-color: $white;\n            position: relative;\n            border: 1px solid $gray-400;\n            @include margin-padding(0  0 10px,  20px 10px 10px);\n            font-size: $font-size-15;\n            .activity-user {\n                height: 50px;\n                margin: 0;\n                padding: 0;\n                width: 50px;\n                @include position(absolute,12px,null,null,8px);\n            }\n            .activity-content {\n                background-color: $white;\n                position: relative;\n                @include margin-padding(0 0 0 60px, 0);\n            }\n            .time {\n                color: $gray-500;\n                display: block;\n                font-size: $font-size-12;\n                line-height: 1.35;\n            }\n            a.name {\n                color: $black;;\n            }\n            a {\n                color: $secondary;\n                font-weight: $font-weight-semibold;\n                font-size: $font-size-15;\n                img{\n                    width:50px;\n                    height:50px;\n                    border-radius: 5px;\n                }\n            }\n        }\n    }\n}\n",".avatar {\n    position: relative;\n    height: 2.625rem;\n    width: 2.625rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: $border-radius;\n    color: $white;\n    font-weight: $font-weight-medium;\n    a.badge:hover {\n        color: $white;\n    }\n    img {\n        width: 100%;\n        height: 100%;\n        border-radius: $border-radius;\n    }\n    &.avatar-rounded {\n        border-radius: 50%;\n        img {\n            border-radius: 50%;\n        }\n    }\n    &.avatar-radius-0 {\n        border-radius: 0;\n        img {\n            border-radius: 0;\n        }\n    }\n    .avatar-badge {\n        position: absolute;\n        inset-block-start: -4%;\n        inset-inline-end: -0.375rem;\n        width: 1.4rem;\n        height: 1.4rem;\n        font-size: 0.625rem;\n        border: 2px solid $white;\n        border-radius: 50% !important;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    &.online,&.offline {\n        &:before {\n            position: absolute;\n            content: \"\";\n            width: 0.5rem;\n            height: 0.5rem;\n            border-radius: 50%;\n            inset-inline-end: 0;\n            inset-block-end: 0;\n            border: 2px solid $white !important;\n            z-index: 1;\n        }\n    }\n    &.online:before {\n        background-color: $success;\n    }\n    &.offline:before {\n        background-color: $gray-500;\n    }\n    &.avatar-xs {\n        width: 1.25rem;\n        height: 1.25rem;\n        line-height: 1.25rem;\n        font-size: 0.65rem;\n        .avatar-badge {\n            padding: 0.25rem;\n            width:  1rem;\n            height: 1rem;\n            line-height: 1rem;\n            font-size: 0.5rem;\n            inset-block-start: -25%;\n            inset-inline-end: -0.5rem;\n        }\n    }\n    &.avatar-sm {\n        width: 2rem;\n        height: 2rem;\n        line-height: 2rem;\n        font-size: 0.65rem;\n        .avatar-badge {\n            padding: 0.3rem;\n            width:  1.1rem;\n            height: 1.1rem;\n            line-height: 1.1rem;\n            font-size: 0.5rem;\n            inset-block-start: -28%;\n            inset-inline-end: -0.45rem;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.5rem;\n                height: 0.5rem;\n            }\n        }    \n    }\n    &.avatar-md {\n        width: 2.5rem;\n        height: 2.5rem;\n        line-height: 2.5rem;\n        font-size: 0.8rem;\n        .avatar-badge {\n            padding: 0.4rem;\n            width:  1.2rem;\n            height: 1.2rem;\n            line-height: 1.2rem;\n            font-size: 0.65rem;\n            inset-block-start: -6%;\n            inset-inline-end: -13%;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.75rem;\n                height: 0.75rem;\n            }\n        }    \n        svg {\n            width: 1.5rem;\n            height: 1.5rem;\n        }\n    }\n    &.avatar-lg {\n        width: 3rem;\n        height: 3rem;\n        line-height: 3rem;\n        font-size: 1rem;\n        .avatar-badge {\n            inset-block-start: -15%;\n            inset-inline-end: -0.25%;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.8rem;\n                height: 0.8rem;\n            }\n        }    \n        svg {\n            width: 1.8rem;\n            height: 1.8rem;\n        }\n    }\n    &.avatar-xl {\n        width: 4rem;\n        height: 4rem;\n        line-height: 4rem;\n        font-size: 1.25rem;\n        .avatar-badge {\n            inset-block-start: -8%;\n            inset-inline-end: -0.2%;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.95rem;\n                height: 0.95rem;\n            }\n        }    \n    }\n    &.avatar-xxl {\n        width: 5rem;\n        height: 5rem;\n        line-height: 5rem;\n        font-size: 1.5rem;\n        .avatar-badge {\n            inset-block-start: -4%;\n            inset-inline-end: 0rem;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 1.05rem;\n                height: 1.05rem;\n                inset-block-end: 0.25rem;\n            }\n            &.online-sm {\n                &:before {\n                    width: 10px;\n                    height: 10px;\n                    inset-block-end: 0rem;\n                }\n            }\n        }    \n    }\n    &.avatar-xxxl {\n        width: 6rem;\n        height: 6rem;\n        line-height: 6rem;\n        font-size: 1.75rem;\n        .avatar-badge {\n            inset-block-start: -4%;\n            inset-inline-end: 0rem;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 1.05rem;\n                height: 1.05rem;\n                inset-block-end: 0.25rem;\n            }\n        }    \n    }\n}\n.avatar-list-stacked {\n    padding: 0;\n    &.avatar-group-overlapped {\n        .avatar {\n            margin-right: -.875rem;\n            &:hover{\n                z-index:1;\n            }\n        }\n    }\t\n    &.avatar-group-lg {\n        .avatar { \n            width: 3.25rem;\n            height: 3.25rem;\n            >.initial-wrap {\n                font-size: .95rem;\n            }\n        }\n        &.avatar-group-overlapped .avatar {\n            margin-right: -1rem;\n        }\t\n    }\n    &.avatar-group-sm {\n        .avatar { \n            width: 2rem;\n            height: 2rem;\n            >.initial-wrap {\n                font-size: .6rem;\n            }\n        }\n        &.avatar-group-overlapped .avatar {\n            margin-right: -0.625rem;\n        }\t\n    }\n    &.avatar-group-xs {\n        .avatar {\n            width: 1.50rem;\n            height: 1.50rem;\n            >.initial-wrap {\n                font-size: .6rem;\n            }\n        }\n    }\n    .avatar {\n        margin-inline-end: -0.875rem !important;\n        border: 1px solid rgba(0,0,0,0.05);\n        vertical-align: middle;\n        transition: transform ease 200ms;\n        &:last-child {\n            margin-inline-end: 0 !important;\n        }\n        &:hover {\n            z-index: 1;\n            transform: translateY(-0.188rem);\n        }\n    }\n}\n.avatar-group {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t.avatar { \n\t\twidth: 2.625rem;\n\t\theight: 2.625rem;\n\t\t.avatar-img,\n\t\t>.initial-wrap {\n\t\t\tborder:2px solid $white;\n\t\t\tfont-size: .9rem;\n\t\t}\n\t}\n\t&.avatar-group-overlapped {\n\t\t.avatar {\n\t\t\tmargin-right: -.875rem;\n\t\t\t&:hover{\n\t\t\t\tz-index:1;\n\t\t\t}\n\t\t}\n\t}\t\n\t&.avatar-group-lg {\n\t\t.avatar { \n\t\t\twidth: 3.25rem;\n\t\t\theight: 3.25rem;\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: .95rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-group-overlapped .avatar {\n\t\t\tmargin-right: -1rem;\n\t\t}\t\n\t}\n\t&.avatar-group-sm {\n\t\t.avatar { \n\t\t\twidth: 2rem;\n\t\t\theight: 2rem;\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: .6rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-group-overlapped .avatar {\n\t\t\tmargin-right: -0.625rem;\n\t\t}\t\n\t}\n}\n.avatar-xxs {\n    width: 16px;\n    height: 16px;\n}",".bootstrap-datetimepicker-widget table td.active,\n.bootstrap-datetimepicker-widget table td.active:hover {\n\tbackground-color: $warning;\n\ttext-shadow: unset;\n}\n.bootstrap-datetimepicker-widget table td.today:before {\n\tborder-bottom-color: $warning;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {\n    background: transparent;\n}\n.bor-b1{\n    border-bottom: 1px solid $gray-300;\n}\n\n.link-purple {\n\tcolor: $purple;\n\t&:hover {\n\t  color: darken($purple, 2);\n\t}\n}\nhr {\n\tborder-color: $light-900;\n}",".btn-primary {\n    color: $white;\n    background-color: $primary;\n    border-color: $primary;\n    font-size: $font-size-14;\n    font-size: $font-size-14;\n}\n.btn-save {\n    background: $primary;\n    color: $white;\n    font-size: $font-size-14;\n    font-size: $font-size-14;\n    border-radius: 5px;\n    @include margin-padding(null, 8px 20px);\n    @include transition(all 0.2s ease);\n    &:hover{\n        background: $primary-hover;\n        color: $white;\n    }\n    @include respond-below(custom991) {\n        min-width: auto;\n        padding: 5px 7px;\n    }\n}\n.btn-reset {\n    background: $text-color;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    border-radius: 5px;\n    @include margin-padding(null, 8px 20px);\n    @include transition(all 0.2s ease);\n    &:hover{\n        background: $secondary;\n        color: $white;\n    }\n    @include respond-below(custom991) {\n        min-width: auto;\n        padding: 5px 7px;\n    }\n}\n.btn-send {\n    background: $primary;\n    @include margin-padding(null, 9px 14px);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    margin-right: 15px;\n    border-radius: 8px;\n    &:hover{\n        background: $primary-hover;\n        color: $white;\n    }\n    .send-mail {\n        margin-right: 10px;\n        width: 16px;\n        height: 16px;\n    }\n}\n.btn-download {\n    background: $secondary;\n    @include margin-padding(null, 9px 14px);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    margin-right: 15px;\n    border-radius: 8px;\n    &:hover{\n        background: $gray-900;\n        color: $white;\n     }\n    .download {\n        margin-right: 10px;\n        width: 16px;\n        height: 16px;\n    }    \n}\n.btn-barcode {\n    background: $danger;\n    @include margin-padding(null, 9px 14px);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    margin-right: 15px;\n    border-radius: 8px;\n    &:hover{\n        background: $danger;\n        color: $white;\n     }\n    .print {\n        margin-right: 10px;\n        width: 16px;\n        height: 16px;\n    }\n    \n}\n.btn-primary.add-em-payroll {\n    padding: 9px 11px;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    border-radius: 8px;\n    .me-2 {\n        width: 16px;\n        height: 16px;\n    }\n}\n.swal2-actions .swal2-confirm.btn:active {\n    background-color: $primary;\n    border-color: $primary;\n}\n.btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active {\n    background-color: $primary;\n    border-color: $primary;\n    color: $white;\n}\n.modal {\n    .card {\n        border: 0;\n    }\n}\n.search-input {\n    .btn-searchset {\n        &:active {\n            background-color: transparent;\n            border-color: transparent;\n            svg {\n                color: $secondary;\n            }\n        }\n    }\n}\n.input-blocks {\n    input[type=text] {\n        &.datetimepicker {\n            padding-left: 35px;\n        }\n    }\n}\n.iti__country-list {\n    z-index: 101;\n}\nbutton {\n    cursor: pointer;\n    &:focus{\n        outline: 0;\n        box-shadow: none;\n    }\n}\n.btn {\n    border-radius: $border-radius-lg;\n    padding: 0.625rem 1.25rem;\n    padding: 0.5rem 0.85rem;\n    font-size: 0.85rem;\n    transition: all 0.5s;\n    font-weight: $font-weight-semibold;\n    &:focus {\n        box-shadow: none !important;\n    }\n    &:hover {\n        transition: all 0.5s;\n    }\n    &.btn-lg {\n        padding: 0.65rem 1rem;\n        font-size: 0.95rem;\n    }\n    &.btn-sm {\n        padding: 0.25rem 0.5rem;\n        font-size: 0.75rem;\n    }\n    @each $color,\n    $value in $theme-colors {\n        &.btn-#{$color} {\n            background-color: #{$value};\n            border: 1px solid #{$value};\n            color: $white;\n            &:hover,\n            &:focus,\n            &.focus,\n            &:active,\n            &.active {\n                background-color: #{darken($value, 7%)};\n                border:1px solid #{darken($value, 7%)};\n                color: $white;\n            }\n        }\n    }\n    &.btn-light {\n        background-color: $light-400;\n        border: 1px solid $light-900;\n        color: $gray-900;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: darken($light-400, 3%);\n            border: 1px solid $light-900;\n            color: $gray-900;\n        }\n    }\n}\n\n.btn-group {\n    .btn {\n      padding: 0.45rem 0.75rem;\n    }\n  }\n  .btn-group-lg {\n    .btn {\n      padding: 0.65rem 1rem;\n    }\n  }\n  .btn-group-sm {\n    .btn {\n      padding: 0.25rem 0.5rem;\n    }\n  }\n.btn {\n    &.btn-w-xs {\n      min-width: 5.625rem;\n    }\n    &.btn-w-sm {\n      min-width: 6.975rem;\n    }\n    &.btn-w-md {\n      min-width: 8.125rem;\n    }\n    &.btn-w-lg {\n      min-width: 9.375rem;\n    }\n  }\n  .btn-icon {\n    i {\n      padding: 0rem;\n      margin: -0.5rem;\n    }\n    &.btn-sm {\n      width: 1.75rem;\n      height: 1.75rem;\n      font-size: 0.8rem;\n    }\n    &.btn-lg {\n      width: 2.75rem;\n      height: 2.75rem;\n      font-size: 1.2rem;\n    }\n  }\n  .btn-list {\n    > button, > a {\n      margin: 0 0.375rem 0.375rem 0;\n    }\n  }\n  [dir=\"rtl\"] {\n    .btn-list {\n      button,\n      div,\n      a,\n      input {\n        margin: 0 0 0.375rem 0.375rem;\n      }\n    }\n  }\n  \n  .btn-list {\n    margin-block-end: -0.5rem;\n  }\n  .btn-square {\n    border-radius: 0;\n}\n.btn-group-pill .btn:first-child {\n    border-radius: 60px 0 0 60px;\n  }\n  .btn-group-pill .btn:last-child {\n    border-radius: 0 60px 60px 0;\n  }\n  \n  .btn-group-square .btn:first-child {\n    border-radius: 0px 0 0 0px;\n  }\n  .btn-group-square .btn:last-child {\n    border-radius: 0 0px 0px 0;\n  }\n.btn {\n  &.btn-primary-light {\n    background-color: rgba($primary, 0.1);\n    color: $primary;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $primary;\n      color: $white;\n      border-color: $primary;\n    }\n  }\n \n  &.btn-secondary-light {\n    background-color: rgba($secondary, 0.1);\n    color: $secondary;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $secondary;\n      color: $white;\n      border-color: $secondary;\n    }\n  }\n  &.btn-warning-light {\n    background-color: rgba($warning, 0.1);\n    color: $warning;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $warning;\n      color: $white;\n      border-color: $warning;\n    }\n  }\n  &.btn-info-light {\n    background-color: rgba($info, 0.1);\n    color: $info;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $info;\n      color: $white;\n      border-color: $info;\n    }\n  }\n  &.btn-success-light {\n    background-color: rgba($success, 0.1);\n    color: $success;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $success;\n      color: $white;\n      border-color: $success;\n    }\n  }\n  &.btn-danger-light {\n    background-color: rgba($danger, 0.1);\n    color: $danger;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $danger;\n      color: $white;\n      border-color: $danger;\n    }\n  }\n}\n.btn {\n  &.btn-primary-ghost {\n    background-color: transparent;\n    color: $primary;\n    border: 1px solid $primary;\n    &:active {\n      color: $primary;\n      border: 1px solid $primary;\n      background-color: transparent;\n    }\n  }\n  &.btn-dark{\n    background: #131022 !important;\n    border-color: #131022 !important;\n    box-shadow: none;\n    color: #fff;\n    &:hover{\n      background: $primary;\n    }\n  }\n  &.btn-secondary-ghost {\n    background-color: transparent;\n    color: $secondary;\n    border: 1px solid $secondary;\n    &:active {\n      color: $secondary;\n      border: 1px solid $secondary;\n      background-color: transparent;\n    }\n  }\n  &.btn-warning-ghost {\n    background-color: transparent;\n    color: $warning;\n    border: 1px solid $warning;\n    &:active {\n      color: $warning;\n      border: 1px solid $warning;\n      background-color: transparent;\n    }\n  }\n  &.btn-info-ghost {\n    background-color: transparent;\n    color: $info;\n    border: 1px solid $info;\n    &:active {\n      color: $info;\n      border: 1px solid $info;\n      background-color: transparent;\n    }\n  }\n  &.btn-success-ghost {\n    background-color: transparent;\n    color: $success;\n    border: 1px solid $success;\n    &:active {\n      color: $success;\n      border: 1px solid $success;\n      background-color: transparent;\n    }\n  }\n  &.btn-danger-ghost {\n    background-color: transparent;\n    color: $danger;\n    border: 1px solid $danger;\n    &:active {\n      color: $danger;\n      border: 1px solid $danger;\n      background-color: transparent;\n    }\n  }\n}\n.btn-list {\n  button {\n    margin: 0 0.375rem 0.375rem 0;\n  }\n}\n.btn-outline-primary {\n    border: 1px solid $primary !important;\n    color: $primary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $primary !important;\n        border:1px solid $primary !important;\n        box-shadow: 0 3px 10px rgba($primary, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-secondary {\n    border: 1px solid $secondary !important;\n    color: $secondary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $secondary !important;\n        border:1px solid $secondary !important;\n        box-shadow: 0 3px 10px rgba($secondary, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-success {\n    border: 1px solid $success !important;\n    color: $success !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $success !important;\n        border:1px solid $success !important;\n        box-shadow: 0 3px 10px rgba($success, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-danger {\n    border: 1px solid $danger !important;\n    color: $danger !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $danger !important;\n        border:1px solid $danger !important;\n        box-shadow: 0 3px 10px rgba($danger, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-warning {\n    border: 1px solid $warning !important;\n    color: $warning !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $warning !important;\n        border:1px solid $warning !important;\n        box-shadow: 0 3px 10px rgba($warning, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-info {\n    border: 1px solid $info !important;\n    color: $info !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $info !important;\n        border:1px solid $info !important;\n        box-shadow: 0 3px 10px rgba($info, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-light {\n    border: 1px solid $light;\n    color: $gray-800 !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $light;\n        border: 1px solid $light;\n        color: $dark !important;\n    }\n}\n.btn-outline-dark {\n    border: 1px solid $dark !important;\n    color: $dark !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $dark !important;\n        border:1px solid $dark !important;\n        box-shadow: 0 3px 10px rgba($dark, 0.5);\n        color: $white !important;\n    }\n}\n.btn-soft-primary {\n    background-color: $primary-300 !important;\n    color: $primary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($primary, .2);\n       border-color: $primary;\n    }    \n}\n.btn-soft-secondary {\n    background-color: $secondary-300 !important;\n    color: $secondary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($secondary, .2);\n       border-color: $secondary;\n    }    \n}\n.btn-soft-success {\n    background-color: $success-300 !important;\n    color: $success !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($success, .2);\n       border-color: $success;\n    }    \n}\n.btn-soft-danger {\n    background-color: $danger-300 !important;\n    color: $danger !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($danger, .2);\n       border-color: $danger;\n    }    \n}\n.btn-soft-warning {\n    background-color: $warning-300 !important;\n    color: $warning !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($warning, .2);\n       border-color: $warning;\n    }    \n}\n.btn-soft-info {\n    background-color: rgba($info, 0.3) !important;\n    color: $info !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($info, .2);\n       border-color: $info;\n    }    \n}\n.btn-soft-light {\n    background-color: rgba($light, .9) !important;\n    color: $text-color !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($light, .2);\n       border-color: $light;\n       border-color: $text-color;\n    }    \n}\n.btn-soft-dark {\n    background-color: rgba($dark, 0.3) !important;\n    color: $white !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($dark, .2);\n       border-color: $dark;\n    }    \n}\n.custom-btn-close {\n  &.btn-close {\n    background-image: none;\n    transition: 0.5s all;\n    &:hover {\n      background: $danger;\n      color: $white;\n      border-color: $danger !important;\n      transition: 0.5s all;\n      transform: rotateZ(360deg);\n    }\n  }\n}\n.modal {\n  .custom-btn-close {\n    &.btn-close {\n      background-image: none;\n      transition: 0.5s all;\n      width: auto !important;\n      height: auto !important;\n      &:hover {\n        background: $danger !important;\n        color: $white !important;\n        border-color: $danger !important;\n        transition: 0.5s all;\n        transform: rotateZ(360deg);\n      }\n    }\n  }\n}\n.btn-purple-light {\n  background-color: $purple-100;\n  border-color: $purple-100;\n  color: $purple;\n  font-size: $font-size-14;\n  font-weight: $font-weight-medium;\n  border-radius: 5px;\n  @include margin-padding(null, 9px 20px);\n  @include transition(all 0.2s ease);\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;        \n  @include respond-below(custom991) {\n      @include margin-padding(null, 9px 14px);\n  }\n}\n$green-hover:  darken($green, 10%);\n.btn-primary {\n  background: $green;\n  border: 1px solid $green;\n  @include transition(all 0.2s ease);\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  &:hover, &:active{\n      background: #c11a06;\n      border-color: #c11a06;\n      color: $white;\n  }\n  @include respond-below(custom991) {\n      min-width: auto;\n  }\n}",".badge {\n    &.badge-primary {\n        background: rgba($primary, 0.1);\n        box-shadow: 0 1px 1px rgba($primary, 0.5);\n        color: $primary;\n        \n    }\n}\n@each $color, $value in $theme-colors {\n    .badge {\n        &.badge-#{$color} {\n            background: #{$value};\n            box-shadow: 0 1px 1px rgba($value, 0.5);\n            color: $white;\n        }\n        &.badge-soft-#{$color} {\n            background: rgba($value, 0.1);\n            box-shadow: 0 1px 1px rgba($value, 0.5);\n            color: $value;\n        }\n    }\n}\n.badge{\n    padding: .25rem .45rem;\n    text-transform:capitalize;\n    font-weight: $font-weight-semibold;\n    letter-spacing: 0.5px;\n    border-radius: $border-radius;\n    color: $gray-900;\n    &.badge-xs {\n        font-size: 10px;\n        padding: 0px 5px;\n        line-height: 18px;\n    }\n    &.badge-sm {\n        font-size: 11px;\n        padding: 5px 8px;\n        line-height: 11px;\n    }\n    &.badge-md {\n        font-size: 12px;\n        padding: 5px 12px;\n        line-height: 1.5;\n    }\n    &.badge-lg {\n        font-size: $font-size-14;\n        padding: 0px 10px;\n        line-height: 30px;\n    }\n    &.badge-xl {\n        font-size: $font-size-16;\n        padding: 0px 15px;\n        line-height: 35px;\n    }\n}\n\n.badge-soft-purple {\n    background: $purple-100;\n    color: $purple;\n    \n}\n.bg-light-danger {\n    background-color: $danger-100 !important;\n    .badge-dots{\n        background-color: $danger-900;\n    }\n}\n.bg-light-success {\n    background-color: $success-100 !important;\n    .badge-dots{\n        background-color: $success-900;\n    }\n}\n.bg-light-info {\n    background-color:$info-100 !important;\n    .badge-dots{\n        background-color: $info-900;\n    }\n}\n.bg-light-warning {\n    background-color: $warning-100 !important;\n    .badge-dots{\n        background-color: $warning-900;\n    }\n}\n.badge-danger-light{\n    background-color: $danger-100 !important;\n    color: $danger-900;\n}\n.badge-pending{\n\tbackground: #676DFF !important;\n    color: $white !important;\n}\n.badge-tertiary {\n    background: $tertiary;\n    color: $white;\n}\n.badge-status {\n    border-radius: 5px;\n    font-size: $font-size-12;\n    padding: 4px 8px;\n    min-width: 64px;\n    color: $white;\n}\n.badge-tag {\n    border-radius: 5px;\n    font-size: $font-size-12;\n    padding: 4px 4px;    \n    font-weight: $font-weight-normal;\n    &.badge-success-light {\n        background: $success-200;\n        color: $success;\n    }\n    &.badge-warning-light {\n        background: $warning-100;\n        color: $warning;\n    }\n    &.badge-purple-light {\n        background: $purple-100;\n        color: $purple;\n    }\n    &.badge-danger-light {\n        background: $danger-100;\n        color: $danger;\n    }\n}",".border-container {\n    display: inline-block;\n    width: 5rem;\n    height: 5rem;\n    margin: 0.25rem;\n    background-color: $light;\n}\n.border {\n    border: 1px solid $border-color !important;\n    &.border-dashed {\n        border-style: dashed !important;\n    }\n    &.border-dotted {\n        border-style: dotted !important;\n    }\n    &.border-primary {\n        border: 1px solid $primary !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($primary, 0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($primary, 0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($primary, 0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($primary, 0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($primary,1) !important;\n        }\n    }\n    &.border-secondary {\n        border: 1px solid $secondary !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($secondary,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($secondary,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($secondary,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($secondary,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($secondary,1) !important;\n        }\n    }\n    &.border-info {\n        border: 1px solid $info !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($info,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($info,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($info,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($info,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($info,1) !important;\n        }\n    }\n    &.border-success {\n        border: 1px solid $success !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($success,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($success,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($success,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($success,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($success,1) !important;\n        }\n    }\n    &.border-warning {\n        border: 1px solid $warning !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($warning,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($warning,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($warning,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($warning,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($warning,1) !important;\n        }\n    }\n    &.border-danger {\n        border: 1px solid $danger !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($danger,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($danger,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($danger,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($danger,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($danger,1) !important;\n        }\n    }\n    &.border-white {\n        border: 1px solid $white !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($white,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($white,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($white,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($white,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($white,1) !important;\n        }\n    }\n    &.border-light {\n        border: 1px solid $light !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($light,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($light,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($light,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($light,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($light,1) !important;\n        }\n    }\n    &.border-dark {\n        border: 1px solid $dark !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($dark,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($dark,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($dark,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($dark,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($dark,1) !important;\n        }\n    }\n    &.border-orange {\n        border: 1px solid $orange !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($orange,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($orange,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($orange,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($orange,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($orange,1) !important;\n        }\n    }\n    &.border-opacity-10 {\n        --bs-border-opacity: 0.1 !important;\n    }\n    &.border-opacity-25 {\n        --bs-border-opacity: 0.25 !important;\n    }\n    &.border-opacity-50 {\n        --bs-border-opacity: 0.5 !important;\n    }\n    &.border-opacity-75 {\n        --bs-border-opacity: 0.75 !important;\n    }\n    &.border-opacity-100 {\n        --bs-border-opacity: 1 !important;\n    }\n    &.border-1 {\n        border-width: 1px !important;\n    }\n    &.border-2 {\n        border-width: 2px !important;\n    }\n    &.border-3 {\n        border-width: 3px !important;\n    }\n    &.border-4 {\n        border-width: 4px !important;\n    }\n    &.border-5 {\n        border-width: 5px !important;\n    }\n    &.border-block-start-dashed {\n        border-top-style: dashed;\n    }\n    &.border-block-start-dotted {\n        border-top-style: dotted;\n    }\n    &.border-inline-end-dashed {\n        border-inline-end-style: dashed;\n    }\n    &.border-inline-end-dotted {\n        border-inline-end-style: dotted;\n    }\n    &.border-block-end-dashed {\n        border-bottom-style: dashed;\n    }\n    &.border-block-end-dotted {\n        border-bottom-style: dotted;\n    }\n    &.border-inline-start-dashed {\n        border-inline-start-style: dashed;\n    }\n    &.border-inline-start-dotted {\n        border-inline-start-style: dotted;\n    }\n    &.border-0 {\n        border: 0 !important;\n    }\n    &.border-top-0 {\n        border-block-start: 0 !important;\n    }\n    &.border-end-0 {\n        border-inline-end: 0 !important;\n    }\n    &.border-bottom-0 {\n        border-block-end: 0 !important;\n    }\n    &.border-start-0 {\n        border-inline-start: 0 !important;\n    }\n}\n.border-top {\n    border-top: 1px solid $border-color !important;\n    &.border-block-start-dashed {\n        border-top-style: dashed !important;\n    }\n    &.border-block-start-dotted {\n        border-top-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.border-end {   \n    border-inline-end: 1px solid $border-color !important;\n    &.border-inline-end-dashed {\n        border-inline-end-style: dashed !important;\n    }\n    &.border-inline-end-dotted {\n        border-inline-end-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.border-bottom {\n    border-bottom: 1px solid $border-color !important;\n    &.border-block-end-dashed {\n        border-bottom-style: dashed !important;\n    }\n    &.border-block-end-dotted {\n        border-bottom-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.border-start {\n    border-inline-start: 1px solid $border-color !important;\n    &.border-inline-start-dashed {\n        border-inline-start-style: dashed !important;\n    }\n    &.border-inline-start-dotted {\n        border-inline-start-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.br-1 {\n    border-radius: 0.0625rem;\n}\n.br-2 {\n    border-radius: 0.125rem;\n}\n.br-3 {\n    border-radius: 0.1875rem;\n}\n.br-4 {\n    border-radius: 0.25rem;\n}\n.br-5 {\n    border-radius: 0.3125rem;\n}\n.br-6 {\n    border-radius: 0.375rem;\n}\n.br-7 {\n    border-radius: 0.4375rem;\n}\n.br-8 {\n    border-radius: 0.5rem;\n}\n.br-9 {\n    border-radius: 0.5625rem;\n}\n.br-10 {\n    border-radius: 0.625rem;\n}\n.br-15 {\n    border-radius: 0.9375rem;\n}\n.br-20 {\n    border-radius: 1.25rem;\n}\n.rounded {\n    border-radius: $border-radius !important;\n}\n\n",".calendar-events {\n    border: 1px solid transparent;\n    cursor: move;\n\t@include margin-padding(null, 10px 15px);\n}\n.calendar-events:hover {\n\tborder-color: $gray-300;\n    background-color: $white;\n}\n.calendar-events i {\n    margin-right: 8px;\n}\n.calendar {\n\tfloat: left;\n\tmargin-bottom: 0;\n}\n.fc-toolbar.fc-header-toolbar {\n    margin-bottom: 1.5rem;\n}\n.none-border .modal-footer {\n\tborder-top: none;\n}\n.fc-toolbar h2 {\n\tfont-size: $font-size-18;\n\tfont-weight: $font-weight-semibold;\n\tfont-family: 'Roboto', sans-serif;\n\tline-height: 30px;\n\ttext-transform: uppercase;\n}\n.fc-day-grid-event .fc-time {\n\tfont-family: 'Roboto', sans-serif;\n}\n.fc-day {\n\tbackground: $white;\n}\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover,\n.fc-toolbar .ui-state-hover {\n\tz-index: 0;\n}\n.fc th.fc-widget-header {\n\tbackground: $light-500;\n\tfont-size: $font-size-14;\n\tline-height: 20px;\n\tpadding: 10px 0;\n\ttext-transform: uppercase;\n}\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n\tborder-color: #f3f3f3;\n}\n.fc-basic-view .fc-day-number, \n.fc-basic-view .fc-week-number {\n    padding: 2px 5px;\n}\n.fc-button {\n\tbackground: #f1f1f1;\n\tborder: none;\n\tcolor: #797979;\n\ttext-transform: capitalize;\n\tbox-shadow: none !important;\n\tborder-radius: 3px !important;\n\tmargin: 0 3px !important;\n\tpadding: 6px 12px !important;\n\theight: auto !important;\n}\n.fc-text-arrow {\n\tfont-family: inherit;\n\tfont-size: $font-size-16;\n}\n.fc-state-hover {\n\tbackground: #f3f3f3;\n}\n.fc-state-highlight {\n\tbackground: #f0f0f0;\n}\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n\tbackground-color: $primary !important;\n\tcolor: $white !important;\n\ttext-shadow: none !important;\n}\n.fc-cell-overlay {\n\tbackground: #f0f0f0;\n}\n.fc-unthemed .fc-today {\n\tbackground: $white;\n}\n.fc-event {\n\tborder-radius: 2px;\n\tborder: none;\n\tcolor: $white !important;\n\tcursor: move;\n\tfont-size: 13px;\n\tmargin: 1px 7px;\n\tpadding: 5px 5px;\n\ttext-align: center;\n}\n.fc-basic-view td.fc-week-number span {\n\tpadding-right: 8px;\n\tfont-weight: $font-weight-bold;\n\tfont-family: 'Roboto', sans-serif;\n}\n.fc-basic-view td.fc-day-number {\n\tpadding-right: 8px;\n\tfont-weight: $font-weight-bold;\n\tfont-family: 'Roboto', sans-serif;\n}\n.event-form .input-group .form-control {\n\theight: 40px;\n}\n.submit-section {\n\ttext-align: center;\n\tmargin-top: 40px;\n}\n.submit-btn {\n    border-radius: 50px;\n    font-size: $font-size-18;\n    font-weight: $font-weight-semibold;\n    min-width: 200px;\n    padding: 10px 20px;\n}",".apexcharts-legend.apexcharts-align-center.position-right {\n    display: none;\n}\n.apexcharts-toolbar {\n    display: none !important;\n}\n#sales_charts,\n.chart-set{\n    overflow: hidden;\n}\n.apexcharts-canvas {\n    width: 100% !important;\n}\n.h-250 {\n    height: 250px;\n}\n",".chat-user-actives {\n    .call-meet-blk {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $white;\n        border-radius: 5px;\n        margin-bottom: 15px;\n        padding: 10px;\n        @include transition(all 0.5s ease);\n        &:hover {\n            background-color: $black;\n            @include transition(all 0.5s ease);\n        }\n        .meet-border {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            width: 39px;\n            height: 39px;\n            background: $white;\n            border: 0.5px solid $gray-300;\n            border-radius: 10px;\n            margin-right: 10px;\n            svg {\n                width: 16px;\n                color: $blue;\n            }\n        }\n        .recent-user-titles {\n            h5 {\n                font-size: $font-size-base;\n                font-weight: $font-weight-semibold;\n                color: $black;\n                margin-bottom: 5px;\n                width: 150px;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n            p {\n                font-size: $font-size-10;\n                color: $text-color;\n            }\n        }\n    }\n}\n.new-join-link {\n    .chat-user-actives {\n        .meet-border {\n            background: gray;\n            border: 0;\n            border-radius: 6px;\n            &:hover {\n                background: $primary;\n                svg {\n                    color: $white;\n                }\n            }\n            svg {\n                color: $primary;\n            }\n        }\n        .recent-user-titles {\n            h5 {\n                color: $primary;\n                width: 100%;\n                margin-bottom: 0;\n                font-size: $font-size-15;\n            }\n        }\n    }\n}\n.meet-chat-blk {\n    .join-call {\n        .join-video {\n            position: relative;\n            margin-bottom: 25px;\n            img {\n                border-radius: 10px;\n            }\n            .video-avatar {\n                color: $white;\n                background: #5D5D5D;\n                font-size: 50px;\n                border-radius: 10px;\n                height: 100%;\n                width: 100%;\n                position: absolute;\n                top: 0;\n                left: 0;\n                display: none;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                &.active {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    position: relative;\n                    height: 426px;\n                }\n            }\n            .call-icons {\n                text-align: center;\n                position: absolute;\n                width: 100%;\n                height: 100%;\n                top: 0;\n                .call-items {\n                    border-radius: 5px;\n                    padding: 0;\n                    margin: 0;\n                    list-style: none;\n                    display: -webkit-inline-box;\n                    display: -ms-inline-flexbox;\n                    display: inline-flex;\n                    position: absolute;\n                    bottom: 30px;\n                    left: 50%;\n                    transform: translate(-50%, 0);\n                    .call-item {\n                        display: inline-block;\n                        text-align: center;\n                        margin-right: 15px;\n                        &:last-child {\n                            margin-right: 0px;\n                        }\n                        a {\n                            color: $white;\n                            background: $white;\n                            border-radius: 10px;\n                            width: 54px;\n                            height: 54px;\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            justify-content: center;\n                            -webkit-justify-content: center;\n                            -ms-flex-pack: center;\n                            font-size: $font-size-20;\n                            white-space: nowrap;\n                            @include respond-below(custom767) {\n                                width: 45px;\n                                height: 45px;\n                            }\n                            i {\n                                color: $text-color;\n                            }\n                            &.stop {\n                                color: $white;\n                                background: $danger;\n                                i {\n                                    color: $white;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            .meet-drop {\n                ul {\n                    li {\n                        i {\n                            font-size: $font-size-18;\n                        }\n                    }\n                }\n            }\n            \n        }\n        .join-content {\n            text-align: center;\n            max-width: 500px;\n            margin: auto;\n            h4 {\n                font-size: $font-size-22;\n                font-weight: $font-weight-semibold;\n                margin-bottom: 20px;\n                @include respond-below(custom767) {\n                    font-size: $font-size-18;\n                }\n            }\n            .event-user-group {\n                margin-bottom: 10px;\n                .avatar-group {\n                    .avatar {\n                        width: 38px;\n                        height: 38px;\n                        border: 3px solid $white;\n                        &+.avatar {\n                            margin-left: -20px;\n                        }\n                        .avatar-title {\n                            color: $black;\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-semibold;\n                            background: gray;\n                        }\n                    }\n                }\n            }\n            p {\n                font-size: $font-size-13;\n                color: $text-color;\n            }\n            .btn-join-call {\n                .btn-primary {\n                    background: $primary;\n                    border-radius: 6px 6px 6px 6px;\n                    color: $white;\n                    font-size: $font-size-base;\n                    border: 1px solid $primary;\n                    font-weight: $font-weight-semibold;\n                    min-width: 105px;\n                    padding: 8px 15px;\n                    &:hover {\n                        background: $danger;\n                        border: 1px solid gray;\n                        color: $primary;\n                    }\n                }\n            }\n        }\n    }\n}\n.conference-meet-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    .meeting-list {\n        width: 100%;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        &.add-meeting {\n            width: 65%;\n            margin-right: 24px;\n            @include respond-below(custom767) {\n                display: none;\n                margin-right: 0px;\n            }\n        }\n    }\n    .right-user-side {\n        width: 0;\n        opacity: 0;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        &.right-side-party {\n            width: 0;\n            opacity: 0;\n            transition: all 0.5s ease;\n            -moz-transition: all 0.5s ease;\n            -o-transition: all 0.5s ease;\n            -ms-transition: all 0.5s ease;\n            -webkit-transition: all 0.5s ease;\n            .party-msg-blk  {\n                .last-call-time {\n                    .call-recent {\n                        background: none;\n                        svg {\n                            color: $primary;\n                            width: 14px;\n                        }\n                    }\n                }\n            }\n        }\n        &.chat-rooms {\n            width: 0;\n            opacity: 0;\n            transition: all 0.5s ease;\n            -moz-transition: all 0.5s ease;\n            -o-transition: all 0.5s ease;\n            -ms-transition: all 0.5s ease;\n            -webkit-transition: all 0.5s ease;\n            .slime-grp {\n                padding: 0;\n                .left-chat-title {\n                    padding: 20px;\n                    border-bottom: 1px solid #E1E8ED;\n                    border-radius: 10px 10px 0 0;\n                }\n            }\n            &.open-chats {\n                width: 35%;\n                opacity: 1;\n                @include respond-below(custom767) {\n                    width: 100%;\n                }\n            }\n        }\n        &.open-message {\n            width: 35%;\n            opacity: 1;\n            @include respond-below(custom767) {\n                width: 100%;\n            }\n        }\n    }\n}\n.meet-drop {\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 10px;\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    ul {\n        li {\n            .chats-dot {\n                a {\n                    width: 50px;\n                    height: 50px;\n                    color: #6B7280;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    @include respond-below(custom767) {\n                        width: 38px;\n                        height: 38px;\n                    }\n                }\n            }\n        }\n    }\n    &.meet-mutes {\n        background: $primary;\n        right: inherit;\n        left: 20px;\n        ul {\n            li {\n                a {\n                    color: $white;\n                    width: 50px;\n                    height: 50px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    @include respond-below(custom767) {\n                        width: 38px;\n                        height: 38px;\n                    }\n                }\n            }\n        }\n    }\n    &.meet-mutes-bottom {\n        background: $primary;\n        bottom: 20px;\n        border-radius: 50px;\n        top: inherit;\n        ul {\n            li {\n                a {\n                    color: $white;\n                    width: 50px;\n                    height: 50px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    @include respond-below(custom767) {\n                        width: 38px;\n                        height: 38px;\n                    }\n                    i {\n                        font-size: $font-size-20;\n                    }\n                }\n            }\n        }\n    }\n}\n.meet-call-menu-blk {\n    .video-call-action {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        @include respond-below(custom767) {\n            display: block;\n        }\n        ul {\n\t\t\tdisplay: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            li {\n                margin-right: 5px;\n                &:last-child {\n                    margin-right: 0;\n                }\n                a {\n                    width: 40px;\n                    height: 40px;\n                    border-radius: 50px;\n                    background: #D9D9D9;\n                    border: 1px solid #D9D9D9;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    color: $black;\n\t\t\t\t\tfont-size: $font-size-18;\n                    &.call-end {\n                        background-color: $danger;\n                        border-color: $danger;\n                        color: $white;\n\t\t\t\t\t\twidth: 60px;\n                    \theight: 60px;\n\t\t\t\t\t\trotate: 135deg;\n\t\t\t\t\t\tfont-size: $font-size-20;\n                    }\n                    &.stop {\n                        color: $white;\n                        background: $danger;\n                        border-color: $danger;\n                        i {\n                            color: $white;\n                        }\n                    }\n                }\n                &.active {\n                    a {\n                        background: $primary;\n                        border-color: $primary;\n                        color: $white;\n                        img {\n                            filter: invert(1) brightness(100);\n                        }\n                    }\n                }\n            }\n            @include respond-below(custom767) {\n                margin-bottom: 5px;\n                justify-content: center;\n            }\n            &:last-child {\n                @include respond-below(custom767) {\n                    margin-bottom: 0px;\n                }\n            }\n        }\n    }\n}\n.recession-meet-blk {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    margin-bottom: 30px;\n    @include respond-below(custom767) {\n        display: block;\n    }\n    .reccession-head {\n        @include respond-below(custom767) {\n            margin-bottom: 5px;\n        }\n        h5 {\n            font-size: $font-size-20;\n            font-weight: $font-weight-bold;\n\t\t\tcolor: $gray-900;\n            margin-bottom: 0px;\n            @include respond-below(custom767) {\n                font-size: $font-size-18;\n            }\n        }\n        ul {\n            li {\n                font-size: $font-size-15;\n                font-weight: $font-weight-normal;\n                color: $text-color;\n                margin-right: 25px;\n                &:last-child {\n                    margin-right: 0px;\n                }\n                @include respond-below(custom767) {\n                    margin-bottom: 10px\n                }\n            }\n        }\n    }\n    .partispant-blk {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        .btn-primary {\n            background: #1b2950;\n            border-radius: 6px;\n            color: $white;\n            border: 1px solid #1b2950;\n            margin-right: 10px;\n            font-weight: $font-weight-bold;\n            font-size: $font-size-base;\n\t\t\t&:hover {\n\t\t\t\tbackground: $primary;\n\t\t\t\tborder: 1px solid $primary;\n\t\t\t}\n            @include respond-below(custom767) {\n                font-size: $font-size-13;\n            }\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n        span {\n            a {\n                width: 42px;\n                height: 42px;\n                background: $light-900;\n                border-radius: 5px;\n                color: $text-color;\n\t\t\t\tfont-size: $font-size-18;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: $primary;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t}\n            }\n        }\n    }\n}\n.recording-time {\n    position: relative;\n    padding-left: 20px;\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 0px;\n        top: 4px;\n        background-color: $danger;\n        width: 13px;\n        height: 13px;\n        border-radius: 50px;\n    }\n    &::after {\n        content: \"\";\n        position: absolute;\n        left: 3px;\n        top: 7px;\n        background-color: $white;\n        width: 7px;\n        height: 7px;\n        border-radius: 50px;\n        animation: blink-animation 1.5s steps(5, start) infinite;\n        -webkit-animation: blink-animation 1.5s steps(5, start) infinite;\n    }\n}\n\n.page-content {\n\twidth: 100%;\n}\n.join-call {\n    width: 100%;\n    margin: 0 auto;\n}\n.join-video {\n\tposition: relative;\n\tmargin-bottom: 25px;\n    img {\n        border-radius: 10px;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    &.join-video-front {\n        img {\n            height: 423px;\n        }      \n    }\n}\n.video-avatar {\n    color: $white;\n    background: #5D5D5D;\n    font-size: 50px;\n    border-radius: 10px;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: none;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    h4 {\n        font-weight: $font-weight-bold;\n        font-size: $font-size-24;\n        color: $white;\n    }\n}\n.video-avatar.active {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.join-video.video-hide > img, \n.video-wrap.video-hide > video {\n    display: none;\n}\n.join-content {\n    p {\n        font-weight: $font-weight-normal;\n        font-size: $font-size-14;\n        margin-bottom: 25px;\n        color: $black;\n    }\n    label {\n        font-size: $font-size-18;\n        margin-bottom: 0;\n        color: $black;\n        font-weight: $font-weight-bold;\n    }\n}\n.part-name {\n\tposition: absolute;\n\ttop: 20px;\n\tleft: 12px;\n\ttext-align: left;\n    background: rgba(255, 255, 255, 0.6);\n    border-radius: 50px;\n    padding: 5px 15px;\n    h4 {\n        font-weight: $font-weight-medium;\n        font-size: $font-size-15;\n        color: $text-color; \n        margin-bottom: 0;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        @include respond-below(custom767) {\n            font-size: $font-size-13;\n        }\n    }\n    &.sub-part-name {\n        background: $white;\n        bottom: 10px;\n        top: inherit;\n        h4 {\n            color: $gray-900;\n            font-size: $font-size-12;\n        }\n    }\n}\n.grid-join {\n    .part-name {\n        background: rgba(0, 0, 0, 0.3);\n        top: inherit;\n        bottom: 20px;\n        h4 {\n            color: $white;\n        }\n    }\n}\n.join-hover-img {\n    position: absolute;\n    @include position-alignment(both);\n    .event-user-group {\n        .avatar-group {\n            background: rgba(0, 0, 0, 0.3);\n            padding: 2px 10px;\n            border-radius: 50px;\n            .avatar {\n                width: 26px;\n                height: 26px;\n                border: 1px solid $white;\n                &+.avatar {\n                    margin-left: -16px;\n                }\n                &:last-child {\n                    margin-right: 0px;\n                }\n                .avatar-title {\n                    color: #1F2937;\n                    font-size: 12px;\n                    font-weight: $font-weight-semibold;\n                    background: #F3F4F6;\n                }\n            }\n        }\n    }\n}\n.more-icon {\n\tposition: absolute;\n\tbottom: 10px;\n\tright: 12px;\n    @include respond-below(custom767) {\n        bottom: 8px;\n        right: 13px;\n    }\n    a {\n        color: $text-color;\n        width: 30px;\n        height: 30px;\n        background: $white;\n        border-radius: 50px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        &:hover {\n            opacity: 0.8;\n        }\n        &.other-mic-off {\n            &.stop {\n                i {\n                    color: $danger;\n                }\n            }\n        }\n    }\n    &.audio-more-icon {\n        a {\n            &.other-mic-off {\n                &.stop {\n                    background-color: $danger !important;\n                    i {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n}\n.call-recent {\n    &.recent-part {\n        a {\n            &.other-mic-off, &.other-video-off {\n                &.stop {\n                    background: $danger !important;\n                    i {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n}\n.meeting {\n    .part-name {\n        top: 15px;\n        left: 15px;\n    }\n    .more-icon {\n        top: 15px;\n        right: 15px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n}\n.vertical-view {\n    .vertical-sec {\n        .part-name {\n            h4 {\n                font-size: $font-size-14;\n\t            font-weight: $font-weight-normal;\n            }\n        }\n    }\n}\n.horizontal-view {\n    .join-video {\n        &.single-user {\n            .part-name h4 {\n                font-size: $font-size-14;\n                font-weight: $font-weight-normal;\n            }\n        }\n    }\n}\n.meeting-wrapper, .meeting {\n\twidth: inherit;\n\tmax-width: inherit;\n}\n.meet-footer {\n\tposition: fixed;\n\tbottom: 25px;    \n\twidth: 100%;\n\tmax-width: 950px;\n\tleft: 50%;\n    transform: translate(-50%, 0);\n\tz-index: 3;\n}\n.show-chat-list, .show-invite-list,\n.show-chat-list .user-sidebar-right,\n.show-invite-list .invite-sidebar-right {\n    transition: all 0.8s ease;\n}\n.user-sidebar-right, .invite-sidebar-right {\n    background: #dedede;\n\tborder-radius: 10px;\n    width: 410px;\n    position: absolute;\n    top: 105px;\n    bottom: 117px;\n    right: 0;\n    margin-right: -410px;\n    transition: all 0.8s ease;\n    overflow: hidden;\n    font-size: 13px;\n\tz-index: 3;\n}\n.join-contents {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-content: flex-start;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\tmargin: 0 auto;\n\toverflow: hidden;\n    &.grid-view {\n        align-content: center;\n    }\n}\n.ripple {\n\twidth: 114px;\n    height: 114px;\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 50%;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n.multigrid-view {\n    .text-box {\n        height: 61px;\n        width: 61px;\n    }\n}\n.multigrid-view {\n    .ripple {\n        width: 80px;\n        height: 80px;\n        background: rgba(0, 0, 0, 0.2);\n        border-radius: 50%;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        -webkit-box-pack: center;\n        -ms-flex-pack: center;\n        justify-content: center;\n    }\n}\n.meeting {\n    .join-video {\n        margin: 0 5px 10px;\t\n        width: 100%;\n    }\n}\n.join-video {\n    &.user-active {\n        background: #415B6A;\n        border-radius: 10px;\n        width: 100%;\n        height: 370px;\n        &.audio-calls {\n            height: 520px;\n        }\n    }\n    &.vertical-active {\n        margin-right: 24px;\n    }\n    &.single-user {\n        width: 100%;\t\n        min-height: 230px;\n        box-sizing: border-box;\n        margin-right: 24px;\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        justify-content: space-between;\n        text-align: center;\n        height: auto;\n        background: #415B6A;\n        border-radius: 10px;\n        padding: 0;\n        flex-grow: 1;\n        @include respond-below(custom1280) {\n            width: 100%;\n        }\n        @include respond-below(custom1199) {\n            min-height: 203px;\n        }\n        @include respond-below(custom991) {\n            min-height: 230px;\n        }\n        &:nth-child(even) {\n            margin-right: 0px;\n            @include respond-below(custom767) {\n                margin-right: 10px;\n            }\n        }\n        @include respond-below(custom767) {\n            width: 100%;\n            min-height: 257px;\n        }\n    }\n\n}\n.multi-grid {\n    .join-video.single-user {\n        @include respond-below(custom767) {\n           width: 45%;\n        }\n        &:nth-child(even) {\n            margin-right: 24px;\n            @include respond-below(custom767) {\n                margin-right: 0px;\n            }\n        }\n        &:nth-child(4n) {\n            margin-right: 0px;\n            @include respond-below(custom767) {\n                &:nth-child(4n) {\n                    margin-right: 0px;\n                }\n            }\n        }\n    }\n}\n.multigrid-view {\n    .join-video {\n        &.single-user {\n            flex-grow: 0;\n        }\n    }\n}\n.horizontal-view {\n    .join-video.single-user {\n        &:nth-child(even) {\n            margin-right: 24px;\n        }\n        &:nth-child(5) {\n            margin-right: 0px;\n        }\n        &:nth-child(3n) {\n            @include respond-below(custom767) {\n                margin-right: 0\n            }\n        }\n    }\n}\n.text-avatar {\n\tcolor: $white;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    h4 {\n        color: $white;\n    }\n}\n.text-box {\n    height: 86px;\n    width: 86px;\t\n    border-radius: 50%;\n    background-color: rgba(0, 0, 0, 0.2);\n    font-size: $font-size-36;\n\tfont-weight: $font-weight-bold;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n.more-icon.mic-view .mic-on, .more-icon .mic-off {\n\tdisplay: none;\n}\n.more-icon.mic-view .mic-off {\n    display: inline-flex;\n}\n.grid-view .join-video.single-user {\n    width: 47%;\t\n    @include respond-below(custom767) {\n        width: 40%;\t\n    }\n    &:nth-child(2n) {\n        @include respond-below(custom767) {\n            margin-right: 0px;\n        }\n    }\n    &:nth-child(3n) {\n        @include respond-below(custom767) {\n            margin-right: 24px;\n        }\n    }\n}\n\n.join-contents.multigrid-view {\n\tmax-width: 100%;\n\tjustify-content: center;\n}\n.meeting {\t\n\tposition: absolute;\n\ttop: 80px;\n\tbottom: 107px;\n\tleft: 0;\n\tright: 0;\n}\n.meeting-list {\n\tflex-direction: column;\n\theight: 100%;\n\twidth: 100%;\n\tposition: relative;\n}\n.user-active {\n    .more-icon {\n        .handraise-on {\n            display: none;\n            &.active {\n                display: block;\n                animation: mymove 5s;\n            }\n        }\n    }\n}\n.user-active .more-icon .handraise-on.active .meeting .join-video.user-active::before {\n\tanimation: mymove 5s infinite;\n\topacity: 1;\n}\n@keyframes mymove {\n\tfrom {color: #0074E0;}\n\tto {color: transparent;}\n}\n.join-contents {\n    &.vertical-view {\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        align-content: center;\n        max-width: 1300px;\n        @include respond-below(custom767) {\n            display: block;\n        }\n        .join-video {\n            &.user-active {\n                flex: 1;\n                margin-bottom: 24px;;\n            }\n            &.single-user {\n                width: 97%;\n                flex-grow: 1;\n                display: flex;\n                @include respond-below(custom767) {\n                    width: 100%;\n                }\n            }\n        }\n        .vertical-sec {\n            width: 20%;\n            @include respond-below(custom991) {\n                width: 30%;\n            }\n            @include respond-below(custom767) {\n                width: 100%;\n            }\n        }\n    }\n    &.vertical {\n        flex-direction: column;\n        height: 200px;\n    }\n}\n.meeting .join-contents.vertical .join-video.user-active {\n\tflex: 1 0 100%;\n}\n.meeting .join-contents.vertical .join-video.single-user {\n\tflex: 0;\n}\n.meeting .join-contents.vertical .join-video {\n\twidth: auto;\n}\n.chat-footer .btn:hover {\n\tbackground: #0066c5;\n\tcolor: $white;\n}\n.join-contents {\n    &.show-whiteboard {\n        display: none;\n    }\n    &.single-view {\n        padding-top: 0;\n        margin-top: 25px;\n        position: relative;\n        .single-user {\n            position: absolute;\n            right: 8px;\n            top: 40px;\n            width: 130px;\n            height: 130px ;\n            min-height: 130px ;\n            img {\n                height: 130px ;\t\n            }\n        }\n    }\n}\n.record-time {\n    position: absolute;\n    top: 20px;\n    z-index: 1;\n    position: absolute;\n    left: 20px;\n\tspan {\n\t\tbackground-color: rgba(255, 255, 255, 0.2);\n\t\tdisplay: inline-block;\n\t\tborder-radius: 130px;\n\t\tcolor: $white;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-semibold;\n\t\twidth: 80px;\n\t\theight: 30px;\n\t\ttext-align: center;\n\t\tline-height: 34px;\n\t\tposition: relative;\n\t\tpadding-left: 15px;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 7px;\n\t\t\ttop: 7px;\n\t\t\tbackground-color: $white;\n\t\t\twidth: 18px;\n\t\t\theight: 18px;\n\t\t\tborder-radius: 50px;\n\t\t}\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 12px;\n\t\t\ttop: 12px;\n\t\t\tbackground-color: $danger;\n\t\t\twidth: 8px;\n\t\t\theight: 8px;\n\t\t\tborder-radius: 50px;\n\t\t\tanimation: blink-animation 1.5s steps(5, start) infinite;\n\t\t\t-webkit-animation: blink-animation 1.5s steps(5, start) infinite;\n\t\t}\n\t}\n}\n\n@keyframes blink-animation {\n\tto {\n\t\tvisibility: hidden;\n\t}\n}\n\n@-webkit-keyframes blink-animation {\n\tto {\n\t\tvisibility: hidden;\n\t}\n}\n.volume-col {\n\tposition: absolute;\n\tleft: 20px;\n\tbottom: 20px;\n}\n.volume-col .inner-volume-col {\n\tbackground-color: $gray-300;\n    border-radius: 130px;\n    width: 30px;\n    height: 120px;\n    position: relative;\n    z-index: 9;\n}\n.volume-col #volume {\n\tposition: absolute;\n    left: 50%;\n    top: 15px;\n    margin: 0 auto;\n    height: 80px;\n    width: 5px;\n    background: $white;\n    border-radius: 15px;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n}\n.volume-col #volume .ui-slider-range-min {\n\theight: 5px;\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    background: $primary;\n    border: none;\n    border-radius: 10px;\n    outline: none;\n}\n.volume-col #volume .ui-slider-handle {\n\twidth: 20px;\n    height: 20px;\n    border-radius: 20px;\n    background: $primary;\n    position: absolute;\n    left: 50%;\n    margin-top: -8px;\n    cursor: pointer;\n    outline: none;\n    transform: translateX(-50%);\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n}\n.volume-col #player {\n\twidth: auto;\n    height: 104px;\n    position: relative;\n    margin: 0 auto;\n    top: 0px;\n}\n\n.volume-col #player i {\n\tposition: absolute;\n\tmargin-top: -6px;\n\tcolor: #666;\n}\n\n.volume-col .volume-icons {\n\tcolor: $white;\n\tmargin-left: 0px;\n\tfont-size: $font-size-18;\n\tmargin-top: 22px;\n}\n.chat-msg-blk {\n    padding: 15px;\n    .chats {\n        max-width: 100%;\n        margin-bottom: 1.5rem;\n        display: flex;\n        display: -webkit-flex;\n        @include respond-below(custom767) {\n            max-width: 100%;\n        }\n        .chat-action-btns {\n            .chat-user-time {\n                .chats-dot {\n                    a {\n                        color: $green;\n                    }\n                }\n            }\n        }\n        &.chats-right {\n            margin-left: auto;\n            flex-direction: row-reverse;\n            -webkit-flex-direction: row-reverse;\n            .chat-content {\n                order: 1;\n                -webkit-order: 1;\n                .message-content {\n                    background-color: $light-900;\n                    border-radius: 8px;\n                    .chat-time {\n                        justify-content: flex-start;\n                        -webkit-justify-content: flex-start;\n                    }\n                    .download-col {\n                        position: relative;\n                         ul {\n                            li {\n                                margin-right: 8px;\n                                &:last-child {\n                                    margin-right: 0px;\n                                }\n                                .image-download-col {\n                                    position: relative;\n                                    &.image-not-download {\n                                        a {\n                                            img {\n                                                -webkit-filter: blur(4px);\n                                                filter: blur(1px);\n                                                border-color: $black;\n                                            }\n                                        }\n                                        span {\n                                            position: absolute;\n                                            @include position-alignment(both);\n                                            i {\n                                                color: $white;\n                                            }\n                                        }\n                                    }\n                                    .download-action {\n                                        position: absolute;\n                                        right: 8px;\n                                        bottom: 8px;\n                                        line-height: 0;\n                                        a {\n                                            color: $white;\n                                            font-size: 10px;\n                                        }\n                                    }\n                                    img {\n                                        border-radius: 5px;\n                                    }\n                                }\n                            }\n                         }\n                    }\n                    &::before {\n                        border-bottom: 6px solid transparent;\n                        border-left: 6px solid $light-900;\n                        border-right: 0;\n                        border-top: 6px solid transparent;\n                        content: \"\";\n                        height: 0;\n                        width: 0;\n                        position: absolute;\n                        top: 8px;\n                        right: -4px;\n                        left: auto;\n                    }\n                }\n            }\n            .chat-avatar {\n                padding: 8px 0px 0 15px;\n            }\n            .chat-action-btns {\n                order: 2;\n                -webkit-order: 2;\n                display: flex;\n                display: -webkit-flex;\n                flex-wrap: wrap;\n                -webkit-flex-wrap: wrap;\n                justify-content: center;\n                -webkit-justify-content: center;\n                .chat-user-time {\n                    .chats-dot {\n                        a {\n                            color: $green;\n                        }\n                    }\n                }\n            }\n        }\n        .chat-avatar {\n            padding: 8px 15px 0 8px;\n            display: flex;\n            display: -webkit-flex;\n            align-items: flex-start;\n            -webkit-align-items: flex-start;\n            flex-shrink: 0;\n            .dreams_chat {\n                width: 40px;\n                height: 40px;\n                object-fit: cover;\n            }\n        }\n        .message-content {\n            background-color: $light-900;\n            border-radius: 8px;\n            padding: 10px 20px;\n            font-weight: $font-weight-medium;\n            margin-bottom: 5px;\n            position: relative;\n            h4 {\n                font-size: $font-size-13;\n                color: $gray-900;\n                margin-bottom: 0px;\n                line-height: 1.4;\n                font-weight: $font-weight-medium;\n            }\n            .chat-time {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                font-size: $font-size-10;\n                font-weight: $font-weight-medium;\n                color: $green;\n                margin-bottom: 0;\n                svg {\n                    width: 10px;\n                }\n            }\n            &::before {\n                border-bottom: 6px solid transparent;\n                border-right: 6px solid $light-900;\n                border-top: 6px solid transparent;\n                content: \"\";\n                height: 0;\n                width: 0;\n                position: absolute;\n                top: 8px;\n                left: -4px;\n                right: auto;\n            }\n        }\n        .chat-profile-name {\n            h6 {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: left;\n                -webkit-justify-content: left;\n                -ms-flex-pack: left;\n                font-size: 8px;\n                font-weight: $font-weight-medium;\n                color: $text-color;\n\t\t\t\ti {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tcolor: #008024;\n\t\t\t\t}\n            }\n        }\n    }\n    .chat-line {\n        margin: 0px 0 20px;\n        position: relative;\n        text-align: center;\n        width: 100%;\n        &:before {\n            content: \"\";\n            position: absolute;\n            left: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            background-color: $green;\n            width: 100%;\n            height: 1px;\n        }\n        .chat-date {\n            background-color: $green;\n            color: $green;\n            font-size: $font-size-13;\n            padding: 7px 14px;\n            border-radius: 3px;\n            display: inline-block;\n            font-weight: $font-weight-semibold;\n            position: relative;\n        }\n    }\n}\n.right-user-side {\n    &.call-user-side {\n        .slime-grp {\n            .right-sidebar-profile {\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n                border-bottom: 0;\n                padding-bottom: 10px;\n                .profile-call-blk {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                }\n                .edit-group {\n                    svg {\n                        width: 16px;\n                        color: $green;\n                    }\n                }\n            }\n            .chat-options {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                border-bottom: 1px solid $green;\n                padding-bottom: 20px;\n                ul {\n                    li {\n                        a {\n                            color: $green;\n                            width: 30px;\n                            height: 30px;\n                            background-color: gray;\n                            padding: 0;\n                            border-radius: 50px;\n                            &:hover {\n                                background: $primary;\n                                border-color: $primary;\n                                svg {\n                                    color: $white;\n                                }\n                            }\n                            svg {\n                                width: 15px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.right-side-party {\n        .slime-grp {\n            padding: 0px;\n            .left-chat-title {\n                padding: 20px;\n                margin-bottom: 0;\n                background-color: $body-bg;\n                border-radius: 10px 10px 0 0;\n                h4 {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    span {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n                        width: 25px;\n                        height: 25px;\n                        background-color: $warning;\n                        border-radius: 50px;\n                        font-size: $font-size-14;\n                        color: $white;\n                        margin-left: 10px;\n                    }\n                }\n            }\n            .card-body-blk {\n                padding: 20px;\n                .user-list {\n                    border-radius: .25rem;\n                    display: flex;\n                    display: -webkit-flex;\n                    -ms-flex-direction: column;\n                    flex-direction: column;\n                    padding-left: 0;\n                    margin-bottom: 0;\n                    .user-list-item {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        padding: 5px;\n                        display: flex;\n                        display: -webkit-flex;\n                        border-radius: 6px;\n                        background-color: #F6F7F8;\n                        margin-bottom: 10px;\n                        border: 0;\n                        &:hover {\n                            background-color: #F6F7F8;\n                            transition: ease all 0.5s;\n                            -webkit-transition: ease all 0.5s;\n                            -ms-transition: ease all 0.5s;\n                        }\n                        .avatar {\n                            margin-right: 0.8rem;\n                            display: inline-block;\n                            margin-bottom: 0;\n                            height: 40px;\n                            width: 40px;\n                            position: relative;\n                            flex-shrink: 0;\n                            &::before {\n                                top: 0;\n                                bottom: inherit;\n                            }\n                            img {\n                                border-radius: 0px;\n                            }\n                        }\n                        .users-list-body {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            justify-content: space-between;\n                            -webkit-justify-content: space-between;\n                            -ms-flex-pack: space-between;\n                            flex-grow: 1;\n                            .name-list-user {\n                                display: grid;\n                                display: -webkit-box;\n                                display: -ms-flexbox;\n                                display: flex;\n                                align-items: center;\n                                -webkit-box-align: center;\n                                -ms-flex-align: center;\n                                h5 {\n                                    font-size: $font-size-15;\n                                    font-weight: $font-weight-normal;\n                                    margin-bottom: 2px;\n                                    color: $text-color;\n                                    white-space: nowrap;\n                                    overflow: hidden;\n                                    text-overflow: ellipsis;\n                                }\n                                p {\n                                    font-size: $font-size-12;\n                                    color: $danger;\n                                    display: -webkit-box;\n                                    display: -ms-flexbox;\n                                    display: flex;\n                                    align-items: center;\n                                    -webkit-box-align: center;\n                                    -ms-flex-align: center;\n                                    svg {\n                                        width: 14px;\n                                        height: 14px;\n                                    }\n                                }\n                            }\n                            .chat-user-time {\n                                .chats-dot {\n                                    a {\n                                        color: $danger;\n                                    }\n                                }\n                            }\n                            .last-chat-time {\n                                .text-muted {\n                                    font-size: $font-size-10;\n                                    color: $gray-900;\n                                    font-weight: $font-weight-medium;\n                                }\n                                .new-message-count {\n                                    width: 20px;\n                                    height: 20px;\n                                    display: flex;\n                                    display: -webkit-flex;\n                                    align-items: center;\n                                    -webkit-align-items: center;\n                                    justify-content: center;\n                                    -webkit-justify-content: center;\n                                    line-height: 0;\n                                    font-size: 11px;\n                                    background-color: $primary;\n                                    color: $white;\n                                    border-radius: 50%;\n                                    margin-left: auto;\n                                    margin-top: 5px;\n                                }\n                            }\n                            .last-call-time {\n                                display: -webkit-box;\n                                display: -ms-flexbox;\n                                display: flex;\n                                align-items: center;\n                                -webkit-box-align: center;\n                                -ms-flex-align: center;\n                                .call-recent {\n                                    a {\n                                        display: -webkit-box;\n                                        display: -ms-flexbox;\n                                        display: flex;\n                                        align-items: center;\n                                        -webkit-box-align: center;\n                                        -ms-flex-align: center;\n                                        justify-content: center;\n                                        -webkit-justify-content: center;\n                                        -ms-flex-pack: center;\n                                        width: 30px;\n                                        height: 30px;\n                                        background: #B8BCC9;\n                                        color: $gray-900;\n                                        border-radius: 50px;\n                                        svg {\n                                            color: $gray-900;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .slimScrollDiv {\n        height: calc(100vh - 110px) !important;\n        .slimscroll {\n            height: calc(100vh - 110px) !important;\n        }\n    }\n    .slime-grp {\n        background: $white;\n\t\tbox-shadow: 0px 4px 60px 0px #E7E7E778;\n\t\tborder: 1px solid #E1E8ED;\n        border-radius: 10px;\n        padding: 15px;\n        .left-chat-title {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin-bottom: 20px;\n\t\t\tbackground-color: $body-bg;\n            .chat-title {\n                h4 {\n                    font-size: $font-size-18;\n                    font-weight: $font-weight-semibold;\n                    color: $gray-900;\n                    margin-bottom: 0;\n                }\n            }\n            .contact-close_call {\n                .close_profile {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    width: 26px;\n                    height: 26px;\n                    background: transparent;\n                    border-radius: 50px;\n                    &:hover {\n                        background: $primary;\n                        svg {\n                            color: $white;\n                        }\n                    }\n                    svg {\n                        width: 16px;\n                        color: $danger;\n                    }\n                }\n            }\n        }\n\t\t.chat-footer {\n\t\t\tposition: sticky;\n\t\t\tleft: 0px;\n\t\t\tright: 0px;\n\t\t\tbottom: 0px;\n\t\t\tpadding: 15px;\n\t\t\tbackground: $white;\n\t\t\tform {\n\t\t\t\tdisplay: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n\t\t\t\tposition: relative;\n\t\t\t\t.comman-icon {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t-webkit-transform: translateY(-50%);\n\t\t\t\t\t-ms-transform: translateY(-50%);\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $text-color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.smile-col {\n\t\t\t\t\tright: inherit;\n\t\t\t\t\tleft: 15px;\n\t\t\t\t}\n\t\t\t\t.attach-col {\n\t\t\t\t\tright: inherit;\n\t\t\t\t\tleft: 45px;\n\t\t\t\t}\n\t\t\t\t.micro-col {\n\t\t\t\t\tright: 50px;\n\t\t\t\t\tleft: inherit;\n\t\t\t\t\ta {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tfont-size: $font-size-16;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.send-chat {\n\t\t\t\t\tright: 5px;\n\t\t\t\t\ta {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n\t\t\t\t\t\twidth: 34px;\n\t\t\t\t\t\theight: 34px;\n\t\t\t\t\t\tbackground: $primary;\n\t\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: #1b2950;\n\t\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\twidth: 14px;\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat_form {\n\t\t\t\t\tborder-radius: 20px;\n\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t\tbackground: $white;\n\t\t\t\t\tborder: 1px solid rgba(145, 158, 171, 0.3);\n\t\t\t\t\tborder-radius: 6px;\n\t\t\t\t\theight: 48px;\n\t\t\t\t\tpadding: 10px 70px;\n\t\t\t\t\t&::placeholder {\n\t\t\t\t\t\tfont-size: $font-size-base;\n\t\t\t\t\t\tcolor: rgba(0, 0, 0, 0.2);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n    }\n}\n.owl-carousel.video-slide {\n    .owl-nav.disabled {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        width: 100%;\n    }\n    .owl-nav {\n        top: 50%;\n        -webkit-transform: translate(0, -50%);\n        -ms-transform: translate(0, -50%);\n        transform: translate(0, -50%);\n        @include respond-below(custom1280) {\n            width: 100%;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n        }\n        button.owl-next, button.owl-prev {\n            background-color: #D9D9D9;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            &:hover {\n                background-color: $primary;\n                i {\n                    color: $white;\n                }\n            }\n            i {\n                color: $text-color;\n            }\n        }\n    }\n}\n.audio-call-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    height: 100%;\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: space-evenly;\n        -webkit-justify-content: space-evenly;\n        -ms-flex-pack: space-evenly;\n        width: 100%;\n        li {\n            position: relative;\n            &.active {\n                .avatar {\n                    &::before {\n                        content: \"\";\n                        width: 250px;\n                        height: 250px;\n                        position: absolute;\n                        border: 1px solid $primary;\n                        border-radius: 50%;\n                        left: -25px;\n                        top: -25px;\n                        @include respond-below(custom991) {\n                            width: 150px;\n                            height: 150px;\n                            left: -10px;\n                            top: -10px;\n                        }\n                        @include respond-below(custom767) {\n                            width: 100px;\n                            height: 100px;\n                            left: -5px;\n                            top: -5px;\n                        }\n                    }\n                }\n            }\n            .avatar {\n                width: 200px;\n                height: 200px;\n                margin: 0;\n                position: relative;\n                @include respond-below(custom991) {\n                    width: 130px;\n                    height: 130px;\n                }\n                @include respond-below(custom767) {\n                    width: 90px;\n                    height: 90px;\n                }\n                img {\n                    width: 100%;\n                    position: relative;\n                }\n            }\n            .user-audio-call {\n                h5 {\n                    font-size: $font-size-14;\n                    color: $white;\n                    font-weight: $font-weight-normal;\n                    text-transform: capitalize;\n                    text-align: center;\n                    margin-top: 35px;\n                    @include respond-below(custom767) {\n                        margin-top: 15px;\n                    }\n                }\n            }\n            .more-icon {\n                position: absolute;\n                bottom: 10px;\n                right: inherit;\n                left: 50%;\n                -webkit-transform: translate(-50%, -50%);\n                -ms-transform: translate(-50%, -50%);\n                transform: translate(-50%, -50%);\n                z-index: 9;\n                @include respond-below(custom767) {\n                    bottom: 0px;\n                }\n                a {\n                    background-color: $primary;\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n.audio-volume {\n    position: absolute;\n    width: fit-content;\n    height: 134px;\n    bottom: 20px;\n    left: 20px;\n    background: $gray-300;\n    border-radius: 50px;\n    padding: 10px 14px;\n    width: 30px;\n    padding-bottom: 30px;\n    .volume-icons {\n        a {\n            position: absolute;\n            bottom: 0;\n            width: 30px;\n            height: 30px;\n            left: 0;\n            border-radius: 50px;\n            background: $white;\n            border: 1px solid $warning;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n        }\n    }\n}\n.custom-input {\n    width: 100%;\n    height: 4px;\n    width: 3px;\n    height: 100%;\n    background: $white;\n    border-radius: 5px;\n    writing-mode: vertical-lr;\n}\n.custom-input::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    appearance: none;\n    width: 12px;\n    height: 12px;\n    background: $primary !important;\n    border-radius: 50%;\n    cursor: pointer;\n}\n.custom-input::-moz-range-thumb {\n    width: 12px;\n    height: 12px;\n    background: $primary !important;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n.table-top-head {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    &.low-stock-top-head {\n        @include respond-below(custom575) {\n            flex-wrap: wrap;  \n           justify-content: start;\n        }\n        li {\n            margin-bottom: 10px;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n    li {\n        margin-right: 10px;\n        flex-shrink: 0;\n        &:last-child {\n            margin-right: 0;\n        }\n        #collapse-header {\n            margin-right: 0;\n            @include respond-below(custom991) {\n                display: none;\n            }\n        }\n        a {\n            height: 38px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $gray-300;\n            background: $white;\n            border-radius: 8px;\n            padding: 6px;\n            svg {\n                color: $gray-900;\n            }\n            &:hover {\n                background: #e3e3e3;\n            }\n            label {\n                margin-right: 10px;\n            }\n            &.btn-secondary {\n                background-color: $gray-900;\n                color: $white;\n                padding: 10px;\n                font-weight: $font-weight-bold;\n                font-size: $font-size-base;\n                &:hover {\n                    background-color: $primary;\n                }\n                svg {\n                    width: 16px;\n                    margin-right: 5px;\n                    color: $white;\n                }\n                @include respond-below(custom767) {\n                    padding: 5px;\n                    font-size: $font-size-base;\n                }\n            }\n            .action-edit.sales-action {\n                color: $blue;\n            }\n        }\n        .status-toggle {\n            height: 38px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $gray-100;\n            background: $white;\n            border-radius: 8px;\n            padding: 6px 10px;\n            label {\n                margin-right: 10px;\n            }\n        }\n    }\n}",".main-chat-blk {\n    .slimscroll {\n\t\theight: calc(100vh - 60px) !important;\n    }\n    .slimscroll-active-sidebar {\n        a {\n            color: $text-color;\n        }\n    }\n\n    .emoj-group ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n    }\n    .emoj-group ul li+li {\n        margin-left: 10px;\n    }\n    .emoj-group ul li a {\n        width: 34px;\n        height: 34px;\n        background: #f6f7f8;\n        border-radius: 50px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n    }\n    .emoj-group ul li a i {\n        color: #424242;\n    }\n    .message-content {\n        position: relative;\n    }\n    .message-content:hover .emoj-group {\n        opacity: 1;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        \n    }\n    .emoj-group {\n        position: absolute;\n        top: 50%;\n        right: -100px;\n        opacity: 0;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        -webkit-transform: translate(0, -50%);\n        -ms-transform: translate(0, -50%);\n        transform: translate(0, -50%);\n    }\n    .rig-emoji-group {\n        position: absolute;\n        right: 210px;\n    }\n    .wrap-emoji-group {\n        position: absolute;\n        right: 290px;\n    }\n    .emoj-group-list-foot {\n        display: none;\n        position: absolute;\n        top: -50px;\n        left: -90px;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n    }\n    .emoj-group-list-foot ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        background: #f6f7f8;\n        border-radius: 50px;\n        padding: 5px;\n    }\n    .emoj-group-list-foot ul li a {\n        padding: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n    }\n    .emoj-group-list-foot ul li.add-emoj a {\n        background: #EDEDED;\n    }\n    .emoj-group-list-foot ul li.add-emoj a i {\n        font-size: $font-size-20;\n        color: #424242;\n    }\n\n    .down-emoji-circle {\n        position: absolute;\n        left: 10px !important;\n        top: -38px !important;\n    }\n    .emoj-action-foot .down-emoji-circle ul {\n        padding: 10px;\n    }\n    .down-emoji-circle ul li + li {\n        margin-left: 14px\t;\n    }\n    .emoj-action-foot .down-emoji-circle ul li:last-child a {\n        width: 34px;\n        height: 34px;\n        border-radius: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\t.chat-page-wrapper {\n\t\t.content {\n\t\t\tpadding: 24px 0 0 24px;\n\t\t}\n\t\t.sidebar {\n\t\t\tposition: initial;\n\t\t\t@include respond-below(custom991) {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t\t.left-chat-title {\n\t\t\tpadding: 12px;\n\t\t\tborder-bottom: 1px solid #E0E0E0;\n\t\t\tmin-height: 72px;\n\t\t}\n\t\t.setting-title-head {\n\t\t\th4 {\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t}\n\t\t}\n\t\t.chat .slimscroll {\n\t\t\theight: calc(100vh - 135px) !important;\n\t\t}\n\t\t.dropdown-menu .dropdown-item {\n\t\t\tfont-size: $font-size-14;\n\t\t\tcursor: pointer;\n\t\t\tpadding: 7px 14px;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t.dropdown-menu .dropdown-item i {\n\t\t\tfont-size: $font-size-16;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item span {\n\t\t\tfloat: right;\n\t\t\tfont-size: $font-size-18;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item.active {\n\t\t\tbackground: none;\n\t\t\tcolor: inherit;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item:focus,\n\t\t.dropdown-menu .dropdown-item:hover,\n\t\t.dropdown-menu .dropdown-item:active {\n\t\t\tbackground-color: #e6e6e6;\n\t\t}\n\t\t.dropdown-menu {\n\t\t\tbackground: $white;\n\t\t\tborder: 1px solid #E5E7EB;\n\t\t\tbox-sizing: border-box;\n\t\t\tbox-shadow: 0px 4px 3px 0px rgba(0, 0, 0, 0.1);\n\t\t\tborder-radius: 8px;\n\t\t\tmin-width: 173px;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item {\n\t\t\tmargin: 0;\n\t\t\tposition: relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t}\n\t\t.dropdown-menu.chat-drop-menu .dropdown-item i {\n\t\t\tfont-size: $font-size-16;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t.dropdown-menu .dropdown-item:hover,\n\t\t.dropdown-menu .dropdown-item:focus,\n\t\t.dropdown-menu .dropdown-item:active {\n\t\t\tbackground-color: #F8ECFF;\n\t\t}\n\t\t.dropdown-menu .dropdown-item span {\n\t\t\tmargin-right: 10px;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t}\n\t\t.contact-close_call {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t}\n\t}\n    \t\t\n@-webkit-keyframes wave {\n\t0%,100%,60% {\n\t\t-webkit-transform: initial;\n\t\ttransform: initial;\n\t}\n\t30% {\n\t\t-webkit-transform: translateY(-5px);\n\t\ttransform: translateY(-5px);\n\t}\n}\n@keyframes wave {\n\t0%,100%,60% {\n\t\t-webkit-transform: initial;\n\t\ttransform: initial;\n\t}\n\t30% {\n\t\t-webkit-transform: translateY(-5px);\n\t\ttransform: translateY(-5px);\n\t}\n}\n.chat {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\tbackground: $white;\n\t.chat-header {\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\tpadding: 15px 24px;\n\t\talign-items: center;\n        border-bottom: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n        background: var(--White, #FFF);\n        box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n\t\tposition: relative;\n\t\t.user-details {\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\talign-items: center;\n\t\t\t-webkit-align-items: center;\n\t\t\tfigure {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\t\t\th5 {\n\t\t\t\tfont-size: $font-size-15;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tmargin-bottom: 4px;\n\t\t\t\tline-height: 1;\n\t\t\t\tcolor: $gray-900;\n\t\t\t}\n\t\t}\n\t\t.chat-options {\n\t\t\tul {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\talign-items: center;\n\t\t\t\t-webkit-align-items: center;\n\t\t\t\t>li {\n\t\t\t\t\t>a {\n\t\t\t\t\t\tfont-size: $font-size-14;\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\twidth: 40px;\n\t\t\t\t\t\theight: 40px;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t-webkit-align-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:not(.no-bg) {\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground-color: $gray-100;\n\t\t\t\t\t\t\t\tborder-color: $gray-100;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.chat-body {\n\t\tflex: 1;\n\t\tpadding: 24px;\n\t\tpadding-bottom: 40px;\n\t\t&:not(.no-message) {\n\t\t\toverflow: hidden;\n\t\t}\n\t\t.messages {\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\tflex-direction: column;\n\t\t\t-webkit-flex-direction: column;\n\t\t\talign-items: flex-start;\n\t\t\t-webkit-align-items: flex-start;\n\t\t\t.chats {\n\t\t\t\tmax-width: 75%;\n\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\t.chat-time {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t-webkit-align-items: center;\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t.avatar {\n\t\t\t\t\t\tmargin-right: 1rem;\n\t\t\t\t\t}\n\t\t\t\t\th5 {\n\t\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t}\n\t\t\t\t\t.time {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tmargin-top: 2px;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tcolor: rgba(247, 247, 247, 0.5);\n\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\twidth: 14px;\n\t\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\t\tmargin-left: 2px;\n\t\t\t\t\t\t\t\tvertical-align: 0px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content {\n\t\t\t\t\tborder-radius: 0px 15px 15px 15px;\n                    background: var(--light-color, #F6F7F8);\n\t\t\t\t\tpadding: 14px 20px;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tfont-size: $font-size-14;\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tbox-shadow: 0px 6px 12px 0px #00000008;\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $cyan;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content.award-link {\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tmargin-bottom: 2px;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t\timg {\n\t\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content.chat-award-link {\n\t\t\t\t\ta {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content.fancy-msg-box {\n\t\t\t\t\t.image-not-download {\n\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\tleft: 50%;\n\t\t\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\n\t\t\t\t\t\t\t-ms-transform: translate(-50%, -50%);\n\t\t\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chat-profile-name {\n\t\t\t\th6 {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tspan {\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chats.chats-right {\n\t\t\t\tmargin-left: auto;\n\t\t\t\t.chat-time {\n\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t}\n\t\t\t\t.message-content {\n\t\t\t\t\tborder-radius: 15px 0px 15px 15px;\n                    background: rgba(255, 159, 67, 0.12);\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tpadding: 15px;\n\t\t\t\t\t.chat-time {\n\t\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t\t-webkit-justify-content: flex-start;\n\t\t\t\t\t\t.time {\n\t\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\t\ti {\n\t\t\t\t\t\t\t\tcolor: $cyan;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat-action-btns {\n\t\t\t\t\torder: 2;\n\t\t\t\t\t-webkit-order: 2;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\t-webkit-flex-wrap: wrap;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t.chat-action-col {\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t}\n\t\t\t\t\t.chat-read-col {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\t\talign-items: flex-end;\n\t\t\t\t\t\t-webkit-align-items: flex-end;\n\t\t\t\t\t\tpadding-bottom: 22px;\n\t\t\t\t\t\tcolor: $gray-600;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat-content {\n\t\t\t\t\torder: 1;\n\t\t\t\t\t-webkit-order: 1;\n\t\t\t\t}\n\t\t\t\t.chat-avatar {\n\t\t\t\t\tpadding: 8px 0px 0 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.download-col {\n\t\t\t\tposition: relative;\n\t\t\t\tul {\n\t\t\t\t\tlist-style: none;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: 0 0 5px 0;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\tli+li {\n\t\t\t\t\t\tmargin-left: 5px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.image-download-col {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ta {\n\t\t\t\t\t\t>img {\n\t\t\t\t\t\t\tborder: 1px solid transparent;\n\t\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.image-download-col.image-not-download {\n\t\t\t\t\ta {\n\t\t\t\t\t\t>img {\n\t\t\t\t\t\t\t-webkit-filter: blur(1px);\n\t\t\t\t\t\t\tfilter: blur(1px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.download-action {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 8px;\n\t\t\t\t\tbottom: 8px;\n\t\t\t\t\tline-height: 0;\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t}\n\t\t\t\t\tdiv+div {\n\t\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\t}\n\t\t\t\t\tdiv {\n\t\t\t\t\t\timg {\n\t\t\t\t\t\t\twidth: 13px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.file-download {\n\t\t\t\t.download-action {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 8px;\n\t\t\t\t\tbottom: 8px;\n\t\t\t\t\tline-height: 0;\n\t\t\t\t\tbottom: 14px;\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\t}\n\t\t\t\t\tdiv+div {\n\t\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\t}\n\t\t\t\t\tdiv {\n\t\t\t\t\t\timg {\n\t\t\t\t\t\t\twidth: 13px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tposition: relative;\n\t\t\t\tbackground: $light-900;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\tpadding: 10px;\n\t\t\t\tmargin-bottom: 7px;\n\t\t\t\t.file-type {\n\t\t\t\t\twidth: 54px;\n\t\t\t\t\theight: 54px;\n\t\t\t\t\tbackground-color: $white;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\ti {\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tfont-size: $font-size-24;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.file-details {\n\t\t\t\t\tspan.file-name {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\t}\n\t\t\t\t\tspan.file-size {\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t\tul {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\tlist-style: none;\n\t\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\t\tfont-size: $font-size-14;\n\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\twidth: 1px;\n\t\t\t\t\t\t\t\theight: 13px;\n\t\t\t\t\t\t\t\tbackground: #C2C2C2;\n\t\t\t\t\t\t\t\tright: -8px;\n\t\t\t\t\t\t\t\ttop: 5px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tli+li {\n\t\t\t\t\t\t\tpadding-left: 15px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.chat-body.no-message {\n\t\tuser-select: none;\n\t}\n\t.chat-footer {\n\t\tposition: relative;\n\t\tform {\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\talign-items: center;\n\t\t\t-webkit-align-items: center;\n\t\t\tposition: absolute;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tpadding: 24px;\n\t\t\t@include respond-below(custom991) {\n\t\t\t\tpadding-bottom: 15px;\n\t\t\t}\n\t\t\t.form-buttons {\n\t\t\t\t.btn {\n\t\t\t\t\tmargin-left: 0px;\n\t\t\t\t\tcolor: $gray-400;\n\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.btn.send-btn {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t\theight: 40px;\n\t\t\t\t\tborder-radius: 6px;\n                    background: $primary;\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground-color: $white;\n\t\t\t\t\t\tborder-color: $gray-800;\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.specker-col {\n\t\t\t\tspan {\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tfont-size: 25px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.attach-col {\n\t\t\t\ti {\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t}\n\t\t\t\tright: inherit;\n\t\t\t\tleft: 60px;\n\t\t\t}\n\t\t\t.smile-col {\n\t\t\t\ti {\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\tfont-size: $font-size-22;\n\t\t\t\t}\n\t\t\t\tright: inherit;\n\t\t\t\tleft: 15px;\n\t\t\t}\n\t\t\t.smile-foot {\n\t\t\t\tmargin-right: 10px;\n\t\t\t\t.action-circle {\n\t\t\t\t\twidth: 38px;\n\t\t\t\t\theight: 38px;\n\t\t\t\t\tbackground: $white;\n\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground-color: $gray-100;\n\t\t\t\t\t\tborder-color: $gray-100;\n\t\t\t\t\t}\n\t\t\t\t\ti {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tfont-size: $font-size-18;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.form-control {\n\t\t\t\t&::-webkit-input-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&::-moz-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&:-ms-input-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&:-moz-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n}\n.chat-options {\n\tul.list-inline {\n\t\t.list-inline-item {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n}\n.last-seen {\n\tcolor: $gray-900;\n\tfont-size: $font-size-14;\n}\n.user_callog {\n\tdisplay: flex;\n\tmargin-top: 0px;\n}\n.calllog_p {\n\tmargin-left: 5px;\n}\n.chat-options.chat-option-profile {\n\t.list-inline-item {\n\t\ta {\n\t\t\tbackground: $primary;\n\t\t\twidth: 38px;\n\t\t\theight: 38px;\n\t\t\tborder-radius: 50px;\n\t\t\tcolor: $gray-900;\n\t\t\tpadding: 0;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tcolor: $white !important; \n\t\t\t&:hover {\n\t\t\t\tbackground: #1b2950;\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t}\n\t.list-inline {\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tmargin-bottom: 0;\n\t\tpadding-bottom: 15px;\n\t}\n}\n.last-seen-profile {\n\tspan {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-normal;\n\t\tmargin-bottom: 12px;\n\t\tdisplay: block;\n\t}\n}\n.header_button {\n\tposition: absolute;\n\tright: 5px;\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 20px;\n\tfont-size: $font-size-14;\n\tcolor: $white;\n\ttext-align: center;\n\tbackground: #ffa977;\n\tbottom: 40px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n}\n.btn-warning {\n\t&:hover {\n\t\tcolor: $white;\n\t\tbackground-color: $primary-800;\n\t\tborder-color: $primary-900;\n\t}\n}\n.right_sidebar_profile {\n\tmargin-top: 0px;\n}\n.account_details {\n\tbackground-color: $gray-300;\n\tborder-color: $gray-400;\n\tborder-radius: 5px !important;\n\tborder-bottom: 0 !important;\n}\n.security_details {\n\tbackground-color: $gray-300;\n\tborder-color: $gray-400;\n\tborder-radius: 5px !important;\n\tborder-bottom: 0 !important;\n}\n.close_icon {\n\tfont-size: $font-size-18;\n}\n.button_plus {\n\tmargin-left: 0px;\n}\n.chat-search {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\topacity: 0;\n\tvisibility: hidden;\n\tinput[type=\"text\"] {\n\t\tpadding: 8px 8px 8px 35px;\n\t\twidth: 100%;\n\t\tmin-height: 47px;\n\t\tborder-radius: 0px 0px 5px 5px;\n\t\tborder: 1px solid #E5E7EB;\n\t\tfont-size: 13px;\n\t\tbackground-color: $white;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\t&:hover {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus-visible {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t}\n}\n.chat-search.visible-chat {\n\topacity: 1;\n\tvisibility: visible;\n\ttop: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\tz-index: 9;\n}\n.form-control-feedback {\n\tz-index: 2;\n\tdisplay: block;\n\ttext-align: center;\n\tpointer-events: none;\n\tcolor: rgba(0, 0, 0, 0.4);\n\tposition: absolute;\n\tleft: 13px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ti {\n\t\tfont-size: $font-size-16;\n\t\tcolor: $gray-900;\n\t}\n}\n.user-chat-search {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\topacity: 0;\n\tvisibility: hidden;\n\tinput[type=\"text\"] {\n\t\tpadding: 8px 8px 8px 35px;\n\t\twidth: 100%;\n\t\tmin-height: 47px;\n\t\tborder-radius: 0px 0px 5px 5px;\n\t\tborder: 1px solid #E5E7EB;\n\t\tfont-size: 13px;\n\t\tbackground-color: $white;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\t&:hover {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus-visible {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t}\n}\n.user-chat-search.visible-chat {\n\topacity: 1;\n\tvisibility: visible;\n\ttop: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\tz-index: 9;\n}\n.all-chats {\n\tposition: relative;\n}\n.close-btn-chat {\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 25px;\n\tcolor: $gray-900;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tposition: absolute;\n\tright: 12px;\n\ttop: 9px;\n\tcursor: pointer;\n}\n.user-close-btn-chat {\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 25px;\n\tcolor: $gray-900;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tposition: absolute;\n\tright: 12px;\n\ttop: 9px;\n\tcursor: pointer;\n}\n.main_content {\n\twidth: 100% !important;\n}\n.avatar-main {\n\theight: 50px;\n\twidth: 50px;\n}\n.archive-btn {\n\tborder: 1px solid #008024;\n\tcolor: $gray-600;\n\tborder-radius: 4px;\n\tfont-size: 11px;\n\tfont-weight: $font-weight-medium;\n\tpadding: 2px 6px;\n\tmargin-right: 1.5rem;\n}\n.archive-btn-grey {\n\tborder: 1px solid #909090;\n\tcolor: $gray-500;\n\tborder-radius: 4px;\n\tfont-size: 9px;\n\tfont-weight: $font-weight-medium;\n\tpadding: 2px 6px;\n\tmargin-top: .25rem;\n}\n.right_sidebar_icon {\n\tlist-style: none;\n}\n.btn.btn-outline-light {\n\t&:hover {\n\t\tbackground: #e6e6e6;\n\t}\n}\n.chat-avatar {\n\tpadding: 8px 15px 0 8px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: flex-start;\n\t-webkit-align-items: flex-start;\n\tflex-shrink: 0;\n}\n.chat-profile-name {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 5px;\n\t.chat-action-col {\n\t\ta {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n}\n.delete-pop-btn {\n\t.btn-primary {\n\t\tmargin: 0 0 0 10px;\n\t}\n}\n.delete-model-head {\n\tpadding: 40px;\n\t.modal-header {\n\t\tpadding: 0;\n\t\tmargin-bottom: 32px;\n\t}\n\t.modal-body {\n\t\tpadding: 0;\n\t}\n}\n.delete-chat-notify {\n\tmargin-bottom: 32px;\n\t.form-check {\n\t\tmargin-bottom: 14px;\n\t}\n}\n.chats.chats-right {\n\tflex-direction: row-reverse;\n\t-webkit-flex-direction: row-reverse;\n}\n.message-star {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t.avatar {\n\t\twidth: 26px;\n\t\theight: 26px;\n\t\tmargin-right: 10px;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\th6 {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\tmargin-bottom: 0;\n\t\tspan {\n\t\t\ti {\n\t\t\t\tcolor: $warning-700;\n\t\t\t}\n\t\t}\n\t}\n}\n.chat-voice-group {\n\tul {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tli {\n\t\t\tspan {\n\t\t\t\twidth: 28px;\n\t\t\t\theight: 28px;\n\t\t\t\tbackground: $primary;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t}\n\t\t}\n\t}\n\tli {\n\t\tmargin-bottom: 0;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-normal;\n\t\tlist-style: none;\n\t}\n\tli+li {\n\t\tpadding-left: 10px;\n\t}\n}\n.file-download-col {\n\t.download-action {\n\t\tposition: absolute;\n\t\tright: 8px;\n\t\tbottom: 8px;\n\t\tline-height: 0;\n\t\ta {\n\t\t\tcolor: $white;\n\t\t\tfont-size: 10px;\n\t\t}\n\t\tdiv+div {\n\t\t\tmargin-left: 8px;\n\t\t}\n\t\tdiv {\n\t\t\timg {\n\t\t\t\twidth: 13px;\n\t\t\t}\n\t\t}\n\t}\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tfloat: left;\n\t\t\twidth: 50%;\n\t\t\tpadding: 5px;\n\t\t\t.image-download-col {\n\t\t\t\tposition: relative;\n\t\t\t\ta {\n\t\t\t\t\t>img {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli.full-width {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n.chat-select {\n\t.select2-container {\n\t\t.select2-selection--single {\n\t\t\tborder: 0;\n\t\t\theight: 24px;\n\t\t\t.select2-selection__rendered {\n\t\t\t\tpadding-right: 40px;\n\t\t\t\tpadding-left: 0px;\n\t\t\t}\n\t\t}\n\t}\n\t.select2-container--default {\n\t\t.select2-selection--single {\n\t\t\t.select2-selection__rendered {\n\t\t\t\tcolor: $gray-500;\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t\tfont-weight: normal;\n\t\t\t\tline-height: 24px;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t}\n\t\t\t.select2-selection__arrow {\n\t\t\t\theight: 24px;\n\t\t\t\tright: 7px;\n\t\t\t\tb {\n\t\t\t\t\tborder-color: $gray-700;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-width: 0 2px 2px 0;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t\theight: 0;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\tmargin-left: -5px;\n\t\t\t\t\tmargin-top: -5px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\twidth: 0;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\t-webkit-transform: rotate(45deg);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.select2-results__option--highlighted[aria-selected] {\n\t\t\tbackground-color: $gray-900;\n\t\t}\n\t\t.select2-selection--multiple {\n\t\t\tborder: 1px solid #ddd;\n\t\t\tmin-height: 40px;\n\t\t}\n\t}\n\t.select2-container--default.select2-container--open {\n\t\t.select2-selection--single {\n\t\t\t.select2-selection__arrow {\n\t\t\t\tb {\n\t\t\t\t\tborder-color: $gray-700;\n\t\t\t\t\tborder-width: 2px 0 0 2px;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t\tmargin-top: -5px;\n\t\t\t\t\tborder-color: $gray-700;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-width: 0 2px 2px 0;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.select2-container--default.form-control-sm {\n\t\t.select2-selection--single {\n\t\t\t.select2-selection__arrow {\n\t\t\t\ttop: 7px;\n\t\t\t}\n\t\t}\n\t}\n\t.select2-container--open {\n\t\t.select2-dropdown--below {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n}\n.success-pass {\n\tmargin-bottom: 40px;\n\ttext-align: center;\n}\n.review-files {\n\tp {\n\t\tmargin-bottom: 5px;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t}\n}\n.like-chat-grp {\n\tul {\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\tmargin-top: 10px;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\ta {\n\t\t\t\tborder: 1px solid #E0E0E0;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tpadding: 3px 12px;\n\t\t\t\tdisplay: block;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\tfont-size: $font-size-14;\n\t\t\t\timg {\n\t\t\t\t\tmargin-left: 5px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\tli.like-chat {\n\t\t\ta {\n\t\t\t\tbackground: #FEF6DC;\n\t\t\t}\n\t\t}\n\t\tli.comment-chat {\n\t\t\ta {\n\t\t\t\tbackground: #FFE8E9;\n\t\t\t}\n\t\t}\n\t}\n}\n.chat-line {\n\tmargin: 0px 0 20px;\n\tposition: relative;\n\ttext-align: center;\n\twidth: 100%;\n\t&:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\t-webkit-transform: translateY(-50%);\n\t\t-ms-transform: translateY(-50%);\n\t\tbackground-color: $light-900;\n\t\twidth: 100%;\n\t\theight: 1px;\n\t}\n}\n.chat-date {\n\tborder-radius: 100px;\n    background: $light-900;\n\tcolor: $gray-900;\n\tfont-size: $font-size-14;\n\tpadding: 4px 20px;\n\tdisplay: inline-block;\n\tfont-weight: $font-weight-normal;\n\tposition: relative;\n\tborder: 1px solid #E0E0E0;\n}\n.chat+.sidebar-group {\n\tmargin-right: 0px;\n\t.sidebar {\n\t\tmargin-right: 0px;\n\t}\n}\n.group-comman-theme {\n\tpadding: 0 24px;\n\th6 {\n\t\tmargin-bottom: 15px;\n\t}\n\tul {\n\t\tpadding: 0;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 15px;\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tli {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tlist-style: none;\n\t\t\tborder: 1px solid #E0E0E0;\n\t\t\tborder-radius: 5px;\n\t\t\tpadding: 5px;\n\t\t\tmargin-bottom: 10px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t\t.avatar {\n\t\t\t\tflex-shrink: 0;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t}\n\t}\n}\n.theme-content {\n\th6 {\n\t\tmargin-bottom: 6px;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t}\n\tp {\n\t\tmargin-bottom: 0;\n\t\ttext-align: start;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: -webkit-box;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t}\n}\n.chat-message-grp {\n\tpadding: 24px;\n\tpadding-top: 0;\n\tul {\n\t\tpadding: 0;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tmargin-bottom: 15px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t\ta {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t&:hover {\n\t\t\t\t\t.stared-group {\n\t\t\t\t\t\th6 {\n\t\t\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.stared-group {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tspan {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tborder-radius: 6px;\n\t\tmargin-right: 10px;\n\t\tbackground: #F6F7F8;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\ti {\n\t\t\tfont-size: $font-size-16;\n\t\t}\n\t}\n\th6 {\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\tcolor: $text-color;\n\t\tmargin-bottom: 0;\n\t}\n}\n.star-message {\n\tbackground: #FEF6DC;\n\ti {\n\t\tcolor: $warning-700;\n\t}\n}\n.mute-message {\n\tbackground: #EBFDFFFA;\n\ti {\n\t\tcolor: $cyan;\n\t}\n}\n.block-message {\n\tbackground: #FFE8E9;\n\ti {\n\t\tcolor: $purple;\n\t}\n}\n.report-message {\n\tbackground: #F8ECFF;\n\ti {\n\t\tcolor: $gray-900;\n\t}\n}\n.delete-message {\n\tbackground: #FFE8E9;\n\ti {\n\t\tcolor: $danger-800;\n\t}\n}\n.count-group {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tspan {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tborder-radius: 50px;\n\t\tcolor: $white;\n\t\tfont-size: 10px;\n\t\tbackground: $primary;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tmargin-right: 5px;\n\t}\n\ti {\n\t\tcolor: #424242;\n\t\tfont-size: $font-size-16;\n\t}\n}\n.nav.nav-tabs.chat-tabs {\n\t.nav-item {\n\t\t.nav-link {\n\t\t\tfont-size: $font-size-16;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: $white;\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 0;\n\t\t}\n\t\t.nav-link.active {\n\t\t\tfont-size: $font-size-16;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: $primary-800;\n\t\t}\n\t}\n}\n.header-top {\n\tul {\n\t\tli {\n\t\t\ta {\n\t\t\t\tcolor: $black;\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t}\n\t\t}\n\t}\n}\n.set-search {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: $font-size-16;\n\tborder-radius: 50px;\n\twidth: 28px;\n\theight: 28px;\n\t&:hover {\n\t\tbackground: #F5F5F5;\n\t\tborder-color: $gray-100;\n\t}\n}\n.header-action {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\tli {\n\t\tdisplay: inline-block;\n\t\tmargin-left: 10px;\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-18;\n\t\t}\n\t}\n}\n.user-list {\n\tborder-radius: .25rem;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\tpadding-left: 0;\n\tmargin-bottom: 0;\n\tli {\n\t\ta {\n\t\t\tpadding: 17px 20px;\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\tcursor: pointer;\n\t\t\tborder-radius: 6px;\n\t\t\tmargin-bottom: 10px;\n\t\t\tborder: 0;\n\t\t\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n\t\t}\n\t\t.avatar {\n\t\t\tmargin-right: 0.8rem;\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-bottom: 0;\n\t\t\theight: 46px;\n\t\t\twidth: 46px;\n\t\t\tborder-radius: 50%;\n\t\t\tposition: relative;\n\t\t\tz-index: 0;\n\t\t\t.letter-avatar {\n\t\t\t\twidth: 45px;\n\t\t\t\theight: 45px;\n\t\t\t\tborder-radius: 45px;\n\t\t\t\tmargin-right: 0.8rem;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\talign-items: center;\n\t\t\t\t-webkit-align-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\tbackground-color: $gray-400;\n\t\t\t\tfont-size: $font-size-16;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tcolor: $violet;\n\t\t\t}\n\t\t}\n\t\ta.admin-shade {\n\t\t\tbox-shadow: none;\n\t\t}\n\t}\n\t.avatar {\n\t\t>a {\n\t\t\t>img {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\t\t>img {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n}\n.avatar-away {\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\ttop: 0px;\n\t\tright: 2px;\n\t\tborder: 2px solid $white;\n\t\tz-index: 9;\n\t\tbackground-color: $yellow;\n\t}\n}\n.avatar-offline {\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\ttop: 0px;\n\t\tright: 2px;\n\t\tborder: 2px solid $white;\n\t\tz-index: 9;\n\t}\n}\n.avatar-online {\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\ttop: 0px;\n\t\tright: 2px;\n\t\tborder: 2px solid $white;\n\t\tz-index: 9;\n\t\tbackground-color: $green;\n\t}\n}\n.animate-typing-col {\n\tcolor: $success;\n\t.dot {\n\t\tdisplay: inline-block;\n\t\twidth: 4px;\n\t\theight: 4px;\n\t\tborder-radius: 50%;\n\t\tmargin-right: -1px;\n\t\tbackground: #0D9B35;\n\t\t-webkit-animation: wave 1.3s linear infinite;\n\t\tanimation: wave 1.3s linear infinite;\n\t\topacity: .6;\n\t\t&:nth-child(2) {\n\t\t\t-webkit-animation-delay: -1.1s;\n\t\t\tanimation-delay: -1.1s;\n\t\t}\n\t\t&:nth-child(3) {\n\t\t\t-webkit-animation-delay: -.9s;\n\t\t\tanimation-delay: -.9s;\n\t\t}\n\t}\n}\n.chat_form {\n\tborder-radius: 20px;\n\tmargin-right: 0px;\n\tbackground: $white;\n\tborder: 1px solid #C2C2C2;\n\tbox-shadow: 0px 4px 4px #F5F8FF;\n\tborder-radius: 6px;\n\theight: 40px;\n\tpadding: 10px 10px;\n}\n.contact-close {\n\ta {\n\t\tcolor: $gray-900;\n\t\topacity: 0.5;\n\t\tborder-color: $gray-300;\n\t}\n}\n.main-wrapper {\n\t.content {\n\t\t.sidebar-group.right-sidebar {\n\t\t\t.sidebar {\n\t\t\t\twidth: 310px;\n\t\t\t}\n\t\t}\n\t}\n}\n.primary-title {\n\tcolor: $primary-800;\n\tfont-size: $font-size-14;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 0;\n\ti {\n\t\tfont-size: $font-size-14;\n\t}\n}\n.contact-action {\n\tpadding: 0;\n\tmargin: 0;\n\tlist-style: none;\n\tli {\n\t\tpadding: 11px 0;\n\t\tborder-bottom: 1px solid #f1f1f1;\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: bold;\n\t\t}\n\t}\n\tli.report-contact {\n\t\ta {\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n\tli.delete-chat {\n\t\ta {\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n\tli.sign-out {\n\t\ta {\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n}\n.left-sidebar {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n}\n.left-sidebar-wrap {\n\tbackground: #FBFBFB;\n\toverflow: hidden;\n\twidth: 448px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\tflex: 1;\n}\n.right-sidebar {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\tbackground-color: $light;\n\topacity: 100%;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\tposition: relative;\n\twidth: 320px;\n\t.right-sidebar-wrap {\n\t\tbackground-color: $white;\n\t\tborder-left: 1px solid #E0E0E0;\n\t\tborder-radius: 0px;\n\t\tmargin-top: 0px;\n\t\tmargin-bottom: 0px;\n\t\theight: calc(100vh - 0px);\n\t\t.sidebar-body {\n\t\t\tpadding: 0;\n\t\t}\n\t\t.right-sidebar-profile {\n\t\t\tpadding: 24px;\n\t\t\tpadding-bottom: 0;\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t}\n\t.contact-close_call {\n\t\t.close_profile {\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t\tborder-radius: 25px;\n\t\t\tcolor: $gray-900;\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\talign-items: center;\n\t\t\t-webkit-align-items: center;\n\t\t\t&.close-star {\n\t\t\t\tcolor: $warning;\n\t\t\t}\n\t\t\t&.close-trash {\n\t\t\t\tcolor: $danger;\n\t\t\t}\n\t\t}\n\t}\n}\n.right-sidebar.video-right-sidebar {\n\twidth: 371px;\n\t.chat {\n\t\t.chat-body {\n\t\t\tpadding-bottom: 110px;\n\t\t}\n\t\tmargin-left: 0 !important;\n\t\tdisplay: block;\n\t}\n}\n.video-call-chat {\n\t.left-chat-title.with-bg {\n\t\tbackground: transparent;\n\t}\n\t.left-chat-title {\n\t\tborder: 0;\n\t}\n\t.chat-title {\n\t\th4 {\n\t\t\tfont-size: $font-size-18;\n\t\t\tfont-weight: $font-weight-semibold;\n\t\t\tcolor: $gray-900;\n\t\t}\n\t\tspan {\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tcolor: $gray-900;\n\t\t}\n\t}\n}\n.chat.video-call-chat {\n\t.chat-body {\n\t\tbackground-image: none;\n\t\t.messages {\n\t\t\t.chats {\n\t\t\t\t.message-content {\n\t\t\t\t\tbackground: #F5F5F5;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chats.chats-right {\n\t\t\t\t.message-content {\n\t\t\t\t\tbackground: #F8ECFF;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.member-details {\n\tmargin-bottom: 10px;\n}\n.chat-member-details {\n\tpadding: 0 24px;\n\t.member-details {\n\t\tul {\n\t\t\tpadding: 0;\n\t\t\tborder-bottom: 1px solid #EDEDED;\n\t\t\tli {\n\t\t\t\tlist-style: none;\n\t\t\t\tmargin-bottom: 15px;\n\t\t\t\th6 {\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t}\n\t\t\t\th5 {\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tmargin-bottom: 0px;\n\t\t\t\t}\n\t\t\t\tspan {\n\t\t\t\t\tfont-size: $font-size-16;\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t}\n\t\t\t\ta {\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tborder-radius: 100px;\n\t\t\t\t\tpadding: 5px;\n\t\t\t\t\tbackground: #F5F5F5;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\ta+a {\n\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.right-sidebar.show-right-sidebar {\n\tmargin-right: 0;\n}\n.right-sidebar.video-right-sidebar.show-right-sidebar {\n\tmargin-right: 0;\n}\n.right-sidebar.hide-right-sidebar {\n\tmargin-right: -320px;\n}\n.right-sidebar.video-right-sidebar.hide-right-sidebar {\n\tmargin-right: -371px;\n}\n.status-modal {\n\t.custom-status-close {\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tborder-radius: 25px;\n\t\tcolor: $gray-900;\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\talign-items: center;\n\t\t-webkit-align-items: center;\n\t\tbackground-color: $gray-100;\n\t\tborder-color: $gray-100;\n\t}\n}\n.group-description {\n\t.description-sub {\n\t\th5 {\n\t\t\tspan {\n\t\t\t\ta {\n\t\t\t\t\twidth: 25px;\n\t\t\t\t\theight: 25px;\n\t\t\t\t\tborder-radius: 25px;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t-webkit-align-items: center;\n\t\t\t\t\tborder-color: $gray-100;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.list_group_notread {\n\tcolor: $primary-800 !important;\n}\n.chat-cont-type {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\t.chat-type-wrapper {\n\t\tmargin-bottom: 0;\n\t\tp {\n\t\t\tcolor: $gray-500;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n}\n.group-type-radio {\n\tdisplay: block;\n\tposition: relative;\n\tpadding-left: 35px;\n\tcursor: pointer;\n\tfont-size: $font-size-22;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-normal;\n\tcolor: $gray-900;\n\tmargin-right: 24px;\n\tinput {\n\t\tposition: absolute;\n\t\topacity: 0;\n\t\tcursor: pointer;\n\t\t&:checked {\n\t\t\t~ {\n\t\t\t\t.checkmark {\n\t\t\t\t\tbackground-color: $gray-800;\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.checkmark {\n\t\t&:after {\n\t\t\ttop: 4px;\n\t\t\tleft: 4px;\n\t\t\twidth: 12px;\n\t\t\theight: 12px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground: white;\n\t\t}\n\t}\n}\n.checkmark {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\theight: 22px;\n\twidth: 22px;\n\tbackground-color: $white;\n\tborder: 1px solid #E4E4E4;\n\tborder-radius: 50%;\n\t&:after {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: none;\n\t}\n}\n.pass-login {\n\tlabel {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-medium;\n\t}\n}\n.select2-container--default {\n\t.select2-results__option--highlighted[aria-selected] {\n\t\tbackground-color: $gray-800 !important;\n\t}\n}\n.right-sidebar-profile {\n\t>.avatar {\n\t\tbackground: rgba(66, 11, 161, 0.1);\n\t}\n}\n.group_img {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n.group-name-search {\n\tmargin-bottom: 14px;\n}\n.parti-wrapper {\n\tmargin-bottom: 14px;\n\tdisplay: flex;\n\talign-items: center;\n}\n.group_header {\n\twidth: 38px !important;\n\theight: 38px !important;\n\tborder: 2px solid $white;\n}\n.last-chat-time {\n\ti.missed-col {\n\t\twidth: 17px;\n\t\tdisplay: inline-block;\n\t\tmargin-top: 10px;\n\t\timg {\n\t\t\tmax-width: 100%;\n\t\t\theight: auto;\n\t\t}\n\t}\n}\n.right-sidebar-head {\n\tpadding: 0px 24px;\n\th5 {\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-semibold;\n\t\tcolor: $gray-900;\n\t\tmargin-bottom: 0px;\n\t}\n}\n.right-sidebar-head.share-media {\n\t.share-media-blk {\n\t\tmargin-bottom: 20px;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t}\n\t.about-media-tabs {\n\t\t.nav-tabs {\n\t\t\tmargin-bottom: 15px;\n\t\t\tpadding: 5px;\n\t\t\tborder-radius: 8px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t}\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tpadding-bottom: 10px;\n\t\tmargin-bottom: 15px;\n\t\t.nav {\n\t\t\t.nav-item.active {\n\t\t\t\tbackground: $primary;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t\t.nav-item {\n\t\t\t\tpadding: 2px 10px;\n\t\t\t\tfont-size: $font-size-14;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\tborder: 0;\n\t\t\t\tmargin-right: 10px;\n\t\t\t\tbackground: $body-bg;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.share-media-img {\n\t\t\tli {\n\t\t\t\tmargin: 0px 6px 6px 0px;\n\t\t\t\tposition: relative;\n\t\t\t\timg {\n\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\twidth: 84px;\n\t\t\t\t}\n\t\t\t\tspan {\n\t\t\t\t\ti {\n\t\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t}\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\n\t\t\t\t\t-ms-transform: translate(-50%, -50%);\n\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\tspan {\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tcolor: $gray-300;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tli.blur-media {\n\t\t\t\timg {\n\t\t\t\t\tfilter: blur(2px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.media-file {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n\tmargin-bottom: 15px;\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n.media-doc-blk {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tspan {\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tborder-radius: 5px;\n\t\tbackground: #F5F5F5;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tmargin-right: 10px;\n\t\ti {\n\t\t\tfont-size: $font-size-24;\n\t\t}\n\t}\n}\n.document-detail {\n\tul {\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tposition: relative;\n\t\t\t&::before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 1px;\n\t\t\t\theight: 13px;\n\t\t\t\tbackground: #C2C2C2;\n\t\t\t\tright: -8px;\n\t\t\t\ttop: 5px;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tpadding-left: 15px;\n\t\t}\n\t}\n\th6 {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t}\n}\n.media-download {\n\ta {\n\t\tcolor: $gray-900;\n\t}\n}\n.social-media-col {\n\tmargin-top: 35px;\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tfloat: left;\n\t\t\ta {\n\t\t\t\tcolor: $violet;\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n\th6 {\n\t\tfont-weight: $font-weight-semibold;\n\t\tcolor: $black;\n\t\tfont-size: $font-size-15;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.media-link-grp {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 15px;\n}\n.media-link-detail {\n\th6 {\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-15;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t}\n\tspan {\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tword-break: break-all;\n\t\t}\n\t}\n\ta {\n\t\t&:hover {\n\t\t\tcolor: $gray-800;\n\t\t}\n\t}\n}\n.share-media-blk {\n\ta {\n\t\tcolor: $gray-800;\n\t\tfont-weight: $font-weight-medium;\n\t}\n}\n.link-img {\n\tflex-shrink: 0;\n\timg {\n\t\tborder-radius: 4px;\n\t\tmargin-right: 10px;\n\t}\n}\n.settings-col {\n\th6 {\n\t\tfont-weight: $font-weight-semibold;\n\t\tcolor: $black;\n\t\tfont-size: $font-size-15;\n\t\tmargin-bottom: 20px;\n\t}\n\tmargin-top: 35px;\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tcolor: $gray-600;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t}\n\t\tli+li {\n\t\t\tmargin-top: 15px;\n\t\t}\n\t}\n\t.switch {\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\twidth: 40px;\n\t\theight: 23px;\n\t\tmargin-bottom: 0;\n\t\tmargin-right: 10px;\n\t\tinput {\n\t\t\topacity: 0;\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t}\n\t.slider {\n\t\tposition: absolute;\n\t\tcursor: pointer;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tbackground-color: $gray-500;\n\t\t-webkit-transition: .4s;\n\t\ttransition: .4s;\n\t\t&:before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\theight: 15px;\n\t\t\twidth: 15px;\n\t\t\tleft: 4px;\n\t\t\tbottom: 4px;\n\t\t\tbackground-color: $white;\n\t\t\t-webkit-transition: .4s;\n\t\t\ttransition: .4s;\n\t\t}\n\t}\n\tinput {\n\t\t&:checked+.slider {\n\t\t\tbackground-color: $blue;\n\t\t\t&:before {\n\t\t\t\t-webkit-transform: translateX(16px);\n\t\t\t\t-ms-transform: translateX(16px);\n\t\t\t\ttransform: translateX(16px);\n\t\t\t}\n\t\t}\n\t\t&:focus+.slider {\n\t\t\tbox-shadow: 0 0 1px #2196F3;\n\t\t}\n\t}\n\t.slider.round {\n\t\tborder-radius: 34px;\n\t\t&:before {\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n}\n.report-col {\n\tmargin-top: 35px;\n\tpadding: 12px;\n\tpadding-bottom: 50px;\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tdisplay: table;\n\t\t\tclear: both;\n\t\t}\n\t\tli {\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tposition: relative;\n\t\t\ta {\n\t\t\t\tcolor: $danger;\n\t\t\t\tpadding-left: 25px;\n\t\t\t\tspan {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttop: 0px;\n\t\t\t\t\tfont-size: $font-size-16;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tmargin-top: 19px;\n\t\t}\n\t}\n}\n.load-more-btn {\n\tfont-weight: $font-weight-semibold;\n\tmargin-top: 10px;\n\ti {\n\t\tbackground: #0057FF;\n\t\tborder-radius: 50%;\n\t\theight: 12px;\n\t\twidth: 12px;\n\t\tcolor: $white;\n\t\tline-height: 8px;\n\t\tfont-size: 12px;\n\t\tvertical-align: top;\n\t}\n}\n.chat-message-grp.chat-encrypt {\n\tpadding-bottom: 0;\n\tul {\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 15px;\n\t}\n}\n.participants-list {\n\tpadding: 0px 24px;\n\t.participants-list-group {\n\t\th6.parti-search {\n\t\t\tfont-size: 20px !important;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tborder: 1px solid #E0E0E0;\n\t\t\tborder-radius: 5px;\n\t\t\tbackground-color: $white;\n\t\t\tpadding: 10px;\n\t\t}\n\t\tli+li {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n\t.users-list-body {\n\t\th5 {\n\t\t\twhite-space: nowrap;\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t\tfont-size: $font-size-15;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tmargin-bottom: 5px;\n\t\t\tcolor: $gray-900;\n\t\t}\n\t\tp {\n\t\t\twhite-space: nowrap;\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t\tmargin-bottom: 0;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t}\n\t\tflex: 1;\n\t\tposition: relative;\n\t\tmin-width: 0px;\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\twidth: 100%;\n\t}\n\t.admin-profiles {\n\t\tdisplay: inline-block;\n\t\tcolor: $gray-800;\n\t\tborder-radius: 6px;\n\t\tfont-size: 12px;\n\t\tpadding: 2px 10px;\n\t\tfont-weight: $font-weight-medium;\n\t\tbackground: #F8ECFF;\n\t\t&:hover {\n\t\t\tbackground: #680A83;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n}\n.participants-list-group {\n\tborder-bottom: 1px solid #EDEDED;\n\tpadding-bottom: 15px;\n\tmargin-bottom: 15px;\n\th6 {\n\t\tmargin-bottom: 15px;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\tcolor: $gray-900;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t}\n}\n.chat-message-grp.group-exits {\n\tpadding: 0px 24px;\n\tpadding-bottom: 30px;\n}\n.grp-delete {\n\t.chat-action-col {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 100%;\n\t\t>a {\n\t\t\tcolor: $gray-500;\n\t\t}\n\t}\n}\n.chat-action-col {\n\t>a {\n\t\tcolor: $gray-900;\n\t}\n}\n.darkmode-btn {\n\twidth: 35px;\n\theight: 32px;\n\tbackground-color: $blue;\n\tborder: 1px solid #FBFBFB;\n\tborder-radius: 5px;\n\tcolor: $white;\n\tfont-size: $font-size-16;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tmargin: 0 auto;\n\t&:hover {\n\t\tcolor: $white;\n\t}\n\t&:focus {\n\t\tcolor: $white;\n\t}\n}\n.add-contacts-btn {\n\t&:hover {\n\t\tcolor: $white;\n\t}\n\t&:focus {\n\t\tcolor: $white;\n\t}\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 30px;\n\tbackground-color: $gray-800;\n\tcolor: $white;\n\tfont-size: 10px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tmargin: 0 auto;\n}\n.group-call-tab {\n\t.nav-tabs {\n\t\t.nav-link {\n\t\t\tcolor: $gray-800;\n\t\t\tborder: 0;\n\t\t\tborder-radius: 10px;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tpadding: 6px 25px;\n\t\t\t&:hover {\n\t\t\t\tcolor: $gray-800;\n\t\t\t}\n\t\t}\n\t\t.nav-link+.nav-link {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\t.nav-link.active {\n\t\t\tbackground-color: rgba(90, 7, 139, 0.1);\n\t\t\tcolor: $gray-800;\n\t\t}\n\t}\n\tnav {\n\t\tpadding: 0 15px 20px;\n\t\tposition: relative;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\tbottom: 0;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: $gray-400;\n\t\t\theight: 1px;\n\t\t}\n\t}\n}\n\n.header_image {\n\twidth: 195px;\n}\n\n.chat_avator_img {\n\tposition: relative;\n}\n\n.group_img {\n\twidth: 40px;\n\theight: 40px;\n\tobject-fit: cover;\n}\n\n.dreams_chat {\n\twidth: 40px;\n\theight: 40px;\n\tobject-fit: cover;\n}\n\n.voice_pop {\n\tpadding-right: 17px;\n}\n\n.status_carousel {\n\tmargin-top: 50px;\n}\n\n.carousel_img {\n\twidth: 650px;\n\theight: 434px;\n}\n\n.video_content {\n\tmin-height: 200px;\n\tmargin-top: 70px;\n}\n\n.voice-call-content {\n\tmin-height: 200px;\n}\n\n.chatimage img {\n\twidth: 120px;\n\theight: 120px;\n}\n\n.send-btn_status {\n\twidth: 52px;\n\theight: 52px;\n\tborder-radius: 50%;\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: $white !important;\n\tbackground-color: #FFA977 !important;\n\tmargin-left: 15px;\n\tfont-size: $font-size-22;\n}\n\n.status_telegram {\n\tcolor: $white;\n}\n\n.media-lists {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tmargin: 0 -5px 0px;\n\tflex-wrap: wrap;\n}\n\n.media-lists .media-image {\n\tmargin: 5px;\n\tflex-basis: 74px;\n\tmin-width: 74px;\n}\n\n.media-lists .media-image img {\n\tmax-width: 100%;\n}\n\n.avatar-group .avatar+.avatar {\n\tmargin-left: -.75rem;\n}\n\n.list-group-item {\n\tbackground-color: inherit;\n\tborder-color: #ebebeb;\n}\n\nul.list-inline .list-inline-item {\n\tmargin-bottom: .5rem;\n}\n\n.form-control {\n\tborder-radius: 5px;\n}\n\n.form-control:focus {\n\tbox-shadow: none;\n\tborder-color: #e6e6e6;\n}\n\n.custom-control-label {\n\tline-height: 25px;\n}\n\n.custom-control-input:checked~.custom-control-label::before {\n\tbackground-color: #0a80ff;\n}\n\n.open_drop {\n\tcolor: $white !important;\n}\n\n.send-btn_status:focus {\n\tbox-shadow: none !important;\n\tborder-color: #ffa977 !important;\n}\n\n.avatar {\n\tdisplay: inline-block;\n\tmargin-bottom: 0;\n\theight: 48px;\n\twidth: 48px;\n\tborder-radius: 50%;\n}\n\n.avatar .avatar-title {\n\tcolor: $white;\n\tbackground: #680A83;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-transform: uppercase;\n\tfont-size: 19px;\n\tfont-weight: $font-weight-semibold;\n}\n\n.avatar > a {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\ttransition: color .3s;\n\tcolor: #0a80ff;\n}\n\n.avatar > a > img,\n.avatar > img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.avatar.avatar-sm {\n\theight: 1.3rem;\n\twidth: 1.3rem;\n}\n\n.avatar.avatar-sm .avatar-title {\n\tfont-size: $font-size-14;\n}\n\n.avatar.avatar-lg {\n\theight: 3.8rem;\n\twidth: 3.8rem;\n}\n\n.avatar.avatar-lg .avatar-title {\n\tfont-size: 29px;\n}\n\n.avatar.avatar-xl {\n\theight: 100px;\n\twidth: 100px;\n}\n\n.header_drop_icon {\n\tborder-radius: 6px;\n}\n\n.accordion-col .accordion-title {\n\tcursor: pointer;\n\tpadding: 15px 0 8px;\n}\n\n.accordion-col .accordion-title .primary-title i {\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\ttransform: rotate(90deg);\n\t-webkit-transform: rotate(90deg);\n\t-ms-transform: rotate(90deg);\n}\n\n.accordion-col .accordion-title.active .primary-title i {\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\ttransform: rotate(270deg);\n\t-webkit-transform: rotate(270deg);\n\t-ms-transform: rotate(270deg);\n}\n\n.accordion-col .accordion-content {\n\tborder-bottom: 1px solid #e6e6e6;\n\tpadding-bottom: 15px;\n}\n\n.accordion-col .accordion-content:last-child {\n\tborder-bottom: 0;\n}\n\n.accordion-col .accordion-content h6 {\n\tfont-size: $font-size-14;\n}\n\n\n\n.status-right {\n\tfont-weight: $font-weight-medium;\n\tcolor: #444444;\n\tfont-size: $font-size-16;\n\ttext-align: center;\n}\n\n.status-right p {\n\tmargin-top: 20px;\n\tmargin-bottom: 0;\n}\n\n.star-drop .btn-outline-light {\n\tcolor: #424242;\n\tborder: 0;\n\tpadding: 0;\n}\n\n.star-drop .btn-outline-light i {\n\tfont-size: $font-size-20;\n}\n\n.star-drop .btn.btn-outline-light:hover {\n\tbackground: transparent;\n\tborder: 0;\n}\n\n.chat.star-chat-group {\n\tbackground-image: none;\n}\n\n.chat.star-chat-group .chat-body {\n\tbackground-image: none;\n}\n\n.chat.star-chat-group .chat-body .messages .chats {\n    max-width: 100%;\n}\n\n.chat.star-chat-group .chat-body .messages .chats .message-content {\n\tbackground: #F5F5F5;\n}\n\n.chat.star-chat-group .chat-body .messages .chats .message-content.award-link a {\n    word-break: break-all;\n}\n\n.chat.star-chat-group .chat-body .messages .chats .message-content.award-link img {\n    max-width: 100%;\n}\n.chat .chat-body .messages .chats.forward-chat-msg {\n\tdisplay: none;\n}\n.chats.forward-chat-msg {\n\tbackground: #EDEDED;\n\tborder-radius: 15px;\n\tpadding: 20px;\n\tborder-left: 2px solid #680A83;\n}\n.chats.forward-chat-msg .chat-avatar {\n\tpadding: 0;\n\tpadding-right: 15px;\n}\n\n.chat-title h4 a {\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-bold;\n\ttext-transform: uppercase;\n\tcolor: #4B0973;\n\tmargin-bottom: 0;\n}\n\n.left-chat-title .add-section > a {\n\twidth: 30px;\n\theight: 30px;\n\tbackground-color: #680A83;\n\tborder-radius: 30px;\n\tcolor: $white;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tfont-size: 13px;\n}\n\n.add-section ul {\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.add-section ul li {\n\tfloat: left;\n\tborder-radius: 50px;\n\twidth: 28px;\n\theight: 28px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\t\n    justify-content: center;\n    -webkit-justify-content: center;\n}\n\n.add-section ul li+li {\n\tmargin-left: 10px;\n}\n\n.add-section ul li a {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tfont-size: $font-size-20;\n}\n.all-chats .add-section ul li:hover{\n  background-color: #F5F5F5;\n  border-color: #F5F5F5;\n}\n\n.online {\n\tcolor: #008024;\n\tfont-weight: $font-weight-medium;\n}\n\n.top-online-contacts {\n\tpadding: 24px 24px 0px;\n}\n.fav-title {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n\tmargin-bottom: 15px;\n}\n.fav-title h6 {\n\tmargin-bottom: 0;\n\tfont-size: $font-size-18;\n\tfont-weight: $font-weight-semibold;\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n}\n.fav-title h6 i {\n\tfont-size: $font-size-22;\n}\n.fav-title a {\n\tmargin-bottom: 0;\n\tcolor: $primary;\n\tfont-weight: $font-weight-medium;\n}\n.fav-title a:hover {\n\tcolor: #0A0A0A;\n}\n\n.top-contacts-box .profile-img {\n\tposition: relative;\n\twidth: 46px;\n\theight: 46px;\n}\n\n.top-contacts-box .profile-img img {\n\tmax-width: 100%;\n\theight: auto;\n\tborder-radius: 50px;\n}\n\n.profile-name span {\n\tcolor: #585858;\n\tfont-size: 12px;\n\tdisplay: inline-block;\n\tmargin-top: 9px;\n}\n\n.top-contacts-box .profile-img.online:before {\n\tcontent: \"\";\n\tposition: absolute;\n\tright: 0;\n\ttransform: translateX(-50%);\n\t-webkit-transform: translateX(-50%);\n\t-ms-transform: translateX(-50%);\n\ttop: 0px;\n\tbackground-color: #49E073;\n\twidth: 10px;\n\theight: 10px;\n\tborder: 2px solid $white;\n\tborder-radius: 50px;\n}\n\n.dropdown-menu .dropdown-item span.edit-profile-icon,\n.dropdown-menu .dropdown-item span.profile-icon-col {\n\tfont-size: $font-size-15;\n}\n\n.avatar {\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 46px;\n\theight: 46px;\n\tflex-shrink: 0;\n}\n\n.avatar > img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.avatar-title {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: #650681;\n\tcolor: $white;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.avatar-away::before,\n.avatar-offline::before,\n.avatar-online::before {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\twidth: 25%;\n\theight: 25%;\n\tborder-radius: 50%;\n\tcontent: '';\n\tborder: 2px solid $white;\n}\n\n.avatar-online::before {\n\tbackground-color: #00e65b;\n}\n\n.avatar-offline::before {\n\tbackground-color: #ff0100;\n}\n\n.avatar-away::before {\n\tbackground-color: #ffbc34;\n}\n\n.avatar .border {\n\tborder-width: 3px !important;\n}\n\n.avatar .rounded {\n\tborder-radius: 6px !important;\n}\n\n.avatar .avatar-title {\n\tfont-size: $font-size-18;\n}\n\n.avatar-xs {\n\twidth: 1.65rem;\n\theight: 1.65rem;\n}\n\n.avatar-xs .border {\n\tborder-width: 2px !important;\n}\n\n.avatar-xs .rounded {\n\tborder-radius: 4px !important;\n}\n\n.avatar-xs .avatar-title {\n\tfont-size: 10px;\n}\n\n.avatar-xs.avatar-away::before,\n.avatar-xs.avatar-offline::before,\n.avatar-xs.avatar-online::before {\n\tborder-width: 1px;\n}\n\n.avatar-sm {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n}\n\n.avatar-sm .border {\n\tborder-width: 3px !important;\n}\n\n.avatar-sm .rounded {\n\tborder-radius: 4px !important;\n}\n\n.avatar-sm .avatar-title {\n\tfont-size: $font-size-15;\n}\n\n.avatar-sm.avatar-away::before,\n.avatar-sm.avatar-offline::before,\n.avatar-sm.avatar-online::before {\n\tborder-width: 2px;\n}\n\n.avatar-lg {\n\twidth: 3.75rem;\n\theight: 3.75rem;\n}\n\n.avatar-lg .border {\n\tborder-width: 3px !important;\n}\n\n.avatar-lg .rounded {\n\tborder-radius: 8px !important;\n}\n\n.avatar-lg .avatar-title {\n\tfont-size: $font-size-24;\n}\n\n.avatar-lg.avatar-away::before,\n.avatar-lg.avatar-offline::before,\n.avatar-lg.avatar-online::before {\n\tborder-width: 3px;\n}\n\n.avatar-xl {\n\twidth: 5rem;\n\theight: 5rem;\n}\n\n.avatar-xl .border {\n\tborder-width: 4px !important;\n}\n\n.avatar-xl .rounded {\n\tborder-radius: 8px !important;\n}\n\n.avatar-xl .avatar-title {\n\tfont-size: $font-size-28;\n}\n\n.avatar-xl.avatar-away::before,\n.avatar-xl.avatar-offline::before,\n.avatar-xl.avatar-online::before {\n\tborder-width: 4px;\n}\n\n.avatar-xxl {\n\twidth: 5.125rem;\n\theight: 5.125rem;\n}\n\n.avatar-xxl .border {\n\tborder-width: 6px !important;\n}\n\n.avatar-xxl .rounded {\n\tborder-radius: 8px !important;\n}\n\n.avatar-xxl .avatar-title {\n\tfont-size: $font-size-30;\n}\n\n.avatar-xxl.avatar-away::before,\n.avatar-xxl.avatar-offline::before,\n.avatar-xxl.avatar-online::before {\n\tborder-width: 4px;\n}\n\n.avatar-group {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tpadding-left: 15px;\n\tmargin-left: auto;\n\tmargin-right: 15px;\n\tcursor: pointer;\n}\n\n.avatar-group .avatar+.avatar {\n\tmargin-left: -.75rem;\n}\n\n.avatar-group .avatar-xs+.avatar-xs {\n\tmargin-left: -15px;\n}\n\n.avatar-group .avatar-sm+.avatar-sm {\n\tmargin-left: -.625rem;\n}\n\n.avatar-group .avatar-lg+.avatar-lg {\n\tmargin-left: -1rem;\n}\n\n.avatar-group .avatar-xl+.avatar-xl {\n\tmargin-left: -1.28125rem;\n}\n\n.avatar-group .avatar:hover {\n\tz-index: 1;\n}\n\n.avatar-group.group-col {\n\tdisplay: block;\n}\n\n.avatar-group.group-col > div {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tpadding-bottom: 5px;\n}\n\n.avatar-group.group-col .avatar {\n\tmargin-right: 0;\n}\n\n.contact-close {\n\tfloat: right;\n\tleft: 95%;\n\tright: 0px;\n\tposition: relative;\n\ttop: 5%;\n}\n\n.status_contactclose {\n\tfloat: right;\n\tleft: 95%;\n\tright: 0px;\n\tposition: relative;\n\ttop: 1%;\n}\n\n.status-active {\n\tborder: 4px solid #650681;\n}\n\n.avatar.avatar-xl .avatar-title {\n\tfont-size: 39px;\n}\n\n.nav.nav-tabs {\n\tborder: none;\n\tline-height: 2;\n}\n\n.badge {\n\tpadding: 5px 10px;\n\tfont-size: 11px;\n}\n\n.badge.badge-success {\n\tbackground: #0abb87;\n}\n\n.badge.badge-danger {\n\tbackground: #fd397a;\n}\n\n.badge.badge-secondary {\n\tbackground: dimgray;\n}\n\n.badge.badge-info {\n\tbackground: #00bcd4;\n}\n\n.badge.badge-warning {\n\tbackground: #ffb822;\n}\n\n.badge.badge-dark {\n\tbackground: #3a3f51;\n}\n\n.badge.badge-primary {\n\tbackground: #0a80ff;\n}\n\n.badge.badge-light {\n\tbackground: #e6e6e6;\n}\n\n.btn {\n\tposition: relative;\n}\n\n.btn .badge {\n\tpadding: 2px 6px;\n\tright: 7px;\n\ttop: -7px;\n\tposition: absolute;\n}\n\n.input-group .input-group-text {\n\tfont-size: $font-size-14;\n}\n\n.tooltip > .tooltip-inner {\n    text-align: left;\n    max-width: 500px;\n    --bs-tooltip-bg: $primary;\n}\n.tooltip {\n    --bs-tooltip-bg: $primary;\n}\n.tooltip .arrow {\n\tdisplay: none;\n\tbackground-color: $primary;\n}\n.tooltip .tooltip-inner {\n\tbackground-color: $primary;\n}\n\n.sticky-top {\n\tz-index: auto;\n}\n\n.tab-content {\n\tpadding-top: 30px;\n}\n\n.tab-content .form-item {\n\tmargin-bottom: .8rem;\n}\n\n.main-wrapper {\n\theight: 100vh;\n\toverflow: hidden;\n}\n\n.main-wrapper .content {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\t@include respond-below(custom991) {\n\t\tdisplay: block;\n\t}\n}\n\n.main-wrapper .content .sidebar-group {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\tposition: relative;\n\tz-index: 99;\n\twidth: 340px;\n\t@include respond-below(custom991) {\n\t\twidth: 100%;\n\t}\n}\n\n.chats {\n\t.chat-content {\n\t\t@include respond-below(custom575) {\n\t\t\twidth: calc(100% - 55px);\n\t\t}\n\t}\n}\n.main-wrapper .content .sidebar-group .sidebar {\n\tbackground: $white;\n\toverflow: hidden;\n\twidth: 340px !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tborder-right: 1px solid rgba(224, 224, 224, 1);\n\t@include respond-below(custom991) {\n\t\twidth: 100%!important;\n\t}\n}\n\n.main-wrapper .content .sidebar-group .sidebar:not(.active) {\n\tdisplay: none;\n}\n\n.header-top {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 30px;\n\tfont-weight: $font-weight-semibold;\n\tbackground-color: #680A83;\n}\n\n.header-top .logo {\n\tmargin-top: 0 !important;\n}\n\n.header-top > span {\n\tfont-size: $font-size-22;\n}\n\n.header-top ul {\n\tmargin-bottom: 0;\n\tdisplay: flex;\n}\n\n.header-top ul.header-action {\n\tmargin-top: 14px !important;\n}\n\n.chat-header ul {\n\tmargin-bottom: 0;\n}\n\n.chat-header ul li:not(.list-inline-item) {\n\tmargin-bottom: 0;\n\twidth: 48px;\n\tmargin-right: 15px !important;\n}\n\n.chat-header ul li:last-child {\n\tmargin-right: 0 !important;\n}\n\n.sidebar-body {\n\tflex: 1;\n\toverflow: auto;\n\tpadding: 24px 24px 10px;\n\twidth: 100%;\n}\n.pin-chat img {\n\tmargin-right: 6px;\n}\n.sidebar-body .profile-name {\n\tfont-weight: $font-weight-semibold;\n\tcolor: #0A0A0A;\n\tfont-size: $font-size-18;\n\tmargin-bottom: 0;\n}\n\n.online-profile {\n\tposition: relative;\n}\n\n.online-profile span {\n\tposition: relative;\n\tcolor: #565656;\n\tfont-size: 13px;\n\tpadding-left: 10px;\n}\n\n.online-profile span:before {\n\tcontent: \"\";\n\tposition: absolute;\n\tleft: 0;\n\ttop: 7px;\n\tbackground-color: #49E073;\n\twidth: 8px;\n\theight: 8px;\n\tborder-radius: 50px;\n}\n\n.close_profile4 {\n\tcolor: $black;\n\tborder-color: #e6e6e6;\n}\n\n.sidebar .user-list li a {\n\tpadding: 10px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tcursor: pointer;\n\tmargin-bottom: 15px;\n\tborder: 1px solid #E0E0E0;\n\tbox-shadow: none;\n\tborder-radius: 5px;\n\tposition: relative;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n}\n\n.sidebar .user-list li a:hover {\n\tbackground-color: rgba(254, 159, 67, 0.08);\n\tborder: 1px solid rgba(254, 159, 67, 0.08);\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n}\n\n.sidebar .user-list li.item-typing {\n\tbackground-color: #F1F6FF;\n}\n\n.sidebar .user-list li figure {\n\tmargin-right: 1rem;\n}\n\n.sidebar .user-list li .users-list-body {\n\tflex: 1;\n\tposition: relative;\n\tmin-width: 0px;\n\tdisplay: flex;\n}\n\n.lock-icon {\n\tcolor: #000000;\n}\n\n.sidebar .user-list li .users-list-body > div:first-child {\n\tmin-width: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n}\n.parti-notify-check {\n\tmargin-bottom: 0 !important;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.sidebar .user-list li .users-list-body h5 {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfont-size: $font-size-15;\n\tfont-weight: $font-weight-medium;\n\tmargin-bottom: 3px;\n\tcolor: #0A0A0A;\n}\n\n.sidebar .user-list li .users-list-body p {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tmargin-bottom: 0;\n\tcolor: #232323;\n\tfont-size: $font-size-14;\n}\n.sidebar .user-list li .users-list-body p.missed-call-col {\n\tcolor: #DE3E44;\n}\n.sidebar .user-list li .users-list-body .last-chat-time {\n\tpadding-left: 15px;\n\tposition: relative;\n}\n\n.sidebar .user-list li .users-list-body .last-chat-time .text-muted {\n\tcolor: #424242 !important;\n\tfont-weight: $font-weight-normal;\n\tfont-size: 12px;\n\tmargin-bottom: 5px;\n\tdisplay: block;\n\ttext-align: right;\n}\n.sidebar .user-list li .users-list-body .last-chat-time .contact-toggle {\n\tcolor: #680A83;\n}\n\n.sidebar .user-list li .users-list-body .last-chat-time .new-message-count {\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tline-height: 0;\n\tfont-size: 11px;\n\tbackground-color: $primary;\n\tcolor: $white;\n\tborder-radius: 50%;\n\tmargin-left: auto;\n\tmargin-top: 10px;\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n}\n\n.sidebar .user-list li .users-list-body .last-chat-time .chat-toggle {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\topacity: 0;\n\ttext-align: right;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\twidth: 18px;\n\theight: 24px;\n}\n\n.sidebar .user-list li.unread h5 {\n\tcolor: $white;\n}\n\n.sidebar .user-list li.unread p {\n\tcolor: $white;\n}\n\n.sidebar .user-list li.unread .text-muted {\n\tcolor: rgba(255, 255, 255, 0.4) !important;\n}\n\n.sidebar .user-list li.user-list-item.item-typing .users-list-body p {\n\tcolor: #0D9B35;\n}\n\n.rightside_tab {\n\tpadding-top: 5px !important;\n}\n.chat-pin {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: end;\n\t-webkit-justify-content: end;\n\t-ms-flex-pack: end;\n\t.green-check {\n\t\tcolor: #0D9B35;\n\t}\n}\n.chat-pin img {\n\twidth: 10px;\n}\n.chat-pin .check {\n\tcolor: #53BDEB;\n}\n.select-message-box {\n\tmargin-top: 50px;\n}\n.select-message-box h4 {\n\tmargin-bottom: 5px;\n}\n.select-message-box p {\n\tmargin-top: 0;\n\tmargin-bottom: 24px;\n\tcolor: #424242;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-normal;\n}\n.select-message-box .btn i {\n\tfont-size: $font-size-15;\n}\n\n.group-description {\n\tpadding: 0px 24px;\n}\n.group-description .description-sub {\n\tborder-bottom: 1px solid #EDEDED;\n\tpadding-bottom: 15px;\n\tmargin-bottom: 15px;\n}\n.group-description h5 {\n\tfont-size: $font-size-15;\n\tfont-weight: $font-weight-medium;\n\tcolor: #0A0A0A;\n\tmargin-bottom: 10px;\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n}\n.group-description h5 a:hover {\n\tcolor: #650681 !important;\n}\n.group-description p { \n\tcolor: #424242;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-normal;\n\tmargin-bottom: 10px;\n}\n.group-description p.description-date { \n\tcolor: #424242;\n\tfont-size: 12px;\n\tfont-weight: $font-weight-normal;\n\tmargin-bottom: 0px;\n}\n.encrypted-message p {\n\tfont-size: 12px;\n\tcolor: #424242;\n\tfont-weight: $font-weight-normal;\n\tmargin-bottom: 0;\n}\n.group-view-all {\n\tmargin-top: 10px;\n}\n.group-view-all a {\n\tcolor: #680A83;\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-medium;\n}\n.group-view-all a:hover {\n\tcolor: #0A0A0A;\n}\n.exit-bg-message {\n\tbackground: #FFE8E9;\n}\n.exit-bg-message i {\n\tcolor: #DE3E44;\n}\n.disapper-message {\n\tbackground: #E7FAF2;\n}\n.disapper-message i {\n\tcolor: #1BA345;\n}\n.group-setting-msg {\n\tbackground: #F8ECFF;\n}\n.group-setting-msg i {\n\tcolor: #680A83;\n}\n.group-setting .stared-group span {\n\twidth: 50px;\n\theight: 50px;\n}\n.edit-set-details p {\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-normal;\n\tcolor: #424242;\n\tmargin-bottom: 0;\n}\n.group-send-msg {\n\tbackground: #FEF6DC;\n}\n.parcipant-check p a {\n\tcolor: #680A83;\n}\n.select-group-chat .dropdown-toggle::after {\n\tdisplay: none;\n}\n.select-group-chat .dropdown-toggle i {\n\tmargin-left: 15px;\n}\n.select-group-chat .dropdown-toggle:hover {\n\tcolor: #0A0A0A;\n}\n.select-group-chat .dropdown-toggle {\n\tfont-weight: $font-weight-semibold;\n\tcolor: #0A0A0A;\n\tfont-size: $font-size-18;\n}\n.select-group-chat .dropdown-menu .dropdown-item {\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-normal;\n\tcolor: #0A0A0A;\n}\n.select-group-chat .dropdown-menu li:first-child .dropdown-item:hover {\n\tborder-radius: 5px 5px 0 0;\n}\n.select-group-chat .dropdown-menu li:last-child .dropdown-item:hover {\n\tborder-radius: 0 0 5px 5px;\n}\n.dropzone {\n\tbackground: $white;\n\tborder: 1px dashed #C2C2C2;\n\tborder-radius: 5px;\n\tpadding: 10px;\n\tmin-height: 70px;\n\ttext-align: center;\n}\n.dropzone.dz-clickable .dz-message {\n\tdisplay: none;\n}\n.dropzone p {\n\tmargin-bottom: 10px;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-medium;\n\tcolor: #0A0A0A;\n}\n.dropzone span {\n\tcolor: #424242;\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-normal;\n}\n.uplaod-image img {\n\tborder-radius: 20px;\n}\n.upload-img-file .modal-body {\n\tpadding: 0;\n}\n.upload-img-file .modal-content {\n\tposition: relative;\n}\n.upload-img-file .modal-header {\n\tposition: absolute;\n\ttop: 0;\n\tz-index: 9;\n\tleft:0;\n\tright: 0;\n}\n.upload-image-list {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n}\n.upload-image-list li+li {\n\tmargin-left: 10px;\n}\n.upload-img-file .modal-header .close {\n\tbackground-color: transparent;\n\tcolor: $white;\n}\n.check-star i {\n\tcolor: #FEC001;\n}\n.emoj-group-list {\n\tdisplay: none;\n\tposition: absolute;\n\ttop: -50px;\n\tleft: -90px;\n\ttransition: all 0.5s ease;\n    -moz-transition: all 0.5s ease;\n    -o-transition: all 0.5s ease;\n    -ms-transition: all 0.5s ease;\n    -webkit-transition: all 0.5s ease;\n}\n.emoj-group-list ul {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tbackground: #f6f7f8;\n\tborder-radius: 50px;\n\tpadding: 5px;\n}\n.emoj-group-list ul li a {\n\tpadding: 0;\n}\n.emoj-group-list ul li.add-emoj a {\n\tbackground: #EDEDED;\n}\n.emoj-group-list ul li.add-emoj a i {\n\tfont-size: $font-size-20;\n\tcolor: #424242;\n}\n.chat .slimscroll {\n\theight: calc(100vh - 60px) !important;\n}\n.settings-option {\n\tdisplay: none;\n\ttext-align: right;\n}\n.settings-option a {\n\tfont-size: $font-size-15;\n\tfont-weight: $font-weight-medium;\n\tcolor: #680A83;\n}\n.empty-dark-img {\n\tdisplay: none;\n}\n.bootstrap-datetimepicker-widget span {\n\tposition: relative;\n}\n\n}\n.chat-window{\n    .card{\n        .card-header {\n            background-color: $white;\n            border-bottom: 1px solid $gray-300;\n        }\n    }\n    .badge-success {\n        background-color: $success !important;\n    }\n}\n.chat-page {\n    .footer {\n        display: none;\n    }\n}\n.chat-search{\n    .input-group {\n        .form-control{\n            @include margin-padding(0,0 0 0 36px);\n            height: 46px;\n        }\n        .input-group-prepend {\n        \tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n            color: $gray-700;\n            pointer-events: none;\n            z-index: 4;\n            @include position(absolute,0,15px,0,null);\n        }\n    }\n}\n.chat-cont-left {\n    .chat-scroll {\n        max-height: calc(100vh - 200px);\n        overflow-y: auto;\n        padding: 0;\n        .media {\n            border-bottom: 1px solid $gray-300;\n            @include margin-padding(0,10px);\n            @include transition(all .2s);\n            &.active {\n                background-color:  $gray-100;\n            }\n            &:hover{\n                background-color:  $gray-100;\n            }\n            .media-img-wrap {\n                @include margin-padding(0  15px 0 0,null);\n                position: relative;\n                .avatar > img {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                }\n            }\n            .media-body {\n                display: -webkit-box;\n\t\t        display: -ms-flexbox;\n\t\t        display: flex;\n\t\t        justify-content: space-between;\n    \t\t\t-webkit-justify-content: space-between;\n    \t\t\t-ms-flex-pack: space-between;\n                .user-name{\n                    max-width: 170px;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                    color: $gray-900;\n                    font-size: $font-size-16;\n                    font-weight: $font-weight-bold;\n                }\n                .user-last-chat {\n                    color: $gray-800;\n                    font-size: $font-size-base;\n                    line-height: 24px;\n                    max-width: 170px;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                }\n                .last-chat-time {\n                    color: $gray-600;\n                    font-size:$font-size-13;\n                }\n                 div{\n                    &:last-child {\n                        text-align: right;\n                    }\n                }\n            }\n        }\n    }\n    \n}\n.chat-cont-right {\n    @include transition(all 0.4s);\n    .chat-scroll {\n        max-height: calc(100vh - 293px);\n        overflow-y: auto;\n        \n    }\n    .msg_head {\n        .back-user-list {\n            display: none;\n            @include margin-padding(0 0 0 -10px ,0 10px);\n        }\n    }\n    .img_cont {\n        position: relative;\n        height: 45px;\n        width: 45px;\n        .user_img {\n            height: 45px;\n            min-width: 45px;\n            width: 45px;\n            border: 1.5px solid $primary;\n        }\n    }\n    .user_info {\n        @include margin-padding(0 auto 0 15px,0);\n        width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    ul.list-unstyled {\n        @include margin-padding(0 auto,0);\n        width: 100%;\n        .media{\n            &.sent {\n                margin-bottom: 20px;\n                .avatar {\n                    order: 3;\n                    height: 30px;\n                    width: 30px;\n                }\n                .media-body {\n                \tdisplay: -webkit-box;\n\t\t\t        display: -ms-flexbox;\n\t\t\t        display: flex;\n                    -webkit-box-align: flex-end;\n  \t\t\t\t\t-ms-flex-align: flex-end;\n  \t\t\t\t\talign-items: flex-end;\n                    -ms-flex-direction: column;\n  \t\t\t\t\tflex-direction: column;\n                    @include margin-padding(0 20px 0 0 ,0);\n                    .msg-box {\n                        @include margin-padding(0,0 0 0 50px);\n                        position: relative;\n                        + .msg-box{\n                            @include margin-padding(5px 0 0,0);\n                        }\n                        p{\n                            @include margin-padding(0,0);\n                        }\n                        &:first-child::before {\n                            border-bottom: 6px solid transparent;\n                            border-left: 6px solid #e3e3e3;\n                            border-top: 6px solid #e3e3e3;\n                            border-right: 6px solid transparent;\n                            content: \"\";\n                            height: 0;\n                            width: 0;\n                            @include position(absolute,0,-12px,null,auto);\n                        }\n                       > div {\n                            @include margin-padding(0,10px 15px);\n                            @include rounded(10px);\n                            background-color: #e3e3e3;\n                            display: inline-block;\n                            position: relative;\n                        }\n                        &:first-child > div {\n                            @include rounded(10px 0 10px 10px) ;\n                        }\n                    }\n                    .chat-msg-attachments {\n                    \tdisplay: -webkit-box;\n\t\t\t\t        display: -ms-flexbox;\n\t\t\t\t        display: flex;\n                        @include margin-padding(0 -1px,4px 0);\n                        width: 100%;\n                        .chat-attachment {\n                            position: relative;\n                            max-width: 130px;\n                            overflow: hidden;\n                            &:before {\n                                @include position(absolute,0,0,0,0);\n                                background: $black;\n                                content: \"\";\n                                opacity: 0.4;\n                                @include transition(all .4s);\n                            }\n                            &:hover{\n                                .chat-attach-download{\n                                    opacity: 1\n                                }\n                            }\n                        }\n                       > div {\n                            margin: 0 1px;\n                        }\n                        \n                        img {\n                            max-width: 100%;\n                        }\n                        .chat-attach-download {\n                            @include position(absolute,50%,null,null,50%);\n                            transform: translate(-50%, -50%);\n                            opacity: 0;\n                            @include transition(all .4s);\n                            color: $white;\n                            width: 32px;\n                            line-height: 32px;\n                            background: rgba(255, 255, 255, 0.2);\n                            text-align: center;\n                        }\n                    }\n                    .chat-msg-info {\n                    \tdisplay: -webkit-box;\n  \t\t\t\t\t\tdisplay: -ms-flexbox;\n  \t\t\t\t\t\tdisplay: flex;\n                    \talign-items: center;\n  \t\t\t\t\t\t-webkit-box-align: center;\n  \t\t\t\t\t\t-ms-flex-align: center;\n                        @include margin-padding(5px 0 0,0);\n                        -ms-flex-wrap: wrap;\n  \t\t\t\t\t\tflex-wrap: wrap;\n                        clear: both;\n                        flex-direction: row-reverse;\n                        list-style: none;\n                        li{\n                            @include margin-padding(0,0 0 0 16px);\n                            position: relative;\n\n                            &:not(:last-child)::after {\n                                @include position(absolute,50%,auto,null,8px);\n                                transform: translate(-50%, -50%);\n                                background: $primary;\n                                content: '';\n                                height: 4px;\n                                width: 4px;\n                            }\n                        }\n                        .chat-time {\n                            color: rgba(50, 65, 72, 0.4);\n                        }\n                        a {\n                            color: $gray-800;\n                        }\n                    }\n                }\n            }\n            &.received {\n                position: relative;\n                margin-bottom: 20px;\n                .media-body{\n                    position: relative;\n                    @include margin-padding(0 0 0 20px,0);\n                    &::before {\n                        border-bottom: 6px solid transparent;\n                        border-right: 6px solid $primary;\n                        border-top: 6px solid $primary;\n                        border-left: 6px solid transparent;\n                        content: \"\";\n                        height: 0;\n                        @include position(absolute,0px,auto,null,-6px);\n                        width: 0;\n                    }\n                    > div {\n                        @include margin-padding(0,10px 15px);\n                        @include rounded(10px);\n                        background-color: $primary;\n                        display: table;\n                        position: relative;\n                        p {\n                            color: $white;\n                            @include margin-padding(0,0);\n                        }\n                    }\n                }\n                .msg-box {\n                    display: block;\n                    + .msg-box {\n                        margin-top: 5px;\n                    }\n                    \n            }\n            .chat-msg-info {\n                display: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n        \t\talign-items: center;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n                -ms-flex-wrap: wrap;\n  \t\t\t\tflex-wrap: wrap;\n                @include margin-padding(5px 0 0,0);\n                clear: both;\n                list-style: none;\n                .chat-time {\n                    color: rgba(255,255,255,.8);\n                }\n            }\n            .chat-msg-attachments {\n            \tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n                @include margin-padding(0 -1px,4px 0);\n                width: 100%;\n                .chat-attachment {\n                    position: relative;\n                    max-width: 130px;\n                    overflow: hidden;\n                    &:before {\n                        @include position(absolute,0,0,0,0);\n                        background: $black;\n                        content: \"\";\n                        opacity: 0.4;\n                        @include transition(all .4s);\n                    }\n                    &:hover{\n                        .chat-attach-download{\n                            opacity: 1\n                        }\n                    }\n                }\n               > div {\n                    margin: 0 1px;\n                }\n                \n                img {\n                    max-width: 100%;\n                }\n                .chat-attach-download {\n                    @include position(absolute,50%,null,null,50%);\n                    @include transform(translate(-50%, -50%));\n                    @include transition(all .4s);\n                    opacity: 0;\n                    color: $white;\n                    width: 32px;\n                    line-height: 32px;\n                    background: rgba(255, 255, 255, 0.2);\n                    text-align: center;\n                }\n            }\n        }\n           \n        }\n        .chat-date {\n            font-size: $font-size-base;\n            margin: 1.875rem 0;\n            overflow: hidden;\n            position: relative;\n            text-align: center;\n            text-transform: capitalize;\n            &:before {\n                background-color: #e0e3e4;\n                content: \"\";\n                height: 1px;\n                margin-right: 28px;\n                @include position(absolute,50%,50%,null,null);\n                width: 100%;\n            }\n            &:after {\n                background-color: #e0e3e4;\n                content: \"\";\n                height: 1px;\n                @include margin-padding(0 0 0 28px,null);\n                @include position(absolute,50%,null,null,50%);\n                width: 100%;\n            }\n        }\n    }\n    \n}\n.card-footer {\n    background-color: $white;\n    border-top: 1px solid $gray-300;\n    @include margin-padding(0,1rem 1.5rem);\n    .type_msg {\n        background-color: rgba(0,0,0,0.1) !important;\n        border: 0 !important;\n        overflow-y: auto;\n    }\n}\n@include respond-below(custom992) {\n    .chat-window.chat-slide .chat-cont-right {\n        right: 0;\n        opacity: 1;\n        visibility: visible;\n    }\n\n    .chat-cont-right {\n        @include position(absolute, null, -100px, null, null);\n        opacity: 0;\n        visibility: hidden;\n        z-index: 99;\n    }\n    .chat-cont-right .msg_head .back-user-list {\n        display: flex;\n        align-items: center;\n    }\n}\n.page-header {\n    .breadcrumb {\n        margin-bottom: 0;\n    }\n    h3{\n        font-weight: $font-weight-bold;\n        color: $gray-900;\n        font-size: $font-size-18;\n        @include respond-below(custom991) {\n            font-size: $font-size-base;\n        }\n    }\n    h4 {\n        font-weight: $font-weight-bold;\n        color: $gray-900;\n        font-size: $font-size-18;\n        margin-bottom: 5px;\n        @include respond-below(custom991) {\n            font-size: $font-size-18;\n        }\n    }\n    h6 {\n        font-size: $font-size-base;\n        color: $gray-700;\n        font-weight: $font-weight-normal;\n        @include respond-below(custom991) {\n            font-size: $font-size-12;\n        }\n        @include respond-below(custom575) {\n            font-size: $font-size-12;\n            margin-bottom: 20px;\n        }\n    }\n    .btn-filter {\n        background: $primary;\n        width: 34px;\n        height: 34px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        padding: 0;\n        &:hover{\n            background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\n        }\n    }\n    .page-btn {\n        margin-left: 10px;\n        @include respond-below(custom575) {\n            margin-left: 0;\n            margin-top: 20px;\n        }\n    }\n    .btn-added {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $primary;\n        padding: 8px 11px;\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-14;\n\t\theight: 40px;\n        border-radius: 5px;\n        &:active {\n            color: $white;\n        }\n        img{\n            filter: brightness(0) invert(1);\n        }\n        @include respond-below(custom991) {\n            padding: 10px 10px; \n        }\n        &:hover{\n            background: $title-color;\n        }\n        .me-2 {\n            width: 16px;\n            height: 16px;\n        }\n    }\n    .btn-added.downloader {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $gray-900;\n        padding: 9px 11px;\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-14;\n        border-radius: 8px;\n        margin: 0 15px 0 15px;\n        img{\n            filter: brightness(0) invert(1);\n        }\n        @include respond-below(custom991) {\n            padding: 10px 10px; \n        }\n        &:hover{\n            background: $primary;\n        }\n        .me-2 {\n            width: 16px;\n            height: 16px;\n        }\n    }\n    .btn-added.printer {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $danger;\n        padding: 9px 11px;\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-14;\n        border-radius: 8px;\n        img{\n            filter: brightness(0) invert(1);\n        }\n        @include respond-below(custom991) {\n            padding: 10px 10px; \n        }\n        &:hover{\n            background: $gray-900;\n        }\n        .me-2 {\n            width: 16px;\n            height: 16px;\n        }\n    }\n    .add-item {\n        @include respond-below(custom767) {\n            display: block !important;\n            .page-btn {\n                margin-left: 0;\n            }\n        }\n        .page-btn {\n            @include respond-below(custom575) {\n                 margin-left: 0;\n                 margin-bottom: 24px;\n            }\n        }\n        .page-title.modal-datail {\n            line-height: 2;\n        }\n    }\n    .add-item.d-flex {\n        margin-right: auto;\n    }\n    .add-item.payslip-list {\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        width: 100%;\n    }\n}\n.page-wrapper.details-blk {\n    padding: 0;\n    margin: 0;\n}\n.history-modal-profile {\n\t.content {\n\t\tpadding: 24px;\n\t}\n\t.right-sidebar-profile {\n\t\tbackground: $body-bg;\n\t\tborder-radius: 8px;\n\t\tpadding: 24px;\n\t\t.list-inline-item {\n\t\t\ta {\n\t\t\t\tbackground: $primary;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tdisplay: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: #1b2950;\n\t\t\t\t\tcolor: $white !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.avatar {\n\t\t\tmargin-bottom: 24px;\n\t\t\twidth: 150px;\n\t\t\theight: 150px;\n\t\t\timg {\n\t\t\t\tborder-radius: 8px;\n\t\t\t}\n\t\t}\n\t}\n}\n.msg-typing {\n    width: auto;\n    height: 24px;\n    padding-top: 8px;\n\tspan {\n\t\theight: 8px;\n\t\twidth: 8px;\n\t\tfloat: left;\n\t\tbackground-color: $white;\n\t\tdisplay: block;\n\t\topacity: .4;\n\t\t@include margin-padding(0 1px, null);\n\t\t@include rounded(50%);\n\t\t&:nth-of-type(1) {\n\t\t\tanimation: 1s blink infinite .33333s;\n\t\t}\n\t\t&:nth-of-type(2) {\n\t\t\tanimation: 1s blink infinite .66666s;\n\t\t}\n\t\t:nth-of-type(3) {\n\t\t\tanimation: 1s blink infinite .99999s;\n\t\t}\n\t}\n}\n@keyframes blink {\n\t50% {\n\t\topacity: 1\n\t}\n}\n\n.phone-call-icon {\n\tsvg {\n\t\twidth: 18px;\n\t}\n\t.income-success {\n\t\tcolor: $success;\n\t}\n\t.income-success-missed {\n\t\tcolor: $danger;\n\t}\n}\n.history-modal-profile {\n\t.content {\n\t\tpadding: 24px;\n\t}\n\t.right-sidebar-profile {\n\t\tbackground: $body-bg;\n\t\tborder-radius: 8px;\n\t\tpadding: 24px;\n\t\t.list-inline-item {\n\t\t\ta {\n\t\t\t\tbackground: $primary;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tdisplay: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n\t\t\t\tcolor: $white !important;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: #1b2950;\n\t\t\t\t\tcolor: $white !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.avatar {\n\t\t\tmargin-bottom: 24px;\n\t\t\twidth: 150px;\n\t\t\theight: 150px;\n\t\t\timg {\n\t\t\t\tborder-radius: 8px;\n\t\t\t}\n\t\t}\n\t}\n}\n.modal-profile-detail {\n\t.modal-userlist {\n\t\tli {\n\t\t\tfont-size: $font-size-14;\n\t\t\tcolor: $black;\n\t\t\tmargin-bottom: 10px;\n\t\t\tspan {\n\t\t\t\tdisplay: block;\n\t\t\t\tcolor: $text-color;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n.chat_sidebar.hide-left-sidebar {\n\t@include respond-below(custom991) {\n\t\t display: none !important;\n\t}   \n}\n.left-sidebar.hide-left-sidebar {\n\t@include respond-below(custom991) {\n\t\t margin-left: -991px;\n\t}      \n}\n\n\n",".img-cropper {\n\t.dropup {\n\t\t.dropdown-toggle {\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n.dropdown-auto {\n\toverflow: auto;\n}\n.dropdown-divider {\n\tmargin: 0;\n}\n.dropdown {\n\t.dropdown-toggle {\n\n\t\t&:after {\n      display: inline-block;\n      margin-inline-start: 0.25rem;\n      vertical-align: 0;\n      content: \"\\f078\";\n      font-family: \"Font Awesome 5 Free\";\n      border: 0;\n      font-size: 0.6rem;\n      font-weight: $font-weight-semibold;\n\t\t}\n\n\t\t&.btn-primary {\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t.dropdown-menu {\n\t\tfont-family: $font-family-primary;\n\t}\n}\n.dropdown {\n  & > a {\n      color: $gray-900;\n      border: 1px solid $light-900;\n      padding: 9px 15px;\n      border-radius: $border-radius-lg;\n      display: flex;\n      align-items: center;\n      box-shadow: 0px 4px 4px 0px #DBDBDB40;\n    }\n}\n.dropdown-menu {\n  border-color: $border-color;\n  box-shadow: 0 1rem 1.125rem rgba(169, 169, 169, 0.15);\n  font-size: 0.875rem;\n  color: $text-color;\n  background-color: $white;\n  padding: 0;\n  z-index: 10;\n}\n.dropdown-divider {\n  border-color: $border-color;\n}\n\n.dropdown-item-text {\n  color: $text-color;\n}\n.dropdown-header {\n  color: $text-color;\n}\n.dropdown-item {\n  color: $text-color;\n  white-space: unset;\n  padding: 0.5rem 0.9375rem;\n  font-size: 0.8125rem;\n\n  &.disabled,\n  &:disabled {\n    color: $text-color;\n    opacity: 0.5;\n  }\n  &:not(.active) {\n    &:hover,\n    &:focus,\n    &:active {\n      color: $primary;\n      background-color: rgba($primary, 0.05);\n    }\n  }\n  &.active {\n    background-color: $primary !important;\n  }\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f078\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f078\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f077\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f053\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.btn.dropdown-toggle-split {\n  opacity: 0.85;\n}\n\n.dropdown-menu-dark {\n  background-color: $dark;\n  border-color: rgba(255, 255, 255, 0.1);\n  li a {\n    color: $white;\n  }\n}\n.btn-list {\n\ta.dropdown-item {\n\t\tmargin-block-end: 0;\n\t}\n\t.btn-soft-success  {\n\t\t&:hover {\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\t.btn-soft-danger  {\n\t\t&:hover {\n\t\t\ttransform: translateY(0);\n\t\t}\n\t\t&:active {\n\t\t\n\t\t}\n\t}\n}\n\n.dropdown-menu {\n  @mixin dropdown-menu-color($color) {\n    background-color: $color;\n    li a {\n      color: rgba(255, 255, 255, 0.9);\n    }\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        color: $white;\n      }\n    }\n  }\n  &.dropdown-menu-primary {\n    @include dropdown-menu-color($primary);\n  }\n  &.dropdown-menu-secondary {\n    @include dropdown-menu-color($secondary);\n  }\n  &.dropdown-menu-warning {\n    @include dropdown-menu-color($warning);\n  }\n  &.dropdown-menu-info {\n    @include dropdown-menu-color($info);\n  }\n  &.dropdown-menu-success {\n    @include dropdown-menu-color($success);\n  }\n  &.dropdown-menu-danger {\n    @include dropdown-menu-color($danger);\n  }\n}\n.dropdown-menu {\n  &.dropmenu-item-primary {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($primary, 0.1) !important;\n        color: $primary;\n      }\n    }\n  }\n  &.dropmenu-item-secondary {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($secondary, 0.1) !important;\n        color: $secondary;\n      }\n    }\n  }\n  &.dropmenu-item-warning {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($warning, 0.1) !important;\n        color: $warning;\n      }\n    }\n  }\n  &.dropmenu-item-info {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($info, 0.1) !important;\n        color: $info;\n      }\n    }\n  }\n  &.dropmenu-item-success {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba(var(--success-rgb), 0.1) !important;\n        color: $success;\n      }\n    }\n  }\n  &.dropmenu-item-danger {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba(var(--danger-rgb), 0.1) !important;\n        color: $danger;\n      }\n    }\n  }\n}\n.dropdown-menu {\n  @mixin dropmenu-light-color($color) {\n    backdrop-filter: blur(2rem);\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        color: $white;\n        background-color: $color !important;\n      }\n    }\n  }\n  &.dropmenu-light-primary {\n    background-color: rgba(var($secondary), 0.1);\n    @include dropmenu-light-color($primary);\n  }\n  &.dropmenu-light-secondary {\n    background-color: rgba(var($secondary), 0.1);\n    @include dropmenu-light-color($secondary);\n  }\n  &.dropmenu-light-info {\n    background-color: rgba($info, 0.1);\n    @include dropmenu-light-color($info);\n  }\n  &.dropmenu-light-warning {\n    background-color: rgba($warning, 0.1);\n    @include dropmenu-light-color($warning);\n  }\n  &.dropmenu-light-success {\n    background-color: rgba($success, 0.1);\n    @include dropmenu-light-color($success);\n  }\n  &.dropmenu-light-danger {\n    background-color: rgba(var(--danger-rgb), 0.1);\n    @include dropmenu-light-color($danger);\n  }\n}\n.dropdown-divider {\n  margin: 0;\n}\n.bd-example > .dropdown-menu {\n  position: static;\n  display: block;\n}\n\n.dropdown-md {\n  min-width: 315px;\n}\n.table-action {\n  .action-icon {\n      width: 33px;\n      height: 33px;\n      background: $light-300;\n      border: 1px solid $light-900;\n      border-radius: 5px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      color: $gray-900;\n      &:hover {\n          color: $gray-900;\n          i {\n              color: $gray-900;\n          }\n      }\n  }\n  .dropdown-toggle {\n      &::after {\n          display: none;\n      }\n  }\n  .dropdown-menu {       \n          a {\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -webkit-box-align: center;\n              -ms-flex-align: center;\n              align-items: center;\n              @include margin-padding(null, 5px);\n              border-radius: 5px;\n              color: $title-color;\n              white-space: nowrap;\n              i {\n                  margin-right: 8px;\n              }\n              &:hover {\n                  background: $light-300;\n                  color: $title-color;\n              }\n          }       \n  } \n}\n.daterangepicker {\n  font-family: $font-family-primary;\n  .calendar-table {\n      th {\n          color: $gray-900;\n      }\n      td {\n          color: $gray-900;\n      }\n\n  }\n}\n.daterangepicker td.active, .daterangepicker td.active:hover {\n  background-color:$danger ;\n  color: $danger-100;\n}\n.daterangepicker .ranges li.active {\n  background-color: $green;\n}\n.sort-dropdown.drop-down {\n  .dropdown-menu li a {\n      white-space: nowrap;\n  }\n}\n.drop-down {\n  position: relative;\n  & > a {\n      border: 1px solid $light-900;\n      border-radius: 5px;\n      box-shadow: 0px 4px 4px 0px #DBDBDB40;\n      background: $white;\n      font-weight: $font-weight-medium;\n      display: -webkit-inline-box;\n      display: -ms-inline-flexbox;\n      display: inline-flex;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n      min-height: 42px;\n      @include margin-padding(null, 9px 15px);\n      i {\n          margin-right: 8px;\n      }   \n      &:hover {\n          color: $title-color;\n      }\n      &.show {\n          border: 1px solid #0092E4;\n      }  \n      &::after {\n          font-size: $font-size-14;\n          margin-left: 8px;\n      }\n      &[aria-expanded=true] {\n          &::after {\n              @include transition(all 0.2s ease);\n              @include transform(rotate(180deg));\n          }\n      } \n  }  \n  .dropdown-menu {\n      li {\n          a {\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              -webkit-box-align: center;\n              -ms-flex-align: center;\n              align-items: center;\n              @include margin-padding(null, 5px);\n              border-radius: 5px;\n              i {\n                  margin-right: 8px;\n              }\n              &:hover {\n                  background: $light-300;\n                  color: $title-color;\n              }\n          }\n      }\n  } \n}\n.dropdown-menu {\n  border: 1px solid $light-900;\n  padding: 15px;\n  box-shadow: $box-shadow-sm;\n}",".inbox-menu {\n    display: inline-block;\n    \n    width: 100%;\n    @include margin-padding(0 0 20px,0 );\n    li {\n        display: inline-block;\n        width: 100%;\n        a {\n            color: #333;\n            display: inline-block;\n            padding: 10px 15px;\n            width: 100%;\n            font-weight: $font-weight-semibold;\n            text-transform: capitalize;\n            -webkit-transition: 0.3s ease;\n            -moz-transition: 0.3s ease;\n            transition: 0.3s ease;\n            &:hover{\n                background: rgba(33, 33, 33, 0.05);\n            }\n            i {\n                font-size: $font-size-16;\n                padding-right: 10px;\n                color: #878787;\n            }\n        }\n    }\n}\n.compose-btn {\n    margin-bottom: 25px;\n}\n.top-action-left{\n    .btn-group {\n        margin-bottom: 5px;\n    }\n    .dropdown-toggle{\n        height: 40px;\n        &::after{\n            display: none;\n        }\n    }\n}\n.table-inbox {\n    .starred.fas.fa-star {\n        color: $warning;\n    }\n    .checked {\n        background-color: $gray-300;\n    }\n    th{\n        border-color: $light-700;  \n    }\n    tbody{\n        tr{\n            td{\n                font-size: $font-size-14;\n                color: $secondary;\n                border-color: $light-900;\n            }\n        }\n    }\n}\n.unread{\n    .name,\n    .subject,\n    .mail-date{\n        color: $black;\n        font-weight: $font-weight-bold;\n    }\n}\n.email-header{\n    .btn-white{\n        min-width: auto;\n        height: 38px;\n        border: 1px solid $light-900;\n        i{\n            margin-left:5px;\n        }\n    }\n}",".file-manager {\n    color:  $text-color;\n    .search-dropdown {\n        height: auto;\n    }\n    .form-sort {\n        width:  auto;\n        .select2-container--default .select2-selection--single .select2-selection__rendered {\n            padding-right: 27px;\n        }\n        &.owned-by {\n            margin-right: 10px;\n        }\n    }\n    &.notes-page-wrapper { \n        .content {\n            .page-add-notes {\n                padding-bottom: 30px;\n                margin-bottom: 30px;\n            }\n            .section-bulk-wrap {\n                margin-top: 0;\n                .form-sort {\n                    svg {\n                        &.fa-filter {\n                            top: 50%;\n                            @include transform(translateY(-50%));                            \n                        }\n                    }\n                }\n                .bulk-action-type {\n                    .select-bluk {\n                        margin-right: 15px;\n                    }\n                }\n            }\n        }\n    }\n    .page-header {\n        .btn-added {\n            margin-left: 10px;\n        }\n        .form-sort {\n            @include respond-below(custom575) {\n                margin-top: 0;\n                margin-bottom:  15px;\n            }\n        }\n        .table-top-head {\n            @include respond-below(custom575) {\n                margin-bottom: 15px;\n            }\n            li {\n                &:last-child {\n                    @include respond-below(custom991) {\n                        margin-right: 0;\n                    }\n                }\n            }\n        }\n    }\n    .bulk-action-type {\n        @include respond-below(custom767) {\n            align-items: start!important;\n        }\n        @include respond-below(custom575) {\n            display: block!important;\n        }\n        @include respond-below(custom767) {\n            .form-sort {\n                margin-top: 0;\n                margin-bottom: 15px;\n                width: 100%;\n            }\n        }\n    }\n    aside {\n        border: 1px solid $light-900;\n        box-shadow: $box-shadow;\n        @include rounded(8px);\n        h5 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n            border-bottom:  1px solid $gray-100;\n            @include margin-padding(0 0 15px 0, 0 0 15px 0);\n        }\n        .btn {\n            font-weight: $font-weight-bold;\n        }\n        .dropdown {\n            > a { \n                width: auto;\n                height: 40px;\n                color:  $white;\n                @include rounded(5px);\n                &:hover, &:focus {\n                    border-color: $gray-400;\n                    background: $gray-400;\n                }\n            }\n            ul {\n                width: 100%;\n                li {\n                    a {\n                        font-size: $font-size-15;\n                    }\n                }\n            }\n        }\n        ul {\n            li {\n                a {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    color: $text-color;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-semibold;\n                    @include margin-padding(0 0 5px 0, 7px 10px);\n                    @include rounded(5px);\n                    height: 40px;\n                    span {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        width: auto;\n                    }\n                    &:hover, &.active {\n                        background: $gray-400;\n                        color: $white;\n                    }\n                }\n            }\n        }\n        span {\n            font-size: $font-size-13;\n            font-weight: $font-weight-medium; \n            width: auto;\n            height: auto;\n        }\n        h6 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            position: relative;\n            z-index: 2;\n        }\n        .space-manager {\n            color:  $white;\n            background: $gray-400;\n            @include rounded(8px);\n            position: relative;\n            img {\n                @include position(absolute,0,0,null,null);\n            }\n            h6 {\n                a {\n                    color:  $white;\n                }\n            }\n            p {\n                color:  $sub-title;\n            }\n        }\n    }\n    .progress {\n        height: 6px;\n        @include rounded(5px);\n    }\n    .search-set {\n         .search-input {\n            input[type=search] {\n                width:  170px;\n                height: 40px;\n            }\n\n         }\n\n    }\n    .budgeted-role-notes {\n        .search-set {\n            .search-input {\n                input[type=search] {\n                    width:  298px;\n                }\n            }\n        }\n    }\n    h4 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-semibold;\n    }\n    h6 {\n        font-size: $font-size-16;\n        font-weight: $font-weight-semibold;\n        a {\n            color: $gray-400;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .overview {\n        .detail {\n            a {\n                &.bg {\n                    @include rounded(8px 8px 0 0);\n                    span {\n                        width: 66px;\n                        height: 66px;\n                        @include rounded(100%);\n                        img {\n                            @include transition(all 0.5s ease);\n                        }\n                    }\n                }\n                &:hover {\n                    img {\n                        transform: scale(1.2);\n                    }\n                }\n            }\n        }\n    }\n    .info {\n        @include rounded(0 0 8px 8px);\n        padding: 15px;\n        background: $white;\n        box-shadow: $box-shadow;\n        span {\n            color:  $text-color;\n            font-size: $font-size-13;\n        }\n    }\n    .folders {\n        border: 1px solid $light-900;\n        box-shadow: $box-shadow;\n        @include rounded(8px);\n        background: $white;\n        h6 {\n            width: 100%;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-right: 8px;\n        }\n    }\n\n    .dropdown {\n        > a {\n            color: $gray-400;\n            width: 25px;\n            height: 25px;\n            @include transition(all 0.5s ease);\n            @include rounded(100%);\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            &:hover {\n                background: $primary;\n                i {\n                    color: $white;\n                }\n            }\n        }\n    }\n    .project-plan {\n        font-size: $font-size-13;\n        font-weight: $font-weight-semibold;\n        margin-top: 10px;\n        label {\n            color: $gray-400;\n            margin-right: 9px;\n            font-size: $font-size-13;\n        }\n        ul {\n            li {\n                font-size: $font-size-13;\n                position: relative;\n                padding: 0 9px 0 14px;\n                color:  $text-color;\n                &:before {\n                    content:  '';\n                    @include position(absolute,50%,null,null,0);\n                    @include transform(translateY(-50%));\n                    width: 5px;\n                    height: 5px;\n                    background: $gray-400;\n                    @include rounded(5px);\n                }\n            }\n        }\n    }\n    .avatar-wrap {\n        a {\n            svg {\n                color: $text-color;\n                width: 18px;\n            }\n            &:hover {\n                svg {\n                    color: $primary; \n                    \n                }\n            }\n        }\n    }\n    .accordion {\n        border:  none;\n        --bs-accordion-border-width: none;\n        .accordion-item {\n            border:  none;\n            border-bottom: 1px solid $light-900;\n            background: none;\n            &:last-of-type {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n                border-bottom: none;\n            }\n            .accordion-button {\n                background: none;\n                border:  none;\n                font-size: $font-size-18;\n                font-weight: $font-weight-semibold;\n                color: $gray-400;\n                padding: 0;\n                display: inline-block;\n                width: auto;\n                &:after {\n                    @include transition(all 0.8s ease);\n                    background-image: none;\n                    content: \"View All\";\n                    font-family: \"Nunito\", sans-serif;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-bold;\n                    color: $text-color;\n                    transform:  none;\n                    width: 60px;\n                    text-align: right;\n                }\n                &:not(.collapsed)::after {\n                    content: \"Hide\";\n                }\n                &.collapsed {\n                    padding: 0;\n                }\n                &:hover {\n                    &:after {\n                        color: $primary;\n                    }\n                }\n            }\n            .accordion-body {\n                border: none;\n                padding: 0;\n                .head {\n                    img {\n                        min-width: 32px;\n                        width:  32px;\n                        height: 32px;\n                    }\n                }\n                .owl-carousel {\n                    padding-top: 15px;\n                }\n            }\n\n        }\n    }\n    .owl-carousel {\n        .owl-item {\n            margin-left: -0.1px!important;\n        }\n        .dropdown-menu {\n            left: auto !important;\n            right: 0 !important;\n            top:  27px !important;\n            transform: none !important;\n            background: $white !important;\n            box-shadow: $box-shadow;\n            z-index: 99999 !important;\n        }\n        .owl-nav {\n            top: -20px;\n            left: 43px;\n            display: inline-table;\n            button {\n                margin-top: 0;\n                margin-bottom: 0;\n                background: none;\n                cursor: pointer;\n                &.owl-next, &.owl-prev {\n                    position: relative;\n                    width: 15px;\n                    i {\n                        color: $text-color;\n                    }\n                    &:hover {\n                        background: none;\n                        i {\n                           color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        &.folders-carousel {\n           .owl-nav {\n                left:  75px;\n            } \n        }\n        &.video-section {\n            .owl-nav {\n                left:  60px;\n            }\n            .info {\n                a {\n                    svg {\n                        color: $text-color;\n                        width: 18px;\n                    }\n                }\n            }\n        }\n    }\n    .all-files {\n        box-shadow: $box-shadow;\n        border: none;\n        .btn-grp {\n            a {\n                padding: 6px 8px;\n                @include rounded(8px);\n                cursor: pointer;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                @include respond-below(custom575) {\n                    margin-bottom: 15px;\n                    display: inline-block;\n                }\n                &.btn-outline-secondary {\n                    color:  $text-color;\n                    background: $body-bg;\n                    border-color: $body-bg;\n                }\n                &:hover {\n                    background: $gray-400;\n                    border-color: $gray-400;\n                    color: $white;\n                }\n            }\n        }\n        .table { \n            thead {\n                tr {\n                    th {\n                        border-color: $light-900;\n                    }\n                }\n            }\n            tbody {\n                tr { \n                    td {  \n                        display: table-cell;\n                        font-size: $font-size-base;\n                        font-weight: $font-weight-medium;\n                        white-space: nowrap;\n                        border-color: $light-900;\n                        a {\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-medium;\n                            &.product-img { \n                                img {\n                                    width: 32px;\n                                    height: 32px;\n                                    border: 0;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    #file-delete {\n        font-size: $font-size-base;\n    }\n}\naside {\n    padding: 24px;\n}\n.color-primary {\n    color:  $text-color;\n}\n.icon-select {\n    position: relative;\n    width: 149px;\n    height: 38px;\n\n    .icon {\n        @include position(absolute,50%,null,null,10px);\n        @include transform(translateY(-50%));\n        z-index: 100;\n    }\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 30px;\n    }\n}\n.bg-light-orange {\n    background: $primary-200;\n    span {\n        background: $primary-200;\n    }\n}\n.bg-light-red {\n    background: $danger-200;\n    span {\n        background: $danger-200;\n    }\n}\n.bg-light-green {\n    background: $success-300;\n    span {\n        background: $success-300;\n    }\n}\n.seprator-sm {\n    @include margin-padding(0 0 24px 0, 0 0 9px 0);\n    border-bottom: 1px solid $gray-100;\n}\n.seprator-lg {\n    @include margin-padding(0 0 24px 0, 0 0 24px 0);\n    border-bottom: 1px solid $light-900;\n}\n.group-avatar {\n    .avatar {\n        position: relative;\n        width: 43px;\n        height: 43px;\n        line-height: 43px;\n        margin: 0;\n    \n         & +.avatar {\n            margin-left: -1.2rem;\n        }\n        &:hover {\n            z-index: 1;\n        }\n    }\n    .count {\n        a { \n            color: $success;\n            line-height: 27px;\n            font-size: $font-size-13;\n            font-weight: $font-weight-medium;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .avatar img {\n      display: block;\n      border-radius: 100%;\n      width: 100%;\n      border: 2px solid $white;\n    }\n}\n\n.video-section .item{\n  opacity:0.4;\n  transition:.4s ease all;\n  transform:scale(.8);\n}\n\n@media(max-width:1000px){\n  .video-section .item{margin:0; transform:scale(.9)}\n}\n\n.video-section .active .item{\n  opacity:1;\n  transform:scale(1);\n} \n\n.video-section .owl-item {\n    -webkit-backface-visibility: hidden;\n    -webkit-transform: translateZ(0) scale(1.0, 1.0);\n}\n\n.video-section video{\n  max-width:100%;\n  height:100%;\n  @include rounded(10px 10px 0 0);\n}\n.delete-alert {\n    padding: 10px 20px;\n    background: $danger-200;\n    border:  none;\n    @include rounded(8px);\n    p {\n        font-size: $font-size-15;\n    }\n    .btn {\n        font-weight: $font-weight-bold;\n    }\n}\n.deleted-info {\n    display: none;\n    .bin-bg {\n        width: 184px;\n        height: 184px;\n        @include rounded(100%);\n        background: $light;\n        margin: 0 auto;\n    }\n}\n.popup-toggle {\n    cursor: pointer;\n}\n.toggle-sidebar {\n    width: 456px;\n    padding: 25px;\n    position: fixed;\n    right: -456px;\n    top: 0;\n    height: 100%;\n    background: $white;\n    z-index: 100001;\n    border-top-left-radius: 15px;\n    border-bottom-left-radius: 15px;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\n    overflow-y: auto;\n    @include transition(all 0.5s ease);\n    @include respond-below(custom575) {\n        width: 320px;\n        right: -320px;\n    }\n    &.open-sidebar {\n        right: 0;\n        @include transition(all 0.5s ease);\n    }\n    .head {\n        .color-primary {\n            &:hover {\n                color: $danger;\n            }\n        }\n    } \n    h4, h5 {\n        font-weight: $font-weight-bold;\n    }\n    h4 {\n        font-size: $font-size-20;\n    }\n    h5 {\n        font-size: $font-size-18;\n    }\n    h6 {\n         font-size: $font-size-15;\n        font-weight: $font-weight-semibold;\n    }\n    .nav-tabs {\n        border-bottom: 1px solid $gray-100;\n        .nav-link {\n            padding: 8px 20px;\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            @include rounded(8px);\n            border: none;\n            background: $body-bg;\n            color: $gray-400;\n            &:hover, &.active {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n    .tab-content {\n        .tab-pane {\n            ul {\n                li {\n                    h6 {\n                        margin-bottom: 5px;\n                    }\n                    p {\n                        &.location {\n                            background: $body-bg;\n                            border: 1px solid $gray-100;\n                            @include rounded(5px);\n                            padding: 5px;\n                            display: inline-block;\n                            img {\n                                width: 20px;\n                                height: 20px;\n                            }\n                        }\n                    }\n                    .note-editor.note-airframe .note-statusbar, .note-editor.note-frame .note-statusbar {\n                        border-top: none;\n                    }\n                }\n            }\n            .avatar-access {\n                span {\n                    a {\n                        display: inline-flex; \n                        margin-right: 3px;\n                        padding-right: 3px;\n                    }\n                    &:first-child {\n                        a {\n                            margin-right: 10px;\n                            padding-right: 10px;\n                            border-right: 1px solid $gray-100;\n                        }\n                    }\n                    &:last-child {\n                        a {\n                            margin-right: 0;\n                            padding-right: 0;\n                        }\n                    }\n                    .add {\n                        background: $primary;\n                        color:  $white;\n                        &:hover {\n                            background: $gray-400;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    p {\n        color: $text-color;\n        font-size: $font-size-15;\n    }\n    .show-all {\n        font-weight: $font-weight-bold;\n        &:hover {\n            color: $gray-400;\n        }\n    }\n\n}\n.text-danger {\n    color: $danger!important;\n}\n.avatar-md {\n    width: 45px;\n    height: 45px;\n    @include rounded(45px);\n}\n.text-secondary {\n    color: $gray-400!important;\n}\n.text-primary {\n    color: $primary!important;\n}\n.text-default {\n    color: $text-color;\n}\n.btn-icon {\n    svg {\n        width: 18px;\n}\n}\n\n.file-manager-modal {\n    .modal-header {\n        h5 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n        }\n    }\n    &#hold-order {\n        h2 {\n            font-size: $font-size-36;\n            font-weight: $font-weight-bold;\n            color: $gray-900;\n            margin-bottom: 10px;\n            background-color: $body-bg;\n            @include rounded(10px);\n        }\n        .input-block {\n            label {\n                margin-bottom: 5px;\n            }\n        }\n        p {\n            margin-top: 20px;\n        }\n    }\n    &#recents {\n        .table {\n            tbody {\n                tr {\n                    td {\n                        padding: 10px 15px;\n                    }\n                }\n            }\n\n        }\n    }\n    .badge {\n        padding: 5px 10px;\n        font-size: $font-size-15;\n        font-weight: normal;\n    }\n    &#orders {\n        .modal-dialog {\n            max-width: 575px;\n        }\n        .order-body{\n            height: 50vh;\n            overflow: auto;\n            .default-cover {\n                border: 1px solid $gray-100;\n                box-shadow: $box-shadow;\n                @include rounded(8px);\n            }\n            .record {\n                font-size: $font-size-15;\n                td {\n                    padding-bottom: 15px;\n                }\n                tr {\n                    &:last-child {\n                        td {\n                            padding-bottom: 0;\n                        }\n                    }\n                }\n                .colon {\n                    padding: 0 10px;\n                    color: $secondary;\n                }\n                .text {\n                    color: $text-color;\n                    white-space: nowrap;\n                }\n            }\n            p {\n                font-size: $font-size-15;\n                background-color: $body-bg;\n                @include rounded(8px);\n            }\n            .search-set {\n                .search-input {\n                    width: 100%;\n                    label {\n                        width: 100%;\n                        input {\n                            width: 100%;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.upload-modal {\n        .modal-body{ \n            .drag-drop {\n                position: relative;\n                padding: 20px;\n                border:  1px dashed $sub-title;\n                input[type=\"file\"] {\n                    @include position(absolute,0,0,null,0);\n                    width: 100%;\n                    height: 100%;\n                    opacity: 0;\n                    cursor: pointer;\n                }\n            }\n            span {\n                font-size: $font-size-13;\n                font-weight: $font-weight-medium;\n                color: $text-color;\n            }\n            p {\n                font-size: $font-size-16;\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n                margin-bottom: 0;\n            }\n            .progress {\n                height: 6px;\n                @include rounded(5px);\n            }\n            ul {\n                li {\n                    @include margin-padding(0 0 15px 0, 15px);\n                    @include rounded(8px);\n                    border: 1px solid $gray-100;\n                    svg {\n                        width: 18px;\n                    }\n                    h6 {\n                        a {\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                            color: $secondary;\n                            svg {\n                                color:  $success;\n                            }\n                        }\n                        &:hover {\n                            a {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n    &#upload-message {\n        .modal-dialog {\n            position:fixed;\n            bottom:0px;\n            right:24px;\n            margin:0px;\n            left:  auto;\n            top: calc(100% - 300px); \n            width: 600px;\n        }\n        .progress {\n            height: 6px;\n            @include rounded(5px);\n        }\n    }\n}\n.datanew {\n    tr {\n        td {\n            svg {\n                width: 18px;\n            }\n        }\n    }\n}",".icons-list {\n    padding: 0;\n    display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n      li {\n        display: block;\n        width: 40px;\n        height: 40px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        font-size: $font-size-18;\n        @include rounded(50px);\n        border: 1px solid #e6ebf1;\n        color: $primary;\n        @include margin-padding(5px, null);\n        @include box-shadow(null, 0, 2px, 3px, null, rgb(215, 197, 255));\n    }\n}",".progress {\n    background-color: $light-900;\n    height: 0.75rem;\n    border-radius: 0.25rem;\n}\n.progress-stacked {\n    background-color: $light-900;\n}\n.progress-bar {\n    color: $white;\n    background-color: $primary;\n}\n\n@keyframes progress-animate {\n    0% {\n        width: 0;\n    }\n}\n.progress-animate {\n    position: relative;\n    border-radius: 0.625rem;\n    .progress-bar {\n        position: relative;\n        border-radius: 0.625rem;\n        animation:  2s progress-animate;\n    }\n}\n.progress,.progress-stacked {\n    &.progress-xs {\n        height: .3125rem;\n    }\n    &.progress-sm {\n        height: 0.5rem;\n    }\n    &.progress-lg {\n        height: 1rem;\n    }\n    &.progress-xl {\n        height: 1.25rem;\n    }\n}\n.progress-vertical {\n    min-height: 250px;\n    height: 250px;\n    width: 10px;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-sm {\n        width: 8px;\n    }\n\n    &.progress-xs {\n        width: 5px;\n    }\n}\n.progress-vertical-bottom {\n    min-height: 250px;\n    height: 250px;\n    position: relative;\n    width: 10px;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n        bottom: 0;\n        position: absolute;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-sm {\n        width: 8px;\n    }\n\n    &.progress-xs {\n        width: 5px;\n    }\n}\n.progress-custom {\n    overflow: visible;\n    position: relative;\n    .progress-bar {\n        position: relative;\n        overflow: visible;\n        &:after {\n            content: \"\";\n            width: 1.15rem;\n            height: 1.15rem;\n            border-radius: 50%;\n            box-shadow: 0 0.313rem 0.313rem rgba($primary, 0.5);\n            background: $white;\n            position: absolute;\n            inset-inline-end: -0.375rem;\n            inset-block-start: -0.375rem;\n            border: 0.25rem solid $primary;\n        }\n        &.bg-secondary:after {\n            border: 0.25rem solid $secondary;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--secondary-rgb),0.2);\n        }\n        &.bg-warning:after {\n            border: 0.25rem solid $warning;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--warning-rgb),0.2);\n        }\n        &.bg-info:after {\n            border: 0.25rem solid $info;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--info-rgb),0.2);\n        }\n        &.bg-success:after {\n            border: 0.25rem solid $success;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--success-rgb),0.2);\n        }\n        &.bg-danger:after {\n            border: 0.25rem solid $danger;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--danger-rgb),0.2);\n        }\n    }\n    .progress-bar-value{\n        width: 1.875rem;\n        height: 1.25rem;\n        line-height: 1.25rem;\n        border-radius: 0.188rem;\n        background: $primary;\n        box-shadow: 0 0.313rem 0.313rem rgba(0,0,0,0.4);\n        font-size: 0.625rem;\n        font-weight: $font-weight-semibold;\n        color: $white;\n        text-align: center;\n        position: absolute;\n        inset-block-end: 1.5rem;\n        inset-inline-end: -0.688rem;\n        &:after{\n            content: \"\";\n            border-block-start: 0.438rem solid $primary;\n            border-inline-start: 0.438rem solid transparent;\n            border-inline-end: 0.438rem solid transparent;\n            position: absolute;\n            inset-block-end: -0.375rem;\n            inset-inline-start: 28%;\n        }\n        &.bg-secondary {\n            background-color: $secondary;\n            &:after {\n                border-block-start: 0.438rem solid $secondary;\n            }\n        }\n        &.bg-success {\n            background-color: $success;\n            &:after {\n                border-block-start: 0.438rem solid $success;\n            }\n        }\n        &.bg-warning {\n            background-color: $warning;\n            &:after {\n                border-block-start: 0.438rem solid $warning;\n            }\n        }\n        &.bg-danger {\n            background-color: $danger;\n            &:after {\n                border-block-start: 0.438rem solid $danger;\n            }\n        }\n        &.bg-info {\n            background-color: $info;\n            &:after {\n                border-block-start: 0.438rem solid $info;\n            }\n        }\n    }\n}\n[dir=\"rtl\"] {\n    .progress-bar-title{ \n        border-radius: 0 0.313rem 0.313rem 0;\n    }\n}\n.progress-item-1, .progress-item-2, .progress-item-3{\n    position:absolute;\n\tmargin-block-start:-0.25rem;\n\tz-index:1;\n\theight:0.938rem;\n\twidth:0.938rem;\n\tborder-radius:1.563rem;\n    background-color: $light;\n}\n.progress-item-1{\n\tinset-inline-start:25%;\n}\n.progress-item-2{\n\tinset-inline-start:50%;\n}\n.progress-item-3{\n\tinset-inline-start:75%;\n}\n.custom-progress-3 {\n    overflow: visible;\n    border-radius: 0.625rem;\n    .progress-bar {\n        position: relative;\n        overflow: visible;\n        margin: 0.313rem;\n        border-radius: 0.25rem;\n        &:before {\n            content: \"\";\n            position: absolute;\n            width: 0.25rem;\n            height: 0.25rem;\n            inset-inline-start: 0.125rem;\n            background-color: $white;\n            border-radius: 50%;\n        }\n        .progress-bar-value{\n            border: 0.125rem solid $primary;\n            width: 2.5rem;\n            height: 1.563rem;\n            line-height: 1.313rem;\n            border-radius: 3.125rem;\n            background: $white;\n            font-size: 0.625rem;\n            font-weight: $font-weight-semibold;\n            color: $primary;\n            text-align: center;\n            position: absolute;\n            inset-inline-end: -0.625rem;\n            &.secondary {\n                border: 0.125rem solid $secondary;\n                color: $secondary;\n            }\n            &.warning {\n                border: 0.125rem solid $warning;\n                color: $warning;\n            }\n            &.info {\n                border: 0.125rem solid $info;\n                color: $info;\n            }\n            &.success {\n                border: 0.125rem solid $success;\n                color: $success;\n            }\n            &.danger {\n                border: 0.125rem solid $danger;\n                color: $danger;\n            }\n        }\n    }\n}\n.custom-progress-4 {\n    &.progress {\n        background-color: rgba($primary, 0.1);\n        border-radius: 0.25rem;\n        &.secondary {\n            background-color: rgba($secondary, 0.1);\n            .progress-bar-label {\n                color: $secondary;\n            }\n        }\n        &.warning {\n            background-color: rgba($warning, 0.1);\n            .progress-bar-label {\n                color: $warning;\n            }\n        }\n        &.info {\n            background-color: rgba($info, 0.1);\n            .progress-bar-label {\n                color: $info;\n            }\n        }\n        &.success {\n            background-color: rgba($success, 0.1);\n            .progress-bar-label {\n                color: $success;\n            }\n        }\n        &.danger {\n            background-color: rgba($danger, 0.1);\n            .progress-bar-label {\n                color: $danger;\n            }\n        }\n        .progress-bar {\n            border-radius: 0.25rem;\n        }\n        .progress-bar-label {\n            position: absolute;\n            inset-inline-end: 0.313rem;\n            font-weight: $font-weight-semibold;\n            font-size: 0.813rem;\n            color: $primary;\n        }\n    }\n}",".page-link {\n    color: $text-color;\n    background-color: $white;\n    border: 1px solid $border-color;\n    &:focus {\n        box-shadow: none;\n        background-color: $light;\n    }\n    &:hover {\n        color: $primary;\n        background-color: $light;\n        border-color: $border-color;\n    }\n}\n.page-item.active .page-link {\n    color: $white;\n    background-color: $primary;\n    border-color: $primary;\n}\n.disabled>.page-link, .page-link.disabled {\n    color: $text-color;\n    background-color: $white;\n    border-color: $border-color;\n    opacity: 0.7;\n}\n\n[dir=\"rtl\"] { \n    .pagination{\n        .page-link{\n            .bx-chevron-left::before{\n                content: \"\\ea50\";\n            }\n            .bx-chevron-right::before{\n                content: \"\\ea4d\";\n            }\n            .ri-arrow-right-s-line:before{\n                content: \"\\ea64\";\n            }\n            .ri-arrow-left-s-line:before{\n                content: \"\\ea6e\";\n            }\n        }\n    }\n}\n.pagination-style-1 .pagination {\n    .page-item {\n        margin: 0 0.25rem;\n        .page-link {\n            border: 0;\n            border-radius: $border-radius;\n            font-size: 0.8125rem;\n            i {\n                font-weight: $font-weight-semibold;\n            }\n        }\n        &.active {\n            .page-link {\n                border-radius: $border-radius;\n                background-color: $primary;\n                color: $white;\n            }\n            &:hover {\n                .page-link {\n                    border-radius: $border-radius;\n                    background-color: $primary;\n                    color: $white;\n                }\n            } \n        }\n        &:hover {\n            .page-link {\n                background-color: $light;\n                color: $primary;\n            }\n        }\n    }\n}\n.pagination-style-2 .pagination {\n    border-radius: $border-radius;\n    .page-item {\n        margin: 0 0.25rem;\n        .page-link {\n            border: 0 !important;\n            font-size: 0.8125rem;\n        }\n        &.active {\n            .page-link {\n                background-color: $white;\n                color: $primary;\n                position: relative;\n                font-weight: bold;\n                &:before {\n                    position: absolute;\n                    content: \"\";\n                    inset-block-end: 0;\n                    inset-inline-start: 0;\n                    width: 100%;\n                    height: 0.1rem;\n                    background-color: $primary;\n                }\n            }\n        }\n        &:hover {\n            .page-link {\n                background-color: transparent;\n            }\n        }\n    }\n}\n.pagination-style-3 .pagination {\n    border-radius: 50px;\n    padding: 0.25rem;\n    align-items: center;\n    .page-item {\n        margin: 0 0.25rem;\n        .page-link {\n            border: 0;\n            border-radius: 50px;\n            font-size: 0.8125rem;\n            i {\n                font-weight: $font-weight-semibold;\n            }\n        }\n        &.active {\n            .page-link {\n                background-color: $primary;\n                color: $white;\n            }\n            &:hover {\n                .page-link {\n                    background-color: $primary;\n                }\n            }\n        }\n        &:hover {\n            .page-link {\n                background-color: $light;\n            }\n        }\n    }\n}\n.pagination-style-4 .pagination {\n    .page-item {\n        .page-link {\n            border: 0 !important;\n            font-size: 0.8125rem;\n            border-radius: $border-radius;\n            i {\n                font-weight: $font-weight-semibold;\n            }\n        }\n        &.active {\n            .page-link {\n                border: 0;\n                border-radius: $border-radius;\n                background-color: $primary;\n                color: $white;\n            }\n            &:hover {\n                .page-link {\n                    background-color: $primary;\n                }\n            }\n        }\n        &:hover {\n            .page-link {\n                background-color: transparent;\n            }\n        }\n    }\n}","h1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  color: $title-color;\n  font-family: $font-family-primary;\n  font-weight: $font-weight-bold;\n  margin-bottom: 0;\n}\nh1,\n.h1 {\n  font-size: 2rem;\n}\nh2,\n.h2 {\n  font-size: 1.75rem;\n}\nh3,\n.h3 {\n  font-size: 1.5rem;\n}\nh4,\n.h4 {\n  font-size: 1.125rem;\n}\nh5,\n.h5 {\n  font-size: 1rem;\n}\nh6,\n.h6 {\n  font-size: 0.875rem;\n}\n.fs-sm {\n  font-size: 0.6875rem; //11px\n}\n.fs-base {\n  font-size: 0.875rem; //14px\n}\n.fs-lg {\n  font-size: 1.125rem; //18px\n}\n\n// (1px-30px are linear, above 30px are step increment of 1)\n.fs-1 {\n  font-size: 0.0625rem; //1px\n}\n.fs-2 {\n  font-size: 0.125rem; //2px\n}\n.fs-3 {\n  font-size: 0.1875rem; //3px\n}\n.fs-4 {\n  font-size: 0.25rem; //4px\n}\n.fs-5 {\n  font-size: 0.3125rem; //5px\n}\n.fs-6 {\n  font-size: 0.375rem; //6px\n}\n.fs-7 {\n  font-size: 0.4375rem; //7px\n}\n.fs-8 {\n  font-size: 0.5rem; //8px\n}\n.fs-9 {\n  font-size: 0.5625rem; //9px\n}\n.fs-10 {\n  font-size: 0.625rem; //10px\n}\n.fs-11 {\n  font-size: 0.6875rem; //11px\n}\n.fs-12 {\n  font-size: 0.75rem; //12px\n}\n.fs-13 {\n  font-size: 0.8125rem; //13px\n}\n.fs-14 {\n  font-size: 0.875rem; //14px\n}\n.fs-15 {\n  font-size: 0.9375rem; //15px\n}\n.fs-16 {\n  font-size: 1rem; //16px\n}\n.fs-17 {\n  font-size: 1.0625rem; //17px\n}\n.fs-18 {\n  font-size: 1.125rem; //18px\n}\n.fs-19 {\n  font-size: 1.1875rem; //19px\n}\n.fs-20 {\n  font-size: 1.25rem; //20px\n}\n.fs-21 {\n  font-size: 1.3125rem; //21px\n}\n.fs-22 {\n  font-size: 1.375rem; //22px\n}\n.fs-23 {\n  font-size: 1.4375rem; //23px\n}\n.fs-24 {\n  font-size: 1.5rem; //24px\n}\n.fs-25 {\n  font-size: 1.5625rem; //25px\n}\n.fs-26 {\n  font-size: 1.625rem; //26px\n}\n.fs-27 {\n  font-size: 1.6875rem; //27px\n}\n.fs-28 {\n  font-size: 1.75rem; //28px\n  @include respond-below(custom575) {\n    font-size: 1.25rem;\n  }\n}\n.fs-29 {\n  font-size: 1.8125rem; //29px\n \n}\n.fs-30 {\n  font-size: 1.875rem; //30px\n}\n.fs-32 {\n  font-size: 2rem; //32px\n}\n.fs-34 {\n  font-size: 2.125rem; //34px\n}\n.fs-36 {\n  font-size: 2.25rem; //36px\n}\n.fs-38 {\n  font-size: 2.375rem; //38px\n}\n.fs-40 {\n  font-size: 2.5rem; //40px\n}\n.fs-60 {\n  font-size: 3.75rem; //60px\n  @include respond-below(custom991) {\n    font-size: 2.125rem;\n  }\n  @include respond-below(custom575) {\n    font-size: 1.125rem;\n  }\n}\n.text-default {\n  color: $text-color !important;\n}\n.text-muted {\n  color: $text-muted !important;\n}\n.text-primary {\n  color: $primary !important;\n  opacity: 1;\n  &.text-opacity-75 {\n    color: rgba($primary, 0.75) !important;\n  }\n  &.text-opacity-25 {\n    color: rgba($primary, 0.25) !important;\n  }\n  &.text-opacity-50 {\n    color: rgba($primary, 0.50) !important;\n  }\n}\n.text-secondary {\n  color: $secondary !important;\n  opacity: 1;\n}\n.text-info {\n  color: $info !important;\n  opacity: 1;\n}\n.text-success {\n  color: $success !important;\n  opacity: 1;\n}\n.text-warning {\n  color: $warning !important;\n  opacity: 1;\n}\n.text-danger {\n  color: $danger !important;\n  opacity: 1;\n}\n.text-blue {\n  color: $blue !important;\n}\n.text-green {\n  color: $green !important;\n}\n.text-pink {\n  color: $pink !important;\n}\n.text-teal {\n  color: $teal !important;\n}\n.text-orange {\n  color: $orange !important;\n}\n.text-indigo {\n  color: $indigo !important;\n}\n.text-purple {\n  color: $purple !important;\n}\n.text-dark {\n  color: $dark !important;\n}\n.text-light {\n  color: $light !important;\n}\n.text-gray {\n  color: $gray-500 !important;\n}\n.text-black {\n  color: $black !important;\n}\n.text-white {\n  color: $white !important;\n}\n.text-fixed-white {\n  color: $white !important;\n}\n.text-fixed-black {\n  color: $black !important;\n}\n.text-gray-1 {\n  color: $gray-100;\n}\n.text-gray-2 {\n  color: $gray-200;\n}\n.text-gray-3 {\n  color: $gray-300;\n}\n.text-gray-4 {\n  color: $gray-400;\n}\n.text-gray-5 {\n  color: $gray-500;\n}\n.text-gray-6 {\n  color: $gray-600;\n}\n.text-gray-7 {\n  color: $gray-700;\n}\n.text-gray-8 {\n  color: $gray-800;\n}\n.text-gray-9 {\n  color: $gray-900;\n}\na {\n  color: $gray-900;\n  cursor: pointer;\n  text-decoration: none;\n  @include transition(all 0.5s ease);\n  &:hover {\n    color: $primary;\n    @include transition(all 0.5s ease);\n  }\n  &:focus {\n    outline: 0;\n  }\n}\n.link-primary {\n  color: $primary !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $primary !important;\n  }\n}\n.link-secondary {\n  color: $secondary !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $secondary !important;\n  }\n}\n.link-success {\n  color: $success !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $success !important;\n  }\n}\n.link-danger {\n  color: $danger !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $danger !important;\n  }\n}\n.link-warning {\n  color: $warning !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $warning !important;\n  }\n}\n.link-info {\n  color: $info !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $info !important;\n  }\n}\n.link-light {\n  color: $light !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $light !important;\n  }\n}\n.link-dark {\n  color: $dark !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $dark !important;\n  }\n}\nhr {\n  &.text-danger {\n    border-color: $danger !important;\n  }\n}\n\n.text-purple {\n  color: $purple !important;\n}\n.blockquote-container {\n  padding: 1.25rem;\n  border-left: 4px solid $default-border;\n  position: relative;\n  &.text-end {\n    border-right: 4px solid $default-border;\n    border-left: 0;\n  }\n}\n.blockquote.custom-blockquote {\n  font-size: 0.85rem;\n  font-weight: $font-weight-semibold;\n  padding: 1rem;\n  border-radius: $border-radius;\n  position: relative;\n  &:before {\n    content: \"\\f10d\";\n    font-family: $font-awesome;\n    z-index: 0;\n    font-size: 2rem;\n    position: absolute;\n    inset-block-start: 0;\n    inset-inline-start: 0.5rem;\n  }\n  &.primary {\n    background-color: rgba($primary, 0.1);\n    border-inline-start: 2px solid $primary;\n    &:before {\n      color: rgba($primary, 0.1);\n    }\n  }\n  &.secondary {\n    background-color: rgba($secondary, 0.1);\n    border-inline-start: 2px solid $secondary;\n    &:before {\n      color: rgba($secondary, 0.1);\n    }\n  }\n  &.info {\n    background-color: rgba($info, 0.1);\n    border-inline-start: 2px solid $info;\n    &:before {\n      color: rgba($info, 0.1);\n    }\n  }\n  &.warning {\n    background-color: rgba($warning, 0.1);\n    border-inline-start: 2px solid $warning;\n    &:before {\n      color: rgba($warning, 0.1);\n    }\n  }\n  &.success {\n    background-color: rgba($success, 0.1);\n    border-inline-start: 2px solid $success;\n    &:before {\n      color: rgba($success, 0.1);\n    }\n  }\n  &.danger {\n    background-color: rgba($danger, 0.1);\n    border-inline-start: 2px solid $danger;\n    &:before {\n      color: rgba($danger, 0.1);\n    }\n  }\n}\n\n[data-theme-mode=\"dark\"] {\n  .shadow-sm {\n    box-shadow: 0 0.125rem 0.25rem rgba(33, 37, 41, 0.3) !important;\n  }\n  .shadow {\n    box-shadow: 0 0.5rem 1rem rgba(33, 37, 41, 0.3) !important;\n  }\n  .shadow-lg {\n    box-shadow: 0 1rem 3rem rgba(33, 37, 41, 0.3) !important;\n  }\n}\n\n@media screen and (min-width: 576px) {\n  .w-sm-auto {\n    width: auto;\n  }\n}\n\n[dir=\"rtl\"] {\n  .text-break {\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n  }\n}\n.transform-none {\n  transform: none !important;\n}\n.w-9 {\n  width: 9px;\n}\n.h-9 {\n  height: 9px;\n}\n.list-circle {\n    list-style: circle;\n    padding-left: 2rem;\n}\n",".alert {\n  padding: 0.625rem 0.85rem;\n  border-radius: $border-radius;\n  font-size: 0.8125rem;\n  &.alert-dismissible {\n    padding: 0.625rem 2.25rem 0.625rem 0.85rem;\n  }\n  i {\n    font-size: $font-size-20;\n  }\n  .btn-close {\n    background-image: none;\n    padding: 0.85rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    i {\n      font-size: $font-size-18;\n      line-height: 18px;\n    }\n  }\n  &:last-child {\n    margin-bottom: 0;\n  }\n  .alert-link {\n    font-weight: $font-weight-semibold;\n  }\n}\n[dir=\"rtl\"] {\n  .alert.alert-dismissible {\n    padding: 0.625rem 0.85rem 0.625rem 2.25rem;\n  }\n}\n@mixin custom-close($color) {\n  background-color: $color;\n  color: $white;\n  opacity: 1;\n  border-radius: 50px;\n  box-shadow: $box-shadow;\n  padding: 0.85rem;\n}\n.alert-warning {\n  background-color: rgba($warning, 0.1);\n  color: $warning;\n  border-color: rgba($warning, 0.1);\n  .alert-link {\n    color: $warning;\n  }\n  .btn-close {\n    color: $warning;\n    &.custom-close {\n      @include custom-close($warning);\n    }\n  }\n}\n.alert-primary {\n  background-color: rgba($primary, 0.1);\n  color: $primary;\n  border-color: rgba($primary, 0.1);\n  .alert-link {\n    color: $primary;\n  }\n  .custom-alert-icon {\t\n\tcolor: $primary;\n  }\n  .btn-close {\n    color: $primary;\n    &.custom-close {\n      @include custom-close($primary);\n    }\n  }\n}\n.alert-secondary {\n  background-color: rgba($secondary, 0.1);\n  color: $secondary;\n  border-color: rgba($secondary, 0.1);\n  .alert-link {\n    color: $secondary;\n  }\n  .btn-close {\n    color: $secondary;\n    &.custom-close {\n      @include custom-close($secondary);\n    }\n  }\n}\n.alert-success {\n  background-color: rgba($success, 0.1);\n  color: $success;\n  border-color: rgba($success, 0.1);\n  .alert-link {\n    color: $success;\n  }\n  .btn-close {\n    color: $success;\n    &.custom-close {\n      @include custom-close($success);\n    }\n  }\n}\n.alert-info {\n  background-color: rgba($info, 0.1);\n  color: $info;\n  border-color: rgba($info, 0.1);\n  .alert-link {\n    color: $info;\n  }\n  .btn-close {\n    color: $info;\n    &.custom-close {\n      @include custom-close($info);\n    }\n  }\n}\n.alert-danger {\n  background-color: rgba($danger, 0.1);\n  color: $danger;\n  border-color: rgba($danger, 0.1);\n  .alert-link {\n    color: $danger;\n  }\n  .btn-close {\n    color: $danger;\n    &.custom-close {\n      @include custom-close($danger);\n    }\n  }\n}\n.alert-light {\n  background-color: $light;\n  color: $text-color;\n  border-color: $light;\n  .alert-link {\n    color: $text-color;\n  }\n  .btn-close {\n    color: $text-color;\n    &.custom-close {\n      @include custom-close($light);\n    }\n  }\n}\n.alert-dark {\n  background-color: rgba($dark, 0.1);\n  color: $text-color;\n  border-color: rgba($dark, 0.1);\n  .alert-link {\n    color: $text-color;\n  }\n  .btn-close {\n    color: $white;\n    &.custom-close {\n      @include custom-close($dark);\n    }\n  }\n}\n@mixin alert-solid-color($color) {\n  background-color: $color;\n  color: $white;\n  border-color: $color;\n  .btn-close {\n    color: $white;\n  }\n}\n.alert-solid-primary {\n  @include alert-solid-color($primary);\n}\n.alert-solid-secondary {\n  @include alert-solid-color($secondary);\n}\n.alert-solid-warning {\n  @include alert-solid-color($warning);\n}\n.alert-solid-info {\n  @include alert-solid-color($info);\n}\n.alert-solid-success {\n  @include alert-solid-color($success);\n}\n.alert-solid-danger {\n  @include alert-solid-color($danger);\n}\n.alert-solid-light {\n  background-color: $light;\n  color: $text-color;\n  border-color: $default-border;\n}\n.alert-solid-dark {\n  @include alert-solid-color($dark);\n}\n@mixin outline-alert($color) {\n  background-color: $white;\n  color: $color;\n  border-color: $color;\n  .btn-close {\n    color: $color;\n  }\n}\n.alert-outline-primary {\n  @include outline-alert($primary);\n}\n.alert-outline-secondary {\n  @include outline-alert($secondary);\n}\n.alert-outline-info {\n  @include outline-alert($info);\n}\n.alert-outline-warning {\n  @include outline-alert($warning);\n}\n.alert-outline-success {\n  @include outline-alert($success);\n}\n.alert-outline-danger {\n  @include outline-alert($danger);\n}\n.alert-outline-light {\n  background-color: $white;\n  color: $text-color;\n  border-color: $light;\n}\n.alert-outline-dark {\n  @include outline-alert($dark);\n}\n@mixin custom-alert($color) {\n  border-inline-start: 0.313rem solid $color !important;\n  color: $text-muted;\n  background-color: $white;\n  border: 1px solid $default-border;\n  font-size: 0.813rem;\n  .btn-close {\n    color: $text-color;\n  }\n}\n.alert-primary.custom-alert-icon {\n  @include custom-alert($primary);\n  & > i {\n\tcolor: $primary;\n  }\n}\n.alert-secondary.custom-alert-icon {\n  @include custom-alert($secondary);\n  & > i {\n\tcolor: $secondary;\n  }\n}\n.alert-warning.custom-alert-icon {\n  @include custom-alert($warning);\n  & > i {\n\tcolor: $warning;\n  }\n}\n.alert-danger.custom-alert-icon {\n  @include custom-alert($danger);\n  & > i {\n\tcolor: $danger;\n  }\n}\n.alert-success.custom-alert-icon {\n  @include custom-alert($success);\n}\n.alert-info.custom-alert-icon {\n  @include custom-alert($info);\n}\n.alert-light.custom-alert-icon {\n  @include custom-alert($light);\n}\n.alert-dark.custom-alert-icon {\n  @include custom-alert($dark);\n}\n.custom-alert1 {\n  margin-block-end: 0;\n  background-color: $white;\n  border: 0;\n  padding: 1.25rem;\n  color: $text-color;\n  p {\n    margin-block-end: 2.5rem;\n    color: $text-muted;\n    font-size: 0.8rem;\n  }\n  .custom-alert-icon {\n\tfont-size: $font-size-40;\n    margin-bottom: 0.85rem;\n\ti {\t\t\n\t\tfont-size: $font-size-40;\n\t}\n  }\n  .btn-close {\n    padding: 0;\n    margin-block-end: 1rem;\n  }\n  &.alert-primary {\n    border-block-start: 0.313rem solid $primary;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $primary;\n\t}\n  }\n  &.alert-secondary {\n    border-block-start: 0.313rem solid $secondary;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $secondary;\n\t}\n  }\n  &.alert-warning {\n    border-block-start: 0.313rem solid $warning;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $warning;\n\t}\n  }\n  &.alert-danger {\n    border-block-start: 0.313rem solid $danger;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $danger;\n\t}\n  }\n}\n.alert-img {\n  display: flex;\n  align-items: center;\n  .avatar {\n    border: 1px solid rgba(0, 0, 0, 0.1);\n  }\n}\n@media screen and (max-width: 400px) {\n  .btn-close.custom-close {\n    margin: 9px 9px 9px 0;\n  }\n}\n.op-1-1 {\n    opacity: 1;\n}\n.op-0 {\n    opacity: 0;\n}\n.op-1 {\n    opacity: 0.1;\n}\n.op-2 {\n    opacity: 0.2;\n}\n.op-3 {\n    opacity: 0.3;\n}\n.op-4 {\n    opacity: 0.4;\n}\n.op-5 {\n    opacity: 0.5;\n}\n.op-6 {\n    opacity: 0.6;\n}\n.op-7 {\n    opacity: 0.7;\n}\n.op-8 {\n    opacity: 0.8;\n}\n.op-9 {\n    opacity: 0.9;\n}\n",".custom-popover {\n  --bs-popover-max-width: 12.5rem;\n  --bs-popover-border-color: #{$primary};\n  --bs-popover-header-bg: #{$primary};\n  --bs-popover-header-color: #{$white};\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 0.5rem;\n}\n.popover {\n  background-color: $white;\n  border: 1px solid $default-border;\n  box-shadow: $box-shadow;\n  font-size: 0.8rem;\n  border-radius: $border-radius;\n  z-index: 999;\n  .popover-header {\n    background-color: $white;\n    border-block-end: 1px solid $default-border;\n  }\n  .popover-body {\n    color: $text-color;\n  }\n  &.only-body {\n    border-radius: 0.3rem;\n  }\n}\n.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n.bs-popover-top > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n.bs-popover-top > .popover-arrow::before {\n  border-top-color: $light;\n}\n.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n.bs-popover-end > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n.bs-popover-end > .popover-arrow::before {\n  border-right-color: $light;\n}\n.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n.bs-popover-start > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n.bs-popover-start > .popover-arrow::before {\n  border-left-color: $light;\n}\n.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n.bs-popover-bottom > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n.bs-popover-bottom > .popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n.bs-popover-bottom .popover-header::before {\n  border-bottom-color: $light;\n}\n\n@mixin pop-header-color($color) {\n  .popover-header {\n    background-color: $color;\n    color: $white;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before {\n    border-bottom-color: $color;\n  }\n}\n.header-primary {\n  @include pop-header-color($primary);\n}\n.header-secondary {\n  @include pop-header-color($secondary);\n}\n.header-warning {\n  @include pop-header-color($warning);\n}\n.header-info {\n  @include pop-header-color($info);\n}\n.header-success {\n  @include pop-header-color($success);\n}\n.header-danger {\n  @include pop-header-color($danger);\n}\n@mixin pop-bgcolor($color) {\n  &.popover {\n      border: 1px solid $color;\n    .popover-header {\n      background-color: $color;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.1);\n      color: $white;\n      border-radius: 0.3rem 0.3rem 0 0;\n    }\n    .popover-body {\n      background-color: $color;\n      color: $white;\n      border-radius: 0 0 0.3rem 0.3rem;\n    }\n  }\n  &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n  &.bs-popover-top > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n  &.bs-popover-top > .popover-arrow::before {\n    border-top-color: $color;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n  &.bs-popover-end > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n  &.bs-popover-end > .popover-arrow::before {\n    border-right-color: $color;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n  &.bs-popover-start > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n  &.bs-popover-start > .popover-arrow::before {\n    border-left-color: $color;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n  &.bs-popover-bottom > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n  &.bs-popover-bottom > .popover-arrow::before,\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n  &.bs-popover-bottom .popover-header::before {\n    border-bottom-color: $color;\n  }\n}\n.popover-primary {\n  @include pop-bgcolor($primary);\n}\n.popover-secondary {\n  @include pop-bgcolor($secondary);\n}\n.popover-warning {\n  @include pop-bgcolor($warning);\n}\n.popover-info {\n  @include pop-bgcolor($info);\n}\n.popover-success {\n  @include pop-bgcolor($success);\n}\n.popover-danger {\n  @include pop-bgcolor($danger);\n}\n.popover-purple {\n  @include pop-bgcolor($purple);\n}\n.popover-teal {\n  @include pop-bgcolor($teal);\n}\n\n.popover-primary-light {\n    &.popover {\n        border: 1px solid rgba($primary, 0.1);\n      .popover-header {\n        background-color: rgba($primary, 0.1);\n        border-block-end: 1px solid rgba($primary, 0.1);\n        color: $primary;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($primary, 0.1);\n        color: $primary;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($primary, 0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($primary, 0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($primary, 0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($primary, 0.1);\n    }\n}\n.popover-secondary-light {\n    &.popover {\n        border: 1px solid rgba($secondary,0.1);\n      .popover-header {\n        background-color: rgba($secondary,0.1);\n        border-block-end: 1px solid rgba($secondary,0.1);\n        color: $secondary;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($secondary,0.1);\n        color: $secondary;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba(var(--secondary-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($secondary,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba(var(--secondary-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba(var(--secondary-rgb),0.1);\n    }\n}\n.popover-warning-light {\n    &.popover {\n        border: 1px solid rgba($warning,0.1);\n      .popover-header {\n        background-color: rgba($warning,0.1);\n        border-block-end: 1px solid rgba($warning,0.1);\n        color: $warning;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($warning,0.1);\n        color: $warning;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($warning,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($warning,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($warning,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($warning,0.1);\n    }\n}\n.popover-info-light {\n    &.popover {\n        border: 1px solid rgba($info,0.1);\n      .popover-header {\n        background-color: rgba($info,0.1);\n        border-block-end: 1px solid rgba($info,0.1);\n        color: $info;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($info,0.1);\n        color: $info;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($info,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($info,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($info,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($info,0.1);\n    }\n}\n.popover-success-light {\n    &.popover {\n        border: 1px solid rgba($success,0.1);\n      .popover-header {\n        background-color: rgba($success,0.1);\n        border-block-end: 1px solid rgba($success,0.1);\n        color: $success;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($success,0.1);\n        color: $success;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($success,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($success,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($success,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($success,0.1);\n    }\n}\n.popover-danger-light {\n    &.popover {\n        border: 1px solid rgba($danger,0.1);\n      .popover-header {\n        background-color: rgba($danger,0.1);\n        border-block-end: 1px solid rgba($danger,0.1);\n        color: $danger;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($danger,0.1);\n        color: $danger;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($danger,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($danger,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($danger,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($danger,0.1);\n    }\n}\n.popover-purple-light {\n    &.popover {\n        border: 1px solid rgba(var(--purple-rgb),0.1);\n      .popover-header {\n        background-color: rgba(var(--purple-rgb),0.1);\n        border-block-end: 1px solid rgba(var(--purple-rgb),0.1);\n        color: $purple;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba(var(--purple-rgb),0.1);\n        color: $purple;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba(var(--purple-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba(var(--purple-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba(var(--purple-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba(var(--purple-rgb),0.1);\n    }\n}\n.popover-teal-light {\n    &.popover {\n        border: 1px solid rgba(var(--teal-rgb),0.1);\n      .popover-header {\n        background-color: rgba(var(--teal-rgb),0.1);\n        border-block-end: 1px solid rgba(var(--teal-rgb),0.1);\n        color: $teal;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba(var(--teal-rgb),0.1);\n        color: $teal;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba(var(--teal-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba(var(--teal-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba(var(--teal-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba(var(--teal-rgb),0.1);\n    }\n}\n.timeline {\n    position: relative;\n    list-style: none;\n    max-width: 1200px;\n    @include margin-padding(0 auto, 20px 0 20px);\n    &:before {\n      content: \" \";\n      position: absolute;\n      width: 3px;\n      margin-left: -1.5px;\n      background-color: $gray-300;\n        @include position(absolute,0,null,0,50%);\n    }\n    > li {\n      position: relative;\n      margin-bottom: 20px;\n      &::before, &::after {\n          content: \" \";\n         display: table;\n      }\n      >.timeline-panel {\n          float: left;\n          position: relative;\n          width: 46%;\n          padding: 20px;\n          border: 1px solid $gray-500;\n            @include rounded(0.25rem);\n            @include box-shadow(null, 0, 1px, 6px, null, rgba(0, 0, 0, .05));\n            &::before {\n                content: \" \";\n                display: inline-block;\n                position: absolute;\n                border-top: 8px solid transparent;\n                border-right: 0 solid $gray-500;\n                border-bottom: 8px solid transparent;\n                border-left: 8px solid $gray-500;\n                  @include position(absolute,26px,-8px,null,null);\n              }\n              &::after {\n                  content: \" \";\n                  display: inline-block;\n                    @include position(absolute,27px,-7px,null,null);\n                  border-top: 7px solid transparent;\n                  border-right: 0 solid $white;\n                  border-bottom: 7px solid transparent;\n                  border-left: 7px solid $white;\n                }\n        }\n    }\n}\n.timeline > li:after {\n  clear: both; \n}\n.timeline>li>.timeline-badge {\n  z-index: 1;\n  width: 50px;\n  height: 50px;\n  margin-left: -25px;\n  text-align: center;\n  font-size: 1.4em;\n  line-height: 50px;\n  color: $white;\n  overflow: hidden;\n    @include rounded(50%);\n    @include position(absolute,16px,null,null,50%);\n}\n.timeline>li.timeline-inverted>.timeline-panel {\n  float: right;\n  &::before {\n      right: auto;\n      left: -8px;\n      border-right-width: 8px;\n      border-left-width: 0;\n    }\n    &::after {\n        right: auto;\n        left: -7px;\n        border-right-width: 7px;\n        border-left-width: 0;\n      }\n}\n.timeline-badge.primary {\n  background-color: $primary;\n}\n.timeline-badge.success {\n  background-color: $success;\n}\n.timeline-badge.warning {\n  background-color: $warning; \n}\n.timeline-badge.danger {\n  background-color: $danger; \n}\n.timeline-badge.info {\n  background-color: $info; \n}\n.timeline-title {\n  margin-top: 0;\n  color: inherit;\n  font-weight: regular; \n}\n.timeline-body > p,\n.timeline-body > ul {\n  margin-bottom: 0; \n}\n.timeline-body > p + p {\n  margin-top: 5px; \n}\n",".form-wrap {\n    margin-bottom: 24px;\n}\n.col-form-label {\n    font-size: $font-size-14;\n    font-weight: $font-weight-medium;\n    color: $title-color;\n}\n.form-control {\n  border-color: $input-border;\n  color: $text-color;\n  background-color: $form-control-bg;\n  font-size: $font-size-14;\n  font-weight: $font-weight-normal;\n  line-height: 1.6;\n  border-radius: 5px;\n  padding: 0.5rem 0.85rem;\n  box-shadow: 0px 4px 4px 0px #DBDBDB40;\n  min-height: 42px;\n  &:focus {\n    box-shadow: none;\n    border-color: $input-border;\n    background-color: $white;\n    box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.05);\n    color: $text-color;\n  }\n}\n.form-control[type=\"file\"] {\n  padding: 0.3rem 0.5rem;\n  line-height: 2.2;\n  &.form-control-sm {\n    padding: 0.25rem 0.5rem !important;\n  }\n  &.form-control-lg {\n    padding: 0.5rem 1rem !important;\n  }\n}\n.col-form-label {\n    font-size: $font-size-14;\n    font-weight: $font-weight-medium;\n    color: $title-color;\n    @include margin-padding(null, 0 0 5px);\n}\n.form-label {\n  font-size: $font-size-14;\n  font-weight: $font-weight-medium;\n  color: $title-color;\n}\n.form-text {\n  color: $text-muted;\n}\n\n.form-control-light {\n  background-color: $light;\n  border: 0;\n\n  &:focus {\n    background-color: $light;\n  }\n}\n.form-control-primary {\n  background-color: rgba($primary, 0.1);\n  border: 0;\n  color: $primary;\n\n  &:focus {\n    background-color: rgba($primary, 0.1);\n    color: $primary;\n  }\n}\n.form-input-color {\n  height: 2.25rem;\n  width: 2.25rem;\n  border-radius: $border-radius;\n  overflow: hidden;\n  padding: 0;\n}\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-select ~ label {\n  color: $text-muted;\n}\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after {\n  background-color: transparent;\n}\n.input-group-text {\n  box-shadow: 0px 4px 4px 0px #DBDBDB40;\n } \n.form-select {\n  background-color: $form-control-bg;\n  border: 1px solid $input-border;\n  color: $text-color;\n  font-size: $font-size-base;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n  background-size: 1.25rem;\n  line-height: 2;\n  box-shadow: 0px 4px 4px 0px #DBDBDB40; \n  option {\n    background-color: $white;\n    padding: 0.35rem 0.75rem;\n    border-radius: 0.25rem;\n    margin-block-end: 0.25rem;\n    &:last-child {\n      margin-block-end: 0;\n    }\n  }\n  option:checked {\n    background-color: rgba(var($primary), 0.2);\n    color: $primary;\n  }\n  option:select {\n    background-color: rgba(var($primary), 0.2);\n    color: $primary;\n  }\n  option:hover {\n    background-color: rgba(var($primary), 0.2);\n    color: $primary;\n  }\n  option:focus {\n    background-color: rgba(var($primary), 0.2);\n    color: $primary;\n  }\n}\n.form-check-input {\n  width: 0.9rem;\n  height: 0.9rem;\n  background-color: $white;\n  border: 1px solid $input-border;\n  &:checked {\n    background-color: $primary;\n    border-color: $primary;\n  }\n  &.form-checked-outline {\n    &:checked {\n      background-color: transparent;\n      border-color: $primary;\n    }\n  }\n  &.form-checked-secondary {\n    &:checked {\n      background-color: $secondary;\n      border-color: $secondary;\n    }\n  }\n  &.form-checked-warning {\n    &:checked {\n      background-color: $warning;\n      border-color: $warning;\n    }\n  }\n  &.form-checked-info {\n    &:checked {\n      background-color: $info;\n      border-color: $info;\n    }\n  }\n  &.form-checked-success {\n    &:checked {\n      background-color: $success;\n      border-color: $success;\n    }\n  }\n  &.form-checked-danger {\n    &:checked {\n      background-color: $danger;\n      border-color: $danger;\n    }\n  }\n  &.form-checked-light {\n    &:checked {\n      background-color: $light;\n      border-color: $light;\n    }\n  }\n  &.form-checked-dark {\n    &:checked {\n      background-color: $dark;\n      border-color: $dark;\n    }\n  }\n  &:focus {\n    box-shadow: none;\n  }\n}\n.form-checked-outline:checked[type=\"checkbox\"] {\n  background-image: none;\n  position: relative;\n  background-color: transparent;\n\n  &:before {\n    content: \"\\F633\";\n    font-family: bootstrap-icons !important;\n    position: absolute;\n    color: $primary;\n    width: 0.625rem;\n    height: 0.625rem;\n    inset-block-start: -1px;\n    inset-inline-start: 0px;\n    font-size: 0.688rem;\n  }\n\n  &.form-checked-secondary {\n    &:before {\n      color: $secondary;\n    }\n  }\n\n  &.form-checked-warning {\n    &:before {\n      color: $warning;\n    }\n  }\n\n  &.form-checked-info {\n    &:before {\n      color: $info;\n    }\n  }\n\n  &.form-checked-success {\n    &:before {\n      color: $success;\n    }\n  }\n\n  &.form-checked-danger {\n    &:before {\n      color: $danger;\n    }\n  }\n\n  &.form-checked-light {\n    &:before {\n      color: $light;\n    }\n  }\n\n  &.form-checked-dark {\n    &:before {\n      color: $dark;\n    }\n  }\n}\n.form-checked-outline:checked[type=\"radio\"] {\n  background-image: none;\n  position: relative;\n  background-color: transparent;\n\n  &:before {\n    content: \"\\F309\";\n    font-family: bootstrap-icons !important;\n    position: absolute;\n    color: $primary;\n    width: 0.625rem;\n    height: 0.625rem;\n    inset-block-start: -1.13rem;\n    inset-inline-start: -0.6rem;\n    font-size: 2rem;\n  }\n\n  &.form-checked-secondary {\n    &:before {\n      color: $secondary;\n    }\n  }\n\n  &.form-checked-warning {\n    &:before {\n      color: $warning;\n    }\n  }\n\n  &.form-checked-info {\n    &:before {\n      color: $info;\n    }\n  }\n\n  &.form-checked-success {\n    &:before {\n      color: $success;\n    }\n  }\n\n  &.form-checked-danger {\n    &:before {\n      color: $danger;\n    }\n  }\n\n  &.form-checked-light {\n    &:before {\n      color: $light;\n    }\n  }\n\n  &.form-checked-dark {\n    &:before {\n      color: $dark;\n    }\n  }\n}\nfieldset:disabled .btn {\n  color: $white;\n  background-color: $primary;\n  border-color: $primary;\n}\n.form-select:focus {\n  border-color: rgba(var($primary), 0.5);\n  outline: 0;\n  box-shadow: none;\n}\n.btn-check:focus + .btn,\n.btn:focus {\n  background-color: none;\n  border-color: none;\n  outline: 0;\n}\n.btn-check:active + .btn:focus,\n.btn-check:checked + .btn:focus,\n.btn.active:focus,\n.btn.show:focus,\n.btn:active:focus {\n  box-shadow: none;\n}\n.form-control,\n.form-select {\n    &:disabled {\n      background-color: $light;\n      color: $text-color;\n  }\n}\n.form-control-plaintext {\n  color: $text-color;\n}\n.form-control::-webkit-file-upload-button {\n  color: $text-color;\n  background-color: $default-background;\n}\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n  background-color: $default-background;\n}\n.form-control {\n  &:focus {\n    &::-webkit-input-placeholder,\n    &::placeholder {\n      padding-inline-start: 0.3rem;\n      transition: padding-inline-start 0.1s ease-in;\n    }\n  }\n  &::-webkit-input-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.7;\n    color: $text-color;\n    padding-inline-start: 0px;\n    transition: padding-inline-start 0.1s ease-in;\n  }\n  &:-moz-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.4;\n    color: $text-color;\n  }\n  &::-moz-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.4;\n    color: $text-color;\n  }\n  &:-ms-input-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.4;\n    color: $text-color;\n  }\n}\n.form-control-sm {\n  font-size: 0.8rem;\n  padding: 0.25rem 0.8rem;\n}\n.form-control-lg {\n  font-size: 1rem;\n  padding: 0.5rem 1rem;\n}\n\n.form-check-md {\n  .form-check-input {\n    width: 1.15rem;\n    height: 1.15rem;\n  }\n\n  &.form-switch {\n    .form-check-input {\n      width: 2.25rem;\n    }\n  }\n\n  label {\n    margin-inline-start: 0.5rem;\n    font-size: 0.95rem;\n    margin-block-start: 3px;\n  }\n}\n\n.form-check-lg {\n  .form-check-input {\n    width: 1.35rem;\n    height: 1.35rem;\n  }\n\n  &.form-switch {\n    .form-check-input {\n      width: 2.5rem;\n    }\n  }\n\n  label {\n    margin-inline-start: 0.5rem;\n    font-size: 1rem;\n    margin-block-start: 3px;\n  }\n}\n.toggle {\n  width: 3.75rem;\n  height: 1.563rem;\n  background-color: $light;\n  margin-inline-start: 0.625rem;\n  margin-block-end: 0.313rem;\n  padding: 0.125rem;\n  border-radius: 0.188rem;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.2s ease;\n\n  span {\n    position: absolute;\n    inset-block-start: 0.188rem;\n    inset-block-end: 0.25rem;\n    inset-inline-start: 0.188rem;\n    display: block;\n    width: 1.25rem;\n    border-radius: 0.125rem;\n    background-color: $white;\n    box-shadow: 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.45);\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &::before {\n      content: \"on\";\n      inset-inline-start: -1.563rem;\n    }\n\n    &::after {\n      content: \"off\";\n      inset-inline-end: -1.813rem;\n      color: $text-muted;\n    }\n\n    &::before,\n    &::after {\n      position: absolute;\n      font-size: 0.625rem;\n      font-weight: $font-weight-medium;\n      letter-spacing: 0.5px;\n      text-transform: uppercase;\n      inset-block-start: 0.188rem;\n      line-height: 1.38;\n      transition: all 0.2s ease;\n    }\n  }\n\n  &.on {\n    background-color: rgba(var($primary), 0.3);\n\n    span {\n      background-color: $primary;\n\n      &::before {\n        color: $primary;\n      }\n    }\n\n    &.toggle-secondary {\n      background-color: rgba($secondary, 0.4);\n\n      span {\n        background-color: $secondary;\n\n        &::before {\n          color: $secondary;\n        }\n      }\n    }\n\n    &.toggle-warning {\n      background-color: rgba($warning, 0.4);\n\n      span {\n        background-color: $warning;\n\n        &::before {\n          color: $warning;\n        }\n      }\n    }\n\n    &.toggle-info {\n      background-color: rgba($info, 0.4);\n\n      span {\n        background-color: $info;\n\n        &::before {\n          color: $info;\n        }\n      }\n    }\n\n    &.toggle-success {\n      background-color: rgba($success, 0.4);\n\n      span {\n        background-color: $success;\n\n        &::before {\n          color: $success;\n        }\n      }\n    }\n\n    &.toggle-danger {\n      background-color: rgba($danger, 0.4);\n\n      span {\n        background-color: $danger;\n\n        &::before {\n          color: $danger;\n        }\n      }\n    }\n\n    &.toggle-light {\n      background-color: rgba($light, 0.4);\n\n      span {\n        background-color: $light;\n\n        &::before,\n        &::after {\n          color: $text-muted;\n        }\n      }\n    }\n\n    &.toggle-dark {\n      background-color: rgba($dark, 0.4);\n\n      span {\n        background-color: $dark;\n\n        &::before {\n          color: $white;\n        }\n      }\n    }\n\n    span {\n      inset-inline-start: 2.313rem;\n    }\n\n    &.toggle-sm span {\n      inset-inline-start: 2.313rem;\n\n      &::before {\n        inset-block-start: -1px;\n        inset-inline-start: -1.563rem;\n      }\n    }\n\n    &.toggle-lg span {\n      inset-inline-start: 2.563rem;\n\n      &::before {\n        inset-block-start: 0.5rem;\n        inset-inline-start: -1.75rem;\n      }\n    }\n  }\n\n  &.toggle-sm {\n    height: 1.063rem;\n    width: 3.125rem;\n\n    span {\n      width: 0.625rem;\n      height: 0.625rem;\n\n      &::after {\n        inset-inline-end: -1.875rem;\n        inset-block-start: -1px;\n      }\n    }\n  }\n\n  &.toggle-lg {\n    height: 2.125rem;\n    width: 4.5rem;\n\n    span {\n      width: 1.75rem;\n\n      &::after {\n        inset-block-start: 0.5rem;\n        inset-inline-end: -1.938rem;\n      }\n    }\n  }\n}\n.custom-toggle-switch > input[type=\"checkbox\"] {\n  display: none;\n}\n.custom-toggle-switch > label {\n  cursor: pointer;\n  height: 0;\n  position: relative;\n  width: 2.5rem;\n}\n\n.label-primary {\n  background: $primary;\n  color: $white;\n}\n\n.label-secondary {\n  background: $secondary;\n  color: $white;\n}\n\n.label-warning {\n  background: $warning;\n  color: $white;\n}\n\n.label-info {\n  background: $info;\n  color: $white;\n}\n\n.label-success {\n  background: $success;\n  color: $white;\n}\n\n.label-danger {\n  background: $danger;\n  color: $white;\n}\n\n.label-light {\n  background: $light;\n  color: $white;\n}\n\n.label-dark {\n  background: $dark;\n  color: $white;\n}\n\n.custom-toggle-switch > input[type=\"checkbox\"]:checked + label::before {\n  background: inherit;\n  opacity: 0.5;\n}\n.custom-toggle-switch > label {\n  &::before {\n    background: $text-muted;\n    box-shadow: inset 0px 0px 0.625rem rgba(255,255,255, 0.5);\n    border-radius: 0.5rem;\n    content: \"\";\n    height: 1rem;\n    margin-block-start: -0.5rem;\n    position: absolute;\n    opacity: 0.3;\n    transition: all 0.4s ease-in-out;\n    width: 2.5rem;\n  }\n\n  &::after {\n    background: $white;\n    border-radius: 1rem;\n    box-shadow: 0 0 0.313rem rgba(228, 229, 237, 0.8);\n    content: \"\";\n    height: 1.5rem;\n    inset-inline-start: -0.25rem;\n    margin-block-start: -0.5rem;\n    position: absolute;\n    inset-block-start: -0.25rem;\n    transition: all 0.3s ease-in-out;\n    width: 1.5rem;\n  }\n}\n.custom-toggle-switch > input[type=\"checkbox\"]:checked + label::after {\n  background: inherit;\n  inset-inline-start: 50%;\n}\n\n.custom-toggle-switch.toggle-sm > label::before {\n  height: 10px;\n  width: 27px;\n  border-radius: 10px;\n}\n\n.custom-toggle-switch.toggle-sm input[type=\"checkbox\"]:checked + label::after {\n  inset-inline-start: 13px;\n}\n\n.custom-toggle-switch.toggle-sm > label::after {\n  height: 17px;\n  width: 17px;\n  border-radius: 50%;\n}\n\n.custom-toggle-switch.toggle-lg > label::before {\n  height: 27px;\n  width: 55px;\n  border-radius: 20px;\n}\n\n.custom-toggle-switch.toggle-lg input[type=\"checkbox\"]:checked + label::after {\n  inset-inline-start: 77%;\n}\n\n.custom-toggle-switch.toggle-lg > label::after {\n  height: 35px;\n  width: 35px;\n  margin-block-start: -8px;\n  border-radius: 50%;\n}\n.form-floating > {\n  .form-control-plaintext,\n  .form-control {\n    &::placeholder {\n      color: transparent !important;\n    }\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem - 4px);\n}\n.form-floating {\n  &.floating-primary {\n    label {\n      color: $primary;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $primary;\n    }\n    & > .form-control:focus ~ label {\n      color: $primary !important;\n    }\n  }\n\n  &.floating-secondary {\n    label {\n      color: $secondary;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $secondary;\n    }\n    & > .form-control:focus ~ label {\n      color: $secondary !important;\n    }\n  }\n\n  &.floating-warning {\n    label {\n      color: $warning;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $warning;\n    }\n    & > .form-control:focus ~ label {\n      color: $warning !important;\n    }\n  }\n\n  &.floating-info {\n    label {\n      color: $info;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $info;\n    }\n    & > .form-control:focus ~ label {\n      color: $info !important;\n    }\n  }\n\n  &.floating-success {\n    label {\n      color: $success;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $success;\n    }\n    & > .form-control:focus ~ label {\n      color: $success !important;\n    }\n  }\n\n  &.floating-danger {\n    label {\n      color: $danger;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $danger;\n    }\n    & > .form-control:focus ~ label {\n      color: $danger !important;\n    }\n  }\n}\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-select ~ label::after {\n  background-color: $white;\n  border-radius: $border-radius;\n}\n.form-wizard-1 {\n  border-bottom: 0;\n  border-radius: 50px;\n\n  .nav-link {\n    border: 0;\n  }\n\n  &.nav-tabs {\n    .nav-item {\n      margin-inline-end: 1rem;\n      position: relative;\n    }\n\n    .nav-link {\n      padding: 0.25rem 0.4rem;\n      color: $text-muted;\n      display: flex;\n      align-items: center;\n      border-radius: 50px;\n      border: 2px solid transparent;\n\n      i {\n        font-size: 12px;\n        padding: 4px;\n        line-height: 1;\n        border-radius: 50px;\n        border: 2px solid $default-border;\n      }\n\n      &:focus,\n      &:hover {\n        border: 2px solid transparent;\n      }\n\n      &.active {\n        border: 2px solid $primary;\n        border-radius: 50px;\n        color: $primary;\n        background-color: transparent;\n\n        i {\n          border: 2px solid $primary;\n        }\n      }\n    }\n  }\n\n  .nav-item:focus-visible {\n    outline: none;\n  }\n}\n.form-control.is-valid:focus,\n.was-validated .form-control:valid:focus {\n  border-color: $success;\n  box-shadow: none;\n}\n.form-control.is-valid,\n.was-validated .form-control:valid {\n  border-color: $success;\n}\n.form-control-color {\n  width: 1.75rem;\n  height: 1.75rem;\n  overflow: hidden;\n  padding: 0;\n}\n.example-picker {\n  .pcr-button {\n    border-radius: 0.35rem !important;\n    overflow: hidden;\n  }\n}\n[dir=\"rtl\"] {\n  [type=\"email\"],\n  [type=\"number\"],\n  [type=\"tel\"],\n  [type=\"url\"] {\n    direction: rtl;\n  }\n}\n.form-select.is-invalid:not([multiple]):not([size]) {\n  padding-right: 1.125rem;\n  background-size: 16px 28px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.invoice-quantity-container\n  .input-group\n  > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(\n    .valid-feedback\n  ):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: 0;\n}\ninput[type=\"range\"]::-webkit-slider-runnable-track {\n  background-color: $light;\n}\n[dir=\"rtl\"] {\n  .form-checked-outline:checked[type=\"checkbox\"]:before {\n    inset-inline-start: 1px;\n  }\n}\n\n.is-invalid~.invalid-feedback, .is-invalid~.invalid-tooltip, .was-validated :invalid~.invalid-feedback, .was-validated :invalid~.invalid-tooltip{\n  display: inline-block;\n}\n.is-valid~.valid-feedback, .is-valid~.valid-tooltip, .was-validated :valid~.valid-feedback, .was-validated :valid~.valid-tooltip{\n  display: inline-block;\n}\n.invalid-tooltip,.valid-tooltip{\n  position: relative;\n  top: 0;\n}\n.form-check {\n  min-height: inherit !important;\n}\n.col-form-label-lg,\n.col-form-label-sm,\n.col-form-label {\n  font-weight: $font-weight-medium;\n}\n#exampleColorInput::-webkit-color-swatch-wrapper {\n  direction: rtl; \n}\n[data-theme-mode=\"dark\"] {\n  input {\n    &[type=\"week\"],\n    &[type=\"month\"],\n    &[type=\"date\"],\n    &[type=\"datetime-local\"],\n    &[type=\"time\"] {\n      &::-webkit-calendar-picker-indicator {\n        filter: invert(1);\n      }\n    }\n  }\n}\n[dir=\"rtl\"] {\n  input {\n    &[type=\"week\"],\n    &[type=\"month\"],\n    &[type=\"date\"],\n    &[type=\"datetime-local\"],\n    &[type=\"time\"] {\n      text-align: end;\n    }\n  }\n}\n.form-control {\n  &.form-control-lg {\n    height: 46px;\n  }\n  &.form-control-sm {\n    height: 30px;\n    min-height: 30px;\n  }\n}\n.input-group-sm {\n  .input-group-text {\n    height: 35px;\n  }\n  .form-control {\n    height: 35px;\n    min-height: 35px;\n  }\n}\n.input-icon-addon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.5rem;\n  color: #515B73;\n  pointer-events: none;\n  font-size: 1.2em;\n}\n.checkboxs {\n  display: block;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  padding-left: 25px;\n  input {\n      position: absolute;\n      opacity: 0;\n      cursor: pointer;\n      height: 0;\n      width: 0;\n  }\n}\n.checkboxs input ~ .checkmarks {\n  border: 1px solid $light-900;\n  border-radius: 5px;\n}\n.checkboxs input:checked ~ .checkmarks {\n  background-color: $purple;\n  border-color: $purple;\n}\n    .checkboxs input:checked ~ .checkmarks:after {\n      display: block;\n    }\n    .checkboxs .checkmarks {\n      height: 16px;\n      width: 16px;\n      @include position(absolute, 0, null, null, 0);\n    }\n    .checkboxs .checkmarks:after {\n      content: \"\";\n      position: absolute;\n      display: none;\n    }\n    .checkboxs .checkmarks:after {\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      content: \"\\f00c\";\n      font-family: 'Font Awesome 5 Free';\n      color: $white;\n      font-weight: $font-weight-semibold;\n      font-size: 10px;\n  }\n.status-radio:checked,\n.status-radio:not(:checked) {\n  position: absolute;\n  left: -9999px;\n}\n.status-radio:checked + label,\n.status-radio:not(:checked) + label\n{\n  position: relative;\n  padding-left: 24px;\n  cursor: pointer;\n  line-height: 16px;\n  display: inline-block;\n  color: $gray-900;\n}\n.status-radio:checked + label:before,\n.status-radio:not(:checked) + label:before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 16px;\n  height: 16px;\n  border: 1px solid $light-900;\n  border-radius: 100%;\n  background: $white;\n}\n.status-radio:checked + label:before {\n  background: $indigo;\n  border-color: $indigo;\n}\n.status-radio[type=\"radio\"]:checked + label:after,\n.status-radio[type=\"radio\"]:not(:checked) + label:after {\n  content: '';\n  width: 8px;\n  height: 8px;\n  background: $white;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  border-radius: 100%;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n[type=\"radio\"]:not(:checked) + label:after {\n  opacity: 0;\n  -webkit-transform: scale(0);\n  transform: scale(0);\n}\n[type=\"radio\"]:checked + label:after {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n.bootstrap-tagsinput {\n  border-color: $light-300;\n  box-shadow: 0px 4px 4px 0px #DBDBDB40;\n  border-radius: 5px;\n  font-size:  $font-size-14;\n  color: $text-color;\n  min-height: 42px;\n  line-height: 2;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  max-height: 42px;\n  overflow-y: auto;\n  .tag {\n      background: $light-300;\n      color: $text-color;\n      padding: 2px 5px;\n      line-height: normal;\n      border-radius: 5px;\n      font-size: $font-size-14;\n  }\n}",".notes-page-wrapper {\n    .content {\n        padding: 24px;\n        .page-add-notes {\n            border-bottom: 1px solid $light-900;\n            padding-bottom: 25px;\n            position: relative;\n            margin-bottom: 0;\n            @include respond-below(custom767) {\n                flex-direction: column;\n                align-items: start;\n            }\n            .notes-tog {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                position: absolute;\n                bottom: -12px;\n                border-radius: 30px;\n                background: #1B2850;\n                color: $white;\n                width: 24px;\n                height: 24px;\n                padding: 5px;\n                @include respond-below(custom991) {\n                    display: none;\n                }\n            }\n        }\n        .section-bulk-wrap {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin: 30px 0 24px 0;\n            padding: 20px;\n            border-radius: 8px;\n            background:  $white;\n            box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n            @include respond-below(custom767) {\n                flex-direction: column;\n                align-items: start;\n            }\n            .bulk-action-type {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                @include respond-below(custom767) {\n                    margin-bottom: 20px;\n                }\n                @include respond-below(custom575) {\n                    margin-bottom: 0;\n                    flex-direction: column;\n                    align-items: self-start;\n                }\n                .select-bluk {\n                    margin-right: 8px;\n                    height: 40px;\n                    .select2-container {\n                        .selection {\n                            .select2-selection {\n                                .select2-selection__rendered {\n                                    padding-left: 10px!important;\n                                }\n                            }\n                        }\n                        \n                    }\n                }\n                .btn-added {\n                    background: $gray-500;\n                    padding: 8px 20px;\n                    color: $white;\n                    font-size: $font-size-15;\n                    font-weight: $font-weight-normal;  \n                    margin-right: 15px; \n                    height: 40px; \n                    line-height: normal;\n                    &:hover {\n                        background: $primary;\n                    }    \n                    @include respond-below(custom575) {\n                        margin: 20px 0;\n                    }           \n                }   \n            }  \n            .form-sort {\n                .fa-filter {\n                    z-index:100!important;\n                    position: absolute;\n                    top: 15px;\n                    left: 15px;\n                    width: 16px;\n                    height: 16px;\n                }\n            } \n        }\n        .section-notes-slider {\n            position: relative;\n            padding-bottom: 40px;\n            border-bottom: 1px solid $light-900;\n            .notes-content {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n                margin-bottom: 20px;\n                .notes-close {\n                    a {\n                        color: $danger;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        i {\n                            margin-right: 6px;\n                        }\n                    }\n                }\n            }\n            .notes-card {\n                padding: 24px;\n                border-radius: 8px;\n                background: rgba(255, 159, 67, 0.03);\n                &.medium {\n                    background: rgba(116, 41, 248, 0.03);\n                }\n                &.high {\n                    background: rgba(234, 84, 85, 0.03);\n                }\n                .notes-card-body {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    p {\n                        &.badged  {\n                            border-radius: 8px;\n                            border: 1px solid  $warning;\n                            padding: 4px 10px; \n                            margin-bottom: 0;\n                            color:$warning;\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-semibold;\n                            display: flex;\n                            align-items: center;\n                            i {\n                                font-size: 7px;\n                                margin-right: 4px;\n                            }\n                            &.medium {\n                                color: #7429F8;\n                                border: 1px solid #7429F8;\n                            }\n                            &.high {\n                                color: $danger;\n                                border: 1px solid $danger;\n                            }\n                        }\n                    }\n                    a {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        color: $gray-500;\n                        &.dropdown-item {\n                            &:hover {\n                                color: $gray-900;\n                                svg {\n                                    color: $gray-900;\n                                }\n                            }\n                        }   \n                    }\n                \n                }\n                .notes-slider-content {\n                    margin: 24px 0;\n                    h4 {\n                        a {\n                            margin-bottom: 10px;\n                            color:$gray-500;\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                            display: -webkit-box;\n                            -webkit-line-clamp: 1;\n                            -webkit-box-orient: vertical;\n                            overflow: hidden;\n                            &:hover {\n                                color: $warning;\n                            }\n                        }                      \n                    }\n                    p {\n                        color: $text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        margin-bottom: 0px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                    }\n                }\n                .notes-slider-widget {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    .notes-logo {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        a {\n                            margin-right: 15px;\n                            span {\n                                width: 32px;\n                                height: 32px;\n                                display: flex;                                \n                                img {\n                                    border-radius: 100px;\n                                }\n                                \n                            }                           \n                        }   \n                        span {\n                            &.medium-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $success;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.high-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $warning;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.low-square {\n                                margin-right: 5px;\n                                i {\n                                    color: #288EC7;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                        }                     \n                        p {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            color:#288EC7;\n                            font-size: $font-size-15;\n                            font-weight: $font-weight-normal;\n                            margin-bottom: 0px;\n                            i {\n                                &.fa-draw-polygon {\n                                    margin-right: 5px;\n                                }\n                            }\n                            &.medium {\n                                color: $success;\n                            }\n                            &.high {\n                                color: $warning;\n                            }\n                        }\n                    }\n                    .notes-star-delete {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        span {\n                            .fa-star {\n                                color: $warning;\n                                width: 16px;\n                                height: 16px;\n                                margin-right: 10px;\n                            }\n                            .feather-trash-2 {\n                                color: $danger;\n                                width: 16px;\n                                height: 16px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .section-card-body {\n            padding-top: 40px;\n            .notes-card-details {\n                border-radius: 8px;\n                border: 1px solid  rgba(145, 158, 171, 0.30);\n                background: $white;\n                box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);\n                padding: 24px;\n                margin-bottom: 24px;\n                .notes-card-body {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    p {\n                        &.badged  {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            border-radius: 8px;\n                            border: 1px solid  $warning;\n                            padding: 4px 10px; \n                            margin-bottom: 0;\n                            color:$warning;\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-semibold;\n                            i {\n                                font-size: 7px;\n                                margin-right: 4px;\n                            }\n                            &.medium {\n                                color: #7429F8;\n                                border: 1px solid #7429F8;\n                            }\n                            &.high {\n                                color: $danger;\n                                border: 1px solid $danger;\n                            }\n                        }\n                    }\n                    .dropdown-item {\n                        span {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            color: $gray-500;\n                            svg {\n                                width: 14px;\n                                height: 14px;\n                                color: $text-color;\n                            }\n                        }\n                        &:hover {\n                            span {\n                                svg {\n                                    color: $white;\n                                }\n                            }\n                        }\n                    }\n                }\n                .notes-wrap-content {\n                    padding: 20px 0;\n                    border-bottom: 1px solid $light-900;\n                    h4 {\n                        a {\n                            color:$gray-500;\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                            margin-bottom: 5px;\n                            display: -webkit-box;\n                            -webkit-line-clamp: 1;\n                            -webkit-box-orient: vertical;\n                            overflow: hidden;\n                            &:hover {\n                                color: $warning;\n                            }\n                        }                    \n                    }\n                    .wrap-cal {\n                        color:$text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        margin-bottom: 20px;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        svg {\n                            margin-right: 5px;\n                            width: 16px;\n                            height: 16px;\n                        }\n                    }\n                    p {\n                        color:$text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        margin-bottom: 0px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                    }\n                }\n                .notes-slider-widget {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    &.notes-widget-profile {\n                        padding-top: 20px;\n                    }\n                    .notes-logo {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        a{\n                            margin-right: 15px;\n                            span {                            \n                                img {\n                                    border-radius: 100px;\n                                }\n                            } \n                        }                                            \n                        span {\n                            &.medium-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $success;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.high-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $warning;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.low-square {\n                                margin-right: 5px;\n                                i {\n                                    color: #288EC7;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                        }\n                        p {\n                            color:#288EC7;\n                            font-size: $font-size-15;\n                            font-weight: $font-weight-normal;\n                            margin-bottom: 0px;\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            i {\n                                &.fa-draw-polygon {\n                                    margin-right: 5px;\n                                }\n                            }\n                            &.medium {\n                                color: $success;\n                            }\n                            &.high {\n                                color: $warning;\n                            }\n                        }\n                    }\n                    .notes-star-delete {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        span {\n                            .feather-star {\n                                color: $text-color;\n                                width: 16px;\n                                height: 16px;\n                                margin-right: 10px;\n                            }\n                            .feather-trash-2 {\n                                color: $danger;\n                                width: 16px;\n                                height: 16px;\n                            }\n                        }\n                    }\n                }\n            }\n        }      \n    }\n}\n.notes-card-details {\n    .notes-card-body {\n        a {\n            color: $gray-500;\n        }\n    }\n\n}\n.star-todo-inbox {\n    svg {\n        width: 13px;\n        height: 13px;\n        color: $text-color;\n    }\n}\n.inbox-call-profile {\n    border-radius: 5px;\n    background: #E92990;\n    border: 1px solid #E92990;\n    padding: 4px 10px;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    color: $white;\n    margin: 0 20px;\n    &:hover  {\n        color: #E92990;\n        background: $white;\n    }\n}\n.notes-tog {\n    i {\n        transform: rotate(180deg);\n    }\n    &.active {\n        i {\n            transform: rotate(0deg);\n        }\n    }\n}\n.section-bulk-wrap {\n    .form-sort {\n        position: relative;\n        svg {\n            &.feather-filter {\n                position: absolute;\n                z-index: 101;\n                width: 16px;\n                height: 16px;\n                top: 12px;\n                left: 10px;\n            }\n            \n        }\n    }\n}\n\n.page-add-notes.active svg {\n    transform: rotate(0) !important;\n}\n.dropdown-menu {\n    &.notes-menu {\n        z-index: 99999;\n        a {\n            &.dropdown-item {\n                color: $gray-500;\n                font-size: $font-size-15;\n                font-weight: $font-weight-normal;\n                display: flex;\n                align-items: center; \n                padding: 5px;   \n                border-radius: 5px;\n                &:hover {\n                    background: $light-300;\n                    color: $gray-900;\n                    svg {\n                        color: $gray-900;\n                    }\n                }                          \n            }\n            \n        }   \n        span {\n            margin-right: 8px;\n        }\n        svg {\n            width: 14px;\n            height: 14px;\n            color: $text-color;\n        }\n    } \n}\n.edit-note-head {\n    a {\n        border-radius: 30px;\n        border: 1px solid rgba(145, 158, 171, 0.30);\n        background:  $white;\n        color: $gray-500;\n        padding: 15px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 20px;\n        height: 20px;\n        &:hover {\n            border-radius: 20px;\n            background:  $primary;\n            color: $white;\n        }\n    }\n}\n.custom-modal-body {\n    .select2-container {\n        .selection {\n            .select2-selection {\n                .select2-selection__rendered {\n                    padding-left: 10px!important;\n                }\n            }\n        }\n        \n    }\n}\n.bulk-con-wrap {\n    width: 100%;\n}\n.section-bulk-widget {\n    transition: 0.6s all\n}\n.section-notes-dashboard {\n    display: none;\n    transition: 0.6s all\n}\n.notes-tog {\n    i {\n        transition: 0.5s all;\n    }\n}\n.notes-tag-left {\n    .notes-tog {\n        i {\n            transform: rotate(360deg);\n            transition: 0.5s all;\n        }\n    }\n}\n.budgeted-role-notes {\n    width: 100%;\n}\n.notes-summernote .card{\n    margin-bottom: 0 !important;\n}\n.dropdown-item:active {\n    background: transparent;\n}\n.notes-summernote p {\n    color: $text-color;\n    font-size: $font-size-15;\n    font-weight: $font-weight-normal;\n}\n.budget-role-notes {\n    .owl-carousel .owl-nav {\n        margin: 0;\n        position: absolute;\n    }\n}\n.notes-dash {\n    margin-top: 30px;\n    padding: 24px;\n    border-radius: 8px;\n    border: 1px solid  rgba(145, 158, 171, 0.30);\n    background: $white;\n    transition: 0.6s all;\n    .notes-top-head {       \n        border-bottom: 1px solid $light-900;\n        h5 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n            color: $gray-500;\n            margin-bottom: 15px;\n            display: flex;\n            align-items: center;\n            svg {\n                width: 19px;\n                height: 19px;\n                margin-right: 6px;\n                color: $text-color;\n            }\n        }\n    }\n    .notes-top-head-submenu {\n        padding: 15px 0;\n        border-bottom: 1px solid $light-900;\n        ul {\n            padding: 15px 0;\n            li {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;               \n                padding: 10px;\n                &.active {\n                    border-radius: 10px;\n                    background:  $gray-500;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }\n                    p {\n                        color: $white;                        \n                    }\n                }\n\n                p {\n                    font-size: $font-size-15;\n                    font-weight: $font-weight-semibold;\n                    color: $text-color;\n                    margin-bottom: 0;\n                    display: flex;\n                    align-items: center;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }\n                }\n                span {\n                    display: flex;\n                    width: 18px;\n                    height: 18px;\n                    padding: 0px 3px;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 12px;\n                    background:  $primary;\n                    color: $white;\n                }\n\n            }\n        }\n    }\n    .content-submenu-tag {\n        margin-top: 15px;\n        padding: 10px;\n        h6 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            color: $gray-500;\n        }\n        ul {\n            padding: 10px 0;\n            &.tags-list {\n                margin-bottom: 24px;\n            }\n            li {\n                &.personal {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a {\n                        color: #288EC7;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.social {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a {\n                        color: $warning;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.work {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a{\n                        color: $success;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.public {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                     a{\n                        color: #A02F7A;\n                        display: flex;\n                        align-items: center;\n                     }\n                    \n                }\n                &.medium {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    } \n                     a {\n                        color: $purple;\n                        display: flex;\n                        align-items: center;\n                     }\n                   \n                }\n                &.high {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a {\n                        color: $danger;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.low {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a  {\n                        color: $warning;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                   font-size: $font-size-15;\n                   font-weight: $font-weight-normal;\n                   display: flex;\n                   align-items: center;\n                +li {\n                    margin-top: 10px;\n                }\n            }\n        }\n    }\n}\n.notes-logo {\n    a {\n        display: flex;\n        align-items: center;\n        span {\n            width: 32px;\n            height: 32px;  \n            img {\n                border-radius: 32px;               \n            }\n        }\n    }\n}\n.notes-top-head-submenu {\n    padding: 15px 0;\n    border-bottom: 1px solid $gray-400;\n    .nav {\n        &.todo-inbox {\n            button.todo-inbox {\n               display:flex;\n               justify-content: start; \n               align-items: center;             \n                padding: 10px;\n                font-size: $font-size-15;\n                font-weight: $font-weight-semibold;\n                color: $text-color;\n                margin-bottom: 0;\n                display: flex;\n                align-items: center;\n                margin-bottom: 5px;\n                border-radius: 5px;\n                &.active {\n                    border-radius: 5px;\n                    background:  #212B36;\n                    padding: 10px;\n                    color: $white;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }               \n                }\n                &:hover {\n                    background:  #212B36;\n                    color: $white;\n                }\n               \n                svg {\n                    width: 16px;\n                    height: 16px;\n                    margin-right: 8px;\n                }\n                span {\n                    display: flex;\n                    width: 20px;\n                    height: 20px;\n                    padding: 0px 3px;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 12px;\n                    background:  $primary;\n                    color: $white;\n                }\n                  \n            }            \n        }\n    }\n    \n}\n.notes-trash-btn {\n    background: $danger;\n    color: $white;\n    border-radius: 8px;\n    margin: 4px 0 20px 0;\n    padding: 10px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    span {\n        display: flex;\n        align-items: center;\n        svg {\n            width: 16px;\n            height: 16px;\n            margin-right: 10px;\n        }\n    }\n}\n.delete-popup {\n    padding: 24px;\n    border-radius: 8px;\n    background: $white;\n    .delete-image {\n        margin-bottom: 20px;\n    }\n    .delete-heads {\n        text-align: center;\n        h4 {\n            color: $gray-500;\n            font-size: $font-size-20;\n            font-weight: $font-weight-bold;\n            margin-bottom: 5px;\n        }\n        p {\n            color: $text-color;\n            font-size: $font-size-15;\n            font-weight: $font-weight-normal;\n            margin-bottom: 0px;\n        }       \n    }\n    .delete-footer {\n        text-align: center;\n    }\n}\n.edit-page-title {\n    display: flex;\n    align-items: center;\n    h4 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-bold;\n        color: $gray-500;\n        margin-bottom: 0;\n        margin-right: 10px;\n    }\n    p {\n        font-size: $font-size-15;\n        font-weight: $font-weight-normal;\n        color: #288EC7;\n    }\n}\n.edit-head-view {\n    margin-bottom: 20px;\n    border-bottom: rgba(145, 158, 171, 0.30);\n    h6 {\n        font-size: $font-size-16;\n        font-weight: $font-weight-semibold;\n        color: $gray-500;\n        margin-bottom: 15px;\n    }\n    p {\n        font-size: $font-size-15;\n        font-weight: $font-weight-normal;\n        color: $text-color;\n        margin-bottom: 15px;\n    }\n    p {\n        &.badged {\n            i {\n                font-size: 7px;\n                margin-right: 7px;\n            }\n            border-radius: 8px;\n            border: 1px solid $warning;\n            padding: 4px 10px;\n            margin-bottom: 0;\n            color: $warning;\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n            display: inline-flex;\n            align-items: center;\n        }\n    }\n}\n.edit-footer-menu a {\n    background-color: $danger;\n}\n.edit-noted-head {\n    a {\n        span {\n            i{\n                 &.fa-trash-alt {\n                    color: $danger;\n                    margin-right: 10px;\n                 }\n                 &.fa-star {\n                    color: $warning;\n                 }\n            }\n        }\n    }\n}\n.edit-head-view {   \n    p {\n        &.badged.high {\n            i {\n                font-size: 7px;\n                margin-right: 7px;\n            }\n            border-radius: 8px;\n            border: 1px solid $danger;\n            padding: 4px 10px;\n            margin-bottom: 0;\n            color: $danger;\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n            display: inline-flex;\n            align-items: center;\n        }\n    }\n}\n.people-profile-pic {\n    border: none !important;\n    margin-left: 14px;\n    position: relative;\n    img {\n        border-radius: 10px;\n    }\n    a {\n        position: absolute;\n        top: 15px;\n        right: 7px;\n        .x-square-add {\n            border-radius: 3px;\n            background:$danger;\n            color: $white;\n        }       \n    }\n}\n\n.people-customer-walk {\n    max-width: 35px;\n}\n.custom-pagination {\n    .paginations {\n        align-items: center;\n        span {\n            display: flex;\n            align-items: center;\n            color: $text-color;\n            width: 16px;\n            height: 16px;\n            .fa-chevron-left {\n                margin-right: 8px;\n            }\n        }\n        .page-wrap {\n            li {\n                a {\n                    margin-right: 8px;\n                    border-radius: 85px;\n                    color:$text-color;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-medium;                    \n                    display: flex;\n                    width: 30px;\n                    height: 30px;\n                    padding: 5px;\n                    justify-content: center;\n                    align-items: center;\n                    &.active {\n                        background: $primary;\n                        color: $white;\n                    }                         \n                }  \n                :hover {\n                    background: $primary;\n                    color: $white;\n                    transition: .3s all;\n                }                                   \n            }                \n        }\n    } \n}\n.section-notes-slider {\n    .notes-slider {\n        &.owl-carousel {\n            .owl-nav {\n                top: -42px;\n                right: unset;\n                left: 170px;\n                button {\n                    background-color: transparent;\n                    width: 15px;\n                    height: auto;\n                    i {\n                        color: $gray-500;\n                    }\n                    &:hover {\n                        background-color: transparent;\n                        i {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n.form-sort {\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 35px;\n    }\n    span.select2-container.select2-container--default.select2-container--open {\n        z-index: 99;\n    }\n}\n.accordion-button:after, .accordion-button:not(.collapsed)::after{\n    display:none;\n}\n.todo-accordion .accordion-item {\n    background: transparent;\n    margin-bottom: 10px;\n    border: 0;\n    padding: 0;\n}\n.search-set {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    .search-input{\n        position: relative;\n        margin-right: 15px;    \n        input[type=\"search\"] {\n            height: 38px;\n            border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n            background: var(--White, #FFF);\n            width: 298px;\n            @include rounded(5px);\n            padding: 10px;\n            &::placeholder {\n                color: $black;\n            }\n            @include respond-below(custom1199) {\n                width: 220px;\n            }\n            @include respond-below(custom991) {\n                width: 200px;\n            }\n            @include respond-below(custom575) {\n                width: auto;\n            }\n        }\n        .btn-searchset {\n            @include margin-padding(null, null);\n            @include rounded(50px);\n            @include position(absolute,0,0,null,null);\n            border: 0;\n            .feather-search {\n                width: 14px;\n                height: 14px;\n            }\n        }\n    }\n}\n.page-add-notes {\n    display: flex;\n    flex-wrap: wrap;\n}",".todo-inbox-check {\n    margin-right: 15px;\n    .checkboxs {\n        margin-bottom: 0;\n        padding-left: 25px;\n        display: flex;\n        align-items: center;\n        input ~ .checkmarks {\n            border-color: rgba(145, 158, 171, 0.30);\n            border-radius: 5px;\n            margin-top: 2px;\n            width: 20px;\n            height: 20px;\n        }\n        input {\n            &:checked {\n                ~ .checkmarks{\n                    border-color: $primary;\n                    background-color:$primary;\n                }\n            }\n        }\n    }    \n}\n.btn-cancel {\n    background: $gray-600;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    border-radius: 5px;\n    @include transition(all 0.5s ease);\n    &:hover{\n        background: #424b52;\n        color: $white;\n     }\n    @include respond-below(custom991) {\n        min-width: auto;\n    }\n}\n.swal2-confirm{\n    margin-right: 5px;\n}\n.btn-submit {\n    background: $primary;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    border-radius: 5px;\n    @include transition(all 0.2s ease);\n    &:hover{\n        background: $primary-hover;\n        color: $white;\n    }\n    @include respond-below(custom991) {\n        min-width: auto;\n    }\n}\n.sections-notes-slider{\n    .accordion-button:after{\n        display: none;\n    }\n}\n.todo-wrapper-list-content {\n    margin-left: 5px;\n}\n.notes-header h3 {\n    color: $gray-500;\n    font-size: $font-size-18;\n    font-weight: $font-weight-bold;\n    margin-bottom: 0;\n}\n.todo-inbox-check .checkboxs .checkmarks:after {\n    left: 9px;\n    top: 10px;\n}\n.checkboxs input:checked ~ .checkmarks:after {\n    display: block;\n}\n.todo-widget {\n    margin-bottom: 25px;\n}\n.todo-today-content {\n    margin-bottom: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .todo-drop-down {\n        span {\n            i {\n                color: $gray-500;\n            }\n        }\n    }\n    .todo-today-header {\n        display: flex;\n        align-items: center;\n        span {\n            margin-right: 5px;\n            display: flex;\n            align-items: center;\n            svg {\n                width: 16px;\n                height: 16px;\n                color: $text-color;\n            }\n        }\n        h3 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            color: $gray-500;\n            margin-bottom: 0;\n            margin-right: 5px;\n        }\n        h6 {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 18px;\n            height: 18px;\n            background-color: $primary;\n            border-radius: 50px;\n            color: $white;\n            font-size: 10px;\n            font-weight: $font-weight-semibold;\n            margin-bottom: 0;\n        }\n    }\n}\n.todo-wrapper-list {\n    padding: 15px;\n    border-radius: 8px;\n    border: 1px solid  rgba(145, 158, 171, 0.30);\n    background:  $white;\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n    @include respond-below(custom575) {\n        flex-direction: column;\n    }\n    .todo-inbox-check {\n        display: flex;\n        align-items: center;\n        .todo-wrapper-list-content {\n            h4 {\n                font-size: $font-size-16;\n                font-weight: $font-weight-bold;\n                color: $gray-500;\n                margin-bottom: 5px;\n            }\n            p {\n                font-size: 13px;\n                font-weight: $font-weight-medium;\n                color: $text-color;\n                margin-bottom: 0;\n            }\n        }\n        &.todo-inbox-check-list {\n            width: 45%;\n            @include respond-below(custom575) {\n                width: auto;\n            }\n            .checkboxs {\n                margin-bottom: 12px;\n                input ~ .checkmarks {\n                    border-radius: 5px;\n                    margin-top: 0;                    \n                }\n            }    \n        }\n    }   \n    .notes-card-body {\n        width: 35%;\n        @include respond-below(custom575) {\n            width: auto;\n            margin: 20px 0;\n        }\n        p {\n            display: flex;\n            align-items: center;\n            &.high {\n                border-radius: 8px;\n                border: 1px solid $danger;\n                padding: 4px 10px;\n                font-size: $font-size-14;\n                font-weight: $font-weight-semibold;\n                color: $danger;\n                margin-right: 10px;\n            }\n            &.medium {\n                padding: 4px 10px;\n                border-radius: 8px;\n                border: 1px solid #423B93;\n                font-size: $font-size-14;\n                font-family: $font-weight-semibold;\n                color: #423B93;\n            }\n            &.pending {\n                padding: 4px 10px;\n                border-radius: 8px;\n                border: 1px solid #288EC7;\n                font-size: $font-size-14;\n                font-family: $font-weight-semibold;\n                color: #288EC7;\n            }\n            &.low {\n                padding: 4px 10px;\n                border-radius: 8px;\n                border: 1px solid $warning;\n                font-size: $font-size-14;\n                font-family: $font-weight-semibold;\n                color: $warning;                \n            }\n            &.success {\n                padding: 4px 10px;\n                border-radius: 8px;\n                border: 1px solid $success;\n                font-size: $font-size-14;\n                font-family: $font-weight-semibold;\n                color: $success;                \n            }\n            i {\n                &.fa-circle{\n                    font-size: 7px;\n                    margin-right: 4px;\n                }\n            }\n            \n        }\n    }\n    .todo-strike-content {\n        h4 {\n            text-decoration-line: line-through;\n        }\n        p {\n            text-decoration-line: line-through;\n        }\n    }\n    .todo-profile {\n        width: 20%;\n        justify-content: end;\n        img {\n            border-radius: 30px;\n            margin-right: 16px;\n            width: 30px;\n            height: 30px;\n        }\n        a {\n            .fa-ellipsis-v {\n                color: $gray-500;\n            }\n        }\n    }\n}\n.datanew{\n    tbody{\n        border-top: 1px solid $light-900;\n    }\n}\n.form-sort {\n    position: relative;\n    width: 149px;\n    height: 40px;\n    .info-img {\n        position: absolute;\n        top: 52%;\n        z-index: 100;\n        width: 16px;\n        height: 16px;\n        left: 0;\n        margin-left: 10px;\n        color: $text-color;\n        transform: translateY(-50%);\n        line-height: normal;\n    }\n    @include respond-below(custom575) {\n        margin-top: 24px;\n    }\n}\n.todo-calendar  .input-groupicon.calender-input input {\n    padding-left: 10px;\n}\n.todo-calendar {\n    position: relative;\n    .calender-input {\n        position: relative;\n        .info-img {\n            position: absolute;\n            top: 11px;\n            z-index: 100;\n            width: 16px;\n            height: 16px;\n            right: 5px !important;\n            color: $text-color;\n        } \n    }   \n}\n.todo-accordion {\n    .accordion-item {\n        background: transparent;\n        margin-bottom: 20px;\n        .accordion-header {\n            cursor: pointer;\n            .accordion-button {\n                background: transparent;\n                padding: 0;\n                &.collapsed {\n                    .todo-today-content {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n            .todo-today-content {\n                width: 100%;\n            }\n            .todo-drop-down {\n                a {\n                    span {\n                        i {\n                            color: $text-color;\n                        }\n                    }\n                }\n            }\n        }\n        .accordion-body {\n            padding: 0;\n        }\n        .todo-widget {\n            margin-bottom: 0;\n            .todo-wrapper-list {\n                &:last-child {\n                    margin-bottom: 0;\n                }\n               \n            }\n        }\n\n    }\n}","@mixin tablecolor($color-bg) {\n  background-color: $white;\n  color: $black;\n  --bs-table-color-state: $black;\n  border-color: var(--bs-table-border-color);\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\n  --bs-table-border-color: rgba(#{$color-bg}, 0.05);\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.2);\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.2);\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.2);\n  &.table-striped > tbody > tr:nth-of-type(odd) > * {\n    background-color: var(--bs-table-accent-bg);\n    --bs-table-accent-bg: rgba(#{$color-bg}, 0.2);\n    color: $black;\n  }\n  &.table.table-hover > tbody > tr:hover > * {\n    background-color: var(--bs-table-accent-bg);\n    --bs-table-accent-bg: rgba(#{$color-bg}, 0.4);\n    color: $white;\n  }\n  .table-active {\n    background-color: var(--bs-table-accent-bg);\n    --bs-table-accent-bg: rgb(#{$color-bg});\n    color: $white;\n  }\n}\ncaption {\n  color: $text-muted;\n}\n.table-active{\n  --bs-table-color-state: var(--default-text-color);\n}\n@mixin tablehead($color-bg) {\n  background-color: $white;\n  color: var(--bs-table-color);\n  --bs-table-color-state: #000;\n  --bs-table-color: #{$black};\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\n  --bs-table-border-color: rgba(#{$color-bg}, 0.1);\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.5);\n  --bs-table-striped-color: #{$black};\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.5);\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.5);\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n@mixin table-color($color-bg) {\n  --bs-table-color: #{$black};\n  --bs-table-color-state: $black;\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\n  --bs-table-border-color: rgba(#{$color-bg}, 0.1);\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.3);\n  --bs-table-striped-color: #{$black};\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.3);\n  --bs-table-active-color: #{$black};\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.3);\n  --bs-table-hover-color: #{$black};\n  color: #{$black};\n  border-color: rgba(#{$color-bg}, 0.1);\n  background-color: #{$white};\n}\n.table {\n  color: $text-color;\n  border-color: $default-border;\n  margin-block-end: 0;\n  .checkboxs {\n    margin-bottom: 15px;\n  }\n  tbody {\n    tr {\n      th {\n        font-weight: $font-weight-medium;\n      }\n    }\n  }\n  th,\n  td {\n    padding: 0.75rem;\n    vertical-align: middle;\n    line-height: 1.462;\n    font-size: 0.813rem;\n    white-space: nowrap;\n  }\n  thead tr th {\n    font-weight: $font-weight-semibold;\n    font-size: 15px;\n  }\n  &.table-sm > :not(caption) > * > * {\n    padding: 0.3rem;\n  }\n  &.table-dark {\n    color: $light-700;\n    border-color: rgba($white, 0.1);\n  }\n  .thead-primary th {\n      background-color: $primary;\n      color: $white;\n  }\n  .thead-secondary th {\n      background-color: $secondary;\n      color: $white;\n  }\n  .thead-info th {\n      background-color: $info;\n      color: $white;\n  }\n  .thead-warning th {\n      background-color: $warning;\n      color: $white;\n  }\n  .thead-danger th {\n      background-color: $danger;\n      color: $white;\n  }\n  .thead-success th {\n      background-color: $success;\n      color: $white;\n  }\n  .thead-dark th {\n      background-color: $dark;\n      color: $white;\n  }\n  .thead-light th {\n      background-color: $light-100;\n      color: $dark;\n  }\n  &.table-primary {\n    @include tablecolor(var(--primary-rgb));\n  }\n  &.table-secondary {\n    @include tablecolor(var(--secondary-rgb));\n  }\n  &.table-warning {\n    @include tablecolor(var(--warning-rgb));\n  }\n  &.table-success {\n    @include tablecolor(var(--success-rgb));\n  }\n  &.table-danger {\n    @include tablecolor(var(--danger-rgb));\n  }\n  &.table-info {\n    @include tablecolor(var(--info-rgb));\n  }\n  &.table-light {\n    @include tablecolor(var(--light-rgb));\n  }\n  &.table-dark {\n    @include tablecolor(var(--dark-rgb));\n  }\n  &.table-bordered {\n    &.border-primary {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($primary, 0.1);\n      }\n    }\n    &.border-info {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($info, 0.1);\n      }\n    }\n    &.border-secondary {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($secondary, 0.1);\n      }\n    }\n    &.border-warning {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($warning, 0.1);\n      }\n    }\n    &.border-success {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($success, 0.1);\n      }\n    }\n    &.border-danger {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($danger, 0.1);\n      }\n    }\n  }\n  &.table-striped > tbody > tr:nth-of-type(odd) > * {\n    --bs-table-accent-bg: rgba(var(--dark-rgb),0.0125);\n    color: $text-color;\n  }\n  &.table-striped-columns > :not(caption) > tr > :nth-child(2n) {\n    --bs-table-accent-bg: rgba(var(--dark-rgb),0.025);\n    color: $text-color;\n  }\n  tbody.table-group-divider {\n    border-top: 1px solid $default-border;\n  }\n  &.table-hover > tbody > tr:hover > * {\n    --bs-table-accent-bg: #{$default-background};\n    color: $text-color;\n  }\n  .table-active {\n    --bs-table-accent-bg: #{$light};\n    color: $text-color;\n  }\n  thead {\n    &.table-primary {\n      @include tablehead(var(--primary-rgb));\n    }\n    &.table-secondary {\n      @include tablehead(var(--secondary-rgb));\n    }\n    &.table-warning {\n      @include tablehead(var(--warning-rgb));\n    }\n    &.table-success {\n      @include tablehead(var(--success-rgb));\n    }\n    &.table-danger {\n      @include tablehead(var(--danger-rgb));\n    }\n    &.table-info {\n      @include tablehead(var(--info-rgb));\n    }\n    &.table-light {\n      @include tablehead(var(--light-rgb));\n    }\n    &.table-dark {\n      @include tablehead(var(--dark-rgb));\n    }\n  }\n}\n.table-primary {\n  @include table-color(var(--primary-rgb));\n}\n.table-secondary {\n  @include table-color(var(--secondary-rgb));\n}\n.table-warning {\n  @include table-color(var(--warning-rgb));\n}\n.table-success {\n  @include table-color(var(--success-rgb));\n}\n.table-info {\n  @include table-color(var(--info-rgb));\n}\n.table-danger {\n  @include table-color(var(--danger-rgb));\n}\n.table-dark {\n  @include table-color(var(--dark-rgb));\n}\n.table-light {\n  @include table-color(var(--light-rgb));\n}\n[data-theme-mode=\"dark\"] {\n  .table-dark {\n    border-color: rgba(0,0,0,0.025);\n  }\n}\n[dir=\"rtl\"] {\n  .table {\n    margin-inline-end: 1px;\n  }\n}\n.table{\n    margin: 0;\n    tbody{\n        tr{\n            td{\n                color: $gray-700;\n                font-size: $font-size-14; \n                .product-img{\n                    img{\n                        border: 0;\n                    }\n                }\n                .userslist-img {\n                    width:35px;\n                    height: 35px;\n                    margin-right: 8px;\n                    img {\n                        border-radius: 0;\n                    }\n                }\n                .userslist-img.bg-img {\n                    img {\n                        border: 1px solid var(--stroke-table, #E8EBED);\n                        // background: url(<path-to-image>), lightgray 50% / cover no-repeat;\n                    }\n                }\n                a {\n                    color: $secondary;\n                    font-size: $font-size-14;\n                    font-weight: $font-weight-normal;\n                    line-height: normal;\n                    &.product-img{\n                        margin-right: 5px;\n                        flex-shrink: 0;\n                    }\n                    .info-img {\n                        margin-right: 8px;\n                        width: 16px;\n                        height: 16px;\n                    }\n                    &:hover {\n                        color: $primary;\n                    }\n                }\n                .emp-name {\n                    line-height: 1;\n                    a {\n                        color: $secondary;\n                    }\n                    p {\n                        line-height: 2;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-medium;\n                        color: $text-color;\n                    }\n                    .role {\n                        line-height: unset;\n                    }\n                }\n                .product-imgs{\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    width:40px;\n                    height:40px;\n                    background: #FFEBD8;\n                    font-size: $font-size-14;\n                    color: #FF9F43 !important;\n                    font-weight: $font-weight-medium;\n                    margin-right:10px;\n                }\n            }\n            .data-header {\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n                font-size: $font-size-15;\n                border-bottom: none;\n            }\n            .ref-number {\n                color: $purple;\n            }\n            &.active{\n                border-bottom: 0;\n                td{\n                    font-size: $font-size-18;\n                    color: $gray-700;\n                    font-weight: $font-weight-semibold;\n                    border-bottom: 0;\n                }\n            }\n        }\n        .loss-highlight {\n            td {\n                font-weight: $font-weight-bold;\n                color: $secondary;\n                font-size: $font-size-base;\n                border-top: 1px solid $gray-300;\n            }\n        }\n        .userimgname {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            img {\n                margin-right: 8px;\n                border-radius: 6px;\n                \n            }\n        }\n        .purchase-count {\n            td {\n                padding-bottom: 20px;\n            }\n        }\n        \n    }\n    .Expense-list {\n       tr {\n        td {\n            padding: 15px 17px;\n            a {\n                margin-bottom: 0;\n            }\n        }\n       }\n    }\n    .sales-list {\n        tr {\n            td {\n                padding: 20px 17px;\n            }\n        }\n    }\n    .Expense-list-blk {\n        tr {\n            td {\n                padding: 20px 17px;\n            }\n        }\n    }\n        \n    \n}\n.new {\n    tbody {\n        tr {\n            td {\n                border-bottom: none;\n            }\n        }\n    }\n}\n.table-height{\n    min-height: 300px;\n    @include respond-below(custom991) {\n        min-height: auto;\n        margin-bottom: 15px;\n    }\n}\n.max-widthauto{\n    max-width: 100% !important;\n}\n.dataTables_filter {\n    & + .dataTables_filter {\n        display: none;\n    }\n}\n.dataview {\n    .dataTables_length,\n    .dataTables_info,\n    .dataTables_paginate{\n        display: none !important;\n    }\n}\n.dataTables_length {\n    font-size: $font-size-12;\n}\n.productimgname {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    a{\n        color: $secondary;\n        font-weight: $font-weight-medium;\n    }\n    .view-product {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        width: 50px;\n        height: 50px;\n        border-radius: 6px;\n        background: #F8F8F8;\n    }\n}\n.input-blocks{\n    .calc-no{\n        width: 50px !important;\n        text-align: center;\n    }\n}\n.table {\n    .input-blocks {\n        input[type=text] {\n            height:40px;\n        }\n    }\n    .scanner-set{\n        width:40px;\n        height:40px;\n    }\n}\n.card.table-list-card {\n    .card-body {\n        padding: 0;\n    }\n    .table-top {\n        padding: 24px 24px 0;\n    }\n    .table-responsive {\n        padding: 24px;\n        .dataTables_wrapper {\n            border: 0;\n            padding: 0;\n        }\n    }\n    .tabs-set {\n        .nav-tabs {\n            padding: 24px 24px 0;\n            margin-bottom: 0;\n        }\n    }\n}\n.table.profit-table {\n    thead {\n        background-color: #FAFBFE;\n        border-radius: 8px 8px 0px 0px;\n        tr {\n            &:hover {\n                background-color: #FAFBFE;\n            }\n        }\n\n    }\n    tbody {\n        td {\n            border-bottom: 0;\n        }\n        .profit-table-bg { \n            td {\n                color: $secondary;\n                font-weight: $font-weight-bold;\n                border-top: 1px solid $gray-100;\n                background-color: #FAFBFE;\n            }\n        }\n        .table-heading {\n            &:hover {\n                background-color: $white;\n            }\n            td {\n                color: $secondary;\n                font-weight: $font-weight-bold;\n            }\n        }\n    }\n} \n.profit-table-top {\n    .daterange-wraper {\n        margin: 0 10px;\n        input {\n            padding-left: 35px;\n        }\n    }\n}\ntable {\n    td {\n        .shield {\n            width: 14px;\n            height: 14px;\n        }\n    }\n}\n.paysilp-table-border {\n    border: 1px solid $gray-100;\n    th {\n        border-right: 1px solid $gray-100;\n        border-left: 1px solid $gray-100;\n        padding: 15px;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-16;\n    }\n}\n.paysilp-table-borders {\n    td {\n        border-right: 1px solid $gray-100;\n        border-left: 1px solid $gray-100;\n        padding: 5px 15px;\n        color: $text-color;\n    }\n}\n.payslip-border-bottom {\n    border: 1px solid $gray-100;\n    th {\n        padding: 5px 15px;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-16;\n    }\n    td {\n        color: $text-color;\n    }\n}\n.emp-details {\n    margin: 20px 0;\n    .pay-slip-salery {\n        h6 {\n            font-weight: $font-weight-bold !important;\n            margin-bottom: 10px;\n            font-size: $font-size-18 !important;\n        }\n    }\n    .emp-name-id.pay-slip-salery {\n        margin-right: 30px;\n    }\n}\n.slip-logo {\n    @include respond-below(custom575) {\n        flex-shrink: 0;\n        margin-right: 15px;\n    }\n}\n.product-name-slip {\n    h4 {\n        color: $primary;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-18;\n    }\n}\n.pay-slip-box {\n    .modal-header {\n        border-radius: 8px 8px 0 0;\n    }\n    .custom-modal-body {\n        padding: 0;\n    }\n    .card {\n        border: 0;\n        border-radius: 0 0 10px 10px;\n        .card-body {\n            padding: 20px;\n            .emp-details.justify-content-start {\n                max-width: 760px;\n                margin: 20px auto 20px;\n            }\n        }\n    }\n}\n.table{\n  margin: 0;\n  tbody{\n      tr{\n          td{\n              color: $gray-700;\n              font-size: $font-size-14; \n              .product-img{\n                  img{\n                      border: 0;\n                  }\n              }\n              .userslist-img {\n                  width:35px;\n                  height: 35px;\n                  margin-right: 8px;\n                  img {\n                      border-radius: 0;\n                  }\n              }\n              .userslist-img.bg-img {\n                  img {\n                      border: 1px solid var(--stroke-table, #E8EBED);\n                    //   background: url(<path-to-image>), lightgray 50% / cover no-repeat;\n                  }\n              }\n              a {\n                  color: $title-color;\n                  font-size: $font-size-14;\n                  font-weight: $font-weight-normal;\n                  line-height: normal;\n                  &.product-img{\n                      margin-right: 5px;\n                      flex-shrink: 0;\n                  }\n                  .info-img {\n                      margin-right: 8px;\n                      width: 16px;\n                      height: 16px;\n                  }\n                  &:hover {\n                      color: $primary;\n                      i {\n                          color: $primary;\n                      }\n                  }\n              }\n              .emp-name {\n                  line-height: 1;\n                  a {\n                      color: $secondary;\n                  }\n                  p {\n                      line-height: 2;\n                      font-size: $font-size-15;\n                      font-weight: $font-weight-medium;\n                      color: $text-color;\n                  }\n                  .role {\n                      line-height: unset;\n                  }\n              }\n              .product-imgs{\n                  display: -webkit-box;\n                  display: -ms-flexbox;\n                  display: flex;\n                  align-items: center;\n                  -webkit-box-align: center;\n                  -ms-flex-align: center;\n                  justify-content: center;\n                  -webkit-justify-content: center;\n                  -ms-flex-pack: center;\n                  width:40px;\n                  height:40px;\n                  background: #FFEBD8;\n                  font-size: $font-size-14;\n                  color: #FF9F43 !important;\n                  font-weight: $font-weight-medium;\n                  margin-right:10px;\n              }\n          }\n          .data-header {\n              font-weight: $font-weight-semibold;\n              color: $secondary;\n              font-size: $font-size-15;\n              border-bottom: none;\n          }\n          .ref-number {\n              color: $purple;\n          }\n          &.active{\n              border-bottom: 0;\n              td{\n                  font-size: $font-size-18;\n                  color: $gray-700;\n                  font-weight: $font-weight-semibold;\n                  border-bottom: 0;\n              }\n          }\n      }\n      .loss-highlight {\n          td {\n              font-weight: $font-weight-bold;\n              color: $secondary;\n              font-size: $font-size-base;\n              border-top: 1px solid $gray-300;\n          }\n      }\n      .userimgname {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          align-items: center;\n          -webkit-box-align: center;\n          -ms-flex-align: center;\n          img {\n              margin-right: 8px;\n              border-radius: 6px;\n              \n          }\n      }\n      .purchase-count {\n          td {\n              padding-bottom: 20px;\n          }\n      }\n      \n  }\n  .Expense-list {\n     tr {\n      td {\n          padding: 15px 17px;\n          a {\n              margin-bottom: 0;\n          }\n      }\n     }\n  }\n  .sales-list {\n      tr {\n          td {\n              padding: 20px 17px;\n          }\n      }\n  }\n  .Expense-list-blk {\n      tr {\n          td {\n              padding: 20px 17px;\n          }\n      }\n  }\n  .userimgname .product-img {\n    display: inherit;\n    width: 35px;\n    height: 35px;\n    margin-right: 8px;\n  }\n  \n}\ntable {\n  tbody {\n      td {\n          &.action-table-data {\n              display: -webkit-box;\n              display: -ms-flexbox;\n              display: flex;\n              a {\n                  border: 1px solid rgba(145, 158, 171, 0.30);\n        background-color: $white;\n                  border-radius: 8px;\n                  display: -webkit-box;\n                  display: -ms-flexbox;\n                  display: flex;\n                  align-items: center;\n                  -webkit-box-align: center;\n                  -ms-flex-align: center;\n                  justify-content: center;\n                  -webkit-justify-content: center;\n                  -ms-flex-pack: center;\n                  padding: 8px;\n                  .feather-edit {\n                      color: $blue;\n                      width: 14px;\n                      height: 14px;\n                  }\n                  .action-edit {\n                     color: $text-color;\n                     width: 14px;\n                      height: 14px;\n                  }\n                  .feather-trash-2 {\n                      color: $danger;\n                      width: 14px;\n                      height: 14px;\n                  }\n                  .feather-eye {\n                      width: 14px;\n                      height: 14px;\n                  }\n                  .action-download {\n                      color: $blue;\n                      width: 14px;\n                      height: 14px;\n                      \n                  }\n                  .action-eye {\n                      color: $secondary;\n                      width: 14px;\n                      height: 14px;\n                  }\n              }\n             \n          }\n      }\n      .productimgname {\n          min-width: 200px;\n          a {\n              &.stock-img.product-img {\n                  display: -webkit-box;\n                  display: -ms-flexbox;\n                  display: flex;\n                  align-items: center;\n                  -webkit-box-align: center;\n                  -ms-flex-align: center;\n                  justify-content: center;\n                  -webkit-justify-content: center;\n                  -ms-flex-pack: center;\n                  margin-right: 8px;\n                  img {\n                      width: 50px;\n                      height: 50px;\n                      max-width: 100%;\n                      margin-right: 0;\n                  }\n              }\n          }\n      }\n  }\n  .edit-delete-action {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      align-items: center;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      justify-content: center;\n      -webkit-justify-content: center;\n      -ms-flex-pack: center;\n      height: 50px;\n      a {\n          padding: 0;\n      }\n\n  }\n  .edit-delete-action.data-view {\n      min-height: 52px;\n  }\n  .edit-delete-action.data-row {\n      height: auto;\n  }\n  .edit-delete-action.data {\n      height: 44px;\n  }\n}\n.custom-table {\n    table {\n        td {\n            ul {\n                &.social-links {\n                    li {\n                        a {\n                            width: 24px;\n                            height: 24px;\n                            border-radius: 50%;\n                            display: inline-flex;\n                            align-items: center;\n                            justify-content: center;\n                            margin-right: 5px;\n                            color: $text-color;\n                            &:hover {\n                                background: $light-900;\n                                color: $text-color;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}",".accordion-button {\n    background-color: $white;\n    color: $text-color;\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n    font-weight: $font-weight-medium;\n    &.accordion-custom-button {\n        &:after {\n            content: \"\\f054\";\n        }\n        &:not(.collapsed) {\n            color: $text-color;\n            background-color: $default-background;\n            box-shadow: none;\n            &:after {\n                content: \"\\f078\";\n                display: block;\n                transform: none;\n            }\n        }\n    }\n    &:not(.collapsed) {\n        color: $text-color;\n        background-color: $default-background;\n        box-shadow: none;\n    }\n    &:focus {\n        border-color: rgba($primary, 0.3);\n        box-shadow: none;\n    }\n    &:after,&:not(.collapsed)::after {\n        background-image: none;\n    }\n    &:after {\n        content: \"\\f078\";\n        font-family: $font-awesome;\n        font-size: $font-size-12;\n        line-height: 1;\n        background-color: $white;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 3.125rem;\n        color: $text-color;\n    }\n}    \n.accordion-body {\n    padding: 0.75rem 1rem;\n    font-size: 0.8125rem;\n    color: $text-muted;\n}\n.accordion-item {\n    color: $text-color;\n    background-color: $white;\n    border: 1px solid $light-900;\n}\n.accordions-items-seperate {\n    .accordion-item:not(:first-of-type) {\n        margin-block-start: 0.5rem;\n    }\n    .accordion-item {\n        border-block-start: 1px solid $light-900;\n        border-radius: $border-radius;\n        overflow: hidden;\n    }\n}\n.accordion-item:last-of-type {\n    border-bottom-right-radius: 0.35rem;\n    border-bottom-left-radius: 0.35rem;\n}\n.accordion-item:first-of-type {\n    border-top-left-radius: 0.35rem;\n    border-top-right-radius: 0.35rem;\n}\n.accordion {\n    &.accordion-primary {\n        .accordion-button {\n            background-color: rgba($primary, 0.1);\n            color: $primary;\n            &:after { \n                background-color: $primary;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-secondary {\n        .accordion-button {\n            background-color: rgba($secondary,0.1);\n            color: $secondary;\n            &:after { \n                background-color: $secondary;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-success {\n        .accordion-button {\n            background-color: rgba($success,0.1);\n            color: $success;\n            &:after { \n                background-color: $success;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-danger {\n        .accordion-button {\n            background-color: rgba($danger,0.1);\n            color: $danger;\n            &:after { \n                background-color: $danger;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-warning {\n        .accordion-button {\n            background-color: rgba($warning,0.1);\n            color: $warning;\n            &:after { \n                background-color: $warning;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-info {\n        .accordion-button {\n            background-color: rgba($info,0.1);\n            color: $info;\n            &:after { \n                background-color: $info;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n}\n.accordion {\n    &.accordion-solid-primary {\n        .accordion-button {\n            background-color: $primary;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $primary;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-secondary {\n        .accordion-button {\n            background-color: $secondary;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $secondary;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-success {\n        .accordion-button {\n            background-color: $success;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $success;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-danger {\n        .accordion-button {\n            background-color: $danger;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $danger;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-warning {\n        .accordion-button {\n            background-color: $warning;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $warning;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-info {\n        .accordion-button {\n            background-color: $info;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $info;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n}\n.accordion {\n    &.accordion-border-primary {\n        .accordion-item {\n            border: 1px solid $primary;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $primary;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $primary;\n                border: 1px solid $primary;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $primary;\n            }\n        }\n    }\n    &.accordion-border-secondary {\n        .accordion-item {\n            border: 1px solid $secondary;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $secondary;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $secondary;\n                border: 1px solid $secondary;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $secondary;\n            }\n        }\n    }\n    &.accordion-border-success {\n        .accordion-item {\n            border: 1px solid $success;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $success;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $success;\n                border: 1px solid $success;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $success;\n            }\n        }\n    }\n    &.accordion-border-danger {\n        .accordion-item {\n            border: 1px solid $danger;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $danger;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $danger;\n                border: 1px solid $danger;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $danger;\n            }\n        }\n    }\n    &.accordion-border-warning {\n        .accordion-item {\n            border: 1px solid $warning;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $warning;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $warning;\n                border: 1px solid $warning;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $warning;\n            }\n        }\n    }\n    &.accordion-border-info {\n        .accordion-item {\n            border: 1px solid $info;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $info;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $info;\n                border: 1px solid $info;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $info;\n            }\n        }\n    }\n}\n.accordion {\n    &.accordionicon-none {\n        .accordion-button:after {\n            display: none;\n        }\n    }\n}\n.accordion {\n    &.accordionicon-left {\n        .accordion-button {\n            padding-inline-start: 2.5rem;\n            &:after {\n                position: absolute;\n                inset-inline-start: 0.625rem;\n            }\n        }\n    }\n}\n.accordion {\n    &.accordion-customicon1 {\n        .accordion-button {\n            &:after {\n                content: \"\\2b\";\n                font-family: $font-awesome;\n                background-color: $default-background;\n            }\n            &:not(.collapsed)::after {\n                content: \"\\f068\";\n\t\t\t\tfont-family: $font-awesome;\n                background-color: $white;\n            }\n        }\n    }\n}\n.customized-accordion {\n    .accordion-item{\n        &.custom-accordion-primary {\n            .accordion-button {\n                background-color: rgba($primary, 0.1);\n                border-inline-start: 0.25rem solid rgba($primary, 0.6);\n                &:after {\n                    background-color: rgba($primary, 0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($primary, 0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($primary, 0.6);\n            }\n        }\n        &.custom-accordion-secondary {\n            .accordion-button {\n                background-color: rgba($secondary,0.1);\n                border-inline-start: 0.25rem solid rgba($secondary,0.6);\n                &:after {\n                    background-color: rgba($secondary,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($secondary,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($secondary,0.6);\n            }\n        }\n        &.custom-accordion-warning {\n            .accordion-button {\n                background-color: rgba($warning,0.1);\n                border-inline-start: 0.25rem solid rgba($warning,0.6);\n                &:after {\n                    background-color: rgba($warning,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($warning,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($warning,0.6);\n            }\n        }\n        &.custom-accordion-info {\n            .accordion-button {\n                background-color: rgba($info,0.1);\n                border-inline-start: 0.25rem solid rgba($info,0.6);\n                &:after {\n                    background-color: rgba($info,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($info,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($info,0.6);\n            }\n        }\n        &.custom-accordion-success {\n            .accordion-button {\n                background-color: rgba($success,0.1);\n                border-inline-start: 0.25rem solid rgba($success,0.6);\n                &:after {\n                    background-color: rgba($success,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($success,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($success,0.6);\n            }\n        }\n        &.custom-accordion-danger {\n            .accordion-button {\n                background-color: rgba($danger,0.1);\n                border-inline-start: 0.25rem solid rgba($danger,0.6);\n                &:after {\n                    background-color: rgba($danger,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($danger,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($danger,0.6);\n            }\n        }\n    }\n}",".page-header-breadcrumb {\n  .breadcrumb-item+.breadcrumb-item::before {\n    content: var(--bs-breadcrumb-divider, \"\\ea65\");\n    font-family: \"tabler-icons\" !important;\n  }\n}\n[dir=\"rtl\"] {\n  .page-header-breadcrumb {\n    .breadcrumb-item+.breadcrumb-item::before {\n      content: var(--bs-breadcrumb-divider, \"\\ea64\");\n      font-family: \"tabler-icons\" !important;\n    }\n  }\n}\n.breadcrumb {\n  .breadcrumb-item {\n    a {\n      color: $text-muted;\n    }\n\n    &.active {\n      color: $primary;\n    }\n  }\n}\n.breadcrumb-item+.breadcrumb-item::before {\n  color: $text-muted;\n  opacity: 0.4;\n}\n.breadcrumb-arrow {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"\\f101\";\n    font-family: $font-awesome !important;\n  }\n}\n.breadcrumb-pipe {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"\\f061\";\n    font-family: $font-awesome !important;\n  }\n}\n.breadcrumb-line {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"-\";\n  }\n}\n.breadcrumb-dot {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"•\";\n  }\n}\n.breadcrumb-divide {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"\\f054\";\n    font-family: $font-awesome !important;\n  }\n}\n.breadcrumb-separatorless {\n  .breadcrumb-item+.breadcrumb-item::before {\n    content: \"\";\n    display: none;\n  }\n}\n.breadcrumb-colored {\n  padding: 12px 15px;\n  border-radius: $border-radius;\n\tli {\n\t\ta {\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t.breadcrumb-item {\n    a {\n\t\t\tcolor: $white;\n    }\n\t\t&.active {\n\t\t\tcolor: $white;\n\t\t\topacity: 0.8;\n\t\t}\n\t\t& + .breadcrumb-item {\n      a {\n        color: $white;\n      }\n\t\t\t&::before {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t}\n}\n.embedded-breadcrumb:before {\n  opacity: 0.7;\n}\n[data-theme-mode=\"dark\"] {\n  .embedded-breadcrumb:before {\n    filter: invert(1);\n  }\n}",".card {\n    margin-bottom: 24px;\n    background-color: $white;\n    transition: all .5s ease-in-out;\n    position: relative;\n    border-radius: $border-radius-lg;\n    border: 0;\n    box-shadow: $box-shadow-sm;\n    color: inherit;\n    .card-body {\n        padding: 1rem;\n    }\n    .card-title {\n        font-size: $font-size-18;\n        font-weight: $font-weight-bold;\n        text-transform: capitalize;\n    }\n    .card-header {\n        border-color: $light-900;\n        position: relative;\n        background: transparent;\n        padding: 1rem;\n        .card-title {\n            margin-bottom: 0rem;\n        }\n        .subtitle {\n            padding-top: 0.3125rem;\n            font-size: 0.875rem;\n            line-height: 1.5; \n        }\n    }\n    .card-footer {\n        border-color: $light-900;\n        background: transparent;\n        padding: 1rem 1.25rem 1rem;\n    }    \n}\n.card-group {\n  .card {    \n      margin-bottom: 1.5rem;\n  }\n}\n.card {\n  &.custom-card {\n  border-radius: $border-radius;\n  border: 0;\n  background-color: $white;\n  position: relative;\n  margin-block-end: 1.5rem;\n  width: 100%;\n  .card-header {\n    padding: 1rem 1.25rem;\n    background-color: transparent !important;\n    border-block-end: 1px solid $default-border;\n    display: flex;\n    align-items: center;\n    position: relative;\n    flex-wrap: wrap;\n    gap: 0.25rem;\n    &:first-child {\n      border-radius: 0.625rem 0.625rem 0 0;\n    }\n    .card-title {\n      position: relative;\n      margin-block-end: 0;\n      font-size: 0.9375rem;\n      font-weight: $font-weight-bold;\n      text-transform: capitalize;\n      .subtitle {\n        margin-block-end: 0;\n        text-transform: initial;\n      }\n    }\n  }\n  .card-footer {\n    background-color: transparent !important;\n    border-block-start: 1px solid $default-border;\n    padding: 1rem 1.5rem;\n    font-size: $font-size-base;\n  }\n  .card-body {\n    padding: 1.5rem;\n    color: $text-color;\n  }\n  .card-link {\n    font-size: 0.75rem;\n  }\n  }\n  .card-text {\n    font-size: 0.813rem;\n  }\n  .footer-card-icon {\n    width: 60px;\n    height: 60px;\n  }\n  &.overlay-card {\n    position: relative;\n    overflow: hidden;\n    color: rgba(255, 255, 255, 0.9);\n    .card-header {\n      border-block-end: 1px solid rgba(255, 255, 255, 0.1);\n    }\n    .card-footer {\n      border-block-start: 1px solid rgba(255, 255, 255, 0.1);\n    }\n    .over-content-bottom {\n      top: auto;\n    }\n    &:before {\n      content: \"\";\n      inset-inline-start: 0;\n      inset-inline-end: 0;\n      inset-block-start: 0;\n      inset-block-end: 0;\n      background-color: rgba(0, 0, 0, 0.2);\n      position: absolute;\n    }\n  }\n  &.card-bg-primary {\n    background-color: $primary;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-secondary {\n    background-color: $secondary;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-warning {\n    background-color: $warning;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-info {\n    background-color: $info;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-success {\n    background-color: $success;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-danger {\n    background-color: $danger;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-light {\n    background-color: $light;\n    color: $text-color;\n    .card-header {\n      background-color: rgba(0, 0, 0, 0.05) !important;\n      color: $text-color;\n      border-block-end: $default-border;\n    }\n    .card-body {\n      color: $text-color;\n    }\n    .card-footer {\n      background-color: rgba(0, 0, 0, 0.05) !important;\n      color: $text-color;\n      border-block-start: $default-border;\n    }\n  }\n  &.card-bg-dark {\n    background-color: $dark;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  .card-anchor {\n    position: absolute;\n    top: 0;\n    inset-inline-end: 0;\n    bottom: 0;\n    inset-inline-start: 0;\n    z-index: 1;\n    pointer-events: auto;\n    content: \"\";\n  }\n  .collapse-close {\n    display: none;\n  }\n  &.card .collapsed {\n    .collapse-close {\n      display: block;\n    }\n    .collapse-open {\n      display: none;\n    }\n  }\n  &.card-fullscreen {\n    position: fixed;\n    top: 0;\n    inset-inline-start: 0;\n    inset-inline-start: 0;\n    bottom: 0;\n    z-index: 9999;\n    margin: 0;\n  }\n}\n.cals-icon {\n    font-size: $font-size-50;\n    color: $gray-500;\n}\n.callout {\n  padding: 1.25rem;\n  margin-block-start: 1.25rem;\n  margin-block-end: 1.25rem;\n  background-color: $light;\n  border-inline-start: 0.25rem solid $default-border;\n}\n.callout-info {\n  background-color: rgba($info, 0.075);\n  border-color: rgba($info, 0.5);\n}\n.callout-warning {\n  background-color: rgba($warning, 0.075);\n  border-color: rgba($warning, 0.5);\n}\n.callout-danger {\n  background-color: rgba($danger, 0.075);\n  border-color: rgba($danger, 0.5);\n}\n.btn-facebook {\n  background-color: $facebook;\n  color: $white;\n  border: 1px solid $facebook;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: $facebook !important;\n    color: $white !important;\n    border: 1px solid $facebook !important;\n  }\n}\n.btn-instagram {\n  background: #f09433;\n  background: -moz-linear-gradient(\n    45deg,\n    #f09433 0%,\n    #e6683c 25%,\n    #dc2743 50%,\n    #cc2366 75%,\n    #bc1888 100%\n  );\n  background: -webkit-linear-gradient(\n    45deg,\n    #f09433 0%,\n    #e6683c 25%,\n    #dc2743 50%,\n    #cc2366 75%,\n    #bc1888 100%\n  );\n  background: linear-gradient(\n    45deg,\n    #f09433 0%,\n    #e6683c 25%,\n    #dc2743 50%,\n    #cc2366 75%,\n    #bc1888 100%\n  );\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );\n  color: $white;\n  border: 1px solid transparent;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $white;\n    border: 1px solid transparent;\n  }\n}\n.btn-twitter {\n  background-color: $twitter;\n  color: $white;\n  border: 1px solid $twitter;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: $twitter !important;\n    color: $white !important;\n    border: 1px solid $twitter !important;\n  }\n}\n.btn-icon {\n    width: 2.313rem;\n    height: 2.313rem;\n    font-size: .95rem;\n    flex-shrink: 0;\n}\n.btn-wave {\n    display: inline-block !important;\n}\n\n@media (max-width: 575px) {\n  .overlay-card {\n      .card-text {\n          font-size: .613rem !important;\n      }\n  }\n}\n@media (max-width: 400px) {\n  .overlay-card {\n      .card-text {\n          font-size: .413rem !important;\n      }\n  }\n}",".tooltip {\n  @mixin tooltip-color($color) {\n    .tooltip-inner {\n      background-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"top\"] .tooltip-arrow::before,\n    &.bs-tooltip-top .tooltip-arrow::before {\n      border-top-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"right\"] .tooltip-arrow::before,\n    &.bs-tooltip-end .tooltip-arrow::before {\n      border-right-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"left\"] .tooltip-arrow::before,\n    &.bs-tooltip-start .tooltip-arrow::before {\n      border-left-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"bottom\"] .tooltip-arrow::before,\n    &.bs-tooltip-end .tooltip-arrow::before {\n      border-bottom-color: $color;\n    }\n  }\n  &.tooltip-primary {\n    @include tooltip-color($primary);\n  }\n  &.tooltip-secondary {\n    @include tooltip-color($secondary);\n  }\n  &.tooltip-warning {\n    @include tooltip-color($warning);\n  }\n  &.tooltip-info {\n    @include tooltip-color($info);\n  }\n  &.tooltip-success {\n    @include tooltip-color($success);\n  }\n  &.tooltip-danger {\n    @include tooltip-color($danger);\n  }\n  &.tooltip-dark {\n    @include tooltip-color($dark);\n    .tooltip-inner {\n      color: $white;\n    }\n  }\n  &.tooltip-light {\n    @include tooltip-color($light);\n    .tooltip-inner {\n      color: $text-color;\n    }\n  }\n}\n",".nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n  }\n  .nav-link {\n    color: $text-color;\n    border-radius: $border-radius;\n    font-weight: $font-weight-semibold;\n    &.active {\n      background-color: rgba($primary,0.1);\n      color: $primary;\n    }\n  }\n  .navbar-brand {\n    color: $text-color;\n    &:focus ,&:hover {\n      color: $text-color;\n      opacity: 0.9;\n    }\n  }\n  .navbar-nav .nav-link.active,\n  .navbar-nav .show > .nav-link {\n    color: $primary;\n  }\n  .nav-link.disabled {\n    color: $text-color;\n    opacity: 0.3;\n  }\n  .nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {\n    color: rgba($dark,0.5);\n  }\n  .navbar-text {\n    color: $text-color;\n  }\n  .navbar-dark {\n    &.bg-dark {\n      .nav-link,\n      .navbar-brand {\n        color: $white;\n      }\n    }\n    .navbar-nav .nav-link.active,\n    .navbar-nav .show > .nav-link {\n      color: $white;\n    }\n  }\n  .nav-pills .nav-link.active,\n  .nav-pills .show > .nav-link {\n    color: $white;\n    background-color: $primary;\n  }\n\n.nav.nav-style-1 {\n  border: 0;\n  .nav-item {\n    margin-inline-end: 0.25rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n  }\n  .nav-link {\n    &.active {\n        background-color: rgba($primary, 0.1);\n        color: $primary;\n        &:hover {        \n          background: rgba($primary, 0.1);\n        }\n    }\n    &:hover {        \n        background: transparent;\n        color: $primary;\n    }\n  }\n}\n.nav.nav-style-2 {\n  .nav-item .nav-link {\n    border-block-start: 3px solid transparent;\n    &.active {\n      background-color: rgba($primary, 0.1);\n      border-block-start: 3px solid $primary;\n      color: $primary;\n    }\n  }\n}\n.nav.nav-style-3 {\n  .nav-link {\n    border-radius: 0;\n  }\n  .nav-link {\n    border-block-end: 3px solid transparent;\n  }\n  .nav-link.active {\n    background-color: transparent;\n    border-block-end: 3px solid $primary;\n    color: $primary;\n  }\n}\n.nav.nav-style-4 {\n  border: 0;\n  .nav-link {\n    color: $text-muted;\n    border: 0;\n  }\n  .nav-link {\n    margin-bottom: 3px;\n    &.active {\n      background-color: $light;\n      color: $text-color;\n      border: 0;\n    }\n    &:hover,\n    &:focus {\n      border: 0;\n    }\n    &:hover {\n        background-color: $light;\n        color: $text-color;   \n    }\n  }\n}\n.nav-tabs.nav-style-5 {\n  border: 0;\n  .nav-link {\n    color: $text-muted;\n    border: 0;\n    margin-bottom: 3px;\n  }\n  .nav-link {\n    &.active {\n      background-color: $primary;\n      color: $white;\n      border: 0;\n    }\n    &:hover,\n    &:focus {\n      border: 0;\n      background-color: $primary;\n      color: $white;\n    }\n  }\n}\n.nav-style-6 {\n  border: 0;\n  &.nav-pills .nav-link {\n    &.active {\n      border: 1px solid $primary;\n      border-block-end: 2px solid $primary;\n      background-color: transparent;\n      color: $primary;\n    }\n  }\n}\n.nav-tabs-header {\n  border: 0 !important;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      border: 1px solid transparent;\n      font-size: 0.8rem;\n      padding: 0.4rem 0.5rem;\n      font-weight: $font-weight-medium;\n      &.active {\n        background: rgba($primary, 0.1);\n        color: $primary;\n        border: 1px solid transparent;\n      }\n      &:hover,&:focus {\n        border: 1px solid transparent;\n        background-color: transparent;\n        color: $primary;\n      } \n    }\n  }\n}\n.nav-tabs-footer {\n  border: 0;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      background-color: transparent;\n      color: $primary;\n      border: 1px solid $primary;\n      font-size: 0.8rem;\n      &.active {\n        background: $primary;\n        color: $white;\n        border: 1px solid $primary;\n      }\n      &:hover,&:focus {\n        border: 1px solid $primary;\n        background-color: transparent;\n         color: $primary;\n      } \n    }\n  }\n}\n.vertical-tabs-2 {\n  border: 0;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      min-width: 7.5rem;\n      max-width: 7.5rem;\n      text-align: center;\n      border: 1px solid $default-border;\n      margin-bottom: 0.5rem;\n      color: $text-muted;\n      background-color: $light;\n      i {\n        font-size: 1rem;\n      }\n      &.active {\n        background-color: $primary;\n        color: $white;\n        position: relative;\n        &:before {\n          content: \"\";\n          position: absolute;\n          inset-inline-end: -0.5rem;\n          inset-block-start: 38%;\n          transform: rotate(45deg);\n          width: 1rem;\n          height: 1rem;\n          background-color: $primary;\n        }\n        &:hover {\n          color: $white;\n        }\n      }\n      &:hover {\n        color: $primary;\n      }\n    }\n  }\n}\n.vertical-tabs-3 {\n  border: 0;\n  .nav-item {\n    border: 0;\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      min-width: 160px;\n      max-width: 160px;\n      border: 1px solid $primary;\n      padding: 1.3rem;\n      margin-block-end: 0.5rem;\n      i {\n        width: 2rem;\n        height: 2rem;\n        line-height: 2rem;\n        text-align: center;\n        font-size: 1rem;\n        background: $primary;\n        color: $white;\n        border-radius: 3.125rem;\n        font-weight: $font-weight-medium;\n      }\n      &.active {\n        background: $primary;\n        border: 1px solid $primary;\n        color: $white;\n        &:hover {\n          background: $primary;\n          border: 1px solid $primary;\n          color: $white;          \n        }\n        i {\n          background: $white;\n          color: $primary;\n        }\n      }\n      &:hover,&:focus {\n        border: 1px solid $primary;\n        color: $primary;\n          background: transparent;\n      }\n    }\n  }\n}\n.nav.tab-style-1 {\n  border-block-end: 0;\n  padding: 0.65rem;\n  background-color: $light;\n  border-radius: 7px;\n  margin-block-end: 1rem;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n  }\n  .nav-link {\n    border-radius: 7px;\n    padding: 0.35rem 1rem;\n    &.active {\n      background-color: $primary !important;\n      color: $white !important;\n      box-shadow: $box-shadow;\n      transition: color 0.15s ease-in;\n    }\n  }\n}\n.nav-tabs.tab-style-1 {\n    .nav-link {\n        &:hover {\n        background: transparent;\n        color: $primary;\n      }  \n\n    }\n\n}\n.tab-style-2 {\n  border-block-end: 0;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      border: 0;\n      i { \n        width: 1.875rem;\n        height: 1.875rem;\n        padding: 0.4rem;\n        border-radius: 50px;\n        background-color: $light;\n        color: $text-color;\n        display: inline-block;\n      }\n      &:hover {\n        border: 0;\n        background: transparent;\n        color: $primary;\n        i {\n          color: $primary;          \n        }\n      }\n      &.active {\n        background-color: transparent;\n        position: relative;\n        border: 0;\n        color: $primary;\n        i { \n          background-color: rgba($primary, 0.1);\n          color: $primary;\n        }\n        &:before {\n          content: \"\";\n          position: absolute;\n          inset-inline-start: 0;\n          inset-inline-end: 0;\n          inset-block-end: 0;\n          width: 100%;\n          height: 0.175rem;\n          background-color: $primary;\n          border-radius: 50px;\n        }\n      }\n    }\n  }\n}\n.tab-style-3 {\n  border-block-end: 0;\n  .nav-item {\n    position: relative;\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      position: relative;\n      border: 0;\n      font-size: 0.75rem;\n      &:before {\n        position: absolute;\n        content: \"\";\n        inset-block-end: -1.063rem;\n        inset-inline-end: 0;\n        inset-inline-start: 0;\n        width: 100%;\n        height: 0.1rem;\n        background-color: $light;\n        border-radius: 50%;\n      }\n      &:after {\n        position: absolute;\n        content: \"\";\n        inset-block-end: -2rem;\n        inset-inline-start: 1.75rem;\n        inset-inline-end: 0;\n        inset-inline-start: 30%;\n        width: 2rem;\n        height: 2rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: $white;\n        border-radius: 50%;\n        border: 2px solid $default-border;\n      }\n      &.home:after {\n        content: \"1\";\n      }\n      &.about:after {\n        content: \"2\";\n      }\n      &.services:after {\n        content: \"3\";\n      }\n      &:hover {\n        border: 0;\n        background: transparent;\n        color: $primary;\n      }\n      &.active {\n        background-color: transparent;\n        border: 0;\n        color: $primary;\n        &:before {\n          background-color: $primary;\n        }\n        &:after {\n          border-color: $primary;\n          color: $primary;\n        }\n      }\n    }\n  }\n}\n.tab-style-4 {\n  &.nav-tabs {\n    border: 0;\n    .nav-item {\n      margin-inline-end: 0.5rem;\n      &:last-child {\n        margin-inline-end: 0;\n      }\n    }\n    .nav-link {\n      border: 0;\n      &:hover {\n        border: 0;\n        background: transparent;\n        color: $primary;\n      }\n      &.active {\n        background-color: transparent;\n        border: 0;\n        color: $primary;\n        position: relative;\n        overflow: hidden;\n        &::before {\n          position: absolute;\n          content: \"\";\n          width: 0.75rem;\n          inset-block-start: 31px;\n          transform: rotate(45deg);\n          inset-inline-start: 47%;\n          overflow: hidden;\n          z-index: 1;\n          height: 0.75rem;\n          background-color: $primary;\n          border: 1px solid $primary;\n        }\n        &:after {\n          position: absolute;\n          content: \"\";\n          width: 40%;\n          height: 1px;\n          inset-inline-start: 30%;\n          inset-block-end: 0;\n          background-color: $primary;\n        }\n      }\n    }\n  }\n}\n#tab-style-4 .tab-pane.active {\n  border: 1px solid $primary;\n  background-color: $primary;\n  color: $white;\n  padding: 16px;\n    border-radius: 7px;\n}\n.tab-style-5 {\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link.active {\n      background: $primary;\n    }\n  }\n}\n.tab-style-6 {\n  border: 0;\n  background-color: $white;\n  border-radius: 7px;\n  color: $primary;\n  padding: 0.5rem;\n  .nav-item {\n    border: 0;\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      color: $primary;\n      padding: 0.5rem 1rem;\n      font-size: 0.813rem;\n      border: 0;\n      font-weight: $font-weight-medium;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      align-items: center;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      &.active {\n        border: 0;\n        background-color: $primary;\n        color: $white;\n        border: 0;\n        box-shadow: 0px 3px 10px 0px rgba(var(--dark-rgb),0.05);\n      }\n      &:hover,\n      &:focus {\n        border: 0;\n      }\n    }\n  }\n}\n.tab-style-7 {\n  .nav-link {\n    margin-block-end: 0.5rem;\n    font-size: 0.813rem;\n    color: $text-muted;\n    text-align: left;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    &:active,\n    &.active {\n      background-color: rgba($primary, 0.1);\n      color: $primary;\n    }\n  }\n}\n.nav-style-1 {\n  .nav-item {\n    .nav-link {\n      &.active {\n        background-color: rgba($primary, 0.1);\n        color: $primary;\n      }\n    }\n  }\n}\n@media screen and (max-width:400px) {\n  .tab-style-4 {\n    .nav-link{\n      padding-inline: 0.5rem;\n    }\n  }\n}\n\n.nav-tabs {\n    border-bottom: 0;\n    &.nav-tabs-bottom {\n        li {\n            margin-bottom: -1px;\n        }\n    }\n    .nav-link {\n        margin-bottom: -1px;\n        background: 0 0;\n        border: 1px solid transparent;\n        border-top-left-radius: 0.25rem;\n        border-top-right-radius: 0.25rem;\n        &.active {\n          border-color: $gray-300;\n        }\n    }\n    li{\n        a{\n            color: $gray-600;\n            border-bottom-width: 2px;\n            &.active{\n                border-color: transparent;\n                border-bottom-color: $primary;\n                background-color: transparent;\n                @include transition(all 0.2s ease);\n            }\n        }\n    }\n}\n.nav-tabs{\n    .nav-tabs-solid {\n        background-color: $white;\n        border: 0;\n        .active{\n            background-color: $primary;\n            border-color: $primary;\n            color: $white;\n        }\n    }\n}\n.nav-tabs{\n    .nav-link{\n        &:hover{\n            border-color: transparent;\n            color: $primary;\n        }\n    }\n    &.nav-tabs-top{\n        li{\n            a{\n                border-width: 2px 0 0 0;\n                &.active{\n                    border-top-color: $primary;                    \n                    @include rounded(0);\n                }\n                &:hover {\n                    border-top-color: $primary;  \n                    background-color: transparent;                    \n                    @include rounded(0);\n                }\n            }\n        }\n    }\n    &.nav-tabs-bottom{\n        li{\n            a{\n                border-width:0 0 2px  0;\n                &.active, &:hover {\n                    border-bottom-color: $primary;\n                    background: transparent;\n                    @include rounded(0);\n                }\n            }\n        }\n    }\n    &.nav-tabs-solid{\n        background-color: $white;\n        border: 0;\n        &.nav-tabs-rounded{\n            li{\n                a{\n                    &.active {\n                        background-color: $primary;\n                        border-color: $primary;\n                        color: $white;\n                        @include rounded(50px);\n                    }\n                }\n            }  \n        }\n        li{\n            a{\n                &.active{\n                    background-color: $primary;\n                    border-color: $primary;\n                    color: $white;\n                    @include rounded(0);\n                }\n            }\n        }   \n    }\n}\n.nav-link{\n    &:hover{\n        color: $primary;\n    }\n}\n.page-menu{\n    .nav-tabs {\n        li{\n            a{\n                font-size: $font-size-16;\n            }\n        }\n    }\n}\n.tabs-set{\n    .nav-tabs {\n        border-bottom: 0;\n        margin-bottom: 20px;\n        .nav-link{\n            color: $secondary;\n            @include margin-padding(null, 8px 15px);\n            font-size: $font-size-16;\n            font-weight: $font-weight-bold;\n            border: 0;\n            min-width: 120px;\n            margin-right: 10px;\n            border-radius: 8px;\n            background: var(--Stroke, rgba(145, 158, 171, 0.30));\n            @include margin-padding(null, null);\n            &:focus{\n                border-color: transparent;\n            }\n            &:hover{\n                border-color: transparent;\n            }\n            &.active{\n                border:0;\n                border-bottom:2px solid $primary;\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n.tabs-sets{\n    .nav-tabs {\n        border-bottom: 0;\n        @include margin-padding(0 0 40px, null);\n        .nav-link{\n            color: $black;;\n            font-size: $font-size-base;\n            font-weight: $font-weight-bold;\n            border: 0;\n            background: $gray-300;\n            margin-right:10px;\n            @include margin-padding(null, 8px 15px);\n            @include rounded(8px);\n            @include transition(all 0.5s ease);\n            &:focus, &:hover, &.active{\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n@include respond-below(custom768) {\n    .nav-tabs {\n        border-bottom: 0;\n        position: relative;\n        background-color: $white;\n        @include margin-padding(null, 5px 0);\n        @include rounded(3px);\n    }\n}",".ribbon1 {\n  position: absolute;\n  inset-block-start: -6.1px;\n  inset-inline-end: 10px;\n  color: $white;\n  z-index: 1;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 20px solid transparent;\n    border-inline-end: 24px solid transparent;\n    border-block-start: 13px solid $danger;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: $font-size-14;\n    line-height: 1;\n    padding: 12px 8px 10px;\n    border-start-end-radius: 8px;\n    &:before,\n    &:after {\n      position: absolute;\n      content: \"\";\n    }\n    &:before {\n      height: 6px;\n      width: 6px;\n      inset-inline-start: -6px;\n      inset-block-start: 0;\n      background: $danger;\n    }\n    &:after {\n      height: 6px;\n      width: 8px;\n      inset-inline-start: -8px;\n      inset-block-start: 0;\n      border-radius: 8px 8px 0 0;\n      background: $danger;\n    }\n  }\n}\n.ribbone {\n  width: 100%;\n  position: relative;\n  background-size: cover;\n  text-transform: uppercase;\n  color: $white;\n  width: 150px;\n  height: 150px;\n  overflow: hidden;\n  position: absolute;\n  z-index: 6;\n  &::after {\n    position: absolute;\n    z-index: -1;\n    content: \"\";\n    display: block;\n    border: 5px solid;\n  }\n  &::before {\n    position: absolute;\n    z-index: -1;\n    content: \"\";\n    display: block;\n    border: 5px solid;\n  }\n  span {\n    position: absolute;\n    display: block;\n    width: 225px;\n    padding: 3px 0;\n    box-shadow: 0 5px 10px rgba(0,0,0, 0.1);\n    color: $white;\n    text-shadow: 0 1px 1px rgba(0,0,0, 0.1);\n    text-transform: capitalize;\n    text-align: center;\n    font-size: 11px;\n  }\n}\n.ribbone1 {\n  position: absolute;\n  inset-block-start: -6.1px;\n  inset-inline-start: 10px;\n  z-index: 1;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 20px solid transparent;\n    border-inline-end: 24px solid transparent;\n    border-block-start: 13px solid $danger;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: $font-size-14;\n    line-height: 1;\n    padding: 12px 8px 10px;\n    border-start-end-radius: 8px;\n    &:after {\n      position: absolute;\n      content: \"\";\n      height: 6px;\n      width: 8px;\n      inset-inline-start: -8px;\n      inset-block-start: 0;\n      border-radius: 8px 8px 0 0;\n      background: $danger;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 6px;\n      width: 6px;\n      inset-inline-start: -6px;\n      inset-block-start: 0;\n      background: $danger;\n    }\n  }\n}\n.arrow-ribbone-left {\n  color: $white;\n  padding: 2px 8px;\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-start: 0;\n  z-index: 6;\n  font-size: 13px;\n}\n.arrow-ribbone-left.bg-purple {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $purple;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-danger {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 112px solid transparent;\n    border-inline-start: 12px solid $danger;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-primary {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-secondary {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $secondary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-success {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $primary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-info {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $info;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-warning {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $warning;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-pink {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $pink;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-teal {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $teal;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right {\n  color: $white;\n  padding: 2px 8px;\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-end: 0;\n  z-index: 6;\n  font-size: 13px;\n}\n.arrow-ribbone-right.bg-purple {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $purple;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-danger {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $danger;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-primary {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-secondary {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $secondary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-success {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $primary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-info {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $info;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-warning {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $warning;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-pink {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $pink;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-teal {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $teal;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone2 {\n  color: $white;\n  padding: 3px 8px;\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-start: -1px;\n  z-index: 6;\n  font-size: $font-size-30;\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -24px;\n    border-block-start: 24px solid transparent;\n    border-block-end: 24px solid transparent;\n    width: 0;\n  }\n}\n.power-ribbone {\n  width: 56px;\n  height: 56px;\n  overflow: hidden;\n  position: absolute;\n  z-index: 6;\n  span {\n    position: absolute;\n    display: block;\n    width: 82px;\n    padding: 8px 0;\n    color: $white;\n    font: 500 16px/1 Lato, sans-serif;\n    text-shadow: 0 1px 1px rgba(0,0,0, 0.1);\n    text-transform: capitalize;\n    text-align: center;\n  }\n}\n.power-ribbone-top-left {\n  inset-block-start: -6px;\n  inset-inline-start: -9px;\n  span {\n    inset-inline-end: -5px;\n    inset-block-start: 1px;\n    transform: rotate(-45deg);\n    i {\n      transform: rotate(45deg);\n      padding-block-start: 2px;\n      padding-inline-start: 7px;\n    }\n  }\n}\n.power-ribbone-bottom-left {\n  inset-block-end: -6px;\n  inset-inline-start: -9px;\n  span {\n    inset-inline-end: -5px;\n    inset-block-end: 1px;\n    transform: rotate(45deg);\n    i {\n      transform: rotate(-45deg);\n      padding-block-end: 2px;\n      padding-inline-start: 7px;\n    }\n  }\n}\n.power-ribbone-top-right {\n  inset-block-start: -6px;\n  inset-inline-end: -9px;\n  span {\n    inset-inline-start: -5px;\n    inset-block-start: 1px;\n    transform: rotate(45deg);\n    i {\n      transform: rotate(-45deg);\n      padding-block-start: 2px;\n      padding-inline-end: 7px;\n    }\n  }\n}\n.power-ribbone-bottom-right {\n  inset-block-end: -6px;\n  inset-inline-end: -9px;\n  span {\n    inset-inline-start: -5px;\n    inset-block-end: 1px;\n    transform: rotate(-45deg);\n    i {\n      transform: rotate(45deg);\n      padding-block-end: 2px;\n      padding-inline-end: 7px;\n    }\n  }\n}\n.ribbone-top-left {\n  inset-block-start: -10px;\n  inset-inline-start: -10px;\n  &::after {\n    border-block-start-color: transparent;\n    border-inline-start-color: transparent;\n    inset-block-end: 50px;\n    inset-inline-start: 0;\n  }\n  &::before {\n    border-block-start-color: transparent;\n    border-inline-start-color: transparent;\n    inset-block-start: 0;\n    inset-inline-end: 50px;\n  }\n  span {\n    inset-inline-end: 0px;\n    inset-block-start: 24px;\n    transform: rotate(-45deg);\n  }\n}\n.ribbone-top-right {\n  inset-block-start: -10px;\n  inset-inline-end: -10px;\n  &::after {\n    border-block-start-color: transparent;\n    border-inline-end-color: transparent;\n    inset-block-end: 50px;\n    inset-inline-end: 0;\n  }\n  &::before {\n    border-block-start-color: transparent;\n    border-inline-end-color: transparent;\n    inset-block-start: 0;\n    inset-inline-start: 50px;\n  }\n  span {\n    inset-inline-start: 0px;\n    inset-block-start: 24px;\n    transform: rotate(45deg);\n  }\n}\n.ribbone-warning-right {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-end: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $warning;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $warning;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-end-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $warning;\n      height: 6px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 50px;\n      border-start-end-radius: 0;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 3px;\n      background: $warning;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-danger-right {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-end: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $danger;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-end-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $danger;\n      height: 6px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 50px;\n      border-start-end-radius: 0;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 3px;\n      background: $danger;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-success-left {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $success;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $success;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-start-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $success;\n      height: 6px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 0;\n      border-start-end-radius: 50px;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 3px;\n      background: $success;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-info-left {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $info;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $info;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-start-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $info;\n      height: 6px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 0;\n      border-start-end-radius: 50px;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 3px;\n      background: $info;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-ribbone-success-left {\n  position: absolute;\n  inset-inline-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-inline-start: 0;\n    border-inline-start: 18px solid $success;\n    border-inline-end: 18px solid $success;\n    border-block-end: 10px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $success;\n    font-size: 13px;\n    line-height: 1;\n    padding: 12px 3px 20px;\n    z-index: 6;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-ribbone-danger-left {\n  position: absolute;\n  inset-inline-start: 10px;\n  color: $white;\n  width: 30px;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-inline-start: 0;\n    border-inline-start: 15px solid $danger;\n    border-inline-end: 15px solid $danger;\n    border-block-end: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: 12px;\n    line-height: 1;\n    padding: 12px 0px;\n    z-index: 6;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-ribbone-secondary-right {\n  position: absolute;\n  inset-inline-end: 10px;\n  color: $white;\n  width: 30px;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-inline-end: 0;\n    border-inline-start: 15px solid $secondary;\n    border-inline-end: 15px solid $secondary;\n    border-block-end: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $secondary;\n    font-size: 11px;\n    line-height: 1;\n    padding: 12px 0px;\n    z-index: 6;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-sideleft-ribbone-success-left {\n  position: absolute;\n  inset-block-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-block-start: 0;\n    inset-inline-end: -8px;\n    border-block-start: 13px solid $success;\n    border-block-end: 13px solid $success;\n    border-inline-end: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $success;\n    font-size: 11px;\n    padding: 5px 13px;\n    z-index: 6;\n    height: 26px;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-sideright-ribbone-primary-right {\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-end: 0;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-block-start: 0;\n    inset-inline-start: -8px;\n    border-block-start: 13px solid $primary;\n    border-block-end: 13px solid $primary;\n    border-inline-start: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $primary;\n    font-size: 11px;\n    padding: 5px 13px;\n    z-index: 6;\n    height: 26px;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-1 {\n  span {\n    &:after {\n      position: absolute;\n      content: \"\";\n    }\n  }\n}\n.arrow-ribbone-2 {\n  color: $white;\n  padding: 3px 8px;\n  position: absolute;\n  z-index: 6;\n  font-size: $font-size-20;\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -24px;\n    border-block-start: 16px solid transparent;\n    border-inline-start: 24px solid $purple;\n    border-block-end: 16px solid transparent;\n    width: 0;\n  }\n}\n.ribbone-card {\n  overflow: hidden;\n}\n.fullwidth-primary-ribbons {\n  .bar {\n    color: $white;\n    background-color: $primary;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-color: $primary $primary $primary transparent;\n        border-block-start-color: $primary;\n        border-inline-end-color: $primary;\n        border-block-end-color: $primary;\n        border-inline-start-color: transparent;\n        inset-inline-start: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $primary;\n        border-inline-end-color: transparent;\n        border-block-end-color: $primary;\n        border-inline-start-color: $primary;\n        inset-inline-end: -30px;\n      }\n    }\n  }\n}\n.fullwidth-secondary-ribbons {\n  .bar {\n    color: $white;\n    background-color: $secondary;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $secondary;\n        border-inline-end-color: $secondary;\n        border-block-end-color: $secondary;\n        border-inline-start-color: transparent;\n        inset-inline-start: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $secondary;\n        border-inline-end-color: transparent;\n        border-block-end-color: $secondary;\n        border-inline-start-color: $secondary;\n        inset-inline-end: -30px;\n      }\n    }\n  }\n}\n.fullwidth-arrow-warning-ribbons {\n  .bar {\n    color: $white;\n    background-color: $warning;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $warning;\n        border-inline-end-color: $warning;\n        border-block-end-color: $warning;\n        border-inline-start-color: transparent;\n        inset-inline-start: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start: 18px solid transparent;\n        border-inline-start: 18px solid $warning;\n        border-block-end: 18px solid transparent;\n        border-inline-end: transparent;\n        inset-inline-end: -20px;\n        inset-block-start: -2px;\n      }\n    }\n  }\n}\n.fullwidth-arrow-danger-ribbons-right {\n  .bar {\n    color: $white;\n    background-color: $danger;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $danger;\n        border-inline-end-color: transparent;\n        border-block-end-color: $danger;\n        border-inline-start-color: $danger;\n        inset-inline-end: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start: 18px solid transparent;\n        border-inline-end: 18px solid $danger;\n        border-block-end: 18px solid transparent;\n        border-inline-start: transparent;\n        inset-inline-start: -20px;\n        inset-block-start: -2px;\n      }\n    }\n  }\n}\n.power-ribbone {\n  span {\n    svg {\n      width: 15px;\n      height: 15px;\n    }\n  }\n}\n.ribbone-card {\n  .card-body {\n    padding: 25px;\n  }\n}\n.ribbone-row {\n  .feather-zap {\n    width: 15px;\n    height: 15px;\n  }\n}\n[data-bs-toggle=\"card-fullscreen\"] {\n  svg {\n    width: 15px;\n    height: 15px;\n  }\n} \n[data-bs-toggle=\"card-remove\"] {\n  svg {\n    width: 15px;\n    height: 15px;\n  }\n} \nsvg {\n  &.collapse-open,&.collapse-close {\n    width: 15px;\n    height: 15px;\n  }\n}\n.btn-icon {\n  &.btn-danger-light {\n    color: $danger-900;\n    background: $danger-100;\n  }\n}\n.live-rating {\n  &.badge {\n    background: $success-200;\n    color: $success-900;\n  }\n}\n@media (min-width: 576px) {\n  .mx-sm-7 {\n    margin-inline: 3rem !important;\n  }\n}\n[dir=\"rtl\"] {\n  .power-ribbone-top-left span {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-top-left span i {\n    transform: rotate(-45deg);\n  }\n\n  .power-ribbone-bottom-left span {\n    transform: rotate(-45deg);\n  }\n\n  .power-ribbone-bottom-left span i {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-top-right span {\n    transform: rotate(-45deg);\n  }\n\n  .power-ribbone-top-right span i {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-bottom-right span {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-bottom-right span i {\n    transform: rotate(-45deg);\n  }\n\n  .ribbone-top-left span {\n    transform: rotate(45deg);\n  }\n\n  .ribbone-top-right span {\n    transform: rotate(-45deg);\n  }\n\n  .ribbon-price .badge {\n    transform: rotate(-45deg);\n  }\n}\n",".modal-barcode {\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        li {\n            @include rounded(7px);\n            width: 25%;\n            margin-bottom: 10px;\n            padding: 0 5px;\n            @include respond-below(custom991) {\n                width: 50%;\n            }\n            a {\n                border: 1px solid $gray-400;\n                @include rounded(10px);\n                display: block;\n                padding: 10px;\n                text-align: center;\n            }\n        }\n    }\n}\n\n.modal {\n    .modal-content {\n        border: 1px solid $light-900;\n        box-shadow: 0px 4px 74px 0px #D0D0D040;\n        border-radius: 5px;\n    }\n    .modal-title {\n        font-weight: $font-weight-bold;\n        @include respond-below(custom991) {\n            font-size: $font-size-16;\n        }\n    }\n\t.logo-lg {\n\t\timg {\n\t\t\twidth: 150px;\n\t\t}\n\t}\n    .modal-header {\n        border-color: $light-900;        \n        border-bottom: 1px solid $light-900;\n        justify-content: space-between;\n        .close,\n        .btn-close {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            color: $danger-700;\n            opacity: 1;\n            font-size: $font-size-12;\n            width: 22px;\n            height: 22px;\n            border: 0;\n            font-weight: $font-weight-bold;\n            background-color: transparent;\n            @include rounded(50px);\n            &:hover{\n                background-color: transparent;\n                color:$white;\n            }\n        }\n    }\n    .modal-footer{\n        .btn-print {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $primary;\n            color: $primary;\n            img{\n                margin-left: 10px;\n            }\n            &:hover{\n                background: $primary;\n                color: $white;\n                img{\n                    filter: brightness(0) invert(1);\n                }\n            }\n        }\n        .btn-secondary{\n            background: $secondary;\n            &:hover{\n                @include box-shadow(inset, 0, 0px, 0px, 100px, $white);\n                color: $secondary !important;\n            }\n        }\n    }\n    \n    .modal-dialog.right-slider-modal {\n        margin: 0;\n        margin-left: auto;\n        max-width: 1102px;\n    }\n    \n    .modal-dialog.add-centered {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        max-width: 1192px;\n    }\n    .modal-dialog.sales-details-modal {\n        max-width: 1192px;\n    }\n    .modal-dialog.edit-sales-modal {\n        max-width: 1192px;\n    }\n    .edit-add.card.edit-expense {\n        border: 1px solid rgba(0,0,0,.2);\n    }\n    .note-editor.note-frame.card {\n        border: 1px solid rgba(0,0,0,.2) !important; \n    }\n}\n.offcanvas.offcanvas-end {\n    width: auto !important;\n}\n.offcanvas.offcanvas-end.em-payrol-add {\n    max-width: 1192px !important;\n}\n\n.modal {\n    &.animated .modal-dialog {\n        transform: translate(0, 0);\n    }\n    &.effect-scale {\n        .modal-dialog {\n            transform: scale(0.7);\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: scale(1);\n            opacity: 1;\n        }\n    }\n    &.effect-slide-in-right {\n        .modal-dialog {\n            transform: translateX(20%);\n            opacity: 0;\n            transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);\n        }\n        &.show .modal-dialog {\n            transform: translateX(0);\n            opacity: 1;\n        }\n    }\n    &.effect-slide-in-bottom {\n        .modal-dialog {\n            transform: translateY(20%);\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: translateY(0);\n            opacity: 1;\n        }\n    }\n    &.effect-newspaper {\n        .modal-dialog {\n            transform: scale(0) rotate(720deg);\n            opacity: 0;\n        }\n        &.show~.modal-backdrop, .modal-dialog {\n            transition: all 0.5s;\n        }\n        &.show .modal-dialog {\n            transform: scale(1) rotate(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-fall {\n        -webkit-perspective: 1300px;\n        -moz-perspective: 1300px;\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: translateZ(600px) rotateX(20deg);\n            opacity: 0;\n        }\n        &.show .modal-dialog {\n            transition: all 0.3s ease-in;\n            transform: translateZ(0px) rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-flip-horizontal {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: rotateY(-70deg);\n            transition: all 0.3s;\n            opacity: 0;\n        }\n        &.show .modal-dialog {\n            transform: rotateY(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-flip-vertical {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: rotateX(-70deg);\n            transition: all 0.3s;\n            opacity: 0;\n        }\n        &.show .modal-dialog {\n            transform: rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-super-scaled {\n        .modal-dialog {\n            transform: scale(2);\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: scale(1);\n            opacity: 1;\n        }\n    }\n    &.effect-sign {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: rotateX(-60deg);\n            transform-origin: 50% 0;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-rotate-bottom {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: translateY(100%) rotateX(90deg);\n            transform-origin: 0 100%;\n            opacity: 0;\n            transition: all 0.3s ease-out;\n        }\n        &.show .modal-dialog {\n            transform: translateY(0%) rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-rotate-left {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: translateZ(100px) translateX(-30%) rotateY(90deg);\n            transform-origin: 0 100%;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: translateZ(0px) translateX(0%) rotateY(0deg);\n            opacity: 1;\n        }\n    }\n}\n.offcanvas-end.offcanvas-large {\n    width: 700px !important;\n}\n.modal {\n    z-index: 1050 !important;\n}\n.modal-backdrop {\n    z-index: 1001 !important;\n}\n.status-toggle {\n    &.small-toggle-btn {\n        float: unset;\n        .label-text {\n            color: $text-color;\n            font-size: $font-size-14;\n            font-weight: $font-weight-normal;\n        }\n        .checktoggle {\n            width: 24px;\n            height: 12px;\n            &:after {\n                width: 8px;\n                height: 8px;\n            }\n        }\n        .check {\n            &:checked{\n                & + .checktoggle {\n                    &:after {\n                        right: 0;\n                        width: 8px;\n                        height: 8px;\n                    }\n                }\n            }\n           \n        }\n    }\n    .check {\n        display: block;\n        height: 0;\n        visibility: hidden;\n        opacity: 0;\n        pointer-events: none;\n        position: absolute;\n        margin: 0;\n        padding: 0;\n        &:checked + .checktoggle:after {\n            left: 100%;\n            transform: translate(calc(-100% - 3px), -50%);\n             right: 0;\n            width: 10px;\n            height: 10px;\n        }\n        &:checked + .checktoggle {\n            background: #1ABE17;\n        }\n    }\n   .checktoggle {\n        background: #CDCDCD;\n        cursor: pointer;\n        display: block;\n        font-size: 0;\n        margin-bottom: 0;\n        position: relative;\n        border-radius: 12px;\n        width: 30px;\n        height: 14px;\n        &:after {\n            content: \" \";\n            display: block;\n            width: 10px;\n            height: 10px;\n            background-color: #FFF;\n            -webkit-transition: all 0.2s ease;\n            -ms-transition: all 0.2s ease;\n            transition: all 0.2s ease;\n            transform: translate(3px, -50%);\n            -webkit-transform: translate(3px, -50%);\n            -ms-transform: translate(3px, -50%);\n            position: absolute;\n            top: 50%;\n            left: 0;\n            border-radius: 50%;\n        }\n    }\n}\n.modal-btn {\n    .btn {\n        @include margin-padding(0 10px 0 0, 7px 15px);\n        &:last-child {\n            margin-right: 0;\n        }\n    } \n}\n.custom-modal {\n    .modal-header {        \n        .btn-close {\n            @include margin-padding(0, 0);\n            background: $white;\n            border: 1px solid $light-900;\n            border-radius: 50%;\n            color: $gray-400;\n            font-weight: $font-weight-normal;\n            font-size: $font-size-14;\n            box-shadow: 0px 4px 4px 0px #DBDBDB40;\n            height: 26px;\n            width: 26px;\n            display: flex;\n            display: -webkit-flex;\n            align-items: center;\n            -webkit-align-items: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -webkit-transition: all 0.7s;\n            -moz-transition: all 0.7s;\n            -o-transition: all 0.7s;\n            transition: all 0.7s;\n            &:hover {\n                border: 1px solid $primary;\n                background: $primary;\n                color: $white;\n                -webkit-transition: all 0.7s;\n                -moz-transition: all 0.7s;\n                -o-transition: all 0.7s;\n                transition: all 0.7s;\n                -webkit-transform: rotateZ(360deg);\n                -moz-transform: rotateZ(360deg);\n                transform: rotateZ(360deg);\n            }    \n        }\n    }\n\n}",".grid-showcase {\n  margin-bottom: -10px;\n  span, .grid-wrapper {\n    display: block;\n    padding: 10px;\n    margin-bottom: 10px;\n    text-align: center;\n    background-color: rgba(242, 243, 247, 0.7);\n  }\n}\n.grid-align {\n  margin-bottom: -16px;\n}\n.grid-align .row {\n  padding: 15px 0;\n  min-height: 7rem;\n  margin-bottom: 16px;\n}\n.grid-vertical {\n  min-height: 150px;\n  padding: 10px;\n  color: $black;\n}\ntable.table-bordered thead tr th p {\n  margin-bottom: 0;\n}","body {\n\tfont-family: $font-family-primary;\n\tfont-size: $font-size-14;\n\tcolor: $text-color;\n\tline-height: 1.5;\n\tbackground-color: $body-bg;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n}\nhtml{\n\tfont-family: $font-family-primary;\t\n}\n::selection {\n  background: $primary;\n  color: $white;\n  text-shadow: none;\n}\nimg {\n\tmax-width: 100%;\n\theight: auto;\n\tvertical-align: inherit;\n}\n*{\n\toutline: none;\n}\nbutton {\n\t@include transition(all 0.5s ease);\n\t&:focus {\n\t\tbox-shadow: none !important;\n\t}\n}\np {\n\tmargin-bottom:20px;\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\nstrong {\n\tfont-weight: $font-weight-bold;\n}\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n  \tcolor: $title-color;\n  \tfont-family: $font-family-primary;\n\tfont-weight: $font-weight-bold;\n  \tmargin-bottom: 0;\n}\nol, ul {\n  list-style: none;\n  margin-block-end: 0;\n  padding: 0;\n}\nul {\n  list-style: none;\n\t&.list-disc {\n\t  list-style: disc;\n\t  padding-left: 15px;\n\t  ul {\n\t    list-style-type: circle;\n\t  }\n\t}\n\t&.list-decimal {\n\t  list-style: decimal;\n\t  padding-left: 15px;\n\t  ul{\n\t    list-style-type: decimal;\n\t  }\n\t}\n\t&.list-icon {\n\t  list-style: none;\n\t  padding-left: 0;\n\t  > li {\n\t    padding-left: 1.875rem;\n\t    counter-increment: li;\n\t    i,\n\t    .feather-icon,\n\t    .svg-icon {\n\t      display: inline-block;\n\t      height: 20px;\n\t      width: 20px;\n\t      text-align: center;\n\t      margin-left: -1.25rem;\n\t      position: relative;\n\t      left: -10px;\n\t      padding: 1px;\n\t      top: -1px;\n\t      \n\t    }\n\t    i {\n\t      font-size: $font-size-20;\n\t      top: 5px;\n\t    }\n\t  }\n\t}\n\t.btn {\n\t  &-primary {\n\t      &:not(:disabled):not(.disabled) {\n\t          &:active,\n\t          &.active {\n\t              &:focus {\n\t                  box-shadow: none;\n\t              \t}\n\t          \t}\n\t      \t}\n\t  \t}\n\t}\n}\n",".bg-primary {\n    background-color: $primary !important;\n}\n.bg-secondary {\n    background-color: $secondary !important;\n}\n.bg-info {\n    background-color: $info !important;\n}\n.bg-success {\n    background-color: $success !important;\n    color: $white !important;\n}\n.bg-warning {\n    background-color: $warning !important;\n    color: $white !important;\n}\n.bg-danger {\n    background-color: $danger !important;\n    color: $white !important;\n}\n.bg-dark {\n    background-color: $dark !important;\n}\n.bg-light {\n    background-color: $light !important;\n}\n.bg-light-300 {\n    background-color: $light-300 !important;\n}\n.bg-light-400 {\n    background: $light-400;\n}\n.bg-light-600 {\n    background-color: $light-600 !important;\n}\n.bg-white {\n    background-color: $white !important;\n}\n.bg-pink {\n    background-color: $pink !important;\n}\n.bg-purple {\n    background-color: $purple !important;\n}\n.bg-teal {\n    background-color: $teal !important;\n}\n.bg-blue {\n    background-color: $blue !important;\n}\n.bg-tertiary {\n    background-color: $tertiary !important;\n}\n.bg-violet {\n    background-color: $violet !important;\n}\n.bg-green {\n    background-color: $green !important;\n}\n.bg-gray {\n    background: $background-3;\n}\n.bg-primary {\n    background-color: $primary !important;\n    &.bg-opacity-10 {\n        background-color: rgba($primary,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($primary,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($primary,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($primary,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($primary,1) !important;\n    }\n}\n.bg-secondary {\n    background-color: $secondary !important;\n    &.bg-opacity-10 {\n        background-color: rgba($secondary,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($secondary,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($secondary,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($secondary,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($secondary,1) !important;\n    }\n}\n.bg-info {\n    background-color: $info !important;\n    &.bg-opacity-10 {\n        background-color: rgba($info,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($info,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($info,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($info,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($info,1) !important;\n    }\n}\n.bg-success {\n    background-color: $success !important;\n    &.bg-opacity-10 {\n        background-color: rgba($success,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($success,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($success,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($success,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($success,1) !important;\n    }\n}\n.bg-warning {\n    background-color: $warning !important;\n    &.bg-opacity-10 {\n        background-color: rgba($warning,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($warning,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($warning,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($warning,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($warning,1) !important;\n    }\n}\n.bg-danger {\n    background-color: $danger !important;\n    &.bg-opacity-10 {\n        background-color: rgba($danger,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($danger,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($danger,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($danger,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($danger,1) !important;\n    }\n}\n.bg-dark {\n    background-color: $dark !important;\n    &.bg-opacity-10 {\n        background-color: rgba($dark,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($dark,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($dark,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($dark,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($dark,1) !important;\n    }\n}\n.bg-light {\n    background-color: $light !important;\n    &.bg-opacity-10 {\n        background-color: rgba($light,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($light,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($light,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($light,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($light,1) !important;\n    }\n}\n@each $color,\n$value in $theme-colors {\n    .bg-#{$color} {\n        background-color: #{$value} !important;\n        border: 1px solid #{$value} !important;\n        color: $white;\n    }\n}\n.bg-soft-primary {\n    background-color: $primary-300;\n    color: $primary;\n}\n.bg-soft-secondary {\n    background-color: $secondary-300;\n    color: $secondary;\n}\n.bg-soft-success {\n    background-color: $success-300;\n    color: $success;\n}\n.bg-soft-danger {\n    background-color: $danger-300;\n    color: $danger;\n}\n.bg-soft-warning {\n    background-color: $warning-300;\n    color: $warning;\n}\n.bg-soft-info {\n    background-color: rgba($info, 0.3);\n    color: $info;\n}\n.bg-soft-light {\n    background-color: rgba($light, 0.9);\n    color: $text-color;\n}\n.bg-soft-dark {\n    background-color: rgba($dark, 0.3);\n    color: $white;\n}\n.bg-light {\n  color: $text-color;\n}\n\n.bg-primary-gradient {\n  background: $primary-gradient !important;\n  color: $white;\n}\n.bg-secondary-gradient {\n  background: $secondary-gradient !important;\n  color: $white;\n}\n.bg-warning-gradient {\n  background: $warning-gradient !important;\n  color: $white;\n}\n.bg-info-gradient {\n  background: $info-gradient !important;\n  color: $white;\n}\n.bg-success-gradient {\n  background: $success-gradient !important;\n  color: $white;\n}\n.bg-danger-gradient {\n  background: $danger-gradient !important;\n  color: $white;\n}\n.bg-orange-gradient {\n  background: $orange-gradient !important;\n  color: $white;\n}\n.bg-purple-gradient {\n  background: $purple-gradient !important;\n  color: $white;\n}\n.bg-teal-gradient {\n  background: $teal-gradient !important;\n  color: $white;\n}\n.bg-light-gradient {\n  background: $light-gradient !important;\n  color: $black;\n}\n.bg-dark-gradient {\n  background: $dark-gradient !important;\n  color: $white;\n}\n.bg-outline-primary {\n  background-color: $white;\n  border: 1px solid $primary;\n  color: $primary;\n}\n.bg-outline-secondary {\n  background-color: $white;\n  border: 1px solid $secondary;\n  color: $secondary;\n}\n.bg-outline-warning {\n  background-color: $white;\n  border: 1px solid $warning;\n  color: $warning;\n}\n.bg-outline-info {\n  background-color: $white;\n  border: 1px solid $info;\n  color: $info;\n}\n.bg-outline-success {\n  background-color: $white;\n  border: 1px solid $success;\n  color: $success;\n}\n.bg-outline-danger {\n  background-color: $white;\n  border: 1px solid $danger;\n  color: $danger;\n}\n.bg-outline-dark {\n  background-color: $white;\n  border: 1px solid $dark;\n  color: $dark;\n}\n.bg-outline-light {\n  background-color: $white;\n  border: 1px solid $light !important;\n  color: $black !important;\n}\n.bg-primary-transparent {\n    background-color: rgba($primary, 0.1) !important;\n    color: $primary !important;\n    &:hover {\n        background-color: rgba($primary, 0.1) !important;\n        color: $primary !important;\n    }\n}\n.bg-secondary-transparent {\n    background-color: rgba($secondary, 0.1) !important;\n    color: $secondary !important;\n    &:hover {\n        background-color: rgba($secondary, 0.1) !important;\n        color: $secondary !important;\n    }\n}\n.bg-info-transparent {\n    background-color: rgba($info, 0.1) !important;\n    color: $info !important;\n    &:hover {\n        background-color: rgba($info, 0.1) !important;\n        color: $info !important;\n    }\n}\n.bg-success-transparent {\n    background-color: rgba($success, 0.1) !important;\n    color: $success !important;\n    &:hover {\n        background-color: rgba($success, 0.1) !important;\n        color: $success !important;\n    }\n}\n.bg-warning-transparent {\n    background-color: rgba($warning, 0.1) !important;\n    color: $warning !important;\n    &:hover {\n        background-color: rgba($warning, 0.1) !important;\n        color: $warning !important;\n    }\n}\n.bg-danger-transparent {\n    background-color: rgba($danger, 0.1) !important;\n    color: $danger !important;\n    &:hover {\n        background-color: rgba($danger, 0.1) !important;\n        color: $danger !important;\n    }\n}\n.bg-light-transparent {\n    background-color: rgba($light, 0.5) !important;\n    color: $light !important;\n    &:hover {\n        background-color: rgba($light, 0.5) !important;\n        color: $text-color !important;\n    }\n}\n.bg-gray-100 {\n    background-color: $gray-100; \n}\n.bg-gray-200 {\n    background-color: $gray-200;\n}\n.bg-gray-300 {\n    background-color: $gray-300;\n}\n.bg-gray-400 {\n    background-color: $gray-400;\n}\n.bg-gray-500 {\n    background-color: $gray-500;\n}\n.bg-gray-600 {\n    background-color: $gray-600;\n}\n.bg-gray-700 {\n    background-color: $gray-700;\n}\n.bg-gray-800 {\n    background-color: $gray-800;\n}\n.bg-gray-900 {\n    background-color: $gray-900;\n}\n.svg-primary {\n    fill: $primary;\n}\n.svg-secondary {\n    fill: $secondary;\n}\n.svg-success {\n    fill: $success;\n}\n.svg-danger {\n    fill: $danger;\n}\n.svg-warning {\n    fill: $warning;\n}\n.svg-white {\n    fill: $white;\n}\n.svg-black {\n    fill: $black;\n}\n.svg-pink {\n    fill: $pink;\n}\n.svg-orange {\n    fill: $orange;\n}\n.svg-purple {\n    fill: $purple;\n}\n.svg-indigo {\n    fill: $indigo;\n}\n.svg-info {\n    fill: $info;\n}\n.svg-yellow {\n    fill: $yellow;\n}\n.svg-light {\n  fill: $light;\n}\n.svg-dark {\n  fill: $dark;\n}\n.svg-teal {\n  fill: $teal;\n}\n.svg-default {\n  fill: $text-color;\n}\n.color-container {\n  width: 5rem;\n  height: 5rem;\n  border-radius: $border-radius;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 3rem;\n}\n.text-container {\n  padding: 0.25rem 0.5rem;\n  border-radius: $border-radius;\n  box-shadow: $box-shadow;\n}\n.color-box {\n    width: 80px;\n    height: 80px;\n    border-radius: $border-radius;\n    margin-right: 0.75rem;\n    margin-bottom: 0.75rem;\n}\n.bg-soft-purple {\n    background: $purple-100 !important;\n    border-color: $purple-100 !important;\n}\n.text-purple {\n    color: $purple;\n}\n.bg-light-200 {\n    background: $light-200;\n}\n.bg-light-100 {\n    background: $light-100;\n}\n.bg-danger-light {\n    background: $danger-100;\n}\n.bg-pending {\n    background: $violet !important;\n    color: $white !important;\n}\n.bg-secondary-success {\n    background: $green !important;\n}\n.bg-orange {\n    background: $orange;\n}\n.text-blue {\n    color: $purple !important;\n}\n.text-blue-light {\n    color: $indigo !important;\n}",".page-header {\n    margin-bottom: 14px;\n    .page-title {\n        font-weight: $font-weight-semibold;\n        margin-bottom: 10px;\n        @include respond-below(custom991) {\n            font-size: $font-size-18;\n        }\n        @include respond-below(custom767) {\n            margin-bottom: 14px;\n        }\n        .count-title {\n            background: #F3EDFF;\n            border-radius: 5px;\n            @include margin-padding(0 0 0 8px, 5px);\n            color: $purple;\n            font-size: $font-size-12;\n            font-weight: $font-weight-semibold;\n        }\n    }\n    .title-head {\n        @include respond-below(custom991) {\n            margin-top: 0;\n        }\n    }\n    .head-icons {\n        margin-bottom: 10px;\n        @include respond-below(custom991) {\n           display: none;\n        }\n        a {\n            width: 32px;\n            height: 32px;\n            background: $white;\n            color: $gray-900;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $light-900;\n            border-radius: 5px;\n            margin-right: 8px;\n            &.active, &:hover {\n                background: $green;\n                color: $white;\n            }\n            &:last-child {\n                margin-right: 0;\n            }\n            @include respond-below(custom991) {\n                margin-right: 4px !important;\n                &:last-child {\n                    margin-right: 0 !important;\n                }\n            }\n        }\n    }\n    .form-sort {\n        margin-top: 0;\n    }\n}\n.set-star {\n    i {\n        color: $light-900;\n        &.filled {\n            color: $orange;\n        }\n    }\n}\n.rating-select {\n    &.filled {\n        i {\n            color: $orange;\n        }\n    }\n}\n.icon-form {\n    position: relative;\n    .form-icon {\n        position: absolute;\n        top: 50%;\n        left: 15px;\n        transform: translateY(-50%);\n        color: $gray-900;\n    }\n    .form-control {\n        @include margin-padding(null, 8px 15px 8px 35px);\n        &:focus{\n            @include margin-padding(null, 8px 15px 8px 35px);\n        }\n    }\n}\n.icon-form-end {\n    position: relative;\n    .form-icon {\n        position: absolute;\n        top: 50%;\n        right: 15px;\n        transform: translateY(-50%);\n        color: $gray-900;\n    }\n    .form-control {\n        @include margin-padding(null, 8px 34px 8px 15px);\n    }\n}\n.view-icons {\n    border: 1px solid $light-900;\n    border-radius: 5px;\n    @include margin-padding(null, 2px);\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n    a {\n        width: 34px;\n        height: 36px;\n        background: $white;\n        color: $gray-900;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        &:first-child {\n            border-radius: 5px 0 0 5px;\n        }\n        &:last-child {\n            border-radius: 0 5px 5px 0;\n        }\n        &.active, &:hover {\n            background: $green;\n            color: $white;\n        }\n    }\n}\n.sidebar-popoverlay{\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    background: rgba(0,0,0,0.75);\n    top: 0;\n    left: -100%;\n    z-index: 1003;\n    &.open{\n        left: 0;\n    }\n}\n.sidebar-popoverlay-sign{\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    background: rgba(0,0,0,0.75);\n    top: 0;\n    left: -100%;\n    z-index: 1003;\n    &.open{\n        left: 0;\n    }\n}\n.profile-pic-upload {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    margin-bottom: 5px;\n    .profile-pic {\n        border: 2px dashed $light-900;\n        margin: 0 15px 10px 0;\n        width: 100px;\n        height: 100px;\n        border-radius: 5px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        position: relative;\n        span {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n        }\n        img {\n            width: 70px;\n            height: 70px;\n            border-radius: 5px;            \n        }\n        .close-img {\n            background: $danger;\n            color: $white;\n            width: 14px;\n            height: 14px;\n            border-radius: 2px;\n            border-radius: 5px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            @include position(absolute, 10px, 10px, null, null);\n        }\n    }\n    .upload-content {\n        p {\n            margin-bottom: 10px;\n        }\n    }\n    .upload-btn {\n        background: $purple-100;\n        border-radius: 5px;\n        position: relative;\n        margin-bottom: 10px;\n        display: inline-block;\n        span {\n            @include margin-padding(null, 9px 12px);\n            cursor: pointer;\n            color: $purple;\n            display: inline-block;\n            i {\n                margin-right: 10px;\n            }\n        }\n        input {\n            opacity: 0;\n            width: 100%;\n            height: 100%;\n            position: absolute;\n            z-index: 1;\n            cursor: pointer;\n        }\n    }\n}\n.user-accordion-item {  \n    background: $white;\n    border: 1px solid #E8E8E8;  \n    border-radius: 5px;\n    box-shadow: 0px 4px 74px 0px #D0D0D040;\n    margin-bottom: 15px;\n    .accordion-wrap {\n        @include margin-padding(null, 10px 25px 10px 10px);\n        font-weight: $font-weight-medium;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        position: relative;\n        span {\n            width: 36px;\n            height: 36px;\n            border-radius: 5px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-right: 8px;\n        }\n        &:hover {\n            color: $gray-900;\n        }\n        &::before {\n            content: \"\\f054\";\n            font-family: 'Font Awesome 5 Free';\n            @include position(absolute, 50%, 10px, null, null);\n            @include transform(translateY(-50%));\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n        } \n        &:not(.collapsed) {                 \n            &::before {\n                content: \"\\f078\";\n            } \n            span{\n                background: $primary;\n                color: $white;\n            }            \n        }\n    }\n    .content-collapse {\n        border-top: 1px solid $light-900;\n        @include margin-padding(5px 10px 10px, 15px 0 0);         \n    }\n    .accordion-collapse {\n        .form-wrap {\n            margin-bottom: 24px;\n            &.mb-wrap {\n                margin-bottom: 0;\n                @include respond-below(custom767) {\n                    margin-bottom: 24px;\n                }\n            }\n        }       \n    }\n}\n.submit-button {\n    .btn {\n        font-size: $font-size-14;\n        font-weight: $font-weight-semibold;\n        border-radius: $border-radius-lg;\n        @include margin-padding(0 10px 0 0, 7px 15px);\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n.radio-wrap {\n    .col-form-label {\n        padding-bottom: 12px;\n    }\n    .radio-btn {\n        margin-right: 15px;\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n.success-message {\n    h3 {\n        margin-bottom: 10px;\n        font-size: $font-size-20;\n    }\n    .del-info {\n        max-width: 300px;\n        @include margin-padding(0 auto, null);\n    }\n    p {\n        font-size: $font-size-16;\n        margin-bottom: 0;\n        @include respond-below(custom767) {\n            font-size: $font-size-14;\n        }\n    }    \n    .modal-btn {\n        margin-top: 40px;\n    }\n}\n.success-popup-icon {\n    background: $danger-100;\n    color: $danger;\n    width: 65px;\n    height: 65px;\n    border-radius: 50%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 15px;\n    font-size: $font-size-42;\n    &.bg-light-blue {\n        background: $purple-100;\n        color: $purple;\n    }\n}\n.access-wrap {\n    border-radius: 5px;\n    @include margin-padding(0 0 20px, 10px);\n    box-shadow: $box-shadow-sm;\n    li {\n        @include margin-padding(0 0 5px, 0);\n        &.checkbox-checked {\n            label {\n                background: $light-300;\n            }\n        }\n        label {\n            width: 100%;\n            position: relative;\n            @include margin-padding(null, 5px);\n            background: transparent;\n            &.checkboxs {\n                .checkmarks {\n                    right: 10px;\n                    left: unset;\n                    top: 50%;\n                    transform: translatey(-50%);\n                }\n                input:checked ~ .checkmark {\n                    background: $primary;\n                    border-color: $primary;\n                }\n            }\n            .people-profile {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n                img {\n                    width: 32px;\n                    height: 32px;\n                    border-radius: 50%;\n                    margin-right: 10px;\n                }\n                a {\n                    color: $text-color;\n                    font-size: $font-size-14;\n                }\n            }\n        }\n        &:hover {\n            background-color: $light-300;\n        }\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n}\n.load-btn {\n    .btn {\n        i {\n            margin-left: 4px;\n            animation: spin 3000ms linear infinite;\n        }\n    }\n}\n@keyframes spin {\n    to {\n      @include transform(rotate(360deg));\n    }\n}\n.img-select {\n    position: relative;\n    .select-box-img {\n        width: 24px;\n        height: 24px;\n        position: absolute;\n        top: 50%;\n        left: 10px;\n        z-index: 9999;\n    }\n    .select2-selection__rendered {\n        padding-left: 40px !important;\n    }\n}\n.users-group {\n    ul {\n        display: flex;\n        align-items: center;\n        li {\n            a {\n                width: 24px;\n                height: 24px;\n                border-radius: 50%;\n                border: 1px solid $white;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                line-height: normal;\n                margin-left: -11px;\n                img {\n                    width: 24px;\n                    height: 24px;\n                    border-radius: 50%;\n                }\n                &.total-group-member {\n                    background: $primary;\n                    color: $white;\n                    font-size: $font-size-10;\n                }\n                &:hover {\n                    position: relative;\n                }\n            }\n            &:first-child {\n                a {\n                    margin-left: 0;\n                }\n            }\n        }\n    }\n}\n.add-new {\n    color: $danger;\n}\n.contact-head {\n    margin-bottom: 5px;\n    .contact-breadcrumb {\n        margin-bottom: 5px;\n        li {\n            color: $text-color;\n            position: relative;\n            display: inline-block;\n            @include margin-padding(0 2px 5px 0, 0 0 0 10px);\n            a {\n                color: $text-color;\n                i {\n                    color: $primary;\n                    margin-right: 8px;\n                }\n                &:hover {\n                    color: $primary;\n                }\n            }\n            &:last-child {\n                margin-right: 0;\n            }\n            &:first-child {\n                padding-left: 0;\n                &::before {\n                    content: none;\n                }\n            }\n            &::before {\n                content: \"/\";\n                @include position(absolute, 0, null, null, 0);\n            }\n            &.before-none {\n                padding-left: 5px;\n                &::before {\n                    content: none;\n                }\n            }\n            .btn {\n                i {\n                    color: $white;\n                }\n                color: $white;\n                &:hover {                    \n                    color: $white;\n                }\n            }\n        }\n    }\n    .contact-pagination {\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        margin-bottom: 10px;\n        p {\n            @include margin-padding(0 15px 0 0, null);\n        }\n        ul {\n            li {\n                display: inline-block;\n                margin-right: 5px;\n                a {\n                    width: 26px;\n                    height: 26px;\n                    border-radius: 50%;\n                    background: $white;\n                    color: $title-color;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    &:hover {\n                        background: $primary;\n                        color: $white;\n                    }\n                }\n                &:last-child {\n                    margin-right: 0;\n                }\n            }\n        }\n    }\n}\n.contacts-action {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    flex-wrap: wrap;\n    & > a {\n        margin: 0 8px 8px 0;\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n    .badge {\n        @include margin-padding(0 8px 10px 0, 7px 6px);\n        font-size: $font-size-14;\n        font-weight: $font-weight-normal;\n        &.badge-light {\n            background: $light-600;\n            color: $gray-400;\n        }\n        i {\n            margin-right: 8px;\n        }\n    }\n    .action-drops {\n        margin-bottom: 10px;\n        .dropdown-toggle {\n            font-weight: $font-weight-semibold;\n            color: $white; \n            display: inline-block;\n            span {\n                display: inline-block;\n                border-radius: 5px;\n                @include margin-padding(null, 4px 10px);\n                color: $white; \n            }\n        }\n    }\n    .dropdown-toggle {\n        margin-right: 0;\n        color: $secondary-900;\n        &::after {\n            content: none;\n        }\n    }\n    .btn {\n        border-radius: 5px;\n        padding: 6px 13px;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        font-size: $font-size-15;\n        font-weight: $font-weight-medium;\n        i {\n            margin-right: 5px;\n        }\n    }\n    .btn-icon {\n        width: 36px;\n        height: 36px;\n        border-radius: 5px;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        background: $light-300;    \n        border: 1px solid $light-300; \n        color: $title-color;\n        &:hover {\n            background: $primary;\n            color: $white;\n        }\n        &.rating {\n            border-radius: 50%;     \n            background: $white;\n            border: 1px solid $light-900; \n            color: $orange;    \n        }\n    }\n    .act-dropdown {\n        margin-bottom: 10px;\n        & > a {\n            width: 34px;\n            height: 34px;\n            border-radius: 5px;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;   \n            background: $white;\n            border: 1px solid $light-900; \n            &:hover {\n                background: $light-900;\n                color: $gray-900;\n            }   \n        }\n        .dropdown-item {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            @include margin-padding(null, 5px);\n            border-radius: 5px;\n            color: $title-color;\n            i {\n                margin-right: 8px;\n            }\n            &:hover {\n                background: $light-300;\n                color: $title-color;\n            }\n        }  \n    }\n}\n.basic-info li {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    font-size: $font-size-14;\n    span {\n        width: 26px;\n        height: 26px;\n        border-radius: 50%;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        background: $light-300;\n        color: $title-color;\n        margin-right: 10px;\n        flex-shrink: 0;\n    }\n}\n.set-info {\n    li {\n        a {\n            color: $gray-400;\n            &:hover {\n                color: $primary;\n            }\n        }\n        i {\n            margin-right: 5px;\n        }\n    }\n}\n.other-info {\n    li {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        .other-title {\n            min-width: 110px;\n            display: inline-block;\n        }\n        .avatar-xs {\n            width: 16px;\n            height: 16px;\n            border-radius: 5px;\n        }\n    }\n}\n.con-sidebar-title {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    flex-wrap: wrap; \n    a {\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        color: $purple;\n        &:hover {\n            color: $primary;\n        }\n    }\n}\n.company-info {\n    li {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        span {\n            width: 52px;\n            height: 52px;\n            border-radius: 5px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $light-900;\n            margin-right: 10px;\n        }\n        h6 {\n            font-size: $font-size-14;\n            font-weight: $font-weight-medium;\n            margin-bottom: 2px;\n\n        }\n        p {\n            font-size: $font-size-14;\n            margin-bottom: 0;\n        }\n    }\n    &.com-info {\n        li {\n            span {\n                width: 32px;\n                height: 32px;\n                margin-right: 8px;\n                border-radius: 50%;\n            }\n            p {\n                i {\n                    margin-right: 5px;\n                    color: $warning;\n                }\n            }\n        }\n    }\n}\n.deals-info {\n    li {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        img {\n            width: 32px;\n            height: 32px;\n            border-radius: 5px;\n            margin-right: 10px;\n        }\n        p {\n            margin-bottom: 0;\n        }\n    }\n}\n.social-info {\n    li {\n        display: inline-block;\n        a {\n            width: 32px;\n            height: 32px;\n            border-radius: 50%;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            background: $white;\n            color: $gray-900;\n            &:hover {\n                background: $gray-900;\n                color: $white;\n            }\n        }\n    }\n}\n.tag-info {\n    li {\n        margin-right: 5px;\n        display: inline-block;\n        a {\n            font-size: $font-size-12;\n            font-weight: $font-weight-medium;\n            border-radius: 5px;\n            @include margin-padding(null, 5px 10px);\n            display: inline-block;\n        }\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n.star-icon {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    border: 1px solid $light-900;\n    color: $orange;\n    i {\n        font-size: $font-size-14;\n    }\n}\n.contact-nav {\n    @include respond-below(custom575) {\n        display: block;\n    }\n    li {\n        display: inline-block;\n        @include margin-padding(0 20px 0 0, null);\n        a {\n            color: $gray-400;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n             justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            font-size: $font-size-14;\n            font-weight: $font-weight-medium;\n            border-bottom: 3px solid $white;\n            text-align: center;\n            @include margin-padding(null, 5px 5px 10px 5px);\n            &:hover, &.active {\n                color: $primary;\n                border-color: $primary;\n            }\n            i {\n                margin-right: 5px;\n            }\n        }\n        @include respond-below(custom575) {\n            display: block;\n        }\n    }\n}\n.form-sort {\n    position: relative;\n   i {\n        position: absolute;\n        z-index: 101;\n        width: 16px;\n        height: 16px;\n        top: 14px;\n        left: 7px;\n    }\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 35px;\n    }\n    span.select2-container.select2-container--default.select2-container--open {\n        z-index: 99;\n    }\n}\n.badge-day {\n    background: $purple-100;\n    color: $purple;\n    border-radius: 5px;\n    display: inline-block;\n    font-size: $font-size-14;\n    @include margin-padding(0 0 20px, 4px 8px);\n    i {\n        margin-right: 5px;\n    }\n}\n.contact-activity {\n    ul {\n        &:last-child {\n            .activity-wrap {\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n}\n.upcoming-info {\n    border: 1px solid $light-900;\n    border-radius: 5px;\n    @include margin-padding(10px 0 0, 15px 15px 5px);\n    p {\n        font-weight: $font-weight-medium;\n        margin-bottom: 8px;\n    }\n    .dropdown {\n        margin-bottom: 10px;\n        .dropdown-toggle {\n            color: $gray-900;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            font-size: $font-size-14;\n            &::after {\n                content: none;\n            }                    \n        }\n        .avatar-xs {\n            width: 16px;\n            height: 16px;\n            border-radius: 5px;\n            margin-right: 10px;\n        }     \n        .circle {\n            font-size: 10px;\n        }       \n        .dropdown-menu {\n            a {\n                display: -webkit-inline-box;\n                display: -ms-inline-flexbox;\n                display: inline-flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                font-size: $font-size-14;\n                color: $gray-900;\n            }\n        }\n    }\n}\n.notes-editor {\n    .dropdown-toggle::after {\n        content: none;\n    }\n}\n.note-edit-wrap {\n    display: none;\n    margin-bottom: 15px;\n}\n.notes-activity {\n    .note-download {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;  \n        border: 1px solid $light-900;\n        box-shadow: 0px 4px 4px 0px #DBDBDB40;\n        @include margin-padding(0 0 15px, 15px);\n        border-radius: 5px;\n        .note-info {\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;  \n            margin-right: 24px;\n            h6 {\n                font-weight: $font-weight-medium;\n                margin-bottom: 5px;\n            }   \n            p {\n                margin-bottom: 0;\n            }  \n            @include respond-below(custom767) { \n                margin-right: 15px;\n            }     \n        }\n        .note-icon {\n            width: 44px;\n            height: 44px;\n            border-radius: 5px;\n            color: $white;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-right: 8px;\n            flex-shrink: 0;\n            img {\n                width: 44px;\n                height: 44px;\n                border-radius: 50%;                \n            }\n        }\n        &:hover {\n            background: $light-300;\n            a {\n                background: $white;\n            }\n        }\n        a {\n            width: 24px;\n            height: 24px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border-radius: 50%;\n            color: $title-color;\n            background: $light-300;\n        }\n        @include respond-below(custom767) { \n            @include margin-padding(0 0 15px, 10px);\n        }\n    }\n    .reply-box {\n        background: $light-200;\n        border-radius: 5px;\n        @include margin-padding(0 0 15px, 15px);\n        p {\n            margin-bottom: 10px;\n        }\n        .btn {\n            background: $white;\n            border-color: $white;\n            border-radius: 5px;\n            color: $gray-900;\n            font-size: $font-size-16;\n            font-weight: $font-weight-normal;\n            @include margin-padding(0, 5px 10px);\n            i {\n                margin-right: 3px;\n            }\n            &:hover {\n                background: $light-100;\n            }\n        }\n    }   \n}\n.note-btns {\n    margin-top: 5px;\n    .btn {\n        @include margin-padding(10px 10px 0 0, 7px 15px);\n        &:last-child {\n            margin-right: 0;\n        }\n        &.btn-primary {\n            min-width: 110px;\n        }\n    }\n}\n.drag-attach {\n    border: 1px dashed $light-900;\n    border-radius: 5px;\n    position: relative;\n    text-align: center;\n    width: 100%;\n    overflow: hidden;\n    input {\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        z-index: 1;\n        cursor: pointer;\n    }\n    .img-upload {\n        background: $purple-100;\n        color: $purple;\n        font-size: $font-size-14;\n        display: inline-block;\n        text-align: center;\n        @include margin-padding(24px 0, 9px 17px); \n        border-radius: 5px;\n        i {\n            margin-right: 10px;\n        }       \n    }\n}\n.drag-upload {\n    background: $light-100;\n    border: 1px dashed $secondary-200;\n    border-radius: 5px;\n    position: relative;\n    input {\n        opacity: 0;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        z-index: 1;\n        cursor: pointer;\n    }\n    i {\n        font-size: $font-size-24;\n        margin-bottom: 10px;\n    }\n    p {\n        font-size: $font-size-14;\n        margin-bottom: 0;\n    }\n    .img-upload {\n        text-align: center;\n        @include margin-padding(null, 36px 20px);        \n    }\n}\n.upload-file {\n    background: $light-200;\n    border: 1px solid $light-900;\n    @include margin-padding(0 0 5px, 15px);   \n    border-radius: 5px; \n    h6 {\n        font-size: $font-size-14;\n        font-weight: $font-weight-medium;\n        margin-bottom: 2px;\n    }   \n    p {\n        font-size: $font-size-14;\n        margin-bottom: 0;\n        &.black-text {\n            color: $gray-900;\n        }\n    } \n    .progress {\n        height: 3px;\n        @include margin-padding(15px 0 4px, null);\n    }\n    &.upload-list {    \n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;        \n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n    }\n}\n.form-title {\n    font-weight: $font-weight-semibold;\n    margin-bottom: 15px;\n}\n.sync-radio {\n    .radio-item {\n        margin-bottom: 15px;\n        label {\n            font-size: $font-size-14;\n        }\n        &:last-child {\n            margin-bottom: 0;\n        }\n    }\n}\n.signature-wrap {\n    background: $light-700;\n    border: 1px solid $light-900;\n    border-radius: 5px;\n    @include margin-padding(0 0 15px, 15px 15px 0);\n    h4, p {\n        margin-bottom: 15px;\n    }\n    h4 {\n        font-weight: $font-weight-semibold;\n         @include respond-below(custom767) {\n            font-size: $font-size-16;\n        }\n    }\n}\n.add-sign {\n    font-size: $font-size-16;\n    color: $warning;\n}\n.sign-item {\n    li {\n        margin-bottom: 15px;\n        .sign-title {\n            display: block;\n            font-weight: $font-weight-medium;\n            margin-bottom: 3px;\n        }\n    }\n}\n.trash-sign {\n    color: $danger;\n}\n.send-success {\n    border: 1px solid $success;\n    background: $success-300;\n    border-radius: 5px;\n    @include margin-padding(0 0 15px, 15px);\n    p {\n        color: $gray-900;\n        margin-bottom: 0;\n        i {\n            margin-right: 5px;\n        }\n    }\n}\nfieldset {\n    display: none;\n    &#first-field-file {\n        display: block;\n   }\n}\n.add-details-wizard {\n    ul {\n        display: flex;\n        align-items: center;\n        margin-bottom: 15px;\n        @include respond-below(custom575) {\n            flex-direction: column;\n        }\n        li {\n            line-height: normal;\n            background: $light-300;\n            padding: 10px 20px;\n            display: flex;\n            align-items: center;\n            @include respond-below(custom575) {\n                width: 100%;\n                margin-bottom: 10px;\n            }\n            span {\n                margin-right: 5px;\n            }\n            .multi-step-info {\n                h6 {\n                    margin-bottom: 0;\n                    font-weight: $font-weight-medium;\n                    font-size: $font-size-14;\n                    color: $gray-400;\n                }\n            }\n            &.active {\n                background: $primary;\n                color: $white;\n                h6 {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n.pipeline-item {\n    border: 1px solid $light-900;\n    @include margin-padding(0 0 5px, 15px 15px 5px);\n    border-radius: 5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;       \n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    position: relative;\n    &::before {\n        @include position(absolute, 0, null, null, 0);\n        content: \"\";\n        width: 2px;\n        height: 100%;\n        background: $secondary;\n    }\n    p {\n        color: $gray-900;\n        font-weight: $font-weight-medium;\n        margin-bottom: 10px;\n    }\n    .action-pipeline {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;   \n        flex-wrap: wrap;    \n        a {\n           @include margin-padding(0 15px 10px 0, null);\n           i {\n                margin-right: 5px;\n           }\n           &:last-child {\n                margin-right: 0;\n           }\n        }\n    }\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n.access-item {\n    .radio-btn {\n        margin-right: 15px;\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n.access-wrapper {\n    margin-top: 20px;\n}\n.access-view {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center; \n    border: 1px solid $light-900;\n    @include margin-padding(0 0 5px, 15px 15px 15px);\n    border-radius: 5px;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    .access-img {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center; \n        img {\n            width: 32px;\n            height: 32px;\n            border-radius: 5px;\n            margin-right: 10px;\n        }\n    }\n    a {\n        font-weight: $font-weight-semibold;\n        color: $danger;\n    }\n}\n.header-collapse {\n    .header-user {\n        display: none;\n        height: 0;\n    }\n    .page-wrapper {\n        padding-top:  0;\n    }\n    .header {\n        border-bottom: none;\n        background: transparent;\n        width: 260px;\n        .header-left {\n            background: white;\n        }\n    }\n    #collapse-header {\n        i {            \n            transform: rotate(180deg);\n            -webkit-transform: rotate(180deg);\n            -ms-transform: rotate(180deg);\n        }\n    }\n}\n.bootstrap-datetimepicker-widget {\n    z-index: 99999;\n    table {\n        td {\n            &.active, &:hover {\n                background-color: $green\n            }\n        }\n    }\n}\n.note-modal-backdrop {\n    z-index: 9;\n}\n.note-modal-footer {\n    height: 57px;\n}\n.table tbody tr td a {\n    &.title-name {\n        color: $gray-900;\n        font-weight: $font-weight-medium;\n        &:hover {\n            color: $primary;\n            text-decoration: underline;\n        }\n    }\n}\n.title-name {\n    color: $gray-900;\n    font-weight: $font-weight-medium;\n}\n.export-list {\n    >ul {\n        display: flex;\n        align-items: center;\n        justify-content: end;\n        flex-wrap: wrap;\n        @include respond-below(custom575) {\n            justify-content: start;\n        }\n    }\n}\n.grid-social-links {\n    a {\n        &:hover {\n            background: $primary-100 !important;\n        }\n    }\n}\n\n",".daterange-picker{\n    .form-sort{\n        margin-left: 10px;\n       input{\n            padding-left: 25px;\n            height:38px;\n       }\n       .select2-container {\n            .select2-selection.select2-selection--single {\n                height: 38px;\n                .select2-selection__rendered{\n                    line-height: 38px;\n                }\n                .select2-selection__arrow {\n                    height: 38px;\n                }\n            }\n\n        }\n    }\n}\n.card-select {\n    ul {\n        display: flex;\n        align-items: center;\n        li{\n            + li{\n                margin-left: 12px;\n                \n            }\n        }\n    }        \n}\n.view-icons {\n    float: right;\n    @include respond-below(custom767) {\n        margin-right: 0;\n    }\n    .btn{\n        background-color: $white;\n        border: 1px solid $light-900;\n        color: $secondary-800;\n        font-size: $font-size-18;\n        min-width: 40px;\n        @include margin-padding(0 5px 0 0, 7px 0 3px 0);\n        &.active {\n            color: $secondary-900;\n        }\n        @include respond-below(custom767) {\n            min-width: 37px;\n            @include margin-padding(0 5px 0 0, 5px 0 3px 0);\n        }\n    }\n}\n.page-header {\n    .view-icons {\n        @include respond-below(custom767) {\n            margin-right: 10px;\n        }\n        @include respond-below(custom575) {\n            margin-right: 0;\n        }\n    }\n}\n.title-head {\n    justify-content: end;\n    align-items: center;\n    @include respond-below(custom767) {\n        justify-content: start;\n        margin-top: 20px;\n    }\n    @include respond-below(custom575) {\n        flex-direction: column;\n        row-gap: 20px;\n        align-items: start;\n    }\n    .add-btn {\n        margin-left: 10px;\n        border-radius: 5px;\n        @include respond-below(custom575) {\n            margin-left: 0;\n        }\n    }\n    .form-sort {\n        .list-view {\n            padding: 10px 10px 10px 30px;\n            background-color: $white;\n            border: 1px solid $light-900;\n            color: $secondary-600;\n            font-size: $font-size-14;\n            text-decoration: none;\n            line-height: normal;\n        }\n    }\n}\n.daterange-picker {\n    .form-sort {\n        min-width: 200px;\n    }\n}\n.statistic-dropdown {\n    .btn-primary{\n        padding: 6px 15px;\n        height: 35px;\n    }\n}\ntd {\n    .badge-pill {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n.badge-dots {\n    width:12px; \n    height:12px;\n    border-radius: 5px;\n    margin-right:5px;\n    display: inline-flex;\n}\n.title-head {\n    .daterange-picker {\n        .form-sort {\n            height: auto;\n            min-width: 212px;\n            i {\n                left: 15px;\n                top: 9px;\n            }\n            input {\n                height: 32px;\n                min-height: 32px;\n            }\n        }\n        .bookingrange {\n            padding-left: 35px;\n        }\n    }\n}",".error-page {\n    background: $white;\n}\n.comming-shapes {\n    position: relative;\n    @include respond-below(custom991) {\n        display: none;\n    }\n    .comming-right-shape {\n        position: fixed;\n        top: 0;\n        left: 0;\n    }\n    .comming-left-shape {\n        position: fixed;\n        bottom: -5px;\n        right: 0;\n    }\n    img {\n        width: 500px;\n    }\n}\n.error-img {\n    max-width: 500px;\n }",".account-page {\n  background: $white;\n}\n.form-wrap {\n  .form-wrap-icon {\n    position: relative;\n    i {\n      font-size: $font-size-18;\n      @include position(absolute, 50%, 15px, null, null);\n      transform: translateY(-50%);\n    }\n  }\n}\n.form-wrap-checkbox {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  justify-content: space-between;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: space-between;\n  margin-bottom: 20px;\n  .check {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    cursor: pointer;\n    color: $gray-900;\n    margin-bottom: 0;\n    input {\n      display: none;\n      &:checked + .box {\n        background: $secondary;\n        &:after {\n          top: 0;\n        }\n      }\n    }\n    .box {\n      width: 20px;\n      height: 20px;\n      display: block;\n      margin-right: 8px;\n      transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);\n      background: $light-200;\n      position: relative;\n      overflow: hidden;\n      cursor: pointer;\n      border: 1px solid $light-900;\n      border-radius: $border-radius-lg;\n      &:after {\n        width: 12px;\n        height: 6px;\n        content: \"\";\n        position: absolute;\n        border-left: 2px solid;\n        border-bottom: 2px solid;\n        border-color: $white;\n        transform: rotate(-45deg) translate3d(0, 0, 0);\n        transform-origin: center center;\n        transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);\n        left: 0;\n        right: 0;\n        top: 200%;\n        bottom: 3px;\n        margin: auto;\n      }\n    }\n  }\n}\n.hover-a {\n  position: relative;\n  color: $purple;\n  &:after {\n    content: \"\";\n    height: 2px;\n    width: 100%;\n    background: $purple;\n    @include transform(scale(0));\n    @include transition(all 0.3s ease);\n    @include position(absolute, null, null, -3px, 0);\n  }\n  &:hover:after {\n    @include transform(scale(1));\n  }\n  &:hover {\n    color: $purple;\n  }\n}\n.account-bg-01 {\n  background-image: url(../../../../public/assets/img/authentication/login-bg.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n.account-bg-02 {\n  background-image: url(../../../../public/assets/img/authentication/register-bg.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n.account-bg-03 {\n  background-image: url(../../../../public/assets/img/authentication/forgot-bg.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n.account-bg-04 {\n  background-image: url(../../../../public/assets/img/authentication/reset-bg.jpg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n}\n.link-hover {\n  position: relative;\n  color: $primary;\n  font-weight: $font-weight-medium;\n  &:after {\n    content: \"\";\n    height: 2px;\n    width: 100%;\n    background: $primary;\n    @include transform(scale(0));\n    @include transition(all 0.3s ease);\n    @include position(absolute, null, null, -3px, 0);\n  }\n  &:hover:after {\n    @include transform(scale(1));\n  }\n  &:hover {\n    color: $primary !important;\n  }\n}\n.bg-backdrop {\n  background: #fffffff2;\n  backdrop-filter: blur(10px);\n  @include respond-below(custom767) {\n    width: 100% !important;\n  }\n}\n.form-set-login.or-text {\n  max-width: 365px;\n  margin: auto;\n}\n.toggle-password {\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  color: $gray-900;\n  font-size: $font-size-18;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  @include rounded(50%);\n  @include transform(translateY(-50%));\n  @include position(absolute, 50%, 10px, null, null);\n  &:hover {\n    color: $primary;\n  }\n}\n.toggle-passwords {\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  color: $gray-900;\n  font-size: $font-size-18;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  @include rounded(50%);\n  @include transform(translateY(-50%));\n  @include position(absolute, 50%, 10px, null, null);\n  &:hover {\n    color: $primary;\n  }\n}\n.toggle-password-new {\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  color: $gray-900;\n  font-size: $font-size-18;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  @include rounded(50%);\n  @include transform(translateY(-50%));\n  @include position(absolute, 50%, 10px, null, null);\n  &:hover {\n    color: $primary;\n  }\n}\n.pass-group {\n  position: relative;\n  font-size: $font-size-base;\n}\n.form-set-login {\n  text-align: center;\n  position: relative;\n  color: $sub-title;\n  font-size: $font-size-base;\n  font-weight: $font-weight-normal;\n  margin-bottom: 23px;\n  h4 {\n    position: relative;\n    font-size: $font-size-base;\n    color: $text-color;\n    font-weight: $font-weight-bold;\n    &:after {\n      content: \"\";\n      background: $sub-title;\n      width: 21px;\n      height: 1px;\n      @include position(absolute, 10px, null, null, 200px);\n      @include respond-below(custom991) {\n        height: 0px;\n      }\n    }\n    &:before {\n      content: \"\";\n      background: $sub-title;\n      width: 21px;\n      height: 1px;\n      @include position(absolute, 10px, 200px, null, null);\n      @include respond-below(custom991) {\n        height: 0px;\n      }\n    }\n  }\n}\n.mw-450 {\n  max-width: 450px;\n}\n.wh-85 {\n  width: 85px;\n  height: 85px;\n  @include respond-below(custom575) {\n    width: 50px;\n    height: 50px;\n  }\n}\n.login-shapes {\n  position: relative;\n  @include respond-below(custom991) {\n    display: none;\n  }\n  .login-right-shape {\n    position: fixed;\n    top: 0;\n    left: 0;\n  }\n  .login-left-shape {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    line-height: 0;\n  }\n}\n",".settings-sidebar {\n    h4 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-semibold;\n        margin-bottom: 24px;\n        @include respond-below(custom767) {\n            font-size: $font-size-16;\n             margin-bottom: 15px;\n        }\n    }\n    a {\n        color: $gray-400;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        border-radius: $border-radius-lg;\n        padding: 10px;\n        width: 100%;\n        position: relative;\n        &.active {\n            background: $light-300;\n            color: $gray-900;\n            &:before {\n                position: absolute;\n                content: '\\f054';\n                font-family: 'FontAwesome';\n                font-size: $font-size-12;\n                top: 50%;\n                transform: translateY(-50%);\n                right: 10px;\n            }\n        }\n        &:hover {\n            color: $gray-900;  \n        }\n    }\n}\n.profile-upload {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    .profile-upload-img {\n        width: 100px;\n        min-width: 100px;\n        height: 100px;\n        position: relative;\n        margin-right: 15px;\n        border-radius: $border-radius-lg;\n        border: 2px dashed $light-900;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        span {\n            color: $gray-400;\n            position: absolute;\n        }\n    }\n    .profile-upload-content {\n        .profile-upload-btn {\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            position: relative;\n            overflow: hidden;\n            color: $purple;\n            background: $purple-100;\n            border: 1px solid $purple-100;\n            border-radius: $border-radius-lg;\n            padding: 8px 10px;\n            margin-bottom: 15px;\n            cursor: pointer;\n            transition: all 0.5s;\n            &:hover {\n                color: $white;\n                background: $purple;\n                border: 1px solid $purple;\n                transition: all 0.5s;\n            }\n            i {\n                font-size: $font-size-16;\n                margin-right: 8px;\n            }\n            input[type=\"file\"] {\n                position: absolute;\n                top: 0;\n                right: 0;\n                min-width: 100%;\n                min-height: 100%;\n                text-align: right;\n                filter: alpha(opacity = 0);\n                opacity: 0;\n                outline: none;\n                cursor: inherit;\n                display: block;\n            }\n        }\n        p {\n            font-weight: $font-weight-medium;\n            color: $gray-400;\n        }\n    }\n    .preview1 {\n        display: none;\n    }\n    .it {\n        width: 70px;\n        height: 70px;\n        border-radius: $border-radius-lg;\n        display: block;\n        position: relative;\n        background: $white;\n        object-fit: cover;\n    }\n    .profile-remove {\n        display: none;\n    }\n    .profile-remove-btn {\n        width: 14px;\n        height: 14px;\n        font-size: $font-size-10;\n        color: $white;\n        background: $danger;\n        border: 1px solid $danger;\n        border-radius: $border-radius-lg;\n        padding: 0;\n        display: inline-block;\n        position: absolute;\n        top: 8px;\n        right: 8px;\n    }\n    .profile-remove-btn:hover {\n        background: $danger-hover;\n        border: 1px solid $danger-hover;\n    }\n}\n.notificaion-table {\n    .table {\n        thead {\n            tr {                \n                &:first-child {\n                    th {\n                        padding-top: 0;\n                    }\n                }\n                th {\n                    font-size: $font-size-16;\n                    padding: 10px;\n                }\n            }\n        }\n        tbody {\n            tr {\n                td {\n                    font-weight: $font-weight-medium;\n                    color: $gray-900;\n                    padding: 10px;\n                }\n                &:last-child {\n                    td {\n                        padding-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n}\n.mod-toggle {\n    .status-toggle {\n        margin-right: 20px;\n    }\n}\n.btn-add {\n    width: 32px;\n    height: 32px;\n    background: $white;\n    border: 1px solid $light-900;\n    border-radius: 5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: $gray-900;\n    &:hover {\n        background: $green;\n        color: $white;\n    }\n}\n.settings-form {\n    .setting-title {\n        margin-bottom: 15px;\n        h6 {\n            font-size: $font-size-14;\n            font-weight: $font-weight-medium;\n        }\n        p {\n            font-size: $font-size-12;\n        }\n    }\n    .form-wrap {\n        margin-bottom: 15px;\n    }\n    .submit-button {\n        margin-top: 14px;\n    }\n}\n.bank-box {\n    background: $light-200;\n    border-radius: 5px;\n    border: 1px solid $light-200;\n    position: relative;\n    @include margin-padding(0 0 24px, 40px);\n    @include respond-below(custom991) {\n        @include margin-padding(0 0 24px, 20px);\n    }\n    &.active {\n        border-color: $success;\n        &::after {\n            position: absolute;\n            top: -8px;\n            right: -8px;\n            content: \"\\f058\";\n            font-family: \"Font Awesome 5 Free\";\n            font-weight: 900;\n            color: $success-900;\n            width: 22px;\n            height: 22px;\n            border-radius: 50%;\n            background-color: $white;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n        }\n    }\n    .table-action {\n        .action-icon {\n            background-color: transparent;\n            &:hover {\n                background-color: $light-300;\n            }\n        }\n    }\n}\n.inv-days {\n    .select2-container {\n        min-width: 62px !important;\n    }\n    p {\n        color: $black;\n        margin-left: 10px;\n    }\n}\n.lang-type {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    li {\n        margin-right: 5px;\n        a {\n            background-color: $light-300;\n            @include rounded(5px);\n            color: $gray-400;\n            font-weight: $font-weight-medium;\n            @include margin-padding(null, 8px 15px);\n            display: inline-block;\n            &:hover {\n                background-color: $green;\n                color: $white !important;\n            }\n        }\n    }\n}\n.theme-type-images {\n    flex-wrap: wrap;\n    .theme-image {\n        background: $white;\n        border-radius: 5px;\n        border: 1px solid $light-900;\n        padding: 10px;\n        margin: 0 24px 15px 0;\n        text-align: center;\n        img {\n            width: 150px;\n             @include respond-below(custom1399) {\n               width: 130px;      \n            }\n        }\n        &:last-child {\n            margin-right: 0;\n        }\n        span {\n            font-weight: $font-weight-medium;\n            font-size: $font-size-14;\n            color: $gray-900;\n            margin-top: 10px;\n            display: block;\n        }\n        &.active {\n            border-color: $primary;\n            span {\n                color: $primary;\n            }\n        }\n    }\n}\n.theme-colors {\n    ul {\n        display: flex;\n        align-items: center;\n        li {\n            margin-right: 10px;\n            span {\n                width: 30px;\n                height: 30px;\n                border-radius: 50%;\n                background-color: $primary;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                cursor: pointer;\n                position: relative;\n                &.active {\n                    background-color: $primary-100;\n                    &:after {\n                        content: \"\";\n                        width: 25px;\n                        height: 25px;\n                        background-color: $primary;\n                        border-radius: 50%;\n                        opacity: 1;\n                    }\n                }\n                &.theme-secondary {\n                    background-color: $secondary;\n                    &.active {\n                        background-color: $secondary-100;\n                        &:after {\n                            background-color: $secondary;\n                        }\n                    }\n                }\n                &.theme-violet {\n                    background-color: $tertiary;\n                    &.active {\n                        background-color: rgba($tertiary, 0.1);\n                        &:after {\n                            background-color: $tertiary;\n                        }\n                    }\n                }\n                &.theme-blue {\n                    background-color: $indigo;\n                    &.active {\n                        background-color: $indigo-100;\n                        &:after {\n                            background-color: $indigo;\n                        }\n                    }\n                }\n                &.theme-brown {\n                    background-color: $purple;\n                    &.active {\n                        background-color: $purple-100;\n                        &:after {\n                            background-color: $purple;\n                        }\n                    }\n                }\n            }\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n}\n.lang-wrap {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n}\n.lang-flag {\n    margin-right: 15px;\n    a {\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        border: 1px solid $light-900;\n        @include rounded(8px);\n        color: $gray-900;\n        font-weight: $font-weight-medium;\n        @include margin-padding(null, 8px 8px);\n        img {\n            margin-right: 8px;\n            @include rounded(50%);\n            width: 20px;\n            height: 20px;\n        }\n    }\n}\n.lang-direct { \n    li {\n        @include margin-padding(0 8px 0 0, null);\n        a {\n            background-color: $gray-200;\n            color: $gray-900;\n            @include rounded(5px);\n            @include margin-padding(null, 8px 15px);\n            display: inline-block;\n            &:hover, &.active {\n                background-color: $tertiary;\n                color: $white;\n            }\n        }\n        &:last-child {\n            margin-right: 0;\n        }\n    }\n}\n.translate-wrap {\n    h6 {\n        font-weight: $font-weight-medium;\n        margin-bottom: 15px;\n    }\n    .form-wrap {\n        margin-bottom: 15px;\n    }\n    &.translate-title {\n        h6 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n        }\n    }\n}\n.translate-item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center; \n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    flex-wrap: wrap;\n    margin-bottom: 24px;\n    .btn, .lang-flag  {\n        margin-bottom: 24px;\n    }\n}\n.lang-flag {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center; \n}\n.lang-progress {\n    margin-bottom: 24px;\n    p {\n        font-weight: $font-weight-medium;\n    }\n    .progress {\n        min-width: 100px;\n        max-width: 150px;\n        height: 7px;\n    }\n}\n.black-text {\n    color: $gray-900 !important;\n}\n.settings-tab {\n    .card-body {\n        padding-top: 0;\n         @include respond-below(custom767) {\n            padding-top: 16px;        \n        }\n        li {\n            a {\n                padding-top: 24px;                \n                @include respond-below(custom767) {\n                     padding-top: 8px; \n                     padding-bottom: 8px;           \n                }\n            }\n        }\n    }\n}\n.payment-img {\n    width: 80px;\n    height: 40px;\n}\n\n\n",".source-report {\n    color: #00918E;\n    font-weight: 500;\n}\n.dropdown {\n    &.table-action {\n        .dropdown-toggle {\n            &::after {\n                display: none;\n            }\n        }\n    }\n    .dropdown-toggle {\n        color: $gray-900;\n        border: 1px solid $light-900;\n        padding: 9px 15px;\n        border-radius: $border-radius-lg;\n        display: flex;\n        align-items: center;\n        box-shadow: 0px 4px 4px 0px #DBDBDB40;\n        &:after {\n            border-top: 0;\n            border-left: 0;\n            border-bottom: 2px solid $gray-900;\n            border-right: 2px solid $gray-900;\n            content: '';\n            display: inline-block;\n            pointer-events: none;\n            width: 8px;\n            height: 8px;\n            vertical-align: 2px;\n            @include transform-origin(66% 66%);\n            @include transition(all 0.2s ease);\n            @include transform(rotate(45deg));\n        }\n        &[aria-expanded=\"true\"]:after {\n            @include transform(rotate(-135deg));\n        }\n    }\n    .dropdown-menu {\n        padding: 10px;\n        background: $white;\n        box-shadow: $box-shadow-lg;\n        border: 1px solid $light-900;\n        .dropdown-item {\n            padding: 5px 10px;\n            color: $gray-800;\n            background: $white;\n            border-radius: $border-radius-lg;\n            &:hover {\n                color: $gray-900;\n                background: $light-300;\n            }\n        }\n    }\n}",".time-text {\n\tp {\n\t\tfont-weight: $font-weight-medium;\n\t\twhite-space: nowrap;\n\t\tmargin-left: 15px;\n\t}\n}\n.activity-title {\n\tmargin-bottom: 10px;\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\th4 {\n\t\tfont-weight: $font-weight-semibold;\n\t\t@include margin-padding(0 15px 10px 0, 0 15px 0 0);\n\t\tposition: relative;\n\t\t&::after {\n\t\t\tcontent: \"\";\n\t\t\tbackground-color: $light-900;\n\t\t\twidth: 1px;\n\t\t\theight: 24px;\n\t\t\t@include position(absolute, 0, 0, null, null);\n\t\t\t@include respond-below(custom767) {\n\t\t\t\tcontent: none;\n\t\t\t}\n\t\t}\n\t}\n\t@include respond-below(custom767) {\n\t\tdisplay: block;\n\t}\n}\n.active-list {\n\tul {\n\t\tmargin-bottom: 10px;\n\t\tli {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-right: 10px;\n\t\t\ta {\n\t\t\t\twidth: 34px;\n\t\t\t\theight: 34px;\n\t\t\t\t@include rounded(5px);\n\t\t\t\tborder: 1px solid $light-900;\n\t            display: -webkit-inline-box;\n\t            display: -ms-inline-flexbox;\n\t            display: inline-flex;\n\t            -webkit-box-align: center;\n\t            -ms-flex-align: center;\n\t            align-items: center;\n\t            justify-content: center;\n\t            -webkit-justify-content: center;\n\t            -ms-flex-pack: center;\n\t            color: $gray-900;\n\t            &:hover, &.active {\n\t            \tbackground-color: $green;\n\t            \tborder-color: $green;\n\t            \tcolor: $white;\n\t            }\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n.radio-activity {\n\t li {\n\t \tdisplay: inline-block;\n\t \t.active-type {\n\t \t\tinput[type=\"radio\"] {\n\t \t\t\tdisplay: none;\n\t \t\t\t~ label {\n\t \t\t\t\tborder: 1px solid $light-900;\n\t \t\t\t\tbox-shadow: 0px 4px 4px 0px #DBDBDB40;\n\t \t\t\t\t@include margin-padding(0 10px 5px 0, 8px 20px);\n\t \t\t\t\t@include rounded(5px);\n\t \t\t\t\tcolor: $gray-900;\n\t \t\t\t\tcursor: pointer;\n\t \t\t\t\ti {\n\t \t\t\t\t\tmargin-right: 5px;\n\t \t\t\t\t}\n\t \t\t\t}\n\t \t\t\t&:checked {\n\t \t\t\t\t~ label {\n\t \t\t\t\t\tborder-color: $green;\n\t \t\t\t\t\tcolor: $green;\n\t \t\t\t\t}\n\t \t\t\t}\n\t \t\t}\n\t \t}\n\t \t&:last-child {\n\t \t\tmargin-right: 0;\n\t \t}\n\t }\n}\n.label-add {\n\tcolor: $primary;\n\tmargin-bottom: 5px;\n\tfont-weight: $font-weight-medium;\n\ti {\n\t\tmargin-right: 8px;\n\t}\n\t&:hover {\n\t\tcolor: $primary-hover;\n\t}\n}\n.tab-activity {\n\t@include rounded(5px);\n\t@include margin-padding(0 0 20px, 15px 15px 0);\n\tbox-shadow: 0px 4px 74px 0px #D0D0D040;\t\n\tul {\n\t\tli {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-right: 20px;\n\t\t\ta {\n\t\t\t\t@include margin-padding(null, 10px 5px 10px);\n\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\tborder-bottom: 4px solid $white;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tspan {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\t@include rounded(50%);\n\t \t\t\t\tborder: 1px solid $light-900;\n\t\t            display: -webkit-inline-box;\n\t\t            display: -ms-inline-flexbox;\n\t\t            display: inline-flex;\n\t\t            -webkit-box-align: center;\n\t\t            -ms-flex-align: center;\n\t\t            align-items: center;\n\t\t            justify-content: center;\n\t\t            -webkit-justify-content: center;\n\t\t            -ms-flex-pack: center;\n\t\t            margin-left: 10px;\n\t\t            color: $gray-900;\n\t\t            font-weight: $font-weight-semibold;\n\t\t            font-size: $font-size-10;\n\t\t\t\t}\n\t\t\t\t&.active {\n\t\t\t\t\tcolor: $primary;\n\t\t\t\t\tborder-color: $primary;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.comment-wrap {\n\t@include margin-padding(0 0 15px, 15px);\n\tbox-shadow: 0px 4px 74px 0px #D0D0D040;\n\tborder: 1px solid $light-900;\n\t@include rounded(5px);\n\th6 {\n\t\tfont-size: $font-size-16;\n\t\tfont-weight: $font-weight-normal;\n\t\tmargin-bottom: 10px;\n\t\tcolor: $gray-400;\n\t}\n\tp {\n\t\tspan {\n\t\t\tcolor: $purple;\n\t\t}\n\t}\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n.activity-badge {\n\tcolor: $white;\n\t@include margin-padding(null, 5px 7px);\n\tfont-size: $font-size-12;\n\t@include rounded(5px);\n\ti {\n\t\tmargin-right: 5px;\n\t}\n}\n.title-head {\n\tfont-weight: $font-weight-medium;\n\tcolor: $gray-900;\n}",".tasks-activity {\n\t&.tasks {\n\t\t& > ul {\n\t\t\tmargin-top: 15px;\n\t\t\t.task-wrap {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\tflex-wrap: wrap;\n\t\t\t\t&.pending {\n\t\t\t\t\t&::before { \n\t\t\t\t\t\tbackground-color: $violet;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.warning {\n\t\t\t\t\t&::before { \n\t\t\t\t\t\tbackground-color: $warning;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.success {\n\t\t\t\t\t&::before { \n\t\t\t\t\t\tbackground-color: $success;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.task-info {\n\t\t\t\t\t.task-icon {\n\t\t\t\t\t\tmargin: 0 20px 10px 0;\n\t\t\t\t\t}\n\t\t\t\t\t.task-checkbox {\n\t\t\t\t\t\tmargin: 0 20px 10px 0;\n\t\t\t\t\t\t.checkboxs .checkmarks {\n\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\t@include transform(translateY(-50%));\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.set-star {\n\t\t\t\t\t\tmargin: 0 20px 10px 0;\n\t\t\t\t\t}\n\t\t\t\t\tp {\n\t\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\t}\n\t\t\t\t\t.badge {\n\t\t\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\t\t\tfont-size: $font-size-12;\n\t\t\t\t\t\t@include margin-padding(0 5px 10px 0, 5px 7px);\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t\t.task-actions {\n\t\t\t\t\tul {\t\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\t@include margin-padding(0 10px 10px 0, null);\n\t\t\t\t\t\t\t.badge-tag {\n\t\t\t\t\t\t\t\tpadding: 5px 4px; \n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\t\t\n\t\t\t}\t\t\t\n\t\t}\n\t}\n}\n.all-read {\n\t.checkboxs {\n\t\t.checkmarks {\n\t\t\ttop: 50%;\n\t\t\t@include transform(translateY(-50%));\n\t\t}\n\t}\n}\n.task-drops {\n\t.dropdown-toggle {\n\t\tborder: 0;\n\t\tpadding: 0;\n\t\tfont-size: $font-size-18;\n\t\tfont-weight: $font-weight-semibold;\n\t\tbox-shadow: none;\n\t\t&.show {\n\t\t\tborder: 0;\n\t\t}\n\t\t@include respond-below(custom767) {\n\t\t\tfont-size: $font-size-16;\n\t\t}\n\t}\n}\n.badge-purple-light{\n\tcolor: #4A00E5 !important;\n\tbackground: #F3EDFF !important;\n}\n.task-wrapper {\n\tborder-bottom: 1px solid $light-900;\n\tmargin-bottom: 15px;\n\tpadding-bottom: 15px;\n\t.tasks-activity {\n\t\t\t&.tasks {\t\t\t\n\t\t\t\t& > ul {\n\t\t\t\t\tmargin-bottom: 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t&:last-child {\n\t\tpadding-bottom: 0;\n\t\t.tasks-activity {\n\t\t\t&.tasks {\t\t\t\n\t\t\t\t& > ul {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.task-accordion {\n\t\tfont-size: $font-size-18;\n\t\tfont-weight: $font-weight-semibold;\n\t\tposition: relative;\n\t\tdisplay: block;\n\t\th4 {\n\t\t\t@include respond-below(custom767) {\n\t\t\t\tfont-size: $font-size-16;\n\t\t\t}\n\t\t}\n\t\tspan {\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\t@include rounded(50%);\n\t\t\tborder: 1px solid $light-900;\n\t\t\tdisplay: -webkit-inline-box;\n\t\t\tdisplay: -ms-inline-flexbox;\n\t\t\tdisplay: inline-flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tmargin-left: 10px;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-weight: $font-weight-semibold;\n\t\t\tfont-size: $font-size-10;\n\t\t}\n\t\t&::before {\n            content: \"\\f054\";\n            font-family: 'Font Awesome 5 Free';\n            @include position(absolute, 50%, 10px, null, null);\n            @include transform(translateY(-50%));\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n        } \n        &:not(.collapsed) {                 \n            &::before {\n                content: \"\\f078\";\n            }           \n        }\n\t}\n\t&:last-child {\n\t\tborder: 0;\n\t\tmargin-bottom: 0;\n\t}\n}\n\n\n.preloader {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 999999;\n\twidth: 100%;\n\theight: 100%;\n\tbackground: #FFF;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\t.loader {\n\t\twidth: 64px;\n\t\theight: 64px;\n\t\tposition: relative;\n\t\tanimation: rotate 1.5s ease-in infinite alternate;\n\t  }\n\t  .loader::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tbottom: 0;\n\t\tcolor: $tertiary;\n\t\tbackground: currentColor;\n\t\twidth: 64px;\n\t\theight: 32px;\n\t\tborder-radius: 0 0 50px 50px;\n\t  }\n\t  .loader::after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: 50%;\n\t\ttop: 10%;\n\t\tbackground: $green;\n\t\twidth: 8px;\n\t\theight: 64px;\n\t\tanimation: rotate 1.2s linear infinite alternate-reverse;\n\t  }\n\t\t\t \n  }\n\n  @keyframes rotate {\n\t100% { transform: rotate(360deg)}\n  }\n  \n.toggle-content-view {\n    margin-bottom: 24px;\n\th5{\n\t\tfont-size: 20px;\n\t\tfont-weight: 700;\n\t\tcolor: $gray-900;\n\t\tmargin-bottom: 5px;\n\t}\n\tp{\n\t\tcolor: $gray-400;\n\t\tfont-size: 14px;\n\t}\n}\n.details-propsal{\n\th4 {\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tmargin-bottom: 24px;\n\t}\n\th6{\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tmargin-bottom: 12px;\n\t}\n\th3{\n\t\tcolor: #3C2371;\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tmargin-bottom: 12px;\n\t}\n\tspan{\n\t\tcolor: #6F6F6F;\n\t\tfont-size: 14px;\n\t\tdisplay: block;\n\t}\n\t&.details-propsals{\n\t\tul{\n\t\t\tli{\n\t\t\t\twidth: 33.3%;\n\t\t\t}\n\t\t}\n\t}\n\tul{\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\t\tborder-bottom: 1px solid $light-900;\n\t\tmargin-bottom: 20px;\n\t\tli{\n\t\t\twidth: 25%;\n\t\t\tmargin-bottom: 10px;\n\t\t\th5{\n\t\t\t\tcolor: $gray-600;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tmargin-bottom: 5px;\n\t\t\t}\n\t\t\th6{\n\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: 400;\n\t\t\t}\n\t\t\timg{\n\t\t\t\twidth: 16px;\n\t\t\t\theight: 16px;\n\t\t\t\tmargin-right: 8px;\n\t\t\t\tborder-radius: 5px;\n\t\t\t}\n\t\t\t.btn{\n\t\t\t\tpadding: 3px 15px;\n\t\t\t}\n\t\t}\n\t}\n}\n.attached-div{\n\th5 {\n\t\tfont-size: 16px;\n\t\tmargin-bottom: 12px;\n\t}\n}\n.attached-div{\n\tpadding-bottom: 15px;\n}\n.attachement-download {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid #E8E8E8;\n    padding: 15px;\n    border-radius: 5px;\n\tmargin-bottom: 12px;\n}\n.attachement-download-icon {\n\tspan {\n\t\tbackground: #E41F07;\n\t\twidth: 44px;\n\t\theight: 44px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tfont-size: 22px;\n\t\tcolor: #fff;\n\t\tborder-radius: 5px;\n\t}\n}\n.attachement-download-img {\n    display: flex;\n    align-items: center;\n}\n.attachement-download-content {\n    margin-left: 10px;\n\th5 {\n\t\tfont-size: 14px;\n\t\tmargin-bottom: 3px;\n\t\tfont-weight: 600;\n\t}\n\th6 {\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t}\n}\n\n.table-view {\n    margin-bottom: 24px;\n    border: 1px solid #E8E8E8;\n    border-radius: 10px;\n\tth {\n\t\tbackground: #E8E8E8;\n\t}\n}\n.table-view{\n\tmargin-bottom: 24px;\n    border: 1px solid #E8E8E8;\n    border-radius: 10px;\n\tth {\n\t\tbackground: #E8E8E8;\n\t}\n} \n.subtotal-div {\n    background: #F9F9FC;\n    padding: 24px;\n\tul {\n\t\tli {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\th5{\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: $gray-400;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t\th6{\n\t\t\t\tfont-size: 16px;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t\t+ li{\n\t\t\t\tmargin-top: 15px;\n\t\t\t}\n\t\t}\n\t}\n}\n.terms-condition{\n\tmargin-top: 15px;\n\tpadding-top: 15px;\n\tborder-top: 1px solid #E8E8E8;\n\th2{\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t\tcolor: $gray-900;\n\t\tmargin-bottom: 15px;\n\t}\n\tp{\n\t\tcolor: $gray-400;\n\t\tfont-size: 14px;\n\t\tpadding-bottom: 15px;\n\t}\n}\n.contact-type{\n\th6{\n\t\tfont-weight: 600;\n\t}\n\tul{\n\t\tborder: 0;\n\t\tdisplay: inline;\n\t\tli{\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 5px;\n\t\t\th5{\n\t\t\t\tposition: relative;\n\t\t\t\twidth: 40%;\n\t\t\t\tcolor: $gray-400;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tmargin: 0;\n\t\t\t\t&:after{\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcontent: \":\";\n\t\t\t\t\tright: 8px;\n\t\t\t\t\ttop: 0px;\n\t\t\t\t}\n\t\t\t}\n\t\t\th6{\n\t\t\t\tposition: relative;\n\t\t\t\twidth: 60%;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n.renewal-history{\n\th4{\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tmargin-bottom: 15px;\n\t}\n}\n.renewal-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background: #fff;\n    border: 1px solid #E8E8E8;\n    padding: 24px;\n    box-shadow: 0px 4px 74px 0px #D0D0D040;\n    border-radius: 5px;\n\tmargin-bottom: 15px;\n\t.renewal-content-history{\n\t\twidth: 80%;\n\t}\n\t.contact-type{\n\t\th6{\n\t\t\tcolor: $gray-700;\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t\tul{\n\t\t\tflex-wrap: wrap;\n\t\t\tdisplay: flex;\n\t\t\tli{\n\t\t\t\twidth: 50%;\n\t\t\t\th6{\n\t\t\t\t\tmargin: 0;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\t\t\t\th5{\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.toogle-header-select{\n\t.select2-container{\n\t\tmin-width: 150px !important;\n\t}\n\t.select2-container--default .select2-results__option--selected {\n\t\tcolor: #fff;\n\t}\n\t.toggle-btn{\n\t\tmin-width: 26px;\n\t}\n}\n.btn-downloads{\n\tfont-size: 14px !important;\n\tborder: 1px solid #E8E8E8;\n\tpadding: 10px 15px;\n\tcolor: $gray-900 !important;\n\tfont-weight: 500;\n\tborder-radius: 5px;\n\t&:hover{\n\t\tbackground: $primary;\n\t\tcolor: $white !important;\n\t}\n\n}\n.input-table {\n\t&.input-table-descripition{\n\t\tinput{\n\t\t\twidth: 130px;\n\t\t}\n\t}\n\tinput {\n\t\tborder: 1px solid #E8E8E8;\n\t\theight: 30px;\n\t\tborder-radius: 5px;\n\t\twidth: 75px;\n\t\tpadding: 5px;\n\t}\n\tselect{\n\t\tborder: 1px solid #E8E8E8;\n\t\theight: 30px;\n\t\tborder-radius: 5px;\n\t\twidth: 75px;\n\t}\n}\n.upload-signature{\n\tposition: relative;\n\tinput{\n\t\twidth: 100%;\n\t\theight: 42px;\n\t\topacity: 0;\n\t\tz-index: 9;\n\t}\n\ta{\n\t\tborder: 1px dashed #E8E8E8;\n\t\tborder-radius: 5px;\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\theight: 42px;\n\t\ttext-align: center;\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tcolor: $gray-400;\n\t\tleft: 0;\n\t\tpadding: 10px;\n\t\tbackground: #fff;\n\t}\n}\n.toggle-header-popup{\n\t.btn-dropdowns{\n\t\tmin-width: 125px;\n\t\tborder: 1px solid #E8E8E8;\n\t\tpadding: 8px 12px;\n\t\tfont-size: 14px !important;\n\t\tcolor: $gray-400 !important;\n\t\t&.dropdown-toggle:after{\n\t\t\ttop: -2px;\n\t\t\tposition: relative;\n\t\t\tfont-size: 12px;\n\t\t}\n\t\t&.dropdown-toggle-contract{\n\t\t\tmin-width: 150px;\n\t\t}\n\t\t&:hover{\n\t\t\tcolor: $white !important;\n\t\t\tbackground: $primary;\n\t\t}\n\t\t&:active,&:focus{\n\t\t\tcolor: $white !important;\n\t\t}\n\t}\n\t.dropdown-item{\n\t\tfont-size: 14px !important;\n\t\tcolor: $gray-400 !important;\n\t}\n}\n\n.toggle-popup-sent ,.toggle-popup-draft , .toggle-popup-declined{\n\t.sidebar-layout .sidebar-header a{\n\t\tfont-size: 14px;\n\t\tcolor: #fff;\n\t}\n}\n\n.signature-contant{\n\tpadding: 15px 0;\n\tborder-top: 1px solid #E8E8E8;\n\tborder-bottom: 1px solid #E8E8E8;\n\tp{\n\t\tcolor: #B5B5B5;\n\t\tmargin: 0;\n\t}\n}\n.pay-now{\n\t.btn{\n\t\theight: 42px;\n\t}\n}\n.sidebar {\n\t.sidebar-inner {\n\t\twidth: 100% !important;\n\t}\n}",".activities-list {\n    ul {\n        li {\n            background: $light-300;\n            padding: 15px 10px;\n            margin-bottom: 20px;\n            &:last-child {\n                margin-bottom: 0;\n            }\n            .activity-name {\n                h5 {\n                    font-size: $font-size-14;\n                    font-weight: $font-weight-medium;\n                    color: $gray-900;\n                    margin-bottom: 5px;\n                    -webkit-line-clamp: 1;\n                    -webkit-box-orient: vertical;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    display: -webkit-box;\n                }\n                p {\n                    font-size: $font-size-14;\n                    margin-bottom: 15px;\n                    -webkit-line-clamp: 1;\n                    -webkit-box-orient: vertical;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    display: -webkit-box;\n                }\n                .badge {\n                    color: $white;\n                    @include margin-padding(null, 5px 7px);\n                    font-size: $font-size-12;\n                    @include rounded(5px);\n                    i {\n                        margin-right: 5px;\n                    }\n                }\n            }\n            .user-activity {\n                display: flex;\n                align-items: center;\n                @include respond-below(custom767) {\n                    margin: 20px 0;\n                }\n               \n                span {\n                    flex-shrink: 0;\n                    display: inline-flex;\n                    margin-right: 5px;\n                    img {\n                        width: 32px;\n                        height: 32px;\n                        border-radius: 50%;\n                    }\n                }\n                h6 {\n                    margin-bottom: 0;\n                    -webkit-line-clamp: 1;\n                    -webkit-box-orient: vertical;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    display: -webkit-box;\n                }\n            }\n        }\n    }\n}\n.card-select {\n    ul {\n        @include respond-below(custom575) {\n            align-items: start !important;\n        }\n    }\n}\n.campaign-card {\n    overflow-x: auto;\n    ul {\n        width: max-content;\n        .campaign-wrap {\n            background-color: $light-200;\n            @include margin-padding(0 0 15px, 15px 15px 5px);\n            .campaign-info {\n                display: flex;\n                display: -webkit-flex;\n                align-items: center;\n                -webkit-align-items: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                white-space: nowrap;\n                border-bottom: 1px solid $light-900;\n                margin: 0 0 15px 0;\n                h5 {\n                    font-weight: $font-weight-semibold;\n                    margin-bottom: 5px;\n                }\n                .campaign-name {\n                    margin: 0 50px 10px 0;\n                }\n                .list-progress {\n                    margin-bottom: 10px;\n                }\n            }\n            .campaign-action {\n                display: flex;\n                display: -webkit-flex;\n                align-items: center;\n                -webkit-align-items: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                flex-wrap: wrap;\n                .project-mem {\n                    margin-bottom: 10px;\n                }\n            }\n            .campaign-date {\n                margin-bottom: 10px;\n                display: flex;\n                display: -webkit-flex;\n                align-items: center;\n                -webkit-align-items: center;\n                .badge {\n                    margin: 0 15px 0 0;\n                }\n            }\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n}",".priority {\n\t&.badge-tag {\n\t\tcolor: $gray-900;\n\t\tmin-width: 80px;\n\t\ttext-align: left;\n\t\tfont-weight: $font-weight-semibold;\n\t\ti {\n\t\t\tmargin-right: 4px;\n\t\t}\n\t\t&.badge-danger-light {\n\t\t\ti {\n\t\t\t\tcolor: $danger;\n\t\t\t}\n\t\t}\n\t\t&.badge-success-light {\n\t\t\ti {\n\t\t\t\tcolor: $success;\n\t\t\t}\n\t\t}\n\t\t&.badge-warning-light {\n\t\t\ti {\n\t\t\t\tcolor: $warning;\n\t\t\t}\n\t\t}\n\t}\n}\n.task-wrap {\n\tborder: 1px solid $light-900;\n\t@include margin-padding(0 0 10px, 15px 15px 5px);\n\tposition: relative;\n\t@include rounded(5px);\n\t&::before {\n\t\tcontent: \"\";\n\t\tbackground-color: $danger;\n\t\twidth: 3px;\n\t\theight: 100%;\n\t\t@include rounded(5px);\n\t\t@include position(absolute, 0, null, null, 0);\n\t}\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n.task-info {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tflex-wrap: wrap;\n\tp {\n\t\tdisplay: inline-block;\n\t\tmargin: 0 24px 10px 0;\n\t\ti {\n\t\t\tcolor: $gray-400;\n\t\t\tmargin-right: 10px;\n\t\t}\n\t \tcolor: $gray-900;\n\t}\n\t.badge {\n\t\tmargin: 0 10px 10px 0;\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t\t&.badge-pill {\n\t\t\ti {\n\t\t\t\tmargin-right: 5px;\n\t\t\t}\n\t\t}\n\t}\n}\n.task-actions {\n\tfloat: right;\n\tul {\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\talign-items: center;\n\t\t-webkit-align-items: center;\n\t\tflex-wrap: wrap;\n\t\tli {\n\t\t\tmargin: 0 24px 10px 0;\n\t\t\tcolor: $gray-900;\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t\t&.task-time {\n\t\t\t\ti {\n\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.task-date {\n\t\t\t\ti {\n\t\t\t\t\tmargin-right: 5px;\n\t\t\t\t}\n\n\t\t\t}\n\t\t\t&.task-owner {\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\talign-items: center;\n\t\t\t\t-webkit-align-items: center;\n\t\t\t\t.task-user {\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\theight: 24px;\n\t\t\t\t\timg {\n\t\t\t\t\t\twidth: 24px;\n\t\t\t\t\t\theight: 24px;\n\t\t\t\t\t\t@include rounded(50%);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t@include respond-below(custom767) {\n\t\tfloat: left;\n\t}\n}\n.select-priority {\n\tposition: relative;\n\t.select-icon {\n\t\t@include position(absolute, 50%, null, null, 10px);\n\t\t@include transform(translateY(-50%));\n\t\tz-index: 99999;\n\t\tcolor: $primary;\n\t}\n\t.select2-container--default .select2-selection--single .select2-selection__rendered {\n\t\tpadding-left: 30px;\n\t}\n}\n.project-name {\n\tmargin-bottom: 15px;\n\tp {\n\t\tfont-weight: $font-weight-medium;\n\t\tmargin-bottom: 5px;\n\t}\n\th4 {\n\t\tfont-weight: $font-weight-semibold;\n\t}\n}\n.con-sidebar-title {\n\t.priority {\n\t\tmargin-bottom: 15px;\n\t}\n\tp {\n\t\tfont-weight: $font-weight-medium;;\n\t\tcolor: $gray-900;\n\t\tmargin-bottom: 15px;\n\t}\n\t&.border-line {\n\t\tborder-bottom: 1px solid $light-900;\n\t\tmargin-bottom: 20px;\n\t}\n}",".kanban-list-items {\n    border: 1px solid $light-900;\n    box-shadow: 0px 4px 4px 0px #DBDBDB40;\n    border-radius: 5px;\n    @include margin-padding(0 20px 20px 0, 15px);\n    width: 100%;\n    min-width: 315px;\n    &:last-child {\n        margin-right: 0;\n    }\n}\n.icons-social {\n    a {\n        width: 30px;\n        height: 30px;\n        background: $light-500;\n        border-radius: 50%;\n        color: $title-color;\n        &:hover {\n            background: $danger-100;\n            color: $primary;\n        }\n    }\n}\n.kanban-drag-wrap {\n    > div {\n        &:last-child {\n            .kanban-card {\n                margin-bottom: 0;\n            }\n        }\n       \n    }\n}\n.pipeline-progress {\n    .progress {\n        background: transparent;\n        width: 70px;\n        height: 5px;\n        .progress-bar {\n            width: 70px;\n            height: 5px;\n            border-radius: 5px;\n            &.progress-bar-success {\n                background: $success;\n            }\n            &.progress-bar-violet {\n                background: $purple;\n            }\n            &.progress-bar-info {\n                background: $info;\n            }\n            &.progress-bar-warning {\n                background: $warning;\n            }\n            &.progress-bar-green {\n                background: $green;\n            }\n            &.progress-bar-danger {\n                background: $danger;\n            }\n        }\n    }\n    span {\n        margin-left: 10px;\n        color: $gray-900;\n        font-weight: $font-weight-medium;\n    }\n}\n.pipe-title {\n    .add-stage {\n        color: $primary;\n        font-weight: $font-weight-medium;\n        margin-bottom: 15px;\n        display: inline-block;\n        i {\n            margin-right: 8px;\n        }\n    }\n}\n.priority-info {\n    .dropdown {\n        .dropdown-toggle {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            border: 1px solid $light-900;\n            box-shadow: 0px 4px 4px 0px #DBDBDB40;\n            border-radius: 5px;\n            @include margin-padding(null, 5px 10px);\n            font-weight: $font-weight-medium;\n            &[aria-expanded=true] {\n                & > i {\n                    @include transition(all 0.2s ease);\n                    @include transform(rotate(180deg));\n                }\n            }\n            &::after {\n                content: none;\n            }\n            span{\n                display: -webkit-inline-box;\n                display: -ms-inline-flexbox;\n                display: inline-flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                i {\n                    font-size: $font-size-10;\n                }                \n            }\n        }\n        a {\n            font-size: $font-size-14;\n            color: $gray-900;\n            span{\n               display: -webkit-inline-box;\n               display: -ms-inline-flexbox;\n               display: inline-flex;\n               align-items: center;\n               -webkit-box-align: center;\n               -ms-flex-align: center;\n               i {\n                   font-size: 10px;\n               }                \n            }\n        }\n        .dropdown-menu {\n            width: 100%;\n        }\n    }\n}\n.select-pipeline {\n    position: relative;\n    margin-right: 8px;\n    .pipe-icon {\n        @include position(absolute, 50%, null, null, 10px);\n        z-index: 99999;\n        transform: translateY(-50%);\n        color: $gray-900;\n    }\n    .select2-container {\n        .select2-selection {\n            &.select2-selection--single {\n                height: 40px;\n                border-radius: 5px;\n                color: $gray-900;\n                font-weight: $font-weight-medium;\n                .select2-selection__rendered {\n                    padding-left: 30px;\n                    line-height: 40px;\n                    color: $gray-900;\n                    font-weight: $font-weight-medium;\n                    padding-right: 30px;\n                }\n                .select2-selection__arrow {\n                    height: 40px;\n                }\n            }\n        }\n    }\n}\n.pipeline-list {\n    border-bottom: 1px solid $light-900;\n    margin-bottom: 15px;\n    ul {\n        margin-bottom: 15px;\n        li {\n            display: inline-block;\n            &:first-child {\n                a {\n                    border-radius: 10px 0 0 10px;\n                }\n            }\n            &:last-child {\n                a {\n                    border-radius: 0;\n                }\n            }\n            a {\n                @include margin-padding(0 0 3px, 12px 25px 12px 50px);\n                font-size: $font-size-14;\n                font-weight: $font-weight-medium;\n                display: inline-block;\n                text-align: center;\n                background: $light-300;\n                color: $title-color;\n                position: relative;\n                min-width: 185px;\n                &::after {\n                    content: '';\n                    @include position(absolute, 0,-23px, null, null);\n                    width: 45px;\n                    height: 45px;\n                    -webkit-transform: scale(.707) rotate(45deg);\n                    -ms-transform: scale(.707) rotate(45deg);\n                    -moz-transform: scale(.707) rotate(45deg);\n                    -transform: scale(.707) rotate(45deg);\n                    z-index: 1;\n                    background: $light-300;\n                    -webkit-box-shadow: 2px -2px 0 1px #fff,3px -3px 0 2px rgba(255,255,255,.1);\n                    box-shadow: 2px -2px 0 1px #fff,3px -3px 0 2px rgba(255,255,255,.1);\n                    border-radius: 0 5px 0 50px;\n                } \n                &.bg-info {\n                    color: $white;\n                    &::after {\n                        background: $info;\n                    }\n                    &:hover {\n                        background: $info !important;\n                    }\n                }    \n                &.bg-warning {\n                    color: $white;\n                    &::after {\n                        background: $warning;\n                    }\n                    &:hover {\n                        background: $warning !important;\n                    }\n                }     \n                &.bg-pending {\n                    color: $white;\n                    background: $purple !important;\n                    &::after {\n                        background: $purple;\n                    }\n                    &:hover {\n                        background: $purple !important;\n                    }\n                }      \n                &.bg-pink {\n                    color: $white;\n                    &::after {\n                        background: $pink;\n                    }\n                    &:hover {\n                        background: $pink !important;\n                    }\n                }        \n                &.bg-success {\n                    color: $white;\n                    &::after {\n                        background: $success;\n                    }\n                    &:hover {\n                        background: $success !important;\n                    }\n                }         \n                &.bg-danger {\n                    color: $white;\n                    &::after {\n                        background: $danger;\n                    }\n                    &:hover {\n                        background: $danger !important;\n                    }\n                }          \n                &.bg-gray {\n                    color: $white;\n                    background: $background-3;\n                    &::after {\n                        background: $background-3;\n                    }\n                    &:hover {\n                        background: $background-3 !important;\n                    }\n                }   \n                @include respond-below(custom575) {  \n                    width: calc(100% - 25px);\n                }       \n            }               \n            @include respond-below(custom575) {  \n                display: block;\n            }  \n        }\n    }\n}",".campaign-box {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n\t@include margin-padding(0 0 24px, 24px);\n\t@include rounded(5px);\n\t@include respond-below(custom1399) {\n\t\t@include margin-padding(0 0 24px, 15px);\n\t}\n\t.campaign-img {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tspan {\n\t\t\twidth: 44px;\n\t\t\theight: 44px;\n\t\t\t@include rounded(5px);\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tcolor: $white;\n\t\t\tmargin-right: 10px;\n\t\t}\n\t\tp {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t}\t\t\n\t}\n\th2 {\n\t\tcolor: $gray-400;\n\t\t@include respond-below(custom1399) {\n\t\t\tfont-size: $font-size-24;\n\t\t}\n\t\t@include respond-below(custom991) {\n\t\t\tfont-size: $font-size-20;\n\t\t}\n\t}\n\t&.bg-danger-light {\n\t\tbackground-color: $danger-100;\n\t\tspan {\n\t\t\tbackground-color: $danger;\n\t\t}\n\t}\n\t&.bg-warning-light {\n\t\tbackground-color: $warning-100;\n\t\tspan {\n\t\t\tbackground-color: $secondary;\n\t\t}\n\t}\n\t&.bg-purple-light {\n\t\tbackground-color: $purple-100;\n\t\tspan {\n\t\t\tbackground-color: $tertiary;\n\t\t}\n\t}\n\t&.bg-success-light {\n\t\tbackground-color: $success-200;\n\t\tspan {\n\t\t\tbackground-color: $green;\n\t\t}\n\t}\n}\n.campaign-tab {\n\t@include margin-padding(0 0 20px, 15px 15px 0);\n\tbox-shadow: 0px 4px 74px 0px #D0D0D040;\n\tbackground-color: $white;\n\t@include rounded(5px);\n\tul {\n\t\tli {\n\t\t\tmargin-right: 15px;\n\t\t\ta {\n\t\t\t\tposition: relative;\n\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\tborder-bottom: 4px solid $white;\n\t\t\t\t@include margin-padding(null, 10px 10px 20px);\n\t\t\t\tdisplay: -webkit-inline-box;\n\t\t\t\tdisplay: -ms-inline-flexbox;\n            \tdisplay: inline-flex;\n\t\t\t    -webkit-box-align: center;\n\t\t\t    -ms-flex-align: center;\n\t\t\t    align-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t    -webkit-justify-content: center;\n\t\t\t    -ms-flex-pack: center;\n\t\t\t\t&.active {\n\t\t\t\t\tborder-color: $primary;\n\t\t\t\t}\n\t\t\t\tspan {\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\tdisplay: -webkit-inline-box;\n\t\t\t        display: -ms-inline-flexbox;\n            \t\tdisplay: inline-flex;\n\t\t\t        -webkit-box-align: center;\n\t\t\t        -ms-flex-align: center;\n\t\t\t        align-items: center;\n\t\t\t        justify-content: center;\n\t\t\t        -webkit-justify-content: center;\n\t\t\t        -ms-flex-pack: center;\n\t\t\t        border: 1px solid $light-900;\n\t\t\t        @include rounded(50%);\n\t\t\t        margin-left: 10px;\n\t\t\t        font-size: $font-size-10;\n\t\t\t        font-weight: $font-weight-semibold;\n\t\t\t        color: $gray-400;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n}\nul.project-mem {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n  \tli {\n  \t\tmargin-left: -10px;\n\t\tdisplay: inline-flex;\n\t\ta {\n\t\t\twidth: 24px;\n\t\t\theight: 24px;\n\t\t}\n  \t\t&:first-child {\n  \t\t\tmargin-left: 0;\n  \t\t}\n  \t\ta {\n  \t\t\timg {\n  \t\t\t\twidth: 24px;\n  \t\t\t\theight: 24px;\n  \t\t\t\tborder-radius: 50%;\n  \t\t\t\tborder: 1px solid $white;\n  \t\t\t}\n  \t\t}\n  \t\t&.more-set {\n  \t\t\ta {\n  \t\t\t\twidth: 24px;\n  \t\t\t\theight: 24px;\n  \t\t\t\tborder-radius: 50%;\n  \t\t\t\tbackground-color: $white;\n  \t\t\t\tborder: 1px solid $light-900;\n  \t\t\t\tdisplay: -webkit-inline-box;\n\t\t\t\tdisplay: -ms-inline-flexbox;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t\tfont-size: $font-size-12;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tcolor: $gray-400;\n  \t\t\t}\n  \t\t}\n  \t}\n}\n.list-progress {\n\tli {\n\t\tdisplay: inline-block;\n\t\tmargin-right: 15px;\n\t\th6 {\n\t\t\tfont-weight: $font-weight-semibold;\n\t\t}\n\t\tp {\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: $font-weight-semibold;\n\t\t\tcolor: $gray-400;\n\t\t}\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n}",".form-wrap {\n\t.checkmarks.mem-plane-check {\n\t\ttop: 3px;\n\t}\n}\n.table-imgname.flag-image img {\n\twidth: 24px;\n\theight: 18px;\n\tborder-radius: 5px;\n}\n.table-imgname.flag-image {\n\tdisplay: flex;\n\talign-items: center;\n\t\n}\n.location-flag-img {\n\tborder: 1px solid #E8E8E8;\n\tborder-radius: 5px;\n\twidth: 32px;\n\theight: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-right: 8px;\n}\n.table-imgname.flag-image span {\n\tfont-weight: 500;\n\tcolor: #262A2A;\n}\n#delete_request {\n\ttd {\n\t\tspan {\n\t\t\t&.badge {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\t\t}\n\t}\n}\n.wh-14 {\n\twidth: 14px;\n\theight: 14px;\n}",".select2-container {\n    min-width: 100% !important;\n    z-index: 99;\n    .select2-selection--single {\n        height: 40px;\n    }\n}\n.select2-container--default {\n    .select2-selection--single {\n        border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n        @include rounded(5px);\n        .select2-selection__rendered {\n            color: $text-color;\n            line-height: 38px;\n            @include rounded(5px);\n            padding-left: 10px;\n            font-size: $font-size-14;\n            font-weight: $font-weight-normal;\n            padding-right: 25px;\n             span {\n                display: -webkit-inline-box;\n                display: -ms-inline-flexbox;\n                display: inline-flex;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                align-items: center;\n                img {\n                    width: 16px;\n                    height: 16px;\n                    border-radius: 5px;\n                    margin-right: 5px;\n                }\n            }\n        }\n        .select {\n            width: 219px;\n        }\n        .select2-selection__arrow {\n            height: 40px;\n            right: 6px;\n        }\n    }\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n    @include position(absolute,50%,null,null,50%);\n    border-color: #637381;\n    border-style: solid;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    height: 0;\n    margin-left: -6px;\n    margin-top: -3px;\n    width: 0;\n    @include transform(rotate(45deg) translateY(-50%));\n}\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\n    border-color: $black;;\n    border-width: 2px 0 0 2px;\n    margin-top: 3px;\n    @include margin-padding(null, 3px);\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n    background: $primary;\n    color: $white;\n}\n.select2-container--focus  {\n    .select2-selection--single{\n        background: $white !important;\n        border-color: $primary;\n    }\n}\nspan.select2-container.select2-container--default.select2-container--open {\n    z-index: 9999;\n}\n.select2-container--default .select2-selection--single .select2-selection__rendered,\n.select2-container--default .select2-selection--multiple {\n    box-shadow: 0px 4px 4px 0px #DBDBDB40;\n}\n.select2-container--classic .select2-selection--single,\n.select2-container--default .select2-selection--single,\n.select2-container--default .select2-selection--single .select2-selection__rendered,\n.select2-container--default .select2-selection--single .select2-selection__arrow,\n.select2-container--default .select2-selection--multiple,\n.select2-container--classic .select2-selection--single .select2-selection__arrow,\n.select2-container--classic .select2-selection--single .select2-selection__rendered {\n    border-color: $light-900;\n    color: $text-color;\n    height: 40px;\n    line-height: 40px;\n}\n.select2-container--default .select2-selection--multiple {\n    line-height: 27px;\n    height: auto;\n    min-height: 40px;\n    .select2-selection__choice {\n        padding-left: 5px;\n        padding-right: 20px;\n    }\n    .select2-selection__choice__display {\n        span {\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            img {\n                width: 16px;\n                height: 16px;\n                border-radius: 5px;\n                margin-right: 5px;\n            }\n        }\n    }\n    .select2-selection__choice__remove {\n        right: 0;\n        left: auto;\n    }\n}\n.select2-results__option {\n    span {\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            align-items: center;\n            img {\n                width: 16px;\n                height: 16px;\n                border-radius: 5px;\n                margin-right: 5px;\n            }\n        }\n}\n.select2-container--classic .select2-selection--multiple .select2-selection__choice,\n.select2-container--default .select2-selection--multiple .select2-selection__choice,\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n    background-color: $light-300;\n    border-color: $light-300;\n    color: $gray-400;\n    border-radius: 5px;\n}\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n    border-color: $light-900;\n}","table.dataTable {\n    margin: 0 !important;\n    width: 100% !important;\n}\ntable.dataTable>thead .sorting:after, \ntable.dataTable>thead .sorting_asc:after,\ntable.dataTable>thead .sorting_desc:after,\ntable.dataTable>thead .sorting_asc_disabled:after, \ntable.dataTable>thead .sorting_desc_disabled:after {\n    right: 0.5em !important;\n    content: \"\\f175\" !important;\n    font-family: 'Font Awesome 5 Free';\n    bottom: 12px !important;\n    color: #BABFC7 !important;\n    font-size: 12px !important;\n    opacity: 1 !important;\n    position: absolute;\n    font-weight: $font-weight-semibold;\n    line-height: 1px !important;\n}\ntable.dataTable>thead .sorting:before, \ntable.dataTable>thead .sorting_asc:before, \ntable.dataTable>thead .sorting_desc:before, \ntable.dataTable>thead .sorting_asc_disabled:before, \ntable.dataTable>thead .sorting_desc_disabled:before {\n    right: 13px !important;\n    content: \"\\f176\" !important;\n    font-family: 'Font Awesome 5 Free';\n    top: 50% !important;\n    transform: translateY(-50%);\n    color: #BABFC7 !important;\n    font-size: 12px !important;\n    opacity: 1 !important;\n    position: absolute;\n    font-weight: $font-weight-semibold;\n    line-height: 1px !important;\n}\n.dataTables_paginate, #dataTables_paginate {\n    .paging_numbers {\n        float: right;\n    }\n}\n.dataTables_info {\n    padding-right: 15px;\n    font-size: $font-size-12;\n    color: $gray-700;\n    font-weight: $font-weight-semibold;\n}\n.custom-select {\n    min-width: 80px;\n    // background: url(../img/icons/dropdown.svg) no-repeat 95% 50%;\n}\n.dataTables_paginate, #dataTables_paginate {\n    .pagination{\n        justify-content: end;\n        -webkit-justify-content: end;\n        -ms-flex-pack: end;\n        li{\n            @include margin-padding(0 2px, null);\n            a {\n                background: $white;\n                border-color: transparent;\n                border-radius: 5px !important;\n                width: 25px;\n                height: 25px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                color: $gray-400;\n                &:hover{\n                    background: $green;\n                    color: $white;\n                }\n            }\n            &.active a.page-link{\n                background: $green;\n                border-color: $green;\n                @include rounded(5px);\n                width: 25px;\n                height: 25px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n            &.previous.disabled, &.previous {\n                width: auto;\n                margin: 0 13px 0 0;\n                a {\n                    background-color: transparent;\n                    border: 0;\n                    width: auto;\n                    padding: 0;\n                    i {\n                        margin-right: 8px;\n                    }\n                    &:hover {\n                        color: $green;\n                    }\n                }\n            }\n            &.next.disabled, &.next {\n                width: auto;\n                margin: 0 0 0 13px;\n                a {\n                    background-color: transparent;\n                    border: 0;\n                    width: auto;\n                    padding: 0;\n                    i {\n                        margin-left: 8px;\n                    }\n                    &:hover {\n                        color: $green;\n                    }\n                }\n            }\n        }\n        @include respond-below(custom767) {\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n        }\n    }\n}\n.dataTables_length, #dataTables_length\n.dataTables_paginate, #dataTables_paginate {\n    margin-top:15px !important;\n}\n.dataTables_length, #dataTables_length {\n    label {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        color: $text-color;\n        font-size: $font-size-14;\n        .form-select {\n            width: 73px;\n            border: 1px solid #E8E8E8;\n            border-radius: 5px;\n            color: $gray-900;\n            margin: 0 8px;\n        }\n        @include respond-below(custom767) {\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-bottom: 10px;\n        }\n    }\n}\n.datatable-length {\n    @include respond-below(custom767) {\n        text-align: center;\n    }\n\n}\ndiv.dataTables_wrapper div.dataTables_info {\n    padding-top: 23px;\n}\ntable.dataTable thead>tr>th.no-sort.sorting_asc:before {\n    display: none;\n}\ntable.dataTable thead>tr>th.no-sort.sorting_asc::after {\n    display: none;\n}\ntable.dataTable thead>tr>th.no-sort.sorting:before {\n    display: none;\n}\ntable.dataTable thead>tr>th.no-sort.sorting::after {\n    display: none;\n}\n.custom-table .table-responsive {\n    border: 1px solid $light-900;\n    border-radius: 6px;\n}\ntable.table.dataTable {\n    & > tbody {\n        > tr {\n            border-color: $light-900;\n            td {\n                color: $gray-400;\n            }\n        } \n    }\n    & > thead > tr {\n        border-color: $light-900;\n            th {\n                color: $gray-900;\n                font-size: $font-size-14;\n                font-weight: $font-weight-medium;\n            }\n    }\n}\n.active>.page-link, .page-link.active {\n    z-index: unset;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
